/**
 * Generated by orval v6.29.1 🍺
 * Do not edit manually.
 * @portal-middleware/hooks
 * react-query hooks for interacting with portal-middleware
 * OpenAPI spec version: 2.453.0
 */ import { useMutation, useQuery } from "@tanstack/react-query";
import { faker } from "@faker-js/faker";
import { HttpResponse, http } from "msw";
import { client } from "./client";
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostOnboardingSchemaType = {
    digital_onboarding: 'digital_onboarding',
    esa_onboarding: 'esa_onboarding',
    jpm_conversion: 'jpm_conversion',
    state_onboarding: 'state_onboarding',
    state_conversion: 'state_conversion',
    voya_onboarding: 'voya_onboarding'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOnboardingSchemaType = {
    digital_onboarding: 'digital_onboarding',
    esa_onboarding: 'esa_onboarding',
    jpm_conversion: 'jpm_conversion',
    state_onboarding: 'state_onboarding',
    state_conversion: 'state_conversion',
    voya_onboarding: 'voya_onboarding'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAgeBasedModelType = {
    nli: 'nli',
    target: 'target'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEmployeePendingTransactionsExcludeDistributionMethods = {
    FULL_CASH: 'FULL_CASH',
    PARTIAL_CASH: 'PARTIAL_CASH',
    FULL_ROLLOVER: 'FULL_ROLLOVER',
    PARTIAL_ROLLOVER: 'PARTIAL_ROLLOVER',
    CASH_AND_ROLLOVER: 'CASH_AND_ROLLOVER'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEmployeePerformanceExcludeDistributionMethods = {
    FULL_CASH: 'FULL_CASH',
    PARTIAL_CASH: 'PARTIAL_CASH',
    FULL_ROLLOVER: 'FULL_ROLLOVER',
    PARTIAL_ROLLOVER: 'PARTIAL_ROLLOVER',
    CASH_AND_ROLLOVER: 'CASH_AND_ROLLOVER'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEmployeeLoansExcludeDistributionMethods = {
    FULL_CASH: 'FULL_CASH',
    PARTIAL_CASH: 'PARTIAL_CASH',
    FULL_ROLLOVER: 'FULL_ROLLOVER',
    PARTIAL_ROLLOVER: 'PARTIAL_ROLLOVER',
    CASH_AND_ROLLOVER: 'CASH_AND_ROLLOVER'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEmployeeHoldingsExcludeDistributionMethods = {
    FULL_CASH: 'FULL_CASH',
    PARTIAL_CASH: 'PARTIAL_CASH',
    FULL_ROLLOVER: 'FULL_ROLLOVER',
    PARTIAL_ROLLOVER: 'PARTIAL_ROLLOVER',
    CASH_AND_ROLLOVER: 'CASH_AND_ROLLOVER'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VssStatusStatus = {
    unknown: 'unknown',
    none: 'none',
    readOnly: 'readOnly',
    normal: 'normal'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VssPlanType = {
    able: 'able',
    collegeSavings: 'collegeSavings',
    secureChoice: 'secureChoice'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RolloverDeliveryDtoMailType = {
    Express_Mail: 'Express Mail',
    Normal_Mail: 'Normal Mail'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RecurringGiftParametersOccasion = {
    birthday: 'birthday',
    'just-because': 'just-because',
    holiday: 'holiday',
    congratulations: 'congratulations',
    graduation: 'graduation',
    'get-well': 'get-well'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RecurringGiftFrequency = {
    monthly: 'monthly',
    biMonthly: 'biMonthly',
    yearly: 'yearly'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostWithdrawalBodyDtoReason = {
    ACP_CORRECTIVE: 'ACP_CORRECTIVE',
    ADP_CORRECTIVE: 'ADP_CORRECTIVE',
    CASH_OUT: 'CASH_OUT',
    CHILD: 'CHILD',
    DEATH: 'DEATH',
    DISABILITY: 'DISABILITY',
    EACA: 'EACA',
    FEE_OUT: 'FEE_OUT',
    FORCE_OUT: 'FORCE_OUT',
    HARDSHIP: 'HARDSHIP',
    IN_SERVICE: 'IN_SERVICE',
    PARTICIPANT_TERMINATION: 'PARTICIPANT_TERMINATION',
    PLAN_TERMINATION: 'PLAN_TERMINATION',
    QACA: 'QACA',
    QDRO: 'QDRO',
    '402G': '402G',
    NUMBER_415: '415',
    REQUIRED_MINIMUM: 'REQUIRED_MINIMUM',
    RETIREMENT_AGE: 'RETIREMENT_AGE',
    ROLLOVER: 'ROLLOVER',
    ESA: 'ESA'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostWithdrawalBodyDtoDistributionMethod = {
    CASH_AND_ROLLOVER: 'CASH_AND_ROLLOVER',
    FULL_CASH: 'FULL_CASH',
    FULL_ROLLOVER: 'FULL_ROLLOVER',
    PARTIAL_CASH: 'PARTIAL_CASH',
    PARTIAL_ROLLOVER: 'PARTIAL_ROLLOVER'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostSubaInitiateExternalTransferBodyDtoExternalTransferType = {
    transferToExternal: 'transferToExternal',
    transferFromExternal: 'transferFromExternal'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostParticipantPlaidLinksBalanceResDtoPlaidAccountType = {
    investment: 'investment',
    credit: 'credit',
    depository: 'depository',
    loan: 'loan',
    brokerage: 'brokerage',
    other: 'other'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostParticipantPlaidLinksBalanceResDtoPlaidAccountSubtype = {
    '401a': '401a',
    '401k': '401k',
    '403B': '403B',
    '457b': '457b',
    NUMBER_529: '529',
    brokerage: 'brokerage',
    cash_isa: 'cash isa',
    crypto_exchange: 'crypto exchange',
    education_savings_account: 'education savings account',
    ebt: 'ebt',
    fixed_annuity: 'fixed annuity',
    gic: 'gic',
    health_reimbursement_arrangement: 'health reimbursement arrangement',
    hsa: 'hsa',
    isa: 'isa',
    ira: 'ira',
    lif: 'lif',
    life_insurance: 'life insurance',
    lira: 'lira',
    lrif: 'lrif',
    lrsp: 'lrsp',
    'non-custodial_wallet': 'non-custodial wallet',
    'non-taxable_brokerage_account': 'non-taxable brokerage account',
    other: 'other',
    other_insurance: 'other insurance',
    other_annuity: 'other annuity',
    prif: 'prif',
    rdsp: 'rdsp',
    resp: 'resp',
    rlif: 'rlif',
    rrif: 'rrif',
    pension: 'pension',
    profit_sharing_plan: 'profit sharing plan',
    retirement: 'retirement',
    roth: 'roth',
    roth_401k: 'roth 401k',
    rrsp: 'rrsp',
    sep_ira: 'sep ira',
    simple_ira: 'simple ira',
    sipp: 'sipp',
    stock_plan: 'stock plan',
    thrift_savings_plan: 'thrift savings plan',
    tfsa: 'tfsa',
    trust: 'trust',
    ugma: 'ugma',
    variable_annuity: 'variable annuity',
    credit_card: 'credit card',
    paypal: 'paypal',
    cd: 'cd',
    checking: 'checking',
    savings: 'savings',
    money_market: 'money market',
    prepaid: 'prepaid',
    auto: 'auto',
    business: 'business',
    commercial: 'commercial',
    construction: 'construction',
    consumer: 'consumer',
    home_equity: 'home equity',
    loan: 'loan',
    mortgage: 'mortgage',
    overdraft: 'overdraft',
    line_of_credit: 'line of credit',
    student: 'student',
    cash_management: 'cash management',
    keogh: 'keogh',
    mutual_fund: 'mutual fund',
    recurring: 'recurring',
    rewards: 'rewards',
    safe_deposit: 'safe deposit',
    sarsep: 'sarsep',
    payroll: 'payroll',
    null: 'null'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostMsManagedAccountsPreviewAllocationBodyDtoRiskTolerance = {
    aggressive: 'aggressive',
    conservative: 'conservative',
    moderate: 'moderate'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostMsManagedAccountsActivateBodyDtoRiskTolerance = {
    aggressive: 'aggressive',
    conservative: 'conservative',
    moderate: 'moderate'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostMsManagedAccounts401kManagerQuestionnaireResDtoRiskTolerance = {
    aggressive: 'aggressive',
    conservative: 'conservative',
    moderate: 'moderate'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostCensusCacheBodyDtoSchemaType = {
    digital_onboarding: 'digital_onboarding',
    esa_onboarding: 'esa_onboarding',
    jpm_conversion: 'jpm_conversion',
    state_onboarding: 'state_onboarding',
    state_conversion: 'state_conversion',
    voya_onboarding: 'voya_onboarding'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PdfConfigDtoFormat = {
    letter: 'letter',
    legal: 'legal',
    tabloid: 'tabloid',
    ledger: 'ledger',
    a0: 'a0',
    a1: 'a1',
    a2: 'a2',
    a3: 'a3',
    a4: 'a4',
    a5: 'a5',
    a6: 'a6'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchStatefulSchemaTrackingStatusBodyDtoStatus = {
    completed_successfully: 'completed_successfully',
    completed_unsuccessfully: 'completed_unsuccessfully',
    in_progress: 'in_progress',
    needs_attention: 'needs_attention',
    new: 'new',
    ongoing: 'ongoing'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchSponsorQuestionnaireDtoOnboardingPlanDesignCallStatus = {
    Plan_Design_Call_Scheduled: 'Plan Design Call Scheduled',
    Plan_Design_Call_Delayed: 'Plan Design Call Delayed'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchPlanDesignConsultStateResDtoPlanDesignConsultType = {
    Full_Consultation: 'Full Consultation',
    Sales_Consultation: 'Sales Consultation',
    Partner_Consultation: 'Partner Consultation',
    Self_Service_Tiles: 'Self Service Tiles',
    'Solo(K)': 'Solo(K)',
    Website_Direct: 'Website Direct'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchPlanDesignConsultStateDtoPlanDesignConsultType = {
    Full_Consultation: 'Full Consultation',
    Sales_Consultation: 'Sales Consultation',
    Partner_Consultation: 'Partner Consultation',
    Self_Service_Tiles: 'Self Service Tiles',
    'Solo(K)': 'Solo(K)',
    Website_Direct: 'Website Direct'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchEsaWithdrawalBodyDtoEsaReason = {
    AUTOMOBILE: 'AUTOMOBILE',
    FUNERAL: 'FUNERAL',
    MEDICAL: 'MEDICAL',
    NOT_SAY: 'NOT_SAY',
    OTHER: 'OTHER',
    REPAIR_RESIDENCE: 'REPAIR_RESIDENCE',
    TUITION_EDUCATION: 'TUITION_EDUCATION'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ParticipantInvestmentsModelDtoModelType = {
    target: 'target',
    risk: 'risk',
    menu: 'menu',
    pmenu: 'pmenu',
    goal: 'goal',
    ms_ma: 'ms_ma',
    ms_ma_menu: 'ms_ma_menu',
    nli: 'nli'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ParticipantInvestmentElectionRiskProfile = {
    aggressive: 'aggressive',
    conservative: 'conservative',
    moderate: 'moderate'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModelWithPerformanceModelType = {
    target: 'target',
    risk: 'risk',
    menu: 'menu',
    pmenu: 'pmenu',
    goal: 'goal',
    ms_ma: 'ms_ma',
    ms_ma_menu: 'ms_ma_menu',
    nli: 'nli'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModelModelType = {
    target: 'target',
    risk: 'risk',
    menu: 'menu',
    pmenu: 'pmenu',
    goal: 'goal',
    ms_ma: 'ms_ma',
    ms_ma_menu: 'ms_ma_menu',
    nli: 'nli'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GiftSubmissionBodyDtoOccasion = {
    birthday: 'birthday',
    'just-because': 'just-because',
    holiday: 'holiday',
    congratulations: 'congratulations',
    graduation: 'graduation',
    'get-well': 'get-well'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GiftSubmissionBodyDtoFrequency = {
    monthly: 'monthly',
    biMonthly: 'biMonthly',
    yearly: 'yearly'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GiftPaymentMethod = {
    debit: 'debit',
    ach: 'ach'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GiftPaymentAccountType = {
    checking: 'checking',
    savings: 'savings',
    prepaid: 'prepaid'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GiftContributorBankBankAccountType = {
    checking: 'checking',
    savings: 'savings',
    prepaid: 'prepaid'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPlanStatisticsModelAgeDistributionModelType = {
    target: 'target',
    risk: 'risk',
    menu: 'menu',
    pmenu: 'pmenu',
    goal: 'goal',
    ms_ma: 'ms_ma',
    ms_ma_menu: 'ms_ma_menu',
    nli: 'nli'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPlanStatisticsModelAgeDistributionAgeRange = {
    '<=25': '<=25',
    '26-35': '26-35',
    '36-45': '36-45',
    '46-55': '46-55',
    '56-65': '56-65',
    '>=66': '>=66'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPlanDesignConsultStateResDtoPlanDesignConsultType = {
    Full_Consultation: 'Full Consultation',
    Sales_Consultation: 'Sales Consultation',
    Partner_Consultation: 'Partner Consultation',
    Self_Service_Tiles: 'Self Service Tiles',
    'Solo(K)': 'Solo(K)',
    Website_Direct: 'Website Direct'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetParticipantLoanCreateLoanPreferencesAllowedPayFrequenciesItem = {
    SC: 'SC',
    B: 'B',
    W: 'W',
    S: 'S',
    M: 'M',
    ME: 'ME'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetParticipantLoanCreateLoanPreferencesAllowedLoanPurposesItem = {
    General: 'General',
    Principal_Residence_Purchase: 'Principal Residence Purchase'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetParticipantBeneficiariesResDtoRelationship = {
    spouse: 'spouse',
    child: 'child',
    parent: 'parent',
    other: 'other'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetParticipantBeneficiariesResDtoBeneficiaryType = {
    person: 'person',
    trust: 'trust',
    organization: 'organization'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOnboardingDtoStatus = {
    completed_successfully: 'completed_successfully',
    completed_unsuccessfully: 'completed_unsuccessfully',
    in_progress: 'in_progress',
    needs_attention: 'needs_attention',
    new: 'new',
    ongoing: 'ongoing'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetMsManagedAccountsPreviewAllocationResDtoRiskTolerance = {
    aggressive: 'aggressive',
    conservative: 'conservative',
    moderate: 'moderate'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgeBasedBodyDtoModelType = {
    nli: 'nli',
    target: 'target'
};
export const getAdvisorById = (params, signal)=>{
    return client({
        url: `/api/advisor`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdvisorByIdQueryKey = (params)=>{
    return [
        `/api/advisor`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdvisorByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorByIdQueryKey(params);
    const queryFn = ({ signal })=>getAdvisorById(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetAdvisorById = (params, options)=>{
    const queryOptions = getGetAdvisorByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getAdvisorCommercialPlatforms = (params, signal)=>{
    return client({
        url: `/api/advisor/commercial-platforms`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdvisorCommercialPlatformsQueryKey = (params)=>{
    return [
        `/api/advisor/commercial-platforms`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdvisorCommercialPlatformsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorCommercialPlatformsQueryKey(params);
    const queryFn = ({ signal })=>getAdvisorCommercialPlatforms(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetAdvisorCommercialPlatforms = (params, options)=>{
    const queryOptions = getGetAdvisorCommercialPlatformsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getAdvisorContactCard = (signal)=>{
    return client({
        url: `/api/advisor/contact-card`,
        method: 'GET',
        signal
    });
};
export const getGetAdvisorContactCardQueryKey = ()=>{
    return [
        `/api/advisor/contact-card`
    ];
};
export const getGetAdvisorContactCardQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorContactCardQueryKey();
    const queryFn = ({ signal })=>getAdvisorContactCard(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetAdvisorContactCard = (options)=>{
    const queryOptions = getGetAdvisorContactCardQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putAdvisorContactCard = (advisorContactCardBodyDto)=>{
    return client({
        url: `/api/advisor/contact-card`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: advisorContactCardBodyDto
    });
};
export const getPutAdvisorContactCardMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putAdvisorContactCard(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutAdvisorContactCard = (options)=>{
    const mutationOptions = getPutAdvisorContactCardMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPlans = (params, signal)=>{
    return client({
        url: `/api/advisor/plans`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPlansQueryKey = (params)=>{
    return [
        `/api/advisor/plans`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPlansQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlansQueryKey(params);
    const queryFn = ({ signal })=>getPlans(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlans = (params, options)=>{
    const queryOptions = getGetPlansQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getAdvisorAnnualTestingPlansPerYear = (year, params, signal)=>{
    return client({
        url: `/api/advisor/plans/annual-testing/${year}`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdvisorAnnualTestingPlansPerYearQueryKey = (year, params)=>{
    return [
        `/api/advisor/plans/annual-testing/${year}`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdvisorAnnualTestingPlansPerYearQueryOptions = (year, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorAnnualTestingPlansPerYearQueryKey(year, params);
    const queryFn = ({ signal })=>getAdvisorAnnualTestingPlansPerYear(year, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!year,
        ...queryOptions
    };
};
export const useGetAdvisorAnnualTestingPlansPerYear = (year, params, options)=>{
    const queryOptions = getGetAdvisorAnnualTestingPlansPerYearQueryOptions(year, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPlansTracker = (params, signal)=>{
    return client({
        url: `/api/advisor/plans/tracker`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPlansTrackerQueryKey = (params)=>{
    return [
        `/api/advisor/plans/tracker`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPlansTrackerQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlansTrackerQueryKey(params);
    const queryFn = ({ signal })=>getPlansTracker(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlansTracker = (params, options)=>{
    const queryOptions = getGetPlansTrackerQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getAdvisorPlanEmployees = (planId, params, signal)=>{
    return client({
        url: `/api/advisor/plans/${planId}/employees`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdvisorPlanEmployeesQueryKey = (planId, params)=>{
    return [
        `/api/advisor/plans/${planId}/employees`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdvisorPlanEmployeesQueryOptions = (planId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorPlanEmployeesQueryKey(planId, params);
    const queryFn = ({ signal })=>getAdvisorPlanEmployees(planId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!planId,
        ...queryOptions
    };
};
export const useGetAdvisorPlanEmployees = (planId, params, options)=>{
    const queryOptions = getGetAdvisorPlanEmployeesQueryOptions(planId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPlanEmployee = (planId, employeeId, signal)=>{
    return client({
        url: `/api/advisor/plans/${planId}/employees/${employeeId}`,
        method: 'GET',
        signal
    });
};
export const getGetPlanEmployeeQueryKey = (planId, employeeId)=>{
    return [
        `/api/advisor/plans/${planId}/employees/${employeeId}`
    ];
};
export const getGetPlanEmployeeQueryOptions = (planId, employeeId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanEmployeeQueryKey(planId, employeeId);
    const queryFn = ({ signal })=>getPlanEmployee(planId, employeeId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(planId && employeeId),
        ...queryOptions
    };
};
export const useGetPlanEmployee = (planId, employeeId, options)=>{
    const queryOptions = getGetPlanEmployeeQueryOptions(planId, employeeId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getAdvisorPlanStatistics = (planId, signal)=>{
    return client({
        url: `/api/advisor/plans/${planId}/stats`,
        method: 'GET',
        signal
    });
};
export const getGetAdvisorPlanStatisticsQueryKey = (planId)=>{
    return [
        `/api/advisor/plans/${planId}/stats`
    ];
};
export const getGetAdvisorPlanStatisticsQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorPlanStatisticsQueryKey(planId);
    const queryFn = ({ signal })=>getAdvisorPlanStatistics(planId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!planId,
        ...queryOptions
    };
};
export const useGetAdvisorPlanStatistics = (planId, options)=>{
    const queryOptions = getGetAdvisorPlanStatisticsQueryOptions(planId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postLinkSponsor = (advisorSponsorLinksBody)=>{
    return client({
        url: `/api/advisor/sponsors/link`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: advisorSponsorLinksBody
    });
};
export const getPostLinkSponsorMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postLinkSponsor(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostLinkSponsor = (options)=>{
    const mutationOptions = getPostLinkSponsorMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getAdvisorStats = (params, signal)=>{
    return client({
        url: `/api/advisor/statistics`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdvisorStatsQueryKey = (params)=>{
    return [
        `/api/advisor/statistics`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdvisorStatsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorStatsQueryKey(params);
    const queryFn = ({ signal })=>getAdvisorStats(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetAdvisorStats = (params, options)=>{
    const queryOptions = getGetAdvisorStatsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getCarousel = (signal)=>{
    return client({
        url: `/api/carousel`,
        method: 'GET',
        signal
    });
};
export const getGetCarouselQueryKey = ()=>{
    return [
        `/api/carousel`
    ];
};
export const getGetCarouselQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCarouselQueryKey();
    const queryFn = ({ signal })=>getCarousel(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetCarousel = (options)=>{
    const queryOptions = getGetCarouselQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getConnectivity = (params, signal)=>{
    return client({
        url: `/api/connectivity`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetConnectivityQueryKey = (params)=>{
    return [
        `/api/connectivity`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetConnectivityQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConnectivityQueryKey(params);
    const queryFn = ({ signal })=>getConnectivity(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetConnectivity = (params, options)=>{
    const queryOptions = getGetConnectivityQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getCsm = (params, signal)=>{
    return client({
        url: `/api/csm`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetCsmQueryKey = (params)=>{
    return [
        `/api/csm`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetCsmQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCsmQueryKey(params);
    const queryFn = ({ signal })=>getCsm(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetCsm = (params, options)=>{
    const queryOptions = getGetCsmQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getLoginDisclosure = (signal)=>{
    return client({
        url: `/api/disclosure/login`,
        method: 'GET',
        signal
    });
};
export const getGetLoginDisclosureQueryKey = ()=>{
    return [
        `/api/disclosure/login`
    ];
};
export const getGetLoginDisclosureQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetLoginDisclosureQueryKey();
    const queryFn = ({ signal })=>getLoginDisclosure(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetLoginDisclosure = (options)=>{
    const queryOptions = getGetLoginDisclosureQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putLoginDisclosure = (putLoginDisclosureBodyDto)=>{
    return client({
        url: `/api/disclosure/login`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putLoginDisclosureBodyDto
    });
};
export const getPutLoginDisclosureMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putLoginDisclosure(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutLoginDisclosure = (options)=>{
    const mutationOptions = getPutLoginDisclosureMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getLoginDisclosureAgreement = (signal)=>{
    return client({
        url: `/api/disclosure/login/agreement`,
        method: 'GET',
        signal
    });
};
export const getGetLoginDisclosureAgreementQueryKey = ()=>{
    return [
        `/api/disclosure/login/agreement`
    ];
};
export const getGetLoginDisclosureAgreementQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetLoginDisclosureAgreementQueryKey();
    const queryFn = ({ signal })=>getLoginDisclosureAgreement(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetLoginDisclosureAgreement = (options)=>{
    const queryOptions = getGetLoginDisclosureAgreementQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getDocumentById = (params, signal)=>{
    return client({
        url: `/api/document`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetDocumentByIdQueryKey = (params)=>{
    return [
        `/api/document`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetDocumentByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDocumentByIdQueryKey(params);
    const queryFn = ({ signal })=>getDocumentById(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetDocumentById = (params, options)=>{
    const queryOptions = getGetDocumentByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchDeleteDocumentById = (documentQueryDto)=>{
    return client({
        url: `/api/document`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: documentQueryDto
    });
};
export const getPatchDeleteDocumentByIdMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchDeleteDocumentById(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchDeleteDocumentById = (options)=>{
    const mutationOptions = getPatchDeleteDocumentByIdMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getAllDocuments = (params, signal)=>{
    return client({
        url: `/api/documents`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAllDocumentsQueryKey = (params)=>{
    return [
        `/api/documents`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAllDocumentsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllDocumentsQueryKey(params);
    const queryFn = ({ signal })=>getAllDocuments(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetAllDocuments = (params, options)=>{
    const queryOptions = getGetAllDocumentsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getDocumentAgreement = (params, signal)=>{
    return client({
        url: `/api/documents/agreement`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetDocumentAgreementQueryKey = (params)=>{
    return [
        `/api/documents/agreement`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetDocumentAgreementQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDocumentAgreementQueryKey(params);
    const queryFn = ({ signal })=>getDocumentAgreement(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetDocumentAgreement = (params, options)=>{
    const queryOptions = getGetDocumentAgreementQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postDocumentAgreement = (postDocumentAgreementBodyDto)=>{
    return client({
        url: `/api/documents/agreement`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postDocumentAgreementBodyDto
    });
};
export const getPostDocumentAgreementMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postDocumentAgreement(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostDocumentAgreement = (options)=>{
    const mutationOptions = getPostDocumentAgreementMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getDocumentDownloadById = (params, signal)=>{
    return client({
        url: `/api/documents/download`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetDocumentDownloadByIdQueryKey = (params)=>{
    return [
        `/api/documents/download`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetDocumentDownloadByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDocumentDownloadByIdQueryKey(params);
    const queryFn = ({ signal })=>getDocumentDownloadById(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetDocumentDownloadById = (params, options)=>{
    const queryOptions = getGetDocumentDownloadByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getDocumentDownloadByKey = (params, signal)=>{
    return client({
        url: `/api/documents/download-by-key`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetDocumentDownloadByKeyQueryKey = (params)=>{
    return [
        `/api/documents/download-by-key`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetDocumentDownloadByKeyQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDocumentDownloadByKeyQueryKey(params);
    const queryFn = ({ signal })=>getDocumentDownloadByKey(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetDocumentDownloadByKey = (params, options)=>{
    const queryOptions = getGetDocumentDownloadByKeyQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getDocumentAsHtml = (params, signal)=>{
    return client({
        url: `/api/documents/html`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetDocumentAsHtmlQueryKey = (params)=>{
    return [
        `/api/documents/html`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetDocumentAsHtmlQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDocumentAsHtmlQueryKey(params);
    const queryFn = ({ signal })=>getDocumentAsHtml(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetDocumentAsHtml = (params, options)=>{
    const queryOptions = getGetDocumentAsHtmlQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getDocumentAsHtmlAndDownload = (params, signal)=>{
    return client({
        url: `/api/documents/html/download`,
        method: 'GET',
        params,
        responseType: 'blob',
        signal
    });
};
export const getGetDocumentAsHtmlAndDownloadQueryKey = (params)=>{
    return [
        `/api/documents/html/download`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetDocumentAsHtmlAndDownloadQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDocumentAsHtmlAndDownloadQueryKey(params);
    const queryFn = ({ signal })=>getDocumentAsHtmlAndDownload(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetDocumentAsHtmlAndDownload = (params, options)=>{
    const queryOptions = getGetDocumentAsHtmlAndDownloadQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postPdf = (postPdfBodyDto)=>{
    return client({
        url: `/api/documents/pdf`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postPdfBodyDto,
        responseType: 'blob'
    });
};
export const getPostPdfMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postPdf(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPdf = (options)=>{
    const mutationOptions = getPostPdfMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postProcessDocument = (postProcessDocumentBodyDto)=>{
    return client({
        url: `/api/documents/process`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postProcessDocumentBodyDto
    });
};
export const getPostProcessDocumentMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postProcessDocument(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostProcessDocument = (options)=>{
    const mutationOptions = getPostProcessDocumentMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postUploadDocument = (uploadDocumentDto)=>{
    return client({
        url: `/api/documents/upload`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: uploadDocumentDto
    });
};
export const getPostUploadDocumentMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postUploadDocument(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostUploadDocument = (options)=>{
    const mutationOptions = getPostUploadDocumentMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postEmail = (postEmailBodyDto)=>{
    return client({
        url: `/api/email`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postEmailBodyDto
    });
};
export const getPostEmailMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postEmail(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostEmail = (options)=>{
    const mutationOptions = getPostEmailMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postEmailPreviewRender = (emailPreviewRenderBodyDto)=>{
    return client({
        url: `/api/email/preview/render`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: emailPreviewRenderBodyDto
    });
};
export const getPostEmailPreviewRenderMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postEmailPreviewRender(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostEmailPreviewRender = (options)=>{
    const mutationOptions = getPostEmailPreviewRenderMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getEmailPreviewById = (params, signal)=>{
    return client({
        url: `/api/email/previews`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEmailPreviewByIdQueryKey = (params)=>{
    return [
        `/api/email/previews`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEmailPreviewByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmailPreviewByIdQueryKey(params);
    const queryFn = ({ signal })=>getEmailPreviewById(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEmailPreviewById = (params, options)=>{
    const queryOptions = getGetEmailPreviewByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEmployeeHoldings = (params, signal)=>{
    return client({
        url: `/api/employee/holdings`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEmployeeHoldingsQueryKey = (params)=>{
    return [
        `/api/employee/holdings`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEmployeeHoldingsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmployeeHoldingsQueryKey(params);
    const queryFn = ({ signal })=>getEmployeeHoldings(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEmployeeHoldings = (params, options)=>{
    const queryOptions = getGetEmployeeHoldingsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEmployeeLoans = (params, signal)=>{
    return client({
        url: `/api/employee/loans`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEmployeeLoansQueryKey = (params)=>{
    return [
        `/api/employee/loans`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEmployeeLoansQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmployeeLoansQueryKey(params);
    const queryFn = ({ signal })=>getEmployeeLoans(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEmployeeLoans = (params, options)=>{
    const queryOptions = getGetEmployeeLoansQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEmployeePerformance = (params, signal)=>{
    return client({
        url: `/api/employee/performance`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEmployeePerformanceQueryKey = (params)=>{
    return [
        `/api/employee/performance`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEmployeePerformanceQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmployeePerformanceQueryKey(params);
    const queryFn = ({ signal })=>getEmployeePerformance(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEmployeePerformance = (params, options)=>{
    const queryOptions = getGetEmployeePerformanceQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEmployeeTransactions = (params, signal)=>{
    return client({
        url: `/api/employee/transactions`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEmployeeTransactionsQueryKey = (params)=>{
    return [
        `/api/employee/transactions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEmployeeTransactionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmployeeTransactionsQueryKey(params);
    const queryFn = ({ signal })=>getEmployeeTransactions(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEmployeeTransactions = (params, options)=>{
    const queryOptions = getGetEmployeeTransactionsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEmployeePendingTransactions = (params, signal)=>{
    return client({
        url: `/api/employee/transactions/pending`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEmployeePendingTransactionsQueryKey = (params)=>{
    return [
        `/api/employee/transactions/pending`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEmployeePendingTransactionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmployeePendingTransactionsQueryKey(params);
    const queryFn = ({ signal })=>getEmployeePendingTransactions(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEmployeePendingTransactions = (params, options)=>{
    const queryOptions = getGetEmployeePendingTransactionsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEmployeeTransactionsYears = (params, signal)=>{
    return client({
        url: `/api/employee/transactions/years`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEmployeeTransactionsYearsQueryKey = (params)=>{
    return [
        `/api/employee/transactions/years`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEmployeeTransactionsYearsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmployeeTransactionsYearsQueryKey(params);
    const queryFn = ({ signal })=>getEmployeeTransactionsYears(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEmployeeTransactionsYears = (params, options)=>{
    const queryOptions = getGetEmployeeTransactionsYearsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getProgramModelSecurities = (employeeId, type, signal)=>{
    return client({
        url: `/api/employee/${employeeId}/model-securities/${type}`,
        method: 'GET',
        signal
    });
};
export const getGetProgramModelSecuritiesQueryKey = (employeeId, type)=>{
    return [
        `/api/employee/${employeeId}/model-securities/${type}`
    ];
};
export const getGetProgramModelSecuritiesQueryOptions = (employeeId, type, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetProgramModelSecuritiesQueryKey(employeeId, type);
    const queryFn = ({ signal })=>getProgramModelSecurities(employeeId, type, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(employeeId && type),
        ...queryOptions
    };
};
export const useGetProgramModelSecurities = (employeeId, type, options)=>{
    const queryOptions = getGetProgramModelSecuritiesQueryOptions(employeeId, type, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEmployeesWithContributions = (params, signal)=>{
    return client({
        url: `/api/employees/contributions`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEmployeesWithContributionsQueryKey = (params)=>{
    return [
        `/api/employees/contributions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEmployeesWithContributionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmployeesWithContributionsQueryKey(params);
    const queryFn = ({ signal })=>getEmployeesWithContributions(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEmployeesWithContributions = (params, options)=>{
    const queryOptions = getGetEmployeesWithContributionsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEmployeeLoanDetails = (params, signal)=>{
    return client({
        url: `/api/employees/loans/details`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEmployeeLoanDetailsQueryKey = (params)=>{
    return [
        `/api/employees/loans/details`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEmployeeLoanDetailsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmployeeLoanDetailsQueryKey(params);
    const queryFn = ({ signal })=>getEmployeeLoanDetails(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEmployeeLoanDetails = (params, options)=>{
    const queryOptions = getGetEmployeeLoanDetailsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEmployeesTransactionsYears = (params, signal)=>{
    return client({
        url: `/api/employees/transactions/years`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEmployeesTransactionsYearsQueryKey = (params)=>{
    return [
        `/api/employees/transactions/years`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEmployeesTransactionsYearsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmployeesTransactionsYearsQueryKey(params);
    const queryFn = ({ signal })=>getEmployeesTransactionsYears(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEmployeesTransactionsYears = (params, options)=>{
    const queryOptions = getGetEmployeesTransactionsYearsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchEsaParticipantGoal = (patchEsaParticipantGoalBodyDto)=>{
    return client({
        url: `/api/esa/participant/goal`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchEsaParticipantGoalBodyDto
    });
};
export const getPatchEsaParticipantGoalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchEsaParticipantGoal(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchEsaParticipantGoal = (options)=>{
    const mutationOptions = getPatchEsaParticipantGoalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getEsaParticipantGoals = (signal)=>{
    return client({
        url: `/api/esa/participant/goals`,
        method: 'GET',
        signal
    });
};
export const getGetEsaParticipantGoalsQueryKey = ()=>{
    return [
        `/api/esa/participant/goals`
    ];
};
export const getGetEsaParticipantGoalsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEsaParticipantGoalsQueryKey();
    const queryFn = ({ signal })=>getEsaParticipantGoals(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEsaParticipantGoals = (options)=>{
    const queryOptions = getGetEsaParticipantGoalsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEsaParticipantIncentives = (signal)=>{
    return client({
        url: `/api/esa/participant/incentives`,
        method: 'GET',
        signal
    });
};
export const getGetEsaParticipantIncentivesQueryKey = ()=>{
    return [
        `/api/esa/participant/incentives`
    ];
};
export const getGetEsaParticipantIncentivesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEsaParticipantIncentivesQueryKey();
    const queryFn = ({ signal })=>getEsaParticipantIncentives(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEsaParticipantIncentives = (options)=>{
    const queryOptions = getGetEsaParticipantIncentivesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEsaPlanCashInterestRate = (signal)=>{
    return client({
        url: `/api/esa/plan/cash-interest-rate`,
        method: 'GET',
        signal
    });
};
export const getGetEsaPlanCashInterestRateQueryKey = ()=>{
    return [
        `/api/esa/plan/cash-interest-rate`
    ];
};
export const getGetEsaPlanCashInterestRateQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEsaPlanCashInterestRateQueryKey();
    const queryFn = ({ signal })=>getEsaPlanCashInterestRate(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEsaPlanCashInterestRate = (options)=>{
    const queryOptions = getGetEsaPlanCashInterestRateQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEsaPlanGroupBalanceOverTime = (params, signal)=>{
    return client({
        url: `/api/esa/plan/group-balance-over-time`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEsaPlanGroupBalanceOverTimeQueryKey = (params)=>{
    return [
        `/api/esa/plan/group-balance-over-time`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEsaPlanGroupBalanceOverTimeQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEsaPlanGroupBalanceOverTimeQueryKey(params);
    const queryFn = ({ signal })=>getEsaPlanGroupBalanceOverTime(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEsaPlanGroupBalanceOverTime = (params, options)=>{
    const queryOptions = getGetEsaPlanGroupBalanceOverTimeQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEsaPlanGroupStats = (params, signal)=>{
    return client({
        url: `/api/esa/plan/group-stats`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEsaPlanGroupStatsQueryKey = (params)=>{
    return [
        `/api/esa/plan/group-stats`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEsaPlanGroupStatsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEsaPlanGroupStatsQueryKey(params);
    const queryFn = ({ signal })=>getEsaPlanGroupStats(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEsaPlanGroupStats = (params, options)=>{
    const queryOptions = getGetEsaPlanGroupStatsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEsaPlanGroups = (signal)=>{
    return client({
        url: `/api/esa/plan/groups`,
        method: 'GET',
        signal
    });
};
export const getGetEsaPlanGroupsQueryKey = ()=>{
    return [
        `/api/esa/plan/groups`
    ];
};
export const getGetEsaPlanGroupsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEsaPlanGroupsQueryKey();
    const queryFn = ({ signal })=>getEsaPlanGroups(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEsaPlanGroups = (options)=>{
    const queryOptions = getGetEsaPlanGroupsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEsaPlanIncentives = (signal)=>{
    return client({
        url: `/api/esa/plan/incentives`,
        method: 'GET',
        signal
    });
};
export const getGetEsaPlanIncentivesQueryKey = ()=>{
    return [
        `/api/esa/plan/incentives`
    ];
};
export const getGetEsaPlanIncentivesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEsaPlanIncentivesQueryKey();
    const queryFn = ({ signal })=>getEsaPlanIncentives(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEsaPlanIncentives = (options)=>{
    const queryOptions = getGetEsaPlanIncentivesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchEsaWithdrawal = (patchEsaWithdrawalBodyDto)=>{
    return client({
        url: `/api/esa/withdrawal`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchEsaWithdrawalBodyDto
    });
};
export const getPatchEsaWithdrawalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchEsaWithdrawal(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchEsaWithdrawal = (options)=>{
    const mutationOptions = getPatchEsaWithdrawalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getFi360Download = (params, signal)=>{
    return client({
        url: `/api/fact-sheets`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetFi360DownloadQueryKey = (params)=>{
    return [
        `/api/fact-sheets`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetFi360DownloadQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFi360DownloadQueryKey(params);
    const queryFn = ({ signal })=>getFi360Download(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetFi360Download = (params, options)=>{
    const queryOptions = getGetFi360DownloadQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getFeatureToggles = (params, signal)=>{
    return client({
        url: `/api/feature-toggle`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetFeatureTogglesQueryKey = (params)=>{
    return [
        `/api/feature-toggle`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetFeatureTogglesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFeatureTogglesQueryKey(params);
    const queryFn = ({ signal })=>getFeatureToggles(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetFeatureToggles = (params, options)=>{
    const queryOptions = getGetFeatureTogglesQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getFeatureTogglesList = (params, signal)=>{
    return client({
        url: `/api/feature-toggle/list`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetFeatureTogglesListQueryKey = (params)=>{
    return [
        `/api/feature-toggle/list`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetFeatureTogglesListQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFeatureTogglesListQueryKey(params);
    const queryFn = ({ signal })=>getFeatureTogglesList(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetFeatureTogglesList = (params, options)=>{
    const queryOptions = getGetFeatureTogglesListQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getFirmById = (params, signal)=>{
    return client({
        url: `/api/firm/entity`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetFirmByIdQueryKey = (params)=>{
    return [
        `/api/firm/entity`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetFirmByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFirmByIdQueryKey(params);
    const queryFn = ({ signal })=>getFirmById(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetFirmById = (params, options)=>{
    const queryOptions = getGetFirmByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getGiftContributorRecurring = (giftContributorId, giftAccountId, signal)=>{
    return client({
        url: `/api/gifting/contributor/${giftContributorId}/gift-account/${giftAccountId}/recurring`,
        method: 'GET',
        signal
    });
};
export const getGetGiftContributorRecurringQueryKey = (giftContributorId, giftAccountId)=>{
    return [
        `/api/gifting/contributor/${giftContributorId}/gift-account/${giftAccountId}/recurring`
    ];
};
export const getGetGiftContributorRecurringQueryOptions = (giftContributorId, giftAccountId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetGiftContributorRecurringQueryKey(giftContributorId, giftAccountId);
    const queryFn = ({ signal })=>getGiftContributorRecurring(giftContributorId, giftAccountId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(giftContributorId && giftAccountId),
        ...queryOptions
    };
};
export const useGetGiftContributorRecurring = (giftContributorId, giftAccountId, options)=>{
    const queryOptions = getGetGiftContributorRecurringQueryOptions(giftContributorId, giftAccountId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const deleteGiftContributorRecurring = (giftContributorId, giftAccountId, recurringId)=>{
    return client({
        url: `/api/gifting/contributor/${giftContributorId}/gift-account/${giftAccountId}/recurring/${recurringId}`,
        method: 'DELETE'
    });
};
export const getDeleteGiftContributorRecurringMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { giftContributorId, giftAccountId, recurringId } = props ?? {};
        return deleteGiftContributorRecurring(giftContributorId, giftAccountId, recurringId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteGiftContributorRecurring = (options)=>{
    const mutationOptions = getDeleteGiftContributorRecurringMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getGiftContributorBanks = (giftContributorId, signal)=>{
    return client({
        url: `/api/gifting/contributor/${giftContributorId}/gift-banks`,
        method: 'GET',
        signal
    });
};
export const getGetGiftContributorBanksQueryKey = (giftContributorId)=>{
    return [
        `/api/gifting/contributor/${giftContributorId}/gift-banks`
    ];
};
export const getGetGiftContributorBanksQueryOptions = (giftContributorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetGiftContributorBanksQueryKey(giftContributorId);
    const queryFn = ({ signal })=>getGiftContributorBanks(giftContributorId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!giftContributorId,
        ...queryOptions
    };
};
export const useGetGiftContributorBanks = (giftContributorId, options)=>{
    const queryOptions = getGetGiftContributorBanksQueryOptions(giftContributorId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getGiftContributorPayments = (giftContributorId, signal)=>{
    return client({
        url: `/api/gifting/contributor/${giftContributorId}/gift-payments`,
        method: 'GET',
        signal
    });
};
export const getGetGiftContributorPaymentsQueryKey = (giftContributorId)=>{
    return [
        `/api/gifting/contributor/${giftContributorId}/gift-payments`
    ];
};
export const getGetGiftContributorPaymentsQueryOptions = (giftContributorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetGiftContributorPaymentsQueryKey(giftContributorId);
    const queryFn = ({ signal })=>getGiftContributorPayments(giftContributorId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!giftContributorId,
        ...queryOptions
    };
};
export const useGetGiftContributorPayments = (giftContributorId, options)=>{
    const queryOptions = getGetGiftContributorPaymentsQueryOptions(giftContributorId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getGiftContributorRecipients = (giftContributorId, signal)=>{
    return client({
        url: `/api/gifting/contributor/${giftContributorId}/recipients`,
        method: 'GET',
        signal
    });
};
export const getGetGiftContributorRecipientsQueryKey = (giftContributorId)=>{
    return [
        `/api/gifting/contributor/${giftContributorId}/recipients`
    ];
};
export const getGetGiftContributorRecipientsQueryOptions = (giftContributorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetGiftContributorRecipientsQueryKey(giftContributorId);
    const queryFn = ({ signal })=>getGiftContributorRecipients(giftContributorId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!giftContributorId,
        ...queryOptions
    };
};
export const useGetGiftContributorRecipients = (giftContributorId, options)=>{
    const queryOptions = getGetGiftContributorRecipientsQueryOptions(giftContributorId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getGiftingPageAndAccountById = (giftingId, giftContributorId, signal)=>{
    return client({
        url: `/api/gifting/gift-account/${giftingId}/${giftContributorId}`,
        method: 'GET',
        signal
    });
};
export const getGetGiftingPageAndAccountByIdQueryKey = (giftingId, giftContributorId)=>{
    return [
        `/api/gifting/gift-account/${giftingId}/${giftContributorId}`
    ];
};
export const getGetGiftingPageAndAccountByIdQueryOptions = (giftingId, giftContributorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetGiftingPageAndAccountByIdQueryKey(giftingId, giftContributorId);
    const queryFn = ({ signal })=>getGiftingPageAndAccountById(giftingId, giftContributorId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(giftingId && giftContributorId),
        ...queryOptions
    };
};
export const useGetGiftingPageAndAccountById = (giftingId, giftContributorId, options)=>{
    const queryOptions = getGetGiftingPageAndAccountByIdQueryOptions(giftingId, giftContributorId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getGiftingPageById = (planId, giftingId, signal)=>{
    return client({
        url: `/api/gifting/gift/${planId}/${giftingId}`,
        method: 'GET',
        signal
    });
};
export const getGetGiftingPageByIdQueryKey = (planId, giftingId)=>{
    return [
        `/api/gifting/gift/${planId}/${giftingId}`
    ];
};
export const getGetGiftingPageByIdQueryOptions = (planId, giftingId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetGiftingPageByIdQueryKey(planId, giftingId);
    const queryFn = ({ signal })=>getGiftingPageById(planId, giftingId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(planId && giftingId),
        ...queryOptions
    };
};
export const useGetGiftingPageById = (planId, giftingId, options)=>{
    const queryOptions = getGetGiftingPageByIdQueryOptions(planId, giftingId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postCreateGiftorProfile = (postCreateGiftorProfileParamsDto)=>{
    return client({
        url: `/api/gifting/profile`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postCreateGiftorProfileParamsDto
    });
};
export const getPostCreateGiftorProfileMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postCreateGiftorProfile(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostCreateGiftorProfile = (options)=>{
    const mutationOptions = getPostCreateGiftorProfileMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putValidateGiftorProfile = (putValidateCreateGiftorProfileParamsDto)=>{
    return client({
        url: `/api/gifting/profile`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putValidateCreateGiftorProfileParamsDto
    });
};
export const getPutValidateGiftorProfileMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putValidateGiftorProfile(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutValidateGiftorProfile = (options)=>{
    const mutationOptions = getPutValidateGiftorProfileMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postGiftSubmission = (giftingId, giftSubmissionBodyDto)=>{
    return client({
        url: `/api/gifting/${giftingId}`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: giftSubmissionBodyDto
    });
};
export const getPostGiftSubmissionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { giftingId, data } = props ?? {};
        return postGiftSubmission(giftingId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostGiftSubmission = (options)=>{
    const mutationOptions = getPostGiftSubmissionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putValidateGiftSubmission = (giftingId, giftSubmissionBodyDto)=>{
    return client({
        url: `/api/gifting/${giftingId}`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: giftSubmissionBodyDto
    });
};
export const getPutValidateGiftSubmissionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { giftingId, data } = props ?? {};
        return putValidateGiftSubmission(giftingId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutValidateGiftSubmission = (options)=>{
    const mutationOptions = getPutValidateGiftSubmissionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getHealth = (signal)=>{
    return client({
        url: `/api/health`,
        method: 'GET',
        signal
    });
};
export const getGetHealthQueryKey = ()=>{
    return [
        `/api/health`
    ];
};
export const getGetHealthQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetHealthQueryKey();
    const queryFn = ({ signal })=>getHealth(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetHealth = (options)=>{
    const queryOptions = getGetHealthQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getLoanAmortizationPdf = (params, signal)=>{
    return client({
        url: `/api/loans/amortization/pdf`,
        method: 'GET',
        params,
        responseType: 'blob',
        signal
    });
};
export const getGetLoanAmortizationPdfQueryKey = (params)=>{
    return [
        `/api/loans/amortization/pdf`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetLoanAmortizationPdfQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetLoanAmortizationPdfQueryKey(params);
    const queryFn = ({ signal })=>getLoanAmortizationPdf(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetLoanAmortizationPdf = (params, options)=>{
    const queryOptions = getGetLoanAmortizationPdfQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getManagedAccountsPlaidToken = (signal)=>{
    return client({
        url: `/api/managed-accounts/plaid-link-token`,
        method: 'GET',
        signal
    });
};
export const getGetManagedAccountsPlaidTokenQueryKey = ()=>{
    return [
        `/api/managed-accounts/plaid-link-token`
    ];
};
export const getGetManagedAccountsPlaidTokenQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManagedAccountsPlaidTokenQueryKey();
    const queryFn = ({ signal })=>getManagedAccountsPlaidToken(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetManagedAccountsPlaidToken = (options)=>{
    const queryOptions = getGetManagedAccountsPlaidTokenQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const deleteManagedAccountsPlaidLinks = (deletePlaidLinkBodyDto)=>{
    return client({
        url: `/api/managed-accounts/plaid-links`,
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        data: deletePlaidLinkBodyDto
    });
};
export const getDeleteManagedAccountsPlaidLinksMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return deleteManagedAccountsPlaidLinks(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteManagedAccountsPlaidLinks = (options)=>{
    const mutationOptions = getDeleteManagedAccountsPlaidLinksMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getManagedAccountsPlaidLinks = (signal)=>{
    return client({
        url: `/api/managed-accounts/plaid-links`,
        method: 'GET',
        signal
    });
};
export const getGetManagedAccountsPlaidLinksQueryKey = ()=>{
    return [
        `/api/managed-accounts/plaid-links`
    ];
};
export const getGetManagedAccountsPlaidLinksQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManagedAccountsPlaidLinksQueryKey();
    const queryFn = ({ signal })=>getManagedAccountsPlaidLinks(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetManagedAccountsPlaidLinks = (options)=>{
    const queryOptions = getGetManagedAccountsPlaidLinksQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postManagedAccountsPlaidLinks = (postPlaidLinkBodyDto)=>{
    return client({
        url: `/api/managed-accounts/plaid-links`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postPlaidLinkBodyDto
    });
};
export const getPostManagedAccountsPlaidLinksMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postManagedAccountsPlaidLinks(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostManagedAccountsPlaidLinks = (options)=>{
    const mutationOptions = getPostManagedAccountsPlaidLinksMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postManagedAccountsPlaidBalances = (postPlaidBalancesBodyDto)=>{
    return client({
        url: `/api/managed-accounts/plaid-links/balance/get`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postPlaidBalancesBodyDto
    });
};
export const getPostManagedAccountsPlaidBalancesMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postManagedAccountsPlaidBalances(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostManagedAccountsPlaidBalances = (options)=>{
    const mutationOptions = getPostManagedAccountsPlaidBalancesMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getMidYearTesting = (params, signal)=>{
    return client({
        url: `/api/midYearTesting`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetMidYearTestingQueryKey = (params)=>{
    return [
        `/api/midYearTesting`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetMidYearTestingQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetMidYearTestingQueryKey(params);
    const queryFn = ({ signal })=>getMidYearTesting(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetMidYearTesting = (params, options)=>{
    const queryOptions = getGetMidYearTestingQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getMidYearTestingCensusRecord = (params, signal)=>{
    return client({
        url: `/api/midYearTesting/censusRecord`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetMidYearTestingCensusRecordQueryKey = (params)=>{
    return [
        `/api/midYearTesting/censusRecord`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetMidYearTestingCensusRecordQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetMidYearTestingCensusRecordQueryKey(params);
    const queryFn = ({ signal })=>getMidYearTestingCensusRecord(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetMidYearTestingCensusRecord = (params, options)=>{
    const queryOptions = getGetMidYearTestingCensusRecordQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postMsManagedAccounts401kManagerQuestionnaire = (postMsManagedAccounts401kManagerQuestionnaireBodyDto)=>{
    return client({
        url: `/api/ms-managed-accounts/401k-manager-questionnaire`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postMsManagedAccounts401kManagerQuestionnaireBodyDto
    });
};
export const getPostMsManagedAccounts401kManagerQuestionnaireMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postMsManagedAccounts401kManagerQuestionnaire(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostMsManagedAccounts401kManagerQuestionnaire = (options)=>{
    const mutationOptions = getPostMsManagedAccounts401kManagerQuestionnaireMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postMsManagedAccountsActivate = (postMsManagedAccountsActivateBodyDto)=>{
    return client({
        url: `/api/ms-managed-accounts/activate`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postMsManagedAccountsActivateBodyDto
    });
};
export const getPostMsManagedAccountsActivateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postMsManagedAccountsActivate(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostMsManagedAccountsActivate = (options)=>{
    const mutationOptions = getPostMsManagedAccountsActivateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postMsManagedAccountsDeactivate = ()=>{
    return client({
        url: `/api/ms-managed-accounts/deactivate`,
        method: 'POST'
    });
};
export const getPostMsManagedAccountsDeactivateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postMsManagedAccountsDeactivate();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostMsManagedAccountsDeactivate = (options)=>{
    const mutationOptions = getPostMsManagedAccountsDeactivateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getMsManagedAccountsPreviewAllocation = (signal)=>{
    return client({
        url: `/api/ms-managed-accounts/preview-allocation`,
        method: 'GET',
        signal
    });
};
export const getGetMsManagedAccountsPreviewAllocationQueryKey = ()=>{
    return [
        `/api/ms-managed-accounts/preview-allocation`
    ];
};
export const getGetMsManagedAccountsPreviewAllocationQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetMsManagedAccountsPreviewAllocationQueryKey();
    const queryFn = ({ signal })=>getMsManagedAccountsPreviewAllocation(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetMsManagedAccountsPreviewAllocation = (options)=>{
    const queryOptions = getGetMsManagedAccountsPreviewAllocationQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postMsManagedAccountsPreviewAllocation = (postMsManagedAccountsPreviewAllocationBodyDto)=>{
    return client({
        url: `/api/ms-managed-accounts/preview-allocation`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postMsManagedAccountsPreviewAllocationBodyDto
    });
};
export const getPostMsManagedAccountsPreviewAllocationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postMsManagedAccountsPreviewAllocation(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostMsManagedAccountsPreviewAllocation = (options)=>{
    const mutationOptions = getPostMsManagedAccountsPreviewAllocationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getDigitalOnboardingState = (signal)=>{
    return client({
        url: `/api/onboarding/digital`,
        method: 'GET',
        signal
    });
};
export const getGetDigitalOnboardingStateQueryKey = ()=>{
    return [
        `/api/onboarding/digital`
    ];
};
export const getGetDigitalOnboardingStateQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDigitalOnboardingStateQueryKey();
    const queryFn = ({ signal })=>getDigitalOnboardingState(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetDigitalOnboardingState = (options)=>{
    const queryOptions = getGetDigitalOnboardingStateQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchDigitalOnboardingState = (patchDigitalOnboardingStateBodyDto)=>{
    return client({
        url: `/api/onboarding/digital`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchDigitalOnboardingStateBodyDto
    });
};
export const getPatchDigitalOnboardingStateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchDigitalOnboardingState(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchDigitalOnboardingState = (options)=>{
    const mutationOptions = getPatchDigitalOnboardingStateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putDigitalOnboardingState = (putDigitalOnboardingStateBodyDto)=>{
    return client({
        url: `/api/onboarding/digital`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putDigitalOnboardingStateBodyDto
    });
};
export const getPutDigitalOnboardingStateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putDigitalOnboardingState(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutDigitalOnboardingState = (options)=>{
    const mutationOptions = getPutDigitalOnboardingStateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const patchStatefulSchemaTrackingStatus = (schemaType, patchStatefulSchemaTrackingStatusBodyDto)=>{
    return client({
        url: `/api/onboarding/stateful-schema-tracking/${schemaType}/status`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchStatefulSchemaTrackingStatusBodyDto
    });
};
export const getPatchStatefulSchemaTrackingStatusMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { schemaType, data } = props ?? {};
        return patchStatefulSchemaTrackingStatus(schemaType, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchStatefulSchemaTrackingStatus = (options)=>{
    const mutationOptions = getPatchStatefulSchemaTrackingStatusMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getParticipantById = (params, signal)=>{
    return client({
        url: `/api/participant`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetParticipantByIdQueryKey = (params)=>{
    return [
        `/api/participant`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantByIdQueryKey(params);
    const queryFn = ({ signal })=>getParticipantById(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantById = (params, options)=>{
    const queryOptions = getGetParticipantByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getParticipantAccountBalanceById = (params, signal)=>{
    return client({
        url: `/api/participant/account-balance`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetParticipantAccountBalanceByIdQueryKey = (params)=>{
    return [
        `/api/participant/account-balance`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantAccountBalanceByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantAccountBalanceByIdQueryKey(params);
    const queryFn = ({ signal })=>getParticipantAccountBalanceById(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantAccountBalanceById = (params, options)=>{
    const queryOptions = getGetParticipantAccountBalanceByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postParticipantLoan = (loanBodyDto)=>{
    return client({
        url: `/api/participant/account/loans`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: loanBodyDto
    });
};
export const getPostParticipantLoanMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postParticipantLoan(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostParticipantLoan = (options)=>{
    const mutationOptions = getPostParticipantLoanMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getParticipantPlaidLinkToken = (params, signal)=>{
    return client({
        url: `/api/participant/account/loans/plaid-link-token`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetParticipantPlaidLinkTokenQueryKey = (params)=>{
    return [
        `/api/participant/account/loans/plaid-link-token`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantPlaidLinkTokenQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantPlaidLinkTokenQueryKey(params);
    const queryFn = ({ signal })=>getParticipantPlaidLinkToken(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantPlaidLinkToken = (params, options)=>{
    const queryOptions = getGetParticipantPlaidLinkTokenQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getParticipantPlaidLinks = (signal)=>{
    return client({
        url: `/api/participant/account/loans/plaid-links`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantPlaidLinksQueryKey = ()=>{
    return [
        `/api/participant/account/loans/plaid-links`
    ];
};
export const getGetParticipantPlaidLinksQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantPlaidLinksQueryKey();
    const queryFn = ({ signal })=>getParticipantPlaidLinks(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantPlaidLinks = (options)=>{
    const queryOptions = getGetParticipantPlaidLinksQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postParticipantPlaidLinks = (plaidLinkBodyDto)=>{
    return client({
        url: `/api/participant/account/loans/plaid-links`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: plaidLinkBodyDto
    });
};
export const getPostParticipantPlaidLinksMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postParticipantPlaidLinks(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostParticipantPlaidLinks = (options)=>{
    const mutationOptions = getPostParticipantPlaidLinksMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getParticipantLoanCreate = (signal)=>{
    return client({
        url: `/api/participant/account/loans/request`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantLoanCreateQueryKey = ()=>{
    return [
        `/api/participant/account/loans/request`
    ];
};
export const getGetParticipantLoanCreateQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantLoanCreateQueryKey();
    const queryFn = ({ signal })=>getParticipantLoanCreate(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantLoanCreate = (options)=>{
    const queryOptions = getGetParticipantLoanCreateQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchParticipantLoan = (loanId, loanAgreementBodyDto)=>{
    return client({
        url: `/api/participant/account/loans/${loanId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: loanAgreementBodyDto
    });
};
export const getPatchParticipantLoanMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { loanId, data } = props ?? {};
        return patchParticipantLoan(loanId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchParticipantLoan = (options)=>{
    const mutationOptions = getPatchParticipantLoanMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postLoanManualRepayment = (loanId, bankAccountIdDto)=>{
    return client({
        url: `/api/participant/account/loans/${loanId}/payment`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: bankAccountIdDto
    });
};
export const getPostLoanManualRepaymentMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { loanId, data } = props ?? {};
        return postLoanManualRepayment(loanId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostLoanManualRepayment = (options)=>{
    const mutationOptions = getPostLoanManualRepaymentMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getParticipantAccounts = (params, signal)=>{
    return client({
        url: `/api/participant/accounts`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetParticipantAccountsQueryKey = (params)=>{
    return [
        `/api/participant/accounts`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantAccountsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantAccountsQueryKey(params);
    const queryFn = ({ signal })=>getParticipantAccounts(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantAccounts = (params, options)=>{
    const queryOptions = getGetParticipantAccountsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getParticipantBalanceOverTime = (signal)=>{
    return client({
        url: `/api/participant/balance-over-time`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantBalanceOverTimeQueryKey = ()=>{
    return [
        `/api/participant/balance-over-time`
    ];
};
export const getGetParticipantBalanceOverTimeQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantBalanceOverTimeQueryKey();
    const queryFn = ({ signal })=>getParticipantBalanceOverTime(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantBalanceOverTime = (options)=>{
    const queryOptions = getGetParticipantBalanceOverTimeQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putArchiveBankAccount = (bankAccountId)=>{
    return client({
        url: `/api/participant/bank-account/${bankAccountId}/archive`,
        method: 'PUT'
    });
};
export const getPutArchiveBankAccountMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { bankAccountId } = props ?? {};
        return putArchiveBankAccount(bankAccountId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutArchiveBankAccount = (options)=>{
    const mutationOptions = getPutArchiveBankAccountMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getParticipantBankAccounts = (signal)=>{
    return client({
        url: `/api/participant/bank-accounts`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantBankAccountsQueryKey = ()=>{
    return [
        `/api/participant/bank-accounts`
    ];
};
export const getGetParticipantBankAccountsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantBankAccountsQueryKey();
    const queryFn = ({ signal })=>getParticipantBankAccounts(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantBankAccounts = (options)=>{
    const queryOptions = getGetParticipantBankAccountsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getParticipantDeposits = (params, signal)=>{
    return client({
        url: `/api/participant/deposit`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetParticipantDepositsQueryKey = (params)=>{
    return [
        `/api/participant/deposit`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantDepositsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantDepositsQueryKey(params);
    const queryFn = ({ signal })=>getParticipantDeposits(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantDeposits = (params, options)=>{
    const queryOptions = getGetParticipantDepositsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postDepositData = (postParticipantDepositBodyDto)=>{
    return client({
        url: `/api/participant/deposit`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postParticipantDepositBodyDto
    });
};
export const getPostDepositDataMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postDepositData(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostDepositData = (options)=>{
    const mutationOptions = getPostDepositDataMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getParticipantRecurringSchedules = (params, signal)=>{
    return client({
        url: `/api/participant/deposit/schedule`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetParticipantRecurringSchedulesQueryKey = (params)=>{
    return [
        `/api/participant/deposit/schedule`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantRecurringSchedulesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantRecurringSchedulesQueryKey(params);
    const queryFn = ({ signal })=>getParticipantRecurringSchedules(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantRecurringSchedules = (params, options)=>{
    const queryOptions = getGetParticipantRecurringSchedulesQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putRecurringSchedule = (recurringScheduleId, putDepositDto)=>{
    return client({
        url: `/api/participant/deposit/schedule/${recurringScheduleId}`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putDepositDto
    });
};
export const getPutRecurringScheduleMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { recurringScheduleId, data } = props ?? {};
        return putRecurringSchedule(recurringScheduleId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutRecurringSchedule = (options)=>{
    const mutationOptions = getPutRecurringScheduleMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getDeposit = (depositId, signal)=>{
    return client({
        url: `/api/participant/deposit/${depositId}`,
        method: 'GET',
        signal
    });
};
export const getGetDepositQueryKey = (depositId)=>{
    return [
        `/api/participant/deposit/${depositId}`
    ];
};
export const getGetDepositQueryOptions = (depositId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDepositQueryKey(depositId);
    const queryFn = ({ signal })=>getDeposit(depositId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!depositId,
        ...queryOptions
    };
};
export const useGetDeposit = (depositId, options)=>{
    const queryOptions = getGetDepositQueryOptions(depositId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getRecentParticipantDocuments = (signal)=>{
    return client({
        url: `/api/participant/documents/recent`,
        method: 'GET',
        signal
    });
};
export const getGetRecentParticipantDocumentsQueryKey = ()=>{
    return [
        `/api/participant/documents/recent`
    ];
};
export const getGetRecentParticipantDocumentsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRecentParticipantDocumentsQueryKey();
    const queryFn = ({ signal })=>getRecentParticipantDocuments(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetRecentParticipantDocuments = (options)=>{
    const queryOptions = getGetRecentParticipantDocumentsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postParticipantEligibility = (postParticipantsEligibilityBodyDto)=>{
    return client({
        url: `/api/participant/eligibility`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postParticipantsEligibilityBodyDto
    });
};
export const getPostParticipantEligibilityMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postParticipantEligibility(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostParticipantEligibility = (options)=>{
    const mutationOptions = getPostParticipantEligibilityMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postEsaGoal = (participantEsaGoalDto)=>{
    return client({
        url: `/api/participant/esa/goal`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: participantEsaGoalDto
    });
};
export const getPostEsaGoalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postEsaGoal(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostEsaGoal = (options)=>{
    const mutationOptions = getPostEsaGoalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getParticipantIdentityVerification = (signal)=>{
    return client({
        url: `/api/participant/identity-verification`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantIdentityVerificationQueryKey = ()=>{
    return [
        `/api/participant/identity-verification`
    ];
};
export const getGetParticipantIdentityVerificationQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantIdentityVerificationQueryKey();
    const queryFn = ({ signal })=>getParticipantIdentityVerification(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantIdentityVerification = (options)=>{
    const queryOptions = getGetParticipantIdentityVerificationQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchParticipantInfoWithEmails = (patchParticipantBodyDto)=>{
    return client({
        url: `/api/participant/info`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchParticipantBodyDto
    });
};
export const getPatchParticipantInfoWithEmailsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchParticipantInfoWithEmails(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchParticipantInfoWithEmails = (options)=>{
    const mutationOptions = getPatchParticipantInfoWithEmailsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getGoalFeedback = (signal)=>{
    return client({
        url: `/api/participant/investment-election`,
        method: 'GET',
        signal
    });
};
export const getGetGoalFeedbackQueryKey = ()=>{
    return [
        `/api/participant/investment-election`
    ];
};
export const getGetGoalFeedbackQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetGoalFeedbackQueryKey();
    const queryFn = ({ signal })=>getGoalFeedback(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetGoalFeedback = (options)=>{
    const queryOptions = getGetGoalFeedbackQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postElectionAgeSuggestion = ()=>{
    return client({
        url: `/api/participant/investment-election/age-suggestion`,
        method: 'POST'
    });
};
export const getPostElectionAgeSuggestionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postElectionAgeSuggestion();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostElectionAgeSuggestion = (options)=>{
    const mutationOptions = getPostElectionAgeSuggestionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postElectionRetirementIncomeSuggestion = ()=>{
    return client({
        url: `/api/participant/investment-election/retirement-income-suggestion`,
        method: 'POST'
    });
};
export const getPostElectionRetirementIncomeSuggestionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postElectionRetirementIncomeSuggestion();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostElectionRetirementIncomeSuggestion = (options)=>{
    const mutationOptions = getPostElectionRetirementIncomeSuggestionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getElectionsSetup = (signal)=>{
    return client({
        url: `/api/participant/investment-election/setup`,
        method: 'GET',
        signal
    });
};
export const getGetElectionsSetupQueryKey = ()=>{
    return [
        `/api/participant/investment-election/setup`
    ];
};
export const getGetElectionsSetupQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetElectionsSetupQueryKey();
    const queryFn = ({ signal })=>getElectionsSetup(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetElectionsSetup = (options)=>{
    const queryOptions = getGetElectionsSetupQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postElectionsSetup = (investmentElectionSetupDto)=>{
    return client({
        url: `/api/participant/investment-election/setup`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: investmentElectionSetupDto
    });
};
export const getPostElectionsSetupMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postElectionsSetup(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostElectionsSetup = (options)=>{
    const mutationOptions = getPostElectionsSetupMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getInvestmentsModelDisplay = (signal)=>{
    return client({
        url: `/api/participant/investments/model`,
        method: 'GET',
        signal
    });
};
export const getGetInvestmentsModelDisplayQueryKey = ()=>{
    return [
        `/api/participant/investments/model`
    ];
};
export const getGetInvestmentsModelDisplayQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInvestmentsModelDisplayQueryKey();
    const queryFn = ({ signal })=>getInvestmentsModelDisplay(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetInvestmentsModelDisplay = (options)=>{
    const queryOptions = getGetInvestmentsModelDisplayQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPlanParticipantStats = (planId, signal)=>{
    return client({
        url: `/api/participant/investments/options/plans/${planId}/stats`,
        method: 'GET',
        signal
    });
};
export const getGetPlanParticipantStatsQueryKey = (planId)=>{
    return [
        `/api/participant/investments/options/plans/${planId}/stats`
    ];
};
export const getGetPlanParticipantStatsQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanParticipantStatsQueryKey(planId);
    const queryFn = ({ signal })=>getPlanParticipantStats(planId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!planId,
        ...queryOptions
    };
};
export const useGetPlanParticipantStats = (planId, options)=>{
    const queryOptions = getGetPlanParticipantStatsQueryOptions(planId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postRebalanceRequest = ()=>{
    return client({
        url: `/api/participant/investments/rebalance-request`,
        method: 'POST'
    });
};
export const getPostRebalanceRequestMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postRebalanceRequest();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostRebalanceRequest = (options)=>{
    const mutationOptions = getPostRebalanceRequestMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getRebalanceSettings = (signal)=>{
    return client({
        url: `/api/participant/investments/rebalance-settings`,
        method: 'GET',
        signal
    });
};
export const getGetRebalanceSettingsQueryKey = ()=>{
    return [
        `/api/participant/investments/rebalance-settings`
    ];
};
export const getGetRebalanceSettingsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRebalanceSettingsQueryKey();
    const queryFn = ({ signal })=>getRebalanceSettings(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetRebalanceSettings = (options)=>{
    const queryOptions = getGetRebalanceSettingsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putRebalanceSettings = (rebalanceBodyDto)=>{
    return client({
        url: `/api/participant/investments/rebalance-settings`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: rebalanceBodyDto
    });
};
export const getPutRebalanceSettingsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putRebalanceSettings(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutRebalanceSettings = (options)=>{
    const mutationOptions = getPutRebalanceSettingsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getStrategiesIndex = (signal)=>{
    return client({
        url: `/api/participant/investments/strategies`,
        method: 'GET',
        signal
    });
};
export const getGetStrategiesIndexQueryKey = ()=>{
    return [
        `/api/participant/investments/strategies`
    ];
};
export const getGetStrategiesIndexQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetStrategiesIndexQueryKey();
    const queryFn = ({ signal })=>getStrategiesIndex(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetStrategiesIndex = (options)=>{
    const queryOptions = getGetStrategiesIndexQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getAgeBased = (params, signal)=>{
    return client({
        url: `/api/participant/investments/strategies/age-based`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAgeBasedQueryKey = (params)=>{
    return [
        `/api/participant/investments/strategies/age-based`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAgeBasedQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAgeBasedQueryKey(params);
    const queryFn = ({ signal })=>getAgeBased(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetAgeBased = (params, options)=>{
    const queryOptions = getGetAgeBasedQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putAgeBased = (ageBasedBodyDto)=>{
    return client({
        url: `/api/participant/investments/strategies/age-based`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: ageBasedBodyDto
    });
};
export const getPutAgeBasedMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putAgeBased(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutAgeBased = (options)=>{
    const mutationOptions = getPutAgeBasedMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putCustomAllocation = (allocationsBodyDto)=>{
    return client({
        url: `/api/participant/investments/strategies/custom-allocation`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: allocationsBodyDto
    });
};
export const getPutCustomAllocationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putCustomAllocation(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutCustomAllocation = (options)=>{
    const mutationOptions = getPutCustomAllocationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getRiskBased = (signal)=>{
    return client({
        url: `/api/participant/investments/strategies/risk-based`,
        method: 'GET',
        signal
    });
};
export const getGetRiskBasedQueryKey = ()=>{
    return [
        `/api/participant/investments/strategies/risk-based`
    ];
};
export const getGetRiskBasedQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRiskBasedQueryKey();
    const queryFn = ({ signal })=>getRiskBased(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetRiskBased = (options)=>{
    const queryOptions = getGetRiskBasedQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putRiskBased = (riskBasedBodyDto)=>{
    return client({
        url: `/api/participant/investments/strategies/risk-based`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: riskBasedBodyDto
    });
};
export const getPutRiskBasedMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putRiskBased(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutRiskBased = (options)=>{
    const mutationOptions = getPutRiskBasedMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getRiskModelQuestionnaire = (params, signal)=>{
    return client({
        url: `/api/participant/investments/strategies/risk-based/questionnaire`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetRiskModelQuestionnaireQueryKey = (params)=>{
    return [
        `/api/participant/investments/strategies/risk-based/questionnaire`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetRiskModelQuestionnaireQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRiskModelQuestionnaireQueryKey(params);
    const queryFn = ({ signal })=>getRiskModelQuestionnaire(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetRiskModelQuestionnaire = (params, options)=>{
    const queryOptions = getGetRiskModelQuestionnaireQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getMailPreferences = (signal)=>{
    return client({
        url: `/api/participant/mail-preferences`,
        method: 'GET',
        signal
    });
};
export const getGetMailPreferencesQueryKey = ()=>{
    return [
        `/api/participant/mail-preferences`
    ];
};
export const getGetMailPreferencesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetMailPreferencesQueryKey();
    const queryFn = ({ signal })=>getMailPreferences(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetMailPreferences = (options)=>{
    const queryOptions = getGetMailPreferencesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putMailPreferences = (paperlessNoticesDto)=>{
    return client({
        url: `/api/participant/mail-preferences`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: paperlessNoticesDto
    });
};
export const getPutMailPreferencesMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putMailPreferences(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutMailPreferences = (options)=>{
    const mutationOptions = getPutMailPreferencesMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getParticipantOnboarding = (signal)=>{
    return client({
        url: `/api/participant/onboarding`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantOnboardingQueryKey = ()=>{
    return [
        `/api/participant/onboarding`
    ];
};
export const getGetParticipantOnboardingQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantOnboardingQueryKey();
    const queryFn = ({ signal })=>getParticipantOnboarding(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantOnboarding = (options)=>{
    const queryOptions = getGetParticipantOnboardingQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getParticipantOverview = (signal)=>{
    return client({
        url: `/api/participant/overview`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantOverviewQueryKey = ()=>{
    return [
        `/api/participant/overview`
    ];
};
export const getGetParticipantOverviewQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantOverviewQueryKey();
    const queryFn = ({ signal })=>getParticipantOverview(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantOverview = (options)=>{
    const queryOptions = getGetParticipantOverviewQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postParticipantPlaidLinksBalance = (plaidLinkBodyDto)=>{
    return client({
        url: `/api/participant/plaid-links/balance`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: plaidLinkBodyDto
    });
};
export const getPostParticipantPlaidLinksBalanceMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postParticipantPlaidLinksBalance(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostParticipantPlaidLinksBalance = (options)=>{
    const mutationOptions = getPostParticipantPlaidLinksBalanceMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postParticipantPlaidLinksBankAccount = (partipantPlaidLinkBankAccountDto)=>{
    return client({
        url: `/api/participant/plaid-links/bank-account`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: partipantPlaidLinkBankAccountDto
    });
};
export const getPostParticipantPlaidLinksBankAccountMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postParticipantPlaidLinksBankAccount(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostParticipantPlaidLinksBankAccount = (options)=>{
    const mutationOptions = getPostParticipantPlaidLinksBankAccountMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postParticipantDiscardPendingPlaidLinks = ()=>{
    return client({
        url: `/api/participant/plaid-links/discard-pending`,
        method: 'POST'
    });
};
export const getPostParticipantDiscardPendingPlaidLinksMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postParticipantDiscardPendingPlaidLinks();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostParticipantDiscardPendingPlaidLinks = (options)=>{
    const mutationOptions = getPostParticipantDiscardPendingPlaidLinksMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPositions = (signal)=>{
    return client({
        url: `/api/participant/positions`,
        method: 'GET',
        signal
    });
};
export const getGetPositionsQueryKey = ()=>{
    return [
        `/api/participant/positions`
    ];
};
export const getGetPositionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPositionsQueryKey();
    const queryFn = ({ signal })=>getPositions(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPositions = (options)=>{
    const queryOptions = getGetPositionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getQboadWithdrawals = (signal)=>{
    return client({
        url: `/api/participant/qboad/withdrawals`,
        method: 'GET',
        signal
    });
};
export const getGetQboadWithdrawalsQueryKey = ()=>{
    return [
        `/api/participant/qboad/withdrawals`
    ];
};
export const getGetQboadWithdrawalsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetQboadWithdrawalsQueryKey();
    const queryFn = ({ signal })=>getQboadWithdrawals(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetQboadWithdrawals = (options)=>{
    const queryOptions = getGetQboadWithdrawalsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchParticipantRollover = (rolloverBodyDto)=>{
    return client({
        url: `/api/participant/rollovers`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: rolloverBodyDto
    });
};
export const getPatchParticipantRolloverMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchParticipantRollover(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchParticipantRollover = (options)=>{
    const mutationOptions = getPatchParticipantRolloverMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getRolloverInstructions = (signal)=>{
    return client({
        url: `/api/participant/rollovers/instructions`,
        method: 'GET',
        signal
    });
};
export const getGetRolloverInstructionsQueryKey = ()=>{
    return [
        `/api/participant/rollovers/instructions`
    ];
};
export const getGetRolloverInstructionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRolloverInstructionsQueryKey();
    const queryFn = ({ signal })=>getRolloverInstructions(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetRolloverInstructions = (options)=>{
    const queryOptions = getGetRolloverInstructionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getRolloverEligibility = (signal)=>{
    return client({
        url: `/api/participant/rollovers/request`,
        method: 'GET',
        signal
    });
};
export const getGetRolloverEligibilityQueryKey = ()=>{
    return [
        `/api/participant/rollovers/request`
    ];
};
export const getGetRolloverEligibilityQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRolloverEligibilityQueryKey();
    const queryFn = ({ signal })=>getRolloverEligibility(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetRolloverEligibility = (options)=>{
    const queryOptions = getGetRolloverEligibilityQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postParticipantRollover = ()=>{
    return client({
        url: `/api/participant/rollovers/request`,
        method: 'POST'
    });
};
export const getPostParticipantRolloverMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postParticipantRollover();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostParticipantRollover = (options)=>{
    const mutationOptions = getPostParticipantRolloverMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getParticipantRollover = (rolloverId, signal)=>{
    return client({
        url: `/api/participant/rollovers/${rolloverId}`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantRolloverQueryKey = (rolloverId)=>{
    return [
        `/api/participant/rollovers/${rolloverId}`
    ];
};
export const getGetParticipantRolloverQueryOptions = (rolloverId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantRolloverQueryKey(rolloverId);
    const queryFn = ({ signal })=>getParticipantRollover(rolloverId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!rolloverId,
        ...queryOptions
    };
};
export const useGetParticipantRollover = (rolloverId, options)=>{
    const queryOptions = getGetParticipantRolloverQueryOptions(rolloverId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getGenerateRolloverLetter = (rolloverId, signal)=>{
    return client({
        url: `/api/participant/rollovers/${rolloverId}/letter`,
        method: 'GET',
        signal
    });
};
export const getGetGenerateRolloverLetterQueryKey = (rolloverId)=>{
    return [
        `/api/participant/rollovers/${rolloverId}/letter`
    ];
};
export const getGetGenerateRolloverLetterQueryOptions = (rolloverId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetGenerateRolloverLetterQueryKey(rolloverId);
    const queryFn = ({ signal })=>getGenerateRolloverLetter(rolloverId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!rolloverId,
        ...queryOptions
    };
};
export const useGetGenerateRolloverLetter = (rolloverId, options)=>{
    const queryOptions = getGetGenerateRolloverLetterQueryOptions(rolloverId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getSavingsDisplay = (signal)=>{
    return client({
        url: `/api/participant/savings`,
        method: 'GET',
        signal
    });
};
export const getGetSavingsDisplayQueryKey = ()=>{
    return [
        `/api/participant/savings`
    ];
};
export const getGetSavingsDisplayQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSavingsDisplayQueryKey();
    const queryFn = ({ signal })=>getSavingsDisplay(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSavingsDisplay = (options)=>{
    const queryOptions = getGetSavingsDisplayQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putSavings = (savingsBodyDto)=>{
    return client({
        url: `/api/participant/savings`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: savingsBodyDto
    });
};
export const getPutSavingsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putSavings(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutSavings = (options)=>{
    const mutationOptions = getPutSavingsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getSurveyLink = (signal)=>{
    return client({
        url: `/api/participant/survey/link`,
        method: 'GET',
        signal
    });
};
export const getGetSurveyLinkQueryKey = ()=>{
    return [
        `/api/participant/survey/link`
    ];
};
export const getGetSurveyLinkQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSurveyLinkQueryKey();
    const queryFn = ({ signal })=>getSurveyLink(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSurveyLink = (options)=>{
    const queryOptions = getGetSurveyLinkQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getParticipantAggregatedByCategoryTransactions = (signal)=>{
    return client({
        url: `/api/participant/transactions/aggregated-by-category`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantAggregatedByCategoryTransactionsQueryKey = ()=>{
    return [
        `/api/participant/transactions/aggregated-by-category`
    ];
};
export const getGetParticipantAggregatedByCategoryTransactionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantAggregatedByCategoryTransactionsQueryKey();
    const queryFn = ({ signal })=>getParticipantAggregatedByCategoryTransactions(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantAggregatedByCategoryTransactions = (options)=>{
    const queryOptions = getGetParticipantAggregatedByCategoryTransactionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getAllowedWithdrawalReasons = (signal)=>{
    return client({
        url: `/api/participant/withdrawals`,
        method: 'GET',
        signal
    });
};
export const getGetAllowedWithdrawalReasonsQueryKey = ()=>{
    return [
        `/api/participant/withdrawals`
    ];
};
export const getGetAllowedWithdrawalReasonsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllowedWithdrawalReasonsQueryKey();
    const queryFn = ({ signal })=>getAllowedWithdrawalReasons(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetAllowedWithdrawalReasons = (options)=>{
    const queryOptions = getGetAllowedWithdrawalReasonsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postWithdrawal = ()=>{
    return client({
        url: `/api/participant/withdrawals`,
        method: 'POST'
    });
};
export const getPostWithdrawalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postWithdrawal();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostWithdrawal = (options)=>{
    const mutationOptions = getPostWithdrawalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const patchOverrideParticipantEligibility = (participantId, patchOverrideParticipantEligibilityBodyDto)=>{
    return client({
        url: `/api/participant/${participantId}/override-eligibility`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchOverrideParticipantEligibilityBodyDto
    });
};
export const getPatchOverrideParticipantEligibilityMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { participantId, data } = props ?? {};
        return patchOverrideParticipantEligibility(participantId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchOverrideParticipantEligibility = (options)=>{
    const mutationOptions = getPatchOverrideParticipantEligibilityMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getEligibleAutoEnrolledParticipants = (params, signal)=>{
    return client({
        url: `/api/participants/opt-out`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEligibleAutoEnrolledParticipantsQueryKey = (params)=>{
    return [
        `/api/participants/opt-out`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEligibleAutoEnrolledParticipantsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEligibleAutoEnrolledParticipantsQueryKey(params);
    const queryFn = ({ signal })=>getEligibleAutoEnrolledParticipants(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEligibleAutoEnrolledParticipants = (params, options)=>{
    const queryOptions = getGetEligibleAutoEnrolledParticipantsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getParticipantOptOutEmailDownload = (params, signal)=>{
    return client({
        url: `/api/participants/opt-out-confirmation/download`,
        method: 'GET',
        params,
        responseType: 'blob',
        signal
    });
};
export const getGetParticipantOptOutEmailDownloadQueryKey = (params)=>{
    return [
        `/api/participants/opt-out-confirmation/download`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantOptOutEmailDownloadQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantOptOutEmailDownloadQueryKey(params);
    const queryFn = ({ signal })=>getParticipantOptOutEmailDownload(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantOptOutEmailDownload = (params, options)=>{
    const queryOptions = getGetParticipantOptOutEmailDownloadQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getOptedOutAutoEnrolledParticipants = (params, signal)=>{
    return client({
        url: `/api/participants/opt-out/enrolled`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetOptedOutAutoEnrolledParticipantsQueryKey = (params)=>{
    return [
        `/api/participants/opt-out/enrolled`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetOptedOutAutoEnrolledParticipantsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOptedOutAutoEnrolledParticipantsQueryKey(params);
    const queryFn = ({ signal })=>getOptedOutAutoEnrolledParticipants(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetOptedOutAutoEnrolledParticipants = (params, options)=>{
    const queryOptions = getGetOptedOutAutoEnrolledParticipantsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getUnregisteredParticipants = (params, signal)=>{
    return client({
        url: `/api/participants/unregistered`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetUnregisteredParticipantsQueryKey = (params)=>{
    return [
        `/api/participants/unregistered`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetUnregisteredParticipantsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetUnregisteredParticipantsQueryKey(params);
    const queryFn = ({ signal })=>getUnregisteredParticipants(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetUnregisteredParticipants = (params, options)=>{
    const queryOptions = getGetUnregisteredParticipantsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getUnregisteredParticipantsCount = (params, signal)=>{
    return client({
        url: `/api/participants/unregistered/count`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetUnregisteredParticipantsCountQueryKey = (params)=>{
    return [
        `/api/participants/unregistered/count`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetUnregisteredParticipantsCountQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetUnregisteredParticipantsCountQueryKey(params);
    const queryFn = ({ signal })=>getUnregisteredParticipantsCount(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetUnregisteredParticipantsCount = (params, options)=>{
    const queryOptions = getGetUnregisteredParticipantsCountQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postParticipantsWelcomeEmails = (postParticipantWelcomeEmailsBodyDto)=>{
    return client({
        url: `/api/participants/welcome-emails/bulk`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postParticipantWelcomeEmailsBodyDto
    });
};
export const getPostParticipantsWelcomeEmailsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postParticipantsWelcomeEmails(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostParticipantsWelcomeEmails = (options)=>{
    const mutationOptions = getPostParticipantsWelcomeEmailsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getParticipantWelcomeEmailDownload = (params, signal)=>{
    return client({
        url: `/api/participants/welcome-emails/download`,
        method: 'GET',
        params,
        responseType: 'blob',
        signal
    });
};
export const getGetParticipantWelcomeEmailDownloadQueryKey = (params)=>{
    return [
        `/api/participants/welcome-emails/download`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantWelcomeEmailDownloadQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantWelcomeEmailDownloadQueryKey(params);
    const queryFn = ({ signal })=>getParticipantWelcomeEmailDownload(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantWelcomeEmailDownload = (params, options)=>{
    const queryOptions = getGetParticipantWelcomeEmailDownloadQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getParticipantWelcomeEmailsHistory = (params, signal)=>{
    return client({
        url: `/api/participants/welcome-emails/history`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetParticipantWelcomeEmailsHistoryQueryKey = (params)=>{
    return [
        `/api/participants/welcome-emails/history`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantWelcomeEmailsHistoryQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantWelcomeEmailsHistoryQueryKey(params);
    const queryFn = ({ signal })=>getParticipantWelcomeEmailsHistory(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantWelcomeEmailsHistory = (params, options)=>{
    const queryOptions = getGetParticipantWelcomeEmailsHistoryQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getCalculatedEsaEmployerContributions = (participantId, params, signal)=>{
    return client({
        url: `/api/participants/${participantId}/calculate-employer-contributions`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetCalculatedEsaEmployerContributionsQueryKey = (participantId, params)=>{
    return [
        `/api/participants/${participantId}/calculate-employer-contributions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetCalculatedEsaEmployerContributionsQueryOptions = (participantId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCalculatedEsaEmployerContributionsQueryKey(participantId, params);
    const queryFn = ({ signal })=>getCalculatedEsaEmployerContributions(participantId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!participantId,
        ...queryOptions
    };
};
export const useGetCalculatedEsaEmployerContributions = (participantId, params, options)=>{
    const queryOptions = getGetCalculatedEsaEmployerContributionsQueryOptions(participantId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getCalculatedEmployerMatchContribution = (participantId, params, signal)=>{
    return client({
        url: `/api/participants/${participantId}/calculate-employer-match`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetCalculatedEmployerMatchContributionQueryKey = (participantId, params)=>{
    return [
        `/api/participants/${participantId}/calculate-employer-match`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetCalculatedEmployerMatchContributionQueryOptions = (participantId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCalculatedEmployerMatchContributionQueryKey(participantId, params);
    const queryFn = ({ signal })=>getCalculatedEmployerMatchContribution(participantId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!participantId,
        ...queryOptions
    };
};
export const useGetCalculatedEmployerMatchContribution = (participantId, params, options)=>{
    const queryOptions = getGetCalculatedEmployerMatchContributionQueryOptions(participantId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postParticipantsAutoEnrollOptOut = (planId, postParticipantsAutoEnrollOptOutBodyDto)=>{
    return client({
        url: `/api/participants/${planId}/opt-out`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postParticipantsAutoEnrollOptOutBodyDto
    });
};
export const getPostParticipantsAutoEnrollOptOutMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { planId, data } = props ?? {};
        return postParticipantsAutoEnrollOptOut(planId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostParticipantsAutoEnrollOptOut = (options)=>{
    const mutationOptions = getPostParticipantsAutoEnrollOptOutMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPlanDesign = (signal)=>{
    return client({
        url: `/api/plan-design`,
        method: 'GET',
        signal
    });
};
export const getGetPlanDesignQueryKey = ()=>{
    return [
        `/api/plan-design`
    ];
};
export const getGetPlanDesignQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanDesignQueryKey();
    const queryFn = ({ signal })=>getPlanDesign(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanDesign = (options)=>{
    const queryOptions = getGetPlanDesignQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchUpdatePlanDesign = (planDesignDto)=>{
    return client({
        url: `/api/plan-design`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: planDesignDto
    });
};
export const getPatchUpdatePlanDesignMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchUpdatePlanDesign(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchUpdatePlanDesign = (options)=>{
    const mutationOptions = getPatchUpdatePlanDesignMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPlanDesignTiles = (signal)=>{
    return client({
        url: `/api/plan-design/tiles`,
        method: 'GET',
        signal
    });
};
export const getGetPlanDesignTilesQueryKey = ()=>{
    return [
        `/api/plan-design/tiles`
    ];
};
export const getGetPlanDesignTilesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanDesignTilesQueryKey();
    const queryFn = ({ signal })=>getPlanDesignTiles(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanDesignTiles = (options)=>{
    const queryOptions = getGetPlanDesignTilesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPlanParticipants = (params, signal)=>{
    return client({
        url: `/api/plan/participants`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPlanParticipantsQueryKey = (params)=>{
    return [
        `/api/plan/participants`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPlanParticipantsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanParticipantsQueryKey(params);
    const queryFn = ({ signal })=>getPlanParticipants(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanParticipants = (params, options)=>{
    const queryOptions = getGetPlanParticipantsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPlanModel = (params, signal)=>{
    return client({
        url: `/api/plans/models`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPlanModelQueryKey = (params)=>{
    return [
        `/api/plans/models`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPlanModelQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanModelQueryKey(params);
    const queryFn = ({ signal })=>getPlanModel(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanModel = (params, options)=>{
    const queryOptions = getGetPlanModelQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchPlan = (planId, patchPlanBodyDto)=>{
    return client({
        url: `/api/plans/${planId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchPlanBodyDto
    });
};
export const getPatchPlanMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { planId, data } = props ?? {};
        return patchPlan(planId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchPlan = (options)=>{
    const mutationOptions = getPatchPlanMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getEsaProgram = (planId, signal)=>{
    return client({
        url: `/api/plans/${planId}/esa-program`,
        method: 'GET',
        signal
    });
};
export const getGetEsaProgramQueryKey = (planId)=>{
    return [
        `/api/plans/${planId}/esa-program`
    ];
};
export const getGetEsaProgramQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEsaProgramQueryKey(planId);
    const queryFn = ({ signal })=>getEsaProgram(planId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!planId,
        ...queryOptions
    };
};
export const useGetEsaProgram = (planId, options)=>{
    const queryOptions = getGetEsaProgramQueryOptions(planId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPlanInvestments = (planId, signal)=>{
    return client({
        url: `/api/plans/${planId}/investments`,
        method: 'GET',
        signal
    });
};
export const getGetPlanInvestmentsQueryKey = (planId)=>{
    return [
        `/api/plans/${planId}/investments`
    ];
};
export const getGetPlanInvestmentsQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanInvestmentsQueryKey(planId);
    const queryFn = ({ signal })=>getPlanInvestments(planId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!planId,
        ...queryOptions
    };
};
export const useGetPlanInvestments = (planId, options)=>{
    const queryOptions = getGetPlanInvestmentsQueryOptions(planId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPlanModelSecurities = (planId, modelId, signal)=>{
    return client({
        url: `/api/plans/${planId}/models/${modelId}/securities`,
        method: 'GET',
        signal
    });
};
export const getGetPlanModelSecuritiesQueryKey = (planId, modelId)=>{
    return [
        `/api/plans/${planId}/models/${modelId}/securities`
    ];
};
export const getGetPlanModelSecuritiesQueryOptions = (planId, modelId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanModelSecuritiesQueryKey(planId, modelId);
    const queryFn = ({ signal })=>getPlanModelSecurities(planId, modelId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(planId && modelId),
        ...queryOptions
    };
};
export const useGetPlanModelSecurities = (planId, modelId, options)=>{
    const queryOptions = getGetPlanModelSecuritiesQueryOptions(planId, modelId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getProgramModels = (params, signal)=>{
    return client({
        url: `/api/program/models`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetProgramModelsQueryKey = (params)=>{
    return [
        `/api/program/models`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetProgramModelsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetProgramModelsQueryKey(params);
    const queryFn = ({ signal })=>getProgramModels(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetProgramModels = (params, options)=>{
    const queryOptions = getGetProgramModelsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getProgramInvestmentOptionsExport = (programId, signal)=>{
    return client({
        url: `/api/program/${programId}/investment-options/download`,
        method: 'GET',
        signal
    });
};
export const getGetProgramInvestmentOptionsExportQueryKey = (programId)=>{
    return [
        `/api/program/${programId}/investment-options/download`
    ];
};
export const getGetProgramInvestmentOptionsExportQueryOptions = (programId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetProgramInvestmentOptionsExportQueryKey(programId);
    const queryFn = ({ signal })=>getProgramInvestmentOptionsExport(programId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!programId,
        ...queryOptions
    };
};
export const useGetProgramInvestmentOptionsExport = (programId, options)=>{
    const queryOptions = getGetProgramInvestmentOptionsExportQueryOptions(programId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getProspectusUrlParts = (signal)=>{
    return client({
        url: `/api/prospectus/url`,
        method: 'GET',
        signal
    });
};
export const getGetProspectusUrlPartsQueryKey = ()=>{
    return [
        `/api/prospectus/url`
    ];
};
export const getGetProspectusUrlPartsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetProspectusUrlPartsQueryKey();
    const queryFn = ({ signal })=>getProspectusUrlParts(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetProspectusUrlParts = (options)=>{
    const queryOptions = getGetProspectusUrlPartsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getAdvisorReport = (advisorId, reportType, fileName, params, signal)=>{
    return client({
        url: `/api/reports/advisors/${advisorId}/${reportType}/${fileName}`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdvisorReportQueryKey = (advisorId, reportType, fileName, params)=>{
    return [
        `/api/reports/advisors/${advisorId}/${reportType}/${fileName}`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdvisorReportQueryOptions = (advisorId, reportType, fileName, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorReportQueryKey(advisorId, reportType, fileName, params);
    const queryFn = ({ signal })=>getAdvisorReport(advisorId, reportType, fileName, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(advisorId && reportType && fileName),
        ...queryOptions
    };
};
export const useGetAdvisorReport = (advisorId, reportType, fileName, params, options)=>{
    const queryOptions = getGetAdvisorReportQueryOptions(advisorId, reportType, fileName, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEmployeeReport = (employeeId, reportType, fileName, params, signal)=>{
    return client({
        url: `/api/reports/employees/${employeeId}/${reportType}/${fileName}`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEmployeeReportQueryKey = (employeeId, reportType, fileName, params)=>{
    return [
        `/api/reports/employees/${employeeId}/${reportType}/${fileName}`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEmployeeReportQueryOptions = (employeeId, reportType, fileName, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmployeeReportQueryKey(employeeId, reportType, fileName, params);
    const queryFn = ({ signal })=>getEmployeeReport(employeeId, reportType, fileName, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(employeeId && reportType && fileName),
        ...queryOptions
    };
};
export const useGetEmployeeReport = (employeeId, reportType, fileName, params, options)=>{
    const queryOptions = getGetEmployeeReportQueryOptions(employeeId, reportType, fileName, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getUnregisteredParticipantsReport = (params, signal)=>{
    return client({
        url: `/api/reports/participants/unregistered`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetUnregisteredParticipantsReportQueryKey = (params)=>{
    return [
        `/api/reports/participants/unregistered`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetUnregisteredParticipantsReportQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetUnregisteredParticipantsReportQueryKey(params);
    const queryFn = ({ signal })=>getUnregisteredParticipantsReport(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetUnregisteredParticipantsReport = (params, options)=>{
    const queryOptions = getGetUnregisteredParticipantsReportQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPlanReport = (planId, reportType, fileName, signal)=>{
    return client({
        url: `/api/reports/plans/${planId}/${reportType}/${fileName}`,
        method: 'GET',
        signal
    });
};
export const getGetPlanReportQueryKey = (planId, reportType, fileName)=>{
    return [
        `/api/reports/plans/${planId}/${reportType}/${fileName}`
    ];
};
export const getGetPlanReportQueryOptions = (planId, reportType, fileName, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanReportQueryKey(planId, reportType, fileName);
    const queryFn = ({ signal })=>getPlanReport(planId, reportType, fileName, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(planId && reportType && fileName),
        ...queryOptions
    };
};
export const useGetPlanReport = (planId, reportType, fileName, options)=>{
    const queryOptions = getGetPlanReportQueryOptions(planId, reportType, fileName, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getSponsorReport = (sponsorId, reportType, fileName, params, signal)=>{
    return client({
        url: `/api/reports/sponsors/${sponsorId}/${reportType}/${fileName}`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetSponsorReportQueryKey = (sponsorId, reportType, fileName, params)=>{
    return [
        `/api/reports/sponsors/${sponsorId}/${reportType}/${fileName}`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetSponsorReportQueryOptions = (sponsorId, reportType, fileName, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSponsorReportQueryKey(sponsorId, reportType, fileName, params);
    const queryFn = ({ signal })=>getSponsorReport(sponsorId, reportType, fileName, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(sponsorId && reportType && fileName),
        ...queryOptions
    };
};
export const useGetSponsorReport = (sponsorId, reportType, fileName, params, options)=>{
    const queryOptions = getGetSponsorReportQueryOptions(sponsorId, reportType, fileName, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getSubaTransactionsReport = (params, signal)=>{
    return client({
        url: `/api/reports/suba-transactions`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetSubaTransactionsReportQueryKey = (params)=>{
    return [
        `/api/reports/suba-transactions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetSubaTransactionsReportQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSubaTransactionsReportQueryKey(params);
    const queryFn = ({ signal })=>getSubaTransactionsReport(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSubaTransactionsReport = (params, options)=>{
    const queryOptions = getGetSubaTransactionsReportQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getAllSafeHarborContributionTypes = (signal)=>{
    return client({
        url: `/api/safe-harbor-contribution-types`,
        method: 'GET',
        signal
    });
};
export const getGetAllSafeHarborContributionTypesQueryKey = ()=>{
    return [
        `/api/safe-harbor-contribution-types`
    ];
};
export const getGetAllSafeHarborContributionTypesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllSafeHarborContributionTypesQueryKey();
    const queryFn = ({ signal })=>getAllSafeHarborContributionTypes(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetAllSafeHarborContributionTypes = (options)=>{
    const queryOptions = getGetAllSafeHarborContributionTypesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getSubaExternalMarketValue = (params, signal)=>{
    return client({
        url: `/api/sdba/external-market-value`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetSubaExternalMarketValueQueryKey = (params)=>{
    return [
        `/api/sdba/external-market-value`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetSubaExternalMarketValueQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSubaExternalMarketValueQueryKey(params);
    const queryFn = ({ signal })=>getSubaExternalMarketValue(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSubaExternalMarketValue = (params, options)=>{
    const queryOptions = getGetSubaExternalMarketValueQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postSubaInitiateExternalTransfer = (postSubaInitiateExternalTransferBodyDto)=>{
    return client({
        url: `/api/sdba/initiate-external-transfer`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postSubaInitiateExternalTransferBodyDto
    });
};
export const getPostSubaInitiateExternalTransferMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postSubaInitiateExternalTransfer(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostSubaInitiateExternalTransfer = (options)=>{
    const mutationOptions = getPostSubaInitiateExternalTransferMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getSdbaSetup = (signal)=>{
    return client({
        url: `/api/sdba/setup`,
        method: 'GET',
        signal
    });
};
export const getGetSdbaSetupQueryKey = ()=>{
    return [
        `/api/sdba/setup`
    ];
};
export const getGetSdbaSetupQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSdbaSetupQueryKey();
    const queryFn = ({ signal })=>getSdbaSetup(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSdbaSetup = (options)=>{
    const queryOptions = getGetSdbaSetupQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getSdbaTransfersInfo = (params, signal)=>{
    return client({
        url: `/api/sdba/transfers`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetSdbaTransfersInfoQueryKey = (params)=>{
    return [
        `/api/sdba/transfers`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetSdbaTransfersInfoQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSdbaTransfersInfoQueryKey(params);
    const queryFn = ({ signal })=>getSdbaTransfersInfo(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSdbaTransfersInfo = (params, options)=>{
    const queryOptions = getGetSdbaTransfersInfoQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getCheckActiveSdbaTransfers = (params, signal)=>{
    return client({
        url: `/api/sdba/transfers-in-progress`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetCheckActiveSdbaTransfersQueryKey = (params)=>{
    return [
        `/api/sdba/transfers-in-progress`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetCheckActiveSdbaTransfersQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCheckActiveSdbaTransfersQueryKey(params);
    const queryFn = ({ signal })=>getCheckActiveSdbaTransfers(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetCheckActiveSdbaTransfers = (params, options)=>{
    const queryOptions = getGetCheckActiveSdbaTransfersQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getSession = (signal)=>{
    return client({
        url: `/api/session`,
        method: 'GET',
        signal
    });
};
export const getGetSessionQueryKey = ()=>{
    return [
        `/api/session`
    ];
};
export const getGetSessionQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSessionQueryKey();
    const queryFn = ({ signal })=>getSession(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSession = (options)=>{
    const queryOptions = getGetSessionQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getSponsorAbilities = (signal)=>{
    return client({
        url: `/api/sponsor/abilities`,
        method: 'GET',
        signal
    });
};
export const getGetSponsorAbilitiesQueryKey = ()=>{
    return [
        `/api/sponsor/abilities`
    ];
};
export const getGetSponsorAbilitiesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSponsorAbilitiesQueryKey();
    const queryFn = ({ signal })=>getSponsorAbilities(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSponsorAbilities = (options)=>{
    const queryOptions = getGetSponsorAbilitiesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getAutoEnrollSponsorPlan = (params, signal)=>{
    return client({
        url: `/api/sponsor/auto-enroll`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAutoEnrollSponsorPlanQueryKey = (params)=>{
    return [
        `/api/sponsor/auto-enroll`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAutoEnrollSponsorPlanQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAutoEnrollSponsorPlanQueryKey(params);
    const queryFn = ({ signal })=>getAutoEnrollSponsorPlan(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetAutoEnrollSponsorPlan = (params, options)=>{
    const queryOptions = getGetAutoEnrollSponsorPlanQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getCensusParticipants = (signal)=>{
    return client({
        url: `/api/sponsor/census/participants`,
        method: 'GET',
        signal
    });
};
export const getGetCensusParticipantsQueryKey = ()=>{
    return [
        `/api/sponsor/census/participants`
    ];
};
export const getGetCensusParticipantsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCensusParticipantsQueryKey();
    const queryFn = ({ signal })=>getCensusParticipants(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetCensusParticipants = (options)=>{
    const queryOptions = getGetCensusParticipantsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getBankAccount = (params, signal)=>{
    return client({
        url: `/api/sponsor/company/bank-account`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetBankAccountQueryKey = (params)=>{
    return [
        `/api/sponsor/company/bank-account`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetBankAccountQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetBankAccountQueryKey(params);
    const queryFn = ({ signal })=>getBankAccount(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetBankAccount = (params, options)=>{
    const queryOptions = getGetBankAccountQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postBankAccount = ()=>{
    return client({
        url: `/api/sponsor/company/bank-account`,
        method: 'POST'
    });
};
export const getPostBankAccountMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postBankAccount();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostBankAccount = (options)=>{
    const mutationOptions = getPostBankAccountMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putBankAccount = (postBankAccountDto)=>{
    return client({
        url: `/api/sponsor/company/bank-account`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postBankAccountDto
    });
};
export const getPutBankAccountMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putBankAccount(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutBankAccount = (options)=>{
    const mutationOptions = getPutBankAccountMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putSponsorArchiveBankAccount = (putBankAccountArchiveDto)=>{
    return client({
        url: `/api/sponsor/company/bank-account/archive`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putBankAccountArchiveDto
    });
};
export const getPutSponsorArchiveBankAccountMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putSponsorArchiveBankAccount(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutSponsorArchiveBankAccount = (options)=>{
    const mutationOptions = getPutSponsorArchiveBankAccountMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putFeePaymentMethod = (putFeePaymentMethodDto)=>{
    return client({
        url: `/api/sponsor/company/bank-account/fee-payment-method`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putFeePaymentMethodDto
    });
};
export const getPutFeePaymentMethodMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putFeePaymentMethod(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutFeePaymentMethod = (options)=>{
    const mutationOptions = getPutFeePaymentMethodMutationOptions(options);
    return useMutation(mutationOptions);
};
export const patchSponsor = (companyInfoBodyDto)=>{
    return client({
        url: `/api/sponsor/company/company-info`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: companyInfoBodyDto
    });
};
export const getPatchSponsorMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchSponsor(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchSponsor = (options)=>{
    const mutationOptions = getPatchSponsorMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getSponsorTeammates = (signal)=>{
    return client({
        url: `/api/sponsor/company/manage-teammate`,
        method: 'GET',
        signal
    });
};
export const getGetSponsorTeammatesQueryKey = ()=>{
    return [
        `/api/sponsor/company/manage-teammate`
    ];
};
export const getGetSponsorTeammatesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSponsorTeammatesQueryKey();
    const queryFn = ({ signal })=>getSponsorTeammates(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSponsorTeammates = (options)=>{
    const queryOptions = getGetSponsorTeammatesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchDeleteTeammate = ()=>{
    return client({
        url: `/api/sponsor/company/manage-teammate`,
        method: 'PATCH'
    });
};
export const getPatchDeleteTeammateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return patchDeleteTeammate();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchDeleteTeammate = (options)=>{
    const mutationOptions = getPatchDeleteTeammateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postSendUserInvite = ()=>{
    return client({
        url: `/api/sponsor/company/manage-teammate`,
        method: 'POST'
    });
};
export const getPostSendUserInviteMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postSendUserInvite();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostSendUserInvite = (options)=>{
    const mutationOptions = getPostSendUserInviteMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPlanConfigurationV2 = (signal)=>{
    return client({
        url: `/api/sponsor/compliance/configuration`,
        method: 'GET',
        signal
    });
};
export const getGetPlanConfigurationV2QueryKey = ()=>{
    return [
        `/api/sponsor/compliance/configuration`
    ];
};
export const getGetPlanConfigurationV2QueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanConfigurationV2QueryKey();
    const queryFn = ({ signal })=>getPlanConfigurationV2(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanConfigurationV2 = (options)=>{
    const queryOptions = getGetPlanConfigurationV2QueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putPlanConfigurationV2 = (putPlanConfigurationBodyDtoV2)=>{
    return client({
        url: `/api/sponsor/compliance/configuration`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putPlanConfigurationBodyDtoV2
    });
};
export const getPutPlanConfigurationV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putPlanConfigurationV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutPlanConfigurationV2 = (options)=>{
    const mutationOptions = getPutPlanConfigurationV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPlanEmployeesV2 = (signal)=>{
    return client({
        url: `/api/sponsor/compliance/employees`,
        method: 'GET',
        signal
    });
};
export const getGetPlanEmployeesV2QueryKey = ()=>{
    return [
        `/api/sponsor/compliance/employees`
    ];
};
export const getGetPlanEmployeesV2QueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanEmployeesV2QueryKey();
    const queryFn = ({ signal })=>getPlanEmployeesV2(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanEmployeesV2 = (options)=>{
    const queryOptions = getGetPlanEmployeesV2QueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPlanGrossCompensationV2 = (signal)=>{
    return client({
        url: `/api/sponsor/compliance/gross-compensation`,
        method: 'GET',
        signal
    });
};
export const getGetPlanGrossCompensationV2QueryKey = ()=>{
    return [
        `/api/sponsor/compliance/gross-compensation`
    ];
};
export const getGetPlanGrossCompensationV2QueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanGrossCompensationV2QueryKey();
    const queryFn = ({ signal })=>getPlanGrossCompensationV2(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanGrossCompensationV2 = (options)=>{
    const queryOptions = getGetPlanGrossCompensationV2QueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putPlanEmployeeGrossCompensationV2 = (putPlanGrossCompensationBodyDtoV2)=>{
    return client({
        url: `/api/sponsor/compliance/gross-compensation`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putPlanGrossCompensationBodyDtoV2
    });
};
export const getPutPlanEmployeeGrossCompensationV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putPlanEmployeeGrossCompensationV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutPlanEmployeeGrossCompensationV2 = (options)=>{
    const mutationOptions = getPutPlanEmployeeGrossCompensationV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const getGrossCompensationTemplateV2 = (params, signal)=>{
    return client({
        url: `/api/sponsor/compliance/gross-compensation/download/template`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetGrossCompensationTemplateV2QueryKey = (params)=>{
    return [
        `/api/sponsor/compliance/gross-compensation/download/template`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetGrossCompensationTemplateV2QueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetGrossCompensationTemplateV2QueryKey(params);
    const queryFn = ({ signal })=>getGrossCompensationTemplateV2(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetGrossCompensationTemplateV2 = (params, options)=>{
    const queryOptions = getGetGrossCompensationTemplateV2QueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postPlanEmployeeGrossCompensationUploadV2 = (postPlanGrossCompensationUploadBodyDtoV2)=>{
    return client({
        url: `/api/sponsor/compliance/gross-compensation/upload`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postPlanGrossCompensationUploadBodyDtoV2
    });
};
export const getPostPlanEmployeeGrossCompensationUploadV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postPlanEmployeeGrossCompensationUploadV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPlanEmployeeGrossCompensationUploadV2 = (options)=>{
    const mutationOptions = getPostPlanEmployeeGrossCompensationUploadV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const postPlanNonEmployeeOwnerV2 = (postPlanNonEmployeeOwnerBodyDtoV2)=>{
    return client({
        url: `/api/sponsor/compliance/non-employee-owner`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postPlanNonEmployeeOwnerBodyDtoV2
    });
};
export const getPostPlanNonEmployeeOwnerV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postPlanNonEmployeeOwnerV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPlanNonEmployeeOwnerV2 = (options)=>{
    const mutationOptions = getPostPlanNonEmployeeOwnerV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPlanOfficersV2 = (signal)=>{
    return client({
        url: `/api/sponsor/compliance/officers`,
        method: 'GET',
        signal
    });
};
export const getGetPlanOfficersV2QueryKey = ()=>{
    return [
        `/api/sponsor/compliance/officers`
    ];
};
export const getGetPlanOfficersV2QueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanOfficersV2QueryKey();
    const queryFn = ({ signal })=>getPlanOfficersV2(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanOfficersV2 = (options)=>{
    const queryOptions = getGetPlanOfficersV2QueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putPlanOfficerStatusV2 = (putPlanOfficersBodyDtoV2)=>{
    return client({
        url: `/api/sponsor/compliance/officers`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putPlanOfficersBodyDtoV2
    });
};
export const getPutPlanOfficerStatusV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putPlanOfficerStatusV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutPlanOfficerStatusV2 = (options)=>{
    const mutationOptions = getPutPlanOfficerStatusV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const deletePlanOwnerV2 = (deletePlanOwnerBodyDtoV2)=>{
    return client({
        url: `/api/sponsor/compliance/owners`,
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        data: deletePlanOwnerBodyDtoV2
    });
};
export const getDeletePlanOwnerV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return deletePlanOwnerV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeletePlanOwnerV2 = (options)=>{
    const mutationOptions = getDeletePlanOwnerV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPlanOwnersV2 = (signal)=>{
    return client({
        url: `/api/sponsor/compliance/owners`,
        method: 'GET',
        signal
    });
};
export const getGetPlanOwnersV2QueryKey = ()=>{
    return [
        `/api/sponsor/compliance/owners`
    ];
};
export const getGetPlanOwnersV2QueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanOwnersV2QueryKey();
    const queryFn = ({ signal })=>getPlanOwnersV2(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanOwnersV2 = (options)=>{
    const queryOptions = getGetPlanOwnersV2QueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postPlanEmployeeOwnerV2 = (postPlanEmployeeOwnerBodyDtoV2)=>{
    return client({
        url: `/api/sponsor/compliance/owners`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postPlanEmployeeOwnerBodyDtoV2
    });
};
export const getPostPlanEmployeeOwnerV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postPlanEmployeeOwnerV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPlanEmployeeOwnerV2 = (options)=>{
    const mutationOptions = getPostPlanEmployeeOwnerV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const putPlanEmployeeOwnerV2 = (putPlanEmployeeOwnerBodyDtoV2)=>{
    return client({
        url: `/api/sponsor/compliance/owners`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putPlanEmployeeOwnerBodyDtoV2
    });
};
export const getPutPlanEmployeeOwnerV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putPlanEmployeeOwnerV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutPlanEmployeeOwnerV2 = (options)=>{
    const mutationOptions = getPutPlanEmployeeOwnerV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const deletePlanOwnersFamilyV2 = (deletePlanOwnersFamilyBodyDtoV2)=>{
    return client({
        url: `/api/sponsor/compliance/owners-family`,
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        data: deletePlanOwnersFamilyBodyDtoV2
    });
};
export const getDeletePlanOwnersFamilyV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return deletePlanOwnersFamilyV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeletePlanOwnersFamilyV2 = (options)=>{
    const mutationOptions = getDeletePlanOwnersFamilyV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPlanOwnersFamilyV2 = (params, signal)=>{
    return client({
        url: `/api/sponsor/compliance/owners-family`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPlanOwnersFamilyV2QueryKey = (params)=>{
    return [
        `/api/sponsor/compliance/owners-family`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPlanOwnersFamilyV2QueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanOwnersFamilyV2QueryKey(params);
    const queryFn = ({ signal })=>getPlanOwnersFamilyV2(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanOwnersFamilyV2 = (params, options)=>{
    const queryOptions = getGetPlanOwnersFamilyV2QueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putPlanOwnersFamilyV2 = (putPlanOwnersFamilyBodyDtoV2)=>{
    return client({
        url: `/api/sponsor/compliance/owners-family`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putPlanOwnersFamilyBodyDtoV2
    });
};
export const getPutPlanOwnersFamilyV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putPlanOwnersFamilyV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutPlanOwnersFamilyV2 = (options)=>{
    const mutationOptions = getPutPlanOwnersFamilyV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const postFileHeadersUpdate = ()=>{
    return client({
        url: `/api/sponsor/contribution/headers/mapping`,
        method: 'POST'
    });
};
export const getPostFileHeadersUpdateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postFileHeadersUpdate();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostFileHeadersUpdate = (options)=>{
    const mutationOptions = getPostFileHeadersUpdateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getContributionsLandingPageDisplay = (signal)=>{
    return client({
        url: `/api/sponsor/contributions`,
        method: 'GET',
        signal
    });
};
export const getGetContributionsLandingPageDisplayQueryKey = ()=>{
    return [
        `/api/sponsor/contributions`
    ];
};
export const getGetContributionsLandingPageDisplayQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetContributionsLandingPageDisplayQueryKey();
    const queryFn = ({ signal })=>getContributionsLandingPageDisplay(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetContributionsLandingPageDisplay = (options)=>{
    const queryOptions = getGetContributionsLandingPageDisplayQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postContribution = ()=>{
    return client({
        url: `/api/sponsor/contributions`,
        method: 'POST'
    });
};
export const getPostContributionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postContribution();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostContribution = (options)=>{
    const mutationOptions = getPostContributionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postCancelSubmission = ()=>{
    return client({
        url: `/api/sponsor/contributions/cancel`,
        method: 'POST'
    });
};
export const getPostCancelSubmissionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postCancelSubmission();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostCancelSubmission = (options)=>{
    const mutationOptions = getPostCancelSubmissionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postCancellationSubmission = ()=>{
    return client({
        url: `/api/sponsor/contributions/cancellation`,
        method: 'POST'
    });
};
export const getPostCancellationSubmissionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postCancellationSubmission();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostCancellationSubmission = (options)=>{
    const mutationOptions = getPostCancellationSubmissionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getParticipantsLoans = (signal)=>{
    return client({
        url: `/api/sponsor/contributions/loans`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantsLoansQueryKey = ()=>{
    return [
        `/api/sponsor/contributions/loans`
    ];
};
export const getGetParticipantsLoansQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantsLoansQueryKey();
    const queryFn = ({ signal })=>getParticipantsLoans(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantsLoans = (options)=>{
    const queryOptions = getGetParticipantsLoansQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postMatchRemediationContribution = (postMatchRemediationContributionBodyDto)=>{
    return client({
        url: `/api/sponsor/contributions/match-remediation`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postMatchRemediationContributionBodyDto
    });
};
export const getPostMatchRemediationContributionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postMatchRemediationContribution(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostMatchRemediationContribution = (options)=>{
    const mutationOptions = getPostMatchRemediationContributionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postOffCycleContribution = ()=>{
    return client({
        url: `/api/sponsor/contributions/offcycle`,
        method: 'POST'
    });
};
export const getPostOffCycleContributionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postOffCycleContribution();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostOffCycleContribution = (options)=>{
    const mutationOptions = getPostOffCycleContributionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postResumeSubmission = ()=>{
    return client({
        url: `/api/sponsor/contributions/resume`,
        method: 'POST'
    });
};
export const getPostResumeSubmissionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postResumeSubmission();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostResumeSubmission = (options)=>{
    const mutationOptions = getPostResumeSubmissionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postIngestionFlowValidation = ()=>{
    return client({
        url: `/api/sponsor/contributions/validate`,
        method: 'POST'
    });
};
export const getPostIngestionFlowValidationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postIngestionFlowValidation();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostIngestionFlowValidation = (options)=>{
    const mutationOptions = getPostIngestionFlowValidationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postContributionValidation = ()=>{
    return client({
        url: `/api/sponsor/contributions/validation`,
        method: 'POST'
    });
};
export const getPostContributionValidationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postContributionValidation();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostContributionValidation = (options)=>{
    const mutationOptions = getPostContributionValidationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getContributionSubmissionDisplay = (ucid, signal)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}`,
        method: 'GET',
        signal
    });
};
export const getGetContributionSubmissionDisplayQueryKey = (ucid)=>{
    return [
        `/api/sponsor/contributions/${ucid}`
    ];
};
export const getGetContributionSubmissionDisplayQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetContributionSubmissionDisplayQueryKey(ucid);
    const queryFn = ({ signal })=>getContributionSubmissionDisplay(ucid, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!ucid,
        ...queryOptions
    };
};
export const useGetContributionSubmissionDisplay = (ucid, options)=>{
    const queryOptions = getGetContributionSubmissionDisplayQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getContributionAdjustments = (ucid, signal)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/adjustments`,
        method: 'GET',
        signal
    });
};
export const getGetContributionAdjustmentsQueryKey = (ucid)=>{
    return [
        `/api/sponsor/contributions/${ucid}/adjustments`
    ];
};
export const getGetContributionAdjustmentsQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetContributionAdjustmentsQueryKey(ucid);
    const queryFn = ({ signal })=>getContributionAdjustments(ucid, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!ucid,
        ...queryOptions
    };
};
export const useGetContributionAdjustments = (ucid, options)=>{
    const queryOptions = getGetContributionAdjustmentsQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postContributionConfirmation = (ucid)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/confirm`,
        method: 'POST'
    });
};
export const getPostContributionConfirmationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { ucid } = props ?? {};
        return postContributionConfirmation(ucid);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostContributionConfirmation = (options)=>{
    const mutationOptions = getPostContributionConfirmationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getContributionConfirmationDisplay = (ucid, signal)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/confirmation`,
        method: 'GET',
        signal
    });
};
export const getGetContributionConfirmationDisplayQueryKey = (ucid)=>{
    return [
        `/api/sponsor/contributions/${ucid}/confirmation`
    ];
};
export const getGetContributionConfirmationDisplayQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetContributionConfirmationDisplayQueryKey(ucid);
    const queryFn = ({ signal })=>getContributionConfirmationDisplay(ucid, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!ucid,
        ...queryOptions
    };
};
export const useGetContributionConfirmationDisplay = (ucid, options)=>{
    const queryOptions = getGetContributionConfirmationDisplayQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postContributionCorrection = (ucid)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/correction`,
        method: 'POST'
    });
};
export const getPostContributionCorrectionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { ucid } = props ?? {};
        return postContributionCorrection(ucid);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostContributionCorrection = (options)=>{
    const mutationOptions = getPostContributionCorrectionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getContributionCorrections = (ucid, signal)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/corrections`,
        method: 'GET',
        signal
    });
};
export const getGetContributionCorrectionsQueryKey = (ucid)=>{
    return [
        `/api/sponsor/contributions/${ucid}/corrections`
    ];
};
export const getGetContributionCorrectionsQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetContributionCorrectionsQueryKey(ucid);
    const queryFn = ({ signal })=>getContributionCorrections(ucid, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!ucid,
        ...queryOptions
    };
};
export const useGetContributionCorrections = (ucid, options)=>{
    const queryOptions = getGetContributionCorrectionsQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getContributionDetails = (ucid, signal)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/details`,
        method: 'GET',
        signal
    });
};
export const getGetContributionDetailsQueryKey = (ucid)=>{
    return [
        `/api/sponsor/contributions/${ucid}/details`
    ];
};
export const getGetContributionDetailsQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetContributionDetailsQueryKey(ucid);
    const queryFn = ({ signal })=>getContributionDetails(ucid, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!ucid,
        ...queryOptions
    };
};
export const useGetContributionDetails = (ucid, options)=>{
    const queryOptions = getGetContributionDetailsQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getContributionDisplay = (ucid, signal)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/display`,
        method: 'GET',
        signal
    });
};
export const getGetContributionDisplayQueryKey = (ucid)=>{
    return [
        `/api/sponsor/contributions/${ucid}/display`
    ];
};
export const getGetContributionDisplayQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetContributionDisplayQueryKey(ucid);
    const queryFn = ({ signal })=>getContributionDisplay(ucid, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!ucid,
        ...queryOptions
    };
};
export const useGetContributionDisplay = (ucid, options)=>{
    const queryOptions = getGetContributionDisplayQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postContributionUpload = (ucid, categoryId)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/document-category/${categoryId}/upload`,
        method: 'POST'
    });
};
export const getPostContributionUploadMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { ucid, categoryId } = props ?? {};
        return postContributionUpload(ucid, categoryId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostContributionUpload = (options)=>{
    const mutationOptions = getPostContributionUploadMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getDownloadContributionFile = (ucid, signal)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/file`,
        method: 'GET',
        signal
    });
};
export const getGetDownloadContributionFileQueryKey = (ucid)=>{
    return [
        `/api/sponsor/contributions/${ucid}/file`
    ];
};
export const getGetDownloadContributionFileQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDownloadContributionFileQueryKey(ucid);
    const queryFn = ({ signal })=>getDownloadContributionFile(ucid, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!ucid,
        ...queryOptions
    };
};
export const useGetDownloadContributionFile = (ucid, options)=>{
    const queryOptions = getGetDownloadContributionFileQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getForfeiture = (ucid, signal)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/forfeiture`,
        method: 'GET',
        signal
    });
};
export const getGetForfeitureQueryKey = (ucid)=>{
    return [
        `/api/sponsor/contributions/${ucid}/forfeiture`
    ];
};
export const getGetForfeitureQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetForfeitureQueryKey(ucid);
    const queryFn = ({ signal })=>getForfeiture(ucid, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!ucid,
        ...queryOptions
    };
};
export const useGetForfeiture = (ucid, options)=>{
    const queryOptions = getGetForfeitureQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postForfeiture = (ucid)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/forfeiture`,
        method: 'POST'
    });
};
export const getPostForfeitureMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { ucid } = props ?? {};
        return postForfeiture(ucid);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostForfeiture = (options)=>{
    const mutationOptions = getPostForfeitureMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getContributionHeaderValidations = (ucid, signal)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/headers`,
        method: 'GET',
        signal
    });
};
export const getGetContributionHeaderValidationsQueryKey = (ucid)=>{
    return [
        `/api/sponsor/contributions/${ucid}/headers`
    ];
};
export const getGetContributionHeaderValidationsQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetContributionHeaderValidationsQueryKey(ucid);
    const queryFn = ({ signal })=>getContributionHeaderValidations(ucid, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!ucid,
        ...queryOptions
    };
};
export const useGetContributionHeaderValidations = (ucid, options)=>{
    const queryOptions = getGetContributionHeaderValidationsQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getNormalizedContributionData = (ucid, signal)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/normalized`,
        method: 'GET',
        signal
    });
};
export const getGetNormalizedContributionDataQueryKey = (ucid)=>{
    return [
        `/api/sponsor/contributions/${ucid}/normalized`
    ];
};
export const getGetNormalizedContributionDataQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetNormalizedContributionDataQueryKey(ucid);
    const queryFn = ({ signal })=>getNormalizedContributionData(ucid, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!ucid,
        ...queryOptions
    };
};
export const useGetNormalizedContributionData = (ucid, options)=>{
    const queryOptions = getGetNormalizedContributionDataQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postIngestionFlowStart = (ucid)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/start`,
        method: 'POST'
    });
};
export const getPostIngestionFlowStartMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { ucid } = props ?? {};
        return postIngestionFlowStart(ucid);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostIngestionFlowStart = (options)=>{
    const mutationOptions = getPostIngestionFlowStartMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getDownloadContributionTemplate = (ucid, signal)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/template.xlsx`,
        method: 'GET',
        signal
    });
};
export const getGetDownloadContributionTemplateQueryKey = (ucid)=>{
    return [
        `/api/sponsor/contributions/${ucid}/template.xlsx`
    ];
};
export const getGetDownloadContributionTemplateQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDownloadContributionTemplateQueryKey(ucid);
    const queryFn = ({ signal })=>getDownloadContributionTemplate(ucid, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!ucid,
        ...queryOptions
    };
};
export const useGetDownloadContributionTemplate = (ucid, options)=>{
    const queryOptions = getGetDownloadContributionTemplateQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getContributionValidationPageDisplay = (ucid, signal)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/validate`,
        method: 'GET',
        signal
    });
};
export const getGetContributionValidationPageDisplayQueryKey = (ucid)=>{
    return [
        `/api/sponsor/contributions/${ucid}/validate`
    ];
};
export const getGetContributionValidationPageDisplayQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetContributionValidationPageDisplayQueryKey(ucid);
    const queryFn = ({ signal })=>getContributionValidationPageDisplay(ucid, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!ucid,
        ...queryOptions
    };
};
export const useGetContributionValidationPageDisplay = (ucid, options)=>{
    const queryOptions = getGetContributionValidationPageDisplayQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getContributionValidation = (ucid, signal)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/validation`,
        method: 'GET',
        signal
    });
};
export const getGetContributionValidationQueryKey = (ucid)=>{
    return [
        `/api/sponsor/contributions/${ucid}/validation`
    ];
};
export const getGetContributionValidationQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetContributionValidationQueryKey(ucid);
    const queryFn = ({ signal })=>getContributionValidation(ucid, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!ucid,
        ...queryOptions
    };
};
export const useGetContributionValidation = (ucid, options)=>{
    const queryOptions = getGetContributionValidationQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getDeferralChanges = (signal)=>{
    return client({
        url: `/api/sponsor/deferral/changes`,
        method: 'GET',
        signal
    });
};
export const getGetDeferralChangesQueryKey = ()=>{
    return [
        `/api/sponsor/deferral/changes`
    ];
};
export const getGetDeferralChangesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDeferralChangesQueryKey();
    const queryFn = ({ signal })=>getDeferralChanges(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetDeferralChanges = (options)=>{
    const queryOptions = getGetDeferralChangesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchDeferralChangesActivities = ()=>{
    return client({
        url: `/api/sponsor/deferral/changes`,
        method: 'PATCH'
    });
};
export const getPatchDeferralChangesActivitiesMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return patchDeferralChangesActivities();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchDeferralChangesActivities = (options)=>{
    const mutationOptions = getPatchDeferralChangesActivitiesMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putParticipant = ()=>{
    return client({
        url: `/api/sponsor/employee`,
        method: 'PUT'
    });
};
export const getPutParticipantMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return putParticipant();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutParticipant = (options)=>{
    const mutationOptions = getPutParticipantMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getEmployeeClasses = (signal)=>{
    return client({
        url: `/api/sponsor/employee-classes`,
        method: 'GET',
        signal
    });
};
export const getGetEmployeeClassesQueryKey = ()=>{
    return [
        `/api/sponsor/employee-classes`
    ];
};
export const getGetEmployeeClassesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmployeeClassesQueryKey();
    const queryFn = ({ signal })=>getEmployeeClasses(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEmployeeClasses = (options)=>{
    const queryOptions = getGetEmployeeClassesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEmployees = (signal)=>{
    return client({
        url: `/api/sponsor/employees`,
        method: 'GET',
        signal
    });
};
export const getGetEmployeesQueryKey = ()=>{
    return [
        `/api/sponsor/employees`
    ];
};
export const getGetEmployeesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmployeesQueryKey();
    const queryFn = ({ signal })=>getEmployees(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEmployees = (options)=>{
    const queryOptions = getGetEmployeesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putParticipants = ()=>{
    return client({
        url: `/api/sponsor/employees`,
        method: 'PUT'
    });
};
export const getPutParticipantsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return putParticipants();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutParticipants = (options)=>{
    const mutationOptions = getPutParticipantsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postUploadCensusOriginal = (postCensusOriginalBodyDto)=>{
    return client({
        url: `/api/sponsor/employees/original`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postCensusOriginalBodyDto
    });
};
export const getPostUploadCensusOriginalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postUploadCensusOriginal(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostUploadCensusOriginal = (options)=>{
    const mutationOptions = getPostUploadCensusOriginalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postValidateEmployee = ()=>{
    return client({
        url: `/api/sponsor/employees/validate`,
        method: 'POST'
    });
};
export const getPostValidateEmployeeMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postValidateEmployee();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostValidateEmployee = (options)=>{
    const mutationOptions = getPostValidateEmployeeMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getEmployeeDetails = (employeeId, signal)=>{
    return client({
        url: `/api/sponsor/employees/${employeeId}`,
        method: 'GET',
        signal
    });
};
export const getGetEmployeeDetailsQueryKey = (employeeId)=>{
    return [
        `/api/sponsor/employees/${employeeId}`
    ];
};
export const getGetEmployeeDetailsQueryOptions = (employeeId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmployeeDetailsQueryKey(employeeId);
    const queryFn = ({ signal })=>getEmployeeDetails(employeeId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!employeeId,
        ...queryOptions
    };
};
export const useGetEmployeeDetails = (employeeId, options)=>{
    const queryOptions = getGetEmployeeDetailsQueryOptions(employeeId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postContactInfo = (employeeId)=>{
    return client({
        url: `/api/sponsor/employees/${employeeId}/address`,
        method: 'POST'
    });
};
export const getPostContactInfoMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { employeeId } = props ?? {};
        return postContactInfo(employeeId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostContactInfo = (options)=>{
    const mutationOptions = getPostContactInfoMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putParticipantContributions = (employeeId)=>{
    return client({
        url: `/api/sponsor/employees/${employeeId}/contributions`,
        method: 'PUT'
    });
};
export const getPutParticipantContributionsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { employeeId } = props ?? {};
        return putParticipantContributions(employeeId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutParticipantContributions = (options)=>{
    const mutationOptions = getPutParticipantContributionsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getSponsorEntity = (signal)=>{
    return client({
        url: `/api/sponsor/entity`,
        method: 'GET',
        signal
    });
};
export const getGetSponsorEntityQueryKey = ()=>{
    return [
        `/api/sponsor/entity`
    ];
};
export const getGetSponsorEntityQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSponsorEntityQueryKey();
    const queryFn = ({ signal })=>getSponsorEntity(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSponsorEntity = (options)=>{
    const queryOptions = getGetSponsorEntityQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getForfeiturePreference = (signal)=>{
    return client({
        url: `/api/sponsor/forfeiture-preference`,
        method: 'GET',
        signal
    });
};
export const getGetForfeiturePreferenceQueryKey = ()=>{
    return [
        `/api/sponsor/forfeiture-preference`
    ];
};
export const getGetForfeiturePreferenceQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetForfeiturePreferenceQueryKey();
    const queryFn = ({ signal })=>getForfeiturePreference(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetForfeiturePreference = (options)=>{
    const queryOptions = getGetForfeiturePreferenceQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putForfeiturePreference = (putForfeiturePreferenceBodyDto)=>{
    return client({
        url: `/api/sponsor/forfeiture-preference`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putForfeiturePreferenceBodyDto
    });
};
export const getPutForfeiturePreferenceMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putForfeiturePreference(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutForfeiturePreference = (options)=>{
    const mutationOptions = getPutForfeiturePreferenceMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getHeapData = (signal)=>{
    return client({
        url: `/api/sponsor/heap`,
        method: 'GET',
        signal
    });
};
export const getGetHeapDataQueryKey = ()=>{
    return [
        `/api/sponsor/heap`
    ];
};
export const getGetHeapDataQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetHeapDataQueryKey();
    const queryFn = ({ signal })=>getHeapData(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetHeapData = (options)=>{
    const queryOptions = getGetHeapDataQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getOnboarding = (params, signal)=>{
    return client({
        url: `/api/sponsor/onboarding`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetOnboardingQueryKey = (params)=>{
    return [
        `/api/sponsor/onboarding`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetOnboardingQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOnboardingQueryKey(params);
    const queryFn = ({ signal })=>getOnboarding(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetOnboarding = (params, options)=>{
    const queryOptions = getGetOnboardingQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postOnboarding = (params)=>{
    return client({
        url: `/api/sponsor/onboarding`,
        method: 'POST',
        params
    });
};
export const getPostOnboardingMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { params } = props ?? {};
        return postOnboarding(params);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostOnboarding = (options)=>{
    const mutationOptions = getPostOnboardingMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putOnboarding = ()=>{
    return client({
        url: `/api/sponsor/onboarding`,
        method: 'PUT'
    });
};
export const getPutOnboardingMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return putOnboarding();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutOnboarding = (options)=>{
    const mutationOptions = getPutOnboardingMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getSponsorOnboardingInformation = (signal)=>{
    return client({
        url: `/api/sponsor/onboarding-information`,
        method: 'GET',
        signal
    });
};
export const getGetSponsorOnboardingInformationQueryKey = ()=>{
    return [
        `/api/sponsor/onboarding-information`
    ];
};
export const getGetSponsorOnboardingInformationQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSponsorOnboardingInformationQueryKey();
    const queryFn = ({ signal })=>getSponsorOnboardingInformation(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSponsorOnboardingInformation = (options)=>{
    const queryOptions = getGetSponsorOnboardingInformationQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putSponsorOnboardingInformation = (putSponsorOnboardingInformationDto)=>{
    return client({
        url: `/api/sponsor/onboarding-information`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putSponsorOnboardingInformationDto
    });
};
export const getPutSponsorOnboardingInformationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putSponsorOnboardingInformation(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutSponsorOnboardingInformation = (options)=>{
    const mutationOptions = getPutSponsorOnboardingInformationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postUploadCensus = (postCensusBodyDto)=>{
    return client({
        url: `/api/sponsor/onboarding/add-employees`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postCensusBodyDto
    });
};
export const getPostUploadCensusMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postUploadCensus(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostUploadCensus = (options)=>{
    const mutationOptions = getPostUploadCensusMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postUploadOnboardingCensusOriginal = (postCensusOriginalBodyDto)=>{
    return client({
        url: `/api/sponsor/onboarding/add-employees/original`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postCensusOriginalBodyDto
    });
};
export const getPostUploadOnboardingCensusOriginalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postUploadOnboardingCensusOriginal(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostUploadOnboardingCensusOriginal = (options)=>{
    const mutationOptions = getPostUploadOnboardingCensusOriginalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getInitialCensus = (params, signal)=>{
    return client({
        url: `/api/sponsor/onboarding/census`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetInitialCensusQueryKey = (params)=>{
    return [
        `/api/sponsor/onboarding/census`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetInitialCensusQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInitialCensusQueryKey(params);
    const queryFn = ({ signal })=>getInitialCensus(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetInitialCensus = (params, options)=>{
    const queryOptions = getGetInitialCensusQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const deleteCensusCache = ()=>{
    return client({
        url: `/api/sponsor/onboarding/census-cache`,
        method: 'DELETE'
    });
};
export const getDeleteCensusCacheMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return deleteCensusCache();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteCensusCache = (options)=>{
    const mutationOptions = getDeleteCensusCacheMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getCensusCache = (signal)=>{
    return client({
        url: `/api/sponsor/onboarding/census-cache`,
        method: 'GET',
        signal
    });
};
export const getGetCensusCacheQueryKey = ()=>{
    return [
        `/api/sponsor/onboarding/census-cache`
    ];
};
export const getGetCensusCacheQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCensusCacheQueryKey();
    const queryFn = ({ signal })=>getCensusCache(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetCensusCache = (options)=>{
    const queryOptions = getGetCensusCacheQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postCensusCache = (postCensusCacheBodyDto)=>{
    return client({
        url: `/api/sponsor/onboarding/census-cache`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postCensusCacheBodyDto
    });
};
export const getPostCensusCacheMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postCensusCache(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostCensusCache = (options)=>{
    const mutationOptions = getPostCensusCacheMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getSponsorEsaProgram = (params, signal)=>{
    return client({
        url: `/api/sponsor/onboarding/esa-program`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetSponsorEsaProgramQueryKey = (params)=>{
    return [
        `/api/sponsor/onboarding/esa-program`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetSponsorEsaProgramQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSponsorEsaProgramQueryKey(params);
    const queryFn = ({ signal })=>getSponsorEsaProgram(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSponsorEsaProgram = (params, options)=>{
    const queryOptions = getGetSponsorEsaProgramQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postFinishOnboarding = ()=>{
    return client({
        url: `/api/sponsor/onboarding/finish`,
        method: 'POST'
    });
};
export const getPostFinishOnboardingMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postFinishOnboarding();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostFinishOnboarding = (options)=>{
    const mutationOptions = getPostFinishOnboardingMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getSponsorOnboardingTeammates = (signal)=>{
    return client({
        url: `/api/sponsor/onboarding/manage-teammate`,
        method: 'GET',
        signal
    });
};
export const getGetSponsorOnboardingTeammatesQueryKey = ()=>{
    return [
        `/api/sponsor/onboarding/manage-teammate`
    ];
};
export const getGetSponsorOnboardingTeammatesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSponsorOnboardingTeammatesQueryKey();
    const queryFn = ({ signal })=>getSponsorOnboardingTeammates(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSponsorOnboardingTeammates = (options)=>{
    const queryOptions = getGetSponsorOnboardingTeammatesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postSendOnboardingUserInvite = ()=>{
    return client({
        url: `/api/sponsor/onboarding/manage-teammate`,
        method: 'POST'
    });
};
export const getPostSendOnboardingUserInviteMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postSendOnboardingUserInvite();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostSendOnboardingUserInvite = (options)=>{
    const mutationOptions = getPostSendOnboardingUserInviteMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getNextPayrollDates = (signal)=>{
    return client({
        url: `/api/sponsor/onboarding/payroll-dates`,
        method: 'GET',
        signal
    });
};
export const getGetNextPayrollDatesQueryKey = ()=>{
    return [
        `/api/sponsor/onboarding/payroll-dates`
    ];
};
export const getGetNextPayrollDatesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetNextPayrollDatesQueryKey();
    const queryFn = ({ signal })=>getNextPayrollDates(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetNextPayrollDates = (options)=>{
    const queryOptions = getGetNextPayrollDatesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPayrollProviders = (signal)=>{
    return client({
        url: `/api/sponsor/onboarding/payroll-providers`,
        method: 'GET',
        signal
    });
};
export const getGetPayrollProvidersQueryKey = ()=>{
    return [
        `/api/sponsor/onboarding/payroll-providers`
    ];
};
export const getGetPayrollProvidersQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPayrollProvidersQueryKey();
    const queryFn = ({ signal })=>getPayrollProviders(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPayrollProviders = (options)=>{
    const queryOptions = getGetPayrollProvidersQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getSponsorPlaidLinkToken = (signal)=>{
    return client({
        url: `/api/sponsor/onboarding/plaid-link-token`,
        method: 'GET',
        signal
    });
};
export const getGetSponsorPlaidLinkTokenQueryKey = ()=>{
    return [
        `/api/sponsor/onboarding/plaid-link-token`
    ];
};
export const getGetSponsorPlaidLinkTokenQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSponsorPlaidLinkTokenQueryKey();
    const queryFn = ({ signal })=>getSponsorPlaidLinkToken(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSponsorPlaidLinkToken = (options)=>{
    const queryOptions = getGetSponsorPlaidLinkTokenQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postGetSponsorPlaidLinks = ()=>{
    return client({
        url: `/api/sponsor/onboarding/plaid-links`,
        method: 'POST'
    });
};
export const getPostGetSponsorPlaidLinksMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postGetSponsorPlaidLinks();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostGetSponsorPlaidLinks = (options)=>{
    const mutationOptions = getPostGetSponsorPlaidLinksMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPlanDesignConsultState = (signal)=>{
    return client({
        url: `/api/sponsor/onboarding/plan-design-consult-state`,
        method: 'GET',
        signal
    });
};
export const getGetPlanDesignConsultStateQueryKey = ()=>{
    return [
        `/api/sponsor/onboarding/plan-design-consult-state`
    ];
};
export const getGetPlanDesignConsultStateQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanDesignConsultStateQueryKey();
    const queryFn = ({ signal })=>getPlanDesignConsultState(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanDesignConsultState = (options)=>{
    const queryOptions = getGetPlanDesignConsultStateQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchPlanDesignConsultState = (patchPlanDesignConsultStateDto)=>{
    return client({
        url: `/api/sponsor/onboarding/plan-design-consult-state`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchPlanDesignConsultStateDto
    });
};
export const getPatchPlanDesignConsultStateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchPlanDesignConsultState(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchPlanDesignConsultState = (options)=>{
    const mutationOptions = getPatchPlanDesignConsultStateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPlanLaunchCallUrl = (signal)=>{
    return client({
        url: `/api/sponsor/onboarding/plan-launch-call`,
        method: 'GET',
        signal
    });
};
export const getGetPlanLaunchCallUrlQueryKey = ()=>{
    return [
        `/api/sponsor/onboarding/plan-launch-call`
    ];
};
export const getGetPlanLaunchCallUrlQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanLaunchCallUrlQueryKey();
    const queryFn = ({ signal })=>getPlanLaunchCallUrl(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanLaunchCallUrl = (options)=>{
    const queryOptions = getGetPlanLaunchCallUrlQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getUserRoles = (signal)=>{
    return client({
        url: `/api/sponsor/onboarding/user-roles`,
        method: 'GET',
        signal
    });
};
export const getGetUserRolesQueryKey = ()=>{
    return [
        `/api/sponsor/onboarding/user-roles`
    ];
};
export const getGetUserRolesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetUserRolesQueryKey();
    const queryFn = ({ signal })=>getUserRoles(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetUserRoles = (options)=>{
    const queryOptions = getGetUserRolesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPayrollConnectionStatus = (signal)=>{
    return client({
        url: `/api/sponsor/payroll/connection-status`,
        method: 'GET',
        signal
    });
};
export const getGetPayrollConnectionStatusQueryKey = ()=>{
    return [
        `/api/sponsor/payroll/connection-status`
    ];
};
export const getGetPayrollConnectionStatusQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPayrollConnectionStatusQueryKey();
    const queryFn = ({ signal })=>getPayrollConnectionStatus(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPayrollConnectionStatus = (options)=>{
    const queryOptions = getGetPayrollConnectionStatusQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPayrollConnectionStatusV2 = (signal)=>{
    return client({
        url: `/api/sponsor/payroll/connection-status/v2`,
        method: 'GET',
        signal
    });
};
export const getGetPayrollConnectionStatusV2QueryKey = ()=>{
    return [
        `/api/sponsor/payroll/connection-status/v2`
    ];
};
export const getGetPayrollConnectionStatusV2QueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPayrollConnectionStatusV2QueryKey();
    const queryFn = ({ signal })=>getPayrollConnectionStatusV2(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPayrollConnectionStatusV2 = (options)=>{
    const queryOptions = getGetPayrollConnectionStatusV2QueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPayrollDates = (params, signal)=>{
    return client({
        url: `/api/sponsor/payroll/dates`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPayrollDatesQueryKey = (params)=>{
    return [
        `/api/sponsor/payroll/dates`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPayrollDatesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPayrollDatesQueryKey(params);
    const queryFn = ({ signal })=>getPayrollDates(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPayrollDates = (params, options)=>{
    const queryOptions = getGetPayrollDatesQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPayrollInfo = (signal)=>{
    return client({
        url: `/api/sponsor/payroll/info`,
        method: 'GET',
        signal
    });
};
export const getGetPayrollInfoQueryKey = ()=>{
    return [
        `/api/sponsor/payroll/info`
    ];
};
export const getGetPayrollInfoQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPayrollInfoQueryKey();
    const queryFn = ({ signal })=>getPayrollInfo(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPayrollInfo = (options)=>{
    const queryOptions = getGetPayrollInfoQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPayrollSetups = (signal)=>{
    return client({
        url: `/api/sponsor/payroll/setup`,
        method: 'GET',
        signal
    });
};
export const getGetPayrollSetupsQueryKey = ()=>{
    return [
        `/api/sponsor/payroll/setup`
    ];
};
export const getGetPayrollSetupsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPayrollSetupsQueryKey();
    const queryFn = ({ signal })=>getPayrollSetups(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPayrollSetups = (options)=>{
    const queryOptions = getGetPayrollSetupsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postPayrollSetup = ()=>{
    return client({
        url: `/api/sponsor/payroll/setup`,
        method: 'POST'
    });
};
export const getPostPayrollSetupMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postPayrollSetup();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPayrollSetup = (options)=>{
    const mutationOptions = getPostPayrollSetupMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postBulkPayrollSetupDisconnection = (bulkPayrollSetupDto)=>{
    return client({
        url: `/api/sponsor/payroll/setup/disconnect`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: bulkPayrollSetupDto
    });
};
export const getPostBulkPayrollSetupDisconnectionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postBulkPayrollSetupDisconnection(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostBulkPayrollSetupDisconnection = (options)=>{
    const mutationOptions = getPostBulkPayrollSetupDisconnectionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPayrollFundingSetups = (signal)=>{
    return client({
        url: `/api/sponsor/payroll/setup/funding`,
        method: 'GET',
        signal
    });
};
export const getGetPayrollFundingSetupsQueryKey = ()=>{
    return [
        `/api/sponsor/payroll/setup/funding`
    ];
};
export const getGetPayrollFundingSetupsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPayrollFundingSetupsQueryKey();
    const queryFn = ({ signal })=>getPayrollFundingSetups(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPayrollFundingSetups = (options)=>{
    const queryOptions = getGetPayrollFundingSetupsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putPayrollProvider = ()=>{
    return client({
        url: `/api/sponsor/payroll/setup/provider`,
        method: 'PUT'
    });
};
export const getPutPayrollProviderMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return putPayrollProvider();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutPayrollProvider = (options)=>{
    const mutationOptions = getPutPayrollProviderMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putPayrollSkipStatus = ()=>{
    return client({
        url: `/api/sponsor/payroll/setup/skip`,
        method: 'PUT'
    });
};
export const getPutPayrollSkipStatusMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return putPayrollSkipStatus();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutPayrollSkipStatus = (options)=>{
    const mutationOptions = getPutPayrollSkipStatusMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putSkipSubmission = ()=>{
    return client({
        url: `/api/sponsor/payroll/setup/skipping`,
        method: 'PUT'
    });
};
export const getPutSkipSubmissionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return putSkipSubmission();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutSkipSubmission = (options)=>{
    const mutationOptions = getPutSkipSubmissionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const deletePayrollSetup = (payrollSetupId)=>{
    return client({
        url: `/api/sponsor/payroll/setup/${payrollSetupId}`,
        method: 'DELETE'
    });
};
export const getDeletePayrollSetupMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { payrollSetupId } = props ?? {};
        return deletePayrollSetup(payrollSetupId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeletePayrollSetup = (options)=>{
    const mutationOptions = getDeletePayrollSetupMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putPayrollDates = (payrollSetupId)=>{
    return client({
        url: `/api/sponsor/payroll/setup/${payrollSetupId}/dates`,
        method: 'PUT'
    });
};
export const getPutPayrollDatesMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { payrollSetupId } = props ?? {};
        return putPayrollDates(payrollSetupId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutPayrollDates = (options)=>{
    const mutationOptions = getPutPayrollDatesMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postPayrollSetupDisconnection = (payrollSetupId)=>{
    return client({
        url: `/api/sponsor/payroll/setup/${payrollSetupId}/disconnect`,
        method: 'POST'
    });
};
export const getPostPayrollSetupDisconnectionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { payrollSetupId } = props ?? {};
        return postPayrollSetupDisconnection(payrollSetupId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPayrollSetupDisconnection = (options)=>{
    const mutationOptions = getPostPayrollSetupDisconnectionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putPayrollSetupInfo = (payrollSetupId)=>{
    return client({
        url: `/api/sponsor/payroll/setup/${payrollSetupId}/info`,
        method: 'PUT'
    });
};
export const getPutPayrollSetupInfoMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { payrollSetupId } = props ?? {};
        return putPayrollSetupInfo(payrollSetupId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutPayrollSetupInfo = (options)=>{
    const mutationOptions = getPutPayrollSetupInfoMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postPayrollValidations = ()=>{
    return client({
        url: `/api/sponsor/payroll/validate`,
        method: 'POST'
    });
};
export const getPostPayrollValidationsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postPayrollValidations();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPayrollValidations = (options)=>{
    const mutationOptions = getPostPayrollValidationsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPlanFeatures = (params, signal)=>{
    return client({
        url: `/api/sponsor/plan-features`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPlanFeaturesQueryKey = (params)=>{
    return [
        `/api/sponsor/plan-features`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPlanFeaturesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanFeaturesQueryKey(params);
    const queryFn = ({ signal })=>getPlanFeatures(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanFeatures = (params, options)=>{
    const queryOptions = getGetPlanFeaturesQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPlanOnboardingStatus = (signal)=>{
    return client({
        url: `/api/sponsor/plan/onboarding/status`,
        method: 'GET',
        signal
    });
};
export const getGetPlanOnboardingStatusQueryKey = ()=>{
    return [
        `/api/sponsor/plan/onboarding/status`
    ];
};
export const getGetPlanOnboardingStatusQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanOnboardingStatusQueryKey();
    const queryFn = ({ signal })=>getPlanOnboardingStatus(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanOnboardingStatus = (options)=>{
    const queryOptions = getGetPlanOnboardingStatusQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postSponsorPlanDisconnection = (planId)=>{
    return client({
        url: `/api/sponsor/plan/${planId}/disconnect`,
        method: 'POST'
    });
};
export const getPostSponsorPlanDisconnectionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { planId } = props ?? {};
        return postSponsorPlanDisconnection(planId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostSponsorPlanDisconnection = (options)=>{
    const mutationOptions = getPostSponsorPlanDisconnectionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPlanStatistics = (planId, signal)=>{
    return client({
        url: `/api/sponsor/plans/${planId}/stats`,
        method: 'GET',
        signal
    });
};
export const getGetPlanStatisticsQueryKey = (planId)=>{
    return [
        `/api/sponsor/plans/${planId}/stats`
    ];
};
export const getGetPlanStatisticsQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanStatisticsQueryKey(planId);
    const queryFn = ({ signal })=>getPlanStatistics(planId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!planId,
        ...queryOptions
    };
};
export const useGetPlanStatistics = (planId, options)=>{
    const queryOptions = getGetPlanStatisticsQueryOptions(planId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPlanConfiguration = (signal)=>{
    return client({
        url: `/api/sponsor/pocet/configuration`,
        method: 'GET',
        signal
    });
};
export const getGetPlanConfigurationQueryKey = ()=>{
    return [
        `/api/sponsor/pocet/configuration`
    ];
};
export const getGetPlanConfigurationQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanConfigurationQueryKey();
    const queryFn = ({ signal })=>getPlanConfiguration(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanConfiguration = (options)=>{
    const queryOptions = getGetPlanConfigurationQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putPlanConfiguration = (putPlanConfigurationBodyDto)=>{
    return client({
        url: `/api/sponsor/pocet/configuration`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putPlanConfigurationBodyDto
    });
};
export const getPutPlanConfigurationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putPlanConfiguration(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutPlanConfiguration = (options)=>{
    const mutationOptions = getPutPlanConfigurationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPlanEmployees = (signal)=>{
    return client({
        url: `/api/sponsor/pocet/employees`,
        method: 'GET',
        signal
    });
};
export const getGetPlanEmployeesQueryKey = ()=>{
    return [
        `/api/sponsor/pocet/employees`
    ];
};
export const getGetPlanEmployeesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanEmployeesQueryKey();
    const queryFn = ({ signal })=>getPlanEmployees(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanEmployees = (options)=>{
    const queryOptions = getGetPlanEmployeesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPlanGrossCompensation = (signal)=>{
    return client({
        url: `/api/sponsor/pocet/gross-compensation`,
        method: 'GET',
        signal
    });
};
export const getGetPlanGrossCompensationQueryKey = ()=>{
    return [
        `/api/sponsor/pocet/gross-compensation`
    ];
};
export const getGetPlanGrossCompensationQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanGrossCompensationQueryKey();
    const queryFn = ({ signal })=>getPlanGrossCompensation(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanGrossCompensation = (options)=>{
    const queryOptions = getGetPlanGrossCompensationQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putPlanEmployeeGrossCompensation = (putPlanGrossCompensationBodyDto)=>{
    return client({
        url: `/api/sponsor/pocet/gross-compensation`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putPlanGrossCompensationBodyDto
    });
};
export const getPutPlanEmployeeGrossCompensationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putPlanEmployeeGrossCompensation(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutPlanEmployeeGrossCompensation = (options)=>{
    const mutationOptions = getPutPlanEmployeeGrossCompensationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getGrossCompensationTemplate = (params, signal)=>{
    return client({
        url: `/api/sponsor/pocet/gross-compensation/download/template`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetGrossCompensationTemplateQueryKey = (params)=>{
    return [
        `/api/sponsor/pocet/gross-compensation/download/template`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetGrossCompensationTemplateQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetGrossCompensationTemplateQueryKey(params);
    const queryFn = ({ signal })=>getGrossCompensationTemplate(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetGrossCompensationTemplate = (params, options)=>{
    const queryOptions = getGetGrossCompensationTemplateQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postPlanEmployeeGrossCompensationUpload = (postPlanGrossCompensationUploadBodyDto)=>{
    return client({
        url: `/api/sponsor/pocet/gross-compensation/upload`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postPlanGrossCompensationUploadBodyDto
    });
};
export const getPostPlanEmployeeGrossCompensationUploadMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postPlanEmployeeGrossCompensationUpload(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPlanEmployeeGrossCompensationUpload = (options)=>{
    const mutationOptions = getPostPlanEmployeeGrossCompensationUploadMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postPlanNonEmployeeOwner = (postPlanNonEmployeeOwnerBodyDto)=>{
    return client({
        url: `/api/sponsor/pocet/non-employee-owner`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postPlanNonEmployeeOwnerBodyDto
    });
};
export const getPostPlanNonEmployeeOwnerMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postPlanNonEmployeeOwner(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPlanNonEmployeeOwner = (options)=>{
    const mutationOptions = getPostPlanNonEmployeeOwnerMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPlanOfficers = (signal)=>{
    return client({
        url: `/api/sponsor/pocet/officers`,
        method: 'GET',
        signal
    });
};
export const getGetPlanOfficersQueryKey = ()=>{
    return [
        `/api/sponsor/pocet/officers`
    ];
};
export const getGetPlanOfficersQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanOfficersQueryKey();
    const queryFn = ({ signal })=>getPlanOfficers(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanOfficers = (options)=>{
    const queryOptions = getGetPlanOfficersQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putPlanOfficerStatus = (putPlanOfficersBodyDto)=>{
    return client({
        url: `/api/sponsor/pocet/officers`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putPlanOfficersBodyDto
    });
};
export const getPutPlanOfficerStatusMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putPlanOfficerStatus(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutPlanOfficerStatus = (options)=>{
    const mutationOptions = getPutPlanOfficerStatusMutationOptions(options);
    return useMutation(mutationOptions);
};
export const deletePlanOwner = (deletePlanOwnerBodyDto)=>{
    return client({
        url: `/api/sponsor/pocet/owners`,
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        data: deletePlanOwnerBodyDto
    });
};
export const getDeletePlanOwnerMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return deletePlanOwner(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeletePlanOwner = (options)=>{
    const mutationOptions = getDeletePlanOwnerMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPlanOwners = (signal)=>{
    return client({
        url: `/api/sponsor/pocet/owners`,
        method: 'GET',
        signal
    });
};
export const getGetPlanOwnersQueryKey = ()=>{
    return [
        `/api/sponsor/pocet/owners`
    ];
};
export const getGetPlanOwnersQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanOwnersQueryKey();
    const queryFn = ({ signal })=>getPlanOwners(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanOwners = (options)=>{
    const queryOptions = getGetPlanOwnersQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postPlanEmployeeOwner = (postPlanEmployeeOwnerBodyDto)=>{
    return client({
        url: `/api/sponsor/pocet/owners`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postPlanEmployeeOwnerBodyDto
    });
};
export const getPostPlanEmployeeOwnerMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postPlanEmployeeOwner(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPlanEmployeeOwner = (options)=>{
    const mutationOptions = getPostPlanEmployeeOwnerMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putPlanEmployeeOwner = (putPlanEmployeeOwnerBodyDto)=>{
    return client({
        url: `/api/sponsor/pocet/owners`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putPlanEmployeeOwnerBodyDto
    });
};
export const getPutPlanEmployeeOwnerMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putPlanEmployeeOwner(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutPlanEmployeeOwner = (options)=>{
    const mutationOptions = getPutPlanEmployeeOwnerMutationOptions(options);
    return useMutation(mutationOptions);
};
export const deletePlanOwnersFamily = (deletePlanOwnersFamilyBodyDto)=>{
    return client({
        url: `/api/sponsor/pocet/owners-family`,
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        data: deletePlanOwnersFamilyBodyDto
    });
};
export const getDeletePlanOwnersFamilyMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return deletePlanOwnersFamily(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeletePlanOwnersFamily = (options)=>{
    const mutationOptions = getDeletePlanOwnersFamilyMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPlanOwnersFamily = (params, signal)=>{
    return client({
        url: `/api/sponsor/pocet/owners-family`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPlanOwnersFamilyQueryKey = (params)=>{
    return [
        `/api/sponsor/pocet/owners-family`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPlanOwnersFamilyQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanOwnersFamilyQueryKey(params);
    const queryFn = ({ signal })=>getPlanOwnersFamily(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanOwnersFamily = (params, options)=>{
    const queryOptions = getGetPlanOwnersFamilyQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putPlanOwnersFamily = (putPlanOwnersFamilyBodyDto)=>{
    return client({
        url: `/api/sponsor/pocet/owners-family`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putPlanOwnersFamilyBodyDto
    });
};
export const getPutPlanOwnersFamilyMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putPlanOwnersFamily(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutPlanOwnersFamily = (options)=>{
    const mutationOptions = getPutPlanOwnersFamilyMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getTrackerDetails = (signal)=>{
    return client({
        url: `/api/sponsor/pocet/tracker`,
        method: 'GET',
        signal
    });
};
export const getGetTrackerDetailsQueryKey = ()=>{
    return [
        `/api/sponsor/pocet/tracker`
    ];
};
export const getGetTrackerDetailsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetTrackerDetailsQueryKey();
    const queryFn = ({ signal })=>getTrackerDetails(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetTrackerDetails = (options)=>{
    const queryOptions = getGetTrackerDetailsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postPriorProvider = ()=>{
    return client({
        url: `/api/sponsor/prior-provider`,
        method: 'POST'
    });
};
export const getPostPriorProviderMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postPriorProvider();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPriorProvider = (options)=>{
    const mutationOptions = getPostPriorProviderMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPriorProviders = (signal)=>{
    return client({
        url: `/api/sponsor/prior-providers`,
        method: 'GET',
        signal
    });
};
export const getGetPriorProvidersQueryKey = ()=>{
    return [
        `/api/sponsor/prior-providers`
    ];
};
export const getGetPriorProvidersQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPriorProvidersQueryKey();
    const queryFn = ({ signal })=>getPriorProviders(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPriorProviders = (options)=>{
    const queryOptions = getGetPriorProvidersQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getSponsorQuestionnaire = (signal)=>{
    return client({
        url: `/api/sponsor/questionnaire`,
        method: 'GET',
        signal
    });
};
export const getGetSponsorQuestionnaireQueryKey = ()=>{
    return [
        `/api/sponsor/questionnaire`
    ];
};
export const getGetSponsorQuestionnaireQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSponsorQuestionnaireQueryKey();
    const queryFn = ({ signal })=>getSponsorQuestionnaire(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSponsorQuestionnaire = (options)=>{
    const queryOptions = getGetSponsorQuestionnaireQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchSponsorQuestionnaire = (patchSponsorQuestionnaireDto)=>{
    return client({
        url: `/api/sponsor/questionnaire`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchSponsorQuestionnaireDto
    });
};
export const getPatchSponsorQuestionnaireMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchSponsorQuestionnaire(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchSponsorQuestionnaire = (options)=>{
    const mutationOptions = getPatchSponsorQuestionnaireMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getQuestionnaireInformation = (signal)=>{
    return client({
        url: `/api/sponsor/questionnaire-information`,
        method: 'GET',
        signal
    });
};
export const getGetQuestionnaireInformationQueryKey = ()=>{
    return [
        `/api/sponsor/questionnaire-information`
    ];
};
export const getGetQuestionnaireInformationQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetQuestionnaireInformationQueryKey();
    const queryFn = ({ signal })=>getQuestionnaireInformation(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetQuestionnaireInformation = (options)=>{
    const queryOptions = getGetQuestionnaireInformationQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getContributions = (signal)=>{
    return client({
        url: `/api/sponsor/sponsor-plan/contributions`,
        method: 'GET',
        signal
    });
};
export const getGetContributionsQueryKey = ()=>{
    return [
        `/api/sponsor/sponsor-plan/contributions`
    ];
};
export const getGetContributionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetContributionsQueryKey();
    const queryFn = ({ signal })=>getContributions(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetContributions = (options)=>{
    const queryOptions = getGetContributionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getSubaPlanDetails = (params, signal)=>{
    return client({
        url: `/api/sponsor/suba-plan-details`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetSubaPlanDetailsQueryKey = (params)=>{
    return [
        `/api/sponsor/suba-plan-details`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetSubaPlanDetailsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSubaPlanDetailsQueryKey(params);
    const queryFn = ({ signal })=>getSubaPlanDetails(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSubaPlanDetails = (params, options)=>{
    const queryOptions = getGetSubaPlanDetailsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getSubaTransactions = (params, signal)=>{
    return client({
        url: `/api/sponsor/suba-transactions`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetSubaTransactionsQueryKey = (params)=>{
    return [
        `/api/sponsor/suba-transactions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetSubaTransactionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSubaTransactionsQueryKey(params);
    const queryFn = ({ signal })=>getSubaTransactions(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSubaTransactions = (params, options)=>{
    const queryOptions = getGetSubaTransactionsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postYetCensusAutosave = (postYetCensusAutosaveBodyDto)=>{
    return client({
        url: `/api/sponsor/yet/census/autosave`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postYetCensusAutosaveBodyDto
    });
};
export const getPostYetCensusAutosaveMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postYetCensusAutosave(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostYetCensusAutosave = (options)=>{
    const mutationOptions = getPostYetCensusAutosaveMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getYetCensusDataDownload = (params, signal)=>{
    return client({
        url: `/api/sponsor/yet/census/download`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetYetCensusDataDownloadQueryKey = (params)=>{
    return [
        `/api/sponsor/yet/census/download`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetYetCensusDataDownloadQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetYetCensusDataDownloadQueryKey(params);
    const queryFn = ({ signal })=>getYetCensusDataDownload(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetYetCensusDataDownload = (params, options)=>{
    const queryOptions = getGetYetCensusDataDownloadQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getYetCensusDataPaged = (params, signal)=>{
    return client({
        url: `/api/sponsor/yet/census/paged`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetYetCensusDataPagedQueryKey = (params)=>{
    return [
        `/api/sponsor/yet/census/paged`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetYetCensusDataPagedQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetYetCensusDataPagedQueryKey(params);
    const queryFn = ({ signal })=>getYetCensusDataPaged(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetYetCensusDataPaged = (params, options)=>{
    const queryOptions = getGetYetCensusDataPagedQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postRefreshCensus = (postRestartCensusBodyDto)=>{
    return client({
        url: `/api/sponsor/yet/census/refresh`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postRestartCensusBodyDto
    });
};
export const getPostRefreshCensusMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postRefreshCensus(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostRefreshCensus = (options)=>{
    const mutationOptions = getPostRefreshCensusMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postRestartCensus = (postRestartCensusBodyDto)=>{
    return client({
        url: `/api/sponsor/yet/census/restart`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postRestartCensusBodyDto
    });
};
export const getPostRestartCensusMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postRestartCensus(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostRestartCensus = (options)=>{
    const mutationOptions = getPostRestartCensusMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postYetCensusStart = (yetCensusBodyDto)=>{
    return client({
        url: `/api/sponsor/yet/census/start`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: yetCensusBodyDto
    });
};
export const getPostYetCensusStartMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postYetCensusStart(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostYetCensusStart = (options)=>{
    const mutationOptions = getPostYetCensusStartMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getCensusStatus = (params, signal)=>{
    return client({
        url: `/api/sponsor/yet/census/status`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetCensusStatusQueryKey = (params)=>{
    return [
        `/api/sponsor/yet/census/status`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetCensusStatusQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCensusStatusQueryKey(params);
    const queryFn = ({ signal })=>getCensusStatus(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetCensusStatus = (params, options)=>{
    const queryOptions = getGetCensusStatusQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postYetCensusSubmit = (yetCensusBodyDto)=>{
    return client({
        url: `/api/sponsor/yet/census/submit`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: yetCensusBodyDto
    });
};
export const getPostYetCensusSubmitMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postYetCensusSubmit(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostYetCensusSubmit = (options)=>{
    const mutationOptions = getPostYetCensusSubmitMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postYetCensusUpload = (postYetCensusUploadBodyDto)=>{
    return client({
        url: `/api/sponsor/yet/census/upload`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postYetCensusUploadBodyDto
    });
};
export const getPostYetCensusUploadMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postYetCensusUpload(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostYetCensusUpload = (options)=>{
    const mutationOptions = getPostYetCensusUploadMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getYetChecklist = (params, signal)=>{
    return client({
        url: `/api/sponsor/yet/checklist`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetYetChecklistQueryKey = (params)=>{
    return [
        `/api/sponsor/yet/checklist`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetYetChecklistQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetYetChecklistQueryKey(params);
    const queryFn = ({ signal })=>getYetChecklist(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetYetChecklist = (params, options)=>{
    const queryOptions = getGetYetChecklistQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchYetChecklist = (patchYetChecklistBodyDto)=>{
    return client({
        url: `/api/sponsor/yet/checklist`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchYetChecklistBodyDto
    });
};
export const getPatchYetChecklistMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchYetChecklist(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchYetChecklist = (options)=>{
    const mutationOptions = getPatchYetChecklistMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getYetConfig = (signal)=>{
    return client({
        url: `/api/sponsor/yet/config`,
        method: 'GET',
        signal
    });
};
export const getGetYetConfigQueryKey = ()=>{
    return [
        `/api/sponsor/yet/config`
    ];
};
export const getGetYetConfigQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetYetConfigQueryKey();
    const queryFn = ({ signal })=>getYetConfig(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetYetConfig = (options)=>{
    const queryOptions = getGetYetConfigQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postContributionsFund = (yetDocumentIdBodyDto)=>{
    return client({
        url: `/api/sponsor/yet/contributions/fund`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: yetDocumentIdBodyDto
    });
};
export const getPostContributionsFundMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postContributionsFund(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostContributionsFund = (options)=>{
    const mutationOptions = getPostContributionsFundMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postContributionsRefund = (yetDocumentIdBodyDto)=>{
    return client({
        url: `/api/sponsor/yet/contributions/refund`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: yetDocumentIdBodyDto
    });
};
export const getPostContributionsRefundMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postContributionsRefund(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostContributionsRefund = (options)=>{
    const mutationOptions = getPostContributionsRefundMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getYetDocuments = (params, signal)=>{
    return client({
        url: `/api/sponsor/yet/documents`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetYetDocumentsQueryKey = (params)=>{
    return [
        `/api/sponsor/yet/documents`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetYetDocumentsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetYetDocumentsQueryKey(params);
    const queryFn = ({ signal })=>getYetDocuments(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetYetDocuments = (params, options)=>{
    const queryOptions = getGetYetDocumentsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postStartOfPackaging = (getYetChecklistQueryDto)=>{
    return client({
        url: `/api/sponsor/yet/packaging/start`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: getYetChecklistQueryDto
    });
};
export const getPostStartOfPackagingMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postStartOfPackaging(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostStartOfPackaging = (options)=>{
    const mutationOptions = getPostStartOfPackagingMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPlanTestResults = (params, signal)=>{
    return client({
        url: `/api/sponsor/yet/plan-test-results`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPlanTestResultsQueryKey = (params)=>{
    return [
        `/api/sponsor/yet/plan-test-results`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPlanTestResultsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanTestResultsQueryKey(params);
    const queryFn = ({ signal })=>getPlanTestResults(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanTestResults = (params, options)=>{
    const queryOptions = getGetPlanTestResultsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getYetSponsorQuestionnaire = (params, signal)=>{
    return client({
        url: `/api/sponsor/yet/questionnaire`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetYetSponsorQuestionnaireQueryKey = (params)=>{
    return [
        `/api/sponsor/yet/questionnaire`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetYetSponsorQuestionnaireQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetYetSponsorQuestionnaireQueryKey(params);
    const queryFn = ({ signal })=>getYetSponsorQuestionnaire(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetYetSponsorQuestionnaire = (params, options)=>{
    const queryOptions = getGetYetSponsorQuestionnaireQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postYetSponsorQuestionnaire = (postYetQuestionnaireDto)=>{
    return client({
        url: `/api/sponsor/yet/questionnaire`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postYetQuestionnaireDto
    });
};
export const getPostYetSponsorQuestionnaireMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postYetSponsorQuestionnaire(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostYetSponsorQuestionnaire = (options)=>{
    const mutationOptions = getPostYetSponsorQuestionnaireMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postRestartTestingProcess = (postRestartTestingProcessBodyDto)=>{
    return client({
        url: `/api/sponsor/yet/restart`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postRestartTestingProcessBodyDto
    });
};
export const getPostRestartTestingProcessMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postRestartTestingProcess(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostRestartTestingProcess = (options)=>{
    const mutationOptions = getPostRestartTestingProcessMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getYetStatus = (params, signal)=>{
    return client({
        url: `/api/sponsor/yet/status`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetYetStatusQueryKey = (params)=>{
    return [
        `/api/sponsor/yet/status`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetYetStatusQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetYetStatusQueryKey(params);
    const queryFn = ({ signal })=>getYetStatus(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetYetStatus = (params, options)=>{
    const queryOptions = getGetYetStatusQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getYtdContributions = (signal)=>{
    return client({
        url: `/api/sponsor/ytd-contributions`,
        method: 'GET',
        signal
    });
};
export const getGetYtdContributionsQueryKey = ()=>{
    return [
        `/api/sponsor/ytd-contributions`
    ];
};
export const getGetYtdContributionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetYtdContributionsQueryKey();
    const queryFn = ({ signal })=>getYtdContributions(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetYtdContributions = (options)=>{
    const queryOptions = getGetYtdContributionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getTIAAIncomeProjection = (signal)=>{
    return client({
        url: `/api/tiaa/income-projection`,
        method: 'GET',
        signal
    });
};
export const getGetTIAAIncomeProjectionQueryKey = ()=>{
    return [
        `/api/tiaa/income-projection`
    ];
};
export const getGetTIAAIncomeProjectionQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetTIAAIncomeProjectionQueryKey();
    const queryFn = ({ signal })=>getTIAAIncomeProjection(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetTIAAIncomeProjection = (options)=>{
    const queryOptions = getGetTIAAIncomeProjectionQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchParticipantById = (patchParticipantBodyDto, params)=>{
    return client({
        url: `/api/v2/participant`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchParticipantBodyDto,
        params
    });
};
export const getPatchParticipantByIdMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data, params } = props ?? {};
        return patchParticipantById(data, params);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchParticipantById = (options)=>{
    const mutationOptions = getPatchParticipantByIdMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getParticipantBeneficiaries = (params, signal)=>{
    return client({
        url: `/api/v2/participant/beneficiaries`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetParticipantBeneficiariesQueryKey = (params)=>{
    return [
        `/api/v2/participant/beneficiaries`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantBeneficiariesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantBeneficiariesQueryKey(params);
    const queryFn = ({ signal })=>getParticipantBeneficiaries(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantBeneficiaries = (params, options)=>{
    const queryOptions = getGetParticipantBeneficiariesQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putParticipantBeneficiariesV2 = (putParticipantBeneficiariesV2Body)=>{
    return client({
        url: `/api/v2/participant/beneficiaries`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putParticipantBeneficiariesV2Body
    });
};
export const getPutParticipantBeneficiariesV2MutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putParticipantBeneficiariesV2(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutParticipantBeneficiariesV2 = (options)=>{
    const mutationOptions = getPutParticipantBeneficiariesV2MutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPlanByIdV2 = (params, signal)=>{
    return client({
        url: `/api/v2/plans`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPlanByIdV2QueryKey = (params)=>{
    return [
        `/api/v2/plans`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPlanByIdV2QueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanByIdV2QueryKey(params);
    const queryFn = ({ signal })=>getPlanByIdV2(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanByIdV2 = (params, options)=>{
    const queryOptions = getGetPlanByIdV2QueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getVestingSchedule = (params, signal)=>{
    return client({
        url: `/api/vesting/schedule`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetVestingScheduleQueryKey = (params)=>{
    return [
        `/api/vesting/schedule`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetVestingScheduleQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetVestingScheduleQueryKey(params);
    const queryFn = ({ signal })=>getVestingSchedule(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetVestingSchedule = (params, options)=>{
    const queryOptions = getGetVestingScheduleQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getVssPlanById = (planId, signal)=>{
    return client({
        url: `/api/vss/plans/${planId}`,
        method: 'GET',
        signal
    });
};
export const getGetVssPlanByIdQueryKey = (planId)=>{
    return [
        `/api/vss/plans/${planId}`
    ];
};
export const getGetVssPlanByIdQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetVssPlanByIdQueryKey(planId);
    const queryFn = ({ signal })=>getVssPlanById(planId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!planId,
        ...queryOptions
    };
};
export const useGetVssPlanById = (planId, options)=>{
    const queryOptions = getGetVssPlanByIdQueryOptions(planId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getVssStatus = (signal)=>{
    return client({
        url: `/api/vss/status`,
        method: 'GET',
        signal
    });
};
export const getGetVssStatusQueryKey = ()=>{
    return [
        `/api/vss/status`
    ];
};
export const getGetVssStatusQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetVssStatusQueryKey();
    const queryFn = ({ signal })=>getVssStatus(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetVssStatus = (options)=>{
    const queryOptions = getGetVssStatusQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postLobLetterEventsWebhook = ()=>{
    return client({
        url: `/api/webhooks/lob/letter-events`,
        method: 'POST'
    });
};
export const getPostLobLetterEventsWebhookMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postLobLetterEventsWebhook();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostLobLetterEventsWebhook = (options)=>{
    const mutationOptions = getPostLobLetterEventsWebhookMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getWhiteLabel = (signal)=>{
    return client({
        url: `/api/whitelabel`,
        method: 'GET',
        signal
    });
};
export const getGetWhiteLabelQueryKey = ()=>{
    return [
        `/api/whitelabel`
    ];
};
export const getGetWhiteLabelQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetWhiteLabelQueryKey();
    const queryFn = ({ signal })=>getWhiteLabel(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetWhiteLabel = (options)=>{
    const queryOptions = getGetWhiteLabelQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getWhiteLabelUnauthorized = (signal)=>{
    return client({
        url: `/api/whitelabel/unauthorized`,
        method: 'GET',
        signal
    });
};
export const getGetWhiteLabelUnauthorizedQueryKey = ()=>{
    return [
        `/api/whitelabel/unauthorized`
    ];
};
export const getGetWhiteLabelUnauthorizedQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetWhiteLabelUnauthorizedQueryKey();
    const queryFn = ({ signal })=>getWhiteLabelUnauthorized(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetWhiteLabelUnauthorized = (options)=>{
    const queryOptions = getGetWhiteLabelUnauthorizedQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postCreateWithdrawal = (postWithdrawalBodyDto)=>{
    return client({
        url: `/api/withdrawal`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postWithdrawalBodyDto
    });
};
export const getPostCreateWithdrawalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postCreateWithdrawal(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostCreateWithdrawal = (options)=>{
    const mutationOptions = getPostCreateWithdrawalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postWithdrawalIdentityVerification = (params)=>{
    return client({
        url: `/api/withdrawal/identity-verification`,
        method: 'POST',
        params
    });
};
export const getPostWithdrawalIdentityVerificationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { params } = props ?? {};
        return postWithdrawalIdentityVerification(params);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostWithdrawalIdentityVerification = (options)=>{
    const mutationOptions = getPostWithdrawalIdentityVerificationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getRmdAmount = (params, signal)=>{
    return client({
        url: `/api/withdrawal/rmd-amount`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetRmdAmountQueryKey = (params)=>{
    return [
        `/api/withdrawal/rmd-amount`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetRmdAmountQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRmdAmountQueryKey(params);
    const queryFn = ({ signal })=>getRmdAmount(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetRmdAmount = (params, options)=>{
    const queryOptions = getGetRmdAmountQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getRmdBalance = (params, signal)=>{
    return client({
        url: `/api/withdrawal/rmd-balance`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetRmdBalanceQueryKey = (params)=>{
    return [
        `/api/withdrawal/rmd-balance`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetRmdBalanceQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRmdBalanceQueryKey(params);
    const queryFn = ({ signal })=>getRmdBalance(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetRmdBalance = (params, options)=>{
    const queryOptions = getGetRmdBalanceQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getRolloverProviders = (signal)=>{
    return client({
        url: `/api/withdrawal/rollover-providers`,
        method: 'GET',
        signal
    });
};
export const getGetRolloverProvidersQueryKey = ()=>{
    return [
        `/api/withdrawal/rollover-providers`
    ];
};
export const getGetRolloverProvidersQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRolloverProvidersQueryKey();
    const queryFn = ({ signal })=>getRolloverProviders(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetRolloverProviders = (options)=>{
    const queryOptions = getGetRolloverProvidersQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getWithholding = (params, signal)=>{
    return client({
        url: `/api/withdrawal/withholding`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetWithholdingQueryKey = (params)=>{
    return [
        `/api/withdrawal/withholding`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetWithholdingQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetWithholdingQueryKey(params);
    const queryFn = ({ signal })=>getWithholding(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetWithholding = (params, options)=>{
    const queryOptions = getGetWithholdingQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getWithholdingDetail = (params, signal)=>{
    return client({
        url: `/api/withdrawal/withholding/total-estimate`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetWithholdingDetailQueryKey = (params)=>{
    return [
        `/api/withdrawal/withholding/total-estimate`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetWithholdingDetailQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetWithholdingDetailQueryKey(params);
    const queryFn = ({ signal })=>getWithholdingDetail(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetWithholdingDetail = (params, options)=>{
    const queryOptions = getGetWithholdingDetailQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getYetNaics = (signal)=>{
    return client({
        url: `/api/yet/naics`,
        method: 'GET',
        signal
    });
};
export const getGetYetNaicsQueryKey = ()=>{
    return [
        `/api/yet/naics`
    ];
};
export const getGetYetNaicsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetYetNaicsQueryKey();
    const queryFn = ({ signal })=>getYetNaics(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetYetNaics = (options)=>{
    const queryOptions = getGetYetNaicsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getZendeskJwt = (signal)=>{
    return client({
        url: `/api/zendesk/jwt`,
        method: 'GET',
        signal
    });
};
export const getGetZendeskJwtQueryKey = ()=>{
    return [
        `/api/zendesk/jwt`
    ];
};
export const getGetZendeskJwtQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetZendeskJwtQueryKey();
    const queryFn = ({ signal })=>getZendeskJwt(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetZendeskJwt = (options)=>{
    const queryOptions = getGetZendeskJwtQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEntitySession = (entity, signal)=>{
    return client({
        url: `/api/${entity}/session`,
        method: 'GET',
        signal
    });
};
export const getGetEntitySessionQueryKey = (entity)=>{
    return [
        `/api/${entity}/session`
    ];
};
export const getGetEntitySessionQueryOptions = (entity, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEntitySessionQueryKey(entity);
    const queryFn = ({ signal })=>getEntitySession(entity, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!entity,
        ...queryOptions
    };
};
export const useGetEntitySession = (entity, options)=>{
    const queryOptions = getGetEntitySessionQueryOptions(entity, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getGetAdvisorByIdResponseMock = (overrideResponse = {})=>({
        companyName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        email: faker.word.sample(),
        firmId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        firstName: faker.word.sample(),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        lastName: faker.word.sample(),
        phone: faker.word.sample(),
        ...overrideResponse
    });
export const getGetAdvisorByIdResponseMock200 = (overrideResponse = {})=>({
        companyName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        email: faker.word.sample(),
        firmId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        firstName: faker.word.sample(),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        lastName: faker.word.sample(),
        phone: faker.word.sample(),
        ...overrideResponse
    });
export const getGetAdvisorByIdResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorByIdResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorByIdResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorByIdResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorByIdResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorByIdResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorByIdResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorByIdResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorByIdResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorByIdResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorByIdResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorByIdResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorByIdResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorByIdResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorByIdResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorByIdResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorByIdResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorByIdResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorCommercialPlatformsResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            commercialPlatformId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            name: faker.word.sample(),
            navbar: faker.helpers.arrayElement([
                {
                    logo: {
                        desktop: faker.word.sample(),
                        mobile: faker.word.sample()
                    }
                },
                undefined
            ]),
            numberOfSponsorPlans: faker.number.int({
                min: undefined,
                max: undefined
            }),
            stats: {
                totalBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            subdomain: faker.word.sample()
        }));
export const getGetAdvisorCommercialPlatformsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            commercialPlatformId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            name: faker.word.sample(),
            navbar: faker.helpers.arrayElement([
                {
                    logo: {
                        desktop: faker.word.sample(),
                        mobile: faker.word.sample()
                    }
                },
                undefined
            ]),
            numberOfSponsorPlans: faker.number.int({
                min: undefined,
                max: undefined
            }),
            stats: {
                totalBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            subdomain: faker.word.sample()
        }));
export const getGetAdvisorCommercialPlatformsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorCommercialPlatformsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorCommercialPlatformsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorCommercialPlatformsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorCommercialPlatformsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorCommercialPlatformsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorCommercialPlatformsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorCommercialPlatformsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorCommercialPlatformsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorCommercialPlatformsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorCommercialPlatformsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorCommercialPlatformsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorCommercialPlatformsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorCommercialPlatformsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorCommercialPlatformsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorCommercialPlatformsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorCommercialPlatformsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorCommercialPlatformsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorContactCardResponseMock = (overrideResponse = {})=>({
        createdAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        displayName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        email: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        image: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isEnabled: faker.datatype.boolean(),
        note: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        phone: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        updatedAt: faker.word.sample(),
        ...overrideResponse
    });
export const getGetAdvisorContactCardResponseMock200 = (overrideResponse = {})=>({
        createdAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        displayName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        email: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        image: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isEnabled: faker.datatype.boolean(),
        note: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        phone: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        updatedAt: faker.word.sample(),
        ...overrideResponse
    });
export const getGetAdvisorContactCardResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorContactCardResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorContactCardResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorContactCardResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorContactCardResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorContactCardResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorContactCardResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorContactCardResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorContactCardResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorContactCardResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorContactCardResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorContactCardResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorContactCardResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorContactCardResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorContactCardResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorContactCardResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorContactCardResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorContactCardResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAdvisorContactCardResponseMock = (overrideResponse = {})=>({
        createdAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        displayName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        email: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        image: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isEnabled: faker.datatype.boolean(),
        note: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        phone: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        updatedAt: faker.word.sample(),
        ...overrideResponse
    });
export const getPutAdvisorContactCardResponseMock200 = (overrideResponse = {})=>({
        createdAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        displayName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        email: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        image: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isEnabled: faker.datatype.boolean(),
        note: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        phone: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        updatedAt: faker.word.sample(),
        ...overrideResponse
    });
export const getPutAdvisorContactCardResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAdvisorContactCardResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAdvisorContactCardResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAdvisorContactCardResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAdvisorContactCardResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAdvisorContactCardResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAdvisorContactCardResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAdvisorContactCardResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAdvisorContactCardResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAdvisorContactCardResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAdvisorContactCardResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAdvisorContactCardResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAdvisorContactCardResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAdvisorContactCardResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAdvisorContactCardResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAdvisorContactCardResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAdvisorContactCardResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAdvisorContactCardResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlansResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                attributes: {
                    effectiveDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    eligibleParticipants: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    employeeBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    employerBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    forfeitureBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    hasPriorLoans: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    inboundBlackoutEndDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    inboundBlackoutStartDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isActive: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    isBlackout: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    isOffboardingBlackoutActive: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    loanBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    name: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    offboardingBlackoutEndDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    offboardingBlackoutStartDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    participantsWithBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    participantsWithDeferrals: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    readyToEnrollParticipants: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    recordkeeper: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    registeredParticipants: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    rolloverBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    sponsorCompanyName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    statefulSchemaTrackingState: faker.helpers.arrayElement([
                        {
                            attributes: faker.helpers.arrayElement([
                                {
                                    createdAt: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    status: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    updatedAt: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    status: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    totalBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    type: faker.helpers.arrayElement([
                        {},
                        undefined
                    ])
                },
                id: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                relationships: {
                    advisor: faker.helpers.arrayElement([
                        {
                            data: faker.helpers.arrayElement([
                                {
                                    id: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    name: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    type: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    firm: faker.helpers.arrayElement([
                        {
                            data: faker.helpers.arrayElement([
                                {
                                    id: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    name: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    type: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    program: faker.helpers.arrayElement([
                        {
                            data: faker.helpers.arrayElement([
                                {
                                    id: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    name: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    type: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    sponsor: faker.helpers.arrayElement([
                        {
                            data: faker.helpers.arrayElement([
                                {
                                    id: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    name: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    type: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    tpa: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                data: faker.helpers.arrayElement([
                                    {
                                        id: faker.helpers.arrayElement([
                                            faker.number.int({
                                                min: undefined,
                                                max: undefined
                                            }),
                                            undefined
                                        ]),
                                        name: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        type: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ])
                                    },
                                    undefined
                                ])
                            })),
                        undefined
                    ])
                }
            })),
        ...overrideResponse
    });
export const getGetPlansResponseMock200 = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                attributes: {
                    effectiveDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    eligibleParticipants: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    employeeBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    employerBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    forfeitureBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    hasPriorLoans: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    inboundBlackoutEndDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    inboundBlackoutStartDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isActive: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    isBlackout: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    isOffboardingBlackoutActive: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    loanBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    name: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    offboardingBlackoutEndDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    offboardingBlackoutStartDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    participantsWithBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    participantsWithDeferrals: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    readyToEnrollParticipants: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    recordkeeper: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    registeredParticipants: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    rolloverBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    sponsorCompanyName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    statefulSchemaTrackingState: faker.helpers.arrayElement([
                        {
                            attributes: faker.helpers.arrayElement([
                                {
                                    createdAt: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    status: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    updatedAt: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    status: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    totalBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    type: faker.helpers.arrayElement([
                        {},
                        undefined
                    ])
                },
                id: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                relationships: {
                    advisor: faker.helpers.arrayElement([
                        {
                            data: faker.helpers.arrayElement([
                                {
                                    id: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    name: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    type: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    firm: faker.helpers.arrayElement([
                        {
                            data: faker.helpers.arrayElement([
                                {
                                    id: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    name: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    type: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    program: faker.helpers.arrayElement([
                        {
                            data: faker.helpers.arrayElement([
                                {
                                    id: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    name: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    type: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    sponsor: faker.helpers.arrayElement([
                        {
                            data: faker.helpers.arrayElement([
                                {
                                    id: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    name: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    type: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    tpa: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                data: faker.helpers.arrayElement([
                                    {
                                        id: faker.helpers.arrayElement([
                                            faker.number.int({
                                                min: undefined,
                                                max: undefined
                                            }),
                                            undefined
                                        ]),
                                        name: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        type: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ])
                                    },
                                    undefined
                                ])
                            })),
                        undefined
                    ])
                }
            })),
        ...overrideResponse
    });
export const getGetPlansResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlansResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlansResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlansResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlansResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlansResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlansResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlansResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlansResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlansResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlansResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlansResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlansResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlansResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlansResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlansResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlansResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlansResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorAnnualTestingPlansPerYearResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                hasNoOfficers: faker.datatype.boolean(),
                hasNoOwners: faker.datatype.boolean(),
                name: faker.word.sample(),
                officersCompleted: faker.datatype.boolean(),
                ownersCompleted: faker.datatype.boolean(),
                packagingCompleted: faker.datatype.boolean(),
                planName: faker.word.sample(),
                processEvents: Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>({
                        createdAt: faker.word.sample(),
                        eventName: faker.word.sample(),
                        processEventId: faker.number.int({
                            min: undefined,
                            max: undefined
                        })
                    })),
                processId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                questionnaireCompleted: faker.datatype.boolean(),
                sponsorPlanId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                sponsorYearEndChecklistId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                year: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                yearEndCensusCompleted: faker.datatype.boolean()
            })),
        meta: {
            count: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        ...overrideResponse
    });
export const getGetAdvisorAnnualTestingPlansPerYearResponseMock200 = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                hasNoOfficers: faker.datatype.boolean(),
                hasNoOwners: faker.datatype.boolean(),
                name: faker.word.sample(),
                officersCompleted: faker.datatype.boolean(),
                ownersCompleted: faker.datatype.boolean(),
                packagingCompleted: faker.datatype.boolean(),
                planName: faker.word.sample(),
                processEvents: Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>({
                        createdAt: faker.word.sample(),
                        eventName: faker.word.sample(),
                        processEventId: faker.number.int({
                            min: undefined,
                            max: undefined
                        })
                    })),
                processId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                questionnaireCompleted: faker.datatype.boolean(),
                sponsorPlanId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                sponsorYearEndChecklistId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                year: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                yearEndCensusCompleted: faker.datatype.boolean()
            })),
        meta: {
            count: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        ...overrideResponse
    });
export const getGetAdvisorAnnualTestingPlansPerYearResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorAnnualTestingPlansPerYearResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorAnnualTestingPlansPerYearResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorAnnualTestingPlansPerYearResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorAnnualTestingPlansPerYearResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorAnnualTestingPlansPerYearResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorAnnualTestingPlansPerYearResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorAnnualTestingPlansPerYearResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorAnnualTestingPlansPerYearResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorAnnualTestingPlansPerYearResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorAnnualTestingPlansPerYearResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorAnnualTestingPlansPerYearResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorAnnualTestingPlansPerYearResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorAnnualTestingPlansPerYearResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorAnnualTestingPlansPerYearResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorAnnualTestingPlansPerYearResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorAnnualTestingPlansPerYearResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorAnnualTestingPlansPerYearResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorPlanStatisticsResponseMock = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            {
                attributes: faker.helpers.arrayElement([
                    {
                        accountBalance: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        cashBalanceInterestRate: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        contributingAvgDeferralRatePct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        currentPositionsEmployee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        currentPositionsEmployer: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        currentPositionsLoan: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        currentPositionsRollover: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        eligibleParticipants: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        eligibleParticipantsWithBeneficiary: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        eligiblesAvgDeferralRatePct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        employedParticipants: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        modelAgeDistributions: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    min: 1,
                                    max: 10
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    ageRange: faker.helpers.arrayElement([
                                        {},
                                        undefined
                                    ]),
                                    balance: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    modelId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    modelName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    modelType: faker.helpers.arrayElement([
                                        {},
                                        undefined
                                    ]),
                                    participantsInModel: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        modelDistributions: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    min: 1,
                                    max: 10
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    balance: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    factsheet: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    modelId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    modelName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    modelType: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    participantsInModel: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    viewName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        mostRecentEmployeeContribution: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        mostRecentEmployerContribution: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        mostRecentLoanContribution: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        nextPayrollDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        participantsWithBalance: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        participantsWithBeneficiary: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        participantsWithDeferrals: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        participationRate: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        readyToEnrollParticipants: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        registeredParticipants: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        terminatedParticipantsWithBalance: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        totalContribution: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        totalParticipants: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        totalPlanMarketValue: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                type: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getGetAdvisorPlanStatisticsResponseMock200 = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            {
                attributes: faker.helpers.arrayElement([
                    {
                        accountBalance: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        cashBalanceInterestRate: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        contributingAvgDeferralRatePct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        currentPositionsEmployee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        currentPositionsEmployer: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        currentPositionsLoan: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        currentPositionsRollover: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        eligibleParticipants: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        eligibleParticipantsWithBeneficiary: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        eligiblesAvgDeferralRatePct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        employedParticipants: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        modelAgeDistributions: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    min: 1,
                                    max: 10
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    ageRange: faker.helpers.arrayElement([
                                        {},
                                        undefined
                                    ]),
                                    balance: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    modelId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    modelName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    modelType: faker.helpers.arrayElement([
                                        {},
                                        undefined
                                    ]),
                                    participantsInModel: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        modelDistributions: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    min: 1,
                                    max: 10
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    balance: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    factsheet: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    modelId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    modelName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    modelType: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    participantsInModel: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    viewName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        mostRecentEmployeeContribution: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        mostRecentEmployerContribution: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        mostRecentLoanContribution: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        nextPayrollDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        participantsWithBalance: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        participantsWithBeneficiary: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        participantsWithDeferrals: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        participationRate: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        readyToEnrollParticipants: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        registeredParticipants: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        terminatedParticipantsWithBalance: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        totalContribution: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        totalParticipants: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        totalPlanMarketValue: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                type: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getGetAdvisorPlanStatisticsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorPlanStatisticsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorPlanStatisticsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorPlanStatisticsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorPlanStatisticsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorPlanStatisticsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorPlanStatisticsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorPlanStatisticsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorPlanStatisticsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorPlanStatisticsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorPlanStatisticsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorPlanStatisticsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorPlanStatisticsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorPlanStatisticsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorPlanStatisticsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorPlanStatisticsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorPlanStatisticsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorPlanStatisticsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLinkSponsorResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLinkSponsorResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLinkSponsorResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLinkSponsorResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLinkSponsorResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLinkSponsorResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLinkSponsorResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLinkSponsorResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLinkSponsorResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLinkSponsorResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLinkSponsorResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLinkSponsorResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLinkSponsorResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLinkSponsorResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLinkSponsorResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLinkSponsorResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLinkSponsorResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLinkSponsorResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorStatsResponseMock = (overrideResponse = {})=>({
        eligibleParticipants: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participantsWithBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participantsWithDeferrals: faker.number.int({
            min: undefined,
            max: undefined
        }),
        totalBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        totalPlans: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorStatsResponseMock200 = (overrideResponse = {})=>({
        eligibleParticipants: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participantsWithBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participantsWithDeferrals: faker.number.int({
            min: undefined,
            max: undefined
        }),
        totalBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        totalPlans: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorStatsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorStatsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorStatsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorStatsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorStatsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorStatsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorStatsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorStatsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorStatsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorStatsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorStatsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorStatsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorStatsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorStatsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorStatsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorStatsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorStatsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorStatsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCarouselResponseMock = (overrideResponse = {})=>({
        esaItems: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    alt: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    path: faker.word.sample(),
                    pdf: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            undefined
        ]),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        items: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    alt: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    path: faker.word.sample(),
                    pdf: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetCarouselResponseMock200 = (overrideResponse = {})=>({
        esaItems: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    alt: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    path: faker.word.sample(),
                    pdf: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            undefined
        ]),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        items: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    alt: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    path: faker.word.sample(),
                    pdf: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetCarouselResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCarouselResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCarouselResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCarouselResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCarouselResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCarouselResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCarouselResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCarouselResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCarouselResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCarouselResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCarouselResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCarouselResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCarouselResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCarouselResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCarouselResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCarouselResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCarouselResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCarouselResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetConnectivityResponseMock = (overrideResponse = {})=>({
        details: faker.helpers.arrayElement([
            {
                [faker.string.alphanumeric(5)]: {
                    status: faker.word.sample()
                }
            },
            undefined
        ]),
        error: faker.helpers.arrayElement([
            {
                [faker.string.alphanumeric(5)]: {
                    status: faker.word.sample()
                }
            },
            undefined
        ]),
        info: faker.helpers.arrayElement([
            {
                [faker.string.alphanumeric(5)]: {
                    status: faker.word.sample()
                }
            },
            undefined
        ]),
        status: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetConnectivityResponseMock200 = (overrideResponse = {})=>({
        details: faker.helpers.arrayElement([
            {
                [faker.string.alphanumeric(5)]: {
                    status: faker.word.sample()
                }
            },
            undefined
        ]),
        error: faker.helpers.arrayElement([
            {
                [faker.string.alphanumeric(5)]: {
                    status: faker.word.sample()
                }
            },
            undefined
        ]),
        info: faker.helpers.arrayElement([
            {
                [faker.string.alphanumeric(5)]: {
                    status: faker.word.sample()
                }
            },
            undefined
        ]),
        status: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetConnectivityResponseMock503 = (overrideResponse = {})=>({
        details: faker.helpers.arrayElement([
            {
                [faker.string.alphanumeric(5)]: {
                    status: faker.word.sample()
                }
            },
            undefined
        ]),
        error: faker.helpers.arrayElement([
            {
                [faker.string.alphanumeric(5)]: {
                    status: faker.word.sample()
                }
            },
            undefined
        ]),
        info: faker.helpers.arrayElement([
            {
                [faker.string.alphanumeric(5)]: {
                    status: faker.word.sample()
                }
            },
            undefined
        ]),
        status: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetCsmResponseMock = (overrideResponse = {})=>({
        createdAt: faker.word.sample(),
        csmId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        email: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        name: faker.word.sample(),
        phoneNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetCsmResponseMock200 = (overrideResponse = {})=>({
        createdAt: faker.word.sample(),
        csmId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        email: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        name: faker.word.sample(),
        phoneNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetCsmResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCsmResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCsmResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCsmResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCsmResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCsmResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCsmResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCsmResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCsmResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCsmResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCsmResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCsmResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCsmResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCsmResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCsmResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCsmResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCsmResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCsmResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureResponseMock = (overrideResponse = {})=>({
        document: faker.word.sample(),
        ...overrideResponse
    });
export const getGetLoginDisclosureResponseMock200 = (overrideResponse = {})=>({
        document: faker.word.sample(),
        ...overrideResponse
    });
export const getGetLoginDisclosureResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutLoginDisclosureResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutLoginDisclosureResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutLoginDisclosureResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutLoginDisclosureResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutLoginDisclosureResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutLoginDisclosureResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutLoginDisclosureResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutLoginDisclosureResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutLoginDisclosureResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutLoginDisclosureResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutLoginDisclosureResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutLoginDisclosureResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutLoginDisclosureResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutLoginDisclosureResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutLoginDisclosureResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutLoginDisclosureResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutLoginDisclosureResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutLoginDisclosureResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureAgreementResponseMock = (overrideResponse = {})=>({
        isAccepted: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getGetLoginDisclosureAgreementResponseMock200 = (overrideResponse = {})=>({
        isAccepted: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getGetLoginDisclosureAgreementResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureAgreementResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureAgreementResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureAgreementResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureAgreementResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureAgreementResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureAgreementResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureAgreementResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureAgreementResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureAgreementResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureAgreementResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureAgreementResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureAgreementResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureAgreementResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureAgreementResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureAgreementResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureAgreementResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoginDisclosureAgreementResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllDocumentsResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            createdAt: faker.word.sample(),
            documentKey: faker.word.sample(),
            entity: faker.word.sample(),
            entityId: faker.word.sample(),
            etag: faker.word.sample(),
            groupDetails: faker.helpers.arrayElement([
                {
                    effectiveDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    groupId: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    id: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    uploadHistoryId: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ])
                },
                undefined
            ]),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            isDraft: faker.datatype.boolean(),
            isEnabled: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            originalFileName: faker.word.sample(),
            uploadPath: faker.word.sample()
        }));
export const getGetAllDocumentsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            createdAt: faker.word.sample(),
            documentKey: faker.word.sample(),
            entity: faker.word.sample(),
            entityId: faker.word.sample(),
            etag: faker.word.sample(),
            groupDetails: faker.helpers.arrayElement([
                {
                    effectiveDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    groupId: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    id: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    uploadHistoryId: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ])
                },
                undefined
            ]),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            isDraft: faker.datatype.boolean(),
            isEnabled: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            originalFileName: faker.word.sample(),
            uploadPath: faker.word.sample()
        }));
export const getGetAllDocumentsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllDocumentsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllDocumentsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllDocumentsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllDocumentsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllDocumentsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllDocumentsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllDocumentsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllDocumentsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllDocumentsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllDocumentsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllDocumentsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllDocumentsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllDocumentsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllDocumentsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllDocumentsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllDocumentsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllDocumentsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAgreementResponseMock = (overrideResponse = {})=>({
        date: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isAccepted: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getGetDocumentAgreementResponseMock200 = (overrideResponse = {})=>({
        date: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isAccepted: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getGetDocumentAgreementResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAgreementResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAgreementResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAgreementResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAgreementResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAgreementResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAgreementResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAgreementResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAgreementResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAgreementResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAgreementResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAgreementResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAgreementResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAgreementResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAgreementResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAgreementResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAgreementResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAgreementResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDocumentAgreementResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDocumentAgreementResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDocumentAgreementResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDocumentAgreementResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDocumentAgreementResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDocumentAgreementResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDocumentAgreementResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDocumentAgreementResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDocumentAgreementResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDocumentAgreementResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDocumentAgreementResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDocumentAgreementResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDocumentAgreementResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDocumentAgreementResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDocumentAgreementResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDocumentAgreementResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDocumentAgreementResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDocumentAgreementResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAsHtmlResponseMock = (overrideResponse = {})=>({
        document: faker.word.sample(),
        documentId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        originalFileName: faker.word.sample(),
        ...overrideResponse
    });
export const getGetDocumentAsHtmlResponseMock200 = (overrideResponse = {})=>({
        document: faker.word.sample(),
        documentId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        originalFileName: faker.word.sample(),
        ...overrideResponse
    });
export const getGetDocumentAsHtmlResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAsHtmlResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAsHtmlResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAsHtmlResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAsHtmlResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAsHtmlResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAsHtmlResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAsHtmlResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAsHtmlResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAsHtmlResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAsHtmlResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAsHtmlResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAsHtmlResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAsHtmlResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAsHtmlResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAsHtmlResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAsHtmlResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAsHtmlResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDocumentAsHtmlAndDownloadResponseMock = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getGetDocumentAsHtmlAndDownloadResponseMock200 = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getPostPdfResponseMock = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getPostPdfResponseMock200 = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getPostProcessDocumentResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({})),
        headers: {},
        ...overrideResponse
    });
export const getPostProcessDocumentResponseMock200 = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({})),
        headers: {},
        ...overrideResponse
    });
export const getPostProcessDocumentResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostProcessDocumentResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostProcessDocumentResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostProcessDocumentResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostProcessDocumentResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostProcessDocumentResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostProcessDocumentResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostProcessDocumentResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostProcessDocumentResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostProcessDocumentResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostProcessDocumentResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostProcessDocumentResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostProcessDocumentResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostProcessDocumentResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostProcessDocumentResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostProcessDocumentResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostProcessDocumentResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostProcessDocumentResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEmailResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEmailResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEmailResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEmailResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEmailResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEmailResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEmailResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEmailResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEmailResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEmailResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEmailResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEmailResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEmailResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEmailResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEmailResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEmailResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEmailResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEmailResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeHoldingsResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            assetAllocations: {
                bondNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                cashNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                otherNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                stockNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            assetClass: faker.word.sample(),
            balance: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            broadCategory: faker.word.sample(),
            category: faker.word.sample(),
            cusip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            expenseRatioPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            fiveYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            fiveYearPerformancePct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            id: faker.word.sample(),
            inceptionDate: faker.word.sample(),
            itdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            itdPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            name: faker.word.sample(),
            oneYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            oneYearPerformancePct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            performanceUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityType: faker.word.sample(),
            securityTypeName: faker.word.sample(),
            shareClass: faker.word.sample(),
            shares: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            tenYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            tenYearPerformancePct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            weightPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            ytdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            ytdPct: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetEmployeeHoldingsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            assetAllocations: {
                bondNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                cashNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                otherNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                stockNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            assetClass: faker.word.sample(),
            balance: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            broadCategory: faker.word.sample(),
            category: faker.word.sample(),
            cusip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            expenseRatioPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            fiveYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            fiveYearPerformancePct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            id: faker.word.sample(),
            inceptionDate: faker.word.sample(),
            itdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            itdPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            name: faker.word.sample(),
            oneYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            oneYearPerformancePct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            performanceUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityType: faker.word.sample(),
            securityTypeName: faker.word.sample(),
            shareClass: faker.word.sample(),
            shares: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            tenYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            tenYearPerformancePct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            weightPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            ytdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            ytdPct: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetEmployeeHoldingsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeHoldingsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeHoldingsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeHoldingsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeHoldingsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeHoldingsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeHoldingsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeHoldingsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeHoldingsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeHoldingsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeHoldingsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeHoldingsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeHoldingsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeHoldingsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeHoldingsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeHoldingsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeHoldingsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeHoldingsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoansResponseMock = (overrideResponse = {})=>({
        balanceOverview: faker.helpers.arrayElement([
            {
                loanAmountAvailable: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                loanOutstandingBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                sdbaBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                totalAccountBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                totalVestedBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            undefined
        ]),
        eligibilityStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        hasAccess: faker.datatype.boolean(),
        hasPendingWithdrawal: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        hasSdbaTransfersOut: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isAddressFraudRestricted: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isBlackout: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isEmailFraudRestricted: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isFraudRestricted: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isLoansAllowed: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        loanPreferences: faker.helpers.arrayElement([
            {
                attributes: faker.helpers.arrayElement([
                    {
                        allowedLoanPurposes: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    min: 1,
                                    max: 10
                                })
                            }, (_, i)=>i + 1).map(()=>({})),
                            undefined
                        ]),
                        allowedPayFrequencies: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    min: 1,
                                    max: 10
                                })
                            }, (_, i)=>i + 1).map(()=>({})),
                            undefined
                        ]),
                        maintenanceFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        maxOutstandingLoans: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        maxYearsResidencePurchase: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        originationFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        overnightCheckFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        wireFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                relationships: faker.helpers.arrayElement([
                    {
                        plan: faker.helpers.arrayElement([
                            {
                                data: faker.helpers.arrayElement([
                                    {
                                        id: faker.helpers.arrayElement([
                                            faker.number.int({
                                                min: undefined,
                                                max: undefined
                                            }),
                                            undefined
                                        ]),
                                        type: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ])
                                    },
                                    undefined
                                ])
                            },
                            undefined
                        ])
                    },
                    undefined
                ]),
                type: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        loanSummaries: faker.helpers.arrayElement([
            {
                fromAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                fromCreatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                fromOutstandingBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                fromStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                pageNumber: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                pageSize: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                'participant-id': faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                'plan-id': faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                sort: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                statuses: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                toAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                toCreatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                toOutstandingBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                toStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        planStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        recordkeeper: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetEmployeeLoansResponseMock200 = (overrideResponse = {})=>({
        balanceOverview: faker.helpers.arrayElement([
            {
                loanAmountAvailable: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                loanOutstandingBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                sdbaBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                totalAccountBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                totalVestedBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            undefined
        ]),
        eligibilityStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        hasAccess: faker.datatype.boolean(),
        hasPendingWithdrawal: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        hasSdbaTransfersOut: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isAddressFraudRestricted: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isBlackout: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isEmailFraudRestricted: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isFraudRestricted: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isLoansAllowed: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        loanPreferences: faker.helpers.arrayElement([
            {
                attributes: faker.helpers.arrayElement([
                    {
                        allowedLoanPurposes: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    min: 1,
                                    max: 10
                                })
                            }, (_, i)=>i + 1).map(()=>({})),
                            undefined
                        ]),
                        allowedPayFrequencies: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    min: 1,
                                    max: 10
                                })
                            }, (_, i)=>i + 1).map(()=>({})),
                            undefined
                        ]),
                        maintenanceFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        maxOutstandingLoans: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        maxYearsResidencePurchase: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        originationFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        overnightCheckFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        wireFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                relationships: faker.helpers.arrayElement([
                    {
                        plan: faker.helpers.arrayElement([
                            {
                                data: faker.helpers.arrayElement([
                                    {
                                        id: faker.helpers.arrayElement([
                                            faker.number.int({
                                                min: undefined,
                                                max: undefined
                                            }),
                                            undefined
                                        ]),
                                        type: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ])
                                    },
                                    undefined
                                ])
                            },
                            undefined
                        ])
                    },
                    undefined
                ]),
                type: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        loanSummaries: faker.helpers.arrayElement([
            {
                fromAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                fromCreatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                fromOutstandingBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                fromStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                pageNumber: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                pageSize: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                'participant-id': faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                'plan-id': faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                sort: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                statuses: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                toAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                toCreatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                toOutstandingBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                toStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        planStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        recordkeeper: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetEmployeeLoansResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoansResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoansResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoansResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoansResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoansResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoansResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoansResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoansResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoansResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoansResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoansResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoansResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoansResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoansResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoansResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoansResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoansResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelSecuritiesResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            assetAllocations: {
                bondNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                cashNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                otherNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                stockNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            assetClass: faker.word.sample(),
            broadCategory: faker.word.sample(),
            category: faker.word.sample(),
            cusip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            expenseRatioPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            fiveYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            fiveYearPerformancePct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            id: faker.word.sample(),
            inceptionDate: faker.word.sample(),
            itdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            itdPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            name: faker.word.sample(),
            oneYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            oneYearPerformancePct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            performanceUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityType: faker.word.sample(),
            securityTypeName: faker.word.sample(),
            shareClass: faker.word.sample(),
            targetPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            tenYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            tenYearPerformancePct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            weightPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            ytdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            ytdPct: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetProgramModelSecuritiesResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            assetAllocations: {
                bondNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                cashNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                otherNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                stockNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            assetClass: faker.word.sample(),
            broadCategory: faker.word.sample(),
            category: faker.word.sample(),
            cusip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            expenseRatioPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            fiveYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            fiveYearPerformancePct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            id: faker.word.sample(),
            inceptionDate: faker.word.sample(),
            itdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            itdPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            name: faker.word.sample(),
            oneYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            oneYearPerformancePct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            performanceUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityType: faker.word.sample(),
            securityTypeName: faker.word.sample(),
            shareClass: faker.word.sample(),
            targetPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            tenYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            tenYearPerformancePct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            weightPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            ytdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            ytdPct: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetProgramModelSecuritiesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelSecuritiesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelSecuritiesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelSecuritiesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelSecuritiesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelSecuritiesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelSecuritiesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelSecuritiesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelSecuritiesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelSecuritiesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelSecuritiesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelSecuritiesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelSecuritiesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelSecuritiesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelSecuritiesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelSecuritiesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelSecuritiesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelSecuritiesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoanDetailsResponseMock = (overrideResponse = {})=>({
        loan: {
            bankAccountInfo: faker.helpers.arrayElement([
                {
                    accountNumber: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    routingNumber: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            deliveryAddress: faker.helpers.arrayElement([
                {
                    address1: faker.word.sample(),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.word.sample(),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.word.sample(),
                    zip: faker.word.sample()
                },
                undefined
            ]),
            deliveryMethod: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            interestRate: faker.number.int({
                min: undefined,
                max: undefined
            }),
            isConversion: faker.datatype.boolean(),
            isSignedAgreement: faker.datatype.boolean(),
            loanAmount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            loanExpectedPayment: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    dueDate: faker.word.sample(),
                    id: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    interest: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    interestPaid: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    latestPaymentDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    loanId: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    paymentSequenceNumber: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    paymentStatus: faker.word.sample(),
                    principal: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    principalPaid: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    total: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    updatedAt: faker.word.sample()
                })),
            loanPurpose: faker.word.sample(),
            loanStatus: faker.word.sample(),
            maintenanceFee: faker.number.int({
                min: undefined,
                max: undefined
            }),
            nextPaymentDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            originationFee: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            outstandingPrincipalDue: faker.number.int({
                min: undefined,
                max: undefined
            }),
            overdueInterest: faker.number.int({
                min: undefined,
                max: undefined
            }),
            paymentFrequency: faker.word.sample(),
            promissoryNoteAcceptanceDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            purchaseSaleAgreementUploaded: faker.datatype.boolean(),
            remainingPaymentsCount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            repaymentYears: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        },
        loanPreferences: {
            allowLoans: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            allowResidencePurchaseExtension: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasPriorLoans: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            maintenanceFee: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            maxOutstandingLoans: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            maxYearsResidencePurchase: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            originationFee: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            overnightCheckFee: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            wireFee: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        },
        plan: {
            isBlackout: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            name: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            recordkeeper: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        sponsor: {
            activationDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyEntityType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyPhoneNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            dayToDayContactLastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            doingBusinessAs: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ein: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            fiscalYearEnd: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            hasOtherBusinesses: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isPartOfControlGroup: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            mailingAddress: faker.helpers.arrayElement([
                {
                    address1: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    zip: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            name: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            physicalAddress: faker.helpers.arrayElement([
                {
                    address1: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    zip: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            primaryContact: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    firstName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    lastName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    role: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            stateOfIncorporation: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            wiredAtWork: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ])
        },
        ...overrideResponse
    });
export const getGetEmployeeLoanDetailsResponseMock200 = (overrideResponse = {})=>({
        loan: {
            bankAccountInfo: faker.helpers.arrayElement([
                {
                    accountNumber: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    routingNumber: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            deliveryAddress: faker.helpers.arrayElement([
                {
                    address1: faker.word.sample(),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.word.sample(),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.word.sample(),
                    zip: faker.word.sample()
                },
                undefined
            ]),
            deliveryMethod: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            interestRate: faker.number.int({
                min: undefined,
                max: undefined
            }),
            isConversion: faker.datatype.boolean(),
            isSignedAgreement: faker.datatype.boolean(),
            loanAmount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            loanExpectedPayment: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    dueDate: faker.word.sample(),
                    id: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    interest: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    interestPaid: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    latestPaymentDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    loanId: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    paymentSequenceNumber: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    paymentStatus: faker.word.sample(),
                    principal: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    principalPaid: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    total: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    updatedAt: faker.word.sample()
                })),
            loanPurpose: faker.word.sample(),
            loanStatus: faker.word.sample(),
            maintenanceFee: faker.number.int({
                min: undefined,
                max: undefined
            }),
            nextPaymentDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            originationFee: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            outstandingPrincipalDue: faker.number.int({
                min: undefined,
                max: undefined
            }),
            overdueInterest: faker.number.int({
                min: undefined,
                max: undefined
            }),
            paymentFrequency: faker.word.sample(),
            promissoryNoteAcceptanceDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            purchaseSaleAgreementUploaded: faker.datatype.boolean(),
            remainingPaymentsCount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            repaymentYears: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        },
        loanPreferences: {
            allowLoans: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            allowResidencePurchaseExtension: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasPriorLoans: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            maintenanceFee: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            maxOutstandingLoans: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            maxYearsResidencePurchase: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            originationFee: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            overnightCheckFee: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            wireFee: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        },
        plan: {
            isBlackout: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            name: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            recordkeeper: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        sponsor: {
            activationDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyEntityType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyPhoneNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            dayToDayContactLastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            doingBusinessAs: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ein: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            fiscalYearEnd: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            hasOtherBusinesses: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isPartOfControlGroup: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            mailingAddress: faker.helpers.arrayElement([
                {
                    address1: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    zip: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            name: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            physicalAddress: faker.helpers.arrayElement([
                {
                    address1: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    zip: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            primaryContact: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    firstName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    lastName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    role: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            stateOfIncorporation: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            wiredAtWork: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ])
        },
        ...overrideResponse
    });
export const getGetEmployeeLoanDetailsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoanDetailsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoanDetailsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoanDetailsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoanDetailsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoanDetailsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoanDetailsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoanDetailsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoanDetailsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoanDetailsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoanDetailsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoanDetailsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoanDetailsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoanDetailsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoanDetailsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoanDetailsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoanDetailsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeLoanDetailsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaParticipantGoalResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaParticipantGoalResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaParticipantGoalResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaParticipantGoalResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaParticipantGoalResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaParticipantGoalResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaParticipantGoalResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaParticipantGoalResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaParticipantGoalResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaParticipantGoalResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaParticipantGoalResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaParticipantGoalResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaParticipantGoalResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaParticipantGoalResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaParticipantGoalResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaParticipantGoalResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaParticipantGoalResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaParticipantGoalResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantGoalsResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            createdAt: faker.word.sample(),
            goalAmount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            name: faker.word.sample(),
            participantId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            priority: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        }));
export const getGetEsaParticipantGoalsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            createdAt: faker.word.sample(),
            goalAmount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            name: faker.word.sample(),
            participantId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            priority: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        }));
export const getGetEsaParticipantGoalsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantGoalsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantGoalsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantGoalsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantGoalsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantGoalsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantGoalsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantGoalsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantGoalsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantGoalsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantGoalsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantGoalsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantGoalsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantGoalsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantGoalsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantGoalsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantGoalsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantGoalsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantIncentivesResponseMock = (overrideResponse = {})=>({
        employerMatch: {
            dollarCap: faker.number.int({
                min: undefined,
                max: undefined
            }),
            lifetimeCap: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        initialBonusAmount: faker.number.int({
            min: undefined,
            max: undefined
        }),
        initialBonusMinimum: faker.number.int({
            min: undefined,
            max: undefined
        }),
        milestoneBonus: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                bonusAmount: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                bonusThreshold: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        ...overrideResponse
    });
export const getGetEsaParticipantIncentivesResponseMock200 = (overrideResponse = {})=>({
        employerMatch: {
            dollarCap: faker.number.int({
                min: undefined,
                max: undefined
            }),
            lifetimeCap: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        initialBonusAmount: faker.number.int({
            min: undefined,
            max: undefined
        }),
        initialBonusMinimum: faker.number.int({
            min: undefined,
            max: undefined
        }),
        milestoneBonus: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                bonusAmount: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                bonusThreshold: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        ...overrideResponse
    });
export const getGetEsaParticipantIncentivesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantIncentivesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantIncentivesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantIncentivesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantIncentivesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantIncentivesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantIncentivesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantIncentivesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantIncentivesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantIncentivesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantIncentivesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantIncentivesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantIncentivesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantIncentivesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantIncentivesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantIncentivesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantIncentivesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaParticipantIncentivesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanCashInterestRateResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            cashInterestProgramId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            effectiveStartDate: faker.word.sample(),
            rate: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetEsaPlanCashInterestRateResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            cashInterestProgramId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            effectiveStartDate: faker.word.sample(),
            rate: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetEsaPlanCashInterestRateResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanCashInterestRateResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanCashInterestRateResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanCashInterestRateResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanCashInterestRateResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanCashInterestRateResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanCashInterestRateResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanCashInterestRateResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanCashInterestRateResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanCashInterestRateResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanCashInterestRateResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanCashInterestRateResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanCashInterestRateResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanCashInterestRateResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanCashInterestRateResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanCashInterestRateResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanCashInterestRateResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanCashInterestRateResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupBalanceOverTimeResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            balance: faker.number.int({
                min: undefined,
                max: undefined
            }),
            dateOf: faker.word.sample()
        }));
export const getGetEsaPlanGroupBalanceOverTimeResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            balance: faker.number.int({
                min: undefined,
                max: undefined
            }),
            dateOf: faker.word.sample()
        }));
export const getGetEsaPlanGroupBalanceOverTimeResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupBalanceOverTimeResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupBalanceOverTimeResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupBalanceOverTimeResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupBalanceOverTimeResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupBalanceOverTimeResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupBalanceOverTimeResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupBalanceOverTimeResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupBalanceOverTimeResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupBalanceOverTimeResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupBalanceOverTimeResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupBalanceOverTimeResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupBalanceOverTimeResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupBalanceOverTimeResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupBalanceOverTimeResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupBalanceOverTimeResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupBalanceOverTimeResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupBalanceOverTimeResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupStatsResponseMock = (overrideResponse = {})=>({
        averageSavingsRateDollars: faker.number.int({
            min: undefined,
            max: undefined
        }),
        averageSavingsRatePct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participantsAccessingSavings: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participatingParticipantsNumber: faker.number.int({
            min: undefined,
            max: undefined
        }),
        savingsRateDollarsParticipantsCount: faker.number.int({
            min: undefined,
            max: undefined
        }),
        savingsRatePctParticipantsCount: faker.number.int({
            min: undefined,
            max: undefined
        }),
        totalBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        totalParticipantsNumber: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupStatsResponseMock200 = (overrideResponse = {})=>({
        averageSavingsRateDollars: faker.number.int({
            min: undefined,
            max: undefined
        }),
        averageSavingsRatePct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participantsAccessingSavings: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participatingParticipantsNumber: faker.number.int({
            min: undefined,
            max: undefined
        }),
        savingsRateDollarsParticipantsCount: faker.number.int({
            min: undefined,
            max: undefined
        }),
        savingsRatePctParticipantsCount: faker.number.int({
            min: undefined,
            max: undefined
        }),
        totalBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        totalParticipantsNumber: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupStatsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupStatsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupStatsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupStatsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupStatsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupStatsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupStatsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupStatsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupStatsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupStatsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupStatsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupStatsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupStatsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupStatsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupStatsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupStatsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupStatsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupStatsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupsResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            description: faker.word.sample(),
            groupId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            initialBonus: faker.number.int({
                min: undefined,
                max: undefined
            }),
            initialBonusThreshold: faker.number.int({
                min: undefined,
                max: undefined
            }),
            match: {
                dollarAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                id: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                lifetimeAmount: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                percent: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            milestoneBonus: {
                amount: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                threshold: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            name: faker.word.sample(),
            participantCount: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetEsaPlanGroupsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            description: faker.word.sample(),
            groupId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            initialBonus: faker.number.int({
                min: undefined,
                max: undefined
            }),
            initialBonusThreshold: faker.number.int({
                min: undefined,
                max: undefined
            }),
            match: {
                dollarAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                id: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                lifetimeAmount: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                percent: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            milestoneBonus: {
                amount: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                threshold: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            name: faker.word.sample(),
            participantCount: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetEsaPlanGroupsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanIncentivesResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            allowInitialBonus: faker.datatype.boolean(),
            allowMatch: faker.datatype.boolean(),
            allowMilestoneBonus: faker.datatype.boolean(),
            bonusAmount: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            bonusThreshold: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            dollarCap: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            employeeGroupId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            initialBonusAmount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            initialBonusMinimum: faker.number.int({
                min: undefined,
                max: undefined
            }),
            lifetimeCap: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        }));
export const getGetEsaPlanIncentivesResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            allowInitialBonus: faker.datatype.boolean(),
            allowMatch: faker.datatype.boolean(),
            allowMilestoneBonus: faker.datatype.boolean(),
            bonusAmount: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            bonusThreshold: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            dollarCap: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            employeeGroupId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            initialBonusAmount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            initialBonusMinimum: faker.number.int({
                min: undefined,
                max: undefined
            }),
            lifetimeCap: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        }));
export const getGetEsaPlanIncentivesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanIncentivesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanIncentivesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanIncentivesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanIncentivesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanIncentivesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanIncentivesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanIncentivesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanIncentivesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanIncentivesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanIncentivesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanIncentivesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanIncentivesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanIncentivesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanIncentivesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanIncentivesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanIncentivesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanIncentivesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaWithdrawalResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaWithdrawalResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaWithdrawalResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaWithdrawalResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaWithdrawalResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaWithdrawalResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaWithdrawalResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaWithdrawalResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaWithdrawalResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaWithdrawalResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaWithdrawalResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaWithdrawalResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaWithdrawalResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaWithdrawalResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaWithdrawalResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaWithdrawalResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaWithdrawalResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchEsaWithdrawalResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesResponseMock = ()=>({
        [faker.string.alphanumeric(5)]: faker.datatype.boolean()
    });
export const getGetFeatureTogglesResponseMock200 = ()=>({
        [faker.string.alphanumeric(5)]: faker.datatype.boolean()
    });
export const getGetFeatureTogglesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesListResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            isExperiment: faker.datatype.boolean(),
            name: faker.word.sample(),
            variation: faker.helpers.arrayElement([
                {
                    id: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    name: faker.word.sample()
                },
                undefined
            ])
        }));
export const getGetFeatureTogglesListResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            isExperiment: faker.datatype.boolean(),
            name: faker.word.sample(),
            variation: faker.helpers.arrayElement([
                {
                    id: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    name: faker.word.sample()
                },
                undefined
            ])
        }));
export const getGetFeatureTogglesListResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesListResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesListResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesListResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesListResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesListResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesListResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesListResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesListResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesListResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesListResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesListResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesListResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesListResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesListResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesListResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesListResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesListResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFirmByIdResponseMock = (overrideResponse = {})=>({
        companyName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        contactName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        firmId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        firmType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        phoneNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        website: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetFirmByIdResponseMock200 = (overrideResponse = {})=>({
        companyName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        contactName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        firmId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        firmType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        phoneNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        website: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetFirmByIdResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFirmByIdResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFirmByIdResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFirmByIdResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFirmByIdResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFirmByIdResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFirmByIdResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFirmByIdResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFirmByIdResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFirmByIdResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFirmByIdResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFirmByIdResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFirmByIdResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFirmByIdResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFirmByIdResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFirmByIdResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFirmByIdResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFirmByIdResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecurringResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                accountId: faker.word.sample(),
                amount: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                bankAccountId: faker.word.sample(),
                correlationId: faker.word.sample(),
                customerId: faker.word.sample(),
                eventTriggerType: faker.word.sample(),
                frequency: faker.helpers.arrayElement([
                    faker.helpers.arrayElement([
                        'monthly',
                        'biMonthly',
                        'yearly'
                    ]),
                    undefined
                ]),
                id: faker.word.sample(),
                isDeactivated: faker.datatype.boolean(),
                isPaused: faker.datatype.boolean(),
                parameters: {
                    from: faker.word.sample(),
                    giftAccountId: faker.word.sample(),
                    giftBankAccountId: faker.word.sample(),
                    giftContributorId: faker.word.sample(),
                    isAnonymous: faker.datatype.boolean(),
                    occasion: faker.helpers.arrayElement([
                        'birthday',
                        'just-because',
                        'holiday',
                        'congratulations',
                        'graduation',
                        'get-well'
                    ])
                },
                planId: faker.word.sample()
            })),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getGetGiftContributorRecurringResponseMock200 = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                accountId: faker.word.sample(),
                amount: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                bankAccountId: faker.word.sample(),
                correlationId: faker.word.sample(),
                customerId: faker.word.sample(),
                eventTriggerType: faker.word.sample(),
                frequency: faker.helpers.arrayElement([
                    faker.helpers.arrayElement([
                        'monthly',
                        'biMonthly',
                        'yearly'
                    ]),
                    undefined
                ]),
                id: faker.word.sample(),
                isDeactivated: faker.datatype.boolean(),
                isPaused: faker.datatype.boolean(),
                parameters: {
                    from: faker.word.sample(),
                    giftAccountId: faker.word.sample(),
                    giftBankAccountId: faker.word.sample(),
                    giftContributorId: faker.word.sample(),
                    isAnonymous: faker.datatype.boolean(),
                    occasion: faker.helpers.arrayElement([
                        'birthday',
                        'just-because',
                        'holiday',
                        'congratulations',
                        'graduation',
                        'get-well'
                    ])
                },
                planId: faker.word.sample()
            })),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getGetGiftContributorRecurringResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecurringResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecurringResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecurringResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecurringResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecurringResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecurringResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecurringResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecurringResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecurringResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecurringResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecurringResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecurringResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecurringResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecurringResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecurringResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecurringResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecurringResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteGiftContributorRecurringResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteGiftContributorRecurringResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteGiftContributorRecurringResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteGiftContributorRecurringResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteGiftContributorRecurringResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteGiftContributorRecurringResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteGiftContributorRecurringResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteGiftContributorRecurringResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteGiftContributorRecurringResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteGiftContributorRecurringResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteGiftContributorRecurringResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteGiftContributorRecurringResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteGiftContributorRecurringResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteGiftContributorRecurringResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteGiftContributorRecurringResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteGiftContributorRecurringResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteGiftContributorRecurringResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteGiftContributorRecurringResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorBanksResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                accountId: faker.word.sample(),
                bankAccountNumber: faker.word.sample(),
                bankAccountType: faker.helpers.arrayElement([
                    'checking',
                    'savings',
                    'prepaid'
                ]),
                bankName: faker.word.sample(),
                createdDate: `${faker.date.past().toISOString().split('.')[0]}Z`,
                customerId: faker.word.sample(),
                deleted: faker.datatype.boolean(),
                giftContributorId: faker.word.sample(),
                id: faker.word.sample(),
                lastUpdated: faker.helpers.arrayElement([
                    `${faker.date.past().toISOString().split('.')[0]}Z`,
                    undefined
                ]),
                payInstructionId: faker.word.sample(),
                routingNumber: faker.word.sample()
            })),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getGetGiftContributorBanksResponseMock200 = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                accountId: faker.word.sample(),
                bankAccountNumber: faker.word.sample(),
                bankAccountType: faker.helpers.arrayElement([
                    'checking',
                    'savings',
                    'prepaid'
                ]),
                bankName: faker.word.sample(),
                createdDate: `${faker.date.past().toISOString().split('.')[0]}Z`,
                customerId: faker.word.sample(),
                deleted: faker.datatype.boolean(),
                giftContributorId: faker.word.sample(),
                id: faker.word.sample(),
                lastUpdated: faker.helpers.arrayElement([
                    `${faker.date.past().toISOString().split('.')[0]}Z`,
                    undefined
                ]),
                payInstructionId: faker.word.sample(),
                routingNumber: faker.word.sample()
            })),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getGetGiftContributorBanksResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorBanksResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorBanksResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorBanksResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorBanksResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorBanksResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorBanksResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorBanksResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorBanksResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorBanksResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorBanksResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorBanksResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorBanksResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorBanksResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorBanksResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorBanksResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorBanksResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorBanksResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorPaymentsResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                active: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                createdDate: `${faker.date.past().toISOString().split('.')[0]}Z`,
                disbursementId: faker.word.sample(),
                feeAmount: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                from: faker.word.sample(),
                giftAccountId: faker.word.sample(),
                giftBankId: faker.word.sample(),
                giftContributorEmail: faker.word.sample(),
                giftContributorId: faker.word.sample(),
                giftContributorPhone: faker.word.sample(),
                giftTransactionId: faker.word.sample(),
                grossAmount: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                id: faker.word.sample(),
                isAnonymous: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                lastUpdated: `${faker.date.past().toISOString().split('.')[0]}Z`,
                netAmount: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                occasion: {
                    id: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    name: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                postedDate: faker.helpers.arrayElement([
                    `${faker.date.past().toISOString().split('.')[0]}Z`,
                    undefined
                ]),
                recurringContributionsId: faker.word.sample(),
                theme: faker.word.sample()
            })),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getGetGiftContributorPaymentsResponseMock200 = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                active: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                createdDate: `${faker.date.past().toISOString().split('.')[0]}Z`,
                disbursementId: faker.word.sample(),
                feeAmount: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                from: faker.word.sample(),
                giftAccountId: faker.word.sample(),
                giftBankId: faker.word.sample(),
                giftContributorEmail: faker.word.sample(),
                giftContributorId: faker.word.sample(),
                giftContributorPhone: faker.word.sample(),
                giftTransactionId: faker.word.sample(),
                grossAmount: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                id: faker.word.sample(),
                isAnonymous: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                lastUpdated: `${faker.date.past().toISOString().split('.')[0]}Z`,
                netAmount: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                occasion: {
                    id: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    name: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                postedDate: faker.helpers.arrayElement([
                    `${faker.date.past().toISOString().split('.')[0]}Z`,
                    undefined
                ]),
                recurringContributionsId: faker.word.sample(),
                theme: faker.word.sample()
            })),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getGetGiftContributorPaymentsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorPaymentsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorPaymentsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorPaymentsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorPaymentsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorPaymentsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorPaymentsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorPaymentsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorPaymentsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorPaymentsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorPaymentsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorPaymentsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorPaymentsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorPaymentsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorPaymentsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorPaymentsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorPaymentsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorPaymentsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecipientsResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                deleted: faker.datatype.boolean(),
                encodedAccountId: faker.word.sample(),
                giftAccount: {
                    accountPublic: {
                        contributionHold: faker.datatype.boolean(),
                        firstName: faker.word.sample(),
                        goalPercentage: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        isActive: faker.datatype.boolean(),
                        planId: faker.word.sample(),
                        title: faker.word.sample()
                    },
                    giftAccount: {
                        accountId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        active: faker.datatype.boolean(),
                        assetId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        canAcceptMoreGifts: faker.datatype.boolean(),
                        contributions: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        deleted: faker.datatype.boolean(),
                        goalPercentage: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        hideGoal: faker.datatype.boolean(),
                        id: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        modeAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        pendingContribution: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        pendingContributionCount: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        planId: faker.word.sample(),
                        remainingBalance: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        shareUrl: faker.word.sample()
                    }
                },
                giftAccountId: faker.word.sample(),
                giftContributorId: faker.word.sample(),
                id: faker.word.sample()
            })),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getGetGiftContributorRecipientsResponseMock200 = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                deleted: faker.datatype.boolean(),
                encodedAccountId: faker.word.sample(),
                giftAccount: {
                    accountPublic: {
                        contributionHold: faker.datatype.boolean(),
                        firstName: faker.word.sample(),
                        goalPercentage: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        isActive: faker.datatype.boolean(),
                        planId: faker.word.sample(),
                        title: faker.word.sample()
                    },
                    giftAccount: {
                        accountId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        active: faker.datatype.boolean(),
                        assetId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        canAcceptMoreGifts: faker.datatype.boolean(),
                        contributions: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        deleted: faker.datatype.boolean(),
                        goalPercentage: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        hideGoal: faker.datatype.boolean(),
                        id: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        modeAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        pendingContribution: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        pendingContributionCount: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        planId: faker.word.sample(),
                        remainingBalance: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        shareUrl: faker.word.sample()
                    }
                },
                giftAccountId: faker.word.sample(),
                giftContributorId: faker.word.sample(),
                id: faker.word.sample()
            })),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getGetGiftContributorRecipientsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecipientsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecipientsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecipientsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecipientsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecipientsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecipientsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecipientsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecipientsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecipientsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecipientsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecipientsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecipientsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecipientsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecipientsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecipientsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecipientsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftContributorRecipientsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageAndAccountByIdResponseMock = (overrideResponse = {})=>({
        data: {
            accountPublic: {
                contributionHold: faker.datatype.boolean(),
                firstName: faker.word.sample(),
                goalPercentage: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                isActive: faker.datatype.boolean(),
                planId: faker.word.sample(),
                title: faker.word.sample()
            },
            giftAccount: {
                accountId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                active: faker.datatype.boolean(),
                assetId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                canAcceptMoreGifts: faker.datatype.boolean(),
                contributions: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                deleted: faker.datatype.boolean(),
                goalPercentage: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                hideGoal: faker.datatype.boolean(),
                id: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                modeAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                pendingContribution: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                pendingContributionCount: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                planId: faker.word.sample(),
                remainingBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                shareUrl: faker.word.sample()
            }
        },
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getGetGiftingPageAndAccountByIdResponseMock200 = (overrideResponse = {})=>({
        data: {
            accountPublic: {
                contributionHold: faker.datatype.boolean(),
                firstName: faker.word.sample(),
                goalPercentage: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                isActive: faker.datatype.boolean(),
                planId: faker.word.sample(),
                title: faker.word.sample()
            },
            giftAccount: {
                accountId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                active: faker.datatype.boolean(),
                assetId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                canAcceptMoreGifts: faker.datatype.boolean(),
                contributions: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                deleted: faker.datatype.boolean(),
                goalPercentage: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                hideGoal: faker.datatype.boolean(),
                id: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                modeAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                pendingContribution: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                pendingContributionCount: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                planId: faker.word.sample(),
                remainingBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                shareUrl: faker.word.sample()
            }
        },
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getGetGiftingPageAndAccountByIdResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageAndAccountByIdResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageAndAccountByIdResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageAndAccountByIdResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageAndAccountByIdResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageAndAccountByIdResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageAndAccountByIdResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageAndAccountByIdResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageAndAccountByIdResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageAndAccountByIdResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageAndAccountByIdResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageAndAccountByIdResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageAndAccountByIdResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageAndAccountByIdResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageAndAccountByIdResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageAndAccountByIdResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageAndAccountByIdResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageAndAccountByIdResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageByIdResponseMock = (overrideResponse = {})=>({
        data: {
            accountId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            active: faker.datatype.boolean(),
            assetId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            canAcceptMoreGifts: faker.datatype.boolean(),
            contributions: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            deleted: faker.datatype.boolean(),
            goalPercentage: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            hideGoal: faker.datatype.boolean(),
            id: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            modeAmount: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            pendingContribution: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            pendingContributionCount: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            planId: faker.word.sample(),
            remainingBalance: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            shareUrl: faker.word.sample()
        },
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getGetGiftingPageByIdResponseMock200 = (overrideResponse = {})=>({
        data: {
            accountId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            active: faker.datatype.boolean(),
            assetId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            canAcceptMoreGifts: faker.datatype.boolean(),
            contributions: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            deleted: faker.datatype.boolean(),
            goalPercentage: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            hideGoal: faker.datatype.boolean(),
            id: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            modeAmount: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            pendingContribution: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            pendingContributionCount: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            planId: faker.word.sample(),
            remainingBalance: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            shareUrl: faker.word.sample()
        },
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getGetGiftingPageByIdResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageByIdResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageByIdResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageByIdResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageByIdResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageByIdResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageByIdResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageByIdResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageByIdResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageByIdResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageByIdResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageByIdResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageByIdResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageByIdResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageByIdResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageByIdResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageByIdResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGiftingPageByIdResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateGiftorProfileResponseMock = (overrideResponse = {})=>({
        data: faker.word.sample(),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPostCreateGiftorProfileResponseMock200 = (overrideResponse = {})=>({
        data: faker.word.sample(),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPostCreateGiftorProfileResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateGiftorProfileResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateGiftorProfileResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateGiftorProfileResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateGiftorProfileResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateGiftorProfileResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateGiftorProfileResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateGiftorProfileResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateGiftorProfileResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateGiftorProfileResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateGiftorProfileResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateGiftorProfileResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateGiftorProfileResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateGiftorProfileResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateGiftorProfileResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateGiftorProfileResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateGiftorProfileResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateGiftorProfileResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftorProfileResponseMock = (overrideResponse = {})=>({
        data: faker.word.sample(),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPutValidateGiftorProfileResponseMock200 = (overrideResponse = {})=>({
        data: faker.word.sample(),
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPutValidateGiftorProfileResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftorProfileResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftorProfileResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftorProfileResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftorProfileResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftorProfileResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftorProfileResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftorProfileResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftorProfileResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftorProfileResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftorProfileResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftorProfileResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftorProfileResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftorProfileResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftorProfileResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftorProfileResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftorProfileResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftorProfileResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostGiftSubmissionResponseMock = (overrideResponse = {})=>({
        data: {},
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPostGiftSubmissionResponseMock200 = (overrideResponse = {})=>({
        data: {},
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPostGiftSubmissionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostGiftSubmissionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostGiftSubmissionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostGiftSubmissionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostGiftSubmissionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostGiftSubmissionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostGiftSubmissionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostGiftSubmissionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostGiftSubmissionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostGiftSubmissionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostGiftSubmissionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostGiftSubmissionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostGiftSubmissionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostGiftSubmissionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostGiftSubmissionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostGiftSubmissionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostGiftSubmissionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostGiftSubmissionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftSubmissionResponseMock = (overrideResponse = {})=>({
        data: {},
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPutValidateGiftSubmissionResponseMock200 = (overrideResponse = {})=>({
        data: {},
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getPutValidateGiftSubmissionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftSubmissionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftSubmissionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftSubmissionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftSubmissionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftSubmissionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftSubmissionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftSubmissionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftSubmissionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftSubmissionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftSubmissionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftSubmissionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftSubmissionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftSubmissionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftSubmissionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftSubmissionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftSubmissionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutValidateGiftSubmissionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetLoanAmortizationPdfResponseMock = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getGetLoanAmortizationPdfResponseMock200 = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getGetManagedAccountsPlaidTokenResponseMock = (overrideResponse = {})=>({
        linkToken: faker.word.sample(),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidTokenResponseMock200 = (overrideResponse = {})=>({
        linkToken: faker.word.sample(),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidTokenResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidTokenResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidTokenResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidTokenResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidTokenResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidTokenResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidTokenResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidTokenResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidTokenResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidTokenResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidTokenResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidTokenResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidTokenResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidTokenResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidTokenResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidTokenResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidTokenResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidTokenResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteManagedAccountsPlaidLinksResponseMock = (overrideResponse = {})=>({
        links: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                availableBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                bankAccountName: faker.word.sample(),
                currentBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                id: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                plaidAccountType: faker.word.sample(),
                updatedAt: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getDeleteManagedAccountsPlaidLinksResponseMock200 = (overrideResponse = {})=>({
        links: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                availableBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                bankAccountName: faker.word.sample(),
                currentBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                id: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                plaidAccountType: faker.word.sample(),
                updatedAt: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getDeleteManagedAccountsPlaidLinksResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteManagedAccountsPlaidLinksResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteManagedAccountsPlaidLinksResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteManagedAccountsPlaidLinksResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteManagedAccountsPlaidLinksResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteManagedAccountsPlaidLinksResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteManagedAccountsPlaidLinksResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteManagedAccountsPlaidLinksResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteManagedAccountsPlaidLinksResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteManagedAccountsPlaidLinksResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteManagedAccountsPlaidLinksResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteManagedAccountsPlaidLinksResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteManagedAccountsPlaidLinksResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteManagedAccountsPlaidLinksResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteManagedAccountsPlaidLinksResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteManagedAccountsPlaidLinksResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteManagedAccountsPlaidLinksResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeleteManagedAccountsPlaidLinksResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidLinksResponseMock = (overrideResponse = {})=>({
        links: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                availableBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                bankAccountName: faker.word.sample(),
                currentBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                id: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                plaidAccountType: faker.word.sample(),
                updatedAt: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidLinksResponseMock200 = (overrideResponse = {})=>({
        links: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                availableBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                bankAccountName: faker.word.sample(),
                currentBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                id: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                plaidAccountType: faker.word.sample(),
                updatedAt: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidLinksResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidLinksResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidLinksResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidLinksResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidLinksResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidLinksResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidLinksResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidLinksResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidLinksResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidLinksResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidLinksResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidLinksResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidLinksResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidLinksResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidLinksResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidLinksResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidLinksResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidLinksResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidLinksResponseMock = (overrideResponse = {})=>({
        links: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                availableBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                bankAccountName: faker.word.sample(),
                currentBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                id: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                plaidAccountType: faker.word.sample(),
                updatedAt: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidLinksResponseMock200 = (overrideResponse = {})=>({
        links: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                availableBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                bankAccountName: faker.word.sample(),
                currentBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                id: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                plaidAccountType: faker.word.sample(),
                updatedAt: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidLinksResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidLinksResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidLinksResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidLinksResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidLinksResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidLinksResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidLinksResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidLinksResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidLinksResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidLinksResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidLinksResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidLinksResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidLinksResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidLinksResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidLinksResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidLinksResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidLinksResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidLinksResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidBalancesResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            availableBalance: faker.number.int({
                min: undefined,
                max: undefined
            }),
            currentBalance: faker.number.int({
                min: undefined,
                max: undefined
            }),
            institutionId: faker.word.sample(),
            itemId: faker.word.sample(),
            plaidAccountId: faker.word.sample(),
            plaidAccountSubtype: faker.word.sample(),
            plaidAccountType: faker.word.sample()
        }));
export const getPostManagedAccountsPlaidBalancesResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            availableBalance: faker.number.int({
                min: undefined,
                max: undefined
            }),
            currentBalance: faker.number.int({
                min: undefined,
                max: undefined
            }),
            institutionId: faker.word.sample(),
            itemId: faker.word.sample(),
            plaidAccountId: faker.word.sample(),
            plaidAccountSubtype: faker.word.sample(),
            plaidAccountType: faker.word.sample()
        }));
export const getPostManagedAccountsPlaidBalancesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidBalancesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidBalancesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidBalancesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidBalancesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidBalancesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidBalancesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidBalancesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidBalancesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidBalancesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidBalancesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidBalancesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidBalancesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidBalancesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidBalancesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidBalancesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidBalancesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidBalancesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingResponseMock = (overrideResponse = {})=>({
        ...overrideResponse
    });
export const getGetMidYearTestingResponseMock200 = (overrideResponse = {})=>({
        ...overrideResponse
    });
export const getGetMidYearTestingResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingCensusRecordResponseMock = (overrideResponse = {})=>({
        ...overrideResponse
    });
export const getGetMidYearTestingCensusRecordResponseMock200 = (overrideResponse = {})=>({
        ...overrideResponse
    });
export const getGetMidYearTestingCensusRecordResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingCensusRecordResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingCensusRecordResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingCensusRecordResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingCensusRecordResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingCensusRecordResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingCensusRecordResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingCensusRecordResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingCensusRecordResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingCensusRecordResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingCensusRecordResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingCensusRecordResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingCensusRecordResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingCensusRecordResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingCensusRecordResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingCensusRecordResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingCensusRecordResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMidYearTestingCensusRecordResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccounts401kManagerQuestionnaireResponseMock = (overrideResponse = {})=>({
        riskTolerance: faker.helpers.arrayElement([
            'aggressive',
            'conservative',
            'moderate'
        ]),
        ...overrideResponse
    });
export const getPostMsManagedAccounts401kManagerQuestionnaireResponseMock200 = (overrideResponse = {})=>({
        riskTolerance: faker.helpers.arrayElement([
            'aggressive',
            'conservative',
            'moderate'
        ]),
        ...overrideResponse
    });
export const getPostMsManagedAccounts401kManagerQuestionnaireResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccounts401kManagerQuestionnaireResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccounts401kManagerQuestionnaireResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccounts401kManagerQuestionnaireResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccounts401kManagerQuestionnaireResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccounts401kManagerQuestionnaireResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccounts401kManagerQuestionnaireResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccounts401kManagerQuestionnaireResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccounts401kManagerQuestionnaireResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccounts401kManagerQuestionnaireResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccounts401kManagerQuestionnaireResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccounts401kManagerQuestionnaireResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccounts401kManagerQuestionnaireResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccounts401kManagerQuestionnaireResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccounts401kManagerQuestionnaireResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccounts401kManagerQuestionnaireResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccounts401kManagerQuestionnaireResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccounts401kManagerQuestionnaireResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsActivateResponseMock = (overrideResponse = {})=>({
        targetAllocations: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                assetAllocations: {
                    bondNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    cashNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    otherNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    stockNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                assetClass: faker.word.sample(),
                broadCategory: faker.word.sample(),
                category: faker.word.sample(),
                cusip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                fundName: faker.word.sample(),
                fundType: faker.word.sample(),
                id: faker.word.sample(),
                inceptionDate: faker.word.sample(),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                morningStarId: faker.word.sample(),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                percentageAllocation: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityType: faker.word.sample(),
                securityTypeName: faker.word.sample(),
                shareClass: faker.word.sample(),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                weightPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        ...overrideResponse
    });
export const getPostMsManagedAccountsActivateResponseMock200 = (overrideResponse = {})=>({
        targetAllocations: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                assetAllocations: {
                    bondNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    cashNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    otherNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    stockNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                assetClass: faker.word.sample(),
                broadCategory: faker.word.sample(),
                category: faker.word.sample(),
                cusip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                fundName: faker.word.sample(),
                fundType: faker.word.sample(),
                id: faker.word.sample(),
                inceptionDate: faker.word.sample(),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                morningStarId: faker.word.sample(),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                percentageAllocation: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityType: faker.word.sample(),
                securityTypeName: faker.word.sample(),
                shareClass: faker.word.sample(),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                weightPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        ...overrideResponse
    });
export const getPostMsManagedAccountsActivateResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsActivateResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsActivateResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsActivateResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsActivateResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsActivateResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsActivateResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsActivateResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsActivateResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsActivateResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsActivateResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsActivateResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsActivateResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsActivateResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsActivateResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsActivateResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsActivateResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsActivateResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsDeactivateResponseMock = (overrideResponse = {})=>({
        deactivateStatus: faker.word.sample(),
        failureReason: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPostMsManagedAccountsDeactivateResponseMock200 = (overrideResponse = {})=>({
        deactivateStatus: faker.word.sample(),
        failureReason: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPostMsManagedAccountsDeactivateResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsDeactivateResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsDeactivateResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsDeactivateResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsDeactivateResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsDeactivateResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsDeactivateResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsDeactivateResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsDeactivateResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsDeactivateResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsDeactivateResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsDeactivateResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsDeactivateResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsDeactivateResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsDeactivateResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsDeactivateResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsDeactivateResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsDeactivateResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMsManagedAccountsPreviewAllocationResponseMock = (overrideResponse = {})=>({
        currentAge: faker.number.int({
            min: undefined,
            max: undefined
        }),
        isActivated: faker.datatype.boolean(),
        lastUpdated: faker.word.sample(),
        retirementAge: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        riskTolerance: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                'aggressive',
                'conservative',
                'moderate'
            ]),
            undefined
        ]),
        targetAllocations: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                assetAllocations: {
                    bondNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    cashNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    otherNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    stockNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                assetClass: faker.word.sample(),
                broadCategory: faker.word.sample(),
                category: faker.word.sample(),
                cusip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                fundName: faker.word.sample(),
                fundType: faker.word.sample(),
                id: faker.word.sample(),
                inceptionDate: faker.word.sample(),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                morningStarId: faker.word.sample(),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                percentageAllocation: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityType: faker.word.sample(),
                securityTypeName: faker.word.sample(),
                shareClass: faker.word.sample(),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                weightPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        ...overrideResponse
    });
export const getGetMsManagedAccountsPreviewAllocationResponseMock200 = (overrideResponse = {})=>({
        currentAge: faker.number.int({
            min: undefined,
            max: undefined
        }),
        isActivated: faker.datatype.boolean(),
        lastUpdated: faker.word.sample(),
        retirementAge: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        riskTolerance: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                'aggressive',
                'conservative',
                'moderate'
            ]),
            undefined
        ]),
        targetAllocations: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                assetAllocations: {
                    bondNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    cashNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    otherNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    stockNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                assetClass: faker.word.sample(),
                broadCategory: faker.word.sample(),
                category: faker.word.sample(),
                cusip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                fundName: faker.word.sample(),
                fundType: faker.word.sample(),
                id: faker.word.sample(),
                inceptionDate: faker.word.sample(),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                morningStarId: faker.word.sample(),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                percentageAllocation: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityType: faker.word.sample(),
                securityTypeName: faker.word.sample(),
                shareClass: faker.word.sample(),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                weightPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        ...overrideResponse
    });
export const getGetMsManagedAccountsPreviewAllocationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMsManagedAccountsPreviewAllocationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMsManagedAccountsPreviewAllocationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMsManagedAccountsPreviewAllocationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMsManagedAccountsPreviewAllocationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMsManagedAccountsPreviewAllocationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMsManagedAccountsPreviewAllocationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMsManagedAccountsPreviewAllocationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMsManagedAccountsPreviewAllocationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMsManagedAccountsPreviewAllocationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMsManagedAccountsPreviewAllocationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMsManagedAccountsPreviewAllocationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMsManagedAccountsPreviewAllocationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMsManagedAccountsPreviewAllocationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMsManagedAccountsPreviewAllocationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMsManagedAccountsPreviewAllocationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMsManagedAccountsPreviewAllocationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMsManagedAccountsPreviewAllocationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsPreviewAllocationResponseMock = (overrideResponse = {})=>({
        currentAge: faker.number.int({
            min: undefined,
            max: undefined
        }),
        isActivated: faker.datatype.boolean(),
        lastUpdated: faker.word.sample(),
        retirementAge: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        riskTolerance: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                'aggressive',
                'conservative',
                'moderate'
            ]),
            undefined
        ]),
        targetAllocations: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                assetAllocations: {
                    bondNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    cashNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    otherNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    stockNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                assetClass: faker.word.sample(),
                broadCategory: faker.word.sample(),
                category: faker.word.sample(),
                cusip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                fundName: faker.word.sample(),
                fundType: faker.word.sample(),
                id: faker.word.sample(),
                inceptionDate: faker.word.sample(),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                morningStarId: faker.word.sample(),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                percentageAllocation: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityType: faker.word.sample(),
                securityTypeName: faker.word.sample(),
                shareClass: faker.word.sample(),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                weightPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        ...overrideResponse
    });
export const getPostMsManagedAccountsPreviewAllocationResponseMock200 = (overrideResponse = {})=>({
        currentAge: faker.number.int({
            min: undefined,
            max: undefined
        }),
        isActivated: faker.datatype.boolean(),
        lastUpdated: faker.word.sample(),
        retirementAge: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        riskTolerance: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                'aggressive',
                'conservative',
                'moderate'
            ]),
            undefined
        ]),
        targetAllocations: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                assetAllocations: {
                    bondNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    cashNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    otherNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    stockNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                assetClass: faker.word.sample(),
                broadCategory: faker.word.sample(),
                category: faker.word.sample(),
                cusip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                fundName: faker.word.sample(),
                fundType: faker.word.sample(),
                id: faker.word.sample(),
                inceptionDate: faker.word.sample(),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                morningStarId: faker.word.sample(),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                percentageAllocation: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityType: faker.word.sample(),
                securityTypeName: faker.word.sample(),
                shareClass: faker.word.sample(),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                weightPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        ...overrideResponse
    });
export const getPostMsManagedAccountsPreviewAllocationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsPreviewAllocationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsPreviewAllocationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsPreviewAllocationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsPreviewAllocationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsPreviewAllocationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsPreviewAllocationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsPreviewAllocationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsPreviewAllocationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsPreviewAllocationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsPreviewAllocationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsPreviewAllocationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsPreviewAllocationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsPreviewAllocationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsPreviewAllocationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsPreviewAllocationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsPreviewAllocationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMsManagedAccountsPreviewAllocationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDigitalOnboardingStateResponseMock = (overrideResponse = {})=>({
        census: faker.helpers.arrayElement([
            faker.word.sample(),
            null
        ]),
        companyQuestionnaire: faker.helpers.arrayElement([
            faker.word.sample(),
            null
        ]),
        completedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            null
        ]),
        contract: faker.helpers.arrayElement([
            faker.word.sample(),
            null
        ]),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        payrollAndPayment: faker.helpers.arrayElement([
            faker.word.sample(),
            null
        ]),
        planDesign: faker.helpers.arrayElement([
            faker.word.sample(),
            null
        ]),
        planLaunch: faker.helpers.arrayElement([
            faker.word.sample(),
            null
        ]),
        sponsorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDigitalOnboardingStateResponseMock200 = (overrideResponse = {})=>({
        census: faker.helpers.arrayElement([
            faker.word.sample(),
            null
        ]),
        companyQuestionnaire: faker.helpers.arrayElement([
            faker.word.sample(),
            null
        ]),
        completedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            null
        ]),
        contract: faker.helpers.arrayElement([
            faker.word.sample(),
            null
        ]),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        payrollAndPayment: faker.helpers.arrayElement([
            faker.word.sample(),
            null
        ]),
        planDesign: faker.helpers.arrayElement([
            faker.word.sample(),
            null
        ]),
        planLaunch: faker.helpers.arrayElement([
            faker.word.sample(),
            null
        ]),
        sponsorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDigitalOnboardingStateResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDigitalOnboardingStateResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDigitalOnboardingStateResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDigitalOnboardingStateResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDigitalOnboardingStateResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDigitalOnboardingStateResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDigitalOnboardingStateResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDigitalOnboardingStateResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDigitalOnboardingStateResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDigitalOnboardingStateResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDigitalOnboardingStateResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDigitalOnboardingStateResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDigitalOnboardingStateResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDigitalOnboardingStateResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDigitalOnboardingStateResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDigitalOnboardingStateResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDigitalOnboardingStateResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDigitalOnboardingStateResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchDigitalOnboardingStateResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchDigitalOnboardingStateResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchDigitalOnboardingStateResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchDigitalOnboardingStateResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchDigitalOnboardingStateResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchDigitalOnboardingStateResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchDigitalOnboardingStateResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchDigitalOnboardingStateResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchDigitalOnboardingStateResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchDigitalOnboardingStateResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchDigitalOnboardingStateResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchDigitalOnboardingStateResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchDigitalOnboardingStateResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchDigitalOnboardingStateResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchDigitalOnboardingStateResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchDigitalOnboardingStateResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchDigitalOnboardingStateResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchDigitalOnboardingStateResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutDigitalOnboardingStateResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutDigitalOnboardingStateResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutDigitalOnboardingStateResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutDigitalOnboardingStateResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutDigitalOnboardingStateResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutDigitalOnboardingStateResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutDigitalOnboardingStateResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutDigitalOnboardingStateResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutDigitalOnboardingStateResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutDigitalOnboardingStateResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutDigitalOnboardingStateResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutDigitalOnboardingStateResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutDigitalOnboardingStateResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutDigitalOnboardingStateResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutDigitalOnboardingStateResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutDigitalOnboardingStateResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutDigitalOnboardingStateResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutDigitalOnboardingStateResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchStatefulSchemaTrackingStatusResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchStatefulSchemaTrackingStatusResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchStatefulSchemaTrackingStatusResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchStatefulSchemaTrackingStatusResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchStatefulSchemaTrackingStatusResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchStatefulSchemaTrackingStatusResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchStatefulSchemaTrackingStatusResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchStatefulSchemaTrackingStatusResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchStatefulSchemaTrackingStatusResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchStatefulSchemaTrackingStatusResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchStatefulSchemaTrackingStatusResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchStatefulSchemaTrackingStatusResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchStatefulSchemaTrackingStatusResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchStatefulSchemaTrackingStatusResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchStatefulSchemaTrackingStatusResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchStatefulSchemaTrackingStatusResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchStatefulSchemaTrackingStatusResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchStatefulSchemaTrackingStatusResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantByIdResponseMock = (overrideResponse = {})=>({
        accountId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        activationDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        addressUpdatedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        advisorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        afterTaxContribution: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        afterTaxContributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        autorebalance: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        birthDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        cipStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        contactInformation: {
            address: {
                address1: faker.word.sample(),
                address2: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                city: faker.word.sample(),
                country: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                state: faker.word.sample(),
                zip: faker.word.sample()
            },
            mailingAddress: faker.helpers.arrayElement([
                {
                    address1: faker.word.sample(),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.word.sample(),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.word.sample(),
                    zip: faker.word.sample()
                },
                undefined
            ]),
            personalEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            phoneNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            physicalSameAsMailing: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            workEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        contributesToRoth: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        contribution: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        contributions: faker.helpers.arrayElement([
            {
                irsLimit: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            undefined
        ]),
        contributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        createdAt: faker.word.sample(),
        dateOfTermination: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        deferralChanged: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        deferralElections: {
            afterTaxAmt: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            afterTaxType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            preTaxAmt: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            preTaxType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            rothAmt: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            rothType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        eligibility: faker.helpers.arrayElement([
            {
                ageRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                entryDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                isLtpt: faker.datatype.boolean(),
                isOverride: faker.datatype.boolean(),
                overrideNotes: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                serviceRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                status: faker.word.sample()
            },
            undefined
        ]),
        emailUpdatedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        employeeClass: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        employeeStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        employmentStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        esaGroupId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        esaGroupName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        externalId: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        firstName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        gender: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        hireDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        inRmdAge: faker.datatype.boolean(),
        isDeceased: faker.datatype.boolean(),
        isDisabled: faker.datatype.boolean(),
        isExcluded: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isVerified: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        lastName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        maritalStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        matchEligibility: faker.helpers.arrayElement([
            {
                ageRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                entryDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                isLtpt: faker.datatype.boolean(),
                isOverride: faker.datatype.boolean(),
                overrideNotes: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                serviceRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                status: faker.word.sample()
            },
            undefined
        ]),
        middleName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        model: faker.helpers.arrayElement([
            {
                modelId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                modelName: faker.word.sample(),
                modelType: faker.word.sample(),
                modelViewName: faker.word.sample()
            },
            undefined
        ]),
        nameUpdatedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        onboardingWizardCompletedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        participantChangedDeferralAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        password: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        planId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        psEligibility: faker.helpers.arrayElement([
            {
                ageRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                entryDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                isLtpt: faker.datatype.boolean(),
                isOverride: faker.datatype.boolean(),
                overrideNotes: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                serviceRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                status: faker.word.sample()
            },
            undefined
        ]),
        registeredOn: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        rehireDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        riskValue: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        rothContribution: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        rothContributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        savesForRetirement: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        sendEmailUpdate: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        sponsorId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        ssn: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        stateIraAccountStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        stateIraCipStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        stateIraPerEmployerStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        updatedAt: faker.word.sample(),
        updatedBy: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        yearsToRetire: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetParticipantByIdResponseMock200 = (overrideResponse = {})=>({
        accountId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        activationDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        addressUpdatedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        advisorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        afterTaxContribution: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        afterTaxContributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        autorebalance: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        birthDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        cipStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        contactInformation: {
            address: {
                address1: faker.word.sample(),
                address2: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                city: faker.word.sample(),
                country: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                state: faker.word.sample(),
                zip: faker.word.sample()
            },
            mailingAddress: faker.helpers.arrayElement([
                {
                    address1: faker.word.sample(),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.word.sample(),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.word.sample(),
                    zip: faker.word.sample()
                },
                undefined
            ]),
            personalEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            phoneNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            physicalSameAsMailing: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            workEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        contributesToRoth: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        contribution: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        contributions: faker.helpers.arrayElement([
            {
                irsLimit: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            undefined
        ]),
        contributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        createdAt: faker.word.sample(),
        dateOfTermination: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        deferralChanged: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        deferralElections: {
            afterTaxAmt: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            afterTaxType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            preTaxAmt: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            preTaxType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            rothAmt: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            rothType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        eligibility: faker.helpers.arrayElement([
            {
                ageRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                entryDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                isLtpt: faker.datatype.boolean(),
                isOverride: faker.datatype.boolean(),
                overrideNotes: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                serviceRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                status: faker.word.sample()
            },
            undefined
        ]),
        emailUpdatedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        employeeClass: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        employeeStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        employmentStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        esaGroupId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        esaGroupName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        externalId: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        firstName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        gender: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        hireDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        inRmdAge: faker.datatype.boolean(),
        isDeceased: faker.datatype.boolean(),
        isDisabled: faker.datatype.boolean(),
        isExcluded: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isVerified: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        lastName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        maritalStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        matchEligibility: faker.helpers.arrayElement([
            {
                ageRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                entryDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                isLtpt: faker.datatype.boolean(),
                isOverride: faker.datatype.boolean(),
                overrideNotes: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                serviceRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                status: faker.word.sample()
            },
            undefined
        ]),
        middleName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        model: faker.helpers.arrayElement([
            {
                modelId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                modelName: faker.word.sample(),
                modelType: faker.word.sample(),
                modelViewName: faker.word.sample()
            },
            undefined
        ]),
        nameUpdatedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        onboardingWizardCompletedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        participantChangedDeferralAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        password: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        planId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        psEligibility: faker.helpers.arrayElement([
            {
                ageRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                entryDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                isLtpt: faker.datatype.boolean(),
                isOverride: faker.datatype.boolean(),
                overrideNotes: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                serviceRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                status: faker.word.sample()
            },
            undefined
        ]),
        registeredOn: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        rehireDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        riskValue: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        rothContribution: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        rothContributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        savesForRetirement: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        sendEmailUpdate: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        sponsorId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        ssn: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        stateIraAccountStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        stateIraCipStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        stateIraPerEmployerStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        updatedAt: faker.word.sample(),
        updatedBy: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        yearsToRetire: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetParticipantByIdResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantByIdResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantByIdResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantByIdResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantByIdResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantByIdResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantByIdResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantByIdResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantByIdResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantByIdResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantByIdResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantByIdResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantByIdResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantByIdResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantByIdResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantByIdResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantByIdResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantByIdResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountBalanceByIdResponseMock = (overrideResponse = {})=>({
        employeeBalance: {
            afterTax: faker.number.int({
                min: undefined,
                max: undefined
            }),
            preTax: faker.number.int({
                min: undefined,
                max: undefined
            }),
            roth: faker.number.int({
                min: undefined,
                max: undefined
            }),
            total: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        employerBalance: {
            match: faker.number.int({
                min: undefined,
                max: undefined
            }),
            profitSharing: faker.number.int({
                min: undefined,
                max: undefined
            }),
            total: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        loanBalance: {
            total: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        rolloverBalance: {
            preTax: faker.number.int({
                min: undefined,
                max: undefined
            }),
            roth: faker.number.int({
                min: undefined,
                max: undefined
            }),
            total: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        totalBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        updatedOn: faker.word.sample(),
        vestedBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountBalanceByIdResponseMock200 = (overrideResponse = {})=>({
        employeeBalance: {
            afterTax: faker.number.int({
                min: undefined,
                max: undefined
            }),
            preTax: faker.number.int({
                min: undefined,
                max: undefined
            }),
            roth: faker.number.int({
                min: undefined,
                max: undefined
            }),
            total: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        employerBalance: {
            match: faker.number.int({
                min: undefined,
                max: undefined
            }),
            profitSharing: faker.number.int({
                min: undefined,
                max: undefined
            }),
            total: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        loanBalance: {
            total: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        rolloverBalance: {
            preTax: faker.number.int({
                min: undefined,
                max: undefined
            }),
            roth: faker.number.int({
                min: undefined,
                max: undefined
            }),
            total: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        totalBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        updatedOn: faker.word.sample(),
        vestedBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountBalanceByIdResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountBalanceByIdResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountBalanceByIdResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountBalanceByIdResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountBalanceByIdResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountBalanceByIdResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountBalanceByIdResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountBalanceByIdResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountBalanceByIdResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountBalanceByIdResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountBalanceByIdResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountBalanceByIdResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountBalanceByIdResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountBalanceByIdResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountBalanceByIdResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountBalanceByIdResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountBalanceByIdResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountBalanceByIdResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantLoanResponseMock = (overrideResponse = {})=>({
        data: {
            attributes: faker.helpers.arrayElement([
                {
                    addressUpdate: faker.helpers.arrayElement([
                        {
                            address1: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            address2: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            approvedBy: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            city: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            country: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            state: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            status: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            submittedBy: faker.word.sample(),
                            updatedAt: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            zip: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    bankAccountInfo: faker.helpers.arrayElement([
                        {
                            accountNumber: faker.word.sample(),
                            financialInstitution: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            plaidMask: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            routingNumber: faker.word.sample()
                        },
                        undefined
                    ]),
                    calloutToParticipant: faker.datatype.boolean(),
                    createdAt: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    deliveryAddress: faker.helpers.arrayElement([
                        {
                            address1: faker.word.sample(),
                            address2: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            city: faker.word.sample(),
                            country: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            state: faker.word.sample(),
                            zip: faker.word.sample()
                        },
                        undefined
                    ]),
                    deliveryMethod: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    extraFee: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    forCreditTo: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    forFurtherCreditTo: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    fraudNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    interestRate: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    isConversion: faker.datatype.boolean(),
                    isReamortizing: faker.datatype.boolean(),
                    isSignedAgreement: faker.datatype.boolean(),
                    loanAmount: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    loanPayments: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                attributes: faker.helpers.arrayElement([
                                    {
                                        dueDate: faker.word.sample(),
                                        interest: faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        interestPaid: faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        latestPaymentDate: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        paymentSequenceNumber: faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        paymentStatus: faker.word.sample(),
                                        principal: faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        principalPaid: faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        total: faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        updatedAt: faker.word.sample()
                                    },
                                    undefined
                                ]),
                                id: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                type: faker.word.sample()
                            })),
                        undefined
                    ]),
                    loanPurpose: faker.word.sample(),
                    loanStatus: faker.word.sample(),
                    ltLoanId: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    maintenanceFee: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    nextPaymentDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    notes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    originationDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    originationFee: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    outstandingPrincipalDue: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    overdueInterest: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    participantFirstName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    participantLastName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    paymentFrequency: faker.word.sample(),
                    promissoryNoteAcceptanceDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    purchaseSaleAgreementUploaded: faker.datatype.boolean(),
                    remainingPaymentsCount: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    repaymentYears: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    totalPaymentsCount: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                undefined
            ]),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            type: faker.word.sample()
        },
        included: {},
        ...overrideResponse
    });
export const getPostParticipantLoanResponseMock200 = (overrideResponse = {})=>({
        data: {
            attributes: faker.helpers.arrayElement([
                {
                    addressUpdate: faker.helpers.arrayElement([
                        {
                            address1: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            address2: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            approvedBy: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            city: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            country: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            state: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            status: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            submittedBy: faker.word.sample(),
                            updatedAt: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            zip: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    bankAccountInfo: faker.helpers.arrayElement([
                        {
                            accountNumber: faker.word.sample(),
                            financialInstitution: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            plaidMask: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            routingNumber: faker.word.sample()
                        },
                        undefined
                    ]),
                    calloutToParticipant: faker.datatype.boolean(),
                    createdAt: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    deliveryAddress: faker.helpers.arrayElement([
                        {
                            address1: faker.word.sample(),
                            address2: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            city: faker.word.sample(),
                            country: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            state: faker.word.sample(),
                            zip: faker.word.sample()
                        },
                        undefined
                    ]),
                    deliveryMethod: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    extraFee: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    forCreditTo: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    forFurtherCreditTo: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    fraudNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    interestRate: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    isConversion: faker.datatype.boolean(),
                    isReamortizing: faker.datatype.boolean(),
                    isSignedAgreement: faker.datatype.boolean(),
                    loanAmount: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    loanPayments: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                attributes: faker.helpers.arrayElement([
                                    {
                                        dueDate: faker.word.sample(),
                                        interest: faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        interestPaid: faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        latestPaymentDate: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        paymentSequenceNumber: faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        paymentStatus: faker.word.sample(),
                                        principal: faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        principalPaid: faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        total: faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        updatedAt: faker.word.sample()
                                    },
                                    undefined
                                ]),
                                id: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                type: faker.word.sample()
                            })),
                        undefined
                    ]),
                    loanPurpose: faker.word.sample(),
                    loanStatus: faker.word.sample(),
                    ltLoanId: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    maintenanceFee: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    nextPaymentDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    notes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    originationDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    originationFee: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    outstandingPrincipalDue: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    overdueInterest: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    participantFirstName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    participantLastName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    paymentFrequency: faker.word.sample(),
                    promissoryNoteAcceptanceDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    purchaseSaleAgreementUploaded: faker.datatype.boolean(),
                    remainingPaymentsCount: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    repaymentYears: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    totalPaymentsCount: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                undefined
            ]),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            type: faker.word.sample()
        },
        included: {},
        ...overrideResponse
    });
export const getPostParticipantLoanResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantLoanResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantLoanResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantLoanResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantLoanResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantLoanResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantLoanResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantLoanResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantLoanResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantLoanResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantLoanResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantLoanResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantLoanResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantLoanResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantLoanResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantLoanResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantLoanResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantLoanResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinkTokenResponseMock = (overrideResponse = {})=>({
        linkToken: faker.word.sample(),
        verificationStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinkTokenResponseMock200 = (overrideResponse = {})=>({
        linkToken: faker.word.sample(),
        verificationStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinkTokenResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinkTokenResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinkTokenResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinkTokenResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinkTokenResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinkTokenResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinkTokenResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinkTokenResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinkTokenResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinkTokenResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinkTokenResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinkTokenResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinkTokenResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinkTokenResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinkTokenResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinkTokenResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinkTokenResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinkTokenResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinksResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            attributes: faker.helpers.arrayElement([
                {
                    accountNumber: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    accountVerificationStatus: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    bankAccountMask: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    bankAccountName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    holdReason: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    id: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    institutionName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    plaidAccountId: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    plaidMask: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    routingNumberMask: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    wireRoutingMask: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            id: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getGetParticipantPlaidLinksResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            attributes: faker.helpers.arrayElement([
                {
                    accountNumber: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    accountVerificationStatus: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    bankAccountMask: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    bankAccountName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    holdReason: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    id: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    institutionName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    plaidAccountId: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    plaidMask: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    routingNumberMask: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    wireRoutingMask: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            id: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getGetParticipantPlaidLinksResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinksResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinksResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinksResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinksResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinksResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinksResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinksResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinksResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinksResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinksResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinksResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinksResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinksResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinksResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinksResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinksResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinksResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksResponseMock = (overrideResponse = {})=>({
        attributes: faker.helpers.arrayElement([
            {
                accountNumber: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                accountVerificationStatus: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                bankAccountMask: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                bankAccountName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                holdReason: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                institutionName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                plaidAccountId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                plaidMask: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                routingNumberMask: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                wireRoutingMask: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        id: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksResponseMock200 = (overrideResponse = {})=>({
        attributes: faker.helpers.arrayElement([
            {
                accountNumber: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                accountVerificationStatus: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                bankAccountMask: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                bankAccountName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                holdReason: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                institutionName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                plaidAccountId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                plaidMask: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                routingNumberMask: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                wireRoutingMask: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        id: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantLoanCreateResponseMock = (overrideResponse = {})=>({
        balanceOverview: faker.helpers.arrayElement([
            {
                loanAmountAvailable: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                loanOutstandingBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                sdbaBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                totalAccountBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                totalVestedBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            undefined
        ]),
        hasAccess: faker.datatype.boolean(),
        interestRate: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        isFraudCheckRestricted: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        loanPreferences: faker.helpers.arrayElement([
            {
                allowedLoanPurposes: faker.helpers.arrayElement([
                    faker.helpers.arrayElements([
                        'General',
                        'Principal Residence Purchase'
                    ]),
                    undefined
                ]),
                allowedPayFrequencies: faker.helpers.arrayElement([
                    faker.helpers.arrayElements([
                        'SC',
                        'B',
                        'W',
                        'S',
                        'M',
                        'ME'
                    ]),
                    undefined
                ]),
                maintenanceFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                maxOutstandingLoans: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                maxYearsResidencePurchase: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                originationFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                overnightCheckFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                wireFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        reason: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetParticipantLoanCreateResponseMock200 = (overrideResponse = {})=>({
        balanceOverview: faker.helpers.arrayElement([
            {
                loanAmountAvailable: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                loanOutstandingBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                sdbaBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                totalAccountBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                totalVestedBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            undefined
        ]),
        hasAccess: faker.datatype.boolean(),
        interestRate: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        isFraudCheckRestricted: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        loanPreferences: faker.helpers.arrayElement([
            {
                allowedLoanPurposes: faker.helpers.arrayElement([
                    faker.helpers.arrayElements([
                        'General',
                        'Principal Residence Purchase'
                    ]),
                    undefined
                ]),
                allowedPayFrequencies: faker.helpers.arrayElement([
                    faker.helpers.arrayElements([
                        'SC',
                        'B',
                        'W',
                        'S',
                        'M',
                        'ME'
                    ]),
                    undefined
                ]),
                maintenanceFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                maxOutstandingLoans: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                maxYearsResidencePurchase: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                originationFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                overnightCheckFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                wireFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        reason: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetParticipantLoanCreateResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantLoanCreateResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantLoanCreateResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantLoanCreateResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantLoanCreateResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantLoanCreateResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantLoanCreateResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantLoanCreateResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantLoanCreateResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantLoanCreateResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantLoanCreateResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantLoanCreateResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantLoanCreateResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantLoanCreateResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantLoanCreateResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantLoanCreateResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantLoanCreateResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantLoanCreateResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountsResponseMock = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            {
                attributes: faker.helpers.arrayElement([
                    {
                        code: faker.word.sample(),
                        source: faker.word.sample(),
                        tax: faker.word.sample()
                    },
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                type: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        stats: faker.helpers.arrayElement([
            {
                allocations: faker.helpers.arrayElement([
                    {
                        assetClass: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        fundName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        targetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        ticker: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                balance: faker.helpers.arrayElement([
                    {
                        afterTax: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        employee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        employer: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        loan: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        preTax: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        profitSharing: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        rollover: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        roth: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        total: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                metaAssetAllocations: faker.helpers.arrayElement([
                    {
                        bondNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        cashNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        otherNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        stockNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                vesting: faker.helpers.arrayElement([
                    {
                        blendedNotVested: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        blendedVariablePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        EMNotVested: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        EMVestedPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        PSNotVested: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        PSVestedPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        QSHMNotVested: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        QSHMVestedPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        QSHNENotVested: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        QSHNEVestedPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        total: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        vestedTotal: faker.number.int({
                            min: undefined,
                            max: undefined
                        })
                    },
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getGetParticipantAccountsResponseMock200 = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            {
                attributes: faker.helpers.arrayElement([
                    {
                        code: faker.word.sample(),
                        source: faker.word.sample(),
                        tax: faker.word.sample()
                    },
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                type: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        stats: faker.helpers.arrayElement([
            {
                allocations: faker.helpers.arrayElement([
                    {
                        assetClass: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        fundName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        targetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        ticker: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                balance: faker.helpers.arrayElement([
                    {
                        afterTax: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        employee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        employer: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        loan: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        preTax: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        profitSharing: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        rollover: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        roth: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        total: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                metaAssetAllocations: faker.helpers.arrayElement([
                    {
                        bondNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        cashNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        otherNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        stockNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                vesting: faker.helpers.arrayElement([
                    {
                        blendedNotVested: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        blendedVariablePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        EMNotVested: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        EMVestedPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        PSNotVested: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        PSVestedPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        QSHMNotVested: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        QSHMVestedPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        QSHNENotVested: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        QSHNEVestedPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        total: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        vestedTotal: faker.number.int({
                            min: undefined,
                            max: undefined
                        })
                    },
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getGetParticipantAccountsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAccountsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBalanceOverTimeResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            balance: faker.number.int({
                min: undefined,
                max: undefined
            }),
            dateOf: faker.word.sample()
        }));
export const getGetParticipantBalanceOverTimeResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            balance: faker.number.int({
                min: undefined,
                max: undefined
            }),
            dateOf: faker.word.sample()
        }));
export const getGetParticipantBalanceOverTimeResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBalanceOverTimeResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBalanceOverTimeResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBalanceOverTimeResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBalanceOverTimeResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBalanceOverTimeResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBalanceOverTimeResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBalanceOverTimeResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBalanceOverTimeResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBalanceOverTimeResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBalanceOverTimeResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBalanceOverTimeResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBalanceOverTimeResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBalanceOverTimeResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBalanceOverTimeResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBalanceOverTimeResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBalanceOverTimeResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBalanceOverTimeResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutArchiveBankAccountResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutArchiveBankAccountResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutArchiveBankAccountResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutArchiveBankAccountResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutArchiveBankAccountResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutArchiveBankAccountResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutArchiveBankAccountResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutArchiveBankAccountResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutArchiveBankAccountResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutArchiveBankAccountResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutArchiveBankAccountResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutArchiveBankAccountResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutArchiveBankAccountResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutArchiveBankAccountResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutArchiveBankAccountResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutArchiveBankAccountResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutArchiveBankAccountResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutArchiveBankAccountResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBankAccountsResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            accountName: faker.word.sample(),
            accountNumberMasked: faker.word.sample(),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            plaidMask: faker.word.sample(),
            routingNumberMasked: faker.word.sample()
        }));
export const getGetParticipantBankAccountsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            accountName: faker.word.sample(),
            accountNumberMasked: faker.word.sample(),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            plaidMask: faker.word.sample(),
            routingNumberMasked: faker.word.sample()
        }));
export const getGetParticipantBankAccountsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBankAccountsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBankAccountsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBankAccountsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBankAccountsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBankAccountsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBankAccountsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBankAccountsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBankAccountsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBankAccountsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBankAccountsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBankAccountsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBankAccountsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBankAccountsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBankAccountsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBankAccountsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBankAccountsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBankAccountsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantDepositsResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            amount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            bankAccountId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            createdAt: faker.word.sample(),
            createdBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            depositType: faker.word.sample(),
            id: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            participantId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            status: faker.word.sample(),
            updatedAt: faker.word.sample()
        }));
export const getGetParticipantDepositsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            amount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            bankAccountId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            createdAt: faker.word.sample(),
            createdBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            depositType: faker.word.sample(),
            id: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            participantId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            status: faker.word.sample(),
            updatedAt: faker.word.sample()
        }));
export const getGetParticipantDepositsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantDepositsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantDepositsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantDepositsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantDepositsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantDepositsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantDepositsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantDepositsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantDepositsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantDepositsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantDepositsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantDepositsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantDepositsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantDepositsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantDepositsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantDepositsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantDepositsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantDepositsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDepositDataResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDepositDataResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDepositDataResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDepositDataResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDepositDataResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDepositDataResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDepositDataResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDepositDataResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDepositDataResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDepositDataResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDepositDataResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDepositDataResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDepositDataResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDepositDataResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDepositDataResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDepositDataResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDepositDataResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostDepositDataResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRecurringSchedulesResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            amount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            autoPause: faker.datatype.boolean(),
            bankAccountId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            createdAt: faker.word.sample(),
            createdBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            frequency: faker.word.sample(),
            id: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            nextDate: faker.word.sample(),
            participantId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            status: faker.word.sample(),
            updatedAt: faker.word.sample(),
            version: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetParticipantRecurringSchedulesResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            amount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            autoPause: faker.datatype.boolean(),
            bankAccountId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            createdAt: faker.word.sample(),
            createdBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            frequency: faker.word.sample(),
            id: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            nextDate: faker.word.sample(),
            participantId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            status: faker.word.sample(),
            updatedAt: faker.word.sample(),
            version: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetParticipantRecurringSchedulesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRecurringSchedulesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRecurringSchedulesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRecurringSchedulesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRecurringSchedulesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRecurringSchedulesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRecurringSchedulesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRecurringSchedulesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRecurringSchedulesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRecurringSchedulesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRecurringSchedulesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRecurringSchedulesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRecurringSchedulesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRecurringSchedulesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRecurringSchedulesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRecurringSchedulesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRecurringSchedulesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRecurringSchedulesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRecurringScheduleResponseMock = (overrideResponse = {})=>({
        amount: faker.number.int({
            min: undefined,
            max: undefined
        }),
        bankAccountId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        createdAt: faker.word.sample(),
        createdBy: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        depositType: faker.word.sample(),
        id: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        participantId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        status: faker.word.sample(),
        updatedAt: faker.word.sample(),
        ...overrideResponse
    });
export const getPutRecurringScheduleResponseMock200 = (overrideResponse = {})=>({
        amount: faker.number.int({
            min: undefined,
            max: undefined
        }),
        bankAccountId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        createdAt: faker.word.sample(),
        createdBy: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        depositType: faker.word.sample(),
        id: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        participantId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        status: faker.word.sample(),
        updatedAt: faker.word.sample(),
        ...overrideResponse
    });
export const getPutRecurringScheduleResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRecurringScheduleResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRecurringScheduleResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRecurringScheduleResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRecurringScheduleResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRecurringScheduleResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRecurringScheduleResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRecurringScheduleResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRecurringScheduleResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRecurringScheduleResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRecurringScheduleResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRecurringScheduleResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRecurringScheduleResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRecurringScheduleResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRecurringScheduleResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRecurringScheduleResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRecurringScheduleResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRecurringScheduleResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDepositResponseMock = (overrideResponse = {})=>({
        amount: faker.number.int({
            min: undefined,
            max: undefined
        }),
        bankAccountId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        createdAt: faker.word.sample(),
        createdBy: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        depositType: faker.word.sample(),
        id: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        participantId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        status: faker.word.sample(),
        updatedAt: faker.word.sample(),
        ...overrideResponse
    });
export const getGetDepositResponseMock200 = (overrideResponse = {})=>({
        amount: faker.number.int({
            min: undefined,
            max: undefined
        }),
        bankAccountId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        createdAt: faker.word.sample(),
        createdBy: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        depositType: faker.word.sample(),
        id: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        participantId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        status: faker.word.sample(),
        updatedAt: faker.word.sample(),
        ...overrideResponse
    });
export const getGetDepositResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDepositResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDepositResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDepositResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDepositResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDepositResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDepositResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDepositResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDepositResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDepositResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDepositResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDepositResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDepositResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDepositResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDepositResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDepositResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDepositResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetDepositResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantEligibilityResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantEligibilityResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantEligibilityResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantEligibilityResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantEligibilityResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantEligibilityResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantEligibilityResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantEligibilityResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantEligibilityResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantEligibilityResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantEligibilityResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantEligibilityResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantEligibilityResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantEligibilityResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantEligibilityResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantEligibilityResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantEligibilityResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantEligibilityResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEsaGoalResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEsaGoalResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEsaGoalResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEsaGoalResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEsaGoalResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEsaGoalResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEsaGoalResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEsaGoalResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEsaGoalResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEsaGoalResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEsaGoalResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEsaGoalResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEsaGoalResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEsaGoalResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEsaGoalResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEsaGoalResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEsaGoalResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostEsaGoalResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantIdentityVerificationResponseMock = (overrideResponse = {})=>({
        beacon: faker.helpers.arrayElement([
            {
                clientId: faker.word.sample(),
                createdAt: faker.word.sample(),
                id: faker.word.sample(),
                requestId: faker.word.sample(),
                status: faker.word.sample(),
                updatedAt: faker.word.sample()
            },
            undefined
        ]),
        cipStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        idVerResponse: faker.helpers.arrayElement([
            {
                clientId: faker.word.sample(),
                completedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                createdAt: faker.word.sample(),
                id: faker.word.sample(),
                requestId: faker.word.sample(),
                status: faker.word.sample(),
                steps: {
                    acceptTos: faker.word.sample(),
                    documentaryVerification: faker.word.sample(),
                    kycCheck: faker.word.sample(),
                    riskCheck: faker.word.sample(),
                    selfieCheck: faker.word.sample(),
                    verifySms: faker.word.sample(),
                    watchlistScreening: faker.word.sample()
                },
                token: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                verificationUrl: faker.word.sample()
            },
            undefined
        ]),
        requiredDocUploads: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>faker.word.sample()),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetParticipantIdentityVerificationResponseMock200 = (overrideResponse = {})=>({
        beacon: faker.helpers.arrayElement([
            {
                clientId: faker.word.sample(),
                createdAt: faker.word.sample(),
                id: faker.word.sample(),
                requestId: faker.word.sample(),
                status: faker.word.sample(),
                updatedAt: faker.word.sample()
            },
            undefined
        ]),
        cipStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        idVerResponse: faker.helpers.arrayElement([
            {
                clientId: faker.word.sample(),
                completedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                createdAt: faker.word.sample(),
                id: faker.word.sample(),
                requestId: faker.word.sample(),
                status: faker.word.sample(),
                steps: {
                    acceptTos: faker.word.sample(),
                    documentaryVerification: faker.word.sample(),
                    kycCheck: faker.word.sample(),
                    riskCheck: faker.word.sample(),
                    selfieCheck: faker.word.sample(),
                    verifySms: faker.word.sample(),
                    watchlistScreening: faker.word.sample()
                },
                token: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                verificationUrl: faker.word.sample()
            },
            undefined
        ]),
        requiredDocUploads: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>faker.word.sample()),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetParticipantIdentityVerificationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantIdentityVerificationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantIdentityVerificationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantIdentityVerificationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantIdentityVerificationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantIdentityVerificationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantIdentityVerificationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantIdentityVerificationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantIdentityVerificationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantIdentityVerificationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantIdentityVerificationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantIdentityVerificationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantIdentityVerificationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantIdentityVerificationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantIdentityVerificationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantIdentityVerificationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantIdentityVerificationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantIdentityVerificationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGoalFeedbackResponseMock = (overrideResponse = {})=>({
        data: {
            election: {
                age: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                ageToDrawSocialSecurity: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                annualIncome: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                currentGoalProbability: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                goalQuestionnaireId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                goalStrategyAnnualIncome: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                isSystemGenerated: faker.datatype.boolean(),
                outsideAccounts: Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>({
                        accountBalance: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        accountName: faker.word.sample(),
                        accountType: faker.word.sample()
                    })),
                outsideAccountsAnnualIncome: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                participantId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                production: faker.datatype.boolean(),
                retireAtAge: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                retirementDate: faker.word.sample(),
                retirementIncome: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                riskProfile: faker.helpers.arrayElement([
                    'aggressive',
                    'conservative',
                    'moderate'
                ]),
                saveMorePerMonth: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                socialSecurityAnnualIncome: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                spendLess: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                totalProjectedAnnualIncome: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                updatedAt: faker.word.sample(),
                updatedBy: {
                    authRole: faker.word.sample(),
                    id: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    idType: faker.word.sample()
                }
            },
            participant: {
                age: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            portfolio: {
                pieChart: Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>({
                        label: faker.word.sample(),
                        value: faker.number.int({
                            min: undefined,
                            max: undefined
                        })
                    })),
                table: Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>({
                        allocation: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        assetClass: faker.word.sample(),
                        id: faker.word.sample(),
                        targetAllocations: Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                allocation: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                assetAllocations: {
                                    bondNetPct: faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    }),
                                    cashNetPct: faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    }),
                                    otherNetPct: faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    }),
                                    stockNetPct: faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    })
                                },
                                assetClass: faker.word.sample(),
                                broadCategory: faker.word.sample(),
                                category: faker.word.sample(),
                                cusip: faker.helpers.arrayElement([
                                    faker.word.sample(),
                                    undefined
                                ]),
                                expenseRatioPct: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                                    faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    }),
                                    undefined
                                ]),
                                fiveYearPerformancePct: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                fundName: faker.word.sample(),
                                id: faker.word.sample(),
                                inceptionDate: faker.word.sample(),
                                itdBenchmarkPct: faker.helpers.arrayElement([
                                    faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    }),
                                    undefined
                                ]),
                                itdPct: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                name: faker.word.sample(),
                                oneYearBenchmarkPct: faker.helpers.arrayElement([
                                    faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    }),
                                    undefined
                                ]),
                                oneYearPerformancePct: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                performanceUpdatedAt: faker.helpers.arrayElement([
                                    faker.word.sample(),
                                    undefined
                                ]),
                                securityId: faker.helpers.arrayElement([
                                    faker.word.sample(),
                                    undefined
                                ]),
                                securityType: faker.word.sample(),
                                securityTypeName: faker.word.sample(),
                                shareClass: faker.word.sample(),
                                tenYearBenchmarkPct: faker.helpers.arrayElement([
                                    faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    }),
                                    undefined
                                ]),
                                tenYearPerformancePct: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                weightPct: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                ytdBenchmarkPct: faker.helpers.arrayElement([
                                    faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    }),
                                    undefined
                                ]),
                                ytdPct: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                })
                            }))
                    }))
            }
        },
        ...overrideResponse
    });
export const getGetGoalFeedbackResponseMock200 = (overrideResponse = {})=>({
        data: {
            election: {
                age: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                ageToDrawSocialSecurity: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                annualIncome: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                currentGoalProbability: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                goalQuestionnaireId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                goalStrategyAnnualIncome: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                isSystemGenerated: faker.datatype.boolean(),
                outsideAccounts: Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>({
                        accountBalance: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        accountName: faker.word.sample(),
                        accountType: faker.word.sample()
                    })),
                outsideAccountsAnnualIncome: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                participantId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                production: faker.datatype.boolean(),
                retireAtAge: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                retirementDate: faker.word.sample(),
                retirementIncome: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                riskProfile: faker.helpers.arrayElement([
                    'aggressive',
                    'conservative',
                    'moderate'
                ]),
                saveMorePerMonth: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                socialSecurityAnnualIncome: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                spendLess: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                totalProjectedAnnualIncome: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                updatedAt: faker.word.sample(),
                updatedBy: {
                    authRole: faker.word.sample(),
                    id: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    idType: faker.word.sample()
                }
            },
            participant: {
                age: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            portfolio: {
                pieChart: Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>({
                        label: faker.word.sample(),
                        value: faker.number.int({
                            min: undefined,
                            max: undefined
                        })
                    })),
                table: Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>({
                        allocation: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        assetClass: faker.word.sample(),
                        id: faker.word.sample(),
                        targetAllocations: Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                allocation: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                assetAllocations: {
                                    bondNetPct: faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    }),
                                    cashNetPct: faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    }),
                                    otherNetPct: faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    }),
                                    stockNetPct: faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    })
                                },
                                assetClass: faker.word.sample(),
                                broadCategory: faker.word.sample(),
                                category: faker.word.sample(),
                                cusip: faker.helpers.arrayElement([
                                    faker.word.sample(),
                                    undefined
                                ]),
                                expenseRatioPct: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                                    faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    }),
                                    undefined
                                ]),
                                fiveYearPerformancePct: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                fundName: faker.word.sample(),
                                id: faker.word.sample(),
                                inceptionDate: faker.word.sample(),
                                itdBenchmarkPct: faker.helpers.arrayElement([
                                    faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    }),
                                    undefined
                                ]),
                                itdPct: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                name: faker.word.sample(),
                                oneYearBenchmarkPct: faker.helpers.arrayElement([
                                    faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    }),
                                    undefined
                                ]),
                                oneYearPerformancePct: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                performanceUpdatedAt: faker.helpers.arrayElement([
                                    faker.word.sample(),
                                    undefined
                                ]),
                                securityId: faker.helpers.arrayElement([
                                    faker.word.sample(),
                                    undefined
                                ]),
                                securityType: faker.word.sample(),
                                securityTypeName: faker.word.sample(),
                                shareClass: faker.word.sample(),
                                tenYearBenchmarkPct: faker.helpers.arrayElement([
                                    faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    }),
                                    undefined
                                ]),
                                tenYearPerformancePct: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                weightPct: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                ytdBenchmarkPct: faker.helpers.arrayElement([
                                    faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    }),
                                    undefined
                                ]),
                                ytdPct: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                })
                            }))
                    }))
            }
        },
        ...overrideResponse
    });
export const getGetGoalFeedbackResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGoalFeedbackResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGoalFeedbackResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGoalFeedbackResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGoalFeedbackResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGoalFeedbackResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGoalFeedbackResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGoalFeedbackResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGoalFeedbackResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGoalFeedbackResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGoalFeedbackResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGoalFeedbackResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGoalFeedbackResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGoalFeedbackResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGoalFeedbackResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGoalFeedbackResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGoalFeedbackResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetGoalFeedbackResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetElectionsSetupResponseMock = (overrideResponse = {})=>({
        data: {
            document: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            election: faker.helpers.arrayElement([
                {
                    age: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    ageToDrawSocialSecurity: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    annualIncome: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    retirementIncome: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ])
                },
                undefined
            ]),
            feeDocumentId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            participant: {
                currentAge: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            }
        },
        ...overrideResponse
    });
export const getGetElectionsSetupResponseMock200 = (overrideResponse = {})=>({
        data: {
            document: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            election: faker.helpers.arrayElement([
                {
                    age: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    ageToDrawSocialSecurity: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    annualIncome: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    retirementIncome: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ])
                },
                undefined
            ]),
            feeDocumentId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            participant: {
                currentAge: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            }
        },
        ...overrideResponse
    });
export const getGetElectionsSetupResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetElectionsSetupResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetElectionsSetupResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetElectionsSetupResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetElectionsSetupResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetElectionsSetupResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetElectionsSetupResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetElectionsSetupResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetElectionsSetupResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetElectionsSetupResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetElectionsSetupResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetElectionsSetupResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetElectionsSetupResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetElectionsSetupResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetElectionsSetupResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetElectionsSetupResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetElectionsSetupResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetElectionsSetupResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostElectionsSetupResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostElectionsSetupResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostElectionsSetupResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostElectionsSetupResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostElectionsSetupResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostElectionsSetupResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostElectionsSetupResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostElectionsSetupResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostElectionsSetupResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostElectionsSetupResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostElectionsSetupResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostElectionsSetupResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostElectionsSetupResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostElectionsSetupResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostElectionsSetupResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostElectionsSetupResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostElectionsSetupResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostElectionsSetupResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetInvestmentsModelDisplayResponseMock = (overrideResponse = {})=>({
        asOfDate: faker.word.sample(),
        expenseRatioPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        fi360FactsheetPath: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        fiveYearBenchmarkPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        fiveYearPerformancePct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        inceptionDate: faker.word.sample(),
        inceptionToDateReturn: faker.number.int({
            min: undefined,
            max: undefined
        }),
        isDefault: faker.datatype.boolean(),
        itdBenchmarkPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        itdPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        metaAssetAllocations: {
            bondNetPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            cashNetPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            otherNetPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            stockNetPct: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        modelBoundaries: {
            riskLevel: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            targetRetireYearHigh: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            targetRetireYearLow: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            yearsToRetireHigh: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            yearsToRetireLow: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        },
        modelDescription: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        modelFundSecurity: faker.helpers.arrayElement([
            {
                assetAllocations: {
                    bondNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    cashNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    otherNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    stockNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                assetClass: faker.word.sample(),
                broadCategory: faker.word.sample(),
                category: faker.word.sample(),
                cusip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                id: faker.word.sample(),
                inceptionDate: faker.word.sample(),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityType: faker.word.sample(),
                securityTypeName: faker.word.sample(),
                shareClass: faker.word.sample(),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                weightPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            undefined
        ]),
        modelSecurities: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                assetAllocations: {
                    bondNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    cashNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    otherNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    stockNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                assetClass: faker.word.sample(),
                broadCategory: faker.word.sample(),
                category: faker.word.sample(),
                cusip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                id: faker.word.sample(),
                inceptionDate: faker.word.sample(),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityType: faker.word.sample(),
                securityTypeName: faker.word.sample(),
                shareClass: faker.word.sample(),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                weightPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        modelType: faker.helpers.arrayElement([
            'target',
            'risk',
            'menu',
            'pmenu',
            'goal',
            'ms_ma',
            'ms_ma_menu',
            'nli'
        ]),
        name: faker.word.sample(),
        oneYearBenchmarkPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        oneYearPerformancePct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        performanceUpdatedAt: faker.word.sample(),
        securityAllocations: {
            bondNetPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            cashNetPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            otherNetPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            stockNetPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        },
        tenYearBenchmarkPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        tenYearPerformancePct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        viewName: faker.word.sample(),
        ytdBenchmarkPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ytdPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetInvestmentsModelDisplayResponseMock200 = (overrideResponse = {})=>({
        asOfDate: faker.word.sample(),
        expenseRatioPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        fi360FactsheetPath: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        fiveYearBenchmarkPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        fiveYearPerformancePct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        inceptionDate: faker.word.sample(),
        inceptionToDateReturn: faker.number.int({
            min: undefined,
            max: undefined
        }),
        isDefault: faker.datatype.boolean(),
        itdBenchmarkPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        itdPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        metaAssetAllocations: {
            bondNetPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            cashNetPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            otherNetPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            stockNetPct: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        modelBoundaries: {
            riskLevel: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            targetRetireYearHigh: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            targetRetireYearLow: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            yearsToRetireHigh: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            yearsToRetireLow: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        },
        modelDescription: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        modelFundSecurity: faker.helpers.arrayElement([
            {
                assetAllocations: {
                    bondNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    cashNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    otherNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    stockNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                assetClass: faker.word.sample(),
                broadCategory: faker.word.sample(),
                category: faker.word.sample(),
                cusip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                id: faker.word.sample(),
                inceptionDate: faker.word.sample(),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityType: faker.word.sample(),
                securityTypeName: faker.word.sample(),
                shareClass: faker.word.sample(),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                weightPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            undefined
        ]),
        modelSecurities: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                assetAllocations: {
                    bondNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    cashNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    otherNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    stockNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                assetClass: faker.word.sample(),
                broadCategory: faker.word.sample(),
                category: faker.word.sample(),
                cusip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                id: faker.word.sample(),
                inceptionDate: faker.word.sample(),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                securityType: faker.word.sample(),
                securityTypeName: faker.word.sample(),
                shareClass: faker.word.sample(),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                weightPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        modelType: faker.helpers.arrayElement([
            'target',
            'risk',
            'menu',
            'pmenu',
            'goal',
            'ms_ma',
            'ms_ma_menu',
            'nli'
        ]),
        name: faker.word.sample(),
        oneYearBenchmarkPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        oneYearPerformancePct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        performanceUpdatedAt: faker.word.sample(),
        securityAllocations: {
            bondNetPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            cashNetPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            otherNetPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            stockNetPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        },
        tenYearBenchmarkPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        tenYearPerformancePct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        viewName: faker.word.sample(),
        ytdBenchmarkPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ytdPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetInvestmentsModelDisplayResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetInvestmentsModelDisplayResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetInvestmentsModelDisplayResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetInvestmentsModelDisplayResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetInvestmentsModelDisplayResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetInvestmentsModelDisplayResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetInvestmentsModelDisplayResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetInvestmentsModelDisplayResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetInvestmentsModelDisplayResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetInvestmentsModelDisplayResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetInvestmentsModelDisplayResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetInvestmentsModelDisplayResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetInvestmentsModelDisplayResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetInvestmentsModelDisplayResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetInvestmentsModelDisplayResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetInvestmentsModelDisplayResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetInvestmentsModelDisplayResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetInvestmentsModelDisplayResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRebalanceRequestResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRebalanceRequestResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRebalanceRequestResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRebalanceRequestResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRebalanceRequestResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRebalanceRequestResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRebalanceRequestResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRebalanceRequestResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRebalanceRequestResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRebalanceRequestResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRebalanceRequestResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRebalanceRequestResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRebalanceRequestResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRebalanceRequestResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRebalanceRequestResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRebalanceRequestResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRebalanceRequestResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRebalanceRequestResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRebalanceSettingsResponseMock = (overrideResponse = {})=>({
        autoRebalance: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getGetRebalanceSettingsResponseMock200 = (overrideResponse = {})=>({
        autoRebalance: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getGetRebalanceSettingsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRebalanceSettingsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRebalanceSettingsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRebalanceSettingsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRebalanceSettingsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRebalanceSettingsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRebalanceSettingsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRebalanceSettingsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRebalanceSettingsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRebalanceSettingsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRebalanceSettingsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRebalanceSettingsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRebalanceSettingsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRebalanceSettingsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRebalanceSettingsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRebalanceSettingsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRebalanceSettingsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRebalanceSettingsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRebalanceSettingsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRebalanceSettingsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRebalanceSettingsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRebalanceSettingsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRebalanceSettingsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRebalanceSettingsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRebalanceSettingsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRebalanceSettingsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRebalanceSettingsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRebalanceSettingsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRebalanceSettingsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRebalanceSettingsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRebalanceSettingsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRebalanceSettingsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRebalanceSettingsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRebalanceSettingsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRebalanceSettingsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRebalanceSettingsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetStrategiesIndexResponseMock = (overrideResponse = {})=>({
        currentlyInUse: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        defaultType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        modelTypes: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>faker.word.sample()),
        ...overrideResponse
    });
export const getGetStrategiesIndexResponseMock200 = (overrideResponse = {})=>({
        currentlyInUse: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        defaultType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        modelTypes: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>faker.word.sample()),
        ...overrideResponse
    });
export const getGetStrategiesIndexResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetStrategiesIndexResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetStrategiesIndexResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetStrategiesIndexResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetStrategiesIndexResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetStrategiesIndexResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetStrategiesIndexResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetStrategiesIndexResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetStrategiesIndexResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetStrategiesIndexResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetStrategiesIndexResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetStrategiesIndexResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetStrategiesIndexResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetStrategiesIndexResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetStrategiesIndexResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetStrategiesIndexResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetStrategiesIndexResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetStrategiesIndexResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAgeBasedResponseMock = (overrideResponse = {})=>({
        birthDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        models: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                asOfDate: faker.word.sample(),
                expenseRatioPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                fi360FactsheetPath: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                fiveYearBenchmarkPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                fiveYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                id: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                inceptionDate: faker.word.sample(),
                inceptionToDateReturn: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                isDefault: faker.datatype.boolean(),
                itdBenchmarkPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                itdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                metaAssetAllocations: {
                    bondNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    cashNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    otherNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    stockNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                modelBoundaries: {
                    riskLevel: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearLow: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireLow: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ])
                },
                modelDescription: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                modelFundSecurity: faker.helpers.arrayElement([
                    {
                        assetAllocations: {
                            bondNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            cashNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            otherNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            stockNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            })
                        },
                        assetClass: faker.word.sample(),
                        broadCategory: faker.word.sample(),
                        category: faker.word.sample(),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        expenseRatioPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        fiveYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        fiveYearPerformancePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        id: faker.word.sample(),
                        inceptionDate: faker.word.sample(),
                        itdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        itdPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        name: faker.word.sample(),
                        oneYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        oneYearPerformancePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        performanceUpdatedAt: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityType: faker.word.sample(),
                        securityTypeName: faker.word.sample(),
                        shareClass: faker.word.sample(),
                        tenYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        tenYearPerformancePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        weightPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        ytdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        ytdPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        })
                    },
                    undefined
                ]),
                modelSecurities: Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>({
                        assetAllocations: {
                            bondNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            cashNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            otherNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            stockNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            })
                        },
                        assetClass: faker.word.sample(),
                        broadCategory: faker.word.sample(),
                        category: faker.word.sample(),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        expenseRatioPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        fiveYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        fiveYearPerformancePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        id: faker.word.sample(),
                        inceptionDate: faker.word.sample(),
                        itdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        itdPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        name: faker.word.sample(),
                        oneYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        oneYearPerformancePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        performanceUpdatedAt: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityType: faker.word.sample(),
                        securityTypeName: faker.word.sample(),
                        shareClass: faker.word.sample(),
                        tenYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        tenYearPerformancePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        weightPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        ytdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        ytdPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        })
                    })),
                modelType: faker.helpers.arrayElement([
                    'target',
                    'risk',
                    'menu',
                    'pmenu',
                    'goal',
                    'ms_ma',
                    'ms_ma_menu',
                    'nli'
                ]),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                oneYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                performanceUpdatedAt: faker.word.sample(),
                securityAllocations: {
                    bondNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    cashNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    otherNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    stockNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ])
                },
                tenYearBenchmarkPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                tenYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                viewName: faker.word.sample(),
                ytdBenchmarkPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                ytdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        participantAge: faker.number.int({
            min: undefined,
            max: undefined
        }),
        retirementAge: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAgeBasedResponseMock200 = (overrideResponse = {})=>({
        birthDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        models: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                asOfDate: faker.word.sample(),
                expenseRatioPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                fi360FactsheetPath: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                fiveYearBenchmarkPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                fiveYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                id: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                inceptionDate: faker.word.sample(),
                inceptionToDateReturn: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                isDefault: faker.datatype.boolean(),
                itdBenchmarkPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                itdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                metaAssetAllocations: {
                    bondNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    cashNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    otherNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    stockNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                modelBoundaries: {
                    riskLevel: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearLow: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireLow: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ])
                },
                modelDescription: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                modelFundSecurity: faker.helpers.arrayElement([
                    {
                        assetAllocations: {
                            bondNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            cashNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            otherNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            stockNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            })
                        },
                        assetClass: faker.word.sample(),
                        broadCategory: faker.word.sample(),
                        category: faker.word.sample(),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        expenseRatioPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        fiveYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        fiveYearPerformancePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        id: faker.word.sample(),
                        inceptionDate: faker.word.sample(),
                        itdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        itdPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        name: faker.word.sample(),
                        oneYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        oneYearPerformancePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        performanceUpdatedAt: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityType: faker.word.sample(),
                        securityTypeName: faker.word.sample(),
                        shareClass: faker.word.sample(),
                        tenYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        tenYearPerformancePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        weightPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        ytdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        ytdPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        })
                    },
                    undefined
                ]),
                modelSecurities: Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>({
                        assetAllocations: {
                            bondNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            cashNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            otherNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            stockNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            })
                        },
                        assetClass: faker.word.sample(),
                        broadCategory: faker.word.sample(),
                        category: faker.word.sample(),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        expenseRatioPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        fiveYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        fiveYearPerformancePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        id: faker.word.sample(),
                        inceptionDate: faker.word.sample(),
                        itdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        itdPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        name: faker.word.sample(),
                        oneYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        oneYearPerformancePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        performanceUpdatedAt: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityType: faker.word.sample(),
                        securityTypeName: faker.word.sample(),
                        shareClass: faker.word.sample(),
                        tenYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        tenYearPerformancePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        weightPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        ytdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        ytdPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        })
                    })),
                modelType: faker.helpers.arrayElement([
                    'target',
                    'risk',
                    'menu',
                    'pmenu',
                    'goal',
                    'ms_ma',
                    'ms_ma_menu',
                    'nli'
                ]),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                oneYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                performanceUpdatedAt: faker.word.sample(),
                securityAllocations: {
                    bondNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    cashNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    otherNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    stockNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ])
                },
                tenYearBenchmarkPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                tenYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                viewName: faker.word.sample(),
                ytdBenchmarkPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                ytdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        participantAge: faker.number.int({
            min: undefined,
            max: undefined
        }),
        retirementAge: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAgeBasedResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAgeBasedResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAgeBasedResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAgeBasedResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAgeBasedResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAgeBasedResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAgeBasedResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAgeBasedResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAgeBasedResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAgeBasedResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAgeBasedResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAgeBasedResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAgeBasedResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAgeBasedResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAgeBasedResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAgeBasedResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAgeBasedResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAgeBasedResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAgeBasedResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAgeBasedResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAgeBasedResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAgeBasedResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAgeBasedResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAgeBasedResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAgeBasedResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAgeBasedResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAgeBasedResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAgeBasedResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAgeBasedResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAgeBasedResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAgeBasedResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAgeBasedResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAgeBasedResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAgeBasedResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAgeBasedResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutAgeBasedResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskBasedResponseMock = (overrideResponse = {})=>({
        models: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                asOfDate: faker.word.sample(),
                expenseRatioPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                fi360FactsheetPath: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                fiveYearBenchmarkPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                fiveYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                id: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                inceptionDate: faker.word.sample(),
                inceptionToDateReturn: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                isDefault: faker.datatype.boolean(),
                itdBenchmarkPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                itdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                metaAssetAllocations: {
                    bondNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    cashNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    otherNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    stockNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                modelBoundaries: {
                    riskLevel: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearLow: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireLow: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ])
                },
                modelDescription: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                modelFundSecurity: faker.helpers.arrayElement([
                    {
                        assetAllocations: {
                            bondNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            cashNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            otherNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            stockNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            })
                        },
                        assetClass: faker.word.sample(),
                        broadCategory: faker.word.sample(),
                        category: faker.word.sample(),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        expenseRatioPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        fiveYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        fiveYearPerformancePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        id: faker.word.sample(),
                        inceptionDate: faker.word.sample(),
                        itdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        itdPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        name: faker.word.sample(),
                        oneYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        oneYearPerformancePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        performanceUpdatedAt: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityType: faker.word.sample(),
                        securityTypeName: faker.word.sample(),
                        shareClass: faker.word.sample(),
                        tenYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        tenYearPerformancePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        weightPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        ytdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        ytdPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        })
                    },
                    undefined
                ]),
                modelSecurities: Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>({
                        assetAllocations: {
                            bondNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            cashNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            otherNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            stockNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            })
                        },
                        assetClass: faker.word.sample(),
                        broadCategory: faker.word.sample(),
                        category: faker.word.sample(),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        expenseRatioPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        fiveYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        fiveYearPerformancePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        id: faker.word.sample(),
                        inceptionDate: faker.word.sample(),
                        itdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        itdPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        name: faker.word.sample(),
                        oneYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        oneYearPerformancePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        performanceUpdatedAt: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityType: faker.word.sample(),
                        securityTypeName: faker.word.sample(),
                        shareClass: faker.word.sample(),
                        tenYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        tenYearPerformancePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        weightPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        ytdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        ytdPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        })
                    })),
                modelType: faker.helpers.arrayElement([
                    'target',
                    'risk',
                    'menu',
                    'pmenu',
                    'goal',
                    'ms_ma',
                    'ms_ma_menu',
                    'nli'
                ]),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                oneYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                performanceUpdatedAt: faker.word.sample(),
                securityAllocations: {
                    bondNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    cashNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    otherNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    stockNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ])
                },
                tenYearBenchmarkPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                tenYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                viewName: faker.word.sample(),
                ytdBenchmarkPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                ytdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        programId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskBasedResponseMock200 = (overrideResponse = {})=>({
        models: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                asOfDate: faker.word.sample(),
                expenseRatioPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                fi360FactsheetPath: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                fiveYearBenchmarkPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                fiveYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                id: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                inceptionDate: faker.word.sample(),
                inceptionToDateReturn: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                isDefault: faker.datatype.boolean(),
                itdBenchmarkPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                itdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                metaAssetAllocations: {
                    bondNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    cashNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    otherNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    stockNetPct: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                modelBoundaries: {
                    riskLevel: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearLow: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireLow: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ])
                },
                modelDescription: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                modelFundSecurity: faker.helpers.arrayElement([
                    {
                        assetAllocations: {
                            bondNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            cashNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            otherNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            stockNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            })
                        },
                        assetClass: faker.word.sample(),
                        broadCategory: faker.word.sample(),
                        category: faker.word.sample(),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        expenseRatioPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        fiveYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        fiveYearPerformancePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        id: faker.word.sample(),
                        inceptionDate: faker.word.sample(),
                        itdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        itdPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        name: faker.word.sample(),
                        oneYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        oneYearPerformancePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        performanceUpdatedAt: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityType: faker.word.sample(),
                        securityTypeName: faker.word.sample(),
                        shareClass: faker.word.sample(),
                        tenYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        tenYearPerformancePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        weightPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        ytdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        ytdPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        })
                    },
                    undefined
                ]),
                modelSecurities: Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>({
                        assetAllocations: {
                            bondNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            cashNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            otherNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            stockNetPct: faker.number.int({
                                min: undefined,
                                max: undefined
                            })
                        },
                        assetClass: faker.word.sample(),
                        broadCategory: faker.word.sample(),
                        category: faker.word.sample(),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        expenseRatioPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        fiveYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        fiveYearPerformancePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        id: faker.word.sample(),
                        inceptionDate: faker.word.sample(),
                        itdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        itdPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        name: faker.word.sample(),
                        oneYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        oneYearPerformancePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        performanceUpdatedAt: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        securityType: faker.word.sample(),
                        securityTypeName: faker.word.sample(),
                        shareClass: faker.word.sample(),
                        tenYearBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        tenYearPerformancePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        weightPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        ytdBenchmarkPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        ytdPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        })
                    })),
                modelType: faker.helpers.arrayElement([
                    'target',
                    'risk',
                    'menu',
                    'pmenu',
                    'goal',
                    'ms_ma',
                    'ms_ma_menu',
                    'nli'
                ]),
                name: faker.word.sample(),
                oneYearBenchmarkPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                oneYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                performanceUpdatedAt: faker.word.sample(),
                securityAllocations: {
                    bondNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    cashNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    otherNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    stockNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ])
                },
                tenYearBenchmarkPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                tenYearPerformancePct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                viewName: faker.word.sample(),
                ytdBenchmarkPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                ytdPct: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        programId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskBasedResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskBasedResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskBasedResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskBasedResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskBasedResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskBasedResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskBasedResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskBasedResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskBasedResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskBasedResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskBasedResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskBasedResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskBasedResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskBasedResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskBasedResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskBasedResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskBasedResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskBasedResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRiskBasedResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRiskBasedResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRiskBasedResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRiskBasedResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRiskBasedResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRiskBasedResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRiskBasedResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRiskBasedResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRiskBasedResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRiskBasedResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRiskBasedResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRiskBasedResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRiskBasedResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRiskBasedResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRiskBasedResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRiskBasedResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRiskBasedResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutRiskBasedResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskModelQuestionnaireResponseMock = (overrideResponse = {})=>({
        modelId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        name: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        riskValue1High: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        riskValue1Low: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetRiskModelQuestionnaireResponseMock200 = (overrideResponse = {})=>({
        modelId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        name: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        riskValue1High: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        riskValue1Low: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetRiskModelQuestionnaireResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskModelQuestionnaireResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskModelQuestionnaireResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskModelQuestionnaireResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskModelQuestionnaireResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskModelQuestionnaireResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskModelQuestionnaireResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskModelQuestionnaireResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskModelQuestionnaireResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskModelQuestionnaireResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskModelQuestionnaireResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskModelQuestionnaireResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskModelQuestionnaireResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskModelQuestionnaireResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskModelQuestionnaireResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskModelQuestionnaireResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskModelQuestionnaireResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskModelQuestionnaireResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMailPreferencesResponseMock = (overrideResponse = {})=>({
        isWiredAtWork: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        paperlessNotices: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetMailPreferencesResponseMock200 = (overrideResponse = {})=>({
        isWiredAtWork: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        paperlessNotices: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetMailPreferencesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMailPreferencesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMailPreferencesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMailPreferencesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMailPreferencesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMailPreferencesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMailPreferencesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMailPreferencesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMailPreferencesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMailPreferencesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMailPreferencesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMailPreferencesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMailPreferencesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMailPreferencesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMailPreferencesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMailPreferencesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMailPreferencesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetMailPreferencesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutMailPreferencesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutMailPreferencesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutMailPreferencesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutMailPreferencesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutMailPreferencesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutMailPreferencesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutMailPreferencesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutMailPreferencesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutMailPreferencesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutMailPreferencesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutMailPreferencesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutMailPreferencesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutMailPreferencesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutMailPreferencesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutMailPreferencesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutMailPreferencesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutMailPreferencesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutMailPreferencesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOnboardingResponseMock = (overrideResponse = {})=>({
        autoEnrollAmount: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        contribution: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        contributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        deferInDollars: faker.datatype.boolean(),
        esaProgramSponsorPlanFree: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        keepExistingRate: faker.datatype.boolean(),
        participantChangedDeferralAt: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                faker.word.sample(),
                null
            ]),
            undefined
        ]),
        rothContribution: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        rothContributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        safeHarborStrategy: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetParticipantOnboardingResponseMock200 = (overrideResponse = {})=>({
        autoEnrollAmount: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        contribution: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        contributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        deferInDollars: faker.datatype.boolean(),
        esaProgramSponsorPlanFree: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        keepExistingRate: faker.datatype.boolean(),
        participantChangedDeferralAt: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                faker.word.sample(),
                null
            ]),
            undefined
        ]),
        rothContribution: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        rothContributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        safeHarborStrategy: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetParticipantOnboardingResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOnboardingResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOnboardingResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOnboardingResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOnboardingResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOnboardingResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOnboardingResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOnboardingResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOnboardingResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOnboardingResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOnboardingResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOnboardingResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOnboardingResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOnboardingResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOnboardingResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOnboardingResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOnboardingResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOnboardingResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOverviewResponseMock = (overrideResponse = {})=>({
        allowRothDeferrals: faker.datatype.boolean(),
        transfers: {
            isEffectiveDateUpcoming: faker.datatype.boolean(),
            loan: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            rollover: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            rolloverIntoAccountAllowed: faker.datatype.boolean()
        },
        ytdContributions: {
            limit: faker.number.int({
                min: undefined,
                max: undefined
            }),
            total: faker.number.int({
                min: undefined,
                max: undefined
            }),
            year: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        ...overrideResponse
    });
export const getGetParticipantOverviewResponseMock200 = (overrideResponse = {})=>({
        allowRothDeferrals: faker.datatype.boolean(),
        transfers: {
            isEffectiveDateUpcoming: faker.datatype.boolean(),
            loan: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            rollover: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            rolloverIntoAccountAllowed: faker.datatype.boolean()
        },
        ytdContributions: {
            limit: faker.number.int({
                min: undefined,
                max: undefined
            }),
            total: faker.number.int({
                min: undefined,
                max: undefined
            }),
            year: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        ...overrideResponse
    });
export const getGetParticipantOverviewResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOverviewResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOverviewResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOverviewResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOverviewResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOverviewResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOverviewResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOverviewResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOverviewResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOverviewResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOverviewResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOverviewResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOverviewResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOverviewResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOverviewResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOverviewResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOverviewResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOverviewResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBalanceResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            availableBalance: faker.number.int({
                min: undefined,
                max: undefined
            }),
            currentBalance: faker.number.int({
                min: undefined,
                max: undefined
            }),
            institutionId: faker.word.sample(),
            itemId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            plaidAccountId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            plaidAccountSubtype: faker.helpers.arrayElement([
                '401a',
                '401k',
                '403B',
                '457b',
                '529',
                'brokerage',
                'cash isa',
                'crypto exchange',
                'education savings account',
                'ebt',
                'fixed annuity',
                'gic',
                'health reimbursement arrangement',
                'hsa',
                'isa',
                'ira',
                'lif',
                'life insurance',
                'lira',
                'lrif',
                'lrsp',
                'non-custodial wallet',
                'non-taxable brokerage account',
                'other',
                'other insurance',
                'other annuity',
                'prif',
                'rdsp',
                'resp',
                'rlif',
                'rrif',
                'pension',
                'profit sharing plan',
                'retirement',
                'roth',
                'roth 401k',
                'rrsp',
                'sep ira',
                'simple ira',
                'sipp',
                'stock plan',
                'thrift savings plan',
                'tfsa',
                'trust',
                'ugma',
                'variable annuity',
                'credit card',
                'paypal',
                'cd',
                'checking',
                'savings',
                'money market',
                'prepaid',
                'auto',
                'business',
                'commercial',
                'construction',
                'consumer',
                'home equity',
                'loan',
                'mortgage',
                'overdraft',
                'line of credit',
                'student',
                'cash management',
                'keogh',
                'mutual fund',
                'recurring',
                'rewards',
                'safe deposit',
                'sarsep',
                'payroll',
                'null'
            ]),
            plaidAccountType: faker.helpers.arrayElement([
                'investment',
                'credit',
                'depository',
                'loan',
                'brokerage',
                'other'
            ])
        }));
export const getPostParticipantPlaidLinksBalanceResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            availableBalance: faker.number.int({
                min: undefined,
                max: undefined
            }),
            currentBalance: faker.number.int({
                min: undefined,
                max: undefined
            }),
            institutionId: faker.word.sample(),
            itemId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            plaidAccountId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            plaidAccountSubtype: faker.helpers.arrayElement([
                '401a',
                '401k',
                '403B',
                '457b',
                '529',
                'brokerage',
                'cash isa',
                'crypto exchange',
                'education savings account',
                'ebt',
                'fixed annuity',
                'gic',
                'health reimbursement arrangement',
                'hsa',
                'isa',
                'ira',
                'lif',
                'life insurance',
                'lira',
                'lrif',
                'lrsp',
                'non-custodial wallet',
                'non-taxable brokerage account',
                'other',
                'other insurance',
                'other annuity',
                'prif',
                'rdsp',
                'resp',
                'rlif',
                'rrif',
                'pension',
                'profit sharing plan',
                'retirement',
                'roth',
                'roth 401k',
                'rrsp',
                'sep ira',
                'simple ira',
                'sipp',
                'stock plan',
                'thrift savings plan',
                'tfsa',
                'trust',
                'ugma',
                'variable annuity',
                'credit card',
                'paypal',
                'cd',
                'checking',
                'savings',
                'money market',
                'prepaid',
                'auto',
                'business',
                'commercial',
                'construction',
                'consumer',
                'home equity',
                'loan',
                'mortgage',
                'overdraft',
                'line of credit',
                'student',
                'cash management',
                'keogh',
                'mutual fund',
                'recurring',
                'rewards',
                'safe deposit',
                'sarsep',
                'payroll',
                'null'
            ]),
            plaidAccountType: faker.helpers.arrayElement([
                'investment',
                'credit',
                'depository',
                'loan',
                'brokerage',
                'other'
            ])
        }));
export const getPostParticipantPlaidLinksBalanceResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBalanceResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBalanceResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBalanceResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBalanceResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBalanceResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBalanceResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBalanceResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBalanceResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBalanceResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBalanceResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBalanceResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBalanceResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBalanceResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBalanceResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBalanceResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBalanceResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBalanceResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBankAccountResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBankAccountResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBankAccountResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBankAccountResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBankAccountResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBankAccountResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBankAccountResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBankAccountResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBankAccountResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBankAccountResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBankAccountResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBankAccountResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBankAccountResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBankAccountResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBankAccountResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBankAccountResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBankAccountResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantPlaidLinksBankAccountResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantDiscardPendingPlaidLinksResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantDiscardPendingPlaidLinksResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantDiscardPendingPlaidLinksResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantDiscardPendingPlaidLinksResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantDiscardPendingPlaidLinksResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantDiscardPendingPlaidLinksResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantDiscardPendingPlaidLinksResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantDiscardPendingPlaidLinksResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantDiscardPendingPlaidLinksResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantDiscardPendingPlaidLinksResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantDiscardPendingPlaidLinksResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantDiscardPendingPlaidLinksResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantDiscardPendingPlaidLinksResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantDiscardPendingPlaidLinksResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantDiscardPendingPlaidLinksResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantDiscardPendingPlaidLinksResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantDiscardPendingPlaidLinksResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantDiscardPendingPlaidLinksResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPositionsResponseMock = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    attributes: faker.helpers.arrayElement([
                        {
                            assetClass: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            balance: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            broadAssetClass: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            cusip: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            expenseRatioPct: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            fundName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            securityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            shares: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            vestedBalance: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            vestedShares: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            weight: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    id: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    type: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            undefined
        ]),
        stats: faker.helpers.arrayElement([
            {
                assetAllocations: faker.helpers.arrayElement([
                    {
                        bondNet: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        bondNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        cashNet: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        cashNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        otherNet: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        otherNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        stockNet: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        stockNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                modelAllocations: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            balance: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            model: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            modelId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            percent: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ])
                        })),
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getGetPositionsResponseMock200 = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    attributes: faker.helpers.arrayElement([
                        {
                            assetClass: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            balance: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            broadAssetClass: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            cusip: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            expenseRatioPct: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            fundName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            securityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            shares: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            vestedBalance: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            vestedShares: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            weight: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    id: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    type: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            undefined
        ]),
        stats: faker.helpers.arrayElement([
            {
                assetAllocations: faker.helpers.arrayElement([
                    {
                        bondNet: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        bondNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        cashNet: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        cashNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        otherNet: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        otherNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        stockNet: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        stockNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                modelAllocations: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            balance: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            model: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            modelId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            percent: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ])
                        })),
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getGetPositionsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPositionsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPositionsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPositionsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPositionsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPositionsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPositionsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPositionsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPositionsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPositionsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPositionsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPositionsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPositionsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPositionsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPositionsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPositionsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPositionsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPositionsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQboadWithdrawalsResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            availableAmount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            birthOrAdoptionDate: faker.word.sample(),
            childFirstName: faker.word.sample(),
            childLastName: faker.word.sample(),
            childSsn: faker.word.sample(),
            disabled: faker.datatype.boolean(),
            disabledReason: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            validUntil: faker.word.sample()
        }));
export const getGetQboadWithdrawalsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            availableAmount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            birthOrAdoptionDate: faker.word.sample(),
            childFirstName: faker.word.sample(),
            childLastName: faker.word.sample(),
            childSsn: faker.word.sample(),
            disabled: faker.datatype.boolean(),
            disabledReason: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            validUntil: faker.word.sample()
        }));
export const getGetQboadWithdrawalsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQboadWithdrawalsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQboadWithdrawalsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQboadWithdrawalsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQboadWithdrawalsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQboadWithdrawalsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQboadWithdrawalsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQboadWithdrawalsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQboadWithdrawalsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQboadWithdrawalsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQboadWithdrawalsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQboadWithdrawalsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQboadWithdrawalsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQboadWithdrawalsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQboadWithdrawalsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQboadWithdrawalsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQboadWithdrawalsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQboadWithdrawalsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRolloverResponseMock = (overrideResponse = {})=>({
        attributes: {
            accountProvider: faker.word.sample(),
            accountType: {},
            createdAt: faker.word.sample(),
            letterDocumentId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            participantId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            preTaxAmount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            rothAmount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            rothCostBasis: faker.number.int({
                min: undefined,
                max: undefined
            }),
            rothStartDate: faker.word.sample(),
            status: {}
        },
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        type: faker.word.sample(),
        ...overrideResponse
    });
export const getGetParticipantRolloverResponseMock200 = (overrideResponse = {})=>({
        attributes: {
            accountProvider: faker.word.sample(),
            accountType: {},
            createdAt: faker.word.sample(),
            letterDocumentId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            participantId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            preTaxAmount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            rothAmount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            rothCostBasis: faker.number.int({
                min: undefined,
                max: undefined
            }),
            rothStartDate: faker.word.sample(),
            status: {}
        },
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        type: faker.word.sample(),
        ...overrideResponse
    });
export const getGetParticipantRolloverResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRolloverResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRolloverResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRolloverResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRolloverResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRolloverResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRolloverResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRolloverResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRolloverResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRolloverResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRolloverResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRolloverResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRolloverResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRolloverResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRolloverResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRolloverResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRolloverResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantRolloverResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSavingsDisplayResponseMock = (overrideResponse = {})=>({
        afterTaxAmount: {
            amount: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            type: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        age: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        allowDollarAmounts: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        allowRothDeferrals: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        catchUpLimit: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        employeeLimit: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        preTaxAmount: {
            amount: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            type: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        rothAmount: {
            amount: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            type: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        safeHarborMatchType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        safeHarborMatchTypeDescription: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        superCatchUpLimit: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        ytdContributions: {
            limit: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            total: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            year: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        ...overrideResponse
    });
export const getGetSavingsDisplayResponseMock200 = (overrideResponse = {})=>({
        afterTaxAmount: {
            amount: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            type: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        age: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        allowDollarAmounts: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        allowRothDeferrals: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        catchUpLimit: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        employeeLimit: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        preTaxAmount: {
            amount: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            type: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        rothAmount: {
            amount: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            type: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        safeHarborMatchType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        safeHarborMatchTypeDescription: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        superCatchUpLimit: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        ytdContributions: {
            limit: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            total: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            year: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        ...overrideResponse
    });
export const getGetSavingsDisplayResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSavingsDisplayResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSavingsDisplayResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSavingsDisplayResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSavingsDisplayResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSavingsDisplayResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSavingsDisplayResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSavingsDisplayResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSavingsDisplayResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSavingsDisplayResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSavingsDisplayResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSavingsDisplayResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSavingsDisplayResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSavingsDisplayResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSavingsDisplayResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSavingsDisplayResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSavingsDisplayResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSavingsDisplayResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAggregatedByCategoryTransactionsResponseMock = (overrideResponse = {})=>({
        asOfDate: faker.word.sample(),
        transactions: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    amount: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    category: faker.word.sample()
                })),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetParticipantAggregatedByCategoryTransactionsResponseMock200 = (overrideResponse = {})=>({
        asOfDate: faker.word.sample(),
        transactions: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    amount: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    category: faker.word.sample()
                })),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetParticipantAggregatedByCategoryTransactionsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAggregatedByCategoryTransactionsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAggregatedByCategoryTransactionsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAggregatedByCategoryTransactionsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAggregatedByCategoryTransactionsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAggregatedByCategoryTransactionsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAggregatedByCategoryTransactionsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAggregatedByCategoryTransactionsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAggregatedByCategoryTransactionsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAggregatedByCategoryTransactionsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAggregatedByCategoryTransactionsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAggregatedByCategoryTransactionsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAggregatedByCategoryTransactionsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAggregatedByCategoryTransactionsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAggregatedByCategoryTransactionsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAggregatedByCategoryTransactionsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAggregatedByCategoryTransactionsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantAggregatedByCategoryTransactionsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllowedWithdrawalReasonsResponseMock = (overrideResponse = {})=>({
        allowedReasons: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    afterTaxAvailableAmount: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    afterTaxMaxAmount: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    disabled: faker.datatype.boolean(),
                    distributionMethods: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                        undefined
                    ]),
                    fee: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    maxAmount: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    preTaxAvailableAmount: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    preTaxMaxAmount: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    qboadSupported: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    reason: faker.word.sample(),
                    rothAvailableAmount: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    rothMaxAmount: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                })),
            undefined
        ]),
        disallowedReasons: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>faker.word.sample()),
            undefined
        ]),
        fullyVestedPreTaxBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        fullyVestedRothBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        overnightCheckFee: faker.number.int({
            min: undefined,
            max: undefined
        }),
        rolloverPreTaxBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        rolloverRothBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        sdbaPreTaxBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        sdbaRothBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        totalPreTaxBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        totalRothBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        vestedPreTaxBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        vestedRothBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        wireFee: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllowedWithdrawalReasonsResponseMock200 = (overrideResponse = {})=>({
        allowedReasons: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    afterTaxAvailableAmount: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    afterTaxMaxAmount: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    disabled: faker.datatype.boolean(),
                    distributionMethods: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                        undefined
                    ]),
                    fee: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    maxAmount: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    preTaxAvailableAmount: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    preTaxMaxAmount: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    qboadSupported: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    reason: faker.word.sample(),
                    rothAvailableAmount: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    rothMaxAmount: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                })),
            undefined
        ]),
        disallowedReasons: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>faker.word.sample()),
            undefined
        ]),
        fullyVestedPreTaxBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        fullyVestedRothBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        overnightCheckFee: faker.number.int({
            min: undefined,
            max: undefined
        }),
        rolloverPreTaxBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        rolloverRothBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        sdbaPreTaxBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        sdbaRothBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        totalPreTaxBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        totalRothBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        vestedPreTaxBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        vestedRothBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        wireFee: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllowedWithdrawalReasonsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllowedWithdrawalReasonsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllowedWithdrawalReasonsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllowedWithdrawalReasonsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllowedWithdrawalReasonsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllowedWithdrawalReasonsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllowedWithdrawalReasonsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllowedWithdrawalReasonsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllowedWithdrawalReasonsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllowedWithdrawalReasonsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllowedWithdrawalReasonsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllowedWithdrawalReasonsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllowedWithdrawalReasonsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllowedWithdrawalReasonsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllowedWithdrawalReasonsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllowedWithdrawalReasonsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllowedWithdrawalReasonsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllowedWithdrawalReasonsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchOverrideParticipantEligibilityResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchOverrideParticipantEligibilityResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchOverrideParticipantEligibilityResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchOverrideParticipantEligibilityResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchOverrideParticipantEligibilityResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchOverrideParticipantEligibilityResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchOverrideParticipantEligibilityResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchOverrideParticipantEligibilityResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchOverrideParticipantEligibilityResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchOverrideParticipantEligibilityResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchOverrideParticipantEligibilityResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchOverrideParticipantEligibilityResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchOverrideParticipantEligibilityResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchOverrideParticipantEligibilityResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchOverrideParticipantEligibilityResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchOverrideParticipantEligibilityResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchOverrideParticipantEligibilityResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchOverrideParticipantEligibilityResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEligibleAutoEnrolledParticipantsResponseMock = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            {
                autoEnrolledParticipants: Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>({
                        contribution: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        contributionType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        eligibilityStatus: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        eligibilityStatusId: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        email: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        entryDate: faker.word.sample(),
                        firstName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        lastName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        loginUserId: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        participantId: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        personalEmail: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        ssnSuffix: faker.word.sample(),
                        workEmail: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    })),
                meta: {
                    total: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                }
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getGetEligibleAutoEnrolledParticipantsResponseMock200 = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            {
                autoEnrolledParticipants: Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>({
                        contribution: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        contributionType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        eligibilityStatus: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        eligibilityStatusId: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        email: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        entryDate: faker.word.sample(),
                        firstName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        lastName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        loginUserId: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        participantId: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        personalEmail: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        ssnSuffix: faker.word.sample(),
                        workEmail: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    })),
                meta: {
                    total: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                }
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getGetEligibleAutoEnrolledParticipantsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEligibleAutoEnrolledParticipantsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEligibleAutoEnrolledParticipantsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEligibleAutoEnrolledParticipantsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEligibleAutoEnrolledParticipantsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEligibleAutoEnrolledParticipantsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEligibleAutoEnrolledParticipantsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEligibleAutoEnrolledParticipantsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEligibleAutoEnrolledParticipantsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEligibleAutoEnrolledParticipantsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEligibleAutoEnrolledParticipantsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEligibleAutoEnrolledParticipantsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEligibleAutoEnrolledParticipantsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEligibleAutoEnrolledParticipantsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEligibleAutoEnrolledParticipantsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEligibleAutoEnrolledParticipantsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEligibleAutoEnrolledParticipantsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEligibleAutoEnrolledParticipantsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantOptOutEmailDownloadResponseMock = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getGetParticipantOptOutEmailDownloadResponseMock200 = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getGetOptedOutAutoEnrolledParticipantsResponseMock = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            {
                meta: {
                    total: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                optedOutParticipants: Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>({
                        firstName: faker.word.sample(),
                        lastName: faker.word.sample(),
                        optedOutAt: faker.word.sample(),
                        optedOutByUserEmail: faker.word.sample(),
                        optedOutByUserId: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        participantId: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        ssnSuffix: faker.word.sample()
                    }))
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getGetOptedOutAutoEnrolledParticipantsResponseMock200 = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            {
                meta: {
                    total: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                optedOutParticipants: Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>({
                        firstName: faker.word.sample(),
                        lastName: faker.word.sample(),
                        optedOutAt: faker.word.sample(),
                        optedOutByUserEmail: faker.word.sample(),
                        optedOutByUserId: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        participantId: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        ssnSuffix: faker.word.sample()
                    }))
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getGetOptedOutAutoEnrolledParticipantsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOptedOutAutoEnrolledParticipantsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOptedOutAutoEnrolledParticipantsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOptedOutAutoEnrolledParticipantsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOptedOutAutoEnrolledParticipantsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOptedOutAutoEnrolledParticipantsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOptedOutAutoEnrolledParticipantsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOptedOutAutoEnrolledParticipantsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOptedOutAutoEnrolledParticipantsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOptedOutAutoEnrolledParticipantsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOptedOutAutoEnrolledParticipantsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOptedOutAutoEnrolledParticipantsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOptedOutAutoEnrolledParticipantsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOptedOutAutoEnrolledParticipantsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOptedOutAutoEnrolledParticipantsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOptedOutAutoEnrolledParticipantsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOptedOutAutoEnrolledParticipantsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOptedOutAutoEnrolledParticipantsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsResponseMock = (overrideResponse = {})=>({
        participants: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    address1: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    eligibilityEntryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    eligibilityStatus: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    emailInfo: faker.helpers.arrayElement([
                        {
                            messageId: faker.word.sample(),
                            sentOn: faker.word.sample(),
                            sentTo: faker.word.sample()
                        },
                        undefined
                    ]),
                    emailType: faker.helpers.arrayElement([
                        {},
                        undefined
                    ]),
                    firstName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    id: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    lastName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    middleName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    personalEmail: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    ssn: faker.word.sample(),
                    state: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    status: faker.word.sample(),
                    workEmail: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    zip: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            undefined
        ]),
        totalCount: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsResponseMock200 = (overrideResponse = {})=>({
        participants: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    address1: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    eligibilityEntryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    eligibilityStatus: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    emailInfo: faker.helpers.arrayElement([
                        {
                            messageId: faker.word.sample(),
                            sentOn: faker.word.sample(),
                            sentTo: faker.word.sample()
                        },
                        undefined
                    ]),
                    emailType: faker.helpers.arrayElement([
                        {},
                        undefined
                    ]),
                    firstName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    id: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    lastName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    middleName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    personalEmail: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    ssn: faker.word.sample(),
                    state: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    status: faker.word.sample(),
                    workEmail: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    zip: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            undefined
        ]),
        totalCount: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsCountResponseMock = (overrideResponse = {})=>({
        count: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsCountResponseMock200 = (overrideResponse = {})=>({
        count: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsCountResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsCountResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsCountResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsCountResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsCountResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsCountResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsCountResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsCountResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsCountResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsCountResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsCountResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsCountResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsCountResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsCountResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsCountResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsCountResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsCountResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsCountResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsWelcomeEmailsResponseMock = (overrideResponse = {})=>({
        successEmails: faker.number.int({
            min: undefined,
            max: undefined
        }),
        totalEmails: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsWelcomeEmailsResponseMock200 = (overrideResponse = {})=>({
        successEmails: faker.number.int({
            min: undefined,
            max: undefined
        }),
        totalEmails: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsWelcomeEmailsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsWelcomeEmailsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsWelcomeEmailsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsWelcomeEmailsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsWelcomeEmailsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsWelcomeEmailsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsWelcomeEmailsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsWelcomeEmailsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsWelcomeEmailsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsWelcomeEmailsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsWelcomeEmailsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsWelcomeEmailsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsWelcomeEmailsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsWelcomeEmailsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsWelcomeEmailsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsWelcomeEmailsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsWelcomeEmailsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsWelcomeEmailsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantWelcomeEmailDownloadResponseMock = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getGetParticipantWelcomeEmailDownloadResponseMock200 = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getGetParticipantWelcomeEmailsHistoryResponseMock = (overrideResponse = {})=>({
        firstName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        history: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    eventType: faker.word.sample(),
                    messageId: faker.word.sample(),
                    sentOn: faker.word.sample(),
                    sentTo: faker.word.sample()
                })),
            undefined
        ]),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        lastName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ssn: faker.word.sample(),
        ...overrideResponse
    });
export const getGetParticipantWelcomeEmailsHistoryResponseMock200 = (overrideResponse = {})=>({
        firstName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        history: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    eventType: faker.word.sample(),
                    messageId: faker.word.sample(),
                    sentOn: faker.word.sample(),
                    sentTo: faker.word.sample()
                })),
            undefined
        ]),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        lastName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ssn: faker.word.sample(),
        ...overrideResponse
    });
export const getGetParticipantWelcomeEmailsHistoryResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantWelcomeEmailsHistoryResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantWelcomeEmailsHistoryResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantWelcomeEmailsHistoryResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantWelcomeEmailsHistoryResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantWelcomeEmailsHistoryResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantWelcomeEmailsHistoryResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantWelcomeEmailsHistoryResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantWelcomeEmailsHistoryResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantWelcomeEmailsHistoryResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantWelcomeEmailsHistoryResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantWelcomeEmailsHistoryResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantWelcomeEmailsHistoryResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantWelcomeEmailsHistoryResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantWelcomeEmailsHistoryResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantWelcomeEmailsHistoryResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantWelcomeEmailsHistoryResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantWelcomeEmailsHistoryResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEsaEmployerContributionsResponseMock = (overrideResponse = {})=>({
        data: {
            atTotal: faker.number.int({
                min: undefined,
                max: undefined
            }),
            employerMatch: faker.number.int({
                min: undefined,
                max: undefined
            }),
            esaGroupId: faker.word.sample(),
            initialBonus: faker.number.int({
                min: undefined,
                max: undefined
            }),
            milestoneBonusAmount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            milestoneBonusId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            participantId: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        error: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        success: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getGetCalculatedEsaEmployerContributionsResponseMock200 = (overrideResponse = {})=>({
        data: {
            atTotal: faker.number.int({
                min: undefined,
                max: undefined
            }),
            employerMatch: faker.number.int({
                min: undefined,
                max: undefined
            }),
            esaGroupId: faker.word.sample(),
            initialBonus: faker.number.int({
                min: undefined,
                max: undefined
            }),
            milestoneBonusAmount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            milestoneBonusId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            participantId: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        error: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        success: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getGetCalculatedEsaEmployerContributionsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEsaEmployerContributionsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEsaEmployerContributionsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEsaEmployerContributionsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEsaEmployerContributionsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEsaEmployerContributionsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEsaEmployerContributionsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEsaEmployerContributionsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEsaEmployerContributionsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEsaEmployerContributionsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEsaEmployerContributionsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEsaEmployerContributionsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEsaEmployerContributionsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEsaEmployerContributionsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEsaEmployerContributionsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEsaEmployerContributionsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEsaEmployerContributionsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEsaEmployerContributionsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEmployerMatchContributionResponseMock = (overrideResponse = {})=>({
        data: {
            employerMatch: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        ...overrideResponse
    });
export const getGetCalculatedEmployerMatchContributionResponseMock200 = (overrideResponse = {})=>({
        data: {
            employerMatch: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        ...overrideResponse
    });
export const getGetCalculatedEmployerMatchContributionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEmployerMatchContributionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEmployerMatchContributionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEmployerMatchContributionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEmployerMatchContributionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEmployerMatchContributionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEmployerMatchContributionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEmployerMatchContributionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEmployerMatchContributionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEmployerMatchContributionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEmployerMatchContributionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEmployerMatchContributionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEmployerMatchContributionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEmployerMatchContributionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEmployerMatchContributionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEmployerMatchContributionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEmployerMatchContributionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCalculatedEmployerMatchContributionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsAutoEnrollOptOutResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsAutoEnrollOptOutResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsAutoEnrollOptOutResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsAutoEnrollOptOutResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsAutoEnrollOptOutResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsAutoEnrollOptOutResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsAutoEnrollOptOutResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsAutoEnrollOptOutResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsAutoEnrollOptOutResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsAutoEnrollOptOutResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsAutoEnrollOptOutResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsAutoEnrollOptOutResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsAutoEnrollOptOutResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsAutoEnrollOptOutResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsAutoEnrollOptOutResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsAutoEnrollOptOutResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsAutoEnrollOptOutResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantsAutoEnrollOptOutResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignResponseMock = (overrideResponse = {})=>({
        distributionFeatures: faker.helpers.arrayElement([
            {
                allowHardshipElective: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipFromPartialVestedAccount: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipMatch: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipProfitSharing: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipRollover: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipSafeHarbor: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipTransfer: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipWithdrawals: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                allowHardshipWithdrawalsFromRothAccount: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceAtEarlyAge: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceAtEarlyAgeFromAllAccounts: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceAtNormalAge: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceAtNormalAgeFromAllAccounts: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceAtSpecifiedAge: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                allowInServiceFromPartialVestedAccount: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceFromRolloverAccount: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceUponDisability: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowPartialDistributionsAfterTermination: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowPermissibleWithdrawal: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowQbad: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowSpecifiedAgeFromRothAccount: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                childFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                correctiveFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                deathFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                disabilityFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                earlyRetirementAgeType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                generalFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                hardshipCriteria: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                hardshipFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                inServiceFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                inServiceSpecifiedAge: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                normalRetirementAge: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                normalRetirementAgeType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                participantTerminationFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                permissibleTimeframe: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                permissiveFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                planTerminationFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                qdroFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                rmdFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                rolloverFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        effectiveDate: faker.helpers.arrayElement([
            {
                blackoutEndDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                blackoutStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                liquidationDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                originalEffectivePlanDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                planYearEnd: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                profitSharingStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                safeHarborEffectiveDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                salaryRothDeferralEffectiveDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                vestwellStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        eligibilityFeatures: faker.helpers.arrayElement([
            {
                eligibilityRules: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequency: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequencyId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            ruleParameter: faker.helpers.arrayElement([
                                {
                                    age: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    failsafe: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    hours: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    months: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        })),
                    undefined
                ]),
                excludeLeasedEmployees: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                hasDualEligibility: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                matchEligibilityRules: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequency: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequencyId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            ruleParameter: faker.helpers.arrayElement([
                                {
                                    age: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    failsafe: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    hours: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    months: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        })),
                    undefined
                ]),
                profitSharingEligibilityRules: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequency: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequencyId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            ruleParameter: faker.helpers.arrayElement([
                                {
                                    age: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    failsafe: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    hours: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    months: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        })),
                    undefined
                ]),
                specialEntryDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                specialParticipationDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        employeeContribution: faker.helpers.arrayElement([
            {
                allowAfterTaxContribution: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowPretaxContribution: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                autoEnrollAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                autoEnrollEffectiveDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                autoEscalate: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                autoEscalateAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                autoEscalateMaximum: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                deferInDollars: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                isSalaryRothDeferral: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ])
            },
            undefined
        ]),
        employerContribution: faker.helpers.arrayElement([
            {
                allowEmployerProfitSharing: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowNonSafeHarborMatch: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowPrevailingWage: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowRollover: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                allowSafeHarborNonElective: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                discretionaryMatchFundingIntent: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                documentMatchFrequency: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                earlyRetirementAge: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                formula: faker.helpers.arrayElement([
                    {
                        dollarCap: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        dollarCapId: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        formulaDefined: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        tiers: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    min: 1,
                                    max: 10
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    tierCap: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    tierIndex: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    tierPercent: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ])
                                })),
                            undefined
                        ])
                    },
                    undefined
                ]),
                isSafeHarbor: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                matchFrequency: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                nonSafeHarborMatchType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                notes: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                profitSharingStrategy: faker.helpers.arrayElement([
                    faker.helpers.arrayElement([
                        faker.word.sample(),
                        null
                    ]),
                    undefined
                ]),
                safeHarborMatchType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        forceOutPreferences: faker.helpers.arrayElement([
            {
                excludeRollover: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                isAllowed: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                isAutomated: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                maxAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                rolloverMin: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        forfeiturePreferences: faker.helpers.arrayElement([
            {
                offsetEmployerContribution: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                payPlanFees: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ])
            },
            undefined
        ]),
        loanFeatures: faker.helpers.arrayElement([
            {
                allowLoans: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                allowResidencePurchaseExtension: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                hasPriorLoans: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                maintenanceFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                maxOutstandingLoans: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                maxYearsResidencePurchase: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                originationFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                overnightCheckFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                wireFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        offboardingInformation: faker.helpers.arrayElement([
            {
                blackoutEndDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                blackoutStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        overview: faker.helpers.arrayElement([
            {
                adminStatus: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                advisorFirstName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                advisorLastName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                clientSuccessManagerId: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                clientSuccessManagerName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                companyName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                conversionType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                integrationLevel: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                integrationTypeId: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                investmentProgram: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                investmentProgramId: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                payroll: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                planDesignTypeName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                planTierId: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                planTierName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                planType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                tpaFiduciary: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                tpaId: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                trustee: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        recordkeeperAndCustodian: faker.helpers.arrayElement([
            {
                adoptionAgreementDocumentProvider: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                custodianAccountNumber: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                externalHardDollarBillingAccountNumber: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                externalPlanId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                opportunityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                partnerSystemName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                priorProvider: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                recordkeeperId: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        vestingPreferences: faker.helpers.arrayElement([
            {
                excludeServicePriorTo18YearsOld: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                excludeServicePriorToPlanExistence: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                fundingSources: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            fundingSourceId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            fundingSourceName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            vestingScheduleId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            vestingScheduleName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        })),
                    undefined
                ]),
                hoursOfServiceRequired: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                vestingMethod: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getGetPlanDesignResponseMock200 = (overrideResponse = {})=>({
        distributionFeatures: faker.helpers.arrayElement([
            {
                allowHardshipElective: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipFromPartialVestedAccount: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipMatch: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipProfitSharing: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipRollover: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipSafeHarbor: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipTransfer: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowHardshipWithdrawals: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                allowHardshipWithdrawalsFromRothAccount: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceAtEarlyAge: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceAtEarlyAgeFromAllAccounts: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceAtNormalAge: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceAtNormalAgeFromAllAccounts: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceAtSpecifiedAge: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                allowInServiceFromPartialVestedAccount: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceFromRolloverAccount: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowInServiceUponDisability: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowPartialDistributionsAfterTermination: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowPermissibleWithdrawal: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowQbad: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowSpecifiedAgeFromRothAccount: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                childFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                correctiveFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                deathFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                disabilityFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                earlyRetirementAgeType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                generalFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                hardshipCriteria: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                hardshipFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                inServiceFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                inServiceSpecifiedAge: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                normalRetirementAge: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                normalRetirementAgeType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                participantTerminationFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                permissibleTimeframe: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                permissiveFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                planTerminationFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                qdroFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                rmdFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                rolloverFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        effectiveDate: faker.helpers.arrayElement([
            {
                blackoutEndDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                blackoutStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                liquidationDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                originalEffectivePlanDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                planYearEnd: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                profitSharingStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                safeHarborEffectiveDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                salaryRothDeferralEffectiveDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                vestwellStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        eligibilityFeatures: faker.helpers.arrayElement([
            {
                eligibilityRules: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequency: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequencyId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            ruleParameter: faker.helpers.arrayElement([
                                {
                                    age: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    failsafe: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    hours: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    months: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        })),
                    undefined
                ]),
                excludeLeasedEmployees: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                hasDualEligibility: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                matchEligibilityRules: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequency: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequencyId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            ruleParameter: faker.helpers.arrayElement([
                                {
                                    age: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    failsafe: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    hours: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    months: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        })),
                    undefined
                ]),
                profitSharingEligibilityRules: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequency: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entryDateFrequencyId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            ruleParameter: faker.helpers.arrayElement([
                                {
                                    age: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    failsafe: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    hours: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    months: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        })),
                    undefined
                ]),
                specialEntryDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                specialParticipationDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        employeeContribution: faker.helpers.arrayElement([
            {
                allowAfterTaxContribution: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowPretaxContribution: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                autoEnrollAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                autoEnrollEffectiveDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                autoEscalate: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                autoEscalateAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                autoEscalateMaximum: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                deferInDollars: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                isSalaryRothDeferral: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ])
            },
            undefined
        ]),
        employerContribution: faker.helpers.arrayElement([
            {
                allowEmployerProfitSharing: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowNonSafeHarborMatch: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowPrevailingWage: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                allowRollover: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                allowSafeHarborNonElective: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                discretionaryMatchFundingIntent: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                documentMatchFrequency: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                earlyRetirementAge: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                formula: faker.helpers.arrayElement([
                    {
                        dollarCap: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        dollarCapId: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        formulaDefined: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        tiers: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    min: 1,
                                    max: 10
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    tierCap: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    tierIndex: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    tierPercent: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ])
                                })),
                            undefined
                        ])
                    },
                    undefined
                ]),
                isSafeHarbor: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                matchFrequency: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                nonSafeHarborMatchType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                notes: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                profitSharingStrategy: faker.helpers.arrayElement([
                    faker.helpers.arrayElement([
                        faker.word.sample(),
                        null
                    ]),
                    undefined
                ]),
                safeHarborMatchType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        forceOutPreferences: faker.helpers.arrayElement([
            {
                excludeRollover: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                isAllowed: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                isAutomated: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                maxAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                rolloverMin: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        forfeiturePreferences: faker.helpers.arrayElement([
            {
                offsetEmployerContribution: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                payPlanFees: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ])
            },
            undefined
        ]),
        loanFeatures: faker.helpers.arrayElement([
            {
                allowLoans: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                allowResidencePurchaseExtension: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                hasPriorLoans: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                maintenanceFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                maxOutstandingLoans: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                maxYearsResidencePurchase: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                originationFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                overnightCheckFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                wireFee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        offboardingInformation: faker.helpers.arrayElement([
            {
                blackoutEndDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                blackoutStartDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        overview: faker.helpers.arrayElement([
            {
                adminStatus: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                advisorFirstName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                advisorLastName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                clientSuccessManagerId: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                clientSuccessManagerName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                companyName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                conversionType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                integrationLevel: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                integrationTypeId: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                investmentProgram: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                investmentProgramId: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                payroll: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                planDesignTypeName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                planTierId: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                planTierName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                planType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                tpaFiduciary: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                tpaId: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                trustee: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        recordkeeperAndCustodian: faker.helpers.arrayElement([
            {
                adoptionAgreementDocumentProvider: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                custodianAccountNumber: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                externalHardDollarBillingAccountNumber: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                externalPlanId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                opportunityId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                partnerSystemName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                priorProvider: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                recordkeeperId: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        vestingPreferences: faker.helpers.arrayElement([
            {
                excludeServicePriorTo18YearsOld: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                excludeServicePriorToPlanExistence: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                fundingSources: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            fundingSourceId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            fundingSourceName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            vestingScheduleId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            vestingScheduleName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        })),
                    undefined
                ]),
                hoursOfServiceRequired: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                vestingMethod: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getGetPlanDesignResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchUpdatePlanDesignResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchUpdatePlanDesignResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchUpdatePlanDesignResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchUpdatePlanDesignResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchUpdatePlanDesignResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchUpdatePlanDesignResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchUpdatePlanDesignResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchUpdatePlanDesignResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchUpdatePlanDesignResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchUpdatePlanDesignResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchUpdatePlanDesignResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchUpdatePlanDesignResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchUpdatePlanDesignResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchUpdatePlanDesignResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchUpdatePlanDesignResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchUpdatePlanDesignResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchUpdatePlanDesignResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchUpdatePlanDesignResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignTilesResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            planDesignTemplate: {
                distributionFeatures: faker.helpers.arrayElement([
                    {
                        allowHardshipElective: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipFromPartialVestedAccount: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipMatch: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipProfitSharing: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipRollover: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipSafeHarbor: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipTransfer: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipWithdrawals: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        allowHardshipWithdrawalsFromRothAccount: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceAtEarlyAge: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceAtEarlyAgeFromAllAccounts: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceAtNormalAge: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceAtNormalAgeFromAllAccounts: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceAtSpecifiedAge: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        allowInServiceFromPartialVestedAccount: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceFromRolloverAccount: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceUponDisability: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowPartialDistributionsAfterTermination: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowPermissibleWithdrawal: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowQbad: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowSpecifiedAgeFromRothAccount: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        childFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        correctiveFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        deathFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        disabilityFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        earlyRetirementAgeType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        generalFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        hardshipCriteria: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        hardshipFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        inServiceFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        inServiceSpecifiedAge: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        normalRetirementAge: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        normalRetirementAgeType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        participantTerminationFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        permissibleTimeframe: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        permissiveFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        planTerminationFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        qdroFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        rmdFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        rolloverFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                effectiveDate: faker.helpers.arrayElement([
                    {
                        blackoutEndDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        blackoutStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        liquidationDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        originalEffectivePlanDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        planYearEnd: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        profitSharingStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        safeHarborEffectiveDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        salaryRothDeferralEffectiveDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        vestwellStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                eligibilityFeatures: faker.helpers.arrayElement([
                    {
                        eligibilityRules: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    min: 1,
                                    max: 10
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequency: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequencyId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    ruleParameter: faker.helpers.arrayElement([
                                        {
                                            age: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    min: undefined,
                                                    max: undefined
                                                }),
                                                undefined
                                            ]),
                                            failsafe: faker.helpers.arrayElement([
                                                faker.word.sample(),
                                                undefined
                                            ]),
                                            hours: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    min: undefined,
                                                    max: undefined
                                                }),
                                                undefined
                                            ]),
                                            months: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    min: undefined,
                                                    max: undefined
                                                }),
                                                undefined
                                            ])
                                        },
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        excludeLeasedEmployees: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        hasDualEligibility: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        matchEligibilityRules: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    min: 1,
                                    max: 10
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequency: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequencyId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    ruleParameter: faker.helpers.arrayElement([
                                        {
                                            age: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    min: undefined,
                                                    max: undefined
                                                }),
                                                undefined
                                            ]),
                                            failsafe: faker.helpers.arrayElement([
                                                faker.word.sample(),
                                                undefined
                                            ]),
                                            hours: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    min: undefined,
                                                    max: undefined
                                                }),
                                                undefined
                                            ]),
                                            months: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    min: undefined,
                                                    max: undefined
                                                }),
                                                undefined
                                            ])
                                        },
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        profitSharingEligibilityRules: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    min: 1,
                                    max: 10
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequency: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequencyId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    ruleParameter: faker.helpers.arrayElement([
                                        {
                                            age: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    min: undefined,
                                                    max: undefined
                                                }),
                                                undefined
                                            ]),
                                            failsafe: faker.helpers.arrayElement([
                                                faker.word.sample(),
                                                undefined
                                            ]),
                                            hours: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    min: undefined,
                                                    max: undefined
                                                }),
                                                undefined
                                            ]),
                                            months: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    min: undefined,
                                                    max: undefined
                                                }),
                                                undefined
                                            ])
                                        },
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        specialEntryDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        specialParticipationDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                employeeContribution: faker.helpers.arrayElement([
                    {
                        allowAfterTaxContribution: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowPretaxContribution: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        autoEnrollAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        autoEnrollEffectiveDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        autoEscalate: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        autoEscalateAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        autoEscalateMaximum: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        deferInDollars: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        isSalaryRothDeferral: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                employerContribution: faker.helpers.arrayElement([
                    {
                        allowEmployerProfitSharing: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowNonSafeHarborMatch: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowPrevailingWage: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowRollover: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        allowSafeHarborNonElective: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        discretionaryMatchFundingIntent: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        documentMatchFrequency: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        earlyRetirementAge: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        formula: faker.helpers.arrayElement([
                            {
                                dollarCap: faker.helpers.arrayElement([
                                    faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    }),
                                    undefined
                                ]),
                                dollarCapId: faker.helpers.arrayElement([
                                    faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    }),
                                    undefined
                                ]),
                                formulaDefined: faker.helpers.arrayElement([
                                    faker.datatype.boolean(),
                                    undefined
                                ]),
                                tiers: faker.helpers.arrayElement([
                                    Array.from({
                                        length: faker.number.int({
                                            min: 1,
                                            max: 10
                                        })
                                    }, (_, i)=>i + 1).map(()=>({
                                            tierCap: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    min: undefined,
                                                    max: undefined
                                                }),
                                                undefined
                                            ]),
                                            tierIndex: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    min: undefined,
                                                    max: undefined
                                                }),
                                                undefined
                                            ]),
                                            tierPercent: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    min: undefined,
                                                    max: undefined
                                                }),
                                                undefined
                                            ])
                                        })),
                                    undefined
                                ])
                            },
                            undefined
                        ]),
                        isSafeHarbor: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        matchFrequency: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        nonSafeHarborMatchType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        notes: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        profitSharingStrategy: faker.helpers.arrayElement([
                            faker.helpers.arrayElement([
                                faker.word.sample(),
                                null
                            ]),
                            undefined
                        ]),
                        safeHarborMatchType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                forceOutPreferences: faker.helpers.arrayElement([
                    {
                        excludeRollover: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        isAllowed: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        isAutomated: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        maxAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        rolloverMin: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                forfeiturePreferences: faker.helpers.arrayElement([
                    {
                        offsetEmployerContribution: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        payPlanFees: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                loanFeatures: faker.helpers.arrayElement([
                    {
                        allowLoans: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        allowResidencePurchaseExtension: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        hasPriorLoans: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        maintenanceFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        maxOutstandingLoans: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        maxYearsResidencePurchase: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        originationFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        overnightCheckFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        wireFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                offboardingInformation: faker.helpers.arrayElement([
                    {
                        blackoutEndDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        blackoutStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                overview: faker.helpers.arrayElement([
                    {
                        adminStatus: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        advisorFirstName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        advisorLastName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        clientSuccessManagerId: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        clientSuccessManagerName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        companyName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        conversionType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        integrationLevel: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        integrationTypeId: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        investmentProgram: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        investmentProgramId: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        payroll: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        planDesignTypeName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        planTierId: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        planTierName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        planType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        tpaFiduciary: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        tpaId: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        trustee: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                recordkeeperAndCustodian: faker.helpers.arrayElement([
                    {
                        adoptionAgreementDocumentProvider: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        custodianAccountNumber: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        externalHardDollarBillingAccountNumber: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        externalPlanId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        opportunityId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        partnerSystemName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        priorProvider: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        recordkeeperId: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                vestingPreferences: faker.helpers.arrayElement([
                    {
                        excludeServicePriorTo18YearsOld: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        excludeServicePriorToPlanExistence: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        fundingSources: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    min: 1,
                                    max: 10
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    fundingSourceId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    fundingSourceName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    vestingScheduleId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    vestingScheduleName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        hoursOfServiceRequired: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        vestingMethod: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ])
            },
            planDesignTileName: faker.word.sample()
        }));
export const getGetPlanDesignTilesResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            planDesignTemplate: {
                distributionFeatures: faker.helpers.arrayElement([
                    {
                        allowHardshipElective: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipFromPartialVestedAccount: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipMatch: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipProfitSharing: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipRollover: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipSafeHarbor: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipTransfer: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowHardshipWithdrawals: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        allowHardshipWithdrawalsFromRothAccount: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceAtEarlyAge: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceAtEarlyAgeFromAllAccounts: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceAtNormalAge: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceAtNormalAgeFromAllAccounts: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceAtSpecifiedAge: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        allowInServiceFromPartialVestedAccount: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceFromRolloverAccount: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowInServiceUponDisability: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowPartialDistributionsAfterTermination: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowPermissibleWithdrawal: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowQbad: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowSpecifiedAgeFromRothAccount: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        childFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        correctiveFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        deathFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        disabilityFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        earlyRetirementAgeType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        generalFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        hardshipCriteria: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        hardshipFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        inServiceFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        inServiceSpecifiedAge: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        normalRetirementAge: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        normalRetirementAgeType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        participantTerminationFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        permissibleTimeframe: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        permissiveFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        planTerminationFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        qdroFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        rmdFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        rolloverFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                effectiveDate: faker.helpers.arrayElement([
                    {
                        blackoutEndDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        blackoutStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        liquidationDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        originalEffectivePlanDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        planYearEnd: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        profitSharingStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        safeHarborEffectiveDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        salaryRothDeferralEffectiveDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        vestwellStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                eligibilityFeatures: faker.helpers.arrayElement([
                    {
                        eligibilityRules: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    min: 1,
                                    max: 10
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequency: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequencyId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    ruleParameter: faker.helpers.arrayElement([
                                        {
                                            age: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    min: undefined,
                                                    max: undefined
                                                }),
                                                undefined
                                            ]),
                                            failsafe: faker.helpers.arrayElement([
                                                faker.word.sample(),
                                                undefined
                                            ]),
                                            hours: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    min: undefined,
                                                    max: undefined
                                                }),
                                                undefined
                                            ]),
                                            months: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    min: undefined,
                                                    max: undefined
                                                }),
                                                undefined
                                            ])
                                        },
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        excludeLeasedEmployees: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        hasDualEligibility: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        matchEligibilityRules: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    min: 1,
                                    max: 10
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequency: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequencyId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    ruleParameter: faker.helpers.arrayElement([
                                        {
                                            age: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    min: undefined,
                                                    max: undefined
                                                }),
                                                undefined
                                            ]),
                                            failsafe: faker.helpers.arrayElement([
                                                faker.word.sample(),
                                                undefined
                                            ]),
                                            hours: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    min: undefined,
                                                    max: undefined
                                                }),
                                                undefined
                                            ]),
                                            months: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    min: undefined,
                                                    max: undefined
                                                }),
                                                undefined
                                            ])
                                        },
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        profitSharingEligibilityRules: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    min: 1,
                                    max: 10
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    eligibilityRequirementTypeId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    eligibilityRequirementTypeName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequency: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    entryDateFrequencyId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    ruleParameter: faker.helpers.arrayElement([
                                        {
                                            age: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    min: undefined,
                                                    max: undefined
                                                }),
                                                undefined
                                            ]),
                                            failsafe: faker.helpers.arrayElement([
                                                faker.word.sample(),
                                                undefined
                                            ]),
                                            hours: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    min: undefined,
                                                    max: undefined
                                                }),
                                                undefined
                                            ]),
                                            months: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    min: undefined,
                                                    max: undefined
                                                }),
                                                undefined
                                            ])
                                        },
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        specialEntryDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        specialParticipationDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                employeeContribution: faker.helpers.arrayElement([
                    {
                        allowAfterTaxContribution: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowPretaxContribution: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        autoEnrollAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        autoEnrollEffectiveDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        autoEscalate: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        autoEscalateAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        autoEscalateMaximum: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        deferInDollars: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        isSalaryRothDeferral: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                employerContribution: faker.helpers.arrayElement([
                    {
                        allowEmployerProfitSharing: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowNonSafeHarborMatch: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowPrevailingWage: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        allowRollover: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        allowSafeHarborNonElective: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        discretionaryMatchFundingIntent: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        documentMatchFrequency: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        earlyRetirementAge: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        formula: faker.helpers.arrayElement([
                            {
                                dollarCap: faker.helpers.arrayElement([
                                    faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    }),
                                    undefined
                                ]),
                                dollarCapId: faker.helpers.arrayElement([
                                    faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    }),
                                    undefined
                                ]),
                                formulaDefined: faker.helpers.arrayElement([
                                    faker.datatype.boolean(),
                                    undefined
                                ]),
                                tiers: faker.helpers.arrayElement([
                                    Array.from({
                                        length: faker.number.int({
                                            min: 1,
                                            max: 10
                                        })
                                    }, (_, i)=>i + 1).map(()=>({
                                            tierCap: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    min: undefined,
                                                    max: undefined
                                                }),
                                                undefined
                                            ]),
                                            tierIndex: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    min: undefined,
                                                    max: undefined
                                                }),
                                                undefined
                                            ]),
                                            tierPercent: faker.helpers.arrayElement([
                                                faker.number.int({
                                                    min: undefined,
                                                    max: undefined
                                                }),
                                                undefined
                                            ])
                                        })),
                                    undefined
                                ])
                            },
                            undefined
                        ]),
                        isSafeHarbor: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        matchFrequency: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        nonSafeHarborMatchType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        notes: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        profitSharingStrategy: faker.helpers.arrayElement([
                            faker.helpers.arrayElement([
                                faker.word.sample(),
                                null
                            ]),
                            undefined
                        ]),
                        safeHarborMatchType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                forceOutPreferences: faker.helpers.arrayElement([
                    {
                        excludeRollover: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        isAllowed: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        isAutomated: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        maxAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        rolloverMin: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                forfeiturePreferences: faker.helpers.arrayElement([
                    {
                        offsetEmployerContribution: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        payPlanFees: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                loanFeatures: faker.helpers.arrayElement([
                    {
                        allowLoans: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        allowResidencePurchaseExtension: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        hasPriorLoans: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        maintenanceFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        maxOutstandingLoans: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        maxYearsResidencePurchase: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        originationFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        overnightCheckFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        wireFee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                offboardingInformation: faker.helpers.arrayElement([
                    {
                        blackoutEndDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        blackoutStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                overview: faker.helpers.arrayElement([
                    {
                        adminStatus: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        advisorFirstName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        advisorLastName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        clientSuccessManagerId: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        clientSuccessManagerName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        companyName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        conversionType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        integrationLevel: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        integrationTypeId: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        investmentProgram: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        investmentProgramId: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        payroll: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        planDesignTypeName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        planTierId: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        planTierName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        planType: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        tpaFiduciary: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        tpaId: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        trustee: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                recordkeeperAndCustodian: faker.helpers.arrayElement([
                    {
                        adoptionAgreementDocumentProvider: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        custodianAccountNumber: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        externalHardDollarBillingAccountNumber: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        externalPlanId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        opportunityId: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        partnerSystemName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        priorProvider: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        recordkeeperId: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                vestingPreferences: faker.helpers.arrayElement([
                    {
                        excludeServicePriorTo18YearsOld: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        excludeServicePriorToPlanExistence: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        fundingSources: faker.helpers.arrayElement([
                            Array.from({
                                length: faker.number.int({
                                    min: 1,
                                    max: 10
                                })
                            }, (_, i)=>i + 1).map(()=>({
                                    fundingSourceId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    fundingSourceName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    vestingScheduleId: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    vestingScheduleName: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                })),
                            undefined
                        ]),
                        hoursOfServiceRequired: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        vestingMethod: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ])
            },
            planDesignTileName: faker.word.sample()
        }));
export const getGetPlanDesignTilesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignTilesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignTilesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignTilesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignTilesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignTilesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignTilesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignTilesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignTilesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignTilesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignTilesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignTilesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignTilesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignTilesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignTilesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignTilesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignTilesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignTilesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelResponseMock = (overrideResponse = {})=>({
        asOfDate: faker.word.sample(),
        expenseRatioPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        fi360FactsheetPath: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        fiveYearBenchmarkPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        fiveYearPerformancePct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        inceptionDate: faker.word.sample(),
        inceptionToDateReturn: faker.number.int({
            min: undefined,
            max: undefined
        }),
        isDefault: faker.datatype.boolean(),
        itdBenchmarkPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        itdPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        metaAssetAllocations: {
            bondNetPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            cashNetPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            otherNetPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            stockNetPct: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        modelBoundaries: {
            riskLevel: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            targetRetireYearHigh: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            targetRetireYearLow: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            yearsToRetireHigh: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            yearsToRetireLow: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        },
        modelDescription: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        modelType: faker.helpers.arrayElement([
            'target',
            'risk',
            'menu',
            'pmenu',
            'goal',
            'ms_ma',
            'ms_ma_menu',
            'nli'
        ]),
        name: faker.word.sample(),
        oneYearBenchmarkPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        oneYearPerformancePct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        performanceUpdatedAt: faker.word.sample(),
        tenYearBenchmarkPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        tenYearPerformancePct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        viewName: faker.word.sample(),
        ytdBenchmarkPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ytdPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelResponseMock200 = (overrideResponse = {})=>({
        asOfDate: faker.word.sample(),
        expenseRatioPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        fi360FactsheetPath: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        fiveYearBenchmarkPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        fiveYearPerformancePct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        inceptionDate: faker.word.sample(),
        inceptionToDateReturn: faker.number.int({
            min: undefined,
            max: undefined
        }),
        isDefault: faker.datatype.boolean(),
        itdBenchmarkPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        itdPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        metaAssetAllocations: {
            bondNetPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            cashNetPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            otherNetPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            stockNetPct: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        modelBoundaries: {
            riskLevel: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            targetRetireYearHigh: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            targetRetireYearLow: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            yearsToRetireHigh: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            yearsToRetireLow: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        },
        modelDescription: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        modelType: faker.helpers.arrayElement([
            'target',
            'risk',
            'menu',
            'pmenu',
            'goal',
            'ms_ma',
            'ms_ma_menu',
            'nli'
        ]),
        name: faker.word.sample(),
        oneYearBenchmarkPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        oneYearPerformancePct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        performanceUpdatedAt: faker.word.sample(),
        tenYearBenchmarkPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        tenYearPerformancePct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        viewName: faker.word.sample(),
        ytdBenchmarkPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ytdPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaProgramResponseMock = (overrideResponse = {})=>({
        directDeposit: faker.datatype.boolean(),
        esaProgramId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        payrollDeduction: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getGetEsaProgramResponseMock200 = (overrideResponse = {})=>({
        directDeposit: faker.datatype.boolean(),
        esaProgramId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        payrollDeduction: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getGetEsaProgramResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaProgramResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaProgramResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaProgramResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaProgramResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaProgramResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaProgramResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaProgramResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaProgramResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaProgramResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaProgramResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaProgramResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaProgramResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaProgramResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaProgramResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaProgramResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaProgramResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaProgramResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanInvestmentsResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                fi360FactsheetPath: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                id: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                inceptionDate: faker.word.sample(),
                isDefault: faker.datatype.boolean(),
                modelBoundaries: {
                    riskLevel: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearLow: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireLow: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ])
                },
                modelDescription: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                modelType: faker.helpers.arrayElement([
                    'target',
                    'risk',
                    'menu',
                    'pmenu',
                    'goal',
                    'ms_ma',
                    'ms_ma_menu',
                    'nli'
                ]),
                name: faker.word.sample(),
                programId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                viewName: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getGetPlanInvestmentsResponseMock200 = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                fi360FactsheetPath: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                id: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                inceptionDate: faker.word.sample(),
                isDefault: faker.datatype.boolean(),
                modelBoundaries: {
                    riskLevel: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    targetRetireYearLow: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireHigh: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    yearsToRetireLow: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ])
                },
                modelDescription: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                modelType: faker.helpers.arrayElement([
                    'target',
                    'risk',
                    'menu',
                    'pmenu',
                    'goal',
                    'ms_ma',
                    'ms_ma_menu',
                    'nli'
                ]),
                name: faker.word.sample(),
                programId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                viewName: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getGetPlanInvestmentsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanInvestmentsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanInvestmentsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanInvestmentsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanInvestmentsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanInvestmentsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanInvestmentsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanInvestmentsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanInvestmentsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanInvestmentsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanInvestmentsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanInvestmentsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanInvestmentsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanInvestmentsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanInvestmentsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanInvestmentsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanInvestmentsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanInvestmentsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelSecuritiesResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            assetAllocations: {
                bondNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                cashNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                otherNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                stockNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            assetClass: faker.word.sample(),
            broadCategory: faker.word.sample(),
            category: faker.word.sample(),
            cusip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            expenseRatioPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            fiveYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            fiveYearPerformancePct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            id: faker.word.sample(),
            inceptionDate: faker.word.sample(),
            itdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            itdPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            name: faker.word.sample(),
            oneYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            oneYearPerformancePct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            performanceUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityType: faker.word.sample(),
            securityTypeName: faker.word.sample(),
            shareClass: faker.word.sample(),
            tenYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            tenYearPerformancePct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            weightPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            ytdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            ytdPct: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetPlanModelSecuritiesResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            assetAllocations: {
                bondNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                cashNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                otherNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                stockNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            assetClass: faker.word.sample(),
            broadCategory: faker.word.sample(),
            category: faker.word.sample(),
            cusip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            expenseRatioPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            fiveYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            fiveYearPerformancePct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            id: faker.word.sample(),
            inceptionDate: faker.word.sample(),
            itdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            itdPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            name: faker.word.sample(),
            oneYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            oneYearPerformancePct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            performanceUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityType: faker.word.sample(),
            securityTypeName: faker.word.sample(),
            shareClass: faker.word.sample(),
            tenYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            tenYearPerformancePct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            weightPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            ytdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            ytdPct: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetPlanModelSecuritiesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelSecuritiesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelSecuritiesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelSecuritiesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelSecuritiesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelSecuritiesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelSecuritiesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelSecuritiesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelSecuritiesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelSecuritiesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelSecuritiesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelSecuritiesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelSecuritiesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelSecuritiesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelSecuritiesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelSecuritiesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelSecuritiesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanModelSecuritiesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelsResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            fi360FactsheetPath: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            inceptionDate: faker.word.sample(),
            isDefault: faker.datatype.boolean(),
            modelBoundaries: {
                riskLevel: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                targetRetireYearHigh: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                targetRetireYearLow: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                yearsToRetireHigh: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                yearsToRetireLow: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            },
            modelDescription: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            modelType: faker.helpers.arrayElement([
                'target',
                'risk',
                'menu',
                'pmenu',
                'goal',
                'ms_ma',
                'ms_ma_menu',
                'nli'
            ]),
            name: faker.word.sample(),
            programId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            viewName: faker.word.sample()
        }));
export const getGetProgramModelsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            fi360FactsheetPath: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            inceptionDate: faker.word.sample(),
            isDefault: faker.datatype.boolean(),
            modelBoundaries: {
                riskLevel: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                targetRetireYearHigh: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                targetRetireYearLow: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                yearsToRetireHigh: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                yearsToRetireLow: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            },
            modelDescription: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            modelType: faker.helpers.arrayElement([
                'target',
                'risk',
                'menu',
                'pmenu',
                'goal',
                'ms_ma',
                'ms_ma_menu',
                'nli'
            ]),
            name: faker.word.sample(),
            programId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            viewName: faker.word.sample()
        }));
export const getGetProgramModelsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProgramModelsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProspectusUrlPartsResponseMock = (overrideResponse = {})=>({
        postfix: faker.word.sample(),
        prefix: faker.word.sample(),
        ...overrideResponse
    });
export const getGetProspectusUrlPartsResponseMock200 = (overrideResponse = {})=>({
        postfix: faker.word.sample(),
        prefix: faker.word.sample(),
        ...overrideResponse
    });
export const getGetProspectusUrlPartsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProspectusUrlPartsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProspectusUrlPartsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProspectusUrlPartsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProspectusUrlPartsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProspectusUrlPartsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProspectusUrlPartsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProspectusUrlPartsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProspectusUrlPartsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProspectusUrlPartsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProspectusUrlPartsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProspectusUrlPartsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProspectusUrlPartsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProspectusUrlPartsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProspectusUrlPartsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProspectusUrlPartsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProspectusUrlPartsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetProspectusUrlPartsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllSafeHarborContributionTypesResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            code: faker.word.sample(),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            name: faker.word.sample(),
            nonElectivePercent: faker.number.int({
                min: undefined,
                max: undefined
            }),
            tierOneMatchMax: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                null
            ]),
            tierOneMatchPercent: faker.number.int({
                min: undefined,
                max: undefined
            }),
            tierTwoMatchMax: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                null
            ]),
            tierTwoMatchMin: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                null
            ]),
            tierTwoMatchPercent: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                null
            ])
        }));
export const getGetAllSafeHarborContributionTypesResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            code: faker.word.sample(),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            name: faker.word.sample(),
            nonElectivePercent: faker.number.int({
                min: undefined,
                max: undefined
            }),
            tierOneMatchMax: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                null
            ]),
            tierOneMatchPercent: faker.number.int({
                min: undefined,
                max: undefined
            }),
            tierTwoMatchMax: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                null
            ]),
            tierTwoMatchMin: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                null
            ]),
            tierTwoMatchPercent: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                null
            ])
        }));
export const getGetAllSafeHarborContributionTypesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllSafeHarborContributionTypesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllSafeHarborContributionTypesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllSafeHarborContributionTypesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllSafeHarborContributionTypesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllSafeHarborContributionTypesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllSafeHarborContributionTypesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllSafeHarborContributionTypesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllSafeHarborContributionTypesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllSafeHarborContributionTypesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllSafeHarborContributionTypesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllSafeHarborContributionTypesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllSafeHarborContributionTypesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllSafeHarborContributionTypesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllSafeHarborContributionTypesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllSafeHarborContributionTypesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllSafeHarborContributionTypesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAllSafeHarborContributionTypesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaExternalMarketValueResponseMock = (overrideResponse = {})=>({
        cashBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        effectiveDate: faker.word.sample(),
        externalAccountNumber: faker.word.sample(),
        totalMarketValue: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaExternalMarketValueResponseMock200 = (overrideResponse = {})=>({
        cashBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        effectiveDate: faker.word.sample(),
        externalAccountNumber: faker.word.sample(),
        totalMarketValue: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaExternalMarketValueResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaExternalMarketValueResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaExternalMarketValueResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaExternalMarketValueResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaExternalMarketValueResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaExternalMarketValueResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaExternalMarketValueResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaExternalMarketValueResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaExternalMarketValueResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaExternalMarketValueResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaExternalMarketValueResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaExternalMarketValueResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaExternalMarketValueResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaExternalMarketValueResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaExternalMarketValueResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaExternalMarketValueResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaExternalMarketValueResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaExternalMarketValueResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSubaInitiateExternalTransferResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSubaInitiateExternalTransferResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSubaInitiateExternalTransferResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSubaInitiateExternalTransferResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSubaInitiateExternalTransferResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSubaInitiateExternalTransferResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSubaInitiateExternalTransferResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSubaInitiateExternalTransferResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSubaInitiateExternalTransferResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSubaInitiateExternalTransferResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSubaInitiateExternalTransferResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSubaInitiateExternalTransferResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSubaInitiateExternalTransferResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSubaInitiateExternalTransferResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSubaInitiateExternalTransferResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSubaInitiateExternalTransferResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSubaInitiateExternalTransferResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSubaInitiateExternalTransferResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaSetupResponseMock = (overrideResponse = {})=>({
        allowSdba: faker.datatype.boolean(),
        createdAt: faker.word.sample(),
        createdBy: {
            authRole: faker.word.sample(),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            idType: faker.word.sample()
        },
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        maxBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        minVestedBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participantFee: faker.number.int({
            min: undefined,
            max: undefined
        }),
        planAccessCode: faker.word.sample(),
        sdbaPlanId: faker.word.sample(),
        sdbaStatus: faker.word.sample(),
        sponsorPlanId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        updatedAt: faker.word.sample(),
        updatedBy: {
            authRole: faker.word.sample(),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            idType: faker.word.sample()
        },
        ...overrideResponse
    });
export const getGetSdbaSetupResponseMock200 = (overrideResponse = {})=>({
        allowSdba: faker.datatype.boolean(),
        createdAt: faker.word.sample(),
        createdBy: {
            authRole: faker.word.sample(),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            idType: faker.word.sample()
        },
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        maxBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        minVestedBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participantFee: faker.number.int({
            min: undefined,
            max: undefined
        }),
        planAccessCode: faker.word.sample(),
        sdbaPlanId: faker.word.sample(),
        sdbaStatus: faker.word.sample(),
        sponsorPlanId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        updatedAt: faker.word.sample(),
        updatedBy: {
            authRole: faker.word.sample(),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            idType: faker.word.sample()
        },
        ...overrideResponse
    });
export const getGetSdbaSetupResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaSetupResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaSetupResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaSetupResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaSetupResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaSetupResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaSetupResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaSetupResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaSetupResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaSetupResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaSetupResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaSetupResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaSetupResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaSetupResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaSetupResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaSetupResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaSetupResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaSetupResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaTransfersInfoResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            amount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            externalTransferType: faker.word.sample(),
            status: faker.word.sample(),
            submissionTime: faker.word.sample(),
            transferId: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetSdbaTransfersInfoResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            amount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            externalTransferType: faker.word.sample(),
            status: faker.word.sample(),
            submissionTime: faker.word.sample(),
            transferId: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetSdbaTransfersInfoResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaTransfersInfoResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaTransfersInfoResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaTransfersInfoResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaTransfersInfoResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaTransfersInfoResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaTransfersInfoResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaTransfersInfoResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaTransfersInfoResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaTransfersInfoResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaTransfersInfoResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaTransfersInfoResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaTransfersInfoResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaTransfersInfoResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaTransfersInfoResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaTransfersInfoResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaTransfersInfoResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSdbaTransfersInfoResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCheckActiveSdbaTransfersResponseMock = (overrideResponse = {})=>({
        hasActiveTransfers: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getGetCheckActiveSdbaTransfersResponseMock200 = (overrideResponse = {})=>({
        hasActiveTransfers: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getGetCheckActiveSdbaTransfersResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCheckActiveSdbaTransfersResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCheckActiveSdbaTransfersResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCheckActiveSdbaTransfersResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCheckActiveSdbaTransfersResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCheckActiveSdbaTransfersResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCheckActiveSdbaTransfersResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCheckActiveSdbaTransfersResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCheckActiveSdbaTransfersResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCheckActiveSdbaTransfersResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCheckActiveSdbaTransfersResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCheckActiveSdbaTransfersResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCheckActiveSdbaTransfersResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCheckActiveSdbaTransfersResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCheckActiveSdbaTransfersResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCheckActiveSdbaTransfersResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCheckActiveSdbaTransfersResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCheckActiveSdbaTransfersResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAutoEnrollSponsorPlanResponseMock = (overrideResponse = {})=>({
        autoEnroll: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        sponsorPlanId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetAutoEnrollSponsorPlanResponseMock200 = (overrideResponse = {})=>({
        autoEnroll: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        sponsorPlanId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetAutoEnrollSponsorPlanResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAutoEnrollSponsorPlanResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAutoEnrollSponsorPlanResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAutoEnrollSponsorPlanResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAutoEnrollSponsorPlanResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAutoEnrollSponsorPlanResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAutoEnrollSponsorPlanResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAutoEnrollSponsorPlanResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAutoEnrollSponsorPlanResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAutoEnrollSponsorPlanResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAutoEnrollSponsorPlanResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAutoEnrollSponsorPlanResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAutoEnrollSponsorPlanResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAutoEnrollSponsorPlanResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAutoEnrollSponsorPlanResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAutoEnrollSponsorPlanResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAutoEnrollSponsorPlanResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAutoEnrollSponsorPlanResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationV2ResponseMock = (overrideResponse = {})=>({
        configurationId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        hasCompleted: faker.datatype.boolean(),
        hasOfficers: faker.datatype.boolean(),
        hasOwners: faker.datatype.boolean(),
        sponsorPlanId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationV2ResponseMock200 = (overrideResponse = {})=>({
        configurationId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        hasCompleted: faker.datatype.boolean(),
        hasOfficers: faker.datatype.boolean(),
        hasOwners: faker.datatype.boolean(),
        sponsorPlanId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesV2ResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                min: undefined,
                max: undefined
            }),
            censusRecordsId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            lastName: faker.word.sample(),
            ssn: faker.word.sample()
        }));
export const getGetPlanEmployeesV2ResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                min: undefined,
                max: undefined
            }),
            censusRecordsId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            lastName: faker.word.sample(),
            ssn: faker.word.sample()
        }));
export const getGetPlanEmployeesV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationV2ResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                min: undefined,
                max: undefined
            }),
            censusRecorsdId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            firstName: faker.word.sample(),
            grossCompensation: faker.number.int({
                min: undefined,
                max: undefined
            }),
            grosscompInformationId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            lastName: faker.word.sample(),
            ssn: faker.word.sample()
        }));
export const getGetPlanGrossCompensationV2ResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                min: undefined,
                max: undefined
            }),
            censusRecorsdId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            firstName: faker.word.sample(),
            grossCompensation: faker.number.int({
                min: undefined,
                max: undefined
            }),
            grosscompInformationId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            lastName: faker.word.sample(),
            ssn: faker.word.sample()
        }));
export const getGetPlanGrossCompensationV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersV2ResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                min: undefined,
                max: undefined
            }),
            censusRecordsId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isOfficer: faker.datatype.boolean(),
            lastName: faker.word.sample(),
            officerInformationId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            ssn: faker.word.sample()
        }));
export const getGetPlanOfficersV2ResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                min: undefined,
                max: undefined
            }),
            censusRecordsId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isOfficer: faker.datatype.boolean(),
            lastName: faker.word.sample(),
            officerInformationId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            ssn: faker.word.sample()
        }));
export const getGetPlanOfficersV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersV2ResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                min: undefined,
                max: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isEmployee: faker.datatype.boolean(),
            lastName: faker.word.sample(),
            ownership: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            ownersId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            ownerSince: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getGetPlanOwnersV2ResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                min: undefined,
                max: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isEmployee: faker.datatype.boolean(),
            lastName: faker.word.sample(),
            ownership: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            ownersId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            ownerSince: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getGetPlanOwnersV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyV2ResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            employee: {
                birthYear: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                censusRecordsId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                firstName: faker.word.sample(),
                hireDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                lastName: faker.word.sample(),
                ssn: faker.word.sample()
            },
            ownersFamilyId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            relationship: faker.word.sample()
        }));
export const getGetPlanOwnersFamilyV2ResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            employee: {
                birthYear: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                censusRecordsId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                firstName: faker.word.sample(),
                hireDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                lastName: faker.word.sample(),
                ssn: faker.word.sample()
            },
            ownersFamilyId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            relationship: faker.word.sample()
        }));
export const getGetPlanOwnersFamilyV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMatchRemediationContributionResponseMock = (overrideResponse = {})=>({
        isNew: faker.datatype.boolean(),
        ucid: faker.word.sample(),
        ...overrideResponse
    });
export const getPostMatchRemediationContributionResponseMock200 = (overrideResponse = {})=>({
        isNew: faker.datatype.boolean(),
        ucid: faker.word.sample(),
        ...overrideResponse
    });
export const getPostMatchRemediationContributionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMatchRemediationContributionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMatchRemediationContributionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMatchRemediationContributionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMatchRemediationContributionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMatchRemediationContributionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMatchRemediationContributionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMatchRemediationContributionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMatchRemediationContributionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMatchRemediationContributionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMatchRemediationContributionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMatchRemediationContributionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMatchRemediationContributionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMatchRemediationContributionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMatchRemediationContributionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMatchRemediationContributionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMatchRemediationContributionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostMatchRemediationContributionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetContributionAdjustmentsResponseMock = (overrideResponse = {})=>({
        adjustmentData: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                columnNames: Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                contributionAmount: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                correctionType: faker.word.sample(),
                createdAt: faker.word.sample(),
                errorCode: faker.word.sample(),
                firstName: faker.word.sample(),
                lastName: faker.word.sample(),
                ssn: faker.word.sample(),
                unallowedAmount: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            })),
        fileTag: faker.word.sample(),
        ...overrideResponse
    });
export const getGetContributionAdjustmentsResponseMock200 = (overrideResponse = {})=>({
        adjustmentData: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                columnNames: Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                contributionAmount: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                correctionType: faker.word.sample(),
                createdAt: faker.word.sample(),
                errorCode: faker.word.sample(),
                firstName: faker.word.sample(),
                lastName: faker.word.sample(),
                ssn: faker.word.sample(),
                unallowedAmount: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            })),
        fileTag: faker.word.sample(),
        ...overrideResponse
    });
export const getGetContributionAdjustmentsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetContributionAdjustmentsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetContributionAdjustmentsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetContributionAdjustmentsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetContributionAdjustmentsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetContributionAdjustmentsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetContributionAdjustmentsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetContributionAdjustmentsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetContributionAdjustmentsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetContributionAdjustmentsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetContributionAdjustmentsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetContributionAdjustmentsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetContributionAdjustmentsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetContributionAdjustmentsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetContributionAdjustmentsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetContributionAdjustmentsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetContributionAdjustmentsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetContributionAdjustmentsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeClassesResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            employeeClass: faker.word.sample(),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            isExcluded: faker.datatype.boolean()
        }));
export const getGetEmployeeClassesResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            employeeClass: faker.word.sample(),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            isExcluded: faker.datatype.boolean()
        }));
export const getGetEmployeeClassesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeClassesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeClassesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeClassesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeClassesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeClassesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeClassesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeClassesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeClassesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeClassesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeClassesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeClassesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeClassesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeClassesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeClassesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeClassesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeClassesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeClassesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeDetailsResponseMock = (overrideResponse = {})=>({
        contributions: {
            contributionLimit: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            employeeYTDContributions: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            employerYTDContributions: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            stateEmployeeYTDContributions: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            totalDollars: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        },
        editAccess: {
            isAllowedToUpdate: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            message: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            participantId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            sponsorId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        },
        employee: {
            accountId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            activationDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            addressUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            advisorId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            afterTaxContribution: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            afterTaxContributionType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            autorebalance: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            birthDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            cipStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contactInformation: {
                address: {
                    address1: faker.word.sample(),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.word.sample(),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.word.sample(),
                    zip: faker.word.sample()
                },
                mailingAddress: faker.helpers.arrayElement([
                    {
                        address1: faker.word.sample(),
                        address2: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        city: faker.word.sample(),
                        country: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        state: faker.word.sample(),
                        zip: faker.word.sample()
                    },
                    undefined
                ]),
                personalEmail: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                phoneNumber: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                physicalSameAsMailing: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                workEmail: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            contributesToRoth: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            contribution: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            contributions: faker.helpers.arrayElement([
                {
                    irsLimit: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                undefined
            ]),
            contributionType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            createdAt: faker.word.sample(),
            dateOfTermination: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            deferralChanged: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            deferralElections: {
                afterTaxAmt: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                afterTaxType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                preTaxAmt: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                preTaxType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                rothAmt: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                rothType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            eligibility: faker.helpers.arrayElement([
                {
                    ageRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    entryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isLtpt: faker.datatype.boolean(),
                    isOverride: faker.datatype.boolean(),
                    overrideNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    serviceRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    status: faker.word.sample()
                },
                undefined
            ]),
            emailUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employeeClass: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employeeStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employmentStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            esaGroupId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            esaGroupName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            externalId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            firstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            gender: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            inRmdAge: faker.datatype.boolean(),
            isDeceased: faker.datatype.boolean(),
            isDisabled: faker.datatype.boolean(),
            isExcluded: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isVerified: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            lastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            maritalStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            matchEligibility: faker.helpers.arrayElement([
                {
                    ageRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    entryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isLtpt: faker.datatype.boolean(),
                    isOverride: faker.datatype.boolean(),
                    overrideNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    serviceRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    status: faker.word.sample()
                },
                undefined
            ]),
            middleName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            model: faker.helpers.arrayElement([
                {
                    modelId: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    modelName: faker.word.sample(),
                    modelType: faker.word.sample(),
                    modelViewName: faker.word.sample()
                },
                undefined
            ]),
            nameUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            onboardingWizardCompletedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            participantChangedDeferralAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            password: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            planId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            psEligibility: faker.helpers.arrayElement([
                {
                    ageRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    entryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isLtpt: faker.datatype.boolean(),
                    isOverride: faker.datatype.boolean(),
                    overrideNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    serviceRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    status: faker.word.sample()
                },
                undefined
            ]),
            registeredOn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            rehireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            riskValue: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            rothContribution: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            rothContributionType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            savesForRetirement: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            sendEmailUpdate: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            sponsorId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateIraAccountStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateIraCipStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateIraPerEmployerStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            updatedAt: faker.word.sample(),
            updatedBy: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            yearsToRetire: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        },
        ...overrideResponse
    });
export const getGetEmployeeDetailsResponseMock200 = (overrideResponse = {})=>({
        contributions: {
            contributionLimit: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            employeeYTDContributions: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            employerYTDContributions: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            stateEmployeeYTDContributions: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            totalDollars: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        },
        editAccess: {
            isAllowedToUpdate: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            message: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            participantId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            sponsorId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        },
        employee: {
            accountId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            activationDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            addressUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            advisorId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            afterTaxContribution: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            afterTaxContributionType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            autorebalance: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            birthDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            cipStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contactInformation: {
                address: {
                    address1: faker.word.sample(),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.word.sample(),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.word.sample(),
                    zip: faker.word.sample()
                },
                mailingAddress: faker.helpers.arrayElement([
                    {
                        address1: faker.word.sample(),
                        address2: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        city: faker.word.sample(),
                        country: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        state: faker.word.sample(),
                        zip: faker.word.sample()
                    },
                    undefined
                ]),
                personalEmail: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                phoneNumber: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                physicalSameAsMailing: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                workEmail: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            contributesToRoth: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            contribution: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            contributions: faker.helpers.arrayElement([
                {
                    irsLimit: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                undefined
            ]),
            contributionType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            createdAt: faker.word.sample(),
            dateOfTermination: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            deferralChanged: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            deferralElections: {
                afterTaxAmt: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                afterTaxType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                preTaxAmt: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                preTaxType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                rothAmt: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                rothType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            eligibility: faker.helpers.arrayElement([
                {
                    ageRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    entryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isLtpt: faker.datatype.boolean(),
                    isOverride: faker.datatype.boolean(),
                    overrideNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    serviceRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    status: faker.word.sample()
                },
                undefined
            ]),
            emailUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employeeClass: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employeeStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employmentStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            esaGroupId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            esaGroupName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            externalId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            firstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            gender: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            inRmdAge: faker.datatype.boolean(),
            isDeceased: faker.datatype.boolean(),
            isDisabled: faker.datatype.boolean(),
            isExcluded: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isVerified: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            lastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            maritalStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            matchEligibility: faker.helpers.arrayElement([
                {
                    ageRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    entryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isLtpt: faker.datatype.boolean(),
                    isOverride: faker.datatype.boolean(),
                    overrideNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    serviceRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    status: faker.word.sample()
                },
                undefined
            ]),
            middleName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            model: faker.helpers.arrayElement([
                {
                    modelId: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    modelName: faker.word.sample(),
                    modelType: faker.word.sample(),
                    modelViewName: faker.word.sample()
                },
                undefined
            ]),
            nameUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            onboardingWizardCompletedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            participantChangedDeferralAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            password: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            planId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            psEligibility: faker.helpers.arrayElement([
                {
                    ageRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    entryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isLtpt: faker.datatype.boolean(),
                    isOverride: faker.datatype.boolean(),
                    overrideNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    serviceRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    status: faker.word.sample()
                },
                undefined
            ]),
            registeredOn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            rehireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            riskValue: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            rothContribution: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            rothContributionType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            savesForRetirement: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            sendEmailUpdate: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            sponsorId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateIraAccountStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateIraCipStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateIraPerEmployerStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            updatedAt: faker.word.sample(),
            updatedBy: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            yearsToRetire: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        },
        ...overrideResponse
    });
export const getGetEmployeeDetailsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeDetailsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeDetailsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeDetailsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeDetailsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeDetailsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeDetailsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeDetailsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeDetailsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeDetailsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeDetailsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeDetailsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeDetailsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeDetailsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeDetailsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeDetailsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeDetailsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEmployeeDetailsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEntityResponseMock = (overrideResponse = {})=>({
        data: {
            attributes: {
                isConvert: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            relationships: {
                firm: {
                    data: {
                        id: faker.number.int({
                            min: undefined,
                            max: undefined
                        })
                    }
                }
            }
        },
        included: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                attributes: {
                    recordKeeperId: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                }
            })),
        ...overrideResponse
    });
export const getGetSponsorEntityResponseMock200 = (overrideResponse = {})=>({
        data: {
            attributes: {
                isConvert: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            relationships: {
                firm: {
                    data: {
                        id: faker.number.int({
                            min: undefined,
                            max: undefined
                        })
                    }
                }
            }
        },
        included: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                attributes: {
                    recordKeeperId: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                }
            })),
        ...overrideResponse
    });
export const getGetSponsorEntityResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEntityResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEntityResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEntityResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEntityResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEntityResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEntityResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEntityResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEntityResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEntityResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEntityResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEntityResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEntityResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEntityResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEntityResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEntityResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEntityResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEntityResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetForfeiturePreferenceResponseMock = (overrideResponse = {})=>({
        createdAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        id: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        offsetEmployerContribution: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        payPlanFees: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        updatedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetForfeiturePreferenceResponseMock200 = (overrideResponse = {})=>({
        createdAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        id: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        offsetEmployerContribution: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        payPlanFees: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        updatedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetForfeiturePreferenceResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetForfeiturePreferenceResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetForfeiturePreferenceResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetForfeiturePreferenceResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetForfeiturePreferenceResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetForfeiturePreferenceResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetForfeiturePreferenceResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetForfeiturePreferenceResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetForfeiturePreferenceResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetForfeiturePreferenceResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetForfeiturePreferenceResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetForfeiturePreferenceResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetForfeiturePreferenceResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetForfeiturePreferenceResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetForfeiturePreferenceResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetForfeiturePreferenceResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetForfeiturePreferenceResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetForfeiturePreferenceResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutForfeiturePreferenceResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutForfeiturePreferenceResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutForfeiturePreferenceResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutForfeiturePreferenceResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutForfeiturePreferenceResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutForfeiturePreferenceResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutForfeiturePreferenceResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutForfeiturePreferenceResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutForfeiturePreferenceResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutForfeiturePreferenceResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutForfeiturePreferenceResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutForfeiturePreferenceResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutForfeiturePreferenceResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutForfeiturePreferenceResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutForfeiturePreferenceResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutForfeiturePreferenceResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutForfeiturePreferenceResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutForfeiturePreferenceResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOnboardingResponseMock = (overrideResponse = {})=>({
        schemaState: {
            censusInfo: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            companyInfo: faker.helpers.arrayElement([
                {
                    mailingAddress: faker.helpers.arrayElement([
                        {},
                        undefined
                    ]),
                    physicalAddress: faker.helpers.arrayElement([
                        {},
                        undefined
                    ])
                },
                undefined
            ]),
            conversionInfo: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            employeeGroups: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>({
                        description: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        dollarCap: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        incentivesOptOut: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        initialBonusAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        initialBonusMinimum: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        lifetimeCap: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        localId: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        milestoneBonusAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        milestoneBonusThreshold: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        name: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        percent: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    })),
                undefined
            ]),
            paymentSetup: faker.helpers.arrayElement([
                {
                    bankAccounts: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>({})),
                        undefined
                    ]),
                    feePayment: faker.helpers.arrayElement([
                        {
                            bankAccountLocalId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                null
                            ]),
                            isPayingWithCreditCard: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    forfeiturePreferences: faker.helpers.arrayElement([
                        {},
                        undefined
                    ]),
                    fundingMethods: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>({})),
                        undefined
                    ]),
                    payrollSchedules: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                fundingMethodId: faker.helpers.arrayElement([
                                    faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    }),
                                    undefined
                                ]),
                                scheduleName: faker.helpers.arrayElement([
                                    faker.word.sample(),
                                    undefined
                                ])
                            })),
                        undefined
                    ]),
                    payrollSystemId: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ])
                },
                undefined
            ]),
            payrollSetup: {
                payrollSchedules: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>({})),
                    undefined
                ]),
                payrollSystem: faker.helpers.arrayElement([
                    {},
                    undefined
                ])
            },
            planAdministration: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            planOptions: faker.helpers.arrayElement([
                {},
                undefined
            ])
        },
        status: faker.helpers.arrayElement([
            'completed_successfully',
            'completed_unsuccessfully',
            'in_progress',
            'needs_attention',
            'new',
            'ongoing'
        ]),
        ...overrideResponse
    });
export const getGetOnboardingResponseMock200 = (overrideResponse = {})=>({
        schemaState: {
            censusInfo: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            companyInfo: faker.helpers.arrayElement([
                {
                    mailingAddress: faker.helpers.arrayElement([
                        {},
                        undefined
                    ]),
                    physicalAddress: faker.helpers.arrayElement([
                        {},
                        undefined
                    ])
                },
                undefined
            ]),
            conversionInfo: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            employeeGroups: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>({
                        description: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        dollarCap: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        incentivesOptOut: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        initialBonusAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        initialBonusMinimum: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        lifetimeCap: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        localId: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        milestoneBonusAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        milestoneBonusThreshold: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        name: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        percent: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    })),
                undefined
            ]),
            paymentSetup: faker.helpers.arrayElement([
                {
                    bankAccounts: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>({})),
                        undefined
                    ]),
                    feePayment: faker.helpers.arrayElement([
                        {
                            bankAccountLocalId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                null
                            ]),
                            isPayingWithCreditCard: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    forfeiturePreferences: faker.helpers.arrayElement([
                        {},
                        undefined
                    ]),
                    fundingMethods: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>({})),
                        undefined
                    ]),
                    payrollSchedules: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                fundingMethodId: faker.helpers.arrayElement([
                                    faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    }),
                                    undefined
                                ]),
                                scheduleName: faker.helpers.arrayElement([
                                    faker.word.sample(),
                                    undefined
                                ])
                            })),
                        undefined
                    ]),
                    payrollSystemId: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ])
                },
                undefined
            ]),
            payrollSetup: {
                payrollSchedules: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>({})),
                    undefined
                ]),
                payrollSystem: faker.helpers.arrayElement([
                    {},
                    undefined
                ])
            },
            planAdministration: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            planOptions: faker.helpers.arrayElement([
                {},
                undefined
            ])
        },
        status: faker.helpers.arrayElement([
            'completed_successfully',
            'completed_unsuccessfully',
            'in_progress',
            'needs_attention',
            'new',
            'ongoing'
        ]),
        ...overrideResponse
    });
export const getGetOnboardingResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOnboardingResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOnboardingResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOnboardingResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOnboardingResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOnboardingResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOnboardingResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOnboardingResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOnboardingResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOnboardingResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOnboardingResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOnboardingResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOnboardingResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOnboardingResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOnboardingResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOnboardingResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOnboardingResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOnboardingResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorOnboardingInformationResponseMock = (overrideResponse = {})=>({
        fields: {
            above10M: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            address1: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            address2: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            advisorsFeesPaidBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            advisoryServiceId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            articlesOfIncorporationLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            assetBasedFeesPaidBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authorizedSignerEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerAddress1: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerAddress2: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerCity: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerDateOfBirth: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerFirstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerLastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerResidenceCountry: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerSSN: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerState: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerTitle: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerWorkPhone: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerZip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            billingContactEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            censusLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            chargesOffPlatform: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            citizenshipType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            city: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            comment: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyEntityType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyPhoneNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            controlGroupBusinesses: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    business: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    ein: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            conversionParticipantDetailsLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            dateSubmittedToRecordkeeper: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            disablePlanDesign: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            doingBusinessAs: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employerIdentificationNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanAssets: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanContactEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanCustodian: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanParticipants: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanProvider: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            expectedAnnualContributions: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            feePaymentMethod: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            feesPaidBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            first3M: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            fiscalYearEnd: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            form5500Link: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            hasCensus: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasMultiplePayrollGroups: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasPdmp: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasUnion: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hqCountry: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            identificationCountry: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationExpirationDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationIssueDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationState: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            investmentProductId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            isActive: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isAuthorizedSigner: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isConvertedPlan: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            leasedEmployeesNumber: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            newOnboarding: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            next2M: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            next5M: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            offsetEmployerContribution: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ownerForeignDignitaryCountry: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ownerIsForeignDignitary: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ownersFamilyMembersEmployees: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    name: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    taxFormType: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            ownersOver5Percent: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            paaLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            participationAgreementLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            partTimeEmployeesNumber: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            payPlanFees: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            perParticipantFeesPaidBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            planTier: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            planType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            planYear: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactFirstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactLastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactTitle: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            standardIndustrialClassification: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            state: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateOfIncorporation: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            summaryPlanDescriptionLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            teamMemberEmails: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            totalEmployeesNumber: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            tpaId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            updatedBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            wiredAtWork: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            zip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        ...overrideResponse
    });
export const getGetSponsorOnboardingInformationResponseMock200 = (overrideResponse = {})=>({
        fields: {
            above10M: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            address1: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            address2: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            advisorsFeesPaidBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            advisoryServiceId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            articlesOfIncorporationLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            assetBasedFeesPaidBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authorizedSignerEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerAddress1: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerAddress2: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerCity: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerDateOfBirth: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerFirstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerLastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerResidenceCountry: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerSSN: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerState: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerTitle: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerWorkPhone: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerZip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            billingContactEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            censusLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            chargesOffPlatform: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            citizenshipType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            city: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            comment: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyEntityType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyPhoneNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            controlGroupBusinesses: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    business: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    ein: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            conversionParticipantDetailsLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            dateSubmittedToRecordkeeper: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            disablePlanDesign: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            doingBusinessAs: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employerIdentificationNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanAssets: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanContactEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanCustodian: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanParticipants: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanProvider: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            expectedAnnualContributions: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            feePaymentMethod: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            feesPaidBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            first3M: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            fiscalYearEnd: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            form5500Link: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            hasCensus: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasMultiplePayrollGroups: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasPdmp: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasUnion: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hqCountry: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            identificationCountry: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationExpirationDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationIssueDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationState: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            investmentProductId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            isActive: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isAuthorizedSigner: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isConvertedPlan: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            leasedEmployeesNumber: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            newOnboarding: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            next2M: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            next5M: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            offsetEmployerContribution: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ownerForeignDignitaryCountry: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ownerIsForeignDignitary: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ownersFamilyMembersEmployees: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    name: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    taxFormType: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            ownersOver5Percent: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            paaLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            participationAgreementLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            partTimeEmployeesNumber: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            payPlanFees: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            perParticipantFeesPaidBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            planTier: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            planType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            planYear: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactFirstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactLastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactTitle: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            standardIndustrialClassification: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            state: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateOfIncorporation: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            summaryPlanDescriptionLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            teamMemberEmails: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            totalEmployeesNumber: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            tpaId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            updatedBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            wiredAtWork: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            zip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        ...overrideResponse
    });
export const getGetSponsorOnboardingInformationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorOnboardingInformationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorOnboardingInformationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorOnboardingInformationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorOnboardingInformationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorOnboardingInformationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorOnboardingInformationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorOnboardingInformationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorOnboardingInformationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorOnboardingInformationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorOnboardingInformationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorOnboardingInformationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorOnboardingInformationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorOnboardingInformationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorOnboardingInformationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorOnboardingInformationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorOnboardingInformationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorOnboardingInformationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutSponsorOnboardingInformationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutSponsorOnboardingInformationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutSponsorOnboardingInformationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutSponsorOnboardingInformationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutSponsorOnboardingInformationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutSponsorOnboardingInformationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutSponsorOnboardingInformationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutSponsorOnboardingInformationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutSponsorOnboardingInformationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutSponsorOnboardingInformationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutSponsorOnboardingInformationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutSponsorOnboardingInformationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutSponsorOnboardingInformationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutSponsorOnboardingInformationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutSponsorOnboardingInformationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutSponsorOnboardingInformationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutSponsorOnboardingInformationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutSponsorOnboardingInformationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadCensusResponseMock = (overrideResponse = {})=>({
        createdAt: faker.word.sample(),
        documentKey: faker.word.sample(),
        entity: faker.word.sample(),
        entityId: faker.word.sample(),
        etag: faker.word.sample(),
        groupDetails: faker.helpers.arrayElement([
            {
                effectiveDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                groupId: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                uploadHistoryId: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        isDraft: faker.datatype.boolean(),
        isEnabled: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        originalFileName: faker.word.sample(),
        uploadPath: faker.word.sample(),
        ...overrideResponse
    });
export const getPostUploadCensusResponseMock200 = (overrideResponse = {})=>({
        createdAt: faker.word.sample(),
        documentKey: faker.word.sample(),
        entity: faker.word.sample(),
        entityId: faker.word.sample(),
        etag: faker.word.sample(),
        groupDetails: faker.helpers.arrayElement([
            {
                effectiveDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                groupId: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                uploadHistoryId: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        isDraft: faker.datatype.boolean(),
        isEnabled: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        originalFileName: faker.word.sample(),
        uploadPath: faker.word.sample(),
        ...overrideResponse
    });
export const getPostUploadCensusResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadCensusResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadCensusResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadCensusResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadCensusResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadCensusResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadCensusResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadCensusResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadCensusResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadCensusResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadCensusResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadCensusResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadCensusResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadCensusResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadCensusResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadCensusResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadCensusResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadCensusResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadOnboardingCensusOriginalResponseMock = (overrideResponse = {})=>({
        createdAt: faker.word.sample(),
        documentKey: faker.word.sample(),
        entity: faker.word.sample(),
        entityId: faker.word.sample(),
        etag: faker.word.sample(),
        groupDetails: faker.helpers.arrayElement([
            {
                effectiveDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                groupId: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                uploadHistoryId: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        isDraft: faker.datatype.boolean(),
        isEnabled: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        originalFileName: faker.word.sample(),
        uploadPath: faker.word.sample(),
        ...overrideResponse
    });
export const getPostUploadOnboardingCensusOriginalResponseMock200 = (overrideResponse = {})=>({
        createdAt: faker.word.sample(),
        documentKey: faker.word.sample(),
        entity: faker.word.sample(),
        entityId: faker.word.sample(),
        etag: faker.word.sample(),
        groupDetails: faker.helpers.arrayElement([
            {
                effectiveDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                groupId: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                uploadHistoryId: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        isDraft: faker.datatype.boolean(),
        isEnabled: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        originalFileName: faker.word.sample(),
        uploadPath: faker.word.sample(),
        ...overrideResponse
    });
export const getPostUploadOnboardingCensusOriginalResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadOnboardingCensusOriginalResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadOnboardingCensusOriginalResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadOnboardingCensusOriginalResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadOnboardingCensusOriginalResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadOnboardingCensusOriginalResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadOnboardingCensusOriginalResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadOnboardingCensusOriginalResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadOnboardingCensusOriginalResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadOnboardingCensusOriginalResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadOnboardingCensusOriginalResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadOnboardingCensusOriginalResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadOnboardingCensusOriginalResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadOnboardingCensusOriginalResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadOnboardingCensusOriginalResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadOnboardingCensusOriginalResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadOnboardingCensusOriginalResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostUploadOnboardingCensusOriginalResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusCacheResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({})),
        ...overrideResponse
    });
export const getGetCensusCacheResponseMock200 = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({})),
        ...overrideResponse
    });
export const getGetCensusCacheResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusCacheResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusCacheResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusCacheResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusCacheResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusCacheResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusCacheResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusCacheResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusCacheResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusCacheResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusCacheResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusCacheResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusCacheResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusCacheResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusCacheResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusCacheResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusCacheResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusCacheResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEsaProgramResponseMock = (overrideResponse = {})=>({
        allowInitialBonus: faker.datatype.boolean(),
        allowMatch: faker.datatype.boolean(),
        allowMilestoneBonus: faker.datatype.boolean(),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEsaProgramResponseMock200 = (overrideResponse = {})=>({
        allowInitialBonus: faker.datatype.boolean(),
        allowMatch: faker.datatype.boolean(),
        allowMilestoneBonus: faker.datatype.boolean(),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEsaProgramResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEsaProgramResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEsaProgramResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEsaProgramResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEsaProgramResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEsaProgramResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEsaProgramResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEsaProgramResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEsaProgramResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEsaProgramResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEsaProgramResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEsaProgramResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEsaProgramResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEsaProgramResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEsaProgramResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEsaProgramResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEsaProgramResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorEsaProgramResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPayrollProvidersResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            dateFormat: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            defaultAdapterId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            instructionLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            integrationTypeId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            isApproved: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isPiIntegrated: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            level: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            name: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            subName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            useCatchupFields: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            useK1: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            useTiredMatch: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ])
        }));
export const getGetPayrollProvidersResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            dateFormat: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            defaultAdapterId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            instructionLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            integrationTypeId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            isApproved: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isPiIntegrated: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            level: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            name: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            subName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            useCatchupFields: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            useK1: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            useTiredMatch: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ])
        }));
export const getGetPayrollProvidersResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPayrollProvidersResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPayrollProvidersResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPayrollProvidersResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPayrollProvidersResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPayrollProvidersResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPayrollProvidersResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPayrollProvidersResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPayrollProvidersResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPayrollProvidersResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPayrollProvidersResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPayrollProvidersResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPayrollProvidersResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPayrollProvidersResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPayrollProvidersResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPayrollProvidersResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPayrollProvidersResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPayrollProvidersResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignConsultStateResponseMock = (overrideResponse = {})=>({
        calendlyUrl: faker.word.sample(),
        isConversion: faker.datatype.boolean(),
        isJpm: faker.datatype.boolean(),
        planDesignConsultType: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                'Full Consultation',
                'Sales Consultation',
                'Partner Consultation',
                'Self Service Tiles',
                'Solo(K)',
                'Website Direct'
            ]),
            undefined
        ]),
        tpaId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetPlanDesignConsultStateResponseMock200 = (overrideResponse = {})=>({
        calendlyUrl: faker.word.sample(),
        isConversion: faker.datatype.boolean(),
        isJpm: faker.datatype.boolean(),
        planDesignConsultType: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                'Full Consultation',
                'Sales Consultation',
                'Partner Consultation',
                'Self Service Tiles',
                'Solo(K)',
                'Website Direct'
            ]),
            undefined
        ]),
        tpaId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetPlanDesignConsultStateResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignConsultStateResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignConsultStateResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignConsultStateResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignConsultStateResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignConsultStateResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignConsultStateResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignConsultStateResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignConsultStateResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignConsultStateResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignConsultStateResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignConsultStateResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignConsultStateResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignConsultStateResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignConsultStateResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignConsultStateResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignConsultStateResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanDesignConsultStateResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanDesignConsultStateResponseMock = (overrideResponse = {})=>({
        planDesignConsultType: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                'Full Consultation',
                'Sales Consultation',
                'Partner Consultation',
                'Self Service Tiles',
                'Solo(K)',
                'Website Direct'
            ]),
            undefined
        ]),
        ...overrideResponse
    });
export const getPatchPlanDesignConsultStateResponseMock200 = (overrideResponse = {})=>({
        planDesignConsultType: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                'Full Consultation',
                'Sales Consultation',
                'Partner Consultation',
                'Self Service Tiles',
                'Solo(K)',
                'Website Direct'
            ]),
            undefined
        ]),
        ...overrideResponse
    });
export const getPatchPlanDesignConsultStateResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanDesignConsultStateResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanDesignConsultStateResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanDesignConsultStateResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanDesignConsultStateResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanDesignConsultStateResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanDesignConsultStateResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanDesignConsultStateResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanDesignConsultStateResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanDesignConsultStateResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanDesignConsultStateResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanDesignConsultStateResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanDesignConsultStateResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanDesignConsultStateResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanDesignConsultStateResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanDesignConsultStateResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanDesignConsultStateResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchPlanDesignConsultStateResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanLaunchCallUrlResponseMock = (overrideResponse = {})=>({
        bookingLink: faker.helpers.arrayElement([
            faker.word.sample(),
            null
        ]),
        ...overrideResponse
    });
export const getGetPlanLaunchCallUrlResponseMock200 = (overrideResponse = {})=>({
        bookingLink: faker.helpers.arrayElement([
            faker.word.sample(),
            null
        ]),
        ...overrideResponse
    });
export const getGetPlanLaunchCallUrlResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanLaunchCallUrlResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanLaunchCallUrlResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanLaunchCallUrlResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanLaunchCallUrlResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanLaunchCallUrlResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanLaunchCallUrlResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanLaunchCallUrlResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanLaunchCallUrlResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanLaunchCallUrlResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanLaunchCallUrlResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanLaunchCallUrlResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanLaunchCallUrlResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanLaunchCallUrlResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanLaunchCallUrlResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanLaunchCallUrlResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanLaunchCallUrlResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanLaunchCallUrlResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUserRolesResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            accessRoleIds: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>faker.number.int({
                    min: undefined,
                    max: undefined
                })),
            clientId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            entityId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            entityType: faker.word.sample(),
            isTemp: faker.datatype.boolean(),
            userId: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetUserRolesResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            accessRoleIds: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>faker.number.int({
                    min: undefined,
                    max: undefined
                })),
            clientId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            entityId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            entityType: faker.word.sample(),
            isTemp: faker.datatype.boolean(),
            userId: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetUserRolesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUserRolesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUserRolesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUserRolesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUserRolesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUserRolesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUserRolesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUserRolesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUserRolesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUserRolesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUserRolesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUserRolesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUserRolesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUserRolesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUserRolesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUserRolesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUserRolesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUserRolesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostBulkPayrollSetupDisconnectionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostBulkPayrollSetupDisconnectionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostBulkPayrollSetupDisconnectionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostBulkPayrollSetupDisconnectionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostBulkPayrollSetupDisconnectionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostBulkPayrollSetupDisconnectionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostBulkPayrollSetupDisconnectionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostBulkPayrollSetupDisconnectionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostBulkPayrollSetupDisconnectionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostBulkPayrollSetupDisconnectionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostBulkPayrollSetupDisconnectionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostBulkPayrollSetupDisconnectionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostBulkPayrollSetupDisconnectionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostBulkPayrollSetupDisconnectionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostBulkPayrollSetupDisconnectionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostBulkPayrollSetupDisconnectionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostBulkPayrollSetupDisconnectionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostBulkPayrollSetupDisconnectionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPayrollSkipStatusResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPayrollSkipStatusResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPayrollSkipStatusResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPayrollSkipStatusResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPayrollSkipStatusResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPayrollSkipStatusResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPayrollSkipStatusResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPayrollSkipStatusResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPayrollSkipStatusResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPayrollSkipStatusResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPayrollSkipStatusResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPayrollSkipStatusResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPayrollSkipStatusResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPayrollSkipStatusResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPayrollSkipStatusResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPayrollSkipStatusResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPayrollSkipStatusResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPayrollSkipStatusResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPayrollSetupDisconnectionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPayrollSetupDisconnectionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPayrollSetupDisconnectionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPayrollSetupDisconnectionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPayrollSetupDisconnectionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPayrollSetupDisconnectionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPayrollSetupDisconnectionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPayrollSetupDisconnectionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPayrollSetupDisconnectionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPayrollSetupDisconnectionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPayrollSetupDisconnectionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPayrollSetupDisconnectionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPayrollSetupDisconnectionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPayrollSetupDisconnectionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPayrollSetupDisconnectionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPayrollSetupDisconnectionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPayrollSetupDisconnectionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPayrollSetupDisconnectionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanFeaturesResponseMock = (overrideResponse = {})=>({
        allowRollover: faker.word.sample(),
        autoEnrollAmountPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        autoEnrollEffectiveDate: faker.word.sample(),
        autoEscalateAmount: faker.number.int({
            min: undefined,
            max: undefined
        }),
        blackoutEndDate: faker.word.sample(),
        blackoutStartDate: faker.word.sample(),
        hasDualEligibility: faker.datatype.boolean(),
        hasPriorLoans: faker.datatype.boolean(),
        isAfterTaxContributionAllowed: faker.datatype.boolean(),
        isAutoEnroll: faker.datatype.boolean(),
        isAutoEscalate: faker.datatype.boolean(),
        isCalculateEmployerMatch: faker.datatype.boolean(),
        isDeferInDollars: faker.datatype.boolean(),
        isEarlyRetirementAllowed: faker.datatype.boolean(),
        isEmployerMatching: faker.datatype.boolean(),
        isHardshipDistributionAllowed: faker.datatype.boolean(),
        isHardshipProofRequired: faker.datatype.boolean(),
        isLoansAllowed: faker.datatype.boolean(),
        isPreTaxContributionAllowed: faker.datatype.boolean(),
        isProfitSharing: faker.datatype.boolean(),
        isSafeHarborMatchAllowed: faker.datatype.boolean(),
        isSafeHarborNonElectiveAllowed: faker.datatype.boolean(),
        isSalaryRothDeferral: faker.datatype.boolean(),
        profitSharingType: faker.word.sample(),
        safeHarborContributionType: faker.word.sample(),
        safeHarborMatchType: faker.word.sample(),
        safeHarborMatchTypeDescription: faker.word.sample(),
        vestingPeriod: faker.word.sample(),
        ...overrideResponse
    });
export const getGetPlanFeaturesResponseMock200 = (overrideResponse = {})=>({
        allowRollover: faker.word.sample(),
        autoEnrollAmountPct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        autoEnrollEffectiveDate: faker.word.sample(),
        autoEscalateAmount: faker.number.int({
            min: undefined,
            max: undefined
        }),
        blackoutEndDate: faker.word.sample(),
        blackoutStartDate: faker.word.sample(),
        hasDualEligibility: faker.datatype.boolean(),
        hasPriorLoans: faker.datatype.boolean(),
        isAfterTaxContributionAllowed: faker.datatype.boolean(),
        isAutoEnroll: faker.datatype.boolean(),
        isAutoEscalate: faker.datatype.boolean(),
        isCalculateEmployerMatch: faker.datatype.boolean(),
        isDeferInDollars: faker.datatype.boolean(),
        isEarlyRetirementAllowed: faker.datatype.boolean(),
        isEmployerMatching: faker.datatype.boolean(),
        isHardshipDistributionAllowed: faker.datatype.boolean(),
        isHardshipProofRequired: faker.datatype.boolean(),
        isLoansAllowed: faker.datatype.boolean(),
        isPreTaxContributionAllowed: faker.datatype.boolean(),
        isProfitSharing: faker.datatype.boolean(),
        isSafeHarborMatchAllowed: faker.datatype.boolean(),
        isSafeHarborNonElectiveAllowed: faker.datatype.boolean(),
        isSalaryRothDeferral: faker.datatype.boolean(),
        profitSharingType: faker.word.sample(),
        safeHarborContributionType: faker.word.sample(),
        safeHarborMatchType: faker.word.sample(),
        safeHarborMatchTypeDescription: faker.word.sample(),
        vestingPeriod: faker.word.sample(),
        ...overrideResponse
    });
export const getGetPlanFeaturesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanFeaturesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanFeaturesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanFeaturesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanFeaturesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanFeaturesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanFeaturesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanFeaturesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanFeaturesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanFeaturesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanFeaturesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanFeaturesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanFeaturesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanFeaturesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanFeaturesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanFeaturesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanFeaturesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanFeaturesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSponsorPlanDisconnectionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSponsorPlanDisconnectionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSponsorPlanDisconnectionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSponsorPlanDisconnectionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSponsorPlanDisconnectionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSponsorPlanDisconnectionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSponsorPlanDisconnectionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSponsorPlanDisconnectionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSponsorPlanDisconnectionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSponsorPlanDisconnectionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSponsorPlanDisconnectionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSponsorPlanDisconnectionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSponsorPlanDisconnectionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSponsorPlanDisconnectionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSponsorPlanDisconnectionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSponsorPlanDisconnectionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSponsorPlanDisconnectionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSponsorPlanDisconnectionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanStatisticsResponseMock = (overrideResponse = {})=>({
        data: {
            attributes: {
                accountBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                cashBalanceInterestRate: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                contributingAvgDeferralRatePct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                currentPositionsEmployee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                currentPositionsEmployer: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                currentPositionsLoan: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                currentPositionsRollover: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                eligibleParticipants: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                eligiblesAvgDeferralRatePct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                employedParticipants: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                modelAgeDistributions: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            ageRange: faker.helpers.arrayElement([
                                faker.helpers.arrayElement([
                                    '<=25',
                                    '26-35',
                                    '36-45',
                                    '46-55',
                                    '56-65',
                                    '>=66'
                                ]),
                                undefined
                            ]),
                            balance: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            modelId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            modelName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            modelType: faker.helpers.arrayElement([
                                faker.helpers.arrayElement([
                                    'target',
                                    'risk',
                                    'menu',
                                    'pmenu',
                                    'goal',
                                    'ms_ma',
                                    'ms_ma_menu',
                                    'nli'
                                ]),
                                undefined
                            ]),
                            participantsInModel: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ])
                        })),
                    undefined
                ]),
                modelDistributions: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            balance: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            factsheet: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            modelId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            modelName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            modelType: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            participantsInModel: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            viewName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        })),
                    undefined
                ]),
                mostRecentEmployeeContribution: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                mostRecentEmployerContribution: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                mostRecentLoanContribution: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                nextPayrollDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                participantsWithBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                participantsWithBeneficiary: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                participantsWithDeferrals: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                participationRate: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                readyToEnrollParticipants: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                registeredParticipants: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                terminatedParticipantsWithBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                totalContribution: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                totalParticipants: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                totalPlanMarketValue: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            }
        },
        ...overrideResponse
    });
export const getGetPlanStatisticsResponseMock200 = (overrideResponse = {})=>({
        data: {
            attributes: {
                accountBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                cashBalanceInterestRate: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                contributingAvgDeferralRatePct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                currentPositionsEmployee: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                currentPositionsEmployer: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                currentPositionsLoan: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                currentPositionsRollover: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                eligibleParticipants: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                eligiblesAvgDeferralRatePct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                employedParticipants: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                modelAgeDistributions: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            ageRange: faker.helpers.arrayElement([
                                faker.helpers.arrayElement([
                                    '<=25',
                                    '26-35',
                                    '36-45',
                                    '46-55',
                                    '56-65',
                                    '>=66'
                                ]),
                                undefined
                            ]),
                            balance: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            modelId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            modelName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            modelType: faker.helpers.arrayElement([
                                faker.helpers.arrayElement([
                                    'target',
                                    'risk',
                                    'menu',
                                    'pmenu',
                                    'goal',
                                    'ms_ma',
                                    'ms_ma_menu',
                                    'nli'
                                ]),
                                undefined
                            ]),
                            participantsInModel: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ])
                        })),
                    undefined
                ]),
                modelDistributions: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            balance: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            factsheet: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            modelId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            modelName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            modelType: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            participantsInModel: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            viewName: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        })),
                    undefined
                ]),
                mostRecentEmployeeContribution: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                mostRecentEmployerContribution: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                mostRecentLoanContribution: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                nextPayrollDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                participantsWithBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                participantsWithBeneficiary: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                participantsWithDeferrals: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                participationRate: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                readyToEnrollParticipants: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                registeredParticipants: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                terminatedParticipantsWithBalance: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                totalContribution: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                totalParticipants: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                totalPlanMarketValue: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            }
        },
        ...overrideResponse
    });
export const getGetPlanStatisticsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanStatisticsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanStatisticsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanStatisticsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanStatisticsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanStatisticsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanStatisticsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanStatisticsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanStatisticsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanStatisticsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanStatisticsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanStatisticsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanStatisticsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanStatisticsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanStatisticsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanStatisticsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanStatisticsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanStatisticsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationResponseMock = (overrideResponse = {})=>({
        configurationId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        hasCompleted: faker.datatype.boolean(),
        hasOfficers: faker.datatype.boolean(),
        hasOwners: faker.datatype.boolean(),
        sponsorPlanId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationResponseMock200 = (overrideResponse = {})=>({
        configurationId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        hasCompleted: faker.datatype.boolean(),
        hasOfficers: faker.datatype.boolean(),
        hasOwners: faker.datatype.boolean(),
        sponsorPlanId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanConfigurationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanConfigurationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                min: undefined,
                max: undefined
            }),
            censusRecordsId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            lastName: faker.word.sample(),
            ssn: faker.word.sample()
        }));
export const getGetPlanEmployeesResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                min: undefined,
                max: undefined
            }),
            censusRecordsId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            lastName: faker.word.sample(),
            ssn: faker.word.sample()
        }));
export const getGetPlanEmployeesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanEmployeesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                min: undefined,
                max: undefined
            }),
            censusRecorsdId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            firstName: faker.word.sample(),
            grossCompensation: faker.number.int({
                min: undefined,
                max: undefined
            }),
            grosscompInformationId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            lastName: faker.word.sample(),
            ssn: faker.word.sample()
        }));
export const getGetPlanGrossCompensationResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                min: undefined,
                max: undefined
            }),
            censusRecorsdId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            firstName: faker.word.sample(),
            grossCompensation: faker.number.int({
                min: undefined,
                max: undefined
            }),
            grosscompInformationId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            lastName: faker.word.sample(),
            ssn: faker.word.sample()
        }));
export const getGetPlanGrossCompensationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeGrossCompensationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeGrossCompensationUploadResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanNonEmployeeOwnerResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                min: undefined,
                max: undefined
            }),
            censusRecordsId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isOfficer: faker.datatype.boolean(),
            lastName: faker.word.sample(),
            officerInformationId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            ssn: faker.word.sample()
        }));
export const getGetPlanOfficersResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                min: undefined,
                max: undefined
            }),
            censusRecordsId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isOfficer: faker.datatype.boolean(),
            lastName: faker.word.sample(),
            officerInformationId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            ssn: faker.word.sample()
        }));
export const getGetPlanOfficersResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOfficersResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOfficerStatusResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnerResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                min: undefined,
                max: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isEmployee: faker.datatype.boolean(),
            lastName: faker.word.sample(),
            ownership: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            ownersId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            ownerSince: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getGetPlanOwnersResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                min: undefined,
                max: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isEmployee: faker.datatype.boolean(),
            lastName: faker.word.sample(),
            ownership: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            ownersId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            ownerSince: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getGetPlanOwnersResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostPlanEmployeeOwnerResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanEmployeeOwnerResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getDeletePlanOwnersFamilyResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            employee: {
                birthYear: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                censusRecordsId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                firstName: faker.word.sample(),
                hireDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                lastName: faker.word.sample(),
                ssn: faker.word.sample()
            },
            ownersFamilyId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            relationship: faker.word.sample()
        }));
export const getGetPlanOwnersFamilyResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            employee: {
                birthYear: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                censusRecordsId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                firstName: faker.word.sample(),
                hireDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                lastName: faker.word.sample(),
                ssn: faker.word.sample()
            },
            ownersFamilyId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            relationship: faker.word.sample()
        }));
export const getGetPlanOwnersFamilyResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanOwnersFamilyResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutPlanOwnersFamilyResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorQuestionnaireResponseMock = (overrideResponse = {})=>({
        onboarding: faker.helpers.arrayElement([
            {
                questionnaireSubmittedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getGetSponsorQuestionnaireResponseMock200 = (overrideResponse = {})=>({
        onboarding: faker.helpers.arrayElement([
            {
                questionnaireSubmittedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getGetSponsorQuestionnaireResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorQuestionnaireResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorQuestionnaireResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorQuestionnaireResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorQuestionnaireResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorQuestionnaireResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorQuestionnaireResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorQuestionnaireResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorQuestionnaireResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorQuestionnaireResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorQuestionnaireResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorQuestionnaireResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorQuestionnaireResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorQuestionnaireResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorQuestionnaireResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorQuestionnaireResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorQuestionnaireResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorQuestionnaireResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQuestionnaireInformationResponseMock = (overrideResponse = {})=>({
        address: faker.helpers.arrayElement([
            {
                address1: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                address2: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                city: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                state: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                zip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        anticipatedHires: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        authorizedSignerEmail: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        authSignerFirstName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        authSignerLastName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        authSignerWorkPhone: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        companyEntityType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        companyName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        companyPhoneNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        contributionScenario: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        controlGroupBusinesses: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        currentComplianceIssues: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>faker.word.sample()),
            undefined
        ]),
        dayToDayContactEmail: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        dayToDayContactLastName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        dayToDayContactName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        dayToDayContactNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        doingBusinessAs: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        employerIdentificationNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        existingPlanProvider: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        existingPlanType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        fiscalYearEnd: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        hasOtherBusinesses: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        highlyCompensatedEmployees: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        industryGroup: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isConvert: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isPartOfControlGroup: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ownerEmployees: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        payrollProviderId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        payrollProviderOther: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        questionnaireSubmittedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        relativesOfOwnerEmployees: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        retirementObjectives: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        sponsorPlan: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    pooledPlan: faker.helpers.arrayElement([
                        {
                            pooledPlanId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            pooledPlanType: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    thirdPartyAdminPlan: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                thirdPartyAdminId: faker.helpers.arrayElement([
                                    faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    }),
                                    undefined
                                ])
                            })),
                        undefined
                    ])
                })),
            undefined
        ]),
        stateOfIncorporation: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        totalEmployeesNumber: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        wiredAtWork: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetQuestionnaireInformationResponseMock200 = (overrideResponse = {})=>({
        address: faker.helpers.arrayElement([
            {
                address1: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                address2: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                city: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                state: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                zip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        anticipatedHires: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        authorizedSignerEmail: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        authSignerFirstName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        authSignerLastName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        authSignerWorkPhone: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        companyEntityType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        companyName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        companyPhoneNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        contributionScenario: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        controlGroupBusinesses: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        currentComplianceIssues: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>faker.word.sample()),
            undefined
        ]),
        dayToDayContactEmail: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        dayToDayContactLastName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        dayToDayContactName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        dayToDayContactNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        doingBusinessAs: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        employerIdentificationNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        existingPlanProvider: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        existingPlanType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        fiscalYearEnd: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        hasOtherBusinesses: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        highlyCompensatedEmployees: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        industryGroup: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isConvert: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isPartOfControlGroup: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ownerEmployees: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        payrollProviderId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        payrollProviderOther: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        questionnaireSubmittedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        relativesOfOwnerEmployees: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        retirementObjectives: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        sponsorPlan: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    pooledPlan: faker.helpers.arrayElement([
                        {
                            pooledPlanId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                undefined
                            ]),
                            pooledPlanType: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    thirdPartyAdminPlan: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                thirdPartyAdminId: faker.helpers.arrayElement([
                                    faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    }),
                                    undefined
                                ])
                            })),
                        undefined
                    ])
                })),
            undefined
        ]),
        stateOfIncorporation: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        totalEmployeesNumber: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        wiredAtWork: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetQuestionnaireInformationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQuestionnaireInformationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQuestionnaireInformationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQuestionnaireInformationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQuestionnaireInformationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQuestionnaireInformationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQuestionnaireInformationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQuestionnaireInformationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQuestionnaireInformationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQuestionnaireInformationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQuestionnaireInformationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQuestionnaireInformationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQuestionnaireInformationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQuestionnaireInformationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQuestionnaireInformationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQuestionnaireInformationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQuestionnaireInformationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetQuestionnaireInformationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaPlanDetailsResponseMock = (overrideResponse = {})=>({
        forfeituresBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        migrationDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetSubaPlanDetailsResponseMock200 = (overrideResponse = {})=>({
        forfeituresBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        migrationDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetSubaPlanDetailsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaPlanDetailsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaPlanDetailsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaPlanDetailsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaPlanDetailsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaPlanDetailsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaPlanDetailsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaPlanDetailsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaPlanDetailsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaPlanDetailsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaPlanDetailsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaPlanDetailsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaPlanDetailsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaPlanDetailsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaPlanDetailsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaPlanDetailsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaPlanDetailsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaPlanDetailsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaTransactionsResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                accountId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                actionType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                amount: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                createdAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                forfeitedBalance: faker.helpers.arrayElement([
                    {
                        participantFirstName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        participantId: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        participantLastName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        withdrawalId: faker.number.int({
                            min: undefined,
                            max: undefined
                        })
                    },
                    undefined
                ]),
                fundingContribution: faker.helpers.arrayElement([
                    {
                        expectedPayDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        ucid: faker.word.sample()
                    },
                    undefined
                ]),
                payingFees: faker.helpers.arrayElement([
                    {
                        billingPeriodId: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        periodEndDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        periodStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        purpose: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                sourceTransactionId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                status: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                tracerId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                transactionTypeCode: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            })),
        meta: {
            count: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        ...overrideResponse
    });
export const getGetSubaTransactionsResponseMock200 = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                accountId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                actionType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                amount: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                createdAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                forfeitedBalance: faker.helpers.arrayElement([
                    {
                        participantFirstName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        participantId: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        participantLastName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        withdrawalId: faker.number.int({
                            min: undefined,
                            max: undefined
                        })
                    },
                    undefined
                ]),
                fundingContribution: faker.helpers.arrayElement([
                    {
                        expectedPayDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        ucid: faker.word.sample()
                    },
                    undefined
                ]),
                payingFees: faker.helpers.arrayElement([
                    {
                        billingPeriodId: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        periodEndDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        periodStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        purpose: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                sourceTransactionId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                status: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                tracerId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                transactionTypeCode: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            })),
        meta: {
            count: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        ...overrideResponse
    });
export const getGetSubaTransactionsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaTransactionsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaTransactionsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaTransactionsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaTransactionsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaTransactionsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaTransactionsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaTransactionsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaTransactionsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaTransactionsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaTransactionsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaTransactionsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaTransactionsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaTransactionsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaTransactionsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaTransactionsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaTransactionsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSubaTransactionsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusAutosaveResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusAutosaveResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusAutosaveResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusAutosaveResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusAutosaveResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusAutosaveResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusAutosaveResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusAutosaveResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusAutosaveResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusAutosaveResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusAutosaveResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusAutosaveResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusAutosaveResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusAutosaveResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusAutosaveResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusAutosaveResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusAutosaveResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusAutosaveResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetCensusDataPagedResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            birthDate: faker.word.sample(),
            dateOfHire: faker.word.sample(),
            dateOfRehire: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            dateOfTermination: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employerDiscretionaryMatch: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            employerSafeHarborContribution: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            firstName: faker.word.sample(),
            grossComp: faker.number.int({
                min: undefined,
                max: undefined
            }),
            lastName: faker.word.sample(),
            participantId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            preTaxContribution: faker.number.int({
                min: undefined,
                max: undefined
            }),
            rothContribution: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            secondDateOfTermination: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            sponsorPlanId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            ssn: faker.word.sample(),
            ytdHours: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetYetCensusDataPagedResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            birthDate: faker.word.sample(),
            dateOfHire: faker.word.sample(),
            dateOfRehire: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            dateOfTermination: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employerDiscretionaryMatch: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            employerSafeHarborContribution: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            firstName: faker.word.sample(),
            grossComp: faker.number.int({
                min: undefined,
                max: undefined
            }),
            lastName: faker.word.sample(),
            participantId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            preTaxContribution: faker.number.int({
                min: undefined,
                max: undefined
            }),
            rothContribution: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            secondDateOfTermination: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            sponsorPlanId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            ssn: faker.word.sample(),
            ytdHours: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetYetCensusDataPagedResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetCensusDataPagedResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetCensusDataPagedResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetCensusDataPagedResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetCensusDataPagedResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetCensusDataPagedResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetCensusDataPagedResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetCensusDataPagedResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetCensusDataPagedResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetCensusDataPagedResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetCensusDataPagedResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetCensusDataPagedResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetCensusDataPagedResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetCensusDataPagedResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetCensusDataPagedResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetCensusDataPagedResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetCensusDataPagedResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetCensusDataPagedResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRefreshCensusResponseMock = (overrideResponse = {})=>({
        recordsAdded: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRefreshCensusResponseMock200 = (overrideResponse = {})=>({
        recordsAdded: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRefreshCensusResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRefreshCensusResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRefreshCensusResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRefreshCensusResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRefreshCensusResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRefreshCensusResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRefreshCensusResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRefreshCensusResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRefreshCensusResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRefreshCensusResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRefreshCensusResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRefreshCensusResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRefreshCensusResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRefreshCensusResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRefreshCensusResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRefreshCensusResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRefreshCensusResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRefreshCensusResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartCensusResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartCensusResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartCensusResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartCensusResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartCensusResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartCensusResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartCensusResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartCensusResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartCensusResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartCensusResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartCensusResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartCensusResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartCensusResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartCensusResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartCensusResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartCensusResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartCensusResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartCensusResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusStartResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusStartResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusStartResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusStartResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusStartResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusStartResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusStartResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusStartResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusStartResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusStartResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusStartResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusStartResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusStartResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusStartResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusStartResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusStartResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusStartResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusStartResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusStatusResponseMock = (overrideResponse = {})=>({
        started: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetCensusStatusResponseMock200 = (overrideResponse = {})=>({
        started: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetCensusStatusResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusStatusResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusStatusResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusStatusResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusStatusResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusStatusResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusStatusResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusStatusResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusStatusResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusStatusResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusStatusResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusStatusResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusStatusResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusStatusResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusStatusResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusStatusResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusStatusResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCensusStatusResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusSubmitResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusSubmitResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusSubmitResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusSubmitResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusSubmitResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusSubmitResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusSubmitResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusSubmitResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusSubmitResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusSubmitResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusSubmitResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusSubmitResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusSubmitResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusSubmitResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusSubmitResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusSubmitResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusSubmitResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusSubmitResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusUploadResponseMock = (overrideResponse = {})=>({
        failures: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                error: faker.word.sample(),
                row: faker.word.sample()
            })),
        successCount: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusUploadResponseMock200 = (overrideResponse = {})=>({
        failures: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                error: faker.word.sample(),
                row: faker.word.sample()
            })),
        successCount: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusUploadResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusUploadResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusUploadResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusUploadResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusUploadResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusUploadResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusUploadResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusUploadResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusUploadResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusUploadResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusUploadResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusUploadResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusUploadResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusUploadResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusUploadResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusUploadResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusUploadResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetCensusUploadResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetChecklistResponseMock = (overrideResponse = {})=>({
        areOfficersCompleted: faker.datatype.boolean(),
        areOwnerFamilyMembersCompleted: faker.datatype.boolean(),
        areOwnersCompleted: faker.datatype.boolean(),
        hasNoOfficers: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        hasNoOwners: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isCensusCompleted: faker.datatype.boolean(),
        isQuestionnaireCompleted: faker.datatype.boolean(),
        isYearEndItemComplete: faker.datatype.boolean(),
        isYearEndPackagingCompleted: faker.datatype.boolean(),
        planYear: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetChecklistResponseMock200 = (overrideResponse = {})=>({
        areOfficersCompleted: faker.datatype.boolean(),
        areOwnerFamilyMembersCompleted: faker.datatype.boolean(),
        areOwnersCompleted: faker.datatype.boolean(),
        hasNoOfficers: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        hasNoOwners: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isCensusCompleted: faker.datatype.boolean(),
        isQuestionnaireCompleted: faker.datatype.boolean(),
        isYearEndItemComplete: faker.datatype.boolean(),
        isYearEndPackagingCompleted: faker.datatype.boolean(),
        planYear: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetChecklistResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetChecklistResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetChecklistResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetChecklistResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetChecklistResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetChecklistResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetChecklistResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetChecklistResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetChecklistResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetChecklistResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetChecklistResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetChecklistResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetChecklistResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetChecklistResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetChecklistResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetChecklistResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetChecklistResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetChecklistResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchYetChecklistResponseMock = (overrideResponse = {})=>({
        areOfficersCompleted: faker.datatype.boolean(),
        areOwnerFamilyMembersCompleted: faker.datatype.boolean(),
        areOwnersCompleted: faker.datatype.boolean(),
        hasNoOfficers: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        hasNoOwners: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isCensusCompleted: faker.datatype.boolean(),
        isQuestionnaireCompleted: faker.datatype.boolean(),
        isYearEndItemComplete: faker.datatype.boolean(),
        isYearEndPackagingCompleted: faker.datatype.boolean(),
        planYear: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchYetChecklistResponseMock200 = (overrideResponse = {})=>({
        areOfficersCompleted: faker.datatype.boolean(),
        areOwnerFamilyMembersCompleted: faker.datatype.boolean(),
        areOwnersCompleted: faker.datatype.boolean(),
        hasNoOfficers: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        hasNoOwners: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isCensusCompleted: faker.datatype.boolean(),
        isQuestionnaireCompleted: faker.datatype.boolean(),
        isYearEndItemComplete: faker.datatype.boolean(),
        isYearEndPackagingCompleted: faker.datatype.boolean(),
        planYear: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchYetChecklistResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchYetChecklistResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchYetChecklistResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchYetChecklistResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchYetChecklistResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchYetChecklistResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchYetChecklistResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchYetChecklistResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchYetChecklistResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchYetChecklistResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchYetChecklistResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchYetChecklistResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchYetChecklistResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchYetChecklistResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchYetChecklistResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchYetChecklistResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchYetChecklistResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchYetChecklistResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetConfigResponseMock = (overrideResponse = {})=>({
        shouldDisplayYearEndPlanToDo: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetYetConfigResponseMock200 = (overrideResponse = {})=>({
        shouldDisplayYearEndPlanToDo: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetYetConfigResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetConfigResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetConfigResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetConfigResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetConfigResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetConfigResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetConfigResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetConfigResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetConfigResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetConfigResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetConfigResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetConfigResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetConfigResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetConfigResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetConfigResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetConfigResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetConfigResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetConfigResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsFundResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsFundResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsFundResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsFundResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsFundResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsFundResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsFundResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsFundResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsFundResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsFundResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsFundResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsFundResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsFundResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsFundResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsFundResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsFundResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsFundResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsFundResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsRefundResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsRefundResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsRefundResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsRefundResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsRefundResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsRefundResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsRefundResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsRefundResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsRefundResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsRefundResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsRefundResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsRefundResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsRefundResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsRefundResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsRefundResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsRefundResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsRefundResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostContributionsRefundResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetDocumentsResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            createdAt: faker.word.sample(),
            documentKey: faker.word.sample(),
            entity: faker.word.sample(),
            entityId: faker.word.sample(),
            etag: faker.word.sample(),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            isEnabled: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            originalFileName: faker.word.sample(),
            uploadPath: faker.word.sample()
        }));
export const getGetYetDocumentsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            createdAt: faker.word.sample(),
            documentKey: faker.word.sample(),
            entity: faker.word.sample(),
            entityId: faker.word.sample(),
            etag: faker.word.sample(),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            isEnabled: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            originalFileName: faker.word.sample(),
            uploadPath: faker.word.sample()
        }));
export const getGetYetDocumentsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetDocumentsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetDocumentsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetDocumentsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetDocumentsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetDocumentsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetDocumentsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetDocumentsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetDocumentsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetDocumentsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetDocumentsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetDocumentsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetDocumentsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetDocumentsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetDocumentsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetDocumentsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetDocumentsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetDocumentsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostStartOfPackagingResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostStartOfPackagingResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostStartOfPackagingResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostStartOfPackagingResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostStartOfPackagingResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostStartOfPackagingResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostStartOfPackagingResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostStartOfPackagingResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostStartOfPackagingResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostStartOfPackagingResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostStartOfPackagingResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostStartOfPackagingResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostStartOfPackagingResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostStartOfPackagingResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostStartOfPackagingResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostStartOfPackagingResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostStartOfPackagingResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostStartOfPackagingResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanTestResultsResponseMock = (overrideResponse = {})=>({
        testExecution: {
            additionalData: {},
            document: faker.helpers.arrayElement([
                {
                    createdAt: faker.word.sample(),
                    documentKey: faker.word.sample(),
                    entity: faker.word.sample(),
                    entityId: faker.word.sample(),
                    etag: faker.word.sample(),
                    id: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    isEnabled: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    originalFileName: faker.word.sample(),
                    uploadPath: faker.word.sample()
                },
                undefined
            ]),
            documentTestResultId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            originalFileName: faker.word.sample(),
            result: faker.word.sample(),
            testId: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        yearEndContribution: {
            result: faker.word.sample(),
            resultCompliancePackage: faker.helpers.arrayElement([
                {
                    document: faker.helpers.arrayElement([
                        {
                            contentType: faker.word.sample(),
                            createdAt: faker.word.sample(),
                            definition: {
                                categoryId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                config: {
                                    dev: {
                                        canSyncToLowerEnvironments: faker.datatype.boolean()
                                    },
                                    extensions: Array.from({
                                        length: faker.number.int({
                                            min: 1,
                                            max: 10
                                        })
                                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                                },
                                createdAt: faker.word.sample(),
                                documentKey: faker.word.sample(),
                                entity: faker.word.sample(),
                                updatedAt: faker.word.sample()
                            },
                            documentKey: faker.word.sample(),
                            entity: faker.word.sample(),
                            entityId: faker.word.sample(),
                            etag: faker.word.sample(),
                            extension: faker.word.sample(),
                            groupDetails: {
                                effectiveDate: faker.word.sample(),
                                groupId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                id: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                uploadHistoryId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                })
                            },
                            id: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            initiatedBy: {
                                id: faker.word.sample(),
                                type: faker.word.sample()
                            },
                            isDraft: faker.datatype.boolean(),
                            isEnabled: faker.datatype.boolean(),
                            originalFileName: faker.word.sample(),
                            uploadPath: faker.word.sample()
                        },
                        undefined
                    ]),
                    result: faker.word.sample(),
                    testId: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                undefined
            ]),
            resultDiscretionaryMatch: faker.helpers.arrayElement([
                {
                    document: faker.helpers.arrayElement([
                        {
                            contentType: faker.word.sample(),
                            createdAt: faker.word.sample(),
                            definition: {
                                categoryId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                config: {
                                    dev: {
                                        canSyncToLowerEnvironments: faker.datatype.boolean()
                                    },
                                    extensions: Array.from({
                                        length: faker.number.int({
                                            min: 1,
                                            max: 10
                                        })
                                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                                },
                                createdAt: faker.word.sample(),
                                documentKey: faker.word.sample(),
                                entity: faker.word.sample(),
                                updatedAt: faker.word.sample()
                            },
                            documentKey: faker.word.sample(),
                            entity: faker.word.sample(),
                            entityId: faker.word.sample(),
                            etag: faker.word.sample(),
                            extension: faker.word.sample(),
                            groupDetails: {
                                effectiveDate: faker.word.sample(),
                                groupId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                id: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                uploadHistoryId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                })
                            },
                            id: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            initiatedBy: {
                                id: faker.word.sample(),
                                type: faker.word.sample()
                            },
                            isDraft: faker.datatype.boolean(),
                            isEnabled: faker.datatype.boolean(),
                            originalFileName: faker.word.sample(),
                            uploadPath: faker.word.sample()
                        },
                        undefined
                    ]),
                    result: faker.word.sample(),
                    testId: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                undefined
            ]),
            resultProfitSharing: faker.helpers.arrayElement([
                {
                    document: faker.helpers.arrayElement([
                        {
                            contentType: faker.word.sample(),
                            createdAt: faker.word.sample(),
                            definition: {
                                categoryId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                config: {
                                    dev: {
                                        canSyncToLowerEnvironments: faker.datatype.boolean()
                                    },
                                    extensions: Array.from({
                                        length: faker.number.int({
                                            min: 1,
                                            max: 10
                                        })
                                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                                },
                                createdAt: faker.word.sample(),
                                documentKey: faker.word.sample(),
                                entity: faker.word.sample(),
                                updatedAt: faker.word.sample()
                            },
                            documentKey: faker.word.sample(),
                            entity: faker.word.sample(),
                            entityId: faker.word.sample(),
                            etag: faker.word.sample(),
                            extension: faker.word.sample(),
                            groupDetails: {
                                effectiveDate: faker.word.sample(),
                                groupId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                id: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                uploadHistoryId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                })
                            },
                            id: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            initiatedBy: {
                                id: faker.word.sample(),
                                type: faker.word.sample()
                            },
                            isDraft: faker.datatype.boolean(),
                            isEnabled: faker.datatype.boolean(),
                            originalFileName: faker.word.sample(),
                            uploadPath: faker.word.sample()
                        },
                        undefined
                    ]),
                    result: faker.word.sample(),
                    testId: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                undefined
            ]),
            resultSafeHarbor: faker.helpers.arrayElement([
                {
                    document: faker.helpers.arrayElement([
                        {
                            contentType: faker.word.sample(),
                            createdAt: faker.word.sample(),
                            definition: {
                                categoryId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                config: {
                                    dev: {
                                        canSyncToLowerEnvironments: faker.datatype.boolean()
                                    },
                                    extensions: Array.from({
                                        length: faker.number.int({
                                            min: 1,
                                            max: 10
                                        })
                                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                                },
                                createdAt: faker.word.sample(),
                                documentKey: faker.word.sample(),
                                entity: faker.word.sample(),
                                updatedAt: faker.word.sample()
                            },
                            documentKey: faker.word.sample(),
                            entity: faker.word.sample(),
                            entityId: faker.word.sample(),
                            etag: faker.word.sample(),
                            extension: faker.word.sample(),
                            groupDetails: {
                                effectiveDate: faker.word.sample(),
                                groupId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                id: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                uploadHistoryId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                })
                            },
                            id: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            initiatedBy: {
                                id: faker.word.sample(),
                                type: faker.word.sample()
                            },
                            isDraft: faker.datatype.boolean(),
                            isEnabled: faker.datatype.boolean(),
                            originalFileName: faker.word.sample(),
                            uploadPath: faker.word.sample()
                        },
                        undefined
                    ]),
                    result: faker.word.sample(),
                    testId: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                undefined
            ]),
            resultYearEndContribution: faker.helpers.arrayElement([
                {
                    document: faker.helpers.arrayElement([
                        {
                            contentType: faker.word.sample(),
                            createdAt: faker.word.sample(),
                            definition: {
                                categoryId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                config: {
                                    dev: {
                                        canSyncToLowerEnvironments: faker.datatype.boolean()
                                    },
                                    extensions: Array.from({
                                        length: faker.number.int({
                                            min: 1,
                                            max: 10
                                        })
                                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                                },
                                createdAt: faker.word.sample(),
                                documentKey: faker.word.sample(),
                                entity: faker.word.sample(),
                                updatedAt: faker.word.sample()
                            },
                            documentKey: faker.word.sample(),
                            entity: faker.word.sample(),
                            entityId: faker.word.sample(),
                            etag: faker.word.sample(),
                            extension: faker.word.sample(),
                            groupDetails: {
                                effectiveDate: faker.word.sample(),
                                groupId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                id: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                uploadHistoryId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                })
                            },
                            id: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            initiatedBy: {
                                id: faker.word.sample(),
                                type: faker.word.sample()
                            },
                            isDraft: faker.datatype.boolean(),
                            isEnabled: faker.datatype.boolean(),
                            originalFileName: faker.word.sample(),
                            uploadPath: faker.word.sample()
                        },
                        undefined
                    ]),
                    result: faker.word.sample(),
                    testId: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                undefined
            ]),
            testId: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        ...overrideResponse
    });
export const getGetPlanTestResultsResponseMock200 = (overrideResponse = {})=>({
        testExecution: {
            additionalData: {},
            document: faker.helpers.arrayElement([
                {
                    createdAt: faker.word.sample(),
                    documentKey: faker.word.sample(),
                    entity: faker.word.sample(),
                    entityId: faker.word.sample(),
                    etag: faker.word.sample(),
                    id: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    isEnabled: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    originalFileName: faker.word.sample(),
                    uploadPath: faker.word.sample()
                },
                undefined
            ]),
            documentTestResultId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            originalFileName: faker.word.sample(),
            result: faker.word.sample(),
            testId: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        yearEndContribution: {
            result: faker.word.sample(),
            resultCompliancePackage: faker.helpers.arrayElement([
                {
                    document: faker.helpers.arrayElement([
                        {
                            contentType: faker.word.sample(),
                            createdAt: faker.word.sample(),
                            definition: {
                                categoryId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                config: {
                                    dev: {
                                        canSyncToLowerEnvironments: faker.datatype.boolean()
                                    },
                                    extensions: Array.from({
                                        length: faker.number.int({
                                            min: 1,
                                            max: 10
                                        })
                                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                                },
                                createdAt: faker.word.sample(),
                                documentKey: faker.word.sample(),
                                entity: faker.word.sample(),
                                updatedAt: faker.word.sample()
                            },
                            documentKey: faker.word.sample(),
                            entity: faker.word.sample(),
                            entityId: faker.word.sample(),
                            etag: faker.word.sample(),
                            extension: faker.word.sample(),
                            groupDetails: {
                                effectiveDate: faker.word.sample(),
                                groupId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                id: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                uploadHistoryId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                })
                            },
                            id: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            initiatedBy: {
                                id: faker.word.sample(),
                                type: faker.word.sample()
                            },
                            isDraft: faker.datatype.boolean(),
                            isEnabled: faker.datatype.boolean(),
                            originalFileName: faker.word.sample(),
                            uploadPath: faker.word.sample()
                        },
                        undefined
                    ]),
                    result: faker.word.sample(),
                    testId: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                undefined
            ]),
            resultDiscretionaryMatch: faker.helpers.arrayElement([
                {
                    document: faker.helpers.arrayElement([
                        {
                            contentType: faker.word.sample(),
                            createdAt: faker.word.sample(),
                            definition: {
                                categoryId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                config: {
                                    dev: {
                                        canSyncToLowerEnvironments: faker.datatype.boolean()
                                    },
                                    extensions: Array.from({
                                        length: faker.number.int({
                                            min: 1,
                                            max: 10
                                        })
                                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                                },
                                createdAt: faker.word.sample(),
                                documentKey: faker.word.sample(),
                                entity: faker.word.sample(),
                                updatedAt: faker.word.sample()
                            },
                            documentKey: faker.word.sample(),
                            entity: faker.word.sample(),
                            entityId: faker.word.sample(),
                            etag: faker.word.sample(),
                            extension: faker.word.sample(),
                            groupDetails: {
                                effectiveDate: faker.word.sample(),
                                groupId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                id: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                uploadHistoryId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                })
                            },
                            id: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            initiatedBy: {
                                id: faker.word.sample(),
                                type: faker.word.sample()
                            },
                            isDraft: faker.datatype.boolean(),
                            isEnabled: faker.datatype.boolean(),
                            originalFileName: faker.word.sample(),
                            uploadPath: faker.word.sample()
                        },
                        undefined
                    ]),
                    result: faker.word.sample(),
                    testId: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                undefined
            ]),
            resultProfitSharing: faker.helpers.arrayElement([
                {
                    document: faker.helpers.arrayElement([
                        {
                            contentType: faker.word.sample(),
                            createdAt: faker.word.sample(),
                            definition: {
                                categoryId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                config: {
                                    dev: {
                                        canSyncToLowerEnvironments: faker.datatype.boolean()
                                    },
                                    extensions: Array.from({
                                        length: faker.number.int({
                                            min: 1,
                                            max: 10
                                        })
                                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                                },
                                createdAt: faker.word.sample(),
                                documentKey: faker.word.sample(),
                                entity: faker.word.sample(),
                                updatedAt: faker.word.sample()
                            },
                            documentKey: faker.word.sample(),
                            entity: faker.word.sample(),
                            entityId: faker.word.sample(),
                            etag: faker.word.sample(),
                            extension: faker.word.sample(),
                            groupDetails: {
                                effectiveDate: faker.word.sample(),
                                groupId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                id: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                uploadHistoryId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                })
                            },
                            id: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            initiatedBy: {
                                id: faker.word.sample(),
                                type: faker.word.sample()
                            },
                            isDraft: faker.datatype.boolean(),
                            isEnabled: faker.datatype.boolean(),
                            originalFileName: faker.word.sample(),
                            uploadPath: faker.word.sample()
                        },
                        undefined
                    ]),
                    result: faker.word.sample(),
                    testId: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                undefined
            ]),
            resultSafeHarbor: faker.helpers.arrayElement([
                {
                    document: faker.helpers.arrayElement([
                        {
                            contentType: faker.word.sample(),
                            createdAt: faker.word.sample(),
                            definition: {
                                categoryId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                config: {
                                    dev: {
                                        canSyncToLowerEnvironments: faker.datatype.boolean()
                                    },
                                    extensions: Array.from({
                                        length: faker.number.int({
                                            min: 1,
                                            max: 10
                                        })
                                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                                },
                                createdAt: faker.word.sample(),
                                documentKey: faker.word.sample(),
                                entity: faker.word.sample(),
                                updatedAt: faker.word.sample()
                            },
                            documentKey: faker.word.sample(),
                            entity: faker.word.sample(),
                            entityId: faker.word.sample(),
                            etag: faker.word.sample(),
                            extension: faker.word.sample(),
                            groupDetails: {
                                effectiveDate: faker.word.sample(),
                                groupId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                id: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                uploadHistoryId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                })
                            },
                            id: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            initiatedBy: {
                                id: faker.word.sample(),
                                type: faker.word.sample()
                            },
                            isDraft: faker.datatype.boolean(),
                            isEnabled: faker.datatype.boolean(),
                            originalFileName: faker.word.sample(),
                            uploadPath: faker.word.sample()
                        },
                        undefined
                    ]),
                    result: faker.word.sample(),
                    testId: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                undefined
            ]),
            resultYearEndContribution: faker.helpers.arrayElement([
                {
                    document: faker.helpers.arrayElement([
                        {
                            contentType: faker.word.sample(),
                            createdAt: faker.word.sample(),
                            definition: {
                                categoryId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                config: {
                                    dev: {
                                        canSyncToLowerEnvironments: faker.datatype.boolean()
                                    },
                                    extensions: Array.from({
                                        length: faker.number.int({
                                            min: 1,
                                            max: 10
                                        })
                                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                                },
                                createdAt: faker.word.sample(),
                                documentKey: faker.word.sample(),
                                entity: faker.word.sample(),
                                updatedAt: faker.word.sample()
                            },
                            documentKey: faker.word.sample(),
                            entity: faker.word.sample(),
                            entityId: faker.word.sample(),
                            etag: faker.word.sample(),
                            extension: faker.word.sample(),
                            groupDetails: {
                                effectiveDate: faker.word.sample(),
                                groupId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                id: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                uploadHistoryId: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                })
                            },
                            id: faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            initiatedBy: {
                                id: faker.word.sample(),
                                type: faker.word.sample()
                            },
                            isDraft: faker.datatype.boolean(),
                            isEnabled: faker.datatype.boolean(),
                            originalFileName: faker.word.sample(),
                            uploadPath: faker.word.sample()
                        },
                        undefined
                    ]),
                    result: faker.word.sample(),
                    testId: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                undefined
            ]),
            testId: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        ...overrideResponse
    });
export const getGetPlanTestResultsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanTestResultsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanTestResultsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanTestResultsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanTestResultsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanTestResultsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanTestResultsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanTestResultsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanTestResultsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanTestResultsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanTestResultsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanTestResultsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanTestResultsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanTestResultsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanTestResultsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanTestResultsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanTestResultsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanTestResultsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetSponsorQuestionnaireResponseMock = (overrideResponse = {})=>({
        answers: {
            ASSETS_NOT_AT_LT_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            BLACKOUT_PERIOD_NOTICE_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            BLACKOUT_PERIODS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            BOND_AMOUNT_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            BUSINESS_CODE_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            CONTROLLED_GROUP_PARTICIPATION_DOCUMENTS: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            CONTROLLED_GROUP_PARTICIPATION_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            CONTROLLED_GROUP_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            EMPLOYER_MATCH_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            EMPLOYER_MATCH_QUESTION_AMOUNT_AND_FORMULA: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            FEES_AND_COMMISSIONS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            LATE_BENEFITS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            LEASED_EMPLOYEES_DOCUMENTS: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            LEASED_EMPLOYEES_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            MERGERS_DESCRIPTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            MERGERS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            NONEXEMPT_TRANSACTIONS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            OTHER_BUSINESS_EMPLOYEES_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            OTHER_BUSINESS_OWNERSHIP_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            OTHER_PLAN_DESCRIPTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            OTHER_PLAN_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            PLAN_LOSS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            PROFIT_SHARING_DESCRIPTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            PROFIT_SHARING_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            TAX_EXTENSION_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            TAXED_AS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            }
        },
        questionnaire: faker.word.sample(),
        sponsorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        sponsorPlanId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        year: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetSponsorQuestionnaireResponseMock200 = (overrideResponse = {})=>({
        answers: {
            ASSETS_NOT_AT_LT_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            BLACKOUT_PERIOD_NOTICE_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            BLACKOUT_PERIODS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            BOND_AMOUNT_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            BUSINESS_CODE_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            CONTROLLED_GROUP_PARTICIPATION_DOCUMENTS: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            CONTROLLED_GROUP_PARTICIPATION_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            CONTROLLED_GROUP_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            EMPLOYER_MATCH_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            EMPLOYER_MATCH_QUESTION_AMOUNT_AND_FORMULA: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            FEES_AND_COMMISSIONS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            LATE_BENEFITS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            LEASED_EMPLOYEES_DOCUMENTS: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            LEASED_EMPLOYEES_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            MERGERS_DESCRIPTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            MERGERS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            NONEXEMPT_TRANSACTIONS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            OTHER_BUSINESS_EMPLOYEES_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            OTHER_BUSINESS_OWNERSHIP_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            OTHER_PLAN_DESCRIPTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            OTHER_PLAN_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            PLAN_LOSS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            PROFIT_SHARING_DESCRIPTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            PROFIT_SHARING_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            TAX_EXTENSION_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            TAXED_AS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            }
        },
        questionnaire: faker.word.sample(),
        sponsorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        sponsorPlanId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        year: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetSponsorQuestionnaireResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetSponsorQuestionnaireResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetSponsorQuestionnaireResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetSponsorQuestionnaireResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetSponsorQuestionnaireResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetSponsorQuestionnaireResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetSponsorQuestionnaireResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetSponsorQuestionnaireResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetSponsorQuestionnaireResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetSponsorQuestionnaireResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetSponsorQuestionnaireResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetSponsorQuestionnaireResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetSponsorQuestionnaireResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetSponsorQuestionnaireResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetSponsorQuestionnaireResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetSponsorQuestionnaireResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetSponsorQuestionnaireResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetSponsorQuestionnaireResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetSponsorQuestionnaireResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetSponsorQuestionnaireResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetSponsorQuestionnaireResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetSponsorQuestionnaireResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetSponsorQuestionnaireResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetSponsorQuestionnaireResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetSponsorQuestionnaireResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetSponsorQuestionnaireResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetSponsorQuestionnaireResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetSponsorQuestionnaireResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetSponsorQuestionnaireResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetSponsorQuestionnaireResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetSponsorQuestionnaireResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetSponsorQuestionnaireResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetSponsorQuestionnaireResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetSponsorQuestionnaireResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetSponsorQuestionnaireResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostYetSponsorQuestionnaireResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartTestingProcessResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartTestingProcessResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartTestingProcessResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartTestingProcessResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartTestingProcessResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartTestingProcessResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartTestingProcessResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartTestingProcessResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartTestingProcessResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartTestingProcessResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartTestingProcessResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartTestingProcessResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartTestingProcessResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartTestingProcessResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartTestingProcessResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartTestingProcessResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartTestingProcessResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRestartTestingProcessResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetTIAAIncomeProjectionResponseMock = (overrideResponse = {})=>({
        balanceAtRetirement: faker.number.int({
            min: undefined,
            max: undefined
        }),
        disclosure: faker.word.sample(),
        estimatedAnnualIncome: faker.number.int({
            min: undefined,
            max: undefined
        }),
        maxLoyaltyBonusPercentage: faker.number.int({
            min: undefined,
            max: undefined
        }),
        minLoyaltyBonusPercentage: faker.number.int({
            min: undefined,
            max: undefined
        }),
        retirementAge: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetTIAAIncomeProjectionResponseMock200 = (overrideResponse = {})=>({
        balanceAtRetirement: faker.number.int({
            min: undefined,
            max: undefined
        }),
        disclosure: faker.word.sample(),
        estimatedAnnualIncome: faker.number.int({
            min: undefined,
            max: undefined
        }),
        maxLoyaltyBonusPercentage: faker.number.int({
            min: undefined,
            max: undefined
        }),
        minLoyaltyBonusPercentage: faker.number.int({
            min: undefined,
            max: undefined
        }),
        retirementAge: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetTIAAIncomeProjectionResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetTIAAIncomeProjectionResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetTIAAIncomeProjectionResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetTIAAIncomeProjectionResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetTIAAIncomeProjectionResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetTIAAIncomeProjectionResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetTIAAIncomeProjectionResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetTIAAIncomeProjectionResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetTIAAIncomeProjectionResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetTIAAIncomeProjectionResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetTIAAIncomeProjectionResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetTIAAIncomeProjectionResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetTIAAIncomeProjectionResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetTIAAIncomeProjectionResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetTIAAIncomeProjectionResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetTIAAIncomeProjectionResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetTIAAIncomeProjectionResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetTIAAIncomeProjectionResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchParticipantByIdResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchParticipantByIdResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchParticipantByIdResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchParticipantByIdResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchParticipantByIdResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchParticipantByIdResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchParticipantByIdResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchParticipantByIdResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchParticipantByIdResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchParticipantByIdResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchParticipantByIdResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchParticipantByIdResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchParticipantByIdResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchParticipantByIdResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchParticipantByIdResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchParticipantByIdResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchParticipantByIdResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchParticipantByIdResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBeneficiariesResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            address1: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            address2: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            allocationPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            beneficiaryId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            beneficiaryType: faker.helpers.arrayElement([
                'person',
                'trust',
                'organization'
            ]),
            businessName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            city: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ein: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            email: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            firstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            holdingFinancialInstitution: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isPrimary: faker.datatype.boolean(),
            lastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            phoneNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            relationship: faker.helpers.arrayElement([
                faker.helpers.arrayElement([
                    'spouse',
                    'child',
                    'parent',
                    'other'
                ]),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            state: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            trustId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            trustName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            zip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getGetParticipantBeneficiariesResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            address1: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            address2: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            allocationPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            beneficiaryId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            beneficiaryType: faker.helpers.arrayElement([
                'person',
                'trust',
                'organization'
            ]),
            businessName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            city: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ein: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            email: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            firstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            holdingFinancialInstitution: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isPrimary: faker.datatype.boolean(),
            lastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            phoneNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            relationship: faker.helpers.arrayElement([
                faker.helpers.arrayElement([
                    'spouse',
                    'child',
                    'parent',
                    'other'
                ]),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            state: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            trustId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            trustName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            zip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getGetParticipantBeneficiariesResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBeneficiariesResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBeneficiariesResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBeneficiariesResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBeneficiariesResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBeneficiariesResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBeneficiariesResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBeneficiariesResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBeneficiariesResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBeneficiariesResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBeneficiariesResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBeneficiariesResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBeneficiariesResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBeneficiariesResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBeneficiariesResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBeneficiariesResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBeneficiariesResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantBeneficiariesResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutParticipantBeneficiariesV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutParticipantBeneficiariesV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutParticipantBeneficiariesV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutParticipantBeneficiariesV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutParticipantBeneficiariesV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutParticipantBeneficiariesV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutParticipantBeneficiariesV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutParticipantBeneficiariesV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutParticipantBeneficiariesV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutParticipantBeneficiariesV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutParticipantBeneficiariesV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutParticipantBeneficiariesV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutParticipantBeneficiariesV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutParticipantBeneficiariesV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutParticipantBeneficiariesV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutParticipantBeneficiariesV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutParticipantBeneficiariesV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPutParticipantBeneficiariesV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanByIdV2ResponseMock = (overrideResponse = {})=>({
        advisorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        custodianAccountNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        effectiveDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        eligibleParticipants: faker.number.int({
            min: undefined,
            max: undefined
        }),
        employeeBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        employerBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        firmId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        forfeitureBalance: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        hasPriorLoans: faker.datatype.boolean(),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        inboundBlackoutEndDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        inboundBlackoutStartDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isActive: faker.datatype.boolean(),
        isBlackout: faker.datatype.boolean(),
        isOffboardingBlackoutActive: faker.datatype.boolean(),
        loanBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        name: faker.word.sample(),
        notes: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        offboardingBlackoutEndDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        offboardingBlackoutStartDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        participantsWithBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participantsWithDeferrals: faker.number.int({
            min: undefined,
            max: undefined
        }),
        programId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        readyToEnrollParticipants: faker.number.int({
            min: undefined,
            max: undefined
        }),
        recordkeeper: faker.word.sample(),
        recordkeeperId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        registeredParticipants: faker.number.int({
            min: undefined,
            max: undefined
        }),
        rolloverBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        sponsorCompanyName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        sponsorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        statefulSchemaTrackingState: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        status: faker.word.sample(),
        totalBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        tpaIds: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>faker.number.int({
                    min: undefined,
                    max: undefined
                })),
            undefined
        ]),
        type: faker.word.sample(),
        ...overrideResponse
    });
export const getGetPlanByIdV2ResponseMock200 = (overrideResponse = {})=>({
        advisorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        custodianAccountNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        effectiveDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        eligibleParticipants: faker.number.int({
            min: undefined,
            max: undefined
        }),
        employeeBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        employerBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        firmId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        forfeitureBalance: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        hasPriorLoans: faker.datatype.boolean(),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        inboundBlackoutEndDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        inboundBlackoutStartDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isActive: faker.datatype.boolean(),
        isBlackout: faker.datatype.boolean(),
        isOffboardingBlackoutActive: faker.datatype.boolean(),
        loanBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        name: faker.word.sample(),
        notes: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        offboardingBlackoutEndDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        offboardingBlackoutStartDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        participantsWithBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participantsWithDeferrals: faker.number.int({
            min: undefined,
            max: undefined
        }),
        programId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        readyToEnrollParticipants: faker.number.int({
            min: undefined,
            max: undefined
        }),
        recordkeeper: faker.word.sample(),
        recordkeeperId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        registeredParticipants: faker.number.int({
            min: undefined,
            max: undefined
        }),
        rolloverBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        sponsorCompanyName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        sponsorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        statefulSchemaTrackingState: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        status: faker.word.sample(),
        totalBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        tpaIds: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>faker.number.int({
                    min: undefined,
                    max: undefined
                })),
            undefined
        ]),
        type: faker.word.sample(),
        ...overrideResponse
    });
export const getGetPlanByIdV2ResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanByIdV2ResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanByIdV2ResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanByIdV2ResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanByIdV2ResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanByIdV2ResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanByIdV2ResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanByIdV2ResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanByIdV2ResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanByIdV2ResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanByIdV2ResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanByIdV2ResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanByIdV2ResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanByIdV2ResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanByIdV2ResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanByIdV2ResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanByIdV2ResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanByIdV2ResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVestingScheduleResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            name: faker.word.sample(),
            vestingScheduleId: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetVestingScheduleResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            name: faker.word.sample(),
            vestingScheduleId: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetVestingScheduleResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVestingScheduleResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVestingScheduleResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVestingScheduleResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVestingScheduleResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVestingScheduleResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVestingScheduleResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVestingScheduleResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVestingScheduleResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVestingScheduleResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVestingScheduleResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVestingScheduleResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVestingScheduleResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVestingScheduleResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVestingScheduleResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVestingScheduleResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVestingScheduleResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVestingScheduleResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssPlanByIdResponseMock = (overrideResponse = {})=>({
        data: {
            gift: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            icon: faker.word.sample(),
            id: faker.word.sample(),
            legalName: faker.word.sample(),
            linkText: faker.word.sample(),
            logo: faker.word.sample(),
            name: faker.word.sample(),
            shortName: faker.word.sample(),
            siteUrl: faker.word.sample(),
            supportHoursPhone: faker.word.sample(),
            supportHoursTty: faker.word.sample(),
            supportPhone: faker.word.sample(),
            supportTty: faker.word.sample(),
            transactionLimits: {},
            type: faker.helpers.arrayElement([
                'able',
                'collegeSavings',
                'secureChoice'
            ]),
            urls: {}
        },
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getGetVssPlanByIdResponseMock200 = (overrideResponse = {})=>({
        data: {
            gift: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            icon: faker.word.sample(),
            id: faker.word.sample(),
            legalName: faker.word.sample(),
            linkText: faker.word.sample(),
            logo: faker.word.sample(),
            name: faker.word.sample(),
            shortName: faker.word.sample(),
            siteUrl: faker.word.sample(),
            supportHoursPhone: faker.word.sample(),
            supportHoursTty: faker.word.sample(),
            supportPhone: faker.word.sample(),
            supportTty: faker.word.sample(),
            transactionLimits: {},
            type: faker.helpers.arrayElement([
                'able',
                'collegeSavings',
                'secureChoice'
            ]),
            urls: {}
        },
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getGetVssPlanByIdResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssPlanByIdResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssPlanByIdResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssPlanByIdResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssPlanByIdResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssPlanByIdResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssPlanByIdResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssPlanByIdResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssPlanByIdResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssPlanByIdResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssPlanByIdResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssPlanByIdResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssPlanByIdResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssPlanByIdResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssPlanByIdResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssPlanByIdResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssPlanByIdResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssPlanByIdResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssStatusResponseMock = (overrideResponse = {})=>({
        data: {
            status: faker.helpers.arrayElement([
                'unknown',
                'none',
                'readOnly',
                'normal'
            ])
        },
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getGetVssStatusResponseMock200 = (overrideResponse = {})=>({
        data: {
            status: faker.helpers.arrayElement([
                'unknown',
                'none',
                'readOnly',
                'normal'
            ])
        },
        metadata: {
            status: {
                status: faker.helpers.arrayElement([
                    'unknown',
                    'none',
                    'readOnly',
                    'normal'
                ])
            }
        },
        ...overrideResponse
    });
export const getGetVssStatusResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssStatusResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssStatusResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssStatusResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssStatusResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssStatusResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssStatusResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssStatusResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssStatusResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssStatusResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssStatusResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssStatusResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssStatusResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssStatusResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssStatusResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssStatusResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssStatusResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetVssStatusResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLobLetterEventsWebhookResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLobLetterEventsWebhookResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLobLetterEventsWebhookResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLobLetterEventsWebhookResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLobLetterEventsWebhookResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLobLetterEventsWebhookResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLobLetterEventsWebhookResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLobLetterEventsWebhookResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLobLetterEventsWebhookResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLobLetterEventsWebhookResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLobLetterEventsWebhookResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLobLetterEventsWebhookResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLobLetterEventsWebhookResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLobLetterEventsWebhookResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLobLetterEventsWebhookResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLobLetterEventsWebhookResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLobLetterEventsWebhookResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostLobLetterEventsWebhookResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelResponseMock = (overrideResponse = {})=>({
        legal: {
            copyright: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            disclosures: faker.helpers.arrayElement([
                {
                    advisor: Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                    participant: Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                    sponsor: Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                },
                undefined
            ]),
            links: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    text: faker.word.sample(),
                    url: faker.word.sample()
                }))
        },
        links: {
            censusTemplate: faker.word.sample(),
            controlGroupHelpLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            csvInstructions: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            editEmployeeInfoAfterOnboardingLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            forfeitureAccountsHelpPlanExpenses: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            gustoLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            notExpectingZero: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            onPayLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            payrollErrors: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            qboLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        login: {
            accountSetup: faker.helpers.arrayElement([
                {
                    infoBanner: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                description: faker.word.sample()
                            })),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        {
                            description: faker.word.sample(),
                            link: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            text: faker.word.sample()
                        },
                        undefined
                    ]),
                    page: faker.helpers.arrayElement([
                        {
                            selections: faker.helpers.arrayElement([
                                Array.from({
                                    length: faker.number.int({
                                        min: 1,
                                        max: 10
                                    })
                                }, (_, i)=>i + 1).map(()=>({
                                        description: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        link: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        title: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ])
                                    })),
                                undefined
                            ]),
                            title: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ])
                },
                undefined
            ]),
            banner: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contacts: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    description: faker.word.sample(),
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            logo: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            resources: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    description: faker.word.sample(),
                    url: faker.word.sample()
                }))
        },
        metadata: {
            favicon: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            title: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        mfa: {
            advisor: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ]),
            participant: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ]),
            sponsor: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ])
        },
        navbar: {
            logo: {
                desktop: faker.word.sample(),
                mobile: faker.word.sample()
            }
        },
        registration: {
            documents: faker.helpers.arrayElement([
                {
                    esaSaverAgreement: faker.helpers.arrayElement([
                        {
                            documentKey: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entity: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    terms: faker.helpers.arrayElement([
                        {
                            documentKey: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entity: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ])
                },
                undefined
            ]),
            exemptionReasons: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    key: faker.word.sample(),
                    value: faker.word.sample()
                })),
            hasEIN: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasSDAT: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isState: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            link: faker.word.sample(),
            logo: faker.helpers.arrayElement([
                {
                    desktop: faker.word.sample(),
                    mobile: faker.word.sample()
                },
                undefined
            ]),
            name: faker.word.sample(),
            website: faker.word.sample()
        },
        sponsorOnboarding: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    items: Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            details: faker.helpers.arrayElement([
                                faker.word.sample(),
                                null
                            ]),
                            item: faker.word.sample()
                        })),
                    title: faker.word.sample()
                })),
            undefined
        ]),
        subdomain: faker.word.sample(),
        support: {
            advisor: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            participant: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            sponsor: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ])
        },
        theme: {
            palette: {
                primary: {
                    contrastText: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    dark: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    main: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                secondary: faker.helpers.arrayElement([
                    {
                        contrastText: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        dark: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        main: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ])
            }
        },
        whitelabelId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelResponseMock200 = (overrideResponse = {})=>({
        legal: {
            copyright: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            disclosures: faker.helpers.arrayElement([
                {
                    advisor: Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                    participant: Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                    sponsor: Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                },
                undefined
            ]),
            links: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    text: faker.word.sample(),
                    url: faker.word.sample()
                }))
        },
        links: {
            censusTemplate: faker.word.sample(),
            controlGroupHelpLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            csvInstructions: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            editEmployeeInfoAfterOnboardingLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            forfeitureAccountsHelpPlanExpenses: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            gustoLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            notExpectingZero: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            onPayLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            payrollErrors: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            qboLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        login: {
            accountSetup: faker.helpers.arrayElement([
                {
                    infoBanner: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                description: faker.word.sample()
                            })),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        {
                            description: faker.word.sample(),
                            link: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            text: faker.word.sample()
                        },
                        undefined
                    ]),
                    page: faker.helpers.arrayElement([
                        {
                            selections: faker.helpers.arrayElement([
                                Array.from({
                                    length: faker.number.int({
                                        min: 1,
                                        max: 10
                                    })
                                }, (_, i)=>i + 1).map(()=>({
                                        description: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        link: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        title: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ])
                                    })),
                                undefined
                            ]),
                            title: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ])
                },
                undefined
            ]),
            banner: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contacts: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    description: faker.word.sample(),
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            logo: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            resources: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    description: faker.word.sample(),
                    url: faker.word.sample()
                }))
        },
        metadata: {
            favicon: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            title: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        mfa: {
            advisor: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ]),
            participant: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ]),
            sponsor: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ])
        },
        navbar: {
            logo: {
                desktop: faker.word.sample(),
                mobile: faker.word.sample()
            }
        },
        registration: {
            documents: faker.helpers.arrayElement([
                {
                    esaSaverAgreement: faker.helpers.arrayElement([
                        {
                            documentKey: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entity: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    terms: faker.helpers.arrayElement([
                        {
                            documentKey: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entity: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ])
                },
                undefined
            ]),
            exemptionReasons: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    key: faker.word.sample(),
                    value: faker.word.sample()
                })),
            hasEIN: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasSDAT: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isState: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            link: faker.word.sample(),
            logo: faker.helpers.arrayElement([
                {
                    desktop: faker.word.sample(),
                    mobile: faker.word.sample()
                },
                undefined
            ]),
            name: faker.word.sample(),
            website: faker.word.sample()
        },
        sponsorOnboarding: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    items: Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            details: faker.helpers.arrayElement([
                                faker.word.sample(),
                                null
                            ]),
                            item: faker.word.sample()
                        })),
                    title: faker.word.sample()
                })),
            undefined
        ]),
        subdomain: faker.word.sample(),
        support: {
            advisor: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            participant: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            sponsor: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ])
        },
        theme: {
            palette: {
                primary: {
                    contrastText: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    dark: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    main: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                secondary: faker.helpers.arrayElement([
                    {
                        contrastText: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        dark: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        main: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ])
            }
        },
        whitelabelId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelUnauthorizedResponseMock = (overrideResponse = {})=>({
        legal: {
            copyright: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            disclosures: faker.helpers.arrayElement([
                {
                    advisor: Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                    participant: Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                    sponsor: Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                },
                undefined
            ]),
            links: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    text: faker.word.sample(),
                    url: faker.word.sample()
                }))
        },
        links: {
            censusTemplate: faker.word.sample(),
            controlGroupHelpLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            csvInstructions: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            editEmployeeInfoAfterOnboardingLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            forfeitureAccountsHelpPlanExpenses: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            gustoLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            notExpectingZero: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            onPayLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            payrollErrors: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            qboLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        login: {
            accountSetup: faker.helpers.arrayElement([
                {
                    infoBanner: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                description: faker.word.sample()
                            })),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        {
                            description: faker.word.sample(),
                            link: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            text: faker.word.sample()
                        },
                        undefined
                    ]),
                    page: faker.helpers.arrayElement([
                        {
                            selections: faker.helpers.arrayElement([
                                Array.from({
                                    length: faker.number.int({
                                        min: 1,
                                        max: 10
                                    })
                                }, (_, i)=>i + 1).map(()=>({
                                        description: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        link: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        title: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ])
                                    })),
                                undefined
                            ]),
                            title: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ])
                },
                undefined
            ]),
            banner: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contacts: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    description: faker.word.sample(),
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            logo: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            resources: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    description: faker.word.sample(),
                    url: faker.word.sample()
                }))
        },
        metadata: {
            favicon: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            title: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        mfa: {
            advisor: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ]),
            participant: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ]),
            sponsor: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ])
        },
        navbar: {
            logo: {
                desktop: faker.word.sample(),
                mobile: faker.word.sample()
            }
        },
        registration: {
            documents: faker.helpers.arrayElement([
                {
                    esaSaverAgreement: faker.helpers.arrayElement([
                        {
                            documentKey: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entity: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    terms: faker.helpers.arrayElement([
                        {
                            documentKey: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entity: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ])
                },
                undefined
            ]),
            exemptionReasons: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    key: faker.word.sample(),
                    value: faker.word.sample()
                })),
            hasEIN: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasSDAT: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isState: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            link: faker.word.sample(),
            logo: faker.helpers.arrayElement([
                {
                    desktop: faker.word.sample(),
                    mobile: faker.word.sample()
                },
                undefined
            ]),
            name: faker.word.sample(),
            website: faker.word.sample()
        },
        sponsorOnboarding: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    items: Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            details: faker.helpers.arrayElement([
                                faker.word.sample(),
                                null
                            ]),
                            item: faker.word.sample()
                        })),
                    title: faker.word.sample()
                })),
            undefined
        ]),
        subdomain: faker.word.sample(),
        support: {
            advisor: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            participant: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            sponsor: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ])
        },
        theme: {
            palette: {
                primary: {
                    contrastText: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    dark: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    main: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                secondary: faker.helpers.arrayElement([
                    {
                        contrastText: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        dark: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        main: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ])
            }
        },
        whitelabelId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelUnauthorizedResponseMock200 = (overrideResponse = {})=>({
        legal: {
            copyright: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            disclosures: faker.helpers.arrayElement([
                {
                    advisor: Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                    participant: Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                    sponsor: Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                },
                undefined
            ]),
            links: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    text: faker.word.sample(),
                    url: faker.word.sample()
                }))
        },
        links: {
            censusTemplate: faker.word.sample(),
            controlGroupHelpLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            csvInstructions: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            editEmployeeInfoAfterOnboardingLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            forfeitureAccountsHelpPlanExpenses: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            gustoLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            notExpectingZero: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            onPayLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            payrollErrors: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            qboLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        login: {
            accountSetup: faker.helpers.arrayElement([
                {
                    infoBanner: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                description: faker.word.sample()
                            })),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        {
                            description: faker.word.sample(),
                            link: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            text: faker.word.sample()
                        },
                        undefined
                    ]),
                    page: faker.helpers.arrayElement([
                        {
                            selections: faker.helpers.arrayElement([
                                Array.from({
                                    length: faker.number.int({
                                        min: 1,
                                        max: 10
                                    })
                                }, (_, i)=>i + 1).map(()=>({
                                        description: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        link: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        title: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ])
                                    })),
                                undefined
                            ]),
                            title: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ])
                },
                undefined
            ]),
            banner: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contacts: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    description: faker.word.sample(),
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            logo: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            resources: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    description: faker.word.sample(),
                    url: faker.word.sample()
                }))
        },
        metadata: {
            favicon: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            title: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        mfa: {
            advisor: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ]),
            participant: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ]),
            sponsor: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ])
        },
        navbar: {
            logo: {
                desktop: faker.word.sample(),
                mobile: faker.word.sample()
            }
        },
        registration: {
            documents: faker.helpers.arrayElement([
                {
                    esaSaverAgreement: faker.helpers.arrayElement([
                        {
                            documentKey: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entity: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    terms: faker.helpers.arrayElement([
                        {
                            documentKey: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entity: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ])
                },
                undefined
            ]),
            exemptionReasons: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    key: faker.word.sample(),
                    value: faker.word.sample()
                })),
            hasEIN: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasSDAT: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isState: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            link: faker.word.sample(),
            logo: faker.helpers.arrayElement([
                {
                    desktop: faker.word.sample(),
                    mobile: faker.word.sample()
                },
                undefined
            ]),
            name: faker.word.sample(),
            website: faker.word.sample()
        },
        sponsorOnboarding: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    items: Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            details: faker.helpers.arrayElement([
                                faker.word.sample(),
                                null
                            ]),
                            item: faker.word.sample()
                        })),
                    title: faker.word.sample()
                })),
            undefined
        ]),
        subdomain: faker.word.sample(),
        support: {
            advisor: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            participant: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            sponsor: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ])
        },
        theme: {
            palette: {
                primary: {
                    contrastText: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    dark: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    main: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                secondary: faker.helpers.arrayElement([
                    {
                        contrastText: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        dark: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        main: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ])
            }
        },
        whitelabelId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelUnauthorizedResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelUnauthorizedResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelUnauthorizedResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelUnauthorizedResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelUnauthorizedResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelUnauthorizedResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelUnauthorizedResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelUnauthorizedResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelUnauthorizedResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelUnauthorizedResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelUnauthorizedResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelUnauthorizedResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelUnauthorizedResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelUnauthorizedResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelUnauthorizedResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelUnauthorizedResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelUnauthorizedResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWhiteLabelUnauthorizedResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateWithdrawalResponseMock = ()=>faker.number.int();
export const getPostCreateWithdrawalResponseMock200 = ()=>faker.number.int();
export const getPostCreateWithdrawalResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateWithdrawalResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateWithdrawalResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateWithdrawalResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateWithdrawalResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateWithdrawalResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateWithdrawalResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateWithdrawalResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateWithdrawalResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateWithdrawalResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateWithdrawalResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateWithdrawalResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateWithdrawalResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateWithdrawalResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateWithdrawalResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateWithdrawalResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateWithdrawalResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateWithdrawalResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostWithdrawalIdentityVerificationResponseMock = (overrideResponse = {})=>({
        beacon: faker.helpers.arrayElement([
            {
                clientId: faker.word.sample(),
                createdAt: faker.word.sample(),
                id: faker.word.sample(),
                requestId: faker.word.sample(),
                status: faker.word.sample(),
                updatedAt: faker.word.sample()
            },
            undefined
        ]),
        cipStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        idVerResponse: faker.helpers.arrayElement([
            {
                clientId: faker.word.sample(),
                completedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                createdAt: faker.word.sample(),
                id: faker.word.sample(),
                requestId: faker.word.sample(),
                status: faker.word.sample(),
                steps: {
                    acceptTos: faker.word.sample(),
                    documentaryVerification: faker.word.sample(),
                    kycCheck: faker.word.sample(),
                    riskCheck: faker.word.sample(),
                    selfieCheck: faker.word.sample(),
                    verifySms: faker.word.sample(),
                    watchlistScreening: faker.word.sample()
                },
                token: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                verificationUrl: faker.word.sample()
            },
            undefined
        ]),
        requiredDocUploads: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>faker.word.sample()),
            undefined
        ]),
        ...overrideResponse
    });
export const getPostWithdrawalIdentityVerificationResponseMock200 = (overrideResponse = {})=>({
        beacon: faker.helpers.arrayElement([
            {
                clientId: faker.word.sample(),
                createdAt: faker.word.sample(),
                id: faker.word.sample(),
                requestId: faker.word.sample(),
                status: faker.word.sample(),
                updatedAt: faker.word.sample()
            },
            undefined
        ]),
        cipStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        idVerResponse: faker.helpers.arrayElement([
            {
                clientId: faker.word.sample(),
                completedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                createdAt: faker.word.sample(),
                id: faker.word.sample(),
                requestId: faker.word.sample(),
                status: faker.word.sample(),
                steps: {
                    acceptTos: faker.word.sample(),
                    documentaryVerification: faker.word.sample(),
                    kycCheck: faker.word.sample(),
                    riskCheck: faker.word.sample(),
                    selfieCheck: faker.word.sample(),
                    verifySms: faker.word.sample(),
                    watchlistScreening: faker.word.sample()
                },
                token: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                verificationUrl: faker.word.sample()
            },
            undefined
        ]),
        requiredDocUploads: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>faker.word.sample()),
            undefined
        ]),
        ...overrideResponse
    });
export const getPostWithdrawalIdentityVerificationResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostWithdrawalIdentityVerificationResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostWithdrawalIdentityVerificationResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostWithdrawalIdentityVerificationResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostWithdrawalIdentityVerificationResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostWithdrawalIdentityVerificationResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostWithdrawalIdentityVerificationResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostWithdrawalIdentityVerificationResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostWithdrawalIdentityVerificationResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostWithdrawalIdentityVerificationResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostWithdrawalIdentityVerificationResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostWithdrawalIdentityVerificationResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostWithdrawalIdentityVerificationResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostWithdrawalIdentityVerificationResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostWithdrawalIdentityVerificationResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostWithdrawalIdentityVerificationResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostWithdrawalIdentityVerificationResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostWithdrawalIdentityVerificationResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdAmountResponseMock = (overrideResponse = {})=>({
        age1: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        age2: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        lifeExpectancy: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        requiredAmount: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        type: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        vestedBalance: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        withdrawalAmount: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        year: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetRmdAmountResponseMock200 = (overrideResponse = {})=>({
        age1: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        age2: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        lifeExpectancy: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        requiredAmount: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        type: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        vestedBalance: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        withdrawalAmount: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        year: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetRmdAmountResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdAmountResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdAmountResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdAmountResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdAmountResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdAmountResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdAmountResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdAmountResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdAmountResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdAmountResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdAmountResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdAmountResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdAmountResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdAmountResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdAmountResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdAmountResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdAmountResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdAmountResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdBalanceResponseMock = (overrideResponse = {})=>({
        balance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        year: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdBalanceResponseMock200 = (overrideResponse = {})=>({
        balance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        year: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdBalanceResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdBalanceResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdBalanceResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdBalanceResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdBalanceResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdBalanceResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdBalanceResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdBalanceResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdBalanceResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdBalanceResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdBalanceResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdBalanceResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdBalanceResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdBalanceResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdBalanceResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdBalanceResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdBalanceResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRmdBalanceResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRolloverProvidersResponseMock = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    address: faker.helpers.arrayElement([
                        {
                            address1: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            address2: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            city: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            state: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            zip: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    id: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    mailType: faker.helpers.arrayElement([
                        faker.helpers.arrayElement([
                            'Express Mail',
                            'Normal Mail'
                        ]),
                        undefined
                    ]),
                    providerAlias: faker.word.sample(),
                    providerName: faker.word.sample(),
                    providerShort: faker.word.sample()
                })),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetRolloverProvidersResponseMock200 = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    address: faker.helpers.arrayElement([
                        {
                            address1: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            address2: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            city: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            state: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            zip: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    id: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    mailType: faker.helpers.arrayElement([
                        faker.helpers.arrayElement([
                            'Express Mail',
                            'Normal Mail'
                        ]),
                        undefined
                    ]),
                    providerAlias: faker.word.sample(),
                    providerName: faker.word.sample(),
                    providerShort: faker.word.sample()
                })),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetRolloverProvidersResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRolloverProvidersResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRolloverProvidersResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRolloverProvidersResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRolloverProvidersResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRolloverProvidersResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRolloverProvidersResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRolloverProvidersResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRolloverProvidersResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRolloverProvidersResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRolloverProvidersResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRolloverProvidersResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRolloverProvidersResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRolloverProvidersResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRolloverProvidersResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRolloverProvidersResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRolloverProvidersResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRolloverProvidersResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingResponseMock = (overrideResponse = {})=>({
        data: {
            code1099: faker.word.sample(),
            federalWithholdingPercent: faker.word.sample(),
            qualifiedRoth: faker.word.sample(),
            rothInitialYear: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            stateWithholdingCode: faker.word.sample(),
            stateWithholdingPercent: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            taxType: faker.word.sample()
        },
        ...overrideResponse
    });
export const getGetWithholdingResponseMock200 = (overrideResponse = {})=>({
        data: {
            code1099: faker.word.sample(),
            federalWithholdingPercent: faker.word.sample(),
            qualifiedRoth: faker.word.sample(),
            rothInitialYear: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            stateWithholdingCode: faker.word.sample(),
            stateWithholdingPercent: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            taxType: faker.word.sample()
        },
        ...overrideResponse
    });
export const getGetWithholdingResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingDetailResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                code1099: faker.word.sample(),
                federalWithholdingAmount: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                federalWithholdingPercent: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                isQualifiedRoth: faker.datatype.boolean(),
                isRollover: faker.datatype.boolean(),
                rothInitialYear: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                stateWithholdingAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                stateWithholdingCode: faker.word.sample(),
                stateWithholdingPercent: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                taxType: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getGetWithholdingDetailResponseMock200 = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                code1099: faker.word.sample(),
                federalWithholdingAmount: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                federalWithholdingPercent: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                isQualifiedRoth: faker.datatype.boolean(),
                isRollover: faker.datatype.boolean(),
                rothInitialYear: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                stateWithholdingAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                stateWithholdingCode: faker.word.sample(),
                stateWithholdingPercent: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                taxType: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getGetWithholdingDetailResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingDetailResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingDetailResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingDetailResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingDetailResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingDetailResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingDetailResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingDetailResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingDetailResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingDetailResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingDetailResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingDetailResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingDetailResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingDetailResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingDetailResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingDetailResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingDetailResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingDetailResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetNaicsResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            code: faker.word.sample(),
            description: faker.word.sample(),
            naicsCodeId: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetYetNaicsResponseMock200 = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            code: faker.word.sample(),
            description: faker.word.sample(),
            naicsCodeId: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetYetNaicsResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetNaicsResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetNaicsResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetNaicsResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetNaicsResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetNaicsResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetNaicsResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetNaicsResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetNaicsResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetNaicsResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetNaicsResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetNaicsResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetNaicsResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetNaicsResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetNaicsResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetNaicsResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetNaicsResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetNaicsResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetZendeskJwtResponseMock = (overrideResponse = {})=>({
        conversationFields: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                id: faker.word.sample(),
                value: {}
            })),
        jwt: faker.word.sample(),
        key: faker.word.sample(),
        ...overrideResponse
    });
export const getGetZendeskJwtResponseMock200 = (overrideResponse = {})=>({
        conversationFields: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                id: faker.word.sample(),
                value: {}
            })),
        jwt: faker.word.sample(),
        key: faker.word.sample(),
        ...overrideResponse
    });
export const getGetZendeskJwtResponseMock400 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetZendeskJwtResponseMock401 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetZendeskJwtResponseMock403 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetZendeskJwtResponseMock404 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetZendeskJwtResponseMock405 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetZendeskJwtResponseMock406 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetZendeskJwtResponseMock408 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetZendeskJwtResponseMock409 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetZendeskJwtResponseMock410 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetZendeskJwtResponseMock412 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetZendeskJwtResponseMock413 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetZendeskJwtResponseMock415 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetZendeskJwtResponseMock422 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetZendeskJwtResponseMock500 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetZendeskJwtResponseMock501 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetZendeskJwtResponseMock502 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetZendeskJwtResponseMock503 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetZendeskJwtResponseMock504 = (overrideResponse = {})=>({
        code: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        message: faker.word.sample(),
        meta: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        status: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetAdvisorByIdMockHandler = (overrideResponse)=>{
    return http.get('*/api/advisor', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorByIdResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorByIdMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/advisor', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorByIdResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorByIdMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/advisor', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorByIdResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorByIdMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/advisor', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorByIdResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorByIdMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/advisor', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorByIdResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorByIdMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/advisor', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorByIdResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorByIdMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/advisor', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorByIdResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorByIdMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/advisor', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorByIdResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorByIdMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/advisor', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorByIdResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorByIdMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/advisor', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorByIdResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorByIdMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/advisor', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorByIdResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorByIdMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/advisor', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorByIdResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorByIdMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/advisor', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorByIdResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorByIdMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/advisor', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorByIdResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorByIdMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/advisor', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorByIdResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorByIdMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/advisor', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorByIdResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorByIdMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/advisor', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorByIdResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorByIdMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/advisor', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorByIdResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorByIdMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/advisor', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorByIdResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorByIdMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/advisor', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorByIdResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorCommercialPlatformsMockHandler = (overrideResponse)=>{
    return http.get('*/api/advisor/commercial-platforms', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorCommercialPlatformsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorCommercialPlatformsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/advisor/commercial-platforms', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorCommercialPlatformsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorCommercialPlatformsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/advisor/commercial-platforms', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorCommercialPlatformsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorCommercialPlatformsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/advisor/commercial-platforms', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorCommercialPlatformsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorCommercialPlatformsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/advisor/commercial-platforms', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorCommercialPlatformsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorCommercialPlatformsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/advisor/commercial-platforms', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorCommercialPlatformsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorCommercialPlatformsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/advisor/commercial-platforms', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorCommercialPlatformsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorCommercialPlatformsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/advisor/commercial-platforms', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorCommercialPlatformsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorCommercialPlatformsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/advisor/commercial-platforms', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorCommercialPlatformsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorCommercialPlatformsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/advisor/commercial-platforms', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorCommercialPlatformsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorCommercialPlatformsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/advisor/commercial-platforms', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorCommercialPlatformsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorCommercialPlatformsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/advisor/commercial-platforms', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorCommercialPlatformsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorCommercialPlatformsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/advisor/commercial-platforms', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorCommercialPlatformsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorCommercialPlatformsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/advisor/commercial-platforms', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorCommercialPlatformsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorCommercialPlatformsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/advisor/commercial-platforms', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorCommercialPlatformsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorCommercialPlatformsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/advisor/commercial-platforms', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorCommercialPlatformsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorCommercialPlatformsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/advisor/commercial-platforms', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorCommercialPlatformsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorCommercialPlatformsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/advisor/commercial-platforms', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorCommercialPlatformsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorCommercialPlatformsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/advisor/commercial-platforms', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorCommercialPlatformsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorCommercialPlatformsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/advisor/commercial-platforms', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorCommercialPlatformsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorContactCardMockHandler = (overrideResponse)=>{
    return http.get('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorContactCardResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorContactCardMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorContactCardResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorContactCardMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorContactCardResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorContactCardMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorContactCardResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorContactCardMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorContactCardResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorContactCardMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorContactCardResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorContactCardMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorContactCardResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorContactCardMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorContactCardResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorContactCardMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorContactCardResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorContactCardMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorContactCardResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorContactCardMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorContactCardResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorContactCardMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorContactCardResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorContactCardMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorContactCardResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorContactCardMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorContactCardResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorContactCardMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorContactCardResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorContactCardMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorContactCardResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorContactCardMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorContactCardResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorContactCardMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorContactCardResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorContactCardMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorContactCardResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorContactCardMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorContactCardResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAdvisorContactCardMockHandler = (overrideResponse)=>{
    return http.put('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAdvisorContactCardResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAdvisorContactCardMockHandler200 = (overrideResponse)=>{
    return http.put('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAdvisorContactCardResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAdvisorContactCardMockHandler400 = (overrideResponse)=>{
    return http.put('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAdvisorContactCardResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAdvisorContactCardMockHandler401 = (overrideResponse)=>{
    return http.put('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAdvisorContactCardResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAdvisorContactCardMockHandler403 = (overrideResponse)=>{
    return http.put('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAdvisorContactCardResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAdvisorContactCardMockHandler404 = (overrideResponse)=>{
    return http.put('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAdvisorContactCardResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAdvisorContactCardMockHandler405 = (overrideResponse)=>{
    return http.put('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAdvisorContactCardResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAdvisorContactCardMockHandler406 = (overrideResponse)=>{
    return http.put('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAdvisorContactCardResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAdvisorContactCardMockHandler408 = (overrideResponse)=>{
    return http.put('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAdvisorContactCardResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAdvisorContactCardMockHandler409 = (overrideResponse)=>{
    return http.put('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAdvisorContactCardResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAdvisorContactCardMockHandler410 = (overrideResponse)=>{
    return http.put('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAdvisorContactCardResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAdvisorContactCardMockHandler412 = (overrideResponse)=>{
    return http.put('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAdvisorContactCardResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAdvisorContactCardMockHandler413 = (overrideResponse)=>{
    return http.put('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAdvisorContactCardResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAdvisorContactCardMockHandler415 = (overrideResponse)=>{
    return http.put('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAdvisorContactCardResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAdvisorContactCardMockHandler422 = (overrideResponse)=>{
    return http.put('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAdvisorContactCardResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAdvisorContactCardMockHandler500 = (overrideResponse)=>{
    return http.put('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAdvisorContactCardResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAdvisorContactCardMockHandler501 = (overrideResponse)=>{
    return http.put('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAdvisorContactCardResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAdvisorContactCardMockHandler502 = (overrideResponse)=>{
    return http.put('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAdvisorContactCardResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAdvisorContactCardMockHandler503 = (overrideResponse)=>{
    return http.put('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAdvisorContactCardResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAdvisorContactCardMockHandler504 = (overrideResponse)=>{
    return http.put('*/api/advisor/contact-card', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAdvisorContactCardResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlansMockHandler = (overrideResponse)=>{
    return http.get('*/api/advisor/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlansResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlansMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlansResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlansMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlansResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlansMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlansResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlansMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlansResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlansMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlansResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlansMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlansResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlansMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlansResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlansMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlansResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlansMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlansResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlansMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlansResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlansMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlansResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlansMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlansResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlansMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlansResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlansMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlansResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlansMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlansResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlansMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlansResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlansMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlansResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlansMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlansResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlansMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlansResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorAnnualTestingPlansPerYearMockHandler = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/annual-testing/:year', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorAnnualTestingPlansPerYearResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorAnnualTestingPlansPerYearMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/annual-testing/:year', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorAnnualTestingPlansPerYearResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorAnnualTestingPlansPerYearMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/annual-testing/:year', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorAnnualTestingPlansPerYearResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorAnnualTestingPlansPerYearMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/annual-testing/:year', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorAnnualTestingPlansPerYearResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorAnnualTestingPlansPerYearMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/annual-testing/:year', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorAnnualTestingPlansPerYearResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorAnnualTestingPlansPerYearMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/annual-testing/:year', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorAnnualTestingPlansPerYearResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorAnnualTestingPlansPerYearMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/annual-testing/:year', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorAnnualTestingPlansPerYearResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorAnnualTestingPlansPerYearMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/annual-testing/:year', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorAnnualTestingPlansPerYearResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorAnnualTestingPlansPerYearMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/annual-testing/:year', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorAnnualTestingPlansPerYearResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorAnnualTestingPlansPerYearMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/annual-testing/:year', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorAnnualTestingPlansPerYearResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorAnnualTestingPlansPerYearMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/annual-testing/:year', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorAnnualTestingPlansPerYearResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorAnnualTestingPlansPerYearMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/annual-testing/:year', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorAnnualTestingPlansPerYearResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorAnnualTestingPlansPerYearMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/annual-testing/:year', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorAnnualTestingPlansPerYearResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorAnnualTestingPlansPerYearMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/annual-testing/:year', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorAnnualTestingPlansPerYearResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorAnnualTestingPlansPerYearMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/annual-testing/:year', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorAnnualTestingPlansPerYearResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorAnnualTestingPlansPerYearMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/annual-testing/:year', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorAnnualTestingPlansPerYearResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorAnnualTestingPlansPerYearMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/annual-testing/:year', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorAnnualTestingPlansPerYearResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorAnnualTestingPlansPerYearMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/annual-testing/:year', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorAnnualTestingPlansPerYearResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorAnnualTestingPlansPerYearMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/annual-testing/:year', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorAnnualTestingPlansPerYearResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorAnnualTestingPlansPerYearMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/annual-testing/:year', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorAnnualTestingPlansPerYearResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlansTrackerMockHandler = ()=>{
    return http.get('*/api/advisor/plans/tracker', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlansTrackerMockHandler200 = ()=>{
    return http.get('*/api/advisor/plans/tracker', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorPlanEmployeesMockHandler = ()=>{
    return http.get('*/api/advisor/plans/:planId/employees', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorPlanEmployeesMockHandler200 = ()=>{
    return http.get('*/api/advisor/plans/:planId/employees', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeeMockHandler = ()=>{
    return http.get('*/api/advisor/plans/:planId/employees/:employeeId', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeeMockHandler200 = ()=>{
    return http.get('*/api/advisor/plans/:planId/employees/:employeeId', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorPlanStatisticsMockHandler = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorPlanStatisticsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorPlanStatisticsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorPlanStatisticsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorPlanStatisticsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorPlanStatisticsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorPlanStatisticsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorPlanStatisticsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorPlanStatisticsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorPlanStatisticsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorPlanStatisticsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorPlanStatisticsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorPlanStatisticsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorPlanStatisticsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorPlanStatisticsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorPlanStatisticsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorPlanStatisticsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorPlanStatisticsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorPlanStatisticsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorPlanStatisticsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorPlanStatisticsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorPlanStatisticsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorPlanStatisticsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorPlanStatisticsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorPlanStatisticsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorPlanStatisticsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorPlanStatisticsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorPlanStatisticsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorPlanStatisticsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorPlanStatisticsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorPlanStatisticsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorPlanStatisticsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorPlanStatisticsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorPlanStatisticsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorPlanStatisticsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorPlanStatisticsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorPlanStatisticsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorPlanStatisticsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorPlanStatisticsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/advisor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorPlanStatisticsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLinkSponsorMockHandler = ()=>{
    return http.post('*/api/advisor/sponsors/link', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLinkSponsorMockHandler200 = ()=>{
    return http.post('*/api/advisor/sponsors/link', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLinkSponsorMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/advisor/sponsors/link', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLinkSponsorResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLinkSponsorMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/advisor/sponsors/link', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLinkSponsorResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLinkSponsorMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/advisor/sponsors/link', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLinkSponsorResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLinkSponsorMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/advisor/sponsors/link', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLinkSponsorResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLinkSponsorMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/advisor/sponsors/link', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLinkSponsorResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLinkSponsorMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/advisor/sponsors/link', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLinkSponsorResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLinkSponsorMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/advisor/sponsors/link', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLinkSponsorResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLinkSponsorMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/advisor/sponsors/link', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLinkSponsorResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLinkSponsorMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/advisor/sponsors/link', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLinkSponsorResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLinkSponsorMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/advisor/sponsors/link', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLinkSponsorResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLinkSponsorMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/advisor/sponsors/link', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLinkSponsorResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLinkSponsorMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/advisor/sponsors/link', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLinkSponsorResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLinkSponsorMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/advisor/sponsors/link', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLinkSponsorResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLinkSponsorMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/advisor/sponsors/link', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLinkSponsorResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLinkSponsorMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/advisor/sponsors/link', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLinkSponsorResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLinkSponsorMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/advisor/sponsors/link', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLinkSponsorResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLinkSponsorMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/advisor/sponsors/link', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLinkSponsorResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLinkSponsorMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/advisor/sponsors/link', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLinkSponsorResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorStatsMockHandler = (overrideResponse)=>{
    return http.get('*/api/advisor/statistics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorStatsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorStatsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/advisor/statistics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorStatsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorStatsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/advisor/statistics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorStatsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorStatsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/advisor/statistics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorStatsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorStatsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/advisor/statistics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorStatsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorStatsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/advisor/statistics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorStatsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorStatsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/advisor/statistics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorStatsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorStatsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/advisor/statistics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorStatsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorStatsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/advisor/statistics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorStatsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorStatsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/advisor/statistics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorStatsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorStatsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/advisor/statistics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorStatsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorStatsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/advisor/statistics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorStatsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorStatsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/advisor/statistics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorStatsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorStatsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/advisor/statistics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorStatsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorStatsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/advisor/statistics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorStatsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorStatsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/advisor/statistics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorStatsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorStatsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/advisor/statistics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorStatsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorStatsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/advisor/statistics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorStatsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorStatsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/advisor/statistics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorStatsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorStatsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/advisor/statistics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorStatsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCarouselMockHandler = (overrideResponse)=>{
    return http.get('*/api/carousel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCarouselResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCarouselMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/carousel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCarouselResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCarouselMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/carousel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCarouselResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCarouselMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/carousel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCarouselResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCarouselMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/carousel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCarouselResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCarouselMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/carousel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCarouselResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCarouselMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/carousel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCarouselResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCarouselMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/carousel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCarouselResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCarouselMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/carousel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCarouselResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCarouselMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/carousel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCarouselResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCarouselMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/carousel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCarouselResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCarouselMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/carousel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCarouselResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCarouselMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/carousel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCarouselResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCarouselMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/carousel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCarouselResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCarouselMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/carousel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCarouselResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCarouselMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/carousel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCarouselResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCarouselMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/carousel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCarouselResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCarouselMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/carousel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCarouselResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCarouselMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/carousel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCarouselResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCarouselMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/carousel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCarouselResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetConnectivityMockHandler = (overrideResponse)=>{
    return http.get('*/api/connectivity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetConnectivityResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetConnectivityMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/connectivity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetConnectivityResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetConnectivityMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/connectivity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetConnectivityResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCsmMockHandler = (overrideResponse)=>{
    return http.get('*/api/csm', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCsmResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCsmMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/csm', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCsmResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCsmMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/csm', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCsmResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCsmMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/csm', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCsmResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCsmMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/csm', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCsmResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCsmMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/csm', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCsmResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCsmMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/csm', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCsmResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCsmMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/csm', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCsmResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCsmMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/csm', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCsmResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCsmMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/csm', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCsmResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCsmMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/csm', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCsmResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCsmMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/csm', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCsmResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCsmMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/csm', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCsmResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCsmMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/csm', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCsmResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCsmMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/csm', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCsmResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCsmMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/csm', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCsmResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCsmMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/csm', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCsmResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCsmMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/csm', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCsmResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCsmMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/csm', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCsmResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCsmMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/csm', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCsmResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureMockHandler = (overrideResponse)=>{
    return http.get('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutLoginDisclosureMockHandler = ()=>{
    return http.put('*/api/disclosure/login', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutLoginDisclosureMockHandler200 = ()=>{
    return http.put('*/api/disclosure/login', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutLoginDisclosureMockHandler400 = (overrideResponse)=>{
    return http.put('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutLoginDisclosureResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutLoginDisclosureMockHandler401 = (overrideResponse)=>{
    return http.put('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutLoginDisclosureResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutLoginDisclosureMockHandler403 = (overrideResponse)=>{
    return http.put('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutLoginDisclosureResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutLoginDisclosureMockHandler404 = (overrideResponse)=>{
    return http.put('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutLoginDisclosureResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutLoginDisclosureMockHandler405 = (overrideResponse)=>{
    return http.put('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutLoginDisclosureResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutLoginDisclosureMockHandler406 = (overrideResponse)=>{
    return http.put('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutLoginDisclosureResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutLoginDisclosureMockHandler408 = (overrideResponse)=>{
    return http.put('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutLoginDisclosureResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutLoginDisclosureMockHandler409 = (overrideResponse)=>{
    return http.put('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutLoginDisclosureResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutLoginDisclosureMockHandler410 = (overrideResponse)=>{
    return http.put('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutLoginDisclosureResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutLoginDisclosureMockHandler412 = (overrideResponse)=>{
    return http.put('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutLoginDisclosureResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutLoginDisclosureMockHandler413 = (overrideResponse)=>{
    return http.put('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutLoginDisclosureResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutLoginDisclosureMockHandler415 = (overrideResponse)=>{
    return http.put('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutLoginDisclosureResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutLoginDisclosureMockHandler422 = (overrideResponse)=>{
    return http.put('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutLoginDisclosureResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutLoginDisclosureMockHandler500 = (overrideResponse)=>{
    return http.put('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutLoginDisclosureResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutLoginDisclosureMockHandler501 = (overrideResponse)=>{
    return http.put('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutLoginDisclosureResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutLoginDisclosureMockHandler502 = (overrideResponse)=>{
    return http.put('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutLoginDisclosureResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutLoginDisclosureMockHandler503 = (overrideResponse)=>{
    return http.put('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutLoginDisclosureResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutLoginDisclosureMockHandler504 = (overrideResponse)=>{
    return http.put('*/api/disclosure/login', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutLoginDisclosureResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureAgreementMockHandler = (overrideResponse)=>{
    return http.get('*/api/disclosure/login/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureAgreementResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureAgreementMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureAgreementResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureAgreementMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureAgreementResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureAgreementMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureAgreementResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureAgreementMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureAgreementResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureAgreementMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureAgreementResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureAgreementMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureAgreementResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureAgreementMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureAgreementResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureAgreementMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureAgreementResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureAgreementMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureAgreementResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureAgreementMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureAgreementResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureAgreementMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureAgreementResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureAgreementMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureAgreementResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureAgreementMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureAgreementResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureAgreementMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureAgreementResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureAgreementMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureAgreementResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureAgreementMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureAgreementResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureAgreementMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureAgreementResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureAgreementMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureAgreementResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureAgreementMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/disclosure/login/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureAgreementResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentByIdMockHandler = ()=>{
    return http.get('*/api/document', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentByIdMockHandler200 = ()=>{
    return http.get('*/api/document', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDeleteDocumentByIdMockHandler = ()=>{
    return http.patch('*/api/document', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDeleteDocumentByIdMockHandler200 = ()=>{
    return http.patch('*/api/document', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllDocumentsMockHandler = (overrideResponse)=>{
    return http.get('*/api/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllDocumentsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllDocumentsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllDocumentsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllDocumentsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllDocumentsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllDocumentsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllDocumentsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllDocumentsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllDocumentsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllDocumentsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllDocumentsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllDocumentsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllDocumentsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllDocumentsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllDocumentsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllDocumentsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllDocumentsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllDocumentsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllDocumentsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllDocumentsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllDocumentsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllDocumentsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllDocumentsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllDocumentsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllDocumentsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllDocumentsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllDocumentsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllDocumentsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllDocumentsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllDocumentsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllDocumentsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllDocumentsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllDocumentsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllDocumentsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllDocumentsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllDocumentsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllDocumentsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllDocumentsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllDocumentsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAgreementMockHandler = (overrideResponse)=>{
    return http.get('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAgreementResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAgreementMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAgreementResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAgreementMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAgreementResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAgreementMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAgreementResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAgreementMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAgreementResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAgreementMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAgreementResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAgreementMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAgreementResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAgreementMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAgreementResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAgreementMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAgreementResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAgreementMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAgreementResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAgreementMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAgreementResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAgreementMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAgreementResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAgreementMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAgreementResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAgreementMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAgreementResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAgreementMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAgreementResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAgreementMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAgreementResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAgreementMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAgreementResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAgreementMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAgreementResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAgreementMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAgreementResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAgreementMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAgreementResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDocumentAgreementMockHandler = ()=>{
    return http.post('*/api/documents/agreement', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDocumentAgreementMockHandler200 = ()=>{
    return http.post('*/api/documents/agreement', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDocumentAgreementMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDocumentAgreementResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDocumentAgreementMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDocumentAgreementResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDocumentAgreementMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDocumentAgreementResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDocumentAgreementMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDocumentAgreementResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDocumentAgreementMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDocumentAgreementResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDocumentAgreementMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDocumentAgreementResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDocumentAgreementMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDocumentAgreementResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDocumentAgreementMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDocumentAgreementResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDocumentAgreementMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDocumentAgreementResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDocumentAgreementMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDocumentAgreementResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDocumentAgreementMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDocumentAgreementResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDocumentAgreementMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDocumentAgreementResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDocumentAgreementMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDocumentAgreementResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDocumentAgreementMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDocumentAgreementResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDocumentAgreementMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDocumentAgreementResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDocumentAgreementMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDocumentAgreementResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDocumentAgreementMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDocumentAgreementResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDocumentAgreementMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/documents/agreement', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDocumentAgreementResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentDownloadByIdMockHandler = ()=>{
    return http.get('*/api/documents/download', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentDownloadByIdMockHandler200 = ()=>{
    return http.get('*/api/documents/download', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentDownloadByKeyMockHandler = ()=>{
    return http.get('*/api/documents/download-by-key', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentDownloadByKeyMockHandler200 = ()=>{
    return http.get('*/api/documents/download-by-key', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAsHtmlMockHandler = (overrideResponse)=>{
    return http.get('*/api/documents/html', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAsHtmlResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAsHtmlMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/documents/html', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAsHtmlResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAsHtmlMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/documents/html', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAsHtmlResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAsHtmlMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/documents/html', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAsHtmlResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAsHtmlMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/documents/html', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAsHtmlResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAsHtmlMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/documents/html', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAsHtmlResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAsHtmlMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/documents/html', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAsHtmlResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAsHtmlMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/documents/html', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAsHtmlResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAsHtmlMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/documents/html', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAsHtmlResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAsHtmlMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/documents/html', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAsHtmlResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAsHtmlMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/documents/html', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAsHtmlResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAsHtmlMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/documents/html', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAsHtmlResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAsHtmlMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/documents/html', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAsHtmlResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAsHtmlMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/documents/html', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAsHtmlResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAsHtmlMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/documents/html', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAsHtmlResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAsHtmlMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/documents/html', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAsHtmlResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAsHtmlMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/documents/html', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAsHtmlResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAsHtmlMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/documents/html', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAsHtmlResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAsHtmlMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/documents/html', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAsHtmlResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAsHtmlMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/documents/html', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAsHtmlResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAsHtmlAndDownloadMockHandler = (overrideResponse)=>{
    return http.get('*/api/documents/html/download', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAsHtmlAndDownloadResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAsHtmlAndDownloadMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/documents/html/download', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAsHtmlAndDownloadResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPdfMockHandler = (overrideResponse)=>{
    return http.post('*/api/documents/pdf', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPdfResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPdfMockHandler200 = (overrideResponse)=>{
    return http.post('*/api/documents/pdf', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPdfResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostProcessDocumentMockHandler = (overrideResponse)=>{
    return http.post('*/api/documents/process', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostProcessDocumentResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostProcessDocumentMockHandler200 = (overrideResponse)=>{
    return http.post('*/api/documents/process', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostProcessDocumentResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostProcessDocumentMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/documents/process', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostProcessDocumentResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostProcessDocumentMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/documents/process', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostProcessDocumentResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostProcessDocumentMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/documents/process', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostProcessDocumentResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostProcessDocumentMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/documents/process', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostProcessDocumentResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostProcessDocumentMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/documents/process', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostProcessDocumentResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostProcessDocumentMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/documents/process', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostProcessDocumentResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostProcessDocumentMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/documents/process', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostProcessDocumentResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostProcessDocumentMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/documents/process', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostProcessDocumentResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostProcessDocumentMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/documents/process', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostProcessDocumentResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostProcessDocumentMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/documents/process', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostProcessDocumentResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostProcessDocumentMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/documents/process', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostProcessDocumentResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostProcessDocumentMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/documents/process', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostProcessDocumentResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostProcessDocumentMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/documents/process', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostProcessDocumentResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostProcessDocumentMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/documents/process', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostProcessDocumentResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostProcessDocumentMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/documents/process', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostProcessDocumentResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostProcessDocumentMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/documents/process', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostProcessDocumentResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostProcessDocumentMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/documents/process', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostProcessDocumentResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostProcessDocumentMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/documents/process', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostProcessDocumentResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadDocumentMockHandler = ()=>{
    return http.post('*/api/documents/upload', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadDocumentMockHandler201 = ()=>{
    return http.post('*/api/documents/upload', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEmailMockHandler = ()=>{
    return http.post('*/api/email', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEmailMockHandler200 = ()=>{
    return http.post('*/api/email', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEmailMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/email', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEmailResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEmailMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/email', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEmailResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEmailMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/email', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEmailResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEmailMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/email', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEmailResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEmailMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/email', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEmailResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEmailMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/email', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEmailResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEmailMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/email', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEmailResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEmailMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/email', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEmailResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEmailMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/email', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEmailResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEmailMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/email', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEmailResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEmailMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/email', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEmailResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEmailMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/email', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEmailResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEmailMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/email', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEmailResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEmailMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/email', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEmailResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEmailMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/email', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEmailResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEmailMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/email', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEmailResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEmailMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/email', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEmailResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEmailMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/email', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEmailResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEmailPreviewRenderMockHandler = ()=>{
    return http.post('*/api/email/preview/render', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEmailPreviewRenderMockHandler201 = ()=>{
    return http.post('*/api/email/preview/render', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmailPreviewByIdMockHandler = ()=>{
    return http.get('*/api/email/previews', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmailPreviewByIdMockHandler200 = ()=>{
    return http.get('*/api/email/previews', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeHoldingsMockHandler = (overrideResponse)=>{
    return http.get('*/api/employee/holdings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeHoldingsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeHoldingsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/employee/holdings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeHoldingsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeHoldingsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/employee/holdings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeHoldingsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeHoldingsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/employee/holdings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeHoldingsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeHoldingsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/employee/holdings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeHoldingsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeHoldingsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/employee/holdings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeHoldingsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeHoldingsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/employee/holdings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeHoldingsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeHoldingsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/employee/holdings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeHoldingsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeHoldingsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/employee/holdings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeHoldingsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeHoldingsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/employee/holdings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeHoldingsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeHoldingsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/employee/holdings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeHoldingsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeHoldingsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/employee/holdings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeHoldingsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeHoldingsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/employee/holdings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeHoldingsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeHoldingsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/employee/holdings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeHoldingsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeHoldingsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/employee/holdings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeHoldingsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeHoldingsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/employee/holdings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeHoldingsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeHoldingsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/employee/holdings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeHoldingsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeHoldingsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/employee/holdings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeHoldingsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeHoldingsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/employee/holdings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeHoldingsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeHoldingsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/employee/holdings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeHoldingsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoansMockHandler = (overrideResponse)=>{
    return http.get('*/api/employee/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoansResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoansMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/employee/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoansResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoansMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/employee/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoansResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoansMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/employee/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoansResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoansMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/employee/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoansResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoansMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/employee/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoansResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoansMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/employee/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoansResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoansMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/employee/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoansResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoansMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/employee/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoansResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoansMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/employee/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoansResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoansMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/employee/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoansResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoansMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/employee/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoansResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoansMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/employee/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoansResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoansMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/employee/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoansResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoansMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/employee/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoansResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoansMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/employee/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoansResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoansMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/employee/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoansResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoansMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/employee/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoansResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoansMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/employee/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoansResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoansMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/employee/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoansResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeePerformanceMockHandler = ()=>{
    return http.get('*/api/employee/performance', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeePerformanceMockHandler200 = ()=>{
    return http.get('*/api/employee/performance', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeTransactionsMockHandler = ()=>{
    return http.get('*/api/employee/transactions', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeTransactionsMockHandler200 = ()=>{
    return http.get('*/api/employee/transactions', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeePendingTransactionsMockHandler = ()=>{
    return http.get('*/api/employee/transactions/pending', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeePendingTransactionsMockHandler200 = ()=>{
    return http.get('*/api/employee/transactions/pending', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeTransactionsYearsMockHandler = ()=>{
    return http.get('*/api/employee/transactions/years', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeTransactionsYearsMockHandler200 = ()=>{
    return http.get('*/api/employee/transactions/years', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelSecuritiesMockHandler = (overrideResponse)=>{
    return http.get('*/api/employee/:employeeId/model-securities/:type', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelSecuritiesResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelSecuritiesMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/employee/:employeeId/model-securities/:type', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelSecuritiesResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelSecuritiesMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/employee/:employeeId/model-securities/:type', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelSecuritiesResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelSecuritiesMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/employee/:employeeId/model-securities/:type', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelSecuritiesResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelSecuritiesMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/employee/:employeeId/model-securities/:type', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelSecuritiesResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelSecuritiesMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/employee/:employeeId/model-securities/:type', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelSecuritiesResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelSecuritiesMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/employee/:employeeId/model-securities/:type', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelSecuritiesResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelSecuritiesMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/employee/:employeeId/model-securities/:type', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelSecuritiesResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelSecuritiesMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/employee/:employeeId/model-securities/:type', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelSecuritiesResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelSecuritiesMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/employee/:employeeId/model-securities/:type', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelSecuritiesResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelSecuritiesMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/employee/:employeeId/model-securities/:type', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelSecuritiesResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelSecuritiesMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/employee/:employeeId/model-securities/:type', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelSecuritiesResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelSecuritiesMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/employee/:employeeId/model-securities/:type', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelSecuritiesResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelSecuritiesMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/employee/:employeeId/model-securities/:type', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelSecuritiesResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelSecuritiesMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/employee/:employeeId/model-securities/:type', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelSecuritiesResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelSecuritiesMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/employee/:employeeId/model-securities/:type', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelSecuritiesResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelSecuritiesMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/employee/:employeeId/model-securities/:type', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelSecuritiesResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelSecuritiesMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/employee/:employeeId/model-securities/:type', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelSecuritiesResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelSecuritiesMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/employee/:employeeId/model-securities/:type', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelSecuritiesResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelSecuritiesMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/employee/:employeeId/model-securities/:type', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelSecuritiesResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeesWithContributionsMockHandler = ()=>{
    return http.get('*/api/employees/contributions', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeesWithContributionsMockHandler200 = ()=>{
    return http.get('*/api/employees/contributions', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoanDetailsMockHandler = (overrideResponse)=>{
    return http.get('*/api/employees/loans/details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoanDetailsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoanDetailsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/employees/loans/details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoanDetailsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoanDetailsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/employees/loans/details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoanDetailsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoanDetailsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/employees/loans/details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoanDetailsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoanDetailsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/employees/loans/details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoanDetailsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoanDetailsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/employees/loans/details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoanDetailsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoanDetailsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/employees/loans/details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoanDetailsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoanDetailsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/employees/loans/details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoanDetailsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoanDetailsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/employees/loans/details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoanDetailsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoanDetailsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/employees/loans/details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoanDetailsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoanDetailsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/employees/loans/details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoanDetailsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoanDetailsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/employees/loans/details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoanDetailsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoanDetailsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/employees/loans/details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoanDetailsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoanDetailsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/employees/loans/details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoanDetailsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoanDetailsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/employees/loans/details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoanDetailsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoanDetailsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/employees/loans/details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoanDetailsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoanDetailsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/employees/loans/details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoanDetailsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoanDetailsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/employees/loans/details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoanDetailsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoanDetailsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/employees/loans/details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoanDetailsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoanDetailsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/employees/loans/details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeLoanDetailsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeesTransactionsYearsMockHandler = ()=>{
    return http.get('*/api/employees/transactions/years', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeesTransactionsYearsMockHandler200 = ()=>{
    return http.get('*/api/employees/transactions/years', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaParticipantGoalMockHandler = ()=>{
    return http.patch('*/api/esa/participant/goal', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaParticipantGoalMockHandler200 = ()=>{
    return http.patch('*/api/esa/participant/goal', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaParticipantGoalMockHandler400 = (overrideResponse)=>{
    return http.patch('*/api/esa/participant/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaParticipantGoalResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaParticipantGoalMockHandler401 = (overrideResponse)=>{
    return http.patch('*/api/esa/participant/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaParticipantGoalResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaParticipantGoalMockHandler403 = (overrideResponse)=>{
    return http.patch('*/api/esa/participant/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaParticipantGoalResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaParticipantGoalMockHandler404 = (overrideResponse)=>{
    return http.patch('*/api/esa/participant/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaParticipantGoalResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaParticipantGoalMockHandler405 = (overrideResponse)=>{
    return http.patch('*/api/esa/participant/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaParticipantGoalResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaParticipantGoalMockHandler406 = (overrideResponse)=>{
    return http.patch('*/api/esa/participant/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaParticipantGoalResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaParticipantGoalMockHandler408 = (overrideResponse)=>{
    return http.patch('*/api/esa/participant/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaParticipantGoalResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaParticipantGoalMockHandler409 = (overrideResponse)=>{
    return http.patch('*/api/esa/participant/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaParticipantGoalResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaParticipantGoalMockHandler410 = (overrideResponse)=>{
    return http.patch('*/api/esa/participant/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaParticipantGoalResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaParticipantGoalMockHandler412 = (overrideResponse)=>{
    return http.patch('*/api/esa/participant/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaParticipantGoalResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaParticipantGoalMockHandler413 = (overrideResponse)=>{
    return http.patch('*/api/esa/participant/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaParticipantGoalResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaParticipantGoalMockHandler415 = (overrideResponse)=>{
    return http.patch('*/api/esa/participant/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaParticipantGoalResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaParticipantGoalMockHandler422 = (overrideResponse)=>{
    return http.patch('*/api/esa/participant/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaParticipantGoalResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaParticipantGoalMockHandler500 = (overrideResponse)=>{
    return http.patch('*/api/esa/participant/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaParticipantGoalResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaParticipantGoalMockHandler501 = (overrideResponse)=>{
    return http.patch('*/api/esa/participant/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaParticipantGoalResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaParticipantGoalMockHandler502 = (overrideResponse)=>{
    return http.patch('*/api/esa/participant/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaParticipantGoalResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaParticipantGoalMockHandler503 = (overrideResponse)=>{
    return http.patch('*/api/esa/participant/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaParticipantGoalResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaParticipantGoalMockHandler504 = (overrideResponse)=>{
    return http.patch('*/api/esa/participant/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaParticipantGoalResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantGoalsMockHandler = (overrideResponse)=>{
    return http.get('*/api/esa/participant/goals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantGoalsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantGoalsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/goals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantGoalsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantGoalsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/goals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantGoalsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantGoalsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/goals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantGoalsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantGoalsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/goals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantGoalsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantGoalsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/goals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantGoalsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantGoalsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/goals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantGoalsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantGoalsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/goals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantGoalsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantGoalsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/goals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantGoalsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantGoalsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/goals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantGoalsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantGoalsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/goals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantGoalsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantGoalsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/goals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantGoalsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantGoalsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/goals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantGoalsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantGoalsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/goals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantGoalsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantGoalsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/goals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantGoalsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantGoalsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/goals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantGoalsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantGoalsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/goals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantGoalsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantGoalsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/goals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantGoalsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantGoalsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/goals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantGoalsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantGoalsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/goals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantGoalsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantIncentivesMockHandler = (overrideResponse)=>{
    return http.get('*/api/esa/participant/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantIncentivesResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantIncentivesMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantIncentivesResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantIncentivesMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantIncentivesResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantIncentivesMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantIncentivesResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantIncentivesMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantIncentivesResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantIncentivesMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantIncentivesResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantIncentivesMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantIncentivesResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantIncentivesMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantIncentivesResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantIncentivesMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantIncentivesResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantIncentivesMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantIncentivesResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantIncentivesMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantIncentivesResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantIncentivesMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantIncentivesResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantIncentivesMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantIncentivesResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantIncentivesMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantIncentivesResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantIncentivesMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantIncentivesResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantIncentivesMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantIncentivesResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantIncentivesMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantIncentivesResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantIncentivesMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantIncentivesResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantIncentivesMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantIncentivesResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantIncentivesMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/esa/participant/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantIncentivesResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanCashInterestRateMockHandler = (overrideResponse)=>{
    return http.get('*/api/esa/plan/cash-interest-rate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanCashInterestRateResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanCashInterestRateMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/cash-interest-rate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanCashInterestRateResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanCashInterestRateMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/cash-interest-rate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanCashInterestRateResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanCashInterestRateMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/cash-interest-rate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanCashInterestRateResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanCashInterestRateMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/cash-interest-rate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanCashInterestRateResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanCashInterestRateMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/cash-interest-rate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanCashInterestRateResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanCashInterestRateMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/cash-interest-rate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanCashInterestRateResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanCashInterestRateMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/cash-interest-rate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanCashInterestRateResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanCashInterestRateMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/cash-interest-rate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanCashInterestRateResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanCashInterestRateMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/cash-interest-rate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanCashInterestRateResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanCashInterestRateMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/cash-interest-rate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanCashInterestRateResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanCashInterestRateMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/cash-interest-rate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanCashInterestRateResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanCashInterestRateMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/cash-interest-rate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanCashInterestRateResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanCashInterestRateMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/cash-interest-rate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanCashInterestRateResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanCashInterestRateMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/cash-interest-rate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanCashInterestRateResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanCashInterestRateMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/cash-interest-rate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanCashInterestRateResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanCashInterestRateMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/cash-interest-rate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanCashInterestRateResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanCashInterestRateMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/cash-interest-rate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanCashInterestRateResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanCashInterestRateMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/cash-interest-rate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanCashInterestRateResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanCashInterestRateMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/cash-interest-rate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanCashInterestRateResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupBalanceOverTimeMockHandler = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupBalanceOverTimeResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupBalanceOverTimeMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupBalanceOverTimeResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupBalanceOverTimeMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupBalanceOverTimeResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupBalanceOverTimeMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupBalanceOverTimeResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupBalanceOverTimeMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupBalanceOverTimeResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupBalanceOverTimeMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupBalanceOverTimeResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupBalanceOverTimeMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupBalanceOverTimeResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupBalanceOverTimeMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupBalanceOverTimeResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupBalanceOverTimeMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupBalanceOverTimeResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupBalanceOverTimeMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupBalanceOverTimeResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupBalanceOverTimeMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupBalanceOverTimeResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupBalanceOverTimeMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupBalanceOverTimeResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupBalanceOverTimeMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupBalanceOverTimeResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupBalanceOverTimeMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupBalanceOverTimeResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupBalanceOverTimeMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupBalanceOverTimeResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupBalanceOverTimeMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupBalanceOverTimeResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupBalanceOverTimeMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupBalanceOverTimeResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupBalanceOverTimeMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupBalanceOverTimeResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupBalanceOverTimeMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupBalanceOverTimeResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupBalanceOverTimeMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupBalanceOverTimeResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupStatsMockHandler = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupStatsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupStatsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupStatsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupStatsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupStatsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupStatsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupStatsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupStatsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupStatsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupStatsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupStatsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupStatsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupStatsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupStatsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupStatsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupStatsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupStatsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupStatsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupStatsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupStatsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupStatsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupStatsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupStatsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupStatsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupStatsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupStatsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupStatsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupStatsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupStatsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupStatsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupStatsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupStatsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupStatsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupStatsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupStatsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupStatsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupStatsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupStatsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupStatsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupsMockHandler = (overrideResponse)=>{
    return http.get('*/api/esa/plan/groups', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/groups', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/groups', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/groups', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/groups', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/groups', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/groups', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/groups', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/groups', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/groups', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/groups', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/groups', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/groups', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/groups', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/groups', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/groups', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/groups', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/groups', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/groups', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/groups', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanIncentivesMockHandler = (overrideResponse)=>{
    return http.get('*/api/esa/plan/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanIncentivesResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanIncentivesMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanIncentivesResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanIncentivesMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanIncentivesResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanIncentivesMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanIncentivesResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanIncentivesMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanIncentivesResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanIncentivesMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanIncentivesResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanIncentivesMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanIncentivesResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanIncentivesMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanIncentivesResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanIncentivesMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanIncentivesResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanIncentivesMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanIncentivesResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanIncentivesMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanIncentivesResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanIncentivesMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanIncentivesResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanIncentivesMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanIncentivesResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanIncentivesMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanIncentivesResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanIncentivesMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanIncentivesResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanIncentivesMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanIncentivesResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanIncentivesMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanIncentivesResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanIncentivesMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanIncentivesResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanIncentivesMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanIncentivesResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanIncentivesMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/esa/plan/incentives', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanIncentivesResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaWithdrawalMockHandler = ()=>{
    return http.patch('*/api/esa/withdrawal', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaWithdrawalMockHandler200 = ()=>{
    return http.patch('*/api/esa/withdrawal', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaWithdrawalMockHandler400 = (overrideResponse)=>{
    return http.patch('*/api/esa/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaWithdrawalResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaWithdrawalMockHandler401 = (overrideResponse)=>{
    return http.patch('*/api/esa/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaWithdrawalResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaWithdrawalMockHandler403 = (overrideResponse)=>{
    return http.patch('*/api/esa/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaWithdrawalResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaWithdrawalMockHandler404 = (overrideResponse)=>{
    return http.patch('*/api/esa/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaWithdrawalResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaWithdrawalMockHandler405 = (overrideResponse)=>{
    return http.patch('*/api/esa/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaWithdrawalResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaWithdrawalMockHandler406 = (overrideResponse)=>{
    return http.patch('*/api/esa/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaWithdrawalResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaWithdrawalMockHandler408 = (overrideResponse)=>{
    return http.patch('*/api/esa/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaWithdrawalResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaWithdrawalMockHandler409 = (overrideResponse)=>{
    return http.patch('*/api/esa/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaWithdrawalResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaWithdrawalMockHandler410 = (overrideResponse)=>{
    return http.patch('*/api/esa/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaWithdrawalResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaWithdrawalMockHandler412 = (overrideResponse)=>{
    return http.patch('*/api/esa/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaWithdrawalResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaWithdrawalMockHandler413 = (overrideResponse)=>{
    return http.patch('*/api/esa/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaWithdrawalResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaWithdrawalMockHandler415 = (overrideResponse)=>{
    return http.patch('*/api/esa/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaWithdrawalResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaWithdrawalMockHandler422 = (overrideResponse)=>{
    return http.patch('*/api/esa/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaWithdrawalResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaWithdrawalMockHandler500 = (overrideResponse)=>{
    return http.patch('*/api/esa/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaWithdrawalResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaWithdrawalMockHandler501 = (overrideResponse)=>{
    return http.patch('*/api/esa/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaWithdrawalResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaWithdrawalMockHandler502 = (overrideResponse)=>{
    return http.patch('*/api/esa/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaWithdrawalResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaWithdrawalMockHandler503 = (overrideResponse)=>{
    return http.patch('*/api/esa/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaWithdrawalResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaWithdrawalMockHandler504 = (overrideResponse)=>{
    return http.patch('*/api/esa/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchEsaWithdrawalResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFi360DownloadMockHandler = ()=>{
    return http.get('*/api/fact-sheets', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFi360DownloadMockHandler200 = ()=>{
    return http.get('*/api/fact-sheets', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesMockHandler = (overrideResponse)=>{
    return http.get('*/api/feature-toggle', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesListMockHandler = (overrideResponse)=>{
    return http.get('*/api/feature-toggle/list', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesListResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesListMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle/list', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesListResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesListMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle/list', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesListResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesListMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle/list', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesListResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesListMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle/list', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesListResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesListMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle/list', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesListResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesListMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle/list', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesListResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesListMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle/list', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesListResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesListMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle/list', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesListResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesListMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle/list', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesListResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesListMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle/list', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesListResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesListMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle/list', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesListResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesListMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle/list', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesListResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesListMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle/list', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesListResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesListMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle/list', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesListResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesListMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle/list', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesListResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesListMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle/list', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesListResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesListMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle/list', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesListResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesListMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle/list', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesListResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesListMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/feature-toggle/list', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesListResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFirmByIdMockHandler = (overrideResponse)=>{
    return http.get('*/api/firm/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFirmByIdResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFirmByIdMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/firm/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFirmByIdResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFirmByIdMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/firm/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFirmByIdResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFirmByIdMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/firm/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFirmByIdResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFirmByIdMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/firm/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFirmByIdResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFirmByIdMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/firm/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFirmByIdResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFirmByIdMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/firm/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFirmByIdResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFirmByIdMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/firm/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFirmByIdResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFirmByIdMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/firm/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFirmByIdResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFirmByIdMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/firm/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFirmByIdResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFirmByIdMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/firm/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFirmByIdResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFirmByIdMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/firm/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFirmByIdResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFirmByIdMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/firm/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFirmByIdResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFirmByIdMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/firm/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFirmByIdResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFirmByIdMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/firm/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFirmByIdResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFirmByIdMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/firm/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFirmByIdResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFirmByIdMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/firm/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFirmByIdResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFirmByIdMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/firm/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFirmByIdResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFirmByIdMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/firm/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFirmByIdResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFirmByIdMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/firm/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFirmByIdResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecurringMockHandler = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecurringResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecurringMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecurringResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecurringMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecurringResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecurringMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecurringResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecurringMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecurringResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecurringMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecurringResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecurringMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecurringResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecurringMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecurringResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecurringMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecurringResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecurringMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecurringResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecurringMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecurringResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecurringMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecurringResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecurringMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecurringResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecurringMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecurringResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecurringMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecurringResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecurringMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecurringResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecurringMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecurringResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecurringMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecurringResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecurringMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecurringResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecurringMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecurringResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteGiftContributorRecurringMockHandler = ()=>{
    return http.delete('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteGiftContributorRecurringMockHandler200 = ()=>{
    return http.delete('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteGiftContributorRecurringMockHandler400 = (overrideResponse)=>{
    return http.delete('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteGiftContributorRecurringResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteGiftContributorRecurringMockHandler401 = (overrideResponse)=>{
    return http.delete('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteGiftContributorRecurringResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteGiftContributorRecurringMockHandler403 = (overrideResponse)=>{
    return http.delete('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteGiftContributorRecurringResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteGiftContributorRecurringMockHandler404 = (overrideResponse)=>{
    return http.delete('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteGiftContributorRecurringResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteGiftContributorRecurringMockHandler405 = (overrideResponse)=>{
    return http.delete('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteGiftContributorRecurringResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteGiftContributorRecurringMockHandler406 = (overrideResponse)=>{
    return http.delete('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteGiftContributorRecurringResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteGiftContributorRecurringMockHandler408 = (overrideResponse)=>{
    return http.delete('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteGiftContributorRecurringResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteGiftContributorRecurringMockHandler409 = (overrideResponse)=>{
    return http.delete('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteGiftContributorRecurringResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteGiftContributorRecurringMockHandler410 = (overrideResponse)=>{
    return http.delete('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteGiftContributorRecurringResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteGiftContributorRecurringMockHandler412 = (overrideResponse)=>{
    return http.delete('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteGiftContributorRecurringResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteGiftContributorRecurringMockHandler413 = (overrideResponse)=>{
    return http.delete('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteGiftContributorRecurringResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteGiftContributorRecurringMockHandler415 = (overrideResponse)=>{
    return http.delete('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteGiftContributorRecurringResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteGiftContributorRecurringMockHandler422 = (overrideResponse)=>{
    return http.delete('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteGiftContributorRecurringResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteGiftContributorRecurringMockHandler500 = (overrideResponse)=>{
    return http.delete('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteGiftContributorRecurringResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteGiftContributorRecurringMockHandler501 = (overrideResponse)=>{
    return http.delete('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteGiftContributorRecurringResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteGiftContributorRecurringMockHandler502 = (overrideResponse)=>{
    return http.delete('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteGiftContributorRecurringResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteGiftContributorRecurringMockHandler503 = (overrideResponse)=>{
    return http.delete('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteGiftContributorRecurringResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteGiftContributorRecurringMockHandler504 = (overrideResponse)=>{
    return http.delete('*/api/gifting/contributor/:giftContributorId/gift-account/:giftAccountId/recurring/:recurringId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteGiftContributorRecurringResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorBanksMockHandler = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-banks', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorBanksResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorBanksMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-banks', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorBanksResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorBanksMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-banks', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorBanksResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorBanksMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-banks', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorBanksResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorBanksMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-banks', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorBanksResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorBanksMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-banks', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorBanksResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorBanksMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-banks', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorBanksResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorBanksMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-banks', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorBanksResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorBanksMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-banks', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorBanksResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorBanksMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-banks', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorBanksResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorBanksMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-banks', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorBanksResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorBanksMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-banks', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorBanksResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorBanksMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-banks', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorBanksResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorBanksMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-banks', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorBanksResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorBanksMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-banks', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorBanksResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorBanksMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-banks', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorBanksResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorBanksMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-banks', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorBanksResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorBanksMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-banks', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorBanksResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorBanksMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-banks', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorBanksResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorBanksMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-banks', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorBanksResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorPaymentsMockHandler = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-payments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorPaymentsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorPaymentsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-payments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorPaymentsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorPaymentsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-payments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorPaymentsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorPaymentsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-payments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorPaymentsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorPaymentsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-payments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorPaymentsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorPaymentsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-payments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorPaymentsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorPaymentsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-payments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorPaymentsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorPaymentsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-payments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorPaymentsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorPaymentsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-payments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorPaymentsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorPaymentsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-payments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorPaymentsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorPaymentsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-payments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorPaymentsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorPaymentsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-payments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorPaymentsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorPaymentsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-payments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorPaymentsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorPaymentsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-payments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorPaymentsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorPaymentsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-payments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorPaymentsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorPaymentsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-payments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorPaymentsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorPaymentsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-payments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorPaymentsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorPaymentsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-payments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorPaymentsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorPaymentsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-payments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorPaymentsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorPaymentsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/gift-payments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorPaymentsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecipientsMockHandler = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/recipients', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecipientsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecipientsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/recipients', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecipientsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecipientsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/recipients', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecipientsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecipientsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/recipients', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecipientsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecipientsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/recipients', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecipientsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecipientsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/recipients', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecipientsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecipientsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/recipients', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecipientsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecipientsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/recipients', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecipientsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecipientsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/recipients', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecipientsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecipientsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/recipients', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecipientsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecipientsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/recipients', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecipientsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecipientsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/recipients', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecipientsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecipientsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/recipients', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecipientsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecipientsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/recipients', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecipientsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecipientsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/recipients', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecipientsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecipientsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/recipients', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecipientsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecipientsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/recipients', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecipientsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecipientsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/recipients', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecipientsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecipientsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/recipients', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecipientsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftContributorRecipientsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/gifting/contributor/:giftContributorId/recipients', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftContributorRecipientsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageAndAccountByIdMockHandler = (overrideResponse)=>{
    return http.get('*/api/gifting/gift-account/:giftingId/:giftContributorId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageAndAccountByIdResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageAndAccountByIdMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift-account/:giftingId/:giftContributorId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageAndAccountByIdResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageAndAccountByIdMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift-account/:giftingId/:giftContributorId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageAndAccountByIdResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageAndAccountByIdMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift-account/:giftingId/:giftContributorId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageAndAccountByIdResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageAndAccountByIdMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift-account/:giftingId/:giftContributorId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageAndAccountByIdResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageAndAccountByIdMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift-account/:giftingId/:giftContributorId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageAndAccountByIdResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageAndAccountByIdMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift-account/:giftingId/:giftContributorId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageAndAccountByIdResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageAndAccountByIdMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift-account/:giftingId/:giftContributorId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageAndAccountByIdResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageAndAccountByIdMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift-account/:giftingId/:giftContributorId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageAndAccountByIdResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageAndAccountByIdMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift-account/:giftingId/:giftContributorId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageAndAccountByIdResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageAndAccountByIdMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift-account/:giftingId/:giftContributorId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageAndAccountByIdResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageAndAccountByIdMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift-account/:giftingId/:giftContributorId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageAndAccountByIdResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageAndAccountByIdMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift-account/:giftingId/:giftContributorId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageAndAccountByIdResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageAndAccountByIdMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift-account/:giftingId/:giftContributorId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageAndAccountByIdResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageAndAccountByIdMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift-account/:giftingId/:giftContributorId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageAndAccountByIdResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageAndAccountByIdMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift-account/:giftingId/:giftContributorId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageAndAccountByIdResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageAndAccountByIdMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift-account/:giftingId/:giftContributorId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageAndAccountByIdResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageAndAccountByIdMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift-account/:giftingId/:giftContributorId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageAndAccountByIdResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageAndAccountByIdMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift-account/:giftingId/:giftContributorId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageAndAccountByIdResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageAndAccountByIdMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift-account/:giftingId/:giftContributorId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageAndAccountByIdResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageByIdMockHandler = (overrideResponse)=>{
    return http.get('*/api/gifting/gift/:planId/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageByIdResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageByIdMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift/:planId/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageByIdResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageByIdMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift/:planId/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageByIdResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageByIdMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift/:planId/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageByIdResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageByIdMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift/:planId/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageByIdResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageByIdMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift/:planId/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageByIdResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageByIdMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift/:planId/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageByIdResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageByIdMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift/:planId/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageByIdResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageByIdMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift/:planId/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageByIdResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageByIdMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift/:planId/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageByIdResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageByIdMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift/:planId/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageByIdResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageByIdMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift/:planId/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageByIdResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageByIdMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift/:planId/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageByIdResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageByIdMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift/:planId/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageByIdResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageByIdMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift/:planId/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageByIdResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageByIdMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift/:planId/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageByIdResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageByIdMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift/:planId/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageByIdResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageByIdMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift/:planId/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageByIdResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageByIdMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift/:planId/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageByIdResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGiftingPageByIdMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/gifting/gift/:planId/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGiftingPageByIdResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateGiftorProfileMockHandler = (overrideResponse)=>{
    return http.post('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateGiftorProfileResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateGiftorProfileMockHandler200 = (overrideResponse)=>{
    return http.post('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateGiftorProfileResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateGiftorProfileMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateGiftorProfileResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateGiftorProfileMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateGiftorProfileResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateGiftorProfileMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateGiftorProfileResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateGiftorProfileMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateGiftorProfileResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateGiftorProfileMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateGiftorProfileResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateGiftorProfileMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateGiftorProfileResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateGiftorProfileMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateGiftorProfileResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateGiftorProfileMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateGiftorProfileResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateGiftorProfileMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateGiftorProfileResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateGiftorProfileMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateGiftorProfileResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateGiftorProfileMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateGiftorProfileResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateGiftorProfileMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateGiftorProfileResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateGiftorProfileMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateGiftorProfileResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateGiftorProfileMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateGiftorProfileResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateGiftorProfileMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateGiftorProfileResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateGiftorProfileMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateGiftorProfileResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateGiftorProfileMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateGiftorProfileResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateGiftorProfileMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateGiftorProfileResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftorProfileMockHandler = (overrideResponse)=>{
    return http.put('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftorProfileResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftorProfileMockHandler200 = (overrideResponse)=>{
    return http.put('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftorProfileResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftorProfileMockHandler400 = (overrideResponse)=>{
    return http.put('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftorProfileResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftorProfileMockHandler401 = (overrideResponse)=>{
    return http.put('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftorProfileResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftorProfileMockHandler403 = (overrideResponse)=>{
    return http.put('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftorProfileResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftorProfileMockHandler404 = (overrideResponse)=>{
    return http.put('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftorProfileResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftorProfileMockHandler405 = (overrideResponse)=>{
    return http.put('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftorProfileResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftorProfileMockHandler406 = (overrideResponse)=>{
    return http.put('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftorProfileResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftorProfileMockHandler408 = (overrideResponse)=>{
    return http.put('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftorProfileResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftorProfileMockHandler409 = (overrideResponse)=>{
    return http.put('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftorProfileResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftorProfileMockHandler410 = (overrideResponse)=>{
    return http.put('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftorProfileResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftorProfileMockHandler412 = (overrideResponse)=>{
    return http.put('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftorProfileResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftorProfileMockHandler413 = (overrideResponse)=>{
    return http.put('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftorProfileResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftorProfileMockHandler415 = (overrideResponse)=>{
    return http.put('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftorProfileResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftorProfileMockHandler422 = (overrideResponse)=>{
    return http.put('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftorProfileResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftorProfileMockHandler500 = (overrideResponse)=>{
    return http.put('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftorProfileResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftorProfileMockHandler501 = (overrideResponse)=>{
    return http.put('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftorProfileResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftorProfileMockHandler502 = (overrideResponse)=>{
    return http.put('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftorProfileResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftorProfileMockHandler503 = (overrideResponse)=>{
    return http.put('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftorProfileResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftorProfileMockHandler504 = (overrideResponse)=>{
    return http.put('*/api/gifting/profile', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftorProfileResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostGiftSubmissionMockHandler = (overrideResponse)=>{
    return http.post('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostGiftSubmissionResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostGiftSubmissionMockHandler200 = (overrideResponse)=>{
    return http.post('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostGiftSubmissionResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostGiftSubmissionMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostGiftSubmissionResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostGiftSubmissionMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostGiftSubmissionResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostGiftSubmissionMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostGiftSubmissionResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostGiftSubmissionMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostGiftSubmissionResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostGiftSubmissionMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostGiftSubmissionResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostGiftSubmissionMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostGiftSubmissionResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostGiftSubmissionMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostGiftSubmissionResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostGiftSubmissionMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostGiftSubmissionResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostGiftSubmissionMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostGiftSubmissionResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostGiftSubmissionMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostGiftSubmissionResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostGiftSubmissionMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostGiftSubmissionResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostGiftSubmissionMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostGiftSubmissionResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostGiftSubmissionMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostGiftSubmissionResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostGiftSubmissionMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostGiftSubmissionResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostGiftSubmissionMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostGiftSubmissionResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostGiftSubmissionMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostGiftSubmissionResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostGiftSubmissionMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostGiftSubmissionResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostGiftSubmissionMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostGiftSubmissionResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftSubmissionMockHandler = (overrideResponse)=>{
    return http.put('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftSubmissionResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftSubmissionMockHandler200 = (overrideResponse)=>{
    return http.put('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftSubmissionResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftSubmissionMockHandler400 = (overrideResponse)=>{
    return http.put('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftSubmissionResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftSubmissionMockHandler401 = (overrideResponse)=>{
    return http.put('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftSubmissionResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftSubmissionMockHandler403 = (overrideResponse)=>{
    return http.put('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftSubmissionResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftSubmissionMockHandler404 = (overrideResponse)=>{
    return http.put('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftSubmissionResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftSubmissionMockHandler405 = (overrideResponse)=>{
    return http.put('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftSubmissionResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftSubmissionMockHandler406 = (overrideResponse)=>{
    return http.put('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftSubmissionResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftSubmissionMockHandler408 = (overrideResponse)=>{
    return http.put('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftSubmissionResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftSubmissionMockHandler409 = (overrideResponse)=>{
    return http.put('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftSubmissionResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftSubmissionMockHandler410 = (overrideResponse)=>{
    return http.put('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftSubmissionResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftSubmissionMockHandler412 = (overrideResponse)=>{
    return http.put('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftSubmissionResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftSubmissionMockHandler413 = (overrideResponse)=>{
    return http.put('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftSubmissionResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftSubmissionMockHandler415 = (overrideResponse)=>{
    return http.put('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftSubmissionResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftSubmissionMockHandler422 = (overrideResponse)=>{
    return http.put('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftSubmissionResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftSubmissionMockHandler500 = (overrideResponse)=>{
    return http.put('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftSubmissionResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftSubmissionMockHandler501 = (overrideResponse)=>{
    return http.put('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftSubmissionResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftSubmissionMockHandler502 = (overrideResponse)=>{
    return http.put('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftSubmissionResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftSubmissionMockHandler503 = (overrideResponse)=>{
    return http.put('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftSubmissionResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutValidateGiftSubmissionMockHandler504 = (overrideResponse)=>{
    return http.put('*/api/gifting/:giftingId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutValidateGiftSubmissionResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetHealthMockHandler = ()=>{
    return http.get('*/api/health', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetHealthMockHandler200 = ()=>{
    return http.get('*/api/health', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoanAmortizationPdfMockHandler = (overrideResponse)=>{
    return http.get('*/api/loans/amortization/pdf', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoanAmortizationPdfResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoanAmortizationPdfMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/loans/amortization/pdf', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoanAmortizationPdfResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidTokenMockHandler = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidTokenResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidTokenMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidTokenResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidTokenMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidTokenResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidTokenMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidTokenResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidTokenMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidTokenResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidTokenMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidTokenResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidTokenMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidTokenResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidTokenMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidTokenResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidTokenMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidTokenResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidTokenMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidTokenResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidTokenMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidTokenResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidTokenMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidTokenResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidTokenMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidTokenResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidTokenMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidTokenResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidTokenMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidTokenResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidTokenMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidTokenResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidTokenMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidTokenResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidTokenMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidTokenResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidTokenMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidTokenResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidTokenMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidTokenResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteManagedAccountsPlaidLinksMockHandler = (overrideResponse)=>{
    return http.delete('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteManagedAccountsPlaidLinksResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteManagedAccountsPlaidLinksMockHandler200 = (overrideResponse)=>{
    return http.delete('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteManagedAccountsPlaidLinksResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteManagedAccountsPlaidLinksMockHandler400 = (overrideResponse)=>{
    return http.delete('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteManagedAccountsPlaidLinksResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteManagedAccountsPlaidLinksMockHandler401 = (overrideResponse)=>{
    return http.delete('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteManagedAccountsPlaidLinksResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteManagedAccountsPlaidLinksMockHandler403 = (overrideResponse)=>{
    return http.delete('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteManagedAccountsPlaidLinksResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteManagedAccountsPlaidLinksMockHandler404 = (overrideResponse)=>{
    return http.delete('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteManagedAccountsPlaidLinksResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteManagedAccountsPlaidLinksMockHandler405 = (overrideResponse)=>{
    return http.delete('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteManagedAccountsPlaidLinksResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteManagedAccountsPlaidLinksMockHandler406 = (overrideResponse)=>{
    return http.delete('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteManagedAccountsPlaidLinksResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteManagedAccountsPlaidLinksMockHandler408 = (overrideResponse)=>{
    return http.delete('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteManagedAccountsPlaidLinksResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteManagedAccountsPlaidLinksMockHandler409 = (overrideResponse)=>{
    return http.delete('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteManagedAccountsPlaidLinksResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteManagedAccountsPlaidLinksMockHandler410 = (overrideResponse)=>{
    return http.delete('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteManagedAccountsPlaidLinksResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteManagedAccountsPlaidLinksMockHandler412 = (overrideResponse)=>{
    return http.delete('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteManagedAccountsPlaidLinksResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteManagedAccountsPlaidLinksMockHandler413 = (overrideResponse)=>{
    return http.delete('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteManagedAccountsPlaidLinksResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteManagedAccountsPlaidLinksMockHandler415 = (overrideResponse)=>{
    return http.delete('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteManagedAccountsPlaidLinksResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteManagedAccountsPlaidLinksMockHandler422 = (overrideResponse)=>{
    return http.delete('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteManagedAccountsPlaidLinksResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteManagedAccountsPlaidLinksMockHandler500 = (overrideResponse)=>{
    return http.delete('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteManagedAccountsPlaidLinksResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteManagedAccountsPlaidLinksMockHandler501 = (overrideResponse)=>{
    return http.delete('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteManagedAccountsPlaidLinksResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteManagedAccountsPlaidLinksMockHandler502 = (overrideResponse)=>{
    return http.delete('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteManagedAccountsPlaidLinksResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteManagedAccountsPlaidLinksMockHandler503 = (overrideResponse)=>{
    return http.delete('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteManagedAccountsPlaidLinksResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteManagedAccountsPlaidLinksMockHandler504 = (overrideResponse)=>{
    return http.delete('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteManagedAccountsPlaidLinksResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidLinksMockHandler = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidLinksResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidLinksMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidLinksResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidLinksMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidLinksResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidLinksMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidLinksResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidLinksMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidLinksResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidLinksMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidLinksResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidLinksMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidLinksResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidLinksMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidLinksResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidLinksMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidLinksResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidLinksMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidLinksResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidLinksMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidLinksResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidLinksMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidLinksResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidLinksMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidLinksResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidLinksMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidLinksResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidLinksMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidLinksResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidLinksMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidLinksResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidLinksMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidLinksResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidLinksMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidLinksResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidLinksMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidLinksResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidLinksMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidLinksResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidLinksMockHandler = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidLinksResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidLinksMockHandler200 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidLinksResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidLinksMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidLinksResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidLinksMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidLinksResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidLinksMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidLinksResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidLinksMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidLinksResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidLinksMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidLinksResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidLinksMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidLinksResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidLinksMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidLinksResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidLinksMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidLinksResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidLinksMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidLinksResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidLinksMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidLinksResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidLinksMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidLinksResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidLinksMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidLinksResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidLinksMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidLinksResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidLinksMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidLinksResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidLinksMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidLinksResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidLinksMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidLinksResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidLinksMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidLinksResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidLinksMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidLinksResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidBalancesMockHandler = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links/balance/get', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidBalancesResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidBalancesMockHandler200 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links/balance/get', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidBalancesResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidBalancesMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links/balance/get', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidBalancesResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidBalancesMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links/balance/get', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidBalancesResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidBalancesMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links/balance/get', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidBalancesResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidBalancesMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links/balance/get', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidBalancesResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidBalancesMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links/balance/get', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidBalancesResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidBalancesMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links/balance/get', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidBalancesResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidBalancesMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links/balance/get', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidBalancesResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidBalancesMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links/balance/get', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidBalancesResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidBalancesMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links/balance/get', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidBalancesResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidBalancesMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links/balance/get', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidBalancesResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidBalancesMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links/balance/get', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidBalancesResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidBalancesMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links/balance/get', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidBalancesResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidBalancesMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links/balance/get', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidBalancesResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidBalancesMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links/balance/get', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidBalancesResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidBalancesMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links/balance/get', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidBalancesResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidBalancesMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links/balance/get', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidBalancesResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidBalancesMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links/balance/get', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidBalancesResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidBalancesMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links/balance/get', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidBalancesResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingMockHandler = (overrideResponse)=>{
    return http.get('*/api/midYearTesting', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingCensusRecordMockHandler = (overrideResponse)=>{
    return http.get('*/api/midYearTesting/censusRecord', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingCensusRecordResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingCensusRecordMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting/censusRecord', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingCensusRecordResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingCensusRecordMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting/censusRecord', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingCensusRecordResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingCensusRecordMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting/censusRecord', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingCensusRecordResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingCensusRecordMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting/censusRecord', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingCensusRecordResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingCensusRecordMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting/censusRecord', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingCensusRecordResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingCensusRecordMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting/censusRecord', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingCensusRecordResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingCensusRecordMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting/censusRecord', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingCensusRecordResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingCensusRecordMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting/censusRecord', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingCensusRecordResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingCensusRecordMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting/censusRecord', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingCensusRecordResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingCensusRecordMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting/censusRecord', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingCensusRecordResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingCensusRecordMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting/censusRecord', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingCensusRecordResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingCensusRecordMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting/censusRecord', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingCensusRecordResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingCensusRecordMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting/censusRecord', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingCensusRecordResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingCensusRecordMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting/censusRecord', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingCensusRecordResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingCensusRecordMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting/censusRecord', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingCensusRecordResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingCensusRecordMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting/censusRecord', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingCensusRecordResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingCensusRecordMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting/censusRecord', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingCensusRecordResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingCensusRecordMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting/censusRecord', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingCensusRecordResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMidYearTestingCensusRecordMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/midYearTesting/censusRecord', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMidYearTestingCensusRecordResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccounts401kManagerQuestionnaireMockHandler = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/401k-manager-questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccounts401kManagerQuestionnaireResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccounts401kManagerQuestionnaireMockHandler200 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/401k-manager-questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccounts401kManagerQuestionnaireResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccounts401kManagerQuestionnaireMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/401k-manager-questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccounts401kManagerQuestionnaireResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccounts401kManagerQuestionnaireMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/401k-manager-questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccounts401kManagerQuestionnaireResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccounts401kManagerQuestionnaireMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/401k-manager-questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccounts401kManagerQuestionnaireResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccounts401kManagerQuestionnaireMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/401k-manager-questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccounts401kManagerQuestionnaireResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccounts401kManagerQuestionnaireMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/401k-manager-questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccounts401kManagerQuestionnaireResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccounts401kManagerQuestionnaireMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/401k-manager-questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccounts401kManagerQuestionnaireResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccounts401kManagerQuestionnaireMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/401k-manager-questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccounts401kManagerQuestionnaireResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccounts401kManagerQuestionnaireMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/401k-manager-questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccounts401kManagerQuestionnaireResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccounts401kManagerQuestionnaireMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/401k-manager-questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccounts401kManagerQuestionnaireResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccounts401kManagerQuestionnaireMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/401k-manager-questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccounts401kManagerQuestionnaireResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccounts401kManagerQuestionnaireMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/401k-manager-questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccounts401kManagerQuestionnaireResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccounts401kManagerQuestionnaireMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/401k-manager-questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccounts401kManagerQuestionnaireResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccounts401kManagerQuestionnaireMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/401k-manager-questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccounts401kManagerQuestionnaireResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccounts401kManagerQuestionnaireMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/401k-manager-questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccounts401kManagerQuestionnaireResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccounts401kManagerQuestionnaireMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/401k-manager-questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccounts401kManagerQuestionnaireResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccounts401kManagerQuestionnaireMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/401k-manager-questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccounts401kManagerQuestionnaireResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccounts401kManagerQuestionnaireMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/401k-manager-questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccounts401kManagerQuestionnaireResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccounts401kManagerQuestionnaireMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/401k-manager-questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccounts401kManagerQuestionnaireResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsActivateMockHandler = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/activate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsActivateResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsActivateMockHandler200 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/activate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsActivateResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsActivateMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/activate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsActivateResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsActivateMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/activate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsActivateResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsActivateMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/activate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsActivateResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsActivateMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/activate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsActivateResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsActivateMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/activate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsActivateResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsActivateMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/activate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsActivateResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsActivateMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/activate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsActivateResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsActivateMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/activate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsActivateResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsActivateMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/activate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsActivateResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsActivateMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/activate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsActivateResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsActivateMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/activate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsActivateResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsActivateMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/activate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsActivateResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsActivateMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/activate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsActivateResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsActivateMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/activate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsActivateResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsActivateMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/activate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsActivateResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsActivateMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/activate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsActivateResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsActivateMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/activate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsActivateResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsActivateMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/activate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsActivateResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsDeactivateMockHandler = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/deactivate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsDeactivateResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsDeactivateMockHandler200 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/deactivate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsDeactivateResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsDeactivateMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/deactivate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsDeactivateResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsDeactivateMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/deactivate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsDeactivateResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsDeactivateMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/deactivate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsDeactivateResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsDeactivateMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/deactivate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsDeactivateResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsDeactivateMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/deactivate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsDeactivateResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsDeactivateMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/deactivate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsDeactivateResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsDeactivateMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/deactivate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsDeactivateResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsDeactivateMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/deactivate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsDeactivateResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsDeactivateMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/deactivate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsDeactivateResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsDeactivateMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/deactivate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsDeactivateResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsDeactivateMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/deactivate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsDeactivateResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsDeactivateMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/deactivate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsDeactivateResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsDeactivateMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/deactivate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsDeactivateResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsDeactivateMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/deactivate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsDeactivateResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsDeactivateMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/deactivate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsDeactivateResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsDeactivateMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/deactivate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsDeactivateResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsDeactivateMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/deactivate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsDeactivateResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsDeactivateMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/deactivate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsDeactivateResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMsManagedAccountsPreviewAllocationMockHandler = (overrideResponse)=>{
    return http.get('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMsManagedAccountsPreviewAllocationResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMsManagedAccountsPreviewAllocationMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMsManagedAccountsPreviewAllocationResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMsManagedAccountsPreviewAllocationMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMsManagedAccountsPreviewAllocationResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMsManagedAccountsPreviewAllocationMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMsManagedAccountsPreviewAllocationResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMsManagedAccountsPreviewAllocationMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMsManagedAccountsPreviewAllocationResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMsManagedAccountsPreviewAllocationMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMsManagedAccountsPreviewAllocationResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMsManagedAccountsPreviewAllocationMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMsManagedAccountsPreviewAllocationResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMsManagedAccountsPreviewAllocationMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMsManagedAccountsPreviewAllocationResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMsManagedAccountsPreviewAllocationMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMsManagedAccountsPreviewAllocationResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMsManagedAccountsPreviewAllocationMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMsManagedAccountsPreviewAllocationResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMsManagedAccountsPreviewAllocationMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMsManagedAccountsPreviewAllocationResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMsManagedAccountsPreviewAllocationMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMsManagedAccountsPreviewAllocationResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMsManagedAccountsPreviewAllocationMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMsManagedAccountsPreviewAllocationResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMsManagedAccountsPreviewAllocationMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMsManagedAccountsPreviewAllocationResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMsManagedAccountsPreviewAllocationMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMsManagedAccountsPreviewAllocationResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMsManagedAccountsPreviewAllocationMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMsManagedAccountsPreviewAllocationResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMsManagedAccountsPreviewAllocationMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMsManagedAccountsPreviewAllocationResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMsManagedAccountsPreviewAllocationMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMsManagedAccountsPreviewAllocationResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMsManagedAccountsPreviewAllocationMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMsManagedAccountsPreviewAllocationResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMsManagedAccountsPreviewAllocationMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMsManagedAccountsPreviewAllocationResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsPreviewAllocationMockHandler = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsPreviewAllocationResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsPreviewAllocationMockHandler200 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsPreviewAllocationResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsPreviewAllocationMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsPreviewAllocationResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsPreviewAllocationMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsPreviewAllocationResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsPreviewAllocationMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsPreviewAllocationResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsPreviewAllocationMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsPreviewAllocationResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsPreviewAllocationMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsPreviewAllocationResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsPreviewAllocationMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsPreviewAllocationResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsPreviewAllocationMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsPreviewAllocationResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsPreviewAllocationMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsPreviewAllocationResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsPreviewAllocationMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsPreviewAllocationResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsPreviewAllocationMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsPreviewAllocationResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsPreviewAllocationMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsPreviewAllocationResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsPreviewAllocationMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsPreviewAllocationResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsPreviewAllocationMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsPreviewAllocationResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsPreviewAllocationMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsPreviewAllocationResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsPreviewAllocationMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsPreviewAllocationResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsPreviewAllocationMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsPreviewAllocationResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsPreviewAllocationMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsPreviewAllocationResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMsManagedAccountsPreviewAllocationMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/ms-managed-accounts/preview-allocation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMsManagedAccountsPreviewAllocationResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDigitalOnboardingStateMockHandler = (overrideResponse)=>{
    return http.get('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDigitalOnboardingStateResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDigitalOnboardingStateMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDigitalOnboardingStateResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDigitalOnboardingStateMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDigitalOnboardingStateResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDigitalOnboardingStateMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDigitalOnboardingStateResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDigitalOnboardingStateMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDigitalOnboardingStateResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDigitalOnboardingStateMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDigitalOnboardingStateResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDigitalOnboardingStateMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDigitalOnboardingStateResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDigitalOnboardingStateMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDigitalOnboardingStateResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDigitalOnboardingStateMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDigitalOnboardingStateResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDigitalOnboardingStateMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDigitalOnboardingStateResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDigitalOnboardingStateMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDigitalOnboardingStateResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDigitalOnboardingStateMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDigitalOnboardingStateResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDigitalOnboardingStateMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDigitalOnboardingStateResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDigitalOnboardingStateMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDigitalOnboardingStateResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDigitalOnboardingStateMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDigitalOnboardingStateResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDigitalOnboardingStateMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDigitalOnboardingStateResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDigitalOnboardingStateMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDigitalOnboardingStateResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDigitalOnboardingStateMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDigitalOnboardingStateResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDigitalOnboardingStateMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDigitalOnboardingStateResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDigitalOnboardingStateMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDigitalOnboardingStateResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDigitalOnboardingStateMockHandler = ()=>{
    return http.patch('*/api/onboarding/digital', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDigitalOnboardingStateMockHandler200 = ()=>{
    return http.patch('*/api/onboarding/digital', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDigitalOnboardingStateMockHandler400 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchDigitalOnboardingStateResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDigitalOnboardingStateMockHandler401 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchDigitalOnboardingStateResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDigitalOnboardingStateMockHandler403 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchDigitalOnboardingStateResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDigitalOnboardingStateMockHandler404 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchDigitalOnboardingStateResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDigitalOnboardingStateMockHandler405 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchDigitalOnboardingStateResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDigitalOnboardingStateMockHandler406 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchDigitalOnboardingStateResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDigitalOnboardingStateMockHandler408 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchDigitalOnboardingStateResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDigitalOnboardingStateMockHandler409 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchDigitalOnboardingStateResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDigitalOnboardingStateMockHandler410 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchDigitalOnboardingStateResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDigitalOnboardingStateMockHandler412 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchDigitalOnboardingStateResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDigitalOnboardingStateMockHandler413 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchDigitalOnboardingStateResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDigitalOnboardingStateMockHandler415 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchDigitalOnboardingStateResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDigitalOnboardingStateMockHandler422 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchDigitalOnboardingStateResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDigitalOnboardingStateMockHandler500 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchDigitalOnboardingStateResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDigitalOnboardingStateMockHandler501 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchDigitalOnboardingStateResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDigitalOnboardingStateMockHandler502 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchDigitalOnboardingStateResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDigitalOnboardingStateMockHandler503 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchDigitalOnboardingStateResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDigitalOnboardingStateMockHandler504 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchDigitalOnboardingStateResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutDigitalOnboardingStateMockHandler = ()=>{
    return http.put('*/api/onboarding/digital', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutDigitalOnboardingStateMockHandler200 = ()=>{
    return http.put('*/api/onboarding/digital', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutDigitalOnboardingStateMockHandler400 = (overrideResponse)=>{
    return http.put('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutDigitalOnboardingStateResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutDigitalOnboardingStateMockHandler401 = (overrideResponse)=>{
    return http.put('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutDigitalOnboardingStateResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutDigitalOnboardingStateMockHandler403 = (overrideResponse)=>{
    return http.put('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutDigitalOnboardingStateResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutDigitalOnboardingStateMockHandler404 = (overrideResponse)=>{
    return http.put('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutDigitalOnboardingStateResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutDigitalOnboardingStateMockHandler405 = (overrideResponse)=>{
    return http.put('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutDigitalOnboardingStateResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutDigitalOnboardingStateMockHandler406 = (overrideResponse)=>{
    return http.put('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutDigitalOnboardingStateResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutDigitalOnboardingStateMockHandler408 = (overrideResponse)=>{
    return http.put('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutDigitalOnboardingStateResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutDigitalOnboardingStateMockHandler409 = (overrideResponse)=>{
    return http.put('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutDigitalOnboardingStateResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutDigitalOnboardingStateMockHandler410 = (overrideResponse)=>{
    return http.put('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutDigitalOnboardingStateResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutDigitalOnboardingStateMockHandler412 = (overrideResponse)=>{
    return http.put('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutDigitalOnboardingStateResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutDigitalOnboardingStateMockHandler413 = (overrideResponse)=>{
    return http.put('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutDigitalOnboardingStateResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutDigitalOnboardingStateMockHandler415 = (overrideResponse)=>{
    return http.put('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutDigitalOnboardingStateResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutDigitalOnboardingStateMockHandler422 = (overrideResponse)=>{
    return http.put('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutDigitalOnboardingStateResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutDigitalOnboardingStateMockHandler500 = (overrideResponse)=>{
    return http.put('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutDigitalOnboardingStateResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutDigitalOnboardingStateMockHandler501 = (overrideResponse)=>{
    return http.put('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutDigitalOnboardingStateResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutDigitalOnboardingStateMockHandler502 = (overrideResponse)=>{
    return http.put('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutDigitalOnboardingStateResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutDigitalOnboardingStateMockHandler503 = (overrideResponse)=>{
    return http.put('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutDigitalOnboardingStateResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutDigitalOnboardingStateMockHandler504 = (overrideResponse)=>{
    return http.put('*/api/onboarding/digital', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutDigitalOnboardingStateResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchStatefulSchemaTrackingStatusMockHandler = ()=>{
    return http.patch('*/api/onboarding/stateful-schema-tracking/:schemaType/status', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchStatefulSchemaTrackingStatusMockHandler200 = ()=>{
    return http.patch('*/api/onboarding/stateful-schema-tracking/:schemaType/status', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchStatefulSchemaTrackingStatusMockHandler400 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/stateful-schema-tracking/:schemaType/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchStatefulSchemaTrackingStatusResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchStatefulSchemaTrackingStatusMockHandler401 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/stateful-schema-tracking/:schemaType/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchStatefulSchemaTrackingStatusResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchStatefulSchemaTrackingStatusMockHandler403 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/stateful-schema-tracking/:schemaType/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchStatefulSchemaTrackingStatusResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchStatefulSchemaTrackingStatusMockHandler404 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/stateful-schema-tracking/:schemaType/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchStatefulSchemaTrackingStatusResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchStatefulSchemaTrackingStatusMockHandler405 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/stateful-schema-tracking/:schemaType/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchStatefulSchemaTrackingStatusResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchStatefulSchemaTrackingStatusMockHandler406 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/stateful-schema-tracking/:schemaType/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchStatefulSchemaTrackingStatusResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchStatefulSchemaTrackingStatusMockHandler408 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/stateful-schema-tracking/:schemaType/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchStatefulSchemaTrackingStatusResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchStatefulSchemaTrackingStatusMockHandler409 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/stateful-schema-tracking/:schemaType/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchStatefulSchemaTrackingStatusResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchStatefulSchemaTrackingStatusMockHandler410 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/stateful-schema-tracking/:schemaType/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchStatefulSchemaTrackingStatusResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchStatefulSchemaTrackingStatusMockHandler412 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/stateful-schema-tracking/:schemaType/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchStatefulSchemaTrackingStatusResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchStatefulSchemaTrackingStatusMockHandler413 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/stateful-schema-tracking/:schemaType/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchStatefulSchemaTrackingStatusResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchStatefulSchemaTrackingStatusMockHandler415 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/stateful-schema-tracking/:schemaType/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchStatefulSchemaTrackingStatusResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchStatefulSchemaTrackingStatusMockHandler422 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/stateful-schema-tracking/:schemaType/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchStatefulSchemaTrackingStatusResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchStatefulSchemaTrackingStatusMockHandler500 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/stateful-schema-tracking/:schemaType/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchStatefulSchemaTrackingStatusResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchStatefulSchemaTrackingStatusMockHandler501 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/stateful-schema-tracking/:schemaType/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchStatefulSchemaTrackingStatusResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchStatefulSchemaTrackingStatusMockHandler502 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/stateful-schema-tracking/:schemaType/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchStatefulSchemaTrackingStatusResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchStatefulSchemaTrackingStatusMockHandler503 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/stateful-schema-tracking/:schemaType/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchStatefulSchemaTrackingStatusResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchStatefulSchemaTrackingStatusMockHandler504 = (overrideResponse)=>{
    return http.patch('*/api/onboarding/stateful-schema-tracking/:schemaType/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchStatefulSchemaTrackingStatusResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantByIdMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantByIdResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantByIdMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantByIdResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantByIdMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantByIdResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantByIdMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantByIdResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantByIdMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantByIdResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantByIdMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantByIdResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantByIdMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantByIdResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantByIdMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantByIdResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantByIdMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantByIdResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantByIdMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantByIdResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantByIdMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantByIdResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantByIdMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantByIdResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantByIdMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantByIdResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantByIdMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantByIdResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantByIdMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantByIdResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantByIdMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantByIdResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantByIdMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantByIdResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantByIdMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantByIdResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantByIdMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantByIdResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantByIdMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantByIdResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountBalanceByIdMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/account-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountBalanceByIdResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountBalanceByIdMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/account-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountBalanceByIdResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountBalanceByIdMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/account-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountBalanceByIdResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountBalanceByIdMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/account-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountBalanceByIdResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountBalanceByIdMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/account-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountBalanceByIdResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountBalanceByIdMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/account-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountBalanceByIdResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountBalanceByIdMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/account-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountBalanceByIdResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountBalanceByIdMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/account-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountBalanceByIdResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountBalanceByIdMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/account-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountBalanceByIdResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountBalanceByIdMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/account-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountBalanceByIdResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountBalanceByIdMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/account-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountBalanceByIdResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountBalanceByIdMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/account-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountBalanceByIdResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountBalanceByIdMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/account-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountBalanceByIdResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountBalanceByIdMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/account-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountBalanceByIdResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountBalanceByIdMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/account-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountBalanceByIdResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountBalanceByIdMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/account-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountBalanceByIdResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountBalanceByIdMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/account-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountBalanceByIdResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountBalanceByIdMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/account-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountBalanceByIdResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountBalanceByIdMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/account-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountBalanceByIdResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountBalanceByIdMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/account-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountBalanceByIdResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantLoanMockHandler = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantLoanResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantLoanMockHandler200 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantLoanResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantLoanMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantLoanResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantLoanMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantLoanResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantLoanMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantLoanResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantLoanMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantLoanResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantLoanMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantLoanResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantLoanMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantLoanResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantLoanMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantLoanResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantLoanMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantLoanResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantLoanMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantLoanResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantLoanMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantLoanResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantLoanMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantLoanResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantLoanMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantLoanResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantLoanMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantLoanResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantLoanMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantLoanResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantLoanMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantLoanResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantLoanMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantLoanResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantLoanMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantLoanResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantLoanMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantLoanResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinkTokenMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinkTokenResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinkTokenMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinkTokenResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinkTokenMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinkTokenResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinkTokenMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinkTokenResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinkTokenMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinkTokenResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinkTokenMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinkTokenResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinkTokenMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinkTokenResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinkTokenMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinkTokenResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinkTokenMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinkTokenResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinkTokenMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinkTokenResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinkTokenMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinkTokenResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinkTokenMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinkTokenResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinkTokenMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinkTokenResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinkTokenMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinkTokenResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinkTokenMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinkTokenResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinkTokenMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinkTokenResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinkTokenMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinkTokenResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinkTokenMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinkTokenResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinkTokenMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinkTokenResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinkTokenMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-link-token', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinkTokenResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinksMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinksResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinksMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinksResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinksMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinksResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinksMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinksResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinksMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinksResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinksMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinksResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinksMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinksResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinksMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinksResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinksMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinksResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinksMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinksResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinksMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinksResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinksMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinksResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinksMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinksResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinksMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinksResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinksMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinksResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinksMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinksResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinksMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinksResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinksMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinksResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinksMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinksResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinksMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinksResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksMockHandler = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksMockHandler200 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans/plaid-links', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantLoanCreateMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantLoanCreateResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantLoanCreateMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantLoanCreateResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantLoanCreateMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantLoanCreateResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantLoanCreateMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantLoanCreateResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantLoanCreateMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantLoanCreateResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantLoanCreateMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantLoanCreateResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantLoanCreateMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantLoanCreateResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantLoanCreateMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantLoanCreateResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantLoanCreateMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantLoanCreateResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantLoanCreateMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantLoanCreateResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantLoanCreateMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantLoanCreateResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantLoanCreateMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantLoanCreateResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantLoanCreateMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantLoanCreateResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantLoanCreateMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantLoanCreateResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantLoanCreateMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantLoanCreateResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantLoanCreateMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantLoanCreateResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantLoanCreateMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantLoanCreateResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantLoanCreateMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantLoanCreateResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantLoanCreateMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantLoanCreateResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantLoanCreateMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantLoanCreateResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantLoanMockHandler = ()=>{
    return http.patch('*/api/participant/account/loans/:loanId', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantLoanMockHandler200 = ()=>{
    return http.patch('*/api/participant/account/loans/:loanId', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLoanManualRepaymentMockHandler = ()=>{
    return http.post('*/api/participant/account/loans/:loanId/payment', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLoanManualRepaymentMockHandler201 = ()=>{
    return http.post('*/api/participant/account/loans/:loanId/payment', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountsMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBalanceOverTimeMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBalanceOverTimeResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBalanceOverTimeMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBalanceOverTimeResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBalanceOverTimeMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBalanceOverTimeResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBalanceOverTimeMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBalanceOverTimeResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBalanceOverTimeMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBalanceOverTimeResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBalanceOverTimeMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBalanceOverTimeResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBalanceOverTimeMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBalanceOverTimeResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBalanceOverTimeMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBalanceOverTimeResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBalanceOverTimeMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBalanceOverTimeResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBalanceOverTimeMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBalanceOverTimeResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBalanceOverTimeMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBalanceOverTimeResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBalanceOverTimeMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBalanceOverTimeResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBalanceOverTimeMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBalanceOverTimeResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBalanceOverTimeMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBalanceOverTimeResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBalanceOverTimeMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBalanceOverTimeResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBalanceOverTimeMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBalanceOverTimeResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBalanceOverTimeMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBalanceOverTimeResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBalanceOverTimeMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBalanceOverTimeResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBalanceOverTimeMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBalanceOverTimeResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBalanceOverTimeMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/balance-over-time', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBalanceOverTimeResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutArchiveBankAccountMockHandler = ()=>{
    return http.put('*/api/participant/bank-account/:bankAccountId/archive', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutArchiveBankAccountMockHandler200 = ()=>{
    return http.put('*/api/participant/bank-account/:bankAccountId/archive', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutArchiveBankAccountMockHandler400 = (overrideResponse)=>{
    return http.put('*/api/participant/bank-account/:bankAccountId/archive', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutArchiveBankAccountResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutArchiveBankAccountMockHandler401 = (overrideResponse)=>{
    return http.put('*/api/participant/bank-account/:bankAccountId/archive', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutArchiveBankAccountResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutArchiveBankAccountMockHandler403 = (overrideResponse)=>{
    return http.put('*/api/participant/bank-account/:bankAccountId/archive', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutArchiveBankAccountResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutArchiveBankAccountMockHandler404 = (overrideResponse)=>{
    return http.put('*/api/participant/bank-account/:bankAccountId/archive', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutArchiveBankAccountResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutArchiveBankAccountMockHandler405 = (overrideResponse)=>{
    return http.put('*/api/participant/bank-account/:bankAccountId/archive', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutArchiveBankAccountResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutArchiveBankAccountMockHandler406 = (overrideResponse)=>{
    return http.put('*/api/participant/bank-account/:bankAccountId/archive', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutArchiveBankAccountResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutArchiveBankAccountMockHandler408 = (overrideResponse)=>{
    return http.put('*/api/participant/bank-account/:bankAccountId/archive', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutArchiveBankAccountResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutArchiveBankAccountMockHandler409 = (overrideResponse)=>{
    return http.put('*/api/participant/bank-account/:bankAccountId/archive', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutArchiveBankAccountResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutArchiveBankAccountMockHandler410 = (overrideResponse)=>{
    return http.put('*/api/participant/bank-account/:bankAccountId/archive', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutArchiveBankAccountResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutArchiveBankAccountMockHandler412 = (overrideResponse)=>{
    return http.put('*/api/participant/bank-account/:bankAccountId/archive', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutArchiveBankAccountResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutArchiveBankAccountMockHandler413 = (overrideResponse)=>{
    return http.put('*/api/participant/bank-account/:bankAccountId/archive', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutArchiveBankAccountResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutArchiveBankAccountMockHandler415 = (overrideResponse)=>{
    return http.put('*/api/participant/bank-account/:bankAccountId/archive', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutArchiveBankAccountResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutArchiveBankAccountMockHandler422 = (overrideResponse)=>{
    return http.put('*/api/participant/bank-account/:bankAccountId/archive', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutArchiveBankAccountResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutArchiveBankAccountMockHandler500 = (overrideResponse)=>{
    return http.put('*/api/participant/bank-account/:bankAccountId/archive', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutArchiveBankAccountResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutArchiveBankAccountMockHandler501 = (overrideResponse)=>{
    return http.put('*/api/participant/bank-account/:bankAccountId/archive', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutArchiveBankAccountResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutArchiveBankAccountMockHandler502 = (overrideResponse)=>{
    return http.put('*/api/participant/bank-account/:bankAccountId/archive', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutArchiveBankAccountResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutArchiveBankAccountMockHandler503 = (overrideResponse)=>{
    return http.put('*/api/participant/bank-account/:bankAccountId/archive', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutArchiveBankAccountResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutArchiveBankAccountMockHandler504 = (overrideResponse)=>{
    return http.put('*/api/participant/bank-account/:bankAccountId/archive', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutArchiveBankAccountResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBankAccountsMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/bank-accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBankAccountsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBankAccountsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/bank-accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBankAccountsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBankAccountsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/bank-accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBankAccountsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBankAccountsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/bank-accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBankAccountsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBankAccountsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/bank-accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBankAccountsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBankAccountsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/bank-accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBankAccountsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBankAccountsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/bank-accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBankAccountsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBankAccountsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/bank-accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBankAccountsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBankAccountsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/bank-accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBankAccountsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBankAccountsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/bank-accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBankAccountsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBankAccountsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/bank-accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBankAccountsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBankAccountsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/bank-accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBankAccountsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBankAccountsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/bank-accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBankAccountsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBankAccountsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/bank-accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBankAccountsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBankAccountsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/bank-accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBankAccountsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBankAccountsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/bank-accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBankAccountsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBankAccountsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/bank-accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBankAccountsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBankAccountsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/bank-accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBankAccountsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBankAccountsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/bank-accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBankAccountsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBankAccountsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/bank-accounts', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBankAccountsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantDepositsMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantDepositsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantDepositsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantDepositsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantDepositsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantDepositsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantDepositsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantDepositsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantDepositsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantDepositsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantDepositsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantDepositsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantDepositsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantDepositsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantDepositsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantDepositsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantDepositsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantDepositsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantDepositsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantDepositsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantDepositsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantDepositsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantDepositsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantDepositsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantDepositsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantDepositsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantDepositsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantDepositsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantDepositsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantDepositsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantDepositsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantDepositsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantDepositsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantDepositsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantDepositsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantDepositsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantDepositsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantDepositsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantDepositsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantDepositsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDepositDataMockHandler = ()=>{
    return http.post('*/api/participant/deposit', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDepositDataMockHandler200 = ()=>{
    return http.post('*/api/participant/deposit', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDepositDataMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDepositDataResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDepositDataMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDepositDataResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDepositDataMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDepositDataResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDepositDataMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDepositDataResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDepositDataMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDepositDataResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDepositDataMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDepositDataResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDepositDataMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDepositDataResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDepositDataMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDepositDataResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDepositDataMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDepositDataResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDepositDataMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDepositDataResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDepositDataMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDepositDataResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDepositDataMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDepositDataResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDepositDataMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDepositDataResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDepositDataMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDepositDataResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDepositDataMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDepositDataResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDepositDataMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDepositDataResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDepositDataMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDepositDataResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDepositDataMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/participant/deposit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostDepositDataResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRecurringSchedulesMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRecurringSchedulesResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRecurringSchedulesMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRecurringSchedulesResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRecurringSchedulesMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRecurringSchedulesResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRecurringSchedulesMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRecurringSchedulesResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRecurringSchedulesMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRecurringSchedulesResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRecurringSchedulesMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRecurringSchedulesResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRecurringSchedulesMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRecurringSchedulesResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRecurringSchedulesMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRecurringSchedulesResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRecurringSchedulesMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRecurringSchedulesResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRecurringSchedulesMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRecurringSchedulesResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRecurringSchedulesMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRecurringSchedulesResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRecurringSchedulesMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRecurringSchedulesResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRecurringSchedulesMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRecurringSchedulesResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRecurringSchedulesMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRecurringSchedulesResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRecurringSchedulesMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRecurringSchedulesResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRecurringSchedulesMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRecurringSchedulesResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRecurringSchedulesMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRecurringSchedulesResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRecurringSchedulesMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRecurringSchedulesResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRecurringSchedulesMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRecurringSchedulesResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRecurringSchedulesMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRecurringSchedulesResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRecurringScheduleMockHandler = (overrideResponse)=>{
    return http.put('*/api/participant/deposit/schedule/:recurringScheduleId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRecurringScheduleResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRecurringScheduleMockHandler200 = (overrideResponse)=>{
    return http.put('*/api/participant/deposit/schedule/:recurringScheduleId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRecurringScheduleResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRecurringScheduleMockHandler400 = (overrideResponse)=>{
    return http.put('*/api/participant/deposit/schedule/:recurringScheduleId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRecurringScheduleResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRecurringScheduleMockHandler401 = (overrideResponse)=>{
    return http.put('*/api/participant/deposit/schedule/:recurringScheduleId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRecurringScheduleResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRecurringScheduleMockHandler403 = (overrideResponse)=>{
    return http.put('*/api/participant/deposit/schedule/:recurringScheduleId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRecurringScheduleResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRecurringScheduleMockHandler404 = (overrideResponse)=>{
    return http.put('*/api/participant/deposit/schedule/:recurringScheduleId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRecurringScheduleResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRecurringScheduleMockHandler405 = (overrideResponse)=>{
    return http.put('*/api/participant/deposit/schedule/:recurringScheduleId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRecurringScheduleResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRecurringScheduleMockHandler406 = (overrideResponse)=>{
    return http.put('*/api/participant/deposit/schedule/:recurringScheduleId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRecurringScheduleResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRecurringScheduleMockHandler408 = (overrideResponse)=>{
    return http.put('*/api/participant/deposit/schedule/:recurringScheduleId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRecurringScheduleResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRecurringScheduleMockHandler409 = (overrideResponse)=>{
    return http.put('*/api/participant/deposit/schedule/:recurringScheduleId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRecurringScheduleResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRecurringScheduleMockHandler410 = (overrideResponse)=>{
    return http.put('*/api/participant/deposit/schedule/:recurringScheduleId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRecurringScheduleResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRecurringScheduleMockHandler412 = (overrideResponse)=>{
    return http.put('*/api/participant/deposit/schedule/:recurringScheduleId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRecurringScheduleResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRecurringScheduleMockHandler413 = (overrideResponse)=>{
    return http.put('*/api/participant/deposit/schedule/:recurringScheduleId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRecurringScheduleResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRecurringScheduleMockHandler415 = (overrideResponse)=>{
    return http.put('*/api/participant/deposit/schedule/:recurringScheduleId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRecurringScheduleResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRecurringScheduleMockHandler422 = (overrideResponse)=>{
    return http.put('*/api/participant/deposit/schedule/:recurringScheduleId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRecurringScheduleResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRecurringScheduleMockHandler500 = (overrideResponse)=>{
    return http.put('*/api/participant/deposit/schedule/:recurringScheduleId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRecurringScheduleResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRecurringScheduleMockHandler501 = (overrideResponse)=>{
    return http.put('*/api/participant/deposit/schedule/:recurringScheduleId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRecurringScheduleResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRecurringScheduleMockHandler502 = (overrideResponse)=>{
    return http.put('*/api/participant/deposit/schedule/:recurringScheduleId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRecurringScheduleResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRecurringScheduleMockHandler503 = (overrideResponse)=>{
    return http.put('*/api/participant/deposit/schedule/:recurringScheduleId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRecurringScheduleResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRecurringScheduleMockHandler504 = (overrideResponse)=>{
    return http.put('*/api/participant/deposit/schedule/:recurringScheduleId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRecurringScheduleResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDepositMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/:depositId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDepositResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDepositMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/:depositId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDepositResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDepositMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/:depositId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDepositResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDepositMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/:depositId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDepositResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDepositMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/:depositId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDepositResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDepositMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/:depositId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDepositResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDepositMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/:depositId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDepositResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDepositMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/:depositId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDepositResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDepositMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/:depositId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDepositResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDepositMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/:depositId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDepositResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDepositMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/:depositId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDepositResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDepositMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/:depositId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDepositResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDepositMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/:depositId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDepositResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDepositMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/:depositId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDepositResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDepositMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/:depositId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDepositResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDepositMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/:depositId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDepositResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDepositMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/:depositId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDepositResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDepositMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/:depositId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDepositResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDepositMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/:depositId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDepositResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDepositMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/deposit/:depositId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDepositResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRecentParticipantDocumentsMockHandler = ()=>{
    return http.get('*/api/participant/documents/recent', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRecentParticipantDocumentsMockHandler200 = ()=>{
    return http.get('*/api/participant/documents/recent', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantEligibilityMockHandler = ()=>{
    return http.post('*/api/participant/eligibility', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantEligibilityMockHandler200 = ()=>{
    return http.post('*/api/participant/eligibility', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantEligibilityMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/participant/eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantEligibilityResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantEligibilityMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/participant/eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantEligibilityResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantEligibilityMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/participant/eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantEligibilityResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantEligibilityMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/participant/eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantEligibilityResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantEligibilityMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/participant/eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantEligibilityResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantEligibilityMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/participant/eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantEligibilityResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantEligibilityMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/participant/eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantEligibilityResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantEligibilityMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/participant/eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantEligibilityResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantEligibilityMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/participant/eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantEligibilityResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantEligibilityMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/participant/eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantEligibilityResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantEligibilityMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/participant/eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantEligibilityResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantEligibilityMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/participant/eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantEligibilityResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantEligibilityMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/participant/eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantEligibilityResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantEligibilityMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/participant/eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantEligibilityResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantEligibilityMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/participant/eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantEligibilityResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantEligibilityMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/participant/eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantEligibilityResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantEligibilityMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/participant/eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantEligibilityResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantEligibilityMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/participant/eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantEligibilityResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEsaGoalMockHandler = ()=>{
    return http.post('*/api/participant/esa/goal', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEsaGoalMockHandler200 = ()=>{
    return http.post('*/api/participant/esa/goal', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEsaGoalMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/participant/esa/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEsaGoalResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEsaGoalMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/participant/esa/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEsaGoalResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEsaGoalMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/participant/esa/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEsaGoalResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEsaGoalMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/participant/esa/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEsaGoalResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEsaGoalMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/participant/esa/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEsaGoalResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEsaGoalMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/participant/esa/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEsaGoalResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEsaGoalMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/participant/esa/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEsaGoalResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEsaGoalMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/participant/esa/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEsaGoalResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEsaGoalMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/participant/esa/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEsaGoalResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEsaGoalMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/participant/esa/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEsaGoalResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEsaGoalMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/participant/esa/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEsaGoalResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEsaGoalMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/participant/esa/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEsaGoalResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEsaGoalMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/participant/esa/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEsaGoalResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEsaGoalMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/participant/esa/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEsaGoalResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEsaGoalMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/participant/esa/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEsaGoalResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEsaGoalMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/participant/esa/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEsaGoalResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEsaGoalMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/participant/esa/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEsaGoalResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEsaGoalMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/participant/esa/goal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostEsaGoalResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantIdentityVerificationMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantIdentityVerificationResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantIdentityVerificationMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantIdentityVerificationResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantIdentityVerificationMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantIdentityVerificationResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantIdentityVerificationMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantIdentityVerificationResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantIdentityVerificationMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantIdentityVerificationResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantIdentityVerificationMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantIdentityVerificationResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantIdentityVerificationMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantIdentityVerificationResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantIdentityVerificationMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantIdentityVerificationResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantIdentityVerificationMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantIdentityVerificationResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantIdentityVerificationMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantIdentityVerificationResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantIdentityVerificationMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantIdentityVerificationResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantIdentityVerificationMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantIdentityVerificationResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantIdentityVerificationMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantIdentityVerificationResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantIdentityVerificationMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantIdentityVerificationResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantIdentityVerificationMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantIdentityVerificationResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantIdentityVerificationMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantIdentityVerificationResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantIdentityVerificationMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantIdentityVerificationResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantIdentityVerificationMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantIdentityVerificationResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantIdentityVerificationMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantIdentityVerificationResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantIdentityVerificationMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantIdentityVerificationResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantInfoWithEmailsMockHandler = ()=>{
    return http.patch('*/api/participant/info', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantInfoWithEmailsMockHandler200 = ()=>{
    return http.patch('*/api/participant/info', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGoalFeedbackMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGoalFeedbackResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGoalFeedbackMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGoalFeedbackResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGoalFeedbackMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGoalFeedbackResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGoalFeedbackMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGoalFeedbackResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGoalFeedbackMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGoalFeedbackResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGoalFeedbackMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGoalFeedbackResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGoalFeedbackMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGoalFeedbackResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGoalFeedbackMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGoalFeedbackResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGoalFeedbackMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGoalFeedbackResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGoalFeedbackMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGoalFeedbackResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGoalFeedbackMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGoalFeedbackResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGoalFeedbackMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGoalFeedbackResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGoalFeedbackMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGoalFeedbackResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGoalFeedbackMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGoalFeedbackResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGoalFeedbackMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGoalFeedbackResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGoalFeedbackMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGoalFeedbackResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGoalFeedbackMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGoalFeedbackResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGoalFeedbackMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGoalFeedbackResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGoalFeedbackMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGoalFeedbackResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGoalFeedbackMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGoalFeedbackResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionAgeSuggestionMockHandler = ()=>{
    return http.post('*/api/participant/investment-election/age-suggestion', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionAgeSuggestionMockHandler201 = ()=>{
    return http.post('*/api/participant/investment-election/age-suggestion', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionRetirementIncomeSuggestionMockHandler = ()=>{
    return http.post('*/api/participant/investment-election/retirement-income-suggestion', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionRetirementIncomeSuggestionMockHandler201 = ()=>{
    return http.post('*/api/participant/investment-election/retirement-income-suggestion', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetElectionsSetupMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetElectionsSetupResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetElectionsSetupMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetElectionsSetupResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetElectionsSetupMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetElectionsSetupResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetElectionsSetupMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetElectionsSetupResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetElectionsSetupMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetElectionsSetupResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetElectionsSetupMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetElectionsSetupResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetElectionsSetupMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetElectionsSetupResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetElectionsSetupMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetElectionsSetupResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetElectionsSetupMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetElectionsSetupResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetElectionsSetupMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetElectionsSetupResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetElectionsSetupMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetElectionsSetupResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetElectionsSetupMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetElectionsSetupResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetElectionsSetupMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetElectionsSetupResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetElectionsSetupMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetElectionsSetupResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetElectionsSetupMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetElectionsSetupResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetElectionsSetupMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetElectionsSetupResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetElectionsSetupMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetElectionsSetupResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetElectionsSetupMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetElectionsSetupResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetElectionsSetupMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetElectionsSetupResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetElectionsSetupMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetElectionsSetupResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionsSetupMockHandler = ()=>{
    return http.post('*/api/participant/investment-election/setup', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionsSetupMockHandler200 = ()=>{
    return http.post('*/api/participant/investment-election/setup', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionsSetupMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostElectionsSetupResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionsSetupMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostElectionsSetupResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionsSetupMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostElectionsSetupResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionsSetupMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostElectionsSetupResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionsSetupMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostElectionsSetupResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionsSetupMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostElectionsSetupResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionsSetupMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostElectionsSetupResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionsSetupMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostElectionsSetupResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionsSetupMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostElectionsSetupResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionsSetupMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostElectionsSetupResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionsSetupMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostElectionsSetupResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionsSetupMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostElectionsSetupResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionsSetupMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostElectionsSetupResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionsSetupMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostElectionsSetupResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionsSetupMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostElectionsSetupResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionsSetupMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostElectionsSetupResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionsSetupMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostElectionsSetupResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionsSetupMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/participant/investment-election/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostElectionsSetupResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetInvestmentsModelDisplayMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/investments/model', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetInvestmentsModelDisplayResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetInvestmentsModelDisplayMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/model', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetInvestmentsModelDisplayResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetInvestmentsModelDisplayMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/model', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetInvestmentsModelDisplayResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetInvestmentsModelDisplayMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/model', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetInvestmentsModelDisplayResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetInvestmentsModelDisplayMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/model', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetInvestmentsModelDisplayResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetInvestmentsModelDisplayMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/model', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetInvestmentsModelDisplayResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetInvestmentsModelDisplayMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/model', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetInvestmentsModelDisplayResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetInvestmentsModelDisplayMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/model', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetInvestmentsModelDisplayResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetInvestmentsModelDisplayMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/model', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetInvestmentsModelDisplayResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetInvestmentsModelDisplayMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/model', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetInvestmentsModelDisplayResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetInvestmentsModelDisplayMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/model', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetInvestmentsModelDisplayResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetInvestmentsModelDisplayMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/model', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetInvestmentsModelDisplayResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetInvestmentsModelDisplayMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/model', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetInvestmentsModelDisplayResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetInvestmentsModelDisplayMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/model', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetInvestmentsModelDisplayResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetInvestmentsModelDisplayMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/model', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetInvestmentsModelDisplayResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetInvestmentsModelDisplayMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/model', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetInvestmentsModelDisplayResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetInvestmentsModelDisplayMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/model', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetInvestmentsModelDisplayResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetInvestmentsModelDisplayMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/model', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetInvestmentsModelDisplayResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetInvestmentsModelDisplayMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/model', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetInvestmentsModelDisplayResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetInvestmentsModelDisplayMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/model', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetInvestmentsModelDisplayResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanParticipantStatsMockHandler = ()=>{
    return http.get('*/api/participant/investments/options/plans/:planId/stats', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanParticipantStatsMockHandler200 = ()=>{
    return http.get('*/api/participant/investments/options/plans/:planId/stats', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRebalanceRequestMockHandler = ()=>{
    return http.post('*/api/participant/investments/rebalance-request', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRebalanceRequestMockHandler200 = ()=>{
    return http.post('*/api/participant/investments/rebalance-request', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRebalanceRequestMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/participant/investments/rebalance-request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRebalanceRequestResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRebalanceRequestMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/participant/investments/rebalance-request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRebalanceRequestResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRebalanceRequestMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/participant/investments/rebalance-request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRebalanceRequestResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRebalanceRequestMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/participant/investments/rebalance-request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRebalanceRequestResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRebalanceRequestMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/participant/investments/rebalance-request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRebalanceRequestResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRebalanceRequestMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/participant/investments/rebalance-request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRebalanceRequestResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRebalanceRequestMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/participant/investments/rebalance-request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRebalanceRequestResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRebalanceRequestMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/participant/investments/rebalance-request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRebalanceRequestResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRebalanceRequestMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/participant/investments/rebalance-request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRebalanceRequestResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRebalanceRequestMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/participant/investments/rebalance-request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRebalanceRequestResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRebalanceRequestMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/participant/investments/rebalance-request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRebalanceRequestResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRebalanceRequestMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/participant/investments/rebalance-request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRebalanceRequestResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRebalanceRequestMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/participant/investments/rebalance-request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRebalanceRequestResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRebalanceRequestMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/participant/investments/rebalance-request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRebalanceRequestResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRebalanceRequestMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/participant/investments/rebalance-request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRebalanceRequestResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRebalanceRequestMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/participant/investments/rebalance-request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRebalanceRequestResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRebalanceRequestMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/participant/investments/rebalance-request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRebalanceRequestResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRebalanceRequestMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/participant/investments/rebalance-request', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRebalanceRequestResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRebalanceSettingsMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRebalanceSettingsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRebalanceSettingsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRebalanceSettingsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRebalanceSettingsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRebalanceSettingsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRebalanceSettingsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRebalanceSettingsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRebalanceSettingsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRebalanceSettingsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRebalanceSettingsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRebalanceSettingsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRebalanceSettingsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRebalanceSettingsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRebalanceSettingsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRebalanceSettingsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRebalanceSettingsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRebalanceSettingsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRebalanceSettingsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRebalanceSettingsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRebalanceSettingsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRebalanceSettingsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRebalanceSettingsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRebalanceSettingsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRebalanceSettingsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRebalanceSettingsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRebalanceSettingsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRebalanceSettingsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRebalanceSettingsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRebalanceSettingsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRebalanceSettingsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRebalanceSettingsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRebalanceSettingsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRebalanceSettingsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRebalanceSettingsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRebalanceSettingsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRebalanceSettingsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRebalanceSettingsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRebalanceSettingsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRebalanceSettingsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRebalanceSettingsMockHandler = ()=>{
    return http.put('*/api/participant/investments/rebalance-settings', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRebalanceSettingsMockHandler200 = ()=>{
    return http.put('*/api/participant/investments/rebalance-settings', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRebalanceSettingsMockHandler400 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRebalanceSettingsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRebalanceSettingsMockHandler401 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRebalanceSettingsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRebalanceSettingsMockHandler403 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRebalanceSettingsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRebalanceSettingsMockHandler404 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRebalanceSettingsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRebalanceSettingsMockHandler405 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRebalanceSettingsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRebalanceSettingsMockHandler406 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRebalanceSettingsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRebalanceSettingsMockHandler408 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRebalanceSettingsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRebalanceSettingsMockHandler409 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRebalanceSettingsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRebalanceSettingsMockHandler410 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRebalanceSettingsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRebalanceSettingsMockHandler412 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRebalanceSettingsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRebalanceSettingsMockHandler413 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRebalanceSettingsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRebalanceSettingsMockHandler415 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRebalanceSettingsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRebalanceSettingsMockHandler422 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRebalanceSettingsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRebalanceSettingsMockHandler500 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRebalanceSettingsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRebalanceSettingsMockHandler501 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRebalanceSettingsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRebalanceSettingsMockHandler502 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRebalanceSettingsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRebalanceSettingsMockHandler503 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRebalanceSettingsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRebalanceSettingsMockHandler504 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/rebalance-settings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRebalanceSettingsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetStrategiesIndexMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetStrategiesIndexResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetStrategiesIndexMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetStrategiesIndexResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetStrategiesIndexMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetStrategiesIndexResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetStrategiesIndexMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetStrategiesIndexResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetStrategiesIndexMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetStrategiesIndexResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetStrategiesIndexMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetStrategiesIndexResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetStrategiesIndexMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetStrategiesIndexResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetStrategiesIndexMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetStrategiesIndexResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetStrategiesIndexMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetStrategiesIndexResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetStrategiesIndexMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetStrategiesIndexResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetStrategiesIndexMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetStrategiesIndexResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetStrategiesIndexMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetStrategiesIndexResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetStrategiesIndexMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetStrategiesIndexResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetStrategiesIndexMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetStrategiesIndexResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetStrategiesIndexMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetStrategiesIndexResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetStrategiesIndexMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetStrategiesIndexResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetStrategiesIndexMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetStrategiesIndexResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetStrategiesIndexMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetStrategiesIndexResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetStrategiesIndexMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetStrategiesIndexResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetStrategiesIndexMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetStrategiesIndexResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAgeBasedMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAgeBasedResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAgeBasedMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAgeBasedResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAgeBasedMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAgeBasedResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAgeBasedMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAgeBasedResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAgeBasedMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAgeBasedResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAgeBasedMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAgeBasedResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAgeBasedMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAgeBasedResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAgeBasedMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAgeBasedResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAgeBasedMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAgeBasedResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAgeBasedMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAgeBasedResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAgeBasedMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAgeBasedResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAgeBasedMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAgeBasedResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAgeBasedMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAgeBasedResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAgeBasedMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAgeBasedResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAgeBasedMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAgeBasedResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAgeBasedMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAgeBasedResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAgeBasedMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAgeBasedResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAgeBasedMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAgeBasedResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAgeBasedMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAgeBasedResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAgeBasedMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAgeBasedResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAgeBasedMockHandler = ()=>{
    return http.put('*/api/participant/investments/strategies/age-based', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAgeBasedMockHandler200 = ()=>{
    return http.put('*/api/participant/investments/strategies/age-based', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAgeBasedMockHandler400 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAgeBasedResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAgeBasedMockHandler401 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAgeBasedResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAgeBasedMockHandler403 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAgeBasedResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAgeBasedMockHandler404 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAgeBasedResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAgeBasedMockHandler405 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAgeBasedResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAgeBasedMockHandler406 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAgeBasedResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAgeBasedMockHandler408 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAgeBasedResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAgeBasedMockHandler409 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAgeBasedResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAgeBasedMockHandler410 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAgeBasedResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAgeBasedMockHandler412 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAgeBasedResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAgeBasedMockHandler413 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAgeBasedResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAgeBasedMockHandler415 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAgeBasedResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAgeBasedMockHandler422 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAgeBasedResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAgeBasedMockHandler500 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAgeBasedResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAgeBasedMockHandler501 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAgeBasedResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAgeBasedMockHandler502 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAgeBasedResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAgeBasedMockHandler503 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAgeBasedResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAgeBasedMockHandler504 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/age-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAgeBasedResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutCustomAllocationMockHandler = ()=>{
    return http.put('*/api/participant/investments/strategies/custom-allocation', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutCustomAllocationMockHandler200 = ()=>{
    return http.put('*/api/participant/investments/strategies/custom-allocation', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskBasedMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskBasedResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskBasedMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskBasedResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskBasedMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskBasedResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskBasedMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskBasedResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskBasedMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskBasedResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskBasedMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskBasedResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskBasedMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskBasedResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskBasedMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskBasedResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskBasedMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskBasedResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskBasedMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskBasedResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskBasedMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskBasedResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskBasedMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskBasedResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskBasedMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskBasedResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskBasedMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskBasedResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskBasedMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskBasedResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskBasedMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskBasedResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskBasedMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskBasedResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskBasedMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskBasedResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskBasedMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskBasedResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskBasedMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskBasedResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRiskBasedMockHandler = ()=>{
    return http.put('*/api/participant/investments/strategies/risk-based', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRiskBasedMockHandler200 = ()=>{
    return http.put('*/api/participant/investments/strategies/risk-based', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRiskBasedMockHandler400 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRiskBasedResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRiskBasedMockHandler401 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRiskBasedResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRiskBasedMockHandler403 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRiskBasedResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRiskBasedMockHandler404 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRiskBasedResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRiskBasedMockHandler405 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRiskBasedResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRiskBasedMockHandler406 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRiskBasedResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRiskBasedMockHandler408 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRiskBasedResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRiskBasedMockHandler409 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRiskBasedResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRiskBasedMockHandler410 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRiskBasedResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRiskBasedMockHandler412 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRiskBasedResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRiskBasedMockHandler413 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRiskBasedResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRiskBasedMockHandler415 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRiskBasedResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRiskBasedMockHandler422 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRiskBasedResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRiskBasedMockHandler500 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRiskBasedResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRiskBasedMockHandler501 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRiskBasedResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRiskBasedMockHandler502 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRiskBasedResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRiskBasedMockHandler503 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRiskBasedResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRiskBasedMockHandler504 = (overrideResponse)=>{
    return http.put('*/api/participant/investments/strategies/risk-based', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutRiskBasedResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskModelQuestionnaireMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskModelQuestionnaireResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskModelQuestionnaireMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskModelQuestionnaireResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskModelQuestionnaireMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskModelQuestionnaireResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskModelQuestionnaireMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskModelQuestionnaireResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskModelQuestionnaireMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskModelQuestionnaireResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskModelQuestionnaireMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskModelQuestionnaireResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskModelQuestionnaireMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskModelQuestionnaireResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskModelQuestionnaireMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskModelQuestionnaireResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskModelQuestionnaireMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskModelQuestionnaireResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskModelQuestionnaireMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskModelQuestionnaireResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskModelQuestionnaireMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskModelQuestionnaireResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskModelQuestionnaireMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskModelQuestionnaireResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskModelQuestionnaireMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskModelQuestionnaireResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskModelQuestionnaireMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskModelQuestionnaireResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskModelQuestionnaireMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskModelQuestionnaireResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskModelQuestionnaireMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskModelQuestionnaireResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskModelQuestionnaireMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskModelQuestionnaireResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskModelQuestionnaireMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskModelQuestionnaireResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskModelQuestionnaireMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskModelQuestionnaireResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskModelQuestionnaireMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskModelQuestionnaireResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMailPreferencesMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMailPreferencesResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMailPreferencesMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMailPreferencesResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMailPreferencesMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMailPreferencesResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMailPreferencesMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMailPreferencesResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMailPreferencesMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMailPreferencesResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMailPreferencesMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMailPreferencesResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMailPreferencesMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMailPreferencesResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMailPreferencesMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMailPreferencesResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMailPreferencesMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMailPreferencesResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMailPreferencesMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMailPreferencesResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMailPreferencesMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMailPreferencesResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMailPreferencesMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMailPreferencesResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMailPreferencesMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMailPreferencesResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMailPreferencesMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMailPreferencesResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMailPreferencesMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMailPreferencesResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMailPreferencesMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMailPreferencesResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMailPreferencesMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMailPreferencesResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMailPreferencesMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMailPreferencesResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMailPreferencesMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMailPreferencesResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMailPreferencesMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMailPreferencesResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutMailPreferencesMockHandler = ()=>{
    return http.put('*/api/participant/mail-preferences', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutMailPreferencesMockHandler200 = ()=>{
    return http.put('*/api/participant/mail-preferences', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutMailPreferencesMockHandler400 = (overrideResponse)=>{
    return http.put('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutMailPreferencesResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutMailPreferencesMockHandler401 = (overrideResponse)=>{
    return http.put('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutMailPreferencesResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutMailPreferencesMockHandler403 = (overrideResponse)=>{
    return http.put('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutMailPreferencesResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutMailPreferencesMockHandler404 = (overrideResponse)=>{
    return http.put('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutMailPreferencesResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutMailPreferencesMockHandler405 = (overrideResponse)=>{
    return http.put('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutMailPreferencesResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutMailPreferencesMockHandler406 = (overrideResponse)=>{
    return http.put('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutMailPreferencesResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutMailPreferencesMockHandler408 = (overrideResponse)=>{
    return http.put('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutMailPreferencesResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutMailPreferencesMockHandler409 = (overrideResponse)=>{
    return http.put('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutMailPreferencesResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutMailPreferencesMockHandler410 = (overrideResponse)=>{
    return http.put('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutMailPreferencesResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutMailPreferencesMockHandler412 = (overrideResponse)=>{
    return http.put('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutMailPreferencesResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutMailPreferencesMockHandler413 = (overrideResponse)=>{
    return http.put('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutMailPreferencesResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutMailPreferencesMockHandler415 = (overrideResponse)=>{
    return http.put('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutMailPreferencesResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutMailPreferencesMockHandler422 = (overrideResponse)=>{
    return http.put('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutMailPreferencesResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutMailPreferencesMockHandler500 = (overrideResponse)=>{
    return http.put('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutMailPreferencesResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutMailPreferencesMockHandler501 = (overrideResponse)=>{
    return http.put('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutMailPreferencesResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutMailPreferencesMockHandler502 = (overrideResponse)=>{
    return http.put('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutMailPreferencesResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutMailPreferencesMockHandler503 = (overrideResponse)=>{
    return http.put('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutMailPreferencesResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutMailPreferencesMockHandler504 = (overrideResponse)=>{
    return http.put('*/api/participant/mail-preferences', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutMailPreferencesResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOnboardingMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOnboardingResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOnboardingMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOnboardingResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOnboardingMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOnboardingResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOnboardingMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOnboardingResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOnboardingMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOnboardingResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOnboardingMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOnboardingResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOnboardingMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOnboardingResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOnboardingMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOnboardingResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOnboardingMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOnboardingResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOnboardingMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOnboardingResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOnboardingMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOnboardingResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOnboardingMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOnboardingResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOnboardingMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOnboardingResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOnboardingMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOnboardingResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOnboardingMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOnboardingResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOnboardingMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOnboardingResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOnboardingMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOnboardingResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOnboardingMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOnboardingResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOnboardingMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOnboardingResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOnboardingMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOnboardingResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOverviewMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/overview', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOverviewResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOverviewMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/overview', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOverviewResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOverviewMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/overview', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOverviewResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOverviewMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/overview', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOverviewResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOverviewMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/overview', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOverviewResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOverviewMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/overview', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOverviewResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOverviewMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/overview', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOverviewResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOverviewMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/overview', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOverviewResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOverviewMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/overview', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOverviewResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOverviewMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/overview', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOverviewResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOverviewMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/overview', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOverviewResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOverviewMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/overview', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOverviewResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOverviewMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/overview', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOverviewResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOverviewMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/overview', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOverviewResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOverviewMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/overview', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOverviewResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOverviewMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/overview', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOverviewResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOverviewMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/overview', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOverviewResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOverviewMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/overview', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOverviewResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOverviewMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/overview', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOverviewResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOverviewMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/overview', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOverviewResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBalanceMockHandler = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBalanceResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBalanceMockHandler200 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBalanceResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBalanceMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBalanceResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBalanceMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBalanceResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBalanceMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBalanceResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBalanceMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBalanceResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBalanceMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBalanceResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBalanceMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBalanceResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBalanceMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBalanceResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBalanceMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBalanceResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBalanceMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBalanceResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBalanceMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBalanceResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBalanceMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBalanceResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBalanceMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBalanceResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBalanceMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBalanceResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBalanceMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBalanceResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBalanceMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBalanceResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBalanceMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBalanceResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBalanceMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBalanceResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBalanceMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBalanceResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBankAccountMockHandler = ()=>{
    return http.post('*/api/participant/plaid-links/bank-account', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBankAccountMockHandler200 = ()=>{
    return http.post('*/api/participant/plaid-links/bank-account', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBankAccountMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/bank-account', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBankAccountResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBankAccountMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/bank-account', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBankAccountResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBankAccountMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/bank-account', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBankAccountResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBankAccountMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/bank-account', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBankAccountResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBankAccountMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/bank-account', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBankAccountResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBankAccountMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/bank-account', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBankAccountResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBankAccountMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/bank-account', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBankAccountResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBankAccountMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/bank-account', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBankAccountResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBankAccountMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/bank-account', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBankAccountResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBankAccountMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/bank-account', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBankAccountResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBankAccountMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/bank-account', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBankAccountResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBankAccountMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/bank-account', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBankAccountResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBankAccountMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/bank-account', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBankAccountResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBankAccountMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/bank-account', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBankAccountResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBankAccountMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/bank-account', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBankAccountResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBankAccountMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/bank-account', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBankAccountResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBankAccountMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/bank-account', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBankAccountResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksBankAccountMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/bank-account', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksBankAccountResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantDiscardPendingPlaidLinksMockHandler = ()=>{
    return http.post('*/api/participant/plaid-links/discard-pending', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantDiscardPendingPlaidLinksMockHandler200 = ()=>{
    return http.post('*/api/participant/plaid-links/discard-pending', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantDiscardPendingPlaidLinksMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/discard-pending', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantDiscardPendingPlaidLinksResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantDiscardPendingPlaidLinksMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/discard-pending', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantDiscardPendingPlaidLinksResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantDiscardPendingPlaidLinksMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/discard-pending', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantDiscardPendingPlaidLinksResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantDiscardPendingPlaidLinksMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/discard-pending', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantDiscardPendingPlaidLinksResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantDiscardPendingPlaidLinksMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/discard-pending', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantDiscardPendingPlaidLinksResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantDiscardPendingPlaidLinksMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/discard-pending', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantDiscardPendingPlaidLinksResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantDiscardPendingPlaidLinksMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/discard-pending', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantDiscardPendingPlaidLinksResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantDiscardPendingPlaidLinksMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/discard-pending', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantDiscardPendingPlaidLinksResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantDiscardPendingPlaidLinksMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/discard-pending', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantDiscardPendingPlaidLinksResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantDiscardPendingPlaidLinksMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/discard-pending', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantDiscardPendingPlaidLinksResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantDiscardPendingPlaidLinksMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/discard-pending', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantDiscardPendingPlaidLinksResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantDiscardPendingPlaidLinksMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/discard-pending', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantDiscardPendingPlaidLinksResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantDiscardPendingPlaidLinksMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/discard-pending', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantDiscardPendingPlaidLinksResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantDiscardPendingPlaidLinksMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/discard-pending', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantDiscardPendingPlaidLinksResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantDiscardPendingPlaidLinksMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/discard-pending', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantDiscardPendingPlaidLinksResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantDiscardPendingPlaidLinksMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/discard-pending', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantDiscardPendingPlaidLinksResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantDiscardPendingPlaidLinksMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/discard-pending', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantDiscardPendingPlaidLinksResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantDiscardPendingPlaidLinksMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/participant/plaid-links/discard-pending', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantDiscardPendingPlaidLinksResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPositionsMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/positions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPositionsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPositionsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/positions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPositionsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPositionsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/positions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPositionsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPositionsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/positions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPositionsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPositionsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/positions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPositionsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPositionsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/positions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPositionsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPositionsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/positions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPositionsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPositionsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/positions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPositionsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPositionsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/positions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPositionsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPositionsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/positions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPositionsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPositionsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/positions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPositionsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPositionsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/positions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPositionsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPositionsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/positions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPositionsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPositionsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/positions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPositionsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPositionsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/positions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPositionsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPositionsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/positions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPositionsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPositionsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/positions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPositionsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPositionsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/positions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPositionsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPositionsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/positions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPositionsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPositionsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/positions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPositionsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQboadWithdrawalsMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/qboad/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQboadWithdrawalsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQboadWithdrawalsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/qboad/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQboadWithdrawalsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQboadWithdrawalsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/qboad/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQboadWithdrawalsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQboadWithdrawalsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/qboad/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQboadWithdrawalsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQboadWithdrawalsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/qboad/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQboadWithdrawalsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQboadWithdrawalsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/qboad/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQboadWithdrawalsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQboadWithdrawalsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/qboad/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQboadWithdrawalsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQboadWithdrawalsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/qboad/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQboadWithdrawalsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQboadWithdrawalsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/qboad/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQboadWithdrawalsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQboadWithdrawalsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/qboad/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQboadWithdrawalsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQboadWithdrawalsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/qboad/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQboadWithdrawalsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQboadWithdrawalsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/qboad/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQboadWithdrawalsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQboadWithdrawalsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/qboad/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQboadWithdrawalsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQboadWithdrawalsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/qboad/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQboadWithdrawalsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQboadWithdrawalsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/qboad/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQboadWithdrawalsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQboadWithdrawalsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/qboad/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQboadWithdrawalsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQboadWithdrawalsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/qboad/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQboadWithdrawalsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQboadWithdrawalsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/qboad/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQboadWithdrawalsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQboadWithdrawalsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/qboad/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQboadWithdrawalsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQboadWithdrawalsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/qboad/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQboadWithdrawalsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantRolloverMockHandler = ()=>{
    return http.patch('*/api/participant/rollovers', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantRolloverMockHandler200 = ()=>{
    return http.patch('*/api/participant/rollovers', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverInstructionsMockHandler = ()=>{
    return http.get('*/api/participant/rollovers/instructions', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverInstructionsMockHandler200 = ()=>{
    return http.get('*/api/participant/rollovers/instructions', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverEligibilityMockHandler = ()=>{
    return http.get('*/api/participant/rollovers/request', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverEligibilityMockHandler200 = ()=>{
    return http.get('*/api/participant/rollovers/request', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantRolloverMockHandler = ()=>{
    return http.post('*/api/participant/rollovers/request', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantRolloverMockHandler201 = ()=>{
    return http.post('*/api/participant/rollovers/request', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRolloverMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/rollovers/:rolloverId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRolloverResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRolloverMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/rollovers/:rolloverId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRolloverResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRolloverMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/rollovers/:rolloverId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRolloverResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRolloverMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/rollovers/:rolloverId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRolloverResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRolloverMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/rollovers/:rolloverId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRolloverResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRolloverMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/rollovers/:rolloverId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRolloverResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRolloverMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/rollovers/:rolloverId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRolloverResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRolloverMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/rollovers/:rolloverId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRolloverResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRolloverMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/rollovers/:rolloverId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRolloverResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRolloverMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/rollovers/:rolloverId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRolloverResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRolloverMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/rollovers/:rolloverId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRolloverResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRolloverMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/rollovers/:rolloverId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRolloverResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRolloverMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/rollovers/:rolloverId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRolloverResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRolloverMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/rollovers/:rolloverId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRolloverResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRolloverMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/rollovers/:rolloverId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRolloverResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRolloverMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/rollovers/:rolloverId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRolloverResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRolloverMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/rollovers/:rolloverId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRolloverResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRolloverMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/rollovers/:rolloverId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRolloverResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRolloverMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/rollovers/:rolloverId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRolloverResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRolloverMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/rollovers/:rolloverId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRolloverResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGenerateRolloverLetterMockHandler = ()=>{
    return http.get('*/api/participant/rollovers/:rolloverId/letter', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGenerateRolloverLetterMockHandler200 = ()=>{
    return http.get('*/api/participant/rollovers/:rolloverId/letter', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSavingsDisplayMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/savings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSavingsDisplayResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSavingsDisplayMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/savings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSavingsDisplayResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSavingsDisplayMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/savings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSavingsDisplayResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSavingsDisplayMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/savings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSavingsDisplayResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSavingsDisplayMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/savings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSavingsDisplayResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSavingsDisplayMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/savings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSavingsDisplayResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSavingsDisplayMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/savings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSavingsDisplayResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSavingsDisplayMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/savings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSavingsDisplayResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSavingsDisplayMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/savings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSavingsDisplayResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSavingsDisplayMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/savings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSavingsDisplayResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSavingsDisplayMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/savings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSavingsDisplayResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSavingsDisplayMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/savings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSavingsDisplayResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSavingsDisplayMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/savings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSavingsDisplayResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSavingsDisplayMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/savings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSavingsDisplayResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSavingsDisplayMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/savings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSavingsDisplayResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSavingsDisplayMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/savings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSavingsDisplayResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSavingsDisplayMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/savings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSavingsDisplayResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSavingsDisplayMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/savings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSavingsDisplayResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSavingsDisplayMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/savings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSavingsDisplayResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSavingsDisplayMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/savings', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSavingsDisplayResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSavingsMockHandler = ()=>{
    return http.put('*/api/participant/savings', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSavingsMockHandler200 = ()=>{
    return http.put('*/api/participant/savings', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSurveyLinkMockHandler = ()=>{
    return http.get('*/api/participant/survey/link', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSurveyLinkMockHandler200 = ()=>{
    return http.get('*/api/participant/survey/link', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAggregatedByCategoryTransactionsMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/transactions/aggregated-by-category', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAggregatedByCategoryTransactionsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAggregatedByCategoryTransactionsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/transactions/aggregated-by-category', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAggregatedByCategoryTransactionsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAggregatedByCategoryTransactionsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/transactions/aggregated-by-category', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAggregatedByCategoryTransactionsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAggregatedByCategoryTransactionsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/transactions/aggregated-by-category', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAggregatedByCategoryTransactionsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAggregatedByCategoryTransactionsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/transactions/aggregated-by-category', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAggregatedByCategoryTransactionsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAggregatedByCategoryTransactionsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/transactions/aggregated-by-category', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAggregatedByCategoryTransactionsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAggregatedByCategoryTransactionsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/transactions/aggregated-by-category', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAggregatedByCategoryTransactionsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAggregatedByCategoryTransactionsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/transactions/aggregated-by-category', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAggregatedByCategoryTransactionsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAggregatedByCategoryTransactionsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/transactions/aggregated-by-category', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAggregatedByCategoryTransactionsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAggregatedByCategoryTransactionsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/transactions/aggregated-by-category', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAggregatedByCategoryTransactionsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAggregatedByCategoryTransactionsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/transactions/aggregated-by-category', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAggregatedByCategoryTransactionsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAggregatedByCategoryTransactionsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/transactions/aggregated-by-category', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAggregatedByCategoryTransactionsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAggregatedByCategoryTransactionsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/transactions/aggregated-by-category', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAggregatedByCategoryTransactionsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAggregatedByCategoryTransactionsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/transactions/aggregated-by-category', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAggregatedByCategoryTransactionsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAggregatedByCategoryTransactionsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/transactions/aggregated-by-category', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAggregatedByCategoryTransactionsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAggregatedByCategoryTransactionsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/transactions/aggregated-by-category', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAggregatedByCategoryTransactionsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAggregatedByCategoryTransactionsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/transactions/aggregated-by-category', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAggregatedByCategoryTransactionsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAggregatedByCategoryTransactionsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/transactions/aggregated-by-category', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAggregatedByCategoryTransactionsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAggregatedByCategoryTransactionsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/transactions/aggregated-by-category', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAggregatedByCategoryTransactionsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAggregatedByCategoryTransactionsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/transactions/aggregated-by-category', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAggregatedByCategoryTransactionsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllowedWithdrawalReasonsMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllowedWithdrawalReasonsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllowedWithdrawalReasonsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participant/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllowedWithdrawalReasonsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllowedWithdrawalReasonsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participant/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllowedWithdrawalReasonsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllowedWithdrawalReasonsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participant/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllowedWithdrawalReasonsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllowedWithdrawalReasonsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participant/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllowedWithdrawalReasonsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllowedWithdrawalReasonsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participant/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllowedWithdrawalReasonsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllowedWithdrawalReasonsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participant/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllowedWithdrawalReasonsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllowedWithdrawalReasonsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participant/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllowedWithdrawalReasonsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllowedWithdrawalReasonsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participant/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllowedWithdrawalReasonsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllowedWithdrawalReasonsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participant/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllowedWithdrawalReasonsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllowedWithdrawalReasonsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participant/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllowedWithdrawalReasonsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllowedWithdrawalReasonsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participant/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllowedWithdrawalReasonsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllowedWithdrawalReasonsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participant/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllowedWithdrawalReasonsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllowedWithdrawalReasonsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participant/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllowedWithdrawalReasonsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllowedWithdrawalReasonsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participant/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllowedWithdrawalReasonsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllowedWithdrawalReasonsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participant/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllowedWithdrawalReasonsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllowedWithdrawalReasonsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participant/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllowedWithdrawalReasonsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllowedWithdrawalReasonsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participant/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllowedWithdrawalReasonsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllowedWithdrawalReasonsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participant/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllowedWithdrawalReasonsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllowedWithdrawalReasonsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participant/withdrawals', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllowedWithdrawalReasonsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostWithdrawalMockHandler = ()=>{
    return http.post('*/api/participant/withdrawals', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostWithdrawalMockHandler201 = ()=>{
    return http.post('*/api/participant/withdrawals', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchOverrideParticipantEligibilityMockHandler = ()=>{
    return http.patch('*/api/participant/:participantId/override-eligibility', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchOverrideParticipantEligibilityMockHandler200 = ()=>{
    return http.patch('*/api/participant/:participantId/override-eligibility', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchOverrideParticipantEligibilityMockHandler400 = (overrideResponse)=>{
    return http.patch('*/api/participant/:participantId/override-eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchOverrideParticipantEligibilityResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchOverrideParticipantEligibilityMockHandler401 = (overrideResponse)=>{
    return http.patch('*/api/participant/:participantId/override-eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchOverrideParticipantEligibilityResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchOverrideParticipantEligibilityMockHandler403 = (overrideResponse)=>{
    return http.patch('*/api/participant/:participantId/override-eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchOverrideParticipantEligibilityResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchOverrideParticipantEligibilityMockHandler404 = (overrideResponse)=>{
    return http.patch('*/api/participant/:participantId/override-eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchOverrideParticipantEligibilityResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchOverrideParticipantEligibilityMockHandler405 = (overrideResponse)=>{
    return http.patch('*/api/participant/:participantId/override-eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchOverrideParticipantEligibilityResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchOverrideParticipantEligibilityMockHandler406 = (overrideResponse)=>{
    return http.patch('*/api/participant/:participantId/override-eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchOverrideParticipantEligibilityResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchOverrideParticipantEligibilityMockHandler408 = (overrideResponse)=>{
    return http.patch('*/api/participant/:participantId/override-eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchOverrideParticipantEligibilityResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchOverrideParticipantEligibilityMockHandler409 = (overrideResponse)=>{
    return http.patch('*/api/participant/:participantId/override-eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchOverrideParticipantEligibilityResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchOverrideParticipantEligibilityMockHandler410 = (overrideResponse)=>{
    return http.patch('*/api/participant/:participantId/override-eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchOverrideParticipantEligibilityResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchOverrideParticipantEligibilityMockHandler412 = (overrideResponse)=>{
    return http.patch('*/api/participant/:participantId/override-eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchOverrideParticipantEligibilityResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchOverrideParticipantEligibilityMockHandler413 = (overrideResponse)=>{
    return http.patch('*/api/participant/:participantId/override-eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchOverrideParticipantEligibilityResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchOverrideParticipantEligibilityMockHandler415 = (overrideResponse)=>{
    return http.patch('*/api/participant/:participantId/override-eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchOverrideParticipantEligibilityResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchOverrideParticipantEligibilityMockHandler422 = (overrideResponse)=>{
    return http.patch('*/api/participant/:participantId/override-eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchOverrideParticipantEligibilityResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchOverrideParticipantEligibilityMockHandler500 = (overrideResponse)=>{
    return http.patch('*/api/participant/:participantId/override-eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchOverrideParticipantEligibilityResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchOverrideParticipantEligibilityMockHandler501 = (overrideResponse)=>{
    return http.patch('*/api/participant/:participantId/override-eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchOverrideParticipantEligibilityResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchOverrideParticipantEligibilityMockHandler502 = (overrideResponse)=>{
    return http.patch('*/api/participant/:participantId/override-eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchOverrideParticipantEligibilityResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchOverrideParticipantEligibilityMockHandler503 = (overrideResponse)=>{
    return http.patch('*/api/participant/:participantId/override-eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchOverrideParticipantEligibilityResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchOverrideParticipantEligibilityMockHandler504 = (overrideResponse)=>{
    return http.patch('*/api/participant/:participantId/override-eligibility', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchOverrideParticipantEligibilityResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEligibleAutoEnrolledParticipantsMockHandler = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEligibleAutoEnrolledParticipantsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEligibleAutoEnrolledParticipantsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEligibleAutoEnrolledParticipantsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEligibleAutoEnrolledParticipantsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEligibleAutoEnrolledParticipantsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEligibleAutoEnrolledParticipantsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEligibleAutoEnrolledParticipantsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEligibleAutoEnrolledParticipantsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEligibleAutoEnrolledParticipantsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEligibleAutoEnrolledParticipantsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEligibleAutoEnrolledParticipantsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEligibleAutoEnrolledParticipantsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEligibleAutoEnrolledParticipantsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEligibleAutoEnrolledParticipantsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEligibleAutoEnrolledParticipantsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEligibleAutoEnrolledParticipantsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEligibleAutoEnrolledParticipantsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEligibleAutoEnrolledParticipantsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEligibleAutoEnrolledParticipantsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEligibleAutoEnrolledParticipantsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEligibleAutoEnrolledParticipantsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEligibleAutoEnrolledParticipantsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEligibleAutoEnrolledParticipantsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEligibleAutoEnrolledParticipantsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEligibleAutoEnrolledParticipantsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEligibleAutoEnrolledParticipantsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEligibleAutoEnrolledParticipantsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEligibleAutoEnrolledParticipantsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEligibleAutoEnrolledParticipantsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEligibleAutoEnrolledParticipantsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEligibleAutoEnrolledParticipantsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEligibleAutoEnrolledParticipantsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEligibleAutoEnrolledParticipantsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEligibleAutoEnrolledParticipantsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEligibleAutoEnrolledParticipantsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEligibleAutoEnrolledParticipantsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEligibleAutoEnrolledParticipantsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEligibleAutoEnrolledParticipantsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEligibleAutoEnrolledParticipantsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOptOutEmailDownloadMockHandler = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out-confirmation/download', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOptOutEmailDownloadResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOptOutEmailDownloadMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out-confirmation/download', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOptOutEmailDownloadResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOptedOutAutoEnrolledParticipantsMockHandler = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out/enrolled', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOptedOutAutoEnrolledParticipantsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOptedOutAutoEnrolledParticipantsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out/enrolled', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOptedOutAutoEnrolledParticipantsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOptedOutAutoEnrolledParticipantsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out/enrolled', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOptedOutAutoEnrolledParticipantsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOptedOutAutoEnrolledParticipantsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out/enrolled', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOptedOutAutoEnrolledParticipantsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOptedOutAutoEnrolledParticipantsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out/enrolled', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOptedOutAutoEnrolledParticipantsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOptedOutAutoEnrolledParticipantsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out/enrolled', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOptedOutAutoEnrolledParticipantsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOptedOutAutoEnrolledParticipantsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out/enrolled', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOptedOutAutoEnrolledParticipantsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOptedOutAutoEnrolledParticipantsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out/enrolled', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOptedOutAutoEnrolledParticipantsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOptedOutAutoEnrolledParticipantsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out/enrolled', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOptedOutAutoEnrolledParticipantsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOptedOutAutoEnrolledParticipantsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out/enrolled', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOptedOutAutoEnrolledParticipantsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOptedOutAutoEnrolledParticipantsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out/enrolled', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOptedOutAutoEnrolledParticipantsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOptedOutAutoEnrolledParticipantsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out/enrolled', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOptedOutAutoEnrolledParticipantsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOptedOutAutoEnrolledParticipantsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out/enrolled', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOptedOutAutoEnrolledParticipantsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOptedOutAutoEnrolledParticipantsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out/enrolled', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOptedOutAutoEnrolledParticipantsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOptedOutAutoEnrolledParticipantsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out/enrolled', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOptedOutAutoEnrolledParticipantsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOptedOutAutoEnrolledParticipantsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out/enrolled', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOptedOutAutoEnrolledParticipantsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOptedOutAutoEnrolledParticipantsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out/enrolled', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOptedOutAutoEnrolledParticipantsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOptedOutAutoEnrolledParticipantsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out/enrolled', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOptedOutAutoEnrolledParticipantsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOptedOutAutoEnrolledParticipantsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out/enrolled', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOptedOutAutoEnrolledParticipantsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOptedOutAutoEnrolledParticipantsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participants/opt-out/enrolled', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOptedOutAutoEnrolledParticipantsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsMockHandler = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsCountMockHandler = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered/count', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsCountResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsCountMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered/count', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsCountResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsCountMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered/count', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsCountResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsCountMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered/count', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsCountResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsCountMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered/count', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsCountResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsCountMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered/count', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsCountResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsCountMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered/count', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsCountResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsCountMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered/count', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsCountResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsCountMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered/count', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsCountResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsCountMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered/count', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsCountResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsCountMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered/count', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsCountResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsCountMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered/count', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsCountResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsCountMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered/count', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsCountResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsCountMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered/count', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsCountResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsCountMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered/count', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsCountResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsCountMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered/count', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsCountResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsCountMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered/count', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsCountResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsCountMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered/count', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsCountResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsCountMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered/count', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsCountResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsCountMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered/count', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsCountResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsWelcomeEmailsMockHandler = (overrideResponse)=>{
    return http.post('*/api/participants/welcome-emails/bulk', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsWelcomeEmailsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsWelcomeEmailsMockHandler200 = (overrideResponse)=>{
    return http.post('*/api/participants/welcome-emails/bulk', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsWelcomeEmailsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsWelcomeEmailsMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/participants/welcome-emails/bulk', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsWelcomeEmailsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsWelcomeEmailsMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/participants/welcome-emails/bulk', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsWelcomeEmailsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsWelcomeEmailsMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/participants/welcome-emails/bulk', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsWelcomeEmailsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsWelcomeEmailsMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/participants/welcome-emails/bulk', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsWelcomeEmailsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsWelcomeEmailsMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/participants/welcome-emails/bulk', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsWelcomeEmailsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsWelcomeEmailsMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/participants/welcome-emails/bulk', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsWelcomeEmailsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsWelcomeEmailsMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/participants/welcome-emails/bulk', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsWelcomeEmailsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsWelcomeEmailsMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/participants/welcome-emails/bulk', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsWelcomeEmailsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsWelcomeEmailsMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/participants/welcome-emails/bulk', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsWelcomeEmailsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsWelcomeEmailsMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/participants/welcome-emails/bulk', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsWelcomeEmailsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsWelcomeEmailsMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/participants/welcome-emails/bulk', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsWelcomeEmailsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsWelcomeEmailsMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/participants/welcome-emails/bulk', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsWelcomeEmailsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsWelcomeEmailsMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/participants/welcome-emails/bulk', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsWelcomeEmailsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsWelcomeEmailsMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/participants/welcome-emails/bulk', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsWelcomeEmailsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsWelcomeEmailsMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/participants/welcome-emails/bulk', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsWelcomeEmailsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsWelcomeEmailsMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/participants/welcome-emails/bulk', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsWelcomeEmailsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsWelcomeEmailsMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/participants/welcome-emails/bulk', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsWelcomeEmailsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsWelcomeEmailsMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/participants/welcome-emails/bulk', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsWelcomeEmailsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantWelcomeEmailDownloadMockHandler = (overrideResponse)=>{
    return http.get('*/api/participants/welcome-emails/download', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantWelcomeEmailDownloadResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantWelcomeEmailDownloadMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participants/welcome-emails/download', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantWelcomeEmailDownloadResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantWelcomeEmailsHistoryMockHandler = (overrideResponse)=>{
    return http.get('*/api/participants/welcome-emails/history', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantWelcomeEmailsHistoryResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantWelcomeEmailsHistoryMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participants/welcome-emails/history', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantWelcomeEmailsHistoryResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantWelcomeEmailsHistoryMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participants/welcome-emails/history', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantWelcomeEmailsHistoryResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantWelcomeEmailsHistoryMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participants/welcome-emails/history', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantWelcomeEmailsHistoryResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantWelcomeEmailsHistoryMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participants/welcome-emails/history', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantWelcomeEmailsHistoryResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantWelcomeEmailsHistoryMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participants/welcome-emails/history', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantWelcomeEmailsHistoryResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantWelcomeEmailsHistoryMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participants/welcome-emails/history', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantWelcomeEmailsHistoryResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantWelcomeEmailsHistoryMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participants/welcome-emails/history', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantWelcomeEmailsHistoryResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantWelcomeEmailsHistoryMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participants/welcome-emails/history', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantWelcomeEmailsHistoryResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantWelcomeEmailsHistoryMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participants/welcome-emails/history', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantWelcomeEmailsHistoryResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantWelcomeEmailsHistoryMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participants/welcome-emails/history', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantWelcomeEmailsHistoryResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantWelcomeEmailsHistoryMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participants/welcome-emails/history', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantWelcomeEmailsHistoryResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantWelcomeEmailsHistoryMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participants/welcome-emails/history', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantWelcomeEmailsHistoryResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantWelcomeEmailsHistoryMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participants/welcome-emails/history', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantWelcomeEmailsHistoryResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantWelcomeEmailsHistoryMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participants/welcome-emails/history', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantWelcomeEmailsHistoryResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantWelcomeEmailsHistoryMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participants/welcome-emails/history', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantWelcomeEmailsHistoryResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantWelcomeEmailsHistoryMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participants/welcome-emails/history', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantWelcomeEmailsHistoryResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantWelcomeEmailsHistoryMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participants/welcome-emails/history', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantWelcomeEmailsHistoryResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantWelcomeEmailsHistoryMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participants/welcome-emails/history', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantWelcomeEmailsHistoryResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantWelcomeEmailsHistoryMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participants/welcome-emails/history', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantWelcomeEmailsHistoryResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEsaEmployerContributionsMockHandler = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-contributions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEsaEmployerContributionsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEsaEmployerContributionsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-contributions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEsaEmployerContributionsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEsaEmployerContributionsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-contributions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEsaEmployerContributionsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEsaEmployerContributionsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-contributions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEsaEmployerContributionsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEsaEmployerContributionsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-contributions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEsaEmployerContributionsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEsaEmployerContributionsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-contributions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEsaEmployerContributionsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEsaEmployerContributionsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-contributions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEsaEmployerContributionsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEsaEmployerContributionsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-contributions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEsaEmployerContributionsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEsaEmployerContributionsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-contributions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEsaEmployerContributionsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEsaEmployerContributionsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-contributions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEsaEmployerContributionsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEsaEmployerContributionsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-contributions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEsaEmployerContributionsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEsaEmployerContributionsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-contributions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEsaEmployerContributionsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEsaEmployerContributionsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-contributions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEsaEmployerContributionsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEsaEmployerContributionsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-contributions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEsaEmployerContributionsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEsaEmployerContributionsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-contributions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEsaEmployerContributionsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEsaEmployerContributionsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-contributions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEsaEmployerContributionsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEsaEmployerContributionsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-contributions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEsaEmployerContributionsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEsaEmployerContributionsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-contributions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEsaEmployerContributionsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEsaEmployerContributionsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-contributions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEsaEmployerContributionsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEsaEmployerContributionsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-contributions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEsaEmployerContributionsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEmployerMatchContributionMockHandler = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-match', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEmployerMatchContributionResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEmployerMatchContributionMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-match', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEmployerMatchContributionResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEmployerMatchContributionMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-match', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEmployerMatchContributionResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEmployerMatchContributionMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-match', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEmployerMatchContributionResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEmployerMatchContributionMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-match', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEmployerMatchContributionResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEmployerMatchContributionMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-match', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEmployerMatchContributionResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEmployerMatchContributionMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-match', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEmployerMatchContributionResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEmployerMatchContributionMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-match', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEmployerMatchContributionResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEmployerMatchContributionMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-match', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEmployerMatchContributionResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEmployerMatchContributionMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-match', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEmployerMatchContributionResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEmployerMatchContributionMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-match', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEmployerMatchContributionResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEmployerMatchContributionMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-match', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEmployerMatchContributionResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEmployerMatchContributionMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-match', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEmployerMatchContributionResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEmployerMatchContributionMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-match', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEmployerMatchContributionResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEmployerMatchContributionMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-match', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEmployerMatchContributionResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEmployerMatchContributionMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-match', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEmployerMatchContributionResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEmployerMatchContributionMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-match', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEmployerMatchContributionResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEmployerMatchContributionMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-match', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEmployerMatchContributionResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEmployerMatchContributionMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-match', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEmployerMatchContributionResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEmployerMatchContributionMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-match', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEmployerMatchContributionResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsAutoEnrollOptOutMockHandler = ()=>{
    return http.post('*/api/participants/:planId/opt-out', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsAutoEnrollOptOutMockHandler200 = ()=>{
    return http.post('*/api/participants/:planId/opt-out', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsAutoEnrollOptOutMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/participants/:planId/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsAutoEnrollOptOutResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsAutoEnrollOptOutMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/participants/:planId/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsAutoEnrollOptOutResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsAutoEnrollOptOutMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/participants/:planId/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsAutoEnrollOptOutResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsAutoEnrollOptOutMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/participants/:planId/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsAutoEnrollOptOutResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsAutoEnrollOptOutMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/participants/:planId/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsAutoEnrollOptOutResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsAutoEnrollOptOutMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/participants/:planId/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsAutoEnrollOptOutResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsAutoEnrollOptOutMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/participants/:planId/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsAutoEnrollOptOutResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsAutoEnrollOptOutMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/participants/:planId/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsAutoEnrollOptOutResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsAutoEnrollOptOutMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/participants/:planId/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsAutoEnrollOptOutResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsAutoEnrollOptOutMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/participants/:planId/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsAutoEnrollOptOutResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsAutoEnrollOptOutMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/participants/:planId/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsAutoEnrollOptOutResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsAutoEnrollOptOutMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/participants/:planId/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsAutoEnrollOptOutResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsAutoEnrollOptOutMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/participants/:planId/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsAutoEnrollOptOutResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsAutoEnrollOptOutMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/participants/:planId/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsAutoEnrollOptOutResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsAutoEnrollOptOutMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/participants/:planId/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsAutoEnrollOptOutResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsAutoEnrollOptOutMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/participants/:planId/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsAutoEnrollOptOutResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsAutoEnrollOptOutMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/participants/:planId/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsAutoEnrollOptOutResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantsAutoEnrollOptOutMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/participants/:planId/opt-out', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantsAutoEnrollOptOutResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignMockHandler = (overrideResponse)=>{
    return http.get('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchUpdatePlanDesignMockHandler = ()=>{
    return http.patch('*/api/plan-design', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchUpdatePlanDesignMockHandler200 = ()=>{
    return http.patch('*/api/plan-design', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchUpdatePlanDesignMockHandler400 = (overrideResponse)=>{
    return http.patch('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchUpdatePlanDesignResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchUpdatePlanDesignMockHandler401 = (overrideResponse)=>{
    return http.patch('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchUpdatePlanDesignResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchUpdatePlanDesignMockHandler403 = (overrideResponse)=>{
    return http.patch('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchUpdatePlanDesignResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchUpdatePlanDesignMockHandler404 = (overrideResponse)=>{
    return http.patch('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchUpdatePlanDesignResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchUpdatePlanDesignMockHandler405 = (overrideResponse)=>{
    return http.patch('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchUpdatePlanDesignResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchUpdatePlanDesignMockHandler406 = (overrideResponse)=>{
    return http.patch('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchUpdatePlanDesignResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchUpdatePlanDesignMockHandler408 = (overrideResponse)=>{
    return http.patch('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchUpdatePlanDesignResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchUpdatePlanDesignMockHandler409 = (overrideResponse)=>{
    return http.patch('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchUpdatePlanDesignResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchUpdatePlanDesignMockHandler410 = (overrideResponse)=>{
    return http.patch('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchUpdatePlanDesignResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchUpdatePlanDesignMockHandler412 = (overrideResponse)=>{
    return http.patch('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchUpdatePlanDesignResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchUpdatePlanDesignMockHandler413 = (overrideResponse)=>{
    return http.patch('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchUpdatePlanDesignResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchUpdatePlanDesignMockHandler415 = (overrideResponse)=>{
    return http.patch('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchUpdatePlanDesignResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchUpdatePlanDesignMockHandler422 = (overrideResponse)=>{
    return http.patch('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchUpdatePlanDesignResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchUpdatePlanDesignMockHandler500 = (overrideResponse)=>{
    return http.patch('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchUpdatePlanDesignResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchUpdatePlanDesignMockHandler501 = (overrideResponse)=>{
    return http.patch('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchUpdatePlanDesignResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchUpdatePlanDesignMockHandler502 = (overrideResponse)=>{
    return http.patch('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchUpdatePlanDesignResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchUpdatePlanDesignMockHandler503 = (overrideResponse)=>{
    return http.patch('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchUpdatePlanDesignResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchUpdatePlanDesignMockHandler504 = (overrideResponse)=>{
    return http.patch('*/api/plan-design', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchUpdatePlanDesignResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignTilesMockHandler = (overrideResponse)=>{
    return http.get('*/api/plan-design/tiles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignTilesResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignTilesMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/plan-design/tiles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignTilesResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignTilesMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/plan-design/tiles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignTilesResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignTilesMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/plan-design/tiles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignTilesResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignTilesMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/plan-design/tiles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignTilesResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignTilesMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/plan-design/tiles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignTilesResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignTilesMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/plan-design/tiles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignTilesResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignTilesMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/plan-design/tiles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignTilesResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignTilesMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/plan-design/tiles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignTilesResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignTilesMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/plan-design/tiles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignTilesResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignTilesMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/plan-design/tiles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignTilesResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignTilesMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/plan-design/tiles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignTilesResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignTilesMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/plan-design/tiles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignTilesResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignTilesMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/plan-design/tiles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignTilesResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignTilesMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/plan-design/tiles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignTilesResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignTilesMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/plan-design/tiles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignTilesResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignTilesMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/plan-design/tiles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignTilesResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignTilesMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/plan-design/tiles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignTilesResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignTilesMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/plan-design/tiles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignTilesResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignTilesMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/plan-design/tiles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignTilesResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanParticipantsMockHandler = ()=>{
    return http.get('*/api/plan/participants', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanParticipantsMockHandler200 = ()=>{
    return http.get('*/api/plan/participants', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelMockHandler = (overrideResponse)=>{
    return http.get('*/api/plans/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/plans/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/plans/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/plans/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/plans/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/plans/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/plans/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/plans/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/plans/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/plans/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/plans/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/plans/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/plans/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/plans/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/plans/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/plans/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/plans/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/plans/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/plans/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/plans/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanMockHandler = ()=>{
    return http.patch('*/api/plans/:planId', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanMockHandler200 = ()=>{
    return http.patch('*/api/plans/:planId', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanMockHandler400 = (overrideResponse)=>{
    return http.patch('*/api/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanMockHandler401 = (overrideResponse)=>{
    return http.patch('*/api/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanMockHandler403 = (overrideResponse)=>{
    return http.patch('*/api/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanMockHandler404 = (overrideResponse)=>{
    return http.patch('*/api/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanMockHandler405 = (overrideResponse)=>{
    return http.patch('*/api/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanMockHandler406 = (overrideResponse)=>{
    return http.patch('*/api/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanMockHandler408 = (overrideResponse)=>{
    return http.patch('*/api/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanMockHandler409 = (overrideResponse)=>{
    return http.patch('*/api/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanMockHandler410 = (overrideResponse)=>{
    return http.patch('*/api/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanMockHandler412 = (overrideResponse)=>{
    return http.patch('*/api/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanMockHandler413 = (overrideResponse)=>{
    return http.patch('*/api/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanMockHandler415 = (overrideResponse)=>{
    return http.patch('*/api/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanMockHandler422 = (overrideResponse)=>{
    return http.patch('*/api/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanMockHandler500 = (overrideResponse)=>{
    return http.patch('*/api/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanMockHandler501 = (overrideResponse)=>{
    return http.patch('*/api/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanMockHandler502 = (overrideResponse)=>{
    return http.patch('*/api/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanMockHandler503 = (overrideResponse)=>{
    return http.patch('*/api/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanMockHandler504 = (overrideResponse)=>{
    return http.patch('*/api/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaProgramMockHandler = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaProgramResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaProgramMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaProgramResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaProgramMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaProgramResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaProgramMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaProgramResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaProgramMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaProgramResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaProgramMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaProgramResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaProgramMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaProgramResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaProgramMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaProgramResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaProgramMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaProgramResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaProgramMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaProgramResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaProgramMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaProgramResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaProgramMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaProgramResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaProgramMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaProgramResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaProgramMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaProgramResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaProgramMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaProgramResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaProgramMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaProgramResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaProgramMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaProgramResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaProgramMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaProgramResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaProgramMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaProgramResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaProgramMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaProgramResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanInvestmentsMockHandler = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/investments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanInvestmentsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanInvestmentsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/investments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanInvestmentsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanInvestmentsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/investments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanInvestmentsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanInvestmentsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/investments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanInvestmentsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanInvestmentsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/investments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanInvestmentsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanInvestmentsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/investments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanInvestmentsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanInvestmentsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/investments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanInvestmentsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanInvestmentsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/investments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanInvestmentsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanInvestmentsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/investments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanInvestmentsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanInvestmentsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/investments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanInvestmentsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanInvestmentsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/investments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanInvestmentsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanInvestmentsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/investments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanInvestmentsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanInvestmentsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/investments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanInvestmentsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanInvestmentsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/investments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanInvestmentsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanInvestmentsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/investments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanInvestmentsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanInvestmentsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/investments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanInvestmentsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanInvestmentsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/investments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanInvestmentsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanInvestmentsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/investments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanInvestmentsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanInvestmentsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/investments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanInvestmentsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanInvestmentsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/investments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanInvestmentsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelSecuritiesMockHandler = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/models/:modelId/securities', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelSecuritiesResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelSecuritiesMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/models/:modelId/securities', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelSecuritiesResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelSecuritiesMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/models/:modelId/securities', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelSecuritiesResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelSecuritiesMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/models/:modelId/securities', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelSecuritiesResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelSecuritiesMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/models/:modelId/securities', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelSecuritiesResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelSecuritiesMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/models/:modelId/securities', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelSecuritiesResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelSecuritiesMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/models/:modelId/securities', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelSecuritiesResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelSecuritiesMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/models/:modelId/securities', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelSecuritiesResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelSecuritiesMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/models/:modelId/securities', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelSecuritiesResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelSecuritiesMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/models/:modelId/securities', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelSecuritiesResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelSecuritiesMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/models/:modelId/securities', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelSecuritiesResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelSecuritiesMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/models/:modelId/securities', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelSecuritiesResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelSecuritiesMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/models/:modelId/securities', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelSecuritiesResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelSecuritiesMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/models/:modelId/securities', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelSecuritiesResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelSecuritiesMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/models/:modelId/securities', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelSecuritiesResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelSecuritiesMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/models/:modelId/securities', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelSecuritiesResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelSecuritiesMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/models/:modelId/securities', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelSecuritiesResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelSecuritiesMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/models/:modelId/securities', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelSecuritiesResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelSecuritiesMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/models/:modelId/securities', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelSecuritiesResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelSecuritiesMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/plans/:planId/models/:modelId/securities', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanModelSecuritiesResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelsMockHandler = (overrideResponse)=>{
    return http.get('*/api/program/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/program/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/program/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/program/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/program/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/program/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/program/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/program/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/program/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/program/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/program/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/program/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/program/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/program/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/program/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/program/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/program/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/program/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/program/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/program/models', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramInvestmentOptionsExportMockHandler = ()=>{
    return http.get('*/api/program/:programId/investment-options/download', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramInvestmentOptionsExportMockHandler200 = ()=>{
    return http.get('*/api/program/:programId/investment-options/download', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProspectusUrlPartsMockHandler = (overrideResponse)=>{
    return http.get('*/api/prospectus/url', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProspectusUrlPartsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProspectusUrlPartsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/prospectus/url', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProspectusUrlPartsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProspectusUrlPartsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/prospectus/url', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProspectusUrlPartsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProspectusUrlPartsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/prospectus/url', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProspectusUrlPartsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProspectusUrlPartsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/prospectus/url', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProspectusUrlPartsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProspectusUrlPartsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/prospectus/url', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProspectusUrlPartsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProspectusUrlPartsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/prospectus/url', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProspectusUrlPartsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProspectusUrlPartsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/prospectus/url', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProspectusUrlPartsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProspectusUrlPartsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/prospectus/url', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProspectusUrlPartsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProspectusUrlPartsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/prospectus/url', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProspectusUrlPartsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProspectusUrlPartsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/prospectus/url', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProspectusUrlPartsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProspectusUrlPartsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/prospectus/url', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProspectusUrlPartsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProspectusUrlPartsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/prospectus/url', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProspectusUrlPartsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProspectusUrlPartsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/prospectus/url', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProspectusUrlPartsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProspectusUrlPartsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/prospectus/url', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProspectusUrlPartsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProspectusUrlPartsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/prospectus/url', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProspectusUrlPartsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProspectusUrlPartsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/prospectus/url', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProspectusUrlPartsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProspectusUrlPartsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/prospectus/url', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProspectusUrlPartsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProspectusUrlPartsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/prospectus/url', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProspectusUrlPartsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProspectusUrlPartsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/prospectus/url', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProspectusUrlPartsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorReportMockHandler = ()=>{
    return http.get('*/api/reports/advisors/:advisorId/:reportType/:fileName', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorReportMockHandler200 = ()=>{
    return http.get('*/api/reports/advisors/:advisorId/:reportType/:fileName', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeReportMockHandler = ()=>{
    return http.get('*/api/reports/employees/:employeeId/:reportType/:fileName', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeReportMockHandler200 = ()=>{
    return http.get('*/api/reports/employees/:employeeId/:reportType/:fileName', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsReportMockHandler = ()=>{
    return http.get('*/api/reports/participants/unregistered', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsReportMockHandler200 = ()=>{
    return http.get('*/api/reports/participants/unregistered', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanReportMockHandler = ()=>{
    return http.get('*/api/reports/plans/:planId/:reportType/:fileName', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanReportMockHandler200 = ()=>{
    return http.get('*/api/reports/plans/:planId/:reportType/:fileName', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorReportMockHandler = ()=>{
    return http.get('*/api/reports/sponsors/:sponsorId/:reportType/:fileName', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorReportMockHandler200 = ()=>{
    return http.get('*/api/reports/sponsors/:sponsorId/:reportType/:fileName', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaTransactionsReportMockHandler = ()=>{
    return http.get('*/api/reports/suba-transactions', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaTransactionsReportMockHandler200 = ()=>{
    return http.get('*/api/reports/suba-transactions', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllSafeHarborContributionTypesMockHandler = (overrideResponse)=>{
    return http.get('*/api/safe-harbor-contribution-types', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllSafeHarborContributionTypesResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllSafeHarborContributionTypesMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/safe-harbor-contribution-types', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllSafeHarborContributionTypesResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllSafeHarborContributionTypesMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/safe-harbor-contribution-types', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllSafeHarborContributionTypesResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllSafeHarborContributionTypesMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/safe-harbor-contribution-types', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllSafeHarborContributionTypesResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllSafeHarborContributionTypesMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/safe-harbor-contribution-types', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllSafeHarborContributionTypesResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllSafeHarborContributionTypesMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/safe-harbor-contribution-types', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllSafeHarborContributionTypesResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllSafeHarborContributionTypesMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/safe-harbor-contribution-types', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllSafeHarborContributionTypesResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllSafeHarborContributionTypesMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/safe-harbor-contribution-types', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllSafeHarborContributionTypesResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllSafeHarborContributionTypesMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/safe-harbor-contribution-types', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllSafeHarborContributionTypesResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllSafeHarborContributionTypesMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/safe-harbor-contribution-types', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllSafeHarborContributionTypesResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllSafeHarborContributionTypesMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/safe-harbor-contribution-types', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllSafeHarborContributionTypesResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllSafeHarborContributionTypesMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/safe-harbor-contribution-types', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllSafeHarborContributionTypesResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllSafeHarborContributionTypesMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/safe-harbor-contribution-types', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllSafeHarborContributionTypesResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllSafeHarborContributionTypesMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/safe-harbor-contribution-types', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllSafeHarborContributionTypesResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllSafeHarborContributionTypesMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/safe-harbor-contribution-types', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllSafeHarborContributionTypesResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllSafeHarborContributionTypesMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/safe-harbor-contribution-types', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllSafeHarborContributionTypesResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllSafeHarborContributionTypesMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/safe-harbor-contribution-types', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllSafeHarborContributionTypesResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllSafeHarborContributionTypesMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/safe-harbor-contribution-types', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllSafeHarborContributionTypesResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllSafeHarborContributionTypesMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/safe-harbor-contribution-types', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllSafeHarborContributionTypesResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllSafeHarborContributionTypesMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/safe-harbor-contribution-types', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllSafeHarborContributionTypesResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaExternalMarketValueMockHandler = (overrideResponse)=>{
    return http.get('*/api/sdba/external-market-value', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaExternalMarketValueResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaExternalMarketValueMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sdba/external-market-value', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaExternalMarketValueResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaExternalMarketValueMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sdba/external-market-value', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaExternalMarketValueResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaExternalMarketValueMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sdba/external-market-value', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaExternalMarketValueResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaExternalMarketValueMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sdba/external-market-value', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaExternalMarketValueResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaExternalMarketValueMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sdba/external-market-value', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaExternalMarketValueResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaExternalMarketValueMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sdba/external-market-value', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaExternalMarketValueResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaExternalMarketValueMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sdba/external-market-value', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaExternalMarketValueResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaExternalMarketValueMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sdba/external-market-value', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaExternalMarketValueResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaExternalMarketValueMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sdba/external-market-value', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaExternalMarketValueResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaExternalMarketValueMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sdba/external-market-value', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaExternalMarketValueResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaExternalMarketValueMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sdba/external-market-value', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaExternalMarketValueResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaExternalMarketValueMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sdba/external-market-value', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaExternalMarketValueResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaExternalMarketValueMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sdba/external-market-value', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaExternalMarketValueResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaExternalMarketValueMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sdba/external-market-value', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaExternalMarketValueResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaExternalMarketValueMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sdba/external-market-value', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaExternalMarketValueResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaExternalMarketValueMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sdba/external-market-value', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaExternalMarketValueResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaExternalMarketValueMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sdba/external-market-value', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaExternalMarketValueResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaExternalMarketValueMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sdba/external-market-value', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaExternalMarketValueResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaExternalMarketValueMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sdba/external-market-value', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaExternalMarketValueResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSubaInitiateExternalTransferMockHandler = ()=>{
    return http.post('*/api/sdba/initiate-external-transfer', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSubaInitiateExternalTransferMockHandler200 = ()=>{
    return http.post('*/api/sdba/initiate-external-transfer', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSubaInitiateExternalTransferMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/sdba/initiate-external-transfer', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSubaInitiateExternalTransferResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSubaInitiateExternalTransferMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/sdba/initiate-external-transfer', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSubaInitiateExternalTransferResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSubaInitiateExternalTransferMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/sdba/initiate-external-transfer', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSubaInitiateExternalTransferResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSubaInitiateExternalTransferMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/sdba/initiate-external-transfer', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSubaInitiateExternalTransferResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSubaInitiateExternalTransferMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/sdba/initiate-external-transfer', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSubaInitiateExternalTransferResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSubaInitiateExternalTransferMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/sdba/initiate-external-transfer', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSubaInitiateExternalTransferResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSubaInitiateExternalTransferMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/sdba/initiate-external-transfer', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSubaInitiateExternalTransferResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSubaInitiateExternalTransferMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/sdba/initiate-external-transfer', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSubaInitiateExternalTransferResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSubaInitiateExternalTransferMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/sdba/initiate-external-transfer', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSubaInitiateExternalTransferResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSubaInitiateExternalTransferMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/sdba/initiate-external-transfer', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSubaInitiateExternalTransferResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSubaInitiateExternalTransferMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/sdba/initiate-external-transfer', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSubaInitiateExternalTransferResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSubaInitiateExternalTransferMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/sdba/initiate-external-transfer', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSubaInitiateExternalTransferResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSubaInitiateExternalTransferMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/sdba/initiate-external-transfer', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSubaInitiateExternalTransferResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSubaInitiateExternalTransferMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/sdba/initiate-external-transfer', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSubaInitiateExternalTransferResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSubaInitiateExternalTransferMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/sdba/initiate-external-transfer', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSubaInitiateExternalTransferResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSubaInitiateExternalTransferMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/sdba/initiate-external-transfer', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSubaInitiateExternalTransferResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSubaInitiateExternalTransferMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/sdba/initiate-external-transfer', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSubaInitiateExternalTransferResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSubaInitiateExternalTransferMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/sdba/initiate-external-transfer', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSubaInitiateExternalTransferResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaSetupMockHandler = (overrideResponse)=>{
    return http.get('*/api/sdba/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaSetupResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaSetupMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sdba/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaSetupResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaSetupMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sdba/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaSetupResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaSetupMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sdba/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaSetupResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaSetupMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sdba/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaSetupResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaSetupMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sdba/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaSetupResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaSetupMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sdba/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaSetupResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaSetupMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sdba/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaSetupResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaSetupMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sdba/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaSetupResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaSetupMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sdba/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaSetupResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaSetupMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sdba/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaSetupResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaSetupMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sdba/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaSetupResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaSetupMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sdba/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaSetupResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaSetupMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sdba/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaSetupResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaSetupMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sdba/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaSetupResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaSetupMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sdba/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaSetupResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaSetupMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sdba/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaSetupResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaSetupMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sdba/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaSetupResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaSetupMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sdba/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaSetupResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaSetupMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sdba/setup', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaSetupResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaTransfersInfoMockHandler = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaTransfersInfoResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaTransfersInfoMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaTransfersInfoResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaTransfersInfoMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaTransfersInfoResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaTransfersInfoMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaTransfersInfoResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaTransfersInfoMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaTransfersInfoResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaTransfersInfoMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaTransfersInfoResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaTransfersInfoMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaTransfersInfoResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaTransfersInfoMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaTransfersInfoResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaTransfersInfoMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaTransfersInfoResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaTransfersInfoMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaTransfersInfoResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaTransfersInfoMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaTransfersInfoResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaTransfersInfoMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaTransfersInfoResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaTransfersInfoMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaTransfersInfoResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaTransfersInfoMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaTransfersInfoResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaTransfersInfoMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaTransfersInfoResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaTransfersInfoMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaTransfersInfoResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaTransfersInfoMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaTransfersInfoResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaTransfersInfoMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaTransfersInfoResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaTransfersInfoMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaTransfersInfoResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSdbaTransfersInfoMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSdbaTransfersInfoResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCheckActiveSdbaTransfersMockHandler = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers-in-progress', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCheckActiveSdbaTransfersResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCheckActiveSdbaTransfersMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers-in-progress', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCheckActiveSdbaTransfersResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCheckActiveSdbaTransfersMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers-in-progress', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCheckActiveSdbaTransfersResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCheckActiveSdbaTransfersMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers-in-progress', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCheckActiveSdbaTransfersResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCheckActiveSdbaTransfersMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers-in-progress', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCheckActiveSdbaTransfersResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCheckActiveSdbaTransfersMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers-in-progress', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCheckActiveSdbaTransfersResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCheckActiveSdbaTransfersMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers-in-progress', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCheckActiveSdbaTransfersResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCheckActiveSdbaTransfersMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers-in-progress', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCheckActiveSdbaTransfersResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCheckActiveSdbaTransfersMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers-in-progress', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCheckActiveSdbaTransfersResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCheckActiveSdbaTransfersMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers-in-progress', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCheckActiveSdbaTransfersResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCheckActiveSdbaTransfersMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers-in-progress', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCheckActiveSdbaTransfersResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCheckActiveSdbaTransfersMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers-in-progress', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCheckActiveSdbaTransfersResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCheckActiveSdbaTransfersMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers-in-progress', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCheckActiveSdbaTransfersResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCheckActiveSdbaTransfersMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers-in-progress', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCheckActiveSdbaTransfersResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCheckActiveSdbaTransfersMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers-in-progress', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCheckActiveSdbaTransfersResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCheckActiveSdbaTransfersMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers-in-progress', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCheckActiveSdbaTransfersResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCheckActiveSdbaTransfersMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers-in-progress', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCheckActiveSdbaTransfersResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCheckActiveSdbaTransfersMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers-in-progress', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCheckActiveSdbaTransfersResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCheckActiveSdbaTransfersMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers-in-progress', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCheckActiveSdbaTransfersResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCheckActiveSdbaTransfersMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sdba/transfers-in-progress', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCheckActiveSdbaTransfersResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSessionMockHandler = ()=>{
    return http.get('*/api/session', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSessionMockHandler200 = ()=>{
    return http.get('*/api/session', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorAbilitiesMockHandler = ()=>{
    return http.get('*/api/sponsor/abilities', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorAbilitiesMockHandler200 = ()=>{
    return http.get('*/api/sponsor/abilities', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAutoEnrollSponsorPlanMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/auto-enroll', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAutoEnrollSponsorPlanResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAutoEnrollSponsorPlanMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/auto-enroll', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAutoEnrollSponsorPlanResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAutoEnrollSponsorPlanMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/auto-enroll', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAutoEnrollSponsorPlanResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAutoEnrollSponsorPlanMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/auto-enroll', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAutoEnrollSponsorPlanResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAutoEnrollSponsorPlanMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/auto-enroll', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAutoEnrollSponsorPlanResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAutoEnrollSponsorPlanMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/auto-enroll', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAutoEnrollSponsorPlanResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAutoEnrollSponsorPlanMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/auto-enroll', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAutoEnrollSponsorPlanResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAutoEnrollSponsorPlanMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/auto-enroll', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAutoEnrollSponsorPlanResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAutoEnrollSponsorPlanMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/auto-enroll', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAutoEnrollSponsorPlanResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAutoEnrollSponsorPlanMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/auto-enroll', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAutoEnrollSponsorPlanResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAutoEnrollSponsorPlanMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/auto-enroll', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAutoEnrollSponsorPlanResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAutoEnrollSponsorPlanMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/auto-enroll', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAutoEnrollSponsorPlanResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAutoEnrollSponsorPlanMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/auto-enroll', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAutoEnrollSponsorPlanResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAutoEnrollSponsorPlanMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/auto-enroll', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAutoEnrollSponsorPlanResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAutoEnrollSponsorPlanMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/auto-enroll', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAutoEnrollSponsorPlanResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAutoEnrollSponsorPlanMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/auto-enroll', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAutoEnrollSponsorPlanResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAutoEnrollSponsorPlanMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/auto-enroll', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAutoEnrollSponsorPlanResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAutoEnrollSponsorPlanMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/auto-enroll', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAutoEnrollSponsorPlanResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAutoEnrollSponsorPlanMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/auto-enroll', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAutoEnrollSponsorPlanResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAutoEnrollSponsorPlanMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/auto-enroll', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAutoEnrollSponsorPlanResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusParticipantsMockHandler = ()=>{
    return http.get('*/api/sponsor/census/participants', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusParticipantsMockHandler200 = ()=>{
    return http.get('*/api/sponsor/census/participants', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetBankAccountMockHandler = ()=>{
    return http.get('*/api/sponsor/company/bank-account', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetBankAccountMockHandler200 = ()=>{
    return http.get('*/api/sponsor/company/bank-account', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostBankAccountMockHandler = ()=>{
    return http.post('*/api/sponsor/company/bank-account', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostBankAccountMockHandler201 = ()=>{
    return http.post('*/api/sponsor/company/bank-account', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutBankAccountMockHandler = ()=>{
    return http.put('*/api/sponsor/company/bank-account', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutBankAccountMockHandler200 = ()=>{
    return http.put('*/api/sponsor/company/bank-account', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSponsorArchiveBankAccountMockHandler = ()=>{
    return http.put('*/api/sponsor/company/bank-account/archive', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSponsorArchiveBankAccountMockHandler200 = ()=>{
    return http.put('*/api/sponsor/company/bank-account/archive', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutFeePaymentMethodMockHandler = ()=>{
    return http.put('*/api/sponsor/company/bank-account/fee-payment-method', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutFeePaymentMethodMockHandler200 = ()=>{
    return http.put('*/api/sponsor/company/bank-account/fee-payment-method', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchSponsorMockHandler = ()=>{
    return http.patch('*/api/sponsor/company/company-info', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchSponsorMockHandler200 = ()=>{
    return http.patch('*/api/sponsor/company/company-info', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorTeammatesMockHandler = ()=>{
    return http.get('*/api/sponsor/company/manage-teammate', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorTeammatesMockHandler200 = ()=>{
    return http.get('*/api/sponsor/company/manage-teammate', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDeleteTeammateMockHandler = ()=>{
    return http.patch('*/api/sponsor/company/manage-teammate', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDeleteTeammateMockHandler200 = ()=>{
    return http.patch('*/api/sponsor/company/manage-teammate', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSendUserInviteMockHandler = ()=>{
    return http.post('*/api/sponsor/company/manage-teammate', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSendUserInviteMockHandler201 = ()=>{
    return http.post('*/api/sponsor/company/manage-teammate', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationV2MockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationV2ResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationV2MockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationV2ResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationV2MockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationV2ResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationV2MockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationV2ResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationV2MockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationV2ResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationV2MockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationV2ResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationV2MockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationV2ResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationV2MockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationV2ResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationV2MockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationV2ResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationV2MockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationV2ResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationV2MockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationV2ResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationV2MockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationV2ResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationV2MockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationV2ResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationV2MockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationV2ResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationV2MockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationV2ResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationV2MockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationV2ResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationV2MockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationV2ResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationV2MockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationV2ResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationV2MockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationV2ResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationV2MockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationV2ResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationV2MockHandler = ()=>{
    return http.put('*/api/sponsor/compliance/configuration', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationV2MockHandler200 = ()=>{
    return http.put('*/api/sponsor/compliance/configuration', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationV2MockHandler400 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationV2ResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationV2MockHandler401 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationV2ResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationV2MockHandler403 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationV2ResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationV2MockHandler404 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationV2ResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationV2MockHandler405 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationV2ResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationV2MockHandler406 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationV2ResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationV2MockHandler408 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationV2ResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationV2MockHandler409 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationV2ResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationV2MockHandler410 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationV2ResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationV2MockHandler412 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationV2ResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationV2MockHandler413 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationV2ResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationV2MockHandler415 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationV2ResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationV2MockHandler422 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationV2ResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationV2MockHandler500 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationV2ResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationV2MockHandler501 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationV2ResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationV2MockHandler502 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationV2ResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationV2MockHandler503 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationV2ResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationV2MockHandler504 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationV2ResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesV2MockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesV2ResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesV2MockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesV2ResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesV2MockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesV2ResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesV2MockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesV2ResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesV2MockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesV2ResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesV2MockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesV2ResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesV2MockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesV2ResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesV2MockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesV2ResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesV2MockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesV2ResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesV2MockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesV2ResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesV2MockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesV2ResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesV2MockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesV2ResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesV2MockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesV2ResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesV2MockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesV2ResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesV2MockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesV2ResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesV2MockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesV2ResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesV2MockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesV2ResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesV2MockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesV2ResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesV2MockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesV2ResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesV2MockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesV2ResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationV2MockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationV2ResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationV2MockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationV2ResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationV2MockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationV2ResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationV2MockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationV2ResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationV2MockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationV2ResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationV2MockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationV2ResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationV2MockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationV2ResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationV2MockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationV2ResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationV2MockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationV2ResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationV2MockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationV2ResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationV2MockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationV2ResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationV2MockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationV2ResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationV2MockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationV2ResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationV2MockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationV2ResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationV2MockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationV2ResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationV2MockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationV2ResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationV2MockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationV2ResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationV2MockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationV2ResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationV2MockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationV2ResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationV2MockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationV2ResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationV2MockHandler = ()=>{
    return http.put('*/api/sponsor/compliance/gross-compensation', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationV2MockHandler200 = ()=>{
    return http.put('*/api/sponsor/compliance/gross-compensation', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationV2MockHandler400 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationV2ResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationV2MockHandler401 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationV2ResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationV2MockHandler403 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationV2ResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationV2MockHandler404 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationV2ResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationV2MockHandler405 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationV2ResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationV2MockHandler406 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationV2ResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationV2MockHandler408 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationV2ResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationV2MockHandler409 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationV2ResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationV2MockHandler410 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationV2ResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationV2MockHandler412 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationV2ResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationV2MockHandler413 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationV2ResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationV2MockHandler415 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationV2ResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationV2MockHandler422 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationV2ResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationV2MockHandler500 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationV2ResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationV2MockHandler501 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationV2ResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationV2MockHandler502 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationV2ResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationV2MockHandler503 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationV2ResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationV2MockHandler504 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationV2ResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGrossCompensationTemplateV2MockHandler = ()=>{
    return http.get('*/api/sponsor/compliance/gross-compensation/download/template', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGrossCompensationTemplateV2MockHandler200 = ()=>{
    return http.get('*/api/sponsor/compliance/gross-compensation/download/template', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadV2MockHandler = ()=>{
    return http.post('*/api/sponsor/compliance/gross-compensation/upload', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadV2MockHandler200 = ()=>{
    return http.post('*/api/sponsor/compliance/gross-compensation/upload', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadV2MockHandler400 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadV2ResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadV2MockHandler401 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadV2ResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadV2MockHandler403 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadV2ResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadV2MockHandler404 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadV2ResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadV2MockHandler405 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadV2ResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadV2MockHandler406 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadV2ResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadV2MockHandler408 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadV2ResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadV2MockHandler409 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadV2ResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadV2MockHandler410 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadV2ResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadV2MockHandler412 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadV2ResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadV2MockHandler413 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadV2ResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadV2MockHandler415 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadV2ResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadV2MockHandler422 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadV2ResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadV2MockHandler500 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadV2ResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadV2MockHandler501 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadV2ResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadV2MockHandler502 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadV2ResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadV2MockHandler503 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadV2ResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadV2MockHandler504 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadV2ResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerV2MockHandler = ()=>{
    return http.post('*/api/sponsor/compliance/non-employee-owner', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerV2MockHandler200 = ()=>{
    return http.post('*/api/sponsor/compliance/non-employee-owner', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerV2MockHandler400 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerV2ResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerV2MockHandler401 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerV2ResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerV2MockHandler403 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerV2ResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerV2MockHandler404 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerV2ResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerV2MockHandler405 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerV2ResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerV2MockHandler406 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerV2ResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerV2MockHandler408 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerV2ResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerV2MockHandler409 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerV2ResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerV2MockHandler410 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerV2ResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerV2MockHandler412 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerV2ResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerV2MockHandler413 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerV2ResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerV2MockHandler415 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerV2ResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerV2MockHandler422 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerV2ResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerV2MockHandler500 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerV2ResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerV2MockHandler501 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerV2ResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerV2MockHandler502 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerV2ResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerV2MockHandler503 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerV2ResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerV2MockHandler504 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerV2ResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersV2MockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersV2ResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersV2MockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersV2ResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersV2MockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersV2ResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersV2MockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersV2ResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersV2MockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersV2ResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersV2MockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersV2ResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersV2MockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersV2ResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersV2MockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersV2ResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersV2MockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersV2ResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersV2MockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersV2ResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersV2MockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersV2ResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersV2MockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersV2ResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersV2MockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersV2ResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersV2MockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersV2ResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersV2MockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersV2ResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersV2MockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersV2ResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersV2MockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersV2ResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersV2MockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersV2ResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersV2MockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersV2ResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersV2MockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersV2ResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusV2MockHandler = ()=>{
    return http.put('*/api/sponsor/compliance/officers', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusV2MockHandler200 = ()=>{
    return http.put('*/api/sponsor/compliance/officers', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusV2MockHandler400 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusV2ResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusV2MockHandler401 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusV2ResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusV2MockHandler403 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusV2ResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusV2MockHandler404 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusV2ResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusV2MockHandler405 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusV2ResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusV2MockHandler406 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusV2ResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusV2MockHandler408 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusV2ResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusV2MockHandler409 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusV2ResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusV2MockHandler410 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusV2ResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusV2MockHandler412 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusV2ResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusV2MockHandler413 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusV2ResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusV2MockHandler415 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusV2ResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusV2MockHandler422 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusV2ResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusV2MockHandler500 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusV2ResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusV2MockHandler501 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusV2ResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusV2MockHandler502 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusV2ResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusV2MockHandler503 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusV2ResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusV2MockHandler504 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusV2ResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerV2MockHandler = ()=>{
    return http.delete('*/api/sponsor/compliance/owners', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerV2MockHandler200 = ()=>{
    return http.delete('*/api/sponsor/compliance/owners', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerV2MockHandler400 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerV2ResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerV2MockHandler401 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerV2ResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerV2MockHandler403 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerV2ResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerV2MockHandler404 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerV2ResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerV2MockHandler405 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerV2ResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerV2MockHandler406 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerV2ResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerV2MockHandler408 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerV2ResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerV2MockHandler409 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerV2ResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerV2MockHandler410 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerV2ResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerV2MockHandler412 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerV2ResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerV2MockHandler413 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerV2ResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerV2MockHandler415 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerV2ResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerV2MockHandler422 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerV2ResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerV2MockHandler500 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerV2ResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerV2MockHandler501 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerV2ResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerV2MockHandler502 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerV2ResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerV2MockHandler503 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerV2ResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerV2MockHandler504 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerV2ResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersV2MockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersV2ResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersV2MockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersV2ResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersV2MockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersV2ResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersV2MockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersV2ResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersV2MockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersV2ResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersV2MockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersV2ResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersV2MockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersV2ResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersV2MockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersV2ResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersV2MockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersV2ResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersV2MockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersV2ResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersV2MockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersV2ResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersV2MockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersV2ResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersV2MockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersV2ResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersV2MockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersV2ResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersV2MockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersV2ResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersV2MockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersV2ResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersV2MockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersV2ResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersV2MockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersV2ResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersV2MockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersV2ResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersV2MockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersV2ResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerV2MockHandler = ()=>{
    return http.post('*/api/sponsor/compliance/owners', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerV2MockHandler200 = ()=>{
    return http.post('*/api/sponsor/compliance/owners', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerV2MockHandler400 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerV2ResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerV2MockHandler401 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerV2ResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerV2MockHandler403 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerV2ResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerV2MockHandler404 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerV2ResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerV2MockHandler405 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerV2ResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerV2MockHandler406 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerV2ResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerV2MockHandler408 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerV2ResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerV2MockHandler409 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerV2ResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerV2MockHandler410 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerV2ResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerV2MockHandler412 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerV2ResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerV2MockHandler413 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerV2ResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerV2MockHandler415 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerV2ResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerV2MockHandler422 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerV2ResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerV2MockHandler500 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerV2ResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerV2MockHandler501 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerV2ResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerV2MockHandler502 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerV2ResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerV2MockHandler503 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerV2ResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerV2MockHandler504 = (overrideResponse)=>{
    return http.post('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerV2ResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerV2MockHandler = ()=>{
    return http.put('*/api/sponsor/compliance/owners', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerV2MockHandler200 = ()=>{
    return http.put('*/api/sponsor/compliance/owners', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerV2MockHandler400 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerV2ResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerV2MockHandler401 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerV2ResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerV2MockHandler403 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerV2ResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerV2MockHandler404 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerV2ResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerV2MockHandler405 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerV2ResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerV2MockHandler406 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerV2ResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerV2MockHandler408 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerV2ResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerV2MockHandler409 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerV2ResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerV2MockHandler410 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerV2ResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerV2MockHandler412 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerV2ResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerV2MockHandler413 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerV2ResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerV2MockHandler415 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerV2ResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerV2MockHandler422 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerV2ResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerV2MockHandler500 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerV2ResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerV2MockHandler501 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerV2ResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerV2MockHandler502 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerV2ResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerV2MockHandler503 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerV2ResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerV2MockHandler504 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerV2ResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyV2MockHandler = ()=>{
    return http.delete('*/api/sponsor/compliance/owners-family', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyV2MockHandler200 = ()=>{
    return http.delete('*/api/sponsor/compliance/owners-family', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyV2MockHandler400 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyV2ResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyV2MockHandler401 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyV2ResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyV2MockHandler403 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyV2ResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyV2MockHandler404 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyV2ResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyV2MockHandler405 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyV2ResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyV2MockHandler406 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyV2ResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyV2MockHandler408 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyV2ResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyV2MockHandler409 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyV2ResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyV2MockHandler410 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyV2ResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyV2MockHandler412 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyV2ResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyV2MockHandler413 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyV2ResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyV2MockHandler415 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyV2ResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyV2MockHandler422 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyV2ResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyV2MockHandler500 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyV2ResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyV2MockHandler501 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyV2ResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyV2MockHandler502 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyV2ResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyV2MockHandler503 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyV2ResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyV2MockHandler504 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyV2ResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyV2MockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyV2ResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyV2MockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyV2ResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyV2MockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyV2ResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyV2MockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyV2ResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyV2MockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyV2ResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyV2MockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyV2ResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyV2MockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyV2ResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyV2MockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyV2ResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyV2MockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyV2ResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyV2MockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyV2ResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyV2MockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyV2ResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyV2MockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyV2ResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyV2MockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyV2ResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyV2MockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyV2ResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyV2MockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyV2ResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyV2MockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyV2ResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyV2MockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyV2ResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyV2MockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyV2ResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyV2MockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyV2ResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyV2MockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyV2ResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyV2MockHandler = ()=>{
    return http.put('*/api/sponsor/compliance/owners-family', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyV2MockHandler200 = ()=>{
    return http.put('*/api/sponsor/compliance/owners-family', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyV2MockHandler400 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyV2ResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyV2MockHandler401 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyV2ResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyV2MockHandler403 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyV2ResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyV2MockHandler404 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyV2ResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyV2MockHandler405 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyV2ResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyV2MockHandler406 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyV2ResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyV2MockHandler408 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyV2ResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyV2MockHandler409 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyV2ResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyV2MockHandler410 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyV2ResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyV2MockHandler412 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyV2ResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyV2MockHandler413 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyV2ResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyV2MockHandler415 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyV2ResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyV2MockHandler422 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyV2ResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyV2MockHandler500 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyV2ResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyV2MockHandler501 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyV2ResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyV2MockHandler502 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyV2ResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyV2MockHandler503 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyV2ResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyV2MockHandler504 = (overrideResponse)=>{
    return http.put('*/api/sponsor/compliance/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyV2ResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostFileHeadersUpdateMockHandler = ()=>{
    return http.post('*/api/sponsor/contribution/headers/mapping', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostFileHeadersUpdateMockHandler201 = ()=>{
    return http.post('*/api/sponsor/contribution/headers/mapping', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionsLandingPageDisplayMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionsLandingPageDisplayMockHandler200 = ()=>{
    return http.get('*/api/sponsor/contributions', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionMockHandler = ()=>{
    return http.post('*/api/sponsor/contributions', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionMockHandler201 = ()=>{
    return http.post('*/api/sponsor/contributions', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCancelSubmissionMockHandler = ()=>{
    return http.post('*/api/sponsor/contributions/cancel', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCancelSubmissionMockHandler201 = ()=>{
    return http.post('*/api/sponsor/contributions/cancel', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCancellationSubmissionMockHandler = ()=>{
    return http.post('*/api/sponsor/contributions/cancellation', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCancellationSubmissionMockHandler201 = ()=>{
    return http.post('*/api/sponsor/contributions/cancellation', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantsLoansMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/loans', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantsLoansMockHandler200 = ()=>{
    return http.get('*/api/sponsor/contributions/loans', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMatchRemediationContributionMockHandler = (overrideResponse)=>{
    return http.post('*/api/sponsor/contributions/match-remediation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMatchRemediationContributionResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMatchRemediationContributionMockHandler200 = (overrideResponse)=>{
    return http.post('*/api/sponsor/contributions/match-remediation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMatchRemediationContributionResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMatchRemediationContributionMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/sponsor/contributions/match-remediation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMatchRemediationContributionResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMatchRemediationContributionMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/sponsor/contributions/match-remediation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMatchRemediationContributionResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMatchRemediationContributionMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/sponsor/contributions/match-remediation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMatchRemediationContributionResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMatchRemediationContributionMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/sponsor/contributions/match-remediation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMatchRemediationContributionResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMatchRemediationContributionMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/sponsor/contributions/match-remediation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMatchRemediationContributionResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMatchRemediationContributionMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/sponsor/contributions/match-remediation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMatchRemediationContributionResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMatchRemediationContributionMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/sponsor/contributions/match-remediation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMatchRemediationContributionResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMatchRemediationContributionMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/sponsor/contributions/match-remediation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMatchRemediationContributionResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMatchRemediationContributionMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/sponsor/contributions/match-remediation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMatchRemediationContributionResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMatchRemediationContributionMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/sponsor/contributions/match-remediation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMatchRemediationContributionResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMatchRemediationContributionMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/sponsor/contributions/match-remediation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMatchRemediationContributionResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMatchRemediationContributionMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/sponsor/contributions/match-remediation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMatchRemediationContributionResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMatchRemediationContributionMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/sponsor/contributions/match-remediation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMatchRemediationContributionResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMatchRemediationContributionMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/sponsor/contributions/match-remediation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMatchRemediationContributionResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMatchRemediationContributionMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/sponsor/contributions/match-remediation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMatchRemediationContributionResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMatchRemediationContributionMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/sponsor/contributions/match-remediation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMatchRemediationContributionResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMatchRemediationContributionMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/sponsor/contributions/match-remediation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMatchRemediationContributionResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostMatchRemediationContributionMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/sponsor/contributions/match-remediation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostMatchRemediationContributionResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostOffCycleContributionMockHandler = ()=>{
    return http.post('*/api/sponsor/contributions/offcycle', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostOffCycleContributionMockHandler201 = ()=>{
    return http.post('*/api/sponsor/contributions/offcycle', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostResumeSubmissionMockHandler = ()=>{
    return http.post('*/api/sponsor/contributions/resume', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostResumeSubmissionMockHandler201 = ()=>{
    return http.post('*/api/sponsor/contributions/resume', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostIngestionFlowValidationMockHandler = ()=>{
    return http.post('*/api/sponsor/contributions/validate', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostIngestionFlowValidationMockHandler201 = ()=>{
    return http.post('*/api/sponsor/contributions/validate', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionValidationMockHandler = ()=>{
    return http.post('*/api/sponsor/contributions/validation', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionValidationMockHandler201 = ()=>{
    return http.post('*/api/sponsor/contributions/validation', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionSubmissionDisplayMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionSubmissionDisplayMockHandler200 = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionAdjustmentsMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/contributions/:ucid/adjustments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetContributionAdjustmentsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionAdjustmentsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/contributions/:ucid/adjustments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetContributionAdjustmentsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionAdjustmentsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/contributions/:ucid/adjustments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetContributionAdjustmentsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionAdjustmentsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/contributions/:ucid/adjustments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetContributionAdjustmentsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionAdjustmentsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/contributions/:ucid/adjustments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetContributionAdjustmentsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionAdjustmentsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/contributions/:ucid/adjustments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetContributionAdjustmentsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionAdjustmentsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/contributions/:ucid/adjustments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetContributionAdjustmentsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionAdjustmentsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/contributions/:ucid/adjustments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetContributionAdjustmentsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionAdjustmentsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/contributions/:ucid/adjustments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetContributionAdjustmentsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionAdjustmentsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/contributions/:ucid/adjustments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetContributionAdjustmentsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionAdjustmentsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/contributions/:ucid/adjustments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetContributionAdjustmentsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionAdjustmentsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/contributions/:ucid/adjustments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetContributionAdjustmentsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionAdjustmentsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/contributions/:ucid/adjustments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetContributionAdjustmentsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionAdjustmentsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/contributions/:ucid/adjustments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetContributionAdjustmentsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionAdjustmentsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/contributions/:ucid/adjustments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetContributionAdjustmentsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionAdjustmentsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/contributions/:ucid/adjustments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetContributionAdjustmentsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionAdjustmentsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/contributions/:ucid/adjustments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetContributionAdjustmentsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionAdjustmentsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/contributions/:ucid/adjustments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetContributionAdjustmentsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionAdjustmentsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/contributions/:ucid/adjustments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetContributionAdjustmentsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionAdjustmentsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/contributions/:ucid/adjustments', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetContributionAdjustmentsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionConfirmationMockHandler = ()=>{
    return http.post('*/api/sponsor/contributions/:ucid/confirm', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionConfirmationMockHandler201 = ()=>{
    return http.post('*/api/sponsor/contributions/:ucid/confirm', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionConfirmationDisplayMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/confirmation', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionConfirmationDisplayMockHandler200 = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/confirmation', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionCorrectionMockHandler = ()=>{
    return http.post('*/api/sponsor/contributions/:ucid/correction', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionCorrectionMockHandler201 = ()=>{
    return http.post('*/api/sponsor/contributions/:ucid/correction', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionCorrectionsMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/corrections', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionCorrectionsMockHandler200 = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/corrections', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionDetailsMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/details', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionDetailsMockHandler200 = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/details', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionDisplayMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/display', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionDisplayMockHandler200 = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/display', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionUploadMockHandler = ()=>{
    return http.post('*/api/sponsor/contributions/:ucid/document-category/:categoryId/upload', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionUploadMockHandler201 = ()=>{
    return http.post('*/api/sponsor/contributions/:ucid/document-category/:categoryId/upload', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDownloadContributionFileMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/file', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDownloadContributionFileMockHandler200 = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/file', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetForfeitureMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/forfeiture', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetForfeitureMockHandler200 = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/forfeiture', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostForfeitureMockHandler = ()=>{
    return http.post('*/api/sponsor/contributions/:ucid/forfeiture', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostForfeitureMockHandler201 = ()=>{
    return http.post('*/api/sponsor/contributions/:ucid/forfeiture', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionHeaderValidationsMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/headers', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionHeaderValidationsMockHandler200 = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/headers', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetNormalizedContributionDataMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/normalized', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetNormalizedContributionDataMockHandler200 = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/normalized', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostIngestionFlowStartMockHandler = ()=>{
    return http.post('*/api/sponsor/contributions/:ucid/start', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostIngestionFlowStartMockHandler201 = ()=>{
    return http.post('*/api/sponsor/contributions/:ucid/start', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDownloadContributionTemplateMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/template.xlsx', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDownloadContributionTemplateMockHandler200 = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/template.xlsx', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionValidationPageDisplayMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/validate', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionValidationPageDisplayMockHandler200 = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/validate', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionValidationMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/validation', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionValidationMockHandler200 = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/validation', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDeferralChangesMockHandler = ()=>{
    return http.get('*/api/sponsor/deferral/changes', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDeferralChangesMockHandler200 = ()=>{
    return http.get('*/api/sponsor/deferral/changes', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDeferralChangesActivitiesMockHandler = ()=>{
    return http.patch('*/api/sponsor/deferral/changes', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDeferralChangesActivitiesMockHandler200 = ()=>{
    return http.patch('*/api/sponsor/deferral/changes', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantMockHandler = ()=>{
    return http.put('*/api/sponsor/employee', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantMockHandler200 = ()=>{
    return http.put('*/api/sponsor/employee', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeClassesMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/employee-classes', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeClassesResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeClassesMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employee-classes', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeClassesResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeClassesMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employee-classes', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeClassesResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeClassesMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employee-classes', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeClassesResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeClassesMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employee-classes', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeClassesResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeClassesMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employee-classes', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeClassesResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeClassesMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employee-classes', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeClassesResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeClassesMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employee-classes', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeClassesResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeClassesMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employee-classes', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeClassesResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeClassesMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employee-classes', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeClassesResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeClassesMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employee-classes', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeClassesResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeClassesMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employee-classes', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeClassesResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeClassesMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employee-classes', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeClassesResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeClassesMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employee-classes', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeClassesResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeClassesMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employee-classes', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeClassesResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeClassesMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employee-classes', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeClassesResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeClassesMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employee-classes', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeClassesResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeClassesMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employee-classes', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeClassesResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeClassesMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employee-classes', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeClassesResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeClassesMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employee-classes', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeClassesResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeesMockHandler = ()=>{
    return http.get('*/api/sponsor/employees', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeesMockHandler200 = ()=>{
    return http.get('*/api/sponsor/employees', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantsMockHandler = ()=>{
    return http.put('*/api/sponsor/employees', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantsMockHandler200 = ()=>{
    return http.put('*/api/sponsor/employees', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadCensusOriginalMockHandler = ()=>{
    return http.post('*/api/sponsor/employees/original', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadCensusOriginalMockHandler201 = ()=>{
    return http.post('*/api/sponsor/employees/original', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostValidateEmployeeMockHandler = ()=>{
    return http.post('*/api/sponsor/employees/validate', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostValidateEmployeeMockHandler201 = ()=>{
    return http.post('*/api/sponsor/employees/validate', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeDetailsMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/employees/:employeeId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeDetailsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeDetailsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employees/:employeeId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeDetailsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeDetailsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employees/:employeeId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeDetailsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeDetailsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employees/:employeeId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeDetailsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeDetailsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employees/:employeeId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeDetailsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeDetailsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employees/:employeeId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeDetailsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeDetailsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employees/:employeeId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeDetailsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeDetailsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employees/:employeeId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeDetailsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeDetailsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employees/:employeeId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeDetailsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeDetailsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employees/:employeeId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeDetailsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeDetailsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employees/:employeeId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeDetailsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeDetailsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employees/:employeeId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeDetailsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeDetailsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employees/:employeeId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeDetailsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeDetailsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employees/:employeeId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeDetailsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeDetailsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employees/:employeeId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeDetailsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeDetailsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employees/:employeeId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeDetailsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeDetailsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employees/:employeeId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeDetailsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeDetailsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employees/:employeeId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeDetailsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeDetailsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employees/:employeeId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeDetailsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeDetailsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/employees/:employeeId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeDetailsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContactInfoMockHandler = ()=>{
    return http.post('*/api/sponsor/employees/:employeeId/address', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContactInfoMockHandler201 = ()=>{
    return http.post('*/api/sponsor/employees/:employeeId/address', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantContributionsMockHandler = ()=>{
    return http.put('*/api/sponsor/employees/:employeeId/contributions', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantContributionsMockHandler200 = ()=>{
    return http.put('*/api/sponsor/employees/:employeeId/contributions', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEntityMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEntityResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEntityMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEntityResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEntityMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEntityResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEntityMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEntityResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEntityMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEntityResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEntityMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEntityResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEntityMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEntityResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEntityMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEntityResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEntityMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEntityResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEntityMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEntityResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEntityMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEntityResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEntityMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEntityResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEntityMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEntityResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEntityMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEntityResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEntityMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEntityResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEntityMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEntityResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEntityMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEntityResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEntityMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEntityResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEntityMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEntityResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEntityMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/entity', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEntityResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetForfeiturePreferenceMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetForfeiturePreferenceResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetForfeiturePreferenceMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetForfeiturePreferenceResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetForfeiturePreferenceMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetForfeiturePreferenceResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetForfeiturePreferenceMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetForfeiturePreferenceResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetForfeiturePreferenceMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetForfeiturePreferenceResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetForfeiturePreferenceMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetForfeiturePreferenceResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetForfeiturePreferenceMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetForfeiturePreferenceResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetForfeiturePreferenceMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetForfeiturePreferenceResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetForfeiturePreferenceMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetForfeiturePreferenceResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetForfeiturePreferenceMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetForfeiturePreferenceResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetForfeiturePreferenceMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetForfeiturePreferenceResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetForfeiturePreferenceMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetForfeiturePreferenceResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetForfeiturePreferenceMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetForfeiturePreferenceResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetForfeiturePreferenceMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetForfeiturePreferenceResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetForfeiturePreferenceMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetForfeiturePreferenceResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetForfeiturePreferenceMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetForfeiturePreferenceResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetForfeiturePreferenceMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetForfeiturePreferenceResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetForfeiturePreferenceMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetForfeiturePreferenceResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetForfeiturePreferenceMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetForfeiturePreferenceResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetForfeiturePreferenceMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetForfeiturePreferenceResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutForfeiturePreferenceMockHandler = ()=>{
    return http.put('*/api/sponsor/forfeiture-preference', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutForfeiturePreferenceMockHandler200 = ()=>{
    return http.put('*/api/sponsor/forfeiture-preference', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutForfeiturePreferenceMockHandler400 = (overrideResponse)=>{
    return http.put('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutForfeiturePreferenceResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutForfeiturePreferenceMockHandler401 = (overrideResponse)=>{
    return http.put('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutForfeiturePreferenceResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutForfeiturePreferenceMockHandler403 = (overrideResponse)=>{
    return http.put('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutForfeiturePreferenceResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutForfeiturePreferenceMockHandler404 = (overrideResponse)=>{
    return http.put('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutForfeiturePreferenceResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutForfeiturePreferenceMockHandler405 = (overrideResponse)=>{
    return http.put('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutForfeiturePreferenceResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutForfeiturePreferenceMockHandler406 = (overrideResponse)=>{
    return http.put('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutForfeiturePreferenceResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutForfeiturePreferenceMockHandler408 = (overrideResponse)=>{
    return http.put('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutForfeiturePreferenceResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutForfeiturePreferenceMockHandler409 = (overrideResponse)=>{
    return http.put('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutForfeiturePreferenceResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutForfeiturePreferenceMockHandler410 = (overrideResponse)=>{
    return http.put('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutForfeiturePreferenceResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutForfeiturePreferenceMockHandler412 = (overrideResponse)=>{
    return http.put('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutForfeiturePreferenceResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutForfeiturePreferenceMockHandler413 = (overrideResponse)=>{
    return http.put('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutForfeiturePreferenceResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutForfeiturePreferenceMockHandler415 = (overrideResponse)=>{
    return http.put('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutForfeiturePreferenceResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutForfeiturePreferenceMockHandler422 = (overrideResponse)=>{
    return http.put('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutForfeiturePreferenceResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutForfeiturePreferenceMockHandler500 = (overrideResponse)=>{
    return http.put('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutForfeiturePreferenceResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutForfeiturePreferenceMockHandler501 = (overrideResponse)=>{
    return http.put('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutForfeiturePreferenceResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutForfeiturePreferenceMockHandler502 = (overrideResponse)=>{
    return http.put('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutForfeiturePreferenceResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutForfeiturePreferenceMockHandler503 = (overrideResponse)=>{
    return http.put('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutForfeiturePreferenceResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutForfeiturePreferenceMockHandler504 = (overrideResponse)=>{
    return http.put('*/api/sponsor/forfeiture-preference', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutForfeiturePreferenceResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetHeapDataMockHandler = ()=>{
    return http.get('*/api/sponsor/heap', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetHeapDataMockHandler200 = ()=>{
    return http.get('*/api/sponsor/heap', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOnboardingMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOnboardingResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOnboardingMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOnboardingResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOnboardingMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOnboardingResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOnboardingMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOnboardingResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOnboardingMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOnboardingResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOnboardingMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOnboardingResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOnboardingMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOnboardingResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOnboardingMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOnboardingResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOnboardingMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOnboardingResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOnboardingMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOnboardingResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOnboardingMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOnboardingResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOnboardingMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOnboardingResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOnboardingMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOnboardingResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOnboardingMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOnboardingResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOnboardingMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOnboardingResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOnboardingMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOnboardingResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOnboardingMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOnboardingResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOnboardingMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOnboardingResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOnboardingMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOnboardingResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOnboardingMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOnboardingResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostOnboardingMockHandler = ()=>{
    return http.post('*/api/sponsor/onboarding', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostOnboardingMockHandler201 = ()=>{
    return http.post('*/api/sponsor/onboarding', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutOnboardingMockHandler = ()=>{
    return http.put('*/api/sponsor/onboarding', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutOnboardingMockHandler200 = ()=>{
    return http.put('*/api/sponsor/onboarding', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorOnboardingInformationMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorOnboardingInformationResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorOnboardingInformationMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorOnboardingInformationResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorOnboardingInformationMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorOnboardingInformationResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorOnboardingInformationMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorOnboardingInformationResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorOnboardingInformationMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorOnboardingInformationResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorOnboardingInformationMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorOnboardingInformationResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorOnboardingInformationMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorOnboardingInformationResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorOnboardingInformationMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorOnboardingInformationResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorOnboardingInformationMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorOnboardingInformationResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorOnboardingInformationMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorOnboardingInformationResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorOnboardingInformationMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorOnboardingInformationResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorOnboardingInformationMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorOnboardingInformationResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorOnboardingInformationMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorOnboardingInformationResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorOnboardingInformationMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorOnboardingInformationResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorOnboardingInformationMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorOnboardingInformationResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorOnboardingInformationMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorOnboardingInformationResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorOnboardingInformationMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorOnboardingInformationResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorOnboardingInformationMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorOnboardingInformationResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorOnboardingInformationMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorOnboardingInformationResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorOnboardingInformationMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorOnboardingInformationResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSponsorOnboardingInformationMockHandler = ()=>{
    return http.put('*/api/sponsor/onboarding-information', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSponsorOnboardingInformationMockHandler200 = ()=>{
    return http.put('*/api/sponsor/onboarding-information', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSponsorOnboardingInformationMockHandler400 = (overrideResponse)=>{
    return http.put('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutSponsorOnboardingInformationResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSponsorOnboardingInformationMockHandler401 = (overrideResponse)=>{
    return http.put('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutSponsorOnboardingInformationResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSponsorOnboardingInformationMockHandler403 = (overrideResponse)=>{
    return http.put('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutSponsorOnboardingInformationResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSponsorOnboardingInformationMockHandler404 = (overrideResponse)=>{
    return http.put('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutSponsorOnboardingInformationResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSponsorOnboardingInformationMockHandler405 = (overrideResponse)=>{
    return http.put('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutSponsorOnboardingInformationResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSponsorOnboardingInformationMockHandler406 = (overrideResponse)=>{
    return http.put('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutSponsorOnboardingInformationResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSponsorOnboardingInformationMockHandler408 = (overrideResponse)=>{
    return http.put('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutSponsorOnboardingInformationResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSponsorOnboardingInformationMockHandler409 = (overrideResponse)=>{
    return http.put('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutSponsorOnboardingInformationResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSponsorOnboardingInformationMockHandler410 = (overrideResponse)=>{
    return http.put('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutSponsorOnboardingInformationResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSponsorOnboardingInformationMockHandler412 = (overrideResponse)=>{
    return http.put('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutSponsorOnboardingInformationResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSponsorOnboardingInformationMockHandler413 = (overrideResponse)=>{
    return http.put('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutSponsorOnboardingInformationResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSponsorOnboardingInformationMockHandler415 = (overrideResponse)=>{
    return http.put('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutSponsorOnboardingInformationResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSponsorOnboardingInformationMockHandler422 = (overrideResponse)=>{
    return http.put('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutSponsorOnboardingInformationResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSponsorOnboardingInformationMockHandler500 = (overrideResponse)=>{
    return http.put('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutSponsorOnboardingInformationResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSponsorOnboardingInformationMockHandler501 = (overrideResponse)=>{
    return http.put('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutSponsorOnboardingInformationResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSponsorOnboardingInformationMockHandler502 = (overrideResponse)=>{
    return http.put('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutSponsorOnboardingInformationResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSponsorOnboardingInformationMockHandler503 = (overrideResponse)=>{
    return http.put('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutSponsorOnboardingInformationResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSponsorOnboardingInformationMockHandler504 = (overrideResponse)=>{
    return http.put('*/api/sponsor/onboarding-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutSponsorOnboardingInformationResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadCensusMockHandler = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadCensusResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadCensusMockHandler200 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadCensusResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadCensusMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadCensusResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadCensusMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadCensusResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadCensusMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadCensusResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadCensusMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadCensusResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadCensusMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadCensusResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadCensusMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadCensusResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadCensusMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadCensusResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadCensusMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadCensusResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadCensusMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadCensusResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadCensusMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadCensusResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadCensusMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadCensusResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadCensusMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadCensusResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadCensusMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadCensusResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadCensusMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadCensusResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadCensusMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadCensusResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadCensusMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadCensusResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadCensusMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadCensusResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadCensusMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadCensusResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadOnboardingCensusOriginalMockHandler = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees/original', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadOnboardingCensusOriginalResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadOnboardingCensusOriginalMockHandler200 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees/original', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadOnboardingCensusOriginalResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadOnboardingCensusOriginalMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees/original', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadOnboardingCensusOriginalResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadOnboardingCensusOriginalMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees/original', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadOnboardingCensusOriginalResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadOnboardingCensusOriginalMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees/original', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadOnboardingCensusOriginalResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadOnboardingCensusOriginalMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees/original', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadOnboardingCensusOriginalResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadOnboardingCensusOriginalMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees/original', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadOnboardingCensusOriginalResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadOnboardingCensusOriginalMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees/original', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadOnboardingCensusOriginalResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadOnboardingCensusOriginalMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees/original', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadOnboardingCensusOriginalResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadOnboardingCensusOriginalMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees/original', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadOnboardingCensusOriginalResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadOnboardingCensusOriginalMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees/original', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadOnboardingCensusOriginalResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadOnboardingCensusOriginalMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees/original', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadOnboardingCensusOriginalResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadOnboardingCensusOriginalMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees/original', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadOnboardingCensusOriginalResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadOnboardingCensusOriginalMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees/original', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadOnboardingCensusOriginalResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadOnboardingCensusOriginalMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees/original', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadOnboardingCensusOriginalResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadOnboardingCensusOriginalMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees/original', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadOnboardingCensusOriginalResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadOnboardingCensusOriginalMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees/original', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadOnboardingCensusOriginalResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadOnboardingCensusOriginalMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees/original', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadOnboardingCensusOriginalResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadOnboardingCensusOriginalMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees/original', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadOnboardingCensusOriginalResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadOnboardingCensusOriginalMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees/original', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadOnboardingCensusOriginalResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetInitialCensusMockHandler = ()=>{
    return http.get('*/api/sponsor/onboarding/census', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetInitialCensusMockHandler200 = ()=>{
    return http.get('*/api/sponsor/onboarding/census', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteCensusCacheMockHandler = ()=>{
    return http.delete('*/api/sponsor/onboarding/census-cache', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteCensusCacheMockHandler200 = ()=>{
    return http.delete('*/api/sponsor/onboarding/census-cache', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusCacheMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/census-cache', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusCacheResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusCacheMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/census-cache', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusCacheResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusCacheMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/census-cache', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusCacheResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusCacheMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/census-cache', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusCacheResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusCacheMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/census-cache', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusCacheResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusCacheMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/census-cache', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusCacheResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusCacheMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/census-cache', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusCacheResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusCacheMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/census-cache', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusCacheResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusCacheMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/census-cache', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusCacheResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusCacheMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/census-cache', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusCacheResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusCacheMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/census-cache', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusCacheResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusCacheMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/census-cache', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusCacheResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusCacheMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/census-cache', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusCacheResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusCacheMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/census-cache', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusCacheResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusCacheMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/census-cache', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusCacheResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusCacheMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/census-cache', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusCacheResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusCacheMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/census-cache', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusCacheResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusCacheMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/census-cache', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusCacheResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusCacheMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/census-cache', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusCacheResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusCacheMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/census-cache', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusCacheResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCensusCacheMockHandler = ()=>{
    return http.post('*/api/sponsor/onboarding/census-cache', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCensusCacheMockHandler201 = ()=>{
    return http.post('*/api/sponsor/onboarding/census-cache', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEsaProgramMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEsaProgramResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEsaProgramMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEsaProgramResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEsaProgramMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEsaProgramResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEsaProgramMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEsaProgramResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEsaProgramMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEsaProgramResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEsaProgramMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEsaProgramResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEsaProgramMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEsaProgramResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEsaProgramMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEsaProgramResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEsaProgramMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEsaProgramResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEsaProgramMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEsaProgramResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEsaProgramMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEsaProgramResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEsaProgramMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEsaProgramResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEsaProgramMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEsaProgramResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEsaProgramMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEsaProgramResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEsaProgramMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEsaProgramResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEsaProgramMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEsaProgramResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEsaProgramMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEsaProgramResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEsaProgramMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEsaProgramResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEsaProgramMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEsaProgramResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEsaProgramMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/esa-program', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEsaProgramResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostFinishOnboardingMockHandler = ()=>{
    return http.post('*/api/sponsor/onboarding/finish', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostFinishOnboardingMockHandler201 = ()=>{
    return http.post('*/api/sponsor/onboarding/finish', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorOnboardingTeammatesMockHandler = ()=>{
    return http.get('*/api/sponsor/onboarding/manage-teammate', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorOnboardingTeammatesMockHandler200 = ()=>{
    return http.get('*/api/sponsor/onboarding/manage-teammate', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSendOnboardingUserInviteMockHandler = ()=>{
    return http.post('*/api/sponsor/onboarding/manage-teammate', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSendOnboardingUserInviteMockHandler201 = ()=>{
    return http.post('*/api/sponsor/onboarding/manage-teammate', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetNextPayrollDatesMockHandler = ()=>{
    return http.get('*/api/sponsor/onboarding/payroll-dates', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetNextPayrollDatesMockHandler200 = ()=>{
    return http.get('*/api/sponsor/onboarding/payroll-dates', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollProvidersMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/payroll-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPayrollProvidersResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollProvidersMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/payroll-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPayrollProvidersResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollProvidersMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/payroll-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPayrollProvidersResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollProvidersMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/payroll-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPayrollProvidersResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollProvidersMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/payroll-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPayrollProvidersResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollProvidersMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/payroll-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPayrollProvidersResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollProvidersMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/payroll-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPayrollProvidersResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollProvidersMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/payroll-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPayrollProvidersResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollProvidersMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/payroll-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPayrollProvidersResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollProvidersMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/payroll-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPayrollProvidersResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollProvidersMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/payroll-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPayrollProvidersResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollProvidersMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/payroll-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPayrollProvidersResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollProvidersMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/payroll-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPayrollProvidersResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollProvidersMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/payroll-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPayrollProvidersResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollProvidersMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/payroll-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPayrollProvidersResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollProvidersMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/payroll-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPayrollProvidersResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollProvidersMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/payroll-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPayrollProvidersResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollProvidersMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/payroll-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPayrollProvidersResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollProvidersMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/payroll-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPayrollProvidersResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollProvidersMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/payroll-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPayrollProvidersResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorPlaidLinkTokenMockHandler = ()=>{
    return http.get('*/api/sponsor/onboarding/plaid-link-token', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorPlaidLinkTokenMockHandler200 = ()=>{
    return http.get('*/api/sponsor/onboarding/plaid-link-token', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostGetSponsorPlaidLinksMockHandler = ()=>{
    return http.post('*/api/sponsor/onboarding/plaid-links', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostGetSponsorPlaidLinksMockHandler201 = ()=>{
    return http.post('*/api/sponsor/onboarding/plaid-links', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignConsultStateMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignConsultStateResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignConsultStateMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignConsultStateResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignConsultStateMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignConsultStateResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignConsultStateMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignConsultStateResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignConsultStateMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignConsultStateResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignConsultStateMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignConsultStateResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignConsultStateMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignConsultStateResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignConsultStateMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignConsultStateResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignConsultStateMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignConsultStateResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignConsultStateMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignConsultStateResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignConsultStateMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignConsultStateResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignConsultStateMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignConsultStateResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignConsultStateMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignConsultStateResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignConsultStateMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignConsultStateResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignConsultStateMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignConsultStateResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignConsultStateMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignConsultStateResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignConsultStateMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignConsultStateResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignConsultStateMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignConsultStateResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignConsultStateMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignConsultStateResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanDesignConsultStateMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanDesignConsultStateResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanDesignConsultStateMockHandler = (overrideResponse)=>{
    return http.patch('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanDesignConsultStateResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanDesignConsultStateMockHandler200 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanDesignConsultStateResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanDesignConsultStateMockHandler400 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanDesignConsultStateResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanDesignConsultStateMockHandler401 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanDesignConsultStateResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanDesignConsultStateMockHandler403 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanDesignConsultStateResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanDesignConsultStateMockHandler404 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanDesignConsultStateResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanDesignConsultStateMockHandler405 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanDesignConsultStateResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanDesignConsultStateMockHandler406 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanDesignConsultStateResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanDesignConsultStateMockHandler408 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanDesignConsultStateResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanDesignConsultStateMockHandler409 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanDesignConsultStateResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanDesignConsultStateMockHandler410 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanDesignConsultStateResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanDesignConsultStateMockHandler412 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanDesignConsultStateResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanDesignConsultStateMockHandler413 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanDesignConsultStateResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanDesignConsultStateMockHandler415 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanDesignConsultStateResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanDesignConsultStateMockHandler422 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanDesignConsultStateResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanDesignConsultStateMockHandler500 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanDesignConsultStateResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanDesignConsultStateMockHandler501 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanDesignConsultStateResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanDesignConsultStateMockHandler502 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanDesignConsultStateResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanDesignConsultStateMockHandler503 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanDesignConsultStateResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchPlanDesignConsultStateMockHandler504 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/onboarding/plan-design-consult-state', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchPlanDesignConsultStateResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanLaunchCallUrlMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-launch-call', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanLaunchCallUrlResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanLaunchCallUrlMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-launch-call', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanLaunchCallUrlResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanLaunchCallUrlMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-launch-call', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanLaunchCallUrlResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanLaunchCallUrlMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-launch-call', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanLaunchCallUrlResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanLaunchCallUrlMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-launch-call', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanLaunchCallUrlResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanLaunchCallUrlMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-launch-call', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanLaunchCallUrlResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanLaunchCallUrlMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-launch-call', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanLaunchCallUrlResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanLaunchCallUrlMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-launch-call', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanLaunchCallUrlResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanLaunchCallUrlMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-launch-call', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanLaunchCallUrlResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanLaunchCallUrlMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-launch-call', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanLaunchCallUrlResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanLaunchCallUrlMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-launch-call', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanLaunchCallUrlResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanLaunchCallUrlMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-launch-call', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanLaunchCallUrlResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanLaunchCallUrlMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-launch-call', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanLaunchCallUrlResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanLaunchCallUrlMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-launch-call', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanLaunchCallUrlResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanLaunchCallUrlMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-launch-call', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanLaunchCallUrlResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanLaunchCallUrlMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-launch-call', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanLaunchCallUrlResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanLaunchCallUrlMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-launch-call', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanLaunchCallUrlResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanLaunchCallUrlMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-launch-call', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanLaunchCallUrlResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanLaunchCallUrlMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-launch-call', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanLaunchCallUrlResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanLaunchCallUrlMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/plan-launch-call', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanLaunchCallUrlResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUserRolesMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/user-roles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUserRolesResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUserRolesMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/user-roles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUserRolesResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUserRolesMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/user-roles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUserRolesResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUserRolesMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/user-roles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUserRolesResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUserRolesMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/user-roles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUserRolesResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUserRolesMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/user-roles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUserRolesResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUserRolesMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/user-roles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUserRolesResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUserRolesMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/user-roles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUserRolesResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUserRolesMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/user-roles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUserRolesResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUserRolesMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/user-roles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUserRolesResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUserRolesMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/user-roles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUserRolesResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUserRolesMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/user-roles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUserRolesResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUserRolesMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/user-roles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUserRolesResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUserRolesMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/user-roles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUserRolesResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUserRolesMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/user-roles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUserRolesResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUserRolesMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/user-roles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUserRolesResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUserRolesMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/user-roles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUserRolesResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUserRolesMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/user-roles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUserRolesResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUserRolesMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/user-roles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUserRolesResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUserRolesMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/user-roles', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUserRolesResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollConnectionStatusMockHandler = ()=>{
    return http.get('*/api/sponsor/payroll/connection-status', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollConnectionStatusMockHandler200 = ()=>{
    return http.get('*/api/sponsor/payroll/connection-status', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollConnectionStatusV2MockHandler = ()=>{
    return http.get('*/api/sponsor/payroll/connection-status/v2', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollConnectionStatusV2MockHandler200 = ()=>{
    return http.get('*/api/sponsor/payroll/connection-status/v2', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollDatesMockHandler = ()=>{
    return http.get('*/api/sponsor/payroll/dates', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollDatesMockHandler200 = ()=>{
    return http.get('*/api/sponsor/payroll/dates', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollInfoMockHandler = ()=>{
    return http.get('*/api/sponsor/payroll/info', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollInfoMockHandler200 = ()=>{
    return http.get('*/api/sponsor/payroll/info', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollSetupsMockHandler = ()=>{
    return http.get('*/api/sponsor/payroll/setup', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollSetupsMockHandler200 = ()=>{
    return http.get('*/api/sponsor/payroll/setup', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollSetupMockHandler = ()=>{
    return http.post('*/api/sponsor/payroll/setup', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollSetupMockHandler201 = ()=>{
    return http.post('*/api/sponsor/payroll/setup', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostBulkPayrollSetupDisconnectionMockHandler = ()=>{
    return http.post('*/api/sponsor/payroll/setup/disconnect', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostBulkPayrollSetupDisconnectionMockHandler200 = ()=>{
    return http.post('*/api/sponsor/payroll/setup/disconnect', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostBulkPayrollSetupDisconnectionMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostBulkPayrollSetupDisconnectionResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostBulkPayrollSetupDisconnectionMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostBulkPayrollSetupDisconnectionResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostBulkPayrollSetupDisconnectionMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostBulkPayrollSetupDisconnectionResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostBulkPayrollSetupDisconnectionMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostBulkPayrollSetupDisconnectionResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostBulkPayrollSetupDisconnectionMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostBulkPayrollSetupDisconnectionResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostBulkPayrollSetupDisconnectionMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostBulkPayrollSetupDisconnectionResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostBulkPayrollSetupDisconnectionMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostBulkPayrollSetupDisconnectionResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostBulkPayrollSetupDisconnectionMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostBulkPayrollSetupDisconnectionResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostBulkPayrollSetupDisconnectionMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostBulkPayrollSetupDisconnectionResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostBulkPayrollSetupDisconnectionMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostBulkPayrollSetupDisconnectionResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostBulkPayrollSetupDisconnectionMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostBulkPayrollSetupDisconnectionResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostBulkPayrollSetupDisconnectionMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostBulkPayrollSetupDisconnectionResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostBulkPayrollSetupDisconnectionMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostBulkPayrollSetupDisconnectionResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostBulkPayrollSetupDisconnectionMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostBulkPayrollSetupDisconnectionResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostBulkPayrollSetupDisconnectionMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostBulkPayrollSetupDisconnectionResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostBulkPayrollSetupDisconnectionMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostBulkPayrollSetupDisconnectionResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostBulkPayrollSetupDisconnectionMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostBulkPayrollSetupDisconnectionResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostBulkPayrollSetupDisconnectionMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostBulkPayrollSetupDisconnectionResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollFundingSetupsMockHandler = ()=>{
    return http.get('*/api/sponsor/payroll/setup/funding', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollFundingSetupsMockHandler200 = ()=>{
    return http.get('*/api/sponsor/payroll/setup/funding', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollProviderMockHandler = ()=>{
    return http.put('*/api/sponsor/payroll/setup/provider', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollProviderMockHandler200 = ()=>{
    return http.put('*/api/sponsor/payroll/setup/provider', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollSkipStatusMockHandler = ()=>{
    return http.put('*/api/sponsor/payroll/setup/skip', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollSkipStatusMockHandler200 = ()=>{
    return http.put('*/api/sponsor/payroll/setup/skip', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollSkipStatusMockHandler400 = (overrideResponse)=>{
    return http.put('*/api/sponsor/payroll/setup/skip', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPayrollSkipStatusResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollSkipStatusMockHandler401 = (overrideResponse)=>{
    return http.put('*/api/sponsor/payroll/setup/skip', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPayrollSkipStatusResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollSkipStatusMockHandler403 = (overrideResponse)=>{
    return http.put('*/api/sponsor/payroll/setup/skip', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPayrollSkipStatusResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollSkipStatusMockHandler404 = (overrideResponse)=>{
    return http.put('*/api/sponsor/payroll/setup/skip', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPayrollSkipStatusResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollSkipStatusMockHandler405 = (overrideResponse)=>{
    return http.put('*/api/sponsor/payroll/setup/skip', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPayrollSkipStatusResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollSkipStatusMockHandler406 = (overrideResponse)=>{
    return http.put('*/api/sponsor/payroll/setup/skip', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPayrollSkipStatusResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollSkipStatusMockHandler408 = (overrideResponse)=>{
    return http.put('*/api/sponsor/payroll/setup/skip', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPayrollSkipStatusResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollSkipStatusMockHandler409 = (overrideResponse)=>{
    return http.put('*/api/sponsor/payroll/setup/skip', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPayrollSkipStatusResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollSkipStatusMockHandler410 = (overrideResponse)=>{
    return http.put('*/api/sponsor/payroll/setup/skip', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPayrollSkipStatusResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollSkipStatusMockHandler412 = (overrideResponse)=>{
    return http.put('*/api/sponsor/payroll/setup/skip', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPayrollSkipStatusResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollSkipStatusMockHandler413 = (overrideResponse)=>{
    return http.put('*/api/sponsor/payroll/setup/skip', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPayrollSkipStatusResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollSkipStatusMockHandler415 = (overrideResponse)=>{
    return http.put('*/api/sponsor/payroll/setup/skip', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPayrollSkipStatusResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollSkipStatusMockHandler422 = (overrideResponse)=>{
    return http.put('*/api/sponsor/payroll/setup/skip', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPayrollSkipStatusResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollSkipStatusMockHandler500 = (overrideResponse)=>{
    return http.put('*/api/sponsor/payroll/setup/skip', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPayrollSkipStatusResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollSkipStatusMockHandler501 = (overrideResponse)=>{
    return http.put('*/api/sponsor/payroll/setup/skip', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPayrollSkipStatusResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollSkipStatusMockHandler502 = (overrideResponse)=>{
    return http.put('*/api/sponsor/payroll/setup/skip', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPayrollSkipStatusResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollSkipStatusMockHandler503 = (overrideResponse)=>{
    return http.put('*/api/sponsor/payroll/setup/skip', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPayrollSkipStatusResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollSkipStatusMockHandler504 = (overrideResponse)=>{
    return http.put('*/api/sponsor/payroll/setup/skip', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPayrollSkipStatusResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSkipSubmissionMockHandler = ()=>{
    return http.put('*/api/sponsor/payroll/setup/skipping', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSkipSubmissionMockHandler200 = ()=>{
    return http.put('*/api/sponsor/payroll/setup/skipping', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePayrollSetupMockHandler = ()=>{
    return http.delete('*/api/sponsor/payroll/setup/:payrollSetupId', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePayrollSetupMockHandler200 = ()=>{
    return http.delete('*/api/sponsor/payroll/setup/:payrollSetupId', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollDatesMockHandler = ()=>{
    return http.put('*/api/sponsor/payroll/setup/:payrollSetupId/dates', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollDatesMockHandler200 = ()=>{
    return http.put('*/api/sponsor/payroll/setup/:payrollSetupId/dates', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollSetupDisconnectionMockHandler = ()=>{
    return http.post('*/api/sponsor/payroll/setup/:payrollSetupId/disconnect', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollSetupDisconnectionMockHandler200 = ()=>{
    return http.post('*/api/sponsor/payroll/setup/:payrollSetupId/disconnect', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollSetupDisconnectionMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/:payrollSetupId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPayrollSetupDisconnectionResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollSetupDisconnectionMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/:payrollSetupId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPayrollSetupDisconnectionResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollSetupDisconnectionMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/:payrollSetupId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPayrollSetupDisconnectionResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollSetupDisconnectionMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/:payrollSetupId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPayrollSetupDisconnectionResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollSetupDisconnectionMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/:payrollSetupId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPayrollSetupDisconnectionResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollSetupDisconnectionMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/:payrollSetupId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPayrollSetupDisconnectionResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollSetupDisconnectionMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/:payrollSetupId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPayrollSetupDisconnectionResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollSetupDisconnectionMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/:payrollSetupId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPayrollSetupDisconnectionResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollSetupDisconnectionMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/:payrollSetupId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPayrollSetupDisconnectionResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollSetupDisconnectionMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/:payrollSetupId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPayrollSetupDisconnectionResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollSetupDisconnectionMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/:payrollSetupId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPayrollSetupDisconnectionResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollSetupDisconnectionMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/:payrollSetupId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPayrollSetupDisconnectionResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollSetupDisconnectionMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/:payrollSetupId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPayrollSetupDisconnectionResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollSetupDisconnectionMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/:payrollSetupId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPayrollSetupDisconnectionResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollSetupDisconnectionMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/:payrollSetupId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPayrollSetupDisconnectionResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollSetupDisconnectionMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/:payrollSetupId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPayrollSetupDisconnectionResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollSetupDisconnectionMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/:payrollSetupId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPayrollSetupDisconnectionResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollSetupDisconnectionMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/sponsor/payroll/setup/:payrollSetupId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPayrollSetupDisconnectionResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollSetupInfoMockHandler = ()=>{
    return http.put('*/api/sponsor/payroll/setup/:payrollSetupId/info', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollSetupInfoMockHandler200 = ()=>{
    return http.put('*/api/sponsor/payroll/setup/:payrollSetupId/info', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollValidationsMockHandler = ()=>{
    return http.post('*/api/sponsor/payroll/validate', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollValidationsMockHandler201 = ()=>{
    return http.post('*/api/sponsor/payroll/validate', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanFeaturesMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/plan-features', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanFeaturesResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanFeaturesMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plan-features', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanFeaturesResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanFeaturesMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plan-features', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanFeaturesResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanFeaturesMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plan-features', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanFeaturesResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanFeaturesMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plan-features', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanFeaturesResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanFeaturesMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plan-features', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanFeaturesResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanFeaturesMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plan-features', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanFeaturesResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanFeaturesMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plan-features', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanFeaturesResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanFeaturesMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plan-features', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanFeaturesResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanFeaturesMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plan-features', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanFeaturesResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanFeaturesMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plan-features', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanFeaturesResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanFeaturesMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plan-features', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanFeaturesResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanFeaturesMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plan-features', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanFeaturesResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanFeaturesMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plan-features', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanFeaturesResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanFeaturesMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plan-features', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanFeaturesResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanFeaturesMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plan-features', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanFeaturesResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanFeaturesMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plan-features', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanFeaturesResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanFeaturesMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plan-features', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanFeaturesResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanFeaturesMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plan-features', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanFeaturesResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanFeaturesMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plan-features', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanFeaturesResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOnboardingStatusMockHandler = ()=>{
    return http.get('*/api/sponsor/plan/onboarding/status', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOnboardingStatusMockHandler200 = ()=>{
    return http.get('*/api/sponsor/plan/onboarding/status', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorPlanDisconnectionMockHandler = ()=>{
    return http.post('*/api/sponsor/plan/:planId/disconnect', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorPlanDisconnectionMockHandler200 = ()=>{
    return http.post('*/api/sponsor/plan/:planId/disconnect', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorPlanDisconnectionMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/sponsor/plan/:planId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSponsorPlanDisconnectionResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorPlanDisconnectionMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/sponsor/plan/:planId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSponsorPlanDisconnectionResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorPlanDisconnectionMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/sponsor/plan/:planId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSponsorPlanDisconnectionResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorPlanDisconnectionMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/sponsor/plan/:planId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSponsorPlanDisconnectionResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorPlanDisconnectionMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/sponsor/plan/:planId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSponsorPlanDisconnectionResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorPlanDisconnectionMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/sponsor/plan/:planId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSponsorPlanDisconnectionResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorPlanDisconnectionMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/sponsor/plan/:planId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSponsorPlanDisconnectionResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorPlanDisconnectionMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/sponsor/plan/:planId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSponsorPlanDisconnectionResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorPlanDisconnectionMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/sponsor/plan/:planId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSponsorPlanDisconnectionResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorPlanDisconnectionMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/sponsor/plan/:planId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSponsorPlanDisconnectionResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorPlanDisconnectionMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/sponsor/plan/:planId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSponsorPlanDisconnectionResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorPlanDisconnectionMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/sponsor/plan/:planId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSponsorPlanDisconnectionResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorPlanDisconnectionMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/sponsor/plan/:planId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSponsorPlanDisconnectionResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorPlanDisconnectionMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/sponsor/plan/:planId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSponsorPlanDisconnectionResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorPlanDisconnectionMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/sponsor/plan/:planId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSponsorPlanDisconnectionResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorPlanDisconnectionMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/sponsor/plan/:planId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSponsorPlanDisconnectionResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorPlanDisconnectionMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/sponsor/plan/:planId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSponsorPlanDisconnectionResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorPlanDisconnectionMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/sponsor/plan/:planId/disconnect', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSponsorPlanDisconnectionResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanStatisticsMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanStatisticsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanStatisticsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanStatisticsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanStatisticsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanStatisticsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanStatisticsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanStatisticsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanStatisticsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanStatisticsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanStatisticsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanStatisticsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanStatisticsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanStatisticsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanStatisticsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanStatisticsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanStatisticsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanStatisticsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanStatisticsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanStatisticsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanStatisticsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanStatisticsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanStatisticsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanStatisticsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanStatisticsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanStatisticsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanStatisticsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanStatisticsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanStatisticsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanStatisticsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanStatisticsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanStatisticsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanStatisticsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanStatisticsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanStatisticsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanStatisticsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanStatisticsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanStatisticsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanStatisticsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/plans/:planId/stats', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanStatisticsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationMockHandler = ()=>{
    return http.put('*/api/sponsor/pocet/configuration', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationMockHandler200 = ()=>{
    return http.put('*/api/sponsor/pocet/configuration', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationMockHandler400 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationMockHandler401 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationMockHandler403 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationMockHandler404 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationMockHandler405 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationMockHandler406 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationMockHandler408 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationMockHandler409 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationMockHandler410 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationMockHandler412 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationMockHandler413 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationMockHandler415 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationMockHandler422 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationMockHandler500 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationMockHandler501 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationMockHandler502 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationMockHandler503 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationMockHandler504 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/configuration', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanConfigurationResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/employees', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationMockHandler = ()=>{
    return http.put('*/api/sponsor/pocet/gross-compensation', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationMockHandler200 = ()=>{
    return http.put('*/api/sponsor/pocet/gross-compensation', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationMockHandler400 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationMockHandler401 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationMockHandler403 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationMockHandler404 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationMockHandler405 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationMockHandler406 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationMockHandler408 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationMockHandler409 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationMockHandler410 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationMockHandler412 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationMockHandler413 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationMockHandler415 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationMockHandler422 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationMockHandler500 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationMockHandler501 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationMockHandler502 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationMockHandler503 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationMockHandler504 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/gross-compensation', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeGrossCompensationResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGrossCompensationTemplateMockHandler = ()=>{
    return http.get('*/api/sponsor/pocet/gross-compensation/download/template', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGrossCompensationTemplateMockHandler200 = ()=>{
    return http.get('*/api/sponsor/pocet/gross-compensation/download/template', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadMockHandler = ()=>{
    return http.post('*/api/sponsor/pocet/gross-compensation/upload', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadMockHandler200 = ()=>{
    return http.post('*/api/sponsor/pocet/gross-compensation/upload', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/gross-compensation/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeGrossCompensationUploadResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerMockHandler = ()=>{
    return http.post('*/api/sponsor/pocet/non-employee-owner', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerMockHandler200 = ()=>{
    return http.post('*/api/sponsor/pocet/non-employee-owner', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/non-employee-owner', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanNonEmployeeOwnerResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusMockHandler = ()=>{
    return http.put('*/api/sponsor/pocet/officers', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusMockHandler200 = ()=>{
    return http.put('*/api/sponsor/pocet/officers', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusMockHandler400 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusMockHandler401 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusMockHandler403 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusMockHandler404 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusMockHandler405 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusMockHandler406 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusMockHandler408 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusMockHandler409 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusMockHandler410 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusMockHandler412 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusMockHandler413 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusMockHandler415 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusMockHandler422 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusMockHandler500 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusMockHandler501 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusMockHandler502 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusMockHandler503 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusMockHandler504 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/officers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOfficerStatusResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerMockHandler = ()=>{
    return http.delete('*/api/sponsor/pocet/owners', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerMockHandler200 = ()=>{
    return http.delete('*/api/sponsor/pocet/owners', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerMockHandler400 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerMockHandler401 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerMockHandler403 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerMockHandler404 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerMockHandler405 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerMockHandler406 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerMockHandler408 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerMockHandler409 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerMockHandler410 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerMockHandler412 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerMockHandler413 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerMockHandler415 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerMockHandler422 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerMockHandler500 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerMockHandler501 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerMockHandler502 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerMockHandler503 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerMockHandler504 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnerResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerMockHandler = ()=>{
    return http.post('*/api/sponsor/pocet/owners', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerMockHandler200 = ()=>{
    return http.post('*/api/sponsor/pocet/owners', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPlanEmployeeOwnerResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerMockHandler = ()=>{
    return http.put('*/api/sponsor/pocet/owners', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerMockHandler200 = ()=>{
    return http.put('*/api/sponsor/pocet/owners', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerMockHandler400 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerMockHandler401 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerMockHandler403 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerMockHandler404 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerMockHandler405 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerMockHandler406 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerMockHandler408 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerMockHandler409 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerMockHandler410 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerMockHandler412 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerMockHandler413 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerMockHandler415 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerMockHandler422 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerMockHandler500 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerMockHandler501 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerMockHandler502 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerMockHandler503 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerMockHandler504 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanEmployeeOwnerResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyMockHandler = ()=>{
    return http.delete('*/api/sponsor/pocet/owners-family', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyMockHandler200 = ()=>{
    return http.delete('*/api/sponsor/pocet/owners-family', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyMockHandler400 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyMockHandler401 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyMockHandler403 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyMockHandler404 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyMockHandler405 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyMockHandler406 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyMockHandler408 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyMockHandler409 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyMockHandler410 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyMockHandler412 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyMockHandler413 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyMockHandler415 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyMockHandler422 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyMockHandler500 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyMockHandler501 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyMockHandler502 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyMockHandler503 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyMockHandler504 = (overrideResponse)=>{
    return http.delete('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeletePlanOwnersFamilyResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyMockHandler = ()=>{
    return http.put('*/api/sponsor/pocet/owners-family', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyMockHandler200 = ()=>{
    return http.put('*/api/sponsor/pocet/owners-family', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyMockHandler400 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyMockHandler401 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyMockHandler403 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyMockHandler404 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyMockHandler405 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyMockHandler406 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyMockHandler408 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyMockHandler409 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyMockHandler410 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyMockHandler412 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyMockHandler413 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyMockHandler415 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyMockHandler422 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyMockHandler500 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyMockHandler501 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyMockHandler502 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyMockHandler503 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyMockHandler504 = (overrideResponse)=>{
    return http.put('*/api/sponsor/pocet/owners-family', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutPlanOwnersFamilyResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetTrackerDetailsMockHandler = ()=>{
    return http.get('*/api/sponsor/pocet/tracker', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetTrackerDetailsMockHandler200 = ()=>{
    return http.get('*/api/sponsor/pocet/tracker', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPriorProviderMockHandler = ()=>{
    return http.post('*/api/sponsor/prior-provider', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPriorProviderMockHandler201 = ()=>{
    return http.post('*/api/sponsor/prior-provider', ()=>{
        return new HttpResponse(null, {
            status: 201,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPriorProvidersMockHandler = ()=>{
    return http.get('*/api/sponsor/prior-providers', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPriorProvidersMockHandler200 = ()=>{
    return http.get('*/api/sponsor/prior-providers', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorQuestionnaireMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorQuestionnaireResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorQuestionnaireMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorQuestionnaireResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorQuestionnaireMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorQuestionnaireResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorQuestionnaireMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorQuestionnaireResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorQuestionnaireMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorQuestionnaireResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorQuestionnaireMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorQuestionnaireResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorQuestionnaireMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorQuestionnaireResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorQuestionnaireMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorQuestionnaireResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorQuestionnaireMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorQuestionnaireResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorQuestionnaireMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorQuestionnaireResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorQuestionnaireMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorQuestionnaireResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorQuestionnaireMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorQuestionnaireResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorQuestionnaireMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorQuestionnaireResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorQuestionnaireMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorQuestionnaireResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorQuestionnaireMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorQuestionnaireResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorQuestionnaireMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorQuestionnaireResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorQuestionnaireMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorQuestionnaireResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorQuestionnaireMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorQuestionnaireResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorQuestionnaireMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorQuestionnaireResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorQuestionnaireMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorQuestionnaireResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchSponsorQuestionnaireMockHandler = ()=>{
    return http.patch('*/api/sponsor/questionnaire', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchSponsorQuestionnaireMockHandler200 = ()=>{
    return http.patch('*/api/sponsor/questionnaire', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQuestionnaireInformationMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQuestionnaireInformationResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQuestionnaireInformationMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQuestionnaireInformationResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQuestionnaireInformationMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQuestionnaireInformationResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQuestionnaireInformationMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQuestionnaireInformationResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQuestionnaireInformationMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQuestionnaireInformationResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQuestionnaireInformationMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQuestionnaireInformationResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQuestionnaireInformationMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQuestionnaireInformationResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQuestionnaireInformationMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQuestionnaireInformationResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQuestionnaireInformationMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQuestionnaireInformationResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQuestionnaireInformationMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQuestionnaireInformationResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQuestionnaireInformationMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQuestionnaireInformationResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQuestionnaireInformationMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQuestionnaireInformationResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQuestionnaireInformationMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQuestionnaireInformationResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQuestionnaireInformationMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQuestionnaireInformationResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQuestionnaireInformationMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQuestionnaireInformationResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQuestionnaireInformationMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQuestionnaireInformationResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQuestionnaireInformationMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQuestionnaireInformationResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQuestionnaireInformationMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQuestionnaireInformationResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQuestionnaireInformationMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQuestionnaireInformationResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQuestionnaireInformationMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire-information', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQuestionnaireInformationResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionsMockHandler = ()=>{
    return http.get('*/api/sponsor/sponsor-plan/contributions', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionsMockHandler200 = ()=>{
    return http.get('*/api/sponsor/sponsor-plan/contributions', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaPlanDetailsMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-plan-details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaPlanDetailsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaPlanDetailsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-plan-details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaPlanDetailsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaPlanDetailsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-plan-details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaPlanDetailsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaPlanDetailsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-plan-details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaPlanDetailsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaPlanDetailsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-plan-details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaPlanDetailsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaPlanDetailsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-plan-details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaPlanDetailsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaPlanDetailsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-plan-details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaPlanDetailsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaPlanDetailsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-plan-details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaPlanDetailsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaPlanDetailsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-plan-details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaPlanDetailsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaPlanDetailsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-plan-details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaPlanDetailsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaPlanDetailsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-plan-details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaPlanDetailsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaPlanDetailsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-plan-details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaPlanDetailsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaPlanDetailsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-plan-details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaPlanDetailsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaPlanDetailsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-plan-details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaPlanDetailsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaPlanDetailsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-plan-details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaPlanDetailsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaPlanDetailsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-plan-details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaPlanDetailsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaPlanDetailsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-plan-details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaPlanDetailsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaPlanDetailsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-plan-details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaPlanDetailsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaPlanDetailsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-plan-details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaPlanDetailsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaPlanDetailsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-plan-details', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaPlanDetailsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaTransactionsMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-transactions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaTransactionsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaTransactionsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-transactions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaTransactionsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaTransactionsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-transactions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaTransactionsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaTransactionsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-transactions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaTransactionsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaTransactionsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-transactions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaTransactionsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaTransactionsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-transactions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaTransactionsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaTransactionsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-transactions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaTransactionsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaTransactionsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-transactions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaTransactionsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaTransactionsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-transactions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaTransactionsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaTransactionsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-transactions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaTransactionsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaTransactionsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-transactions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaTransactionsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaTransactionsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-transactions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaTransactionsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaTransactionsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-transactions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaTransactionsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaTransactionsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-transactions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaTransactionsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaTransactionsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-transactions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaTransactionsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaTransactionsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-transactions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaTransactionsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaTransactionsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-transactions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaTransactionsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaTransactionsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-transactions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaTransactionsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaTransactionsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-transactions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaTransactionsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaTransactionsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-transactions', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaTransactionsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusAutosaveMockHandler = ()=>{
    return http.post('*/api/sponsor/yet/census/autosave', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusAutosaveMockHandler200 = ()=>{
    return http.post('*/api/sponsor/yet/census/autosave', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusAutosaveMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/autosave', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusAutosaveResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusAutosaveMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/autosave', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusAutosaveResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusAutosaveMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/autosave', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusAutosaveResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusAutosaveMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/autosave', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusAutosaveResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusAutosaveMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/autosave', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusAutosaveResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusAutosaveMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/autosave', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusAutosaveResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusAutosaveMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/autosave', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusAutosaveResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusAutosaveMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/autosave', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusAutosaveResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusAutosaveMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/autosave', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusAutosaveResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusAutosaveMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/autosave', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusAutosaveResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusAutosaveMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/autosave', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusAutosaveResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusAutosaveMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/autosave', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusAutosaveResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusAutosaveMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/autosave', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusAutosaveResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusAutosaveMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/autosave', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusAutosaveResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusAutosaveMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/autosave', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusAutosaveResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusAutosaveMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/autosave', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusAutosaveResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusAutosaveMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/autosave', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusAutosaveResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusAutosaveMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/autosave', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusAutosaveResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetCensusDataDownloadMockHandler = ()=>{
    return http.get('*/api/sponsor/yet/census/download', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetCensusDataDownloadMockHandler200 = ()=>{
    return http.get('*/api/sponsor/yet/census/download', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetCensusDataPagedMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/paged', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetCensusDataPagedResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetCensusDataPagedMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/paged', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetCensusDataPagedResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetCensusDataPagedMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/paged', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetCensusDataPagedResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetCensusDataPagedMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/paged', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetCensusDataPagedResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetCensusDataPagedMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/paged', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetCensusDataPagedResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetCensusDataPagedMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/paged', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetCensusDataPagedResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetCensusDataPagedMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/paged', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetCensusDataPagedResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetCensusDataPagedMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/paged', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetCensusDataPagedResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetCensusDataPagedMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/paged', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetCensusDataPagedResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetCensusDataPagedMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/paged', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetCensusDataPagedResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetCensusDataPagedMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/paged', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetCensusDataPagedResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetCensusDataPagedMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/paged', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetCensusDataPagedResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetCensusDataPagedMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/paged', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetCensusDataPagedResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetCensusDataPagedMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/paged', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetCensusDataPagedResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetCensusDataPagedMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/paged', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetCensusDataPagedResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetCensusDataPagedMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/paged', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetCensusDataPagedResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetCensusDataPagedMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/paged', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetCensusDataPagedResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetCensusDataPagedMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/paged', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetCensusDataPagedResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetCensusDataPagedMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/paged', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetCensusDataPagedResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetCensusDataPagedMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/paged', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetCensusDataPagedResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRefreshCensusMockHandler = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/refresh', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRefreshCensusResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRefreshCensusMockHandler200 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/refresh', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRefreshCensusResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRefreshCensusMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/refresh', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRefreshCensusResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRefreshCensusMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/refresh', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRefreshCensusResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRefreshCensusMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/refresh', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRefreshCensusResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRefreshCensusMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/refresh', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRefreshCensusResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRefreshCensusMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/refresh', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRefreshCensusResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRefreshCensusMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/refresh', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRefreshCensusResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRefreshCensusMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/refresh', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRefreshCensusResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRefreshCensusMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/refresh', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRefreshCensusResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRefreshCensusMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/refresh', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRefreshCensusResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRefreshCensusMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/refresh', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRefreshCensusResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRefreshCensusMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/refresh', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRefreshCensusResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRefreshCensusMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/refresh', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRefreshCensusResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRefreshCensusMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/refresh', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRefreshCensusResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRefreshCensusMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/refresh', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRefreshCensusResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRefreshCensusMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/refresh', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRefreshCensusResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRefreshCensusMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/refresh', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRefreshCensusResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRefreshCensusMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/refresh', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRefreshCensusResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRefreshCensusMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/refresh', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRefreshCensusResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartCensusMockHandler = ()=>{
    return http.post('*/api/sponsor/yet/census/restart', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartCensusMockHandler200 = ()=>{
    return http.post('*/api/sponsor/yet/census/restart', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartCensusMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartCensusResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartCensusMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartCensusResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartCensusMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartCensusResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartCensusMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartCensusResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartCensusMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartCensusResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartCensusMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartCensusResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartCensusMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartCensusResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartCensusMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartCensusResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartCensusMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartCensusResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartCensusMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartCensusResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartCensusMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartCensusResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartCensusMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartCensusResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartCensusMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartCensusResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartCensusMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartCensusResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartCensusMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartCensusResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartCensusMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartCensusResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartCensusMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartCensusResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartCensusMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartCensusResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusStartMockHandler = ()=>{
    return http.post('*/api/sponsor/yet/census/start', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusStartMockHandler200 = ()=>{
    return http.post('*/api/sponsor/yet/census/start', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusStartMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusStartResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusStartMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusStartResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusStartMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusStartResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusStartMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusStartResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusStartMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusStartResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusStartMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusStartResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusStartMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusStartResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusStartMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusStartResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusStartMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusStartResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusStartMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusStartResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusStartMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusStartResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusStartMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusStartResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusStartMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusStartResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusStartMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusStartResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusStartMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusStartResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusStartMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusStartResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusStartMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusStartResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusStartMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusStartResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusStatusMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusStatusResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusStatusMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusStatusResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusStatusMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusStatusResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusStatusMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusStatusResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusStatusMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusStatusResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusStatusMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusStatusResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusStatusMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusStatusResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusStatusMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusStatusResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusStatusMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusStatusResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusStatusMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusStatusResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusStatusMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusStatusResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusStatusMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusStatusResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusStatusMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusStatusResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusStatusMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusStatusResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusStatusMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusStatusResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusStatusMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusStatusResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusStatusMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusStatusResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusStatusMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusStatusResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusStatusMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusStatusResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusStatusMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusStatusResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusSubmitMockHandler = ()=>{
    return http.post('*/api/sponsor/yet/census/submit', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusSubmitMockHandler200 = ()=>{
    return http.post('*/api/sponsor/yet/census/submit', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusSubmitMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/submit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusSubmitResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusSubmitMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/submit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusSubmitResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusSubmitMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/submit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusSubmitResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusSubmitMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/submit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusSubmitResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusSubmitMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/submit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusSubmitResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusSubmitMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/submit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusSubmitResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusSubmitMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/submit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusSubmitResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusSubmitMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/submit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusSubmitResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusSubmitMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/submit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusSubmitResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusSubmitMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/submit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusSubmitResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusSubmitMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/submit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusSubmitResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusSubmitMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/submit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusSubmitResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusSubmitMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/submit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusSubmitResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusSubmitMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/submit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusSubmitResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusSubmitMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/submit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusSubmitResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusSubmitMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/submit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusSubmitResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusSubmitMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/submit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusSubmitResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusSubmitMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/submit', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusSubmitResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusUploadMockHandler = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusUploadResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusUploadMockHandler200 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusUploadResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusUploadMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusUploadResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusUploadMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusUploadResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusUploadMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusUploadResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusUploadMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusUploadResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusUploadMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusUploadResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusUploadMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusUploadResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusUploadMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusUploadResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusUploadMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusUploadResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusUploadMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusUploadResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusUploadMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusUploadResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusUploadMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusUploadResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusUploadMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusUploadResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusUploadMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusUploadResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusUploadMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusUploadResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusUploadMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusUploadResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusUploadMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusUploadResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusUploadMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusUploadResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusUploadMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/census/upload', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetCensusUploadResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetChecklistMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetChecklistResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetChecklistMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetChecklistResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetChecklistMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetChecklistResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetChecklistMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetChecklistResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetChecklistMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetChecklistResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetChecklistMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetChecklistResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetChecklistMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetChecklistResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetChecklistMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetChecklistResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetChecklistMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetChecklistResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetChecklistMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetChecklistResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetChecklistMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetChecklistResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetChecklistMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetChecklistResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetChecklistMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetChecklistResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetChecklistMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetChecklistResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetChecklistMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetChecklistResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetChecklistMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetChecklistResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetChecklistMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetChecklistResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetChecklistMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetChecklistResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetChecklistMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetChecklistResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetChecklistMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetChecklistResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchYetChecklistMockHandler = (overrideResponse)=>{
    return http.patch('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchYetChecklistResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchYetChecklistMockHandler200 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchYetChecklistResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchYetChecklistMockHandler400 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchYetChecklistResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchYetChecklistMockHandler401 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchYetChecklistResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchYetChecklistMockHandler403 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchYetChecklistResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchYetChecklistMockHandler404 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchYetChecklistResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchYetChecklistMockHandler405 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchYetChecklistResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchYetChecklistMockHandler406 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchYetChecklistResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchYetChecklistMockHandler408 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchYetChecklistResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchYetChecklistMockHandler409 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchYetChecklistResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchYetChecklistMockHandler410 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchYetChecklistResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchYetChecklistMockHandler412 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchYetChecklistResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchYetChecklistMockHandler413 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchYetChecklistResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchYetChecklistMockHandler415 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchYetChecklistResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchYetChecklistMockHandler422 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchYetChecklistResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchYetChecklistMockHandler500 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchYetChecklistResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchYetChecklistMockHandler501 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchYetChecklistResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchYetChecklistMockHandler502 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchYetChecklistResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchYetChecklistMockHandler503 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchYetChecklistResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchYetChecklistMockHandler504 = (overrideResponse)=>{
    return http.patch('*/api/sponsor/yet/checklist', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchYetChecklistResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetConfigMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/config', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetConfigResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetConfigMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/config', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetConfigResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetConfigMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/config', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetConfigResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetConfigMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/config', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetConfigResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetConfigMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/config', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetConfigResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetConfigMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/config', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetConfigResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetConfigMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/config', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetConfigResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetConfigMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/config', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetConfigResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetConfigMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/config', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetConfigResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetConfigMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/config', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetConfigResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetConfigMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/config', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetConfigResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetConfigMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/config', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetConfigResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetConfigMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/config', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetConfigResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetConfigMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/config', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetConfigResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetConfigMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/config', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetConfigResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetConfigMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/config', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetConfigResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetConfigMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/config', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetConfigResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetConfigMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/config', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetConfigResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetConfigMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/config', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetConfigResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetConfigMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/config', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetConfigResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsFundMockHandler = ()=>{
    return http.post('*/api/sponsor/yet/contributions/fund', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsFundMockHandler200 = ()=>{
    return http.post('*/api/sponsor/yet/contributions/fund', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsFundMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/fund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsFundResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsFundMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/fund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsFundResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsFundMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/fund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsFundResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsFundMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/fund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsFundResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsFundMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/fund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsFundResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsFundMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/fund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsFundResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsFundMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/fund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsFundResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsFundMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/fund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsFundResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsFundMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/fund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsFundResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsFundMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/fund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsFundResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsFundMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/fund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsFundResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsFundMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/fund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsFundResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsFundMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/fund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsFundResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsFundMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/fund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsFundResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsFundMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/fund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsFundResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsFundMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/fund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsFundResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsFundMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/fund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsFundResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsFundMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/fund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsFundResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsRefundMockHandler = ()=>{
    return http.post('*/api/sponsor/yet/contributions/refund', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsRefundMockHandler200 = ()=>{
    return http.post('*/api/sponsor/yet/contributions/refund', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsRefundMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/refund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsRefundResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsRefundMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/refund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsRefundResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsRefundMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/refund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsRefundResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsRefundMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/refund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsRefundResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsRefundMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/refund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsRefundResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsRefundMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/refund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsRefundResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsRefundMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/refund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsRefundResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsRefundMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/refund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsRefundResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsRefundMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/refund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsRefundResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsRefundMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/refund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsRefundResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsRefundMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/refund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsRefundResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsRefundMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/refund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsRefundResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsRefundMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/refund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsRefundResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsRefundMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/refund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsRefundResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsRefundMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/refund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsRefundResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsRefundMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/refund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsRefundResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsRefundMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/refund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsRefundResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsRefundMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/contributions/refund', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostContributionsRefundResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetDocumentsMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetDocumentsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetDocumentsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetDocumentsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetDocumentsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetDocumentsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetDocumentsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetDocumentsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetDocumentsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetDocumentsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetDocumentsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetDocumentsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetDocumentsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetDocumentsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetDocumentsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetDocumentsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetDocumentsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetDocumentsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetDocumentsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetDocumentsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetDocumentsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetDocumentsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetDocumentsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetDocumentsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetDocumentsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetDocumentsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetDocumentsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetDocumentsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetDocumentsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetDocumentsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetDocumentsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetDocumentsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetDocumentsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetDocumentsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetDocumentsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetDocumentsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetDocumentsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetDocumentsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetDocumentsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/documents', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetDocumentsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostStartOfPackagingMockHandler = ()=>{
    return http.post('*/api/sponsor/yet/packaging/start', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostStartOfPackagingMockHandler200 = ()=>{
    return http.post('*/api/sponsor/yet/packaging/start', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostStartOfPackagingMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/packaging/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostStartOfPackagingResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostStartOfPackagingMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/packaging/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostStartOfPackagingResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostStartOfPackagingMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/packaging/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostStartOfPackagingResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostStartOfPackagingMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/packaging/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostStartOfPackagingResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostStartOfPackagingMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/packaging/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostStartOfPackagingResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostStartOfPackagingMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/packaging/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostStartOfPackagingResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostStartOfPackagingMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/packaging/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostStartOfPackagingResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostStartOfPackagingMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/packaging/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostStartOfPackagingResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostStartOfPackagingMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/packaging/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostStartOfPackagingResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostStartOfPackagingMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/packaging/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostStartOfPackagingResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostStartOfPackagingMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/packaging/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostStartOfPackagingResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostStartOfPackagingMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/packaging/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostStartOfPackagingResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostStartOfPackagingMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/packaging/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostStartOfPackagingResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostStartOfPackagingMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/packaging/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostStartOfPackagingResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostStartOfPackagingMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/packaging/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostStartOfPackagingResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostStartOfPackagingMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/packaging/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostStartOfPackagingResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostStartOfPackagingMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/packaging/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostStartOfPackagingResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostStartOfPackagingMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/packaging/start', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostStartOfPackagingResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanTestResultsMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/plan-test-results', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanTestResultsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanTestResultsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/plan-test-results', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanTestResultsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanTestResultsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/plan-test-results', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanTestResultsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanTestResultsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/plan-test-results', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanTestResultsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanTestResultsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/plan-test-results', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanTestResultsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanTestResultsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/plan-test-results', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanTestResultsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanTestResultsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/plan-test-results', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanTestResultsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanTestResultsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/plan-test-results', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanTestResultsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanTestResultsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/plan-test-results', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanTestResultsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanTestResultsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/plan-test-results', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanTestResultsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanTestResultsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/plan-test-results', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanTestResultsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanTestResultsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/plan-test-results', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanTestResultsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanTestResultsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/plan-test-results', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanTestResultsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanTestResultsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/plan-test-results', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanTestResultsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanTestResultsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/plan-test-results', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanTestResultsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanTestResultsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/plan-test-results', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanTestResultsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanTestResultsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/plan-test-results', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanTestResultsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanTestResultsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/plan-test-results', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanTestResultsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanTestResultsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/plan-test-results', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanTestResultsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanTestResultsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/plan-test-results', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanTestResultsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetSponsorQuestionnaireMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetSponsorQuestionnaireResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetSponsorQuestionnaireMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetSponsorQuestionnaireResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetSponsorQuestionnaireMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetSponsorQuestionnaireResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetSponsorQuestionnaireMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetSponsorQuestionnaireResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetSponsorQuestionnaireMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetSponsorQuestionnaireResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetSponsorQuestionnaireMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetSponsorQuestionnaireResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetSponsorQuestionnaireMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetSponsorQuestionnaireResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetSponsorQuestionnaireMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetSponsorQuestionnaireResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetSponsorQuestionnaireMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetSponsorQuestionnaireResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetSponsorQuestionnaireMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetSponsorQuestionnaireResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetSponsorQuestionnaireMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetSponsorQuestionnaireResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetSponsorQuestionnaireMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetSponsorQuestionnaireResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetSponsorQuestionnaireMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetSponsorQuestionnaireResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetSponsorQuestionnaireMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetSponsorQuestionnaireResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetSponsorQuestionnaireMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetSponsorQuestionnaireResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetSponsorQuestionnaireMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetSponsorQuestionnaireResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetSponsorQuestionnaireMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetSponsorQuestionnaireResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetSponsorQuestionnaireMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetSponsorQuestionnaireResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetSponsorQuestionnaireMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetSponsorQuestionnaireResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetSponsorQuestionnaireMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetSponsorQuestionnaireResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetSponsorQuestionnaireMockHandler = ()=>{
    return http.post('*/api/sponsor/yet/questionnaire', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetSponsorQuestionnaireMockHandler200 = ()=>{
    return http.post('*/api/sponsor/yet/questionnaire', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetSponsorQuestionnaireMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetSponsorQuestionnaireResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetSponsorQuestionnaireMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetSponsorQuestionnaireResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetSponsorQuestionnaireMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetSponsorQuestionnaireResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetSponsorQuestionnaireMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetSponsorQuestionnaireResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetSponsorQuestionnaireMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetSponsorQuestionnaireResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetSponsorQuestionnaireMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetSponsorQuestionnaireResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetSponsorQuestionnaireMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetSponsorQuestionnaireResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetSponsorQuestionnaireMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetSponsorQuestionnaireResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetSponsorQuestionnaireMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetSponsorQuestionnaireResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetSponsorQuestionnaireMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetSponsorQuestionnaireResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetSponsorQuestionnaireMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetSponsorQuestionnaireResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetSponsorQuestionnaireMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetSponsorQuestionnaireResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetSponsorQuestionnaireMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetSponsorQuestionnaireResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetSponsorQuestionnaireMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetSponsorQuestionnaireResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetSponsorQuestionnaireMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetSponsorQuestionnaireResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetSponsorQuestionnaireMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetSponsorQuestionnaireResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetSponsorQuestionnaireMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetSponsorQuestionnaireResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetSponsorQuestionnaireMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/questionnaire', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostYetSponsorQuestionnaireResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartTestingProcessMockHandler = ()=>{
    return http.post('*/api/sponsor/yet/restart', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartTestingProcessMockHandler200 = ()=>{
    return http.post('*/api/sponsor/yet/restart', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartTestingProcessMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartTestingProcessResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartTestingProcessMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartTestingProcessResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartTestingProcessMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartTestingProcessResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartTestingProcessMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartTestingProcessResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartTestingProcessMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartTestingProcessResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartTestingProcessMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartTestingProcessResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartTestingProcessMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartTestingProcessResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartTestingProcessMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartTestingProcessResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartTestingProcessMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartTestingProcessResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartTestingProcessMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartTestingProcessResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartTestingProcessMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartTestingProcessResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartTestingProcessMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartTestingProcessResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartTestingProcessMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartTestingProcessResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartTestingProcessMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartTestingProcessResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartTestingProcessMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartTestingProcessResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartTestingProcessMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartTestingProcessResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartTestingProcessMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartTestingProcessResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartTestingProcessMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/sponsor/yet/restart', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRestartTestingProcessResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetStatusMockHandler = ()=>{
    return http.get('*/api/sponsor/yet/status', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetStatusMockHandler200 = ()=>{
    return http.get('*/api/sponsor/yet/status', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYtdContributionsMockHandler = ()=>{
    return http.get('*/api/sponsor/ytd-contributions', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYtdContributionsMockHandler200 = ()=>{
    return http.get('*/api/sponsor/ytd-contributions', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetTIAAIncomeProjectionMockHandler = (overrideResponse)=>{
    return http.get('*/api/tiaa/income-projection', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetTIAAIncomeProjectionResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetTIAAIncomeProjectionMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/tiaa/income-projection', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetTIAAIncomeProjectionResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetTIAAIncomeProjectionMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/tiaa/income-projection', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetTIAAIncomeProjectionResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetTIAAIncomeProjectionMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/tiaa/income-projection', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetTIAAIncomeProjectionResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetTIAAIncomeProjectionMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/tiaa/income-projection', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetTIAAIncomeProjectionResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetTIAAIncomeProjectionMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/tiaa/income-projection', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetTIAAIncomeProjectionResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetTIAAIncomeProjectionMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/tiaa/income-projection', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetTIAAIncomeProjectionResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetTIAAIncomeProjectionMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/tiaa/income-projection', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetTIAAIncomeProjectionResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetTIAAIncomeProjectionMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/tiaa/income-projection', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetTIAAIncomeProjectionResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetTIAAIncomeProjectionMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/tiaa/income-projection', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetTIAAIncomeProjectionResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetTIAAIncomeProjectionMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/tiaa/income-projection', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetTIAAIncomeProjectionResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetTIAAIncomeProjectionMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/tiaa/income-projection', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetTIAAIncomeProjectionResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetTIAAIncomeProjectionMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/tiaa/income-projection', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetTIAAIncomeProjectionResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetTIAAIncomeProjectionMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/tiaa/income-projection', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetTIAAIncomeProjectionResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetTIAAIncomeProjectionMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/tiaa/income-projection', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetTIAAIncomeProjectionResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetTIAAIncomeProjectionMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/tiaa/income-projection', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetTIAAIncomeProjectionResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetTIAAIncomeProjectionMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/tiaa/income-projection', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetTIAAIncomeProjectionResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetTIAAIncomeProjectionMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/tiaa/income-projection', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetTIAAIncomeProjectionResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetTIAAIncomeProjectionMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/tiaa/income-projection', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetTIAAIncomeProjectionResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetTIAAIncomeProjectionMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/tiaa/income-projection', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetTIAAIncomeProjectionResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantByIdMockHandler = ()=>{
    return http.patch('*/api/v2/participant', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantByIdMockHandler200 = ()=>{
    return http.patch('*/api/v2/participant', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantByIdMockHandler400 = (overrideResponse)=>{
    return http.patch('*/api/v2/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchParticipantByIdResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantByIdMockHandler401 = (overrideResponse)=>{
    return http.patch('*/api/v2/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchParticipantByIdResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantByIdMockHandler403 = (overrideResponse)=>{
    return http.patch('*/api/v2/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchParticipantByIdResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantByIdMockHandler404 = (overrideResponse)=>{
    return http.patch('*/api/v2/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchParticipantByIdResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantByIdMockHandler405 = (overrideResponse)=>{
    return http.patch('*/api/v2/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchParticipantByIdResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantByIdMockHandler406 = (overrideResponse)=>{
    return http.patch('*/api/v2/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchParticipantByIdResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantByIdMockHandler408 = (overrideResponse)=>{
    return http.patch('*/api/v2/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchParticipantByIdResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantByIdMockHandler409 = (overrideResponse)=>{
    return http.patch('*/api/v2/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchParticipantByIdResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantByIdMockHandler410 = (overrideResponse)=>{
    return http.patch('*/api/v2/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchParticipantByIdResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantByIdMockHandler412 = (overrideResponse)=>{
    return http.patch('*/api/v2/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchParticipantByIdResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantByIdMockHandler413 = (overrideResponse)=>{
    return http.patch('*/api/v2/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchParticipantByIdResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantByIdMockHandler415 = (overrideResponse)=>{
    return http.patch('*/api/v2/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchParticipantByIdResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantByIdMockHandler422 = (overrideResponse)=>{
    return http.patch('*/api/v2/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchParticipantByIdResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantByIdMockHandler500 = (overrideResponse)=>{
    return http.patch('*/api/v2/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchParticipantByIdResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantByIdMockHandler501 = (overrideResponse)=>{
    return http.patch('*/api/v2/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchParticipantByIdResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantByIdMockHandler502 = (overrideResponse)=>{
    return http.patch('*/api/v2/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchParticipantByIdResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantByIdMockHandler503 = (overrideResponse)=>{
    return http.patch('*/api/v2/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchParticipantByIdResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantByIdMockHandler504 = (overrideResponse)=>{
    return http.patch('*/api/v2/participant', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchParticipantByIdResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBeneficiariesMockHandler = (overrideResponse)=>{
    return http.get('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBeneficiariesResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBeneficiariesMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBeneficiariesResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBeneficiariesMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBeneficiariesResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBeneficiariesMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBeneficiariesResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBeneficiariesMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBeneficiariesResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBeneficiariesMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBeneficiariesResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBeneficiariesMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBeneficiariesResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBeneficiariesMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBeneficiariesResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBeneficiariesMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBeneficiariesResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBeneficiariesMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBeneficiariesResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBeneficiariesMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBeneficiariesResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBeneficiariesMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBeneficiariesResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBeneficiariesMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBeneficiariesResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBeneficiariesMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBeneficiariesResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBeneficiariesMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBeneficiariesResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBeneficiariesMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBeneficiariesResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBeneficiariesMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBeneficiariesResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBeneficiariesMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBeneficiariesResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBeneficiariesMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBeneficiariesResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBeneficiariesMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBeneficiariesResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantBeneficiariesV2MockHandler = ()=>{
    return http.put('*/api/v2/participant/beneficiaries', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantBeneficiariesV2MockHandler200 = ()=>{
    return http.put('*/api/v2/participant/beneficiaries', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantBeneficiariesV2MockHandler400 = (overrideResponse)=>{
    return http.put('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutParticipantBeneficiariesV2ResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantBeneficiariesV2MockHandler401 = (overrideResponse)=>{
    return http.put('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutParticipantBeneficiariesV2ResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantBeneficiariesV2MockHandler403 = (overrideResponse)=>{
    return http.put('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutParticipantBeneficiariesV2ResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantBeneficiariesV2MockHandler404 = (overrideResponse)=>{
    return http.put('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutParticipantBeneficiariesV2ResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantBeneficiariesV2MockHandler405 = (overrideResponse)=>{
    return http.put('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutParticipantBeneficiariesV2ResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantBeneficiariesV2MockHandler406 = (overrideResponse)=>{
    return http.put('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutParticipantBeneficiariesV2ResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantBeneficiariesV2MockHandler408 = (overrideResponse)=>{
    return http.put('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutParticipantBeneficiariesV2ResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantBeneficiariesV2MockHandler409 = (overrideResponse)=>{
    return http.put('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutParticipantBeneficiariesV2ResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantBeneficiariesV2MockHandler410 = (overrideResponse)=>{
    return http.put('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutParticipantBeneficiariesV2ResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantBeneficiariesV2MockHandler412 = (overrideResponse)=>{
    return http.put('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutParticipantBeneficiariesV2ResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantBeneficiariesV2MockHandler413 = (overrideResponse)=>{
    return http.put('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutParticipantBeneficiariesV2ResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantBeneficiariesV2MockHandler415 = (overrideResponse)=>{
    return http.put('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutParticipantBeneficiariesV2ResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantBeneficiariesV2MockHandler422 = (overrideResponse)=>{
    return http.put('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutParticipantBeneficiariesV2ResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantBeneficiariesV2MockHandler500 = (overrideResponse)=>{
    return http.put('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutParticipantBeneficiariesV2ResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantBeneficiariesV2MockHandler501 = (overrideResponse)=>{
    return http.put('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutParticipantBeneficiariesV2ResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantBeneficiariesV2MockHandler502 = (overrideResponse)=>{
    return http.put('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutParticipantBeneficiariesV2ResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantBeneficiariesV2MockHandler503 = (overrideResponse)=>{
    return http.put('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutParticipantBeneficiariesV2ResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantBeneficiariesV2MockHandler504 = (overrideResponse)=>{
    return http.put('*/api/v2/participant/beneficiaries', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutParticipantBeneficiariesV2ResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanByIdV2MockHandler = (overrideResponse)=>{
    return http.get('*/api/v2/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanByIdV2ResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanByIdV2MockHandler200 = (overrideResponse)=>{
    return http.get('*/api/v2/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanByIdV2ResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanByIdV2MockHandler400 = (overrideResponse)=>{
    return http.get('*/api/v2/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanByIdV2ResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanByIdV2MockHandler401 = (overrideResponse)=>{
    return http.get('*/api/v2/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanByIdV2ResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanByIdV2MockHandler403 = (overrideResponse)=>{
    return http.get('*/api/v2/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanByIdV2ResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanByIdV2MockHandler404 = (overrideResponse)=>{
    return http.get('*/api/v2/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanByIdV2ResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanByIdV2MockHandler405 = (overrideResponse)=>{
    return http.get('*/api/v2/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanByIdV2ResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanByIdV2MockHandler406 = (overrideResponse)=>{
    return http.get('*/api/v2/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanByIdV2ResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanByIdV2MockHandler408 = (overrideResponse)=>{
    return http.get('*/api/v2/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanByIdV2ResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanByIdV2MockHandler409 = (overrideResponse)=>{
    return http.get('*/api/v2/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanByIdV2ResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanByIdV2MockHandler410 = (overrideResponse)=>{
    return http.get('*/api/v2/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanByIdV2ResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanByIdV2MockHandler412 = (overrideResponse)=>{
    return http.get('*/api/v2/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanByIdV2ResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanByIdV2MockHandler413 = (overrideResponse)=>{
    return http.get('*/api/v2/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanByIdV2ResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanByIdV2MockHandler415 = (overrideResponse)=>{
    return http.get('*/api/v2/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanByIdV2ResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanByIdV2MockHandler422 = (overrideResponse)=>{
    return http.get('*/api/v2/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanByIdV2ResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanByIdV2MockHandler500 = (overrideResponse)=>{
    return http.get('*/api/v2/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanByIdV2ResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanByIdV2MockHandler501 = (overrideResponse)=>{
    return http.get('*/api/v2/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanByIdV2ResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanByIdV2MockHandler502 = (overrideResponse)=>{
    return http.get('*/api/v2/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanByIdV2ResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanByIdV2MockHandler503 = (overrideResponse)=>{
    return http.get('*/api/v2/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanByIdV2ResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanByIdV2MockHandler504 = (overrideResponse)=>{
    return http.get('*/api/v2/plans', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanByIdV2ResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVestingScheduleMockHandler = (overrideResponse)=>{
    return http.get('*/api/vesting/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVestingScheduleResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVestingScheduleMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/vesting/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVestingScheduleResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVestingScheduleMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/vesting/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVestingScheduleResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVestingScheduleMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/vesting/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVestingScheduleResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVestingScheduleMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/vesting/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVestingScheduleResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVestingScheduleMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/vesting/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVestingScheduleResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVestingScheduleMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/vesting/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVestingScheduleResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVestingScheduleMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/vesting/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVestingScheduleResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVestingScheduleMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/vesting/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVestingScheduleResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVestingScheduleMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/vesting/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVestingScheduleResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVestingScheduleMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/vesting/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVestingScheduleResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVestingScheduleMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/vesting/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVestingScheduleResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVestingScheduleMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/vesting/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVestingScheduleResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVestingScheduleMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/vesting/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVestingScheduleResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVestingScheduleMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/vesting/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVestingScheduleResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVestingScheduleMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/vesting/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVestingScheduleResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVestingScheduleMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/vesting/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVestingScheduleResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVestingScheduleMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/vesting/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVestingScheduleResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVestingScheduleMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/vesting/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVestingScheduleResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVestingScheduleMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/vesting/schedule', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVestingScheduleResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssPlanByIdMockHandler = (overrideResponse)=>{
    return http.get('*/api/vss/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssPlanByIdResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssPlanByIdMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/vss/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssPlanByIdResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssPlanByIdMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/vss/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssPlanByIdResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssPlanByIdMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/vss/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssPlanByIdResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssPlanByIdMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/vss/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssPlanByIdResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssPlanByIdMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/vss/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssPlanByIdResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssPlanByIdMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/vss/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssPlanByIdResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssPlanByIdMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/vss/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssPlanByIdResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssPlanByIdMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/vss/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssPlanByIdResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssPlanByIdMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/vss/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssPlanByIdResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssPlanByIdMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/vss/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssPlanByIdResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssPlanByIdMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/vss/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssPlanByIdResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssPlanByIdMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/vss/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssPlanByIdResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssPlanByIdMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/vss/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssPlanByIdResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssPlanByIdMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/vss/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssPlanByIdResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssPlanByIdMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/vss/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssPlanByIdResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssPlanByIdMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/vss/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssPlanByIdResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssPlanByIdMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/vss/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssPlanByIdResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssPlanByIdMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/vss/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssPlanByIdResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssPlanByIdMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/vss/plans/:planId', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssPlanByIdResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssStatusMockHandler = (overrideResponse)=>{
    return http.get('*/api/vss/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssStatusResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssStatusMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/vss/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssStatusResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssStatusMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/vss/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssStatusResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssStatusMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/vss/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssStatusResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssStatusMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/vss/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssStatusResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssStatusMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/vss/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssStatusResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssStatusMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/vss/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssStatusResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssStatusMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/vss/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssStatusResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssStatusMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/vss/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssStatusResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssStatusMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/vss/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssStatusResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssStatusMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/vss/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssStatusResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssStatusMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/vss/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssStatusResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssStatusMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/vss/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssStatusResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssStatusMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/vss/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssStatusResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssStatusMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/vss/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssStatusResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssStatusMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/vss/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssStatusResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssStatusMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/vss/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssStatusResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssStatusMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/vss/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssStatusResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssStatusMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/vss/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssStatusResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetVssStatusMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/vss/status', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetVssStatusResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLobLetterEventsWebhookMockHandler = ()=>{
    return http.post('*/api/webhooks/lob/letter-events', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLobLetterEventsWebhookMockHandler200 = ()=>{
    return http.post('*/api/webhooks/lob/letter-events', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLobLetterEventsWebhookMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/webhooks/lob/letter-events', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLobLetterEventsWebhookResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLobLetterEventsWebhookMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/webhooks/lob/letter-events', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLobLetterEventsWebhookResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLobLetterEventsWebhookMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/webhooks/lob/letter-events', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLobLetterEventsWebhookResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLobLetterEventsWebhookMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/webhooks/lob/letter-events', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLobLetterEventsWebhookResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLobLetterEventsWebhookMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/webhooks/lob/letter-events', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLobLetterEventsWebhookResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLobLetterEventsWebhookMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/webhooks/lob/letter-events', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLobLetterEventsWebhookResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLobLetterEventsWebhookMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/webhooks/lob/letter-events', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLobLetterEventsWebhookResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLobLetterEventsWebhookMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/webhooks/lob/letter-events', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLobLetterEventsWebhookResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLobLetterEventsWebhookMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/webhooks/lob/letter-events', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLobLetterEventsWebhookResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLobLetterEventsWebhookMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/webhooks/lob/letter-events', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLobLetterEventsWebhookResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLobLetterEventsWebhookMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/webhooks/lob/letter-events', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLobLetterEventsWebhookResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLobLetterEventsWebhookMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/webhooks/lob/letter-events', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLobLetterEventsWebhookResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLobLetterEventsWebhookMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/webhooks/lob/letter-events', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLobLetterEventsWebhookResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLobLetterEventsWebhookMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/webhooks/lob/letter-events', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLobLetterEventsWebhookResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLobLetterEventsWebhookMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/webhooks/lob/letter-events', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLobLetterEventsWebhookResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLobLetterEventsWebhookMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/webhooks/lob/letter-events', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLobLetterEventsWebhookResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLobLetterEventsWebhookMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/webhooks/lob/letter-events', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLobLetterEventsWebhookResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLobLetterEventsWebhookMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/webhooks/lob/letter-events', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostLobLetterEventsWebhookResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelMockHandler = (overrideResponse)=>{
    return http.get('*/api/whitelabel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/whitelabel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/whitelabel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/whitelabel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/whitelabel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/whitelabel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/whitelabel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/whitelabel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/whitelabel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/whitelabel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/whitelabel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/whitelabel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/whitelabel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/whitelabel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/whitelabel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/whitelabel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/whitelabel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/whitelabel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/whitelabel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/whitelabel', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelUnauthorizedMockHandler = (overrideResponse)=>{
    return http.get('*/api/whitelabel/unauthorized', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelUnauthorizedResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelUnauthorizedMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/whitelabel/unauthorized', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelUnauthorizedResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelUnauthorizedMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/whitelabel/unauthorized', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelUnauthorizedResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelUnauthorizedMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/whitelabel/unauthorized', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelUnauthorizedResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelUnauthorizedMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/whitelabel/unauthorized', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelUnauthorizedResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelUnauthorizedMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/whitelabel/unauthorized', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelUnauthorizedResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelUnauthorizedMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/whitelabel/unauthorized', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelUnauthorizedResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelUnauthorizedMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/whitelabel/unauthorized', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelUnauthorizedResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelUnauthorizedMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/whitelabel/unauthorized', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelUnauthorizedResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelUnauthorizedMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/whitelabel/unauthorized', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelUnauthorizedResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelUnauthorizedMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/whitelabel/unauthorized', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelUnauthorizedResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelUnauthorizedMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/whitelabel/unauthorized', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelUnauthorizedResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelUnauthorizedMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/whitelabel/unauthorized', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelUnauthorizedResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelUnauthorizedMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/whitelabel/unauthorized', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelUnauthorizedResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelUnauthorizedMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/whitelabel/unauthorized', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelUnauthorizedResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelUnauthorizedMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/whitelabel/unauthorized', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelUnauthorizedResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelUnauthorizedMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/whitelabel/unauthorized', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelUnauthorizedResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelUnauthorizedMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/whitelabel/unauthorized', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelUnauthorizedResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelUnauthorizedMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/whitelabel/unauthorized', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelUnauthorizedResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelUnauthorizedMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/whitelabel/unauthorized', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelUnauthorizedResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateWithdrawalMockHandler = (overrideResponse)=>{
    return http.post('*/api/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateWithdrawalResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateWithdrawalMockHandler200 = (overrideResponse)=>{
    return http.post('*/api/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateWithdrawalResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateWithdrawalMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateWithdrawalResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateWithdrawalMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateWithdrawalResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateWithdrawalMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateWithdrawalResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateWithdrawalMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateWithdrawalResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateWithdrawalMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateWithdrawalResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateWithdrawalMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateWithdrawalResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateWithdrawalMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateWithdrawalResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateWithdrawalMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateWithdrawalResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateWithdrawalMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateWithdrawalResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateWithdrawalMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateWithdrawalResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateWithdrawalMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateWithdrawalResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateWithdrawalMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateWithdrawalResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateWithdrawalMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateWithdrawalResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateWithdrawalMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateWithdrawalResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateWithdrawalMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateWithdrawalResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateWithdrawalMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateWithdrawalResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateWithdrawalMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateWithdrawalResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateWithdrawalMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/withdrawal', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateWithdrawalResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostWithdrawalIdentityVerificationMockHandler = (overrideResponse)=>{
    return http.post('*/api/withdrawal/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostWithdrawalIdentityVerificationResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostWithdrawalIdentityVerificationMockHandler200 = (overrideResponse)=>{
    return http.post('*/api/withdrawal/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostWithdrawalIdentityVerificationResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostWithdrawalIdentityVerificationMockHandler400 = (overrideResponse)=>{
    return http.post('*/api/withdrawal/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostWithdrawalIdentityVerificationResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostWithdrawalIdentityVerificationMockHandler401 = (overrideResponse)=>{
    return http.post('*/api/withdrawal/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostWithdrawalIdentityVerificationResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostWithdrawalIdentityVerificationMockHandler403 = (overrideResponse)=>{
    return http.post('*/api/withdrawal/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostWithdrawalIdentityVerificationResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostWithdrawalIdentityVerificationMockHandler404 = (overrideResponse)=>{
    return http.post('*/api/withdrawal/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostWithdrawalIdentityVerificationResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostWithdrawalIdentityVerificationMockHandler405 = (overrideResponse)=>{
    return http.post('*/api/withdrawal/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostWithdrawalIdentityVerificationResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostWithdrawalIdentityVerificationMockHandler406 = (overrideResponse)=>{
    return http.post('*/api/withdrawal/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostWithdrawalIdentityVerificationResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostWithdrawalIdentityVerificationMockHandler408 = (overrideResponse)=>{
    return http.post('*/api/withdrawal/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostWithdrawalIdentityVerificationResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostWithdrawalIdentityVerificationMockHandler409 = (overrideResponse)=>{
    return http.post('*/api/withdrawal/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostWithdrawalIdentityVerificationResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostWithdrawalIdentityVerificationMockHandler410 = (overrideResponse)=>{
    return http.post('*/api/withdrawal/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostWithdrawalIdentityVerificationResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostWithdrawalIdentityVerificationMockHandler412 = (overrideResponse)=>{
    return http.post('*/api/withdrawal/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostWithdrawalIdentityVerificationResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostWithdrawalIdentityVerificationMockHandler413 = (overrideResponse)=>{
    return http.post('*/api/withdrawal/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostWithdrawalIdentityVerificationResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostWithdrawalIdentityVerificationMockHandler415 = (overrideResponse)=>{
    return http.post('*/api/withdrawal/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostWithdrawalIdentityVerificationResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostWithdrawalIdentityVerificationMockHandler422 = (overrideResponse)=>{
    return http.post('*/api/withdrawal/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostWithdrawalIdentityVerificationResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostWithdrawalIdentityVerificationMockHandler500 = (overrideResponse)=>{
    return http.post('*/api/withdrawal/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostWithdrawalIdentityVerificationResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostWithdrawalIdentityVerificationMockHandler501 = (overrideResponse)=>{
    return http.post('*/api/withdrawal/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostWithdrawalIdentityVerificationResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostWithdrawalIdentityVerificationMockHandler502 = (overrideResponse)=>{
    return http.post('*/api/withdrawal/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostWithdrawalIdentityVerificationResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostWithdrawalIdentityVerificationMockHandler503 = (overrideResponse)=>{
    return http.post('*/api/withdrawal/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostWithdrawalIdentityVerificationResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostWithdrawalIdentityVerificationMockHandler504 = (overrideResponse)=>{
    return http.post('*/api/withdrawal/identity-verification', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostWithdrawalIdentityVerificationResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdAmountMockHandler = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-amount', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdAmountResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdAmountMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-amount', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdAmountResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdAmountMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-amount', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdAmountResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdAmountMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-amount', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdAmountResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdAmountMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-amount', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdAmountResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdAmountMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-amount', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdAmountResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdAmountMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-amount', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdAmountResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdAmountMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-amount', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdAmountResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdAmountMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-amount', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdAmountResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdAmountMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-amount', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdAmountResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdAmountMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-amount', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdAmountResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdAmountMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-amount', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdAmountResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdAmountMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-amount', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdAmountResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdAmountMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-amount', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdAmountResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdAmountMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-amount', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdAmountResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdAmountMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-amount', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdAmountResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdAmountMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-amount', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdAmountResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdAmountMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-amount', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdAmountResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdAmountMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-amount', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdAmountResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdAmountMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-amount', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdAmountResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdBalanceMockHandler = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdBalanceResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdBalanceMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdBalanceResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdBalanceMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdBalanceResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdBalanceMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdBalanceResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdBalanceMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdBalanceResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdBalanceMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdBalanceResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdBalanceMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdBalanceResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdBalanceMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdBalanceResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdBalanceMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdBalanceResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdBalanceMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdBalanceResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdBalanceMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdBalanceResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdBalanceMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdBalanceResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdBalanceMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdBalanceResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdBalanceMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdBalanceResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdBalanceMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdBalanceResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdBalanceMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdBalanceResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdBalanceMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdBalanceResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdBalanceMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdBalanceResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdBalanceMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdBalanceResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdBalanceMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-balance', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdBalanceResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverProvidersMockHandler = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rollover-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRolloverProvidersResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverProvidersMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rollover-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRolloverProvidersResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverProvidersMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rollover-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRolloverProvidersResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverProvidersMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rollover-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRolloverProvidersResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverProvidersMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rollover-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRolloverProvidersResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverProvidersMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rollover-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRolloverProvidersResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverProvidersMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rollover-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRolloverProvidersResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverProvidersMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rollover-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRolloverProvidersResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverProvidersMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rollover-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRolloverProvidersResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverProvidersMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rollover-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRolloverProvidersResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverProvidersMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rollover-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRolloverProvidersResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverProvidersMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rollover-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRolloverProvidersResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverProvidersMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rollover-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRolloverProvidersResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverProvidersMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rollover-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRolloverProvidersResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverProvidersMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rollover-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRolloverProvidersResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverProvidersMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rollover-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRolloverProvidersResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverProvidersMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rollover-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRolloverProvidersResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverProvidersMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rollover-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRolloverProvidersResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverProvidersMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rollover-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRolloverProvidersResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverProvidersMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rollover-providers', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRolloverProvidersResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingMockHandler = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingDetailMockHandler = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding/total-estimate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingDetailResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingDetailMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding/total-estimate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingDetailResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingDetailMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding/total-estimate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingDetailResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingDetailMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding/total-estimate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingDetailResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingDetailMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding/total-estimate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingDetailResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingDetailMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding/total-estimate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingDetailResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingDetailMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding/total-estimate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingDetailResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingDetailMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding/total-estimate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingDetailResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingDetailMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding/total-estimate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingDetailResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingDetailMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding/total-estimate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingDetailResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingDetailMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding/total-estimate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingDetailResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingDetailMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding/total-estimate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingDetailResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingDetailMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding/total-estimate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingDetailResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingDetailMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding/total-estimate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingDetailResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingDetailMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding/total-estimate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingDetailResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingDetailMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding/total-estimate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingDetailResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingDetailMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding/total-estimate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingDetailResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingDetailMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding/total-estimate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingDetailResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingDetailMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding/total-estimate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingDetailResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingDetailMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding/total-estimate', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingDetailResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetNaicsMockHandler = (overrideResponse)=>{
    return http.get('*/api/yet/naics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetNaicsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetNaicsMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/yet/naics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetNaicsResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetNaicsMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/yet/naics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetNaicsResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetNaicsMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/yet/naics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetNaicsResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetNaicsMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/yet/naics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetNaicsResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetNaicsMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/yet/naics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetNaicsResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetNaicsMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/yet/naics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetNaicsResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetNaicsMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/yet/naics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetNaicsResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetNaicsMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/yet/naics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetNaicsResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetNaicsMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/yet/naics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetNaicsResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetNaicsMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/yet/naics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetNaicsResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetNaicsMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/yet/naics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetNaicsResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetNaicsMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/yet/naics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetNaicsResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetNaicsMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/yet/naics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetNaicsResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetNaicsMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/yet/naics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetNaicsResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetNaicsMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/yet/naics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetNaicsResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetNaicsMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/yet/naics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetNaicsResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetNaicsMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/yet/naics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetNaicsResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetNaicsMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/yet/naics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetNaicsResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetNaicsMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/yet/naics', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetNaicsResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetZendeskJwtMockHandler = (overrideResponse)=>{
    return http.get('*/api/zendesk/jwt', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetZendeskJwtResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetZendeskJwtMockHandler200 = (overrideResponse)=>{
    return http.get('*/api/zendesk/jwt', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetZendeskJwtResponseMock200()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetZendeskJwtMockHandler400 = (overrideResponse)=>{
    return http.get('*/api/zendesk/jwt', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetZendeskJwtResponseMock400()), {
            status: 400,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetZendeskJwtMockHandler401 = (overrideResponse)=>{
    return http.get('*/api/zendesk/jwt', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetZendeskJwtResponseMock401()), {
            status: 401,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetZendeskJwtMockHandler403 = (overrideResponse)=>{
    return http.get('*/api/zendesk/jwt', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetZendeskJwtResponseMock403()), {
            status: 403,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetZendeskJwtMockHandler404 = (overrideResponse)=>{
    return http.get('*/api/zendesk/jwt', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetZendeskJwtResponseMock404()), {
            status: 404,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetZendeskJwtMockHandler405 = (overrideResponse)=>{
    return http.get('*/api/zendesk/jwt', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetZendeskJwtResponseMock405()), {
            status: 405,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetZendeskJwtMockHandler406 = (overrideResponse)=>{
    return http.get('*/api/zendesk/jwt', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetZendeskJwtResponseMock406()), {
            status: 406,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetZendeskJwtMockHandler408 = (overrideResponse)=>{
    return http.get('*/api/zendesk/jwt', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetZendeskJwtResponseMock408()), {
            status: 408,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetZendeskJwtMockHandler409 = (overrideResponse)=>{
    return http.get('*/api/zendesk/jwt', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetZendeskJwtResponseMock409()), {
            status: 409,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetZendeskJwtMockHandler410 = (overrideResponse)=>{
    return http.get('*/api/zendesk/jwt', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetZendeskJwtResponseMock410()), {
            status: 410,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetZendeskJwtMockHandler412 = (overrideResponse)=>{
    return http.get('*/api/zendesk/jwt', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetZendeskJwtResponseMock412()), {
            status: 412,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetZendeskJwtMockHandler413 = (overrideResponse)=>{
    return http.get('*/api/zendesk/jwt', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetZendeskJwtResponseMock413()), {
            status: 413,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetZendeskJwtMockHandler415 = (overrideResponse)=>{
    return http.get('*/api/zendesk/jwt', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetZendeskJwtResponseMock415()), {
            status: 415,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetZendeskJwtMockHandler422 = (overrideResponse)=>{
    return http.get('*/api/zendesk/jwt', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetZendeskJwtResponseMock422()), {
            status: 422,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetZendeskJwtMockHandler500 = (overrideResponse)=>{
    return http.get('*/api/zendesk/jwt', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetZendeskJwtResponseMock500()), {
            status: 500,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetZendeskJwtMockHandler501 = (overrideResponse)=>{
    return http.get('*/api/zendesk/jwt', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetZendeskJwtResponseMock501()), {
            status: 501,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetZendeskJwtMockHandler502 = (overrideResponse)=>{
    return http.get('*/api/zendesk/jwt', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetZendeskJwtResponseMock502()), {
            status: 502,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetZendeskJwtMockHandler503 = (overrideResponse)=>{
    return http.get('*/api/zendesk/jwt', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetZendeskJwtResponseMock503()), {
            status: 503,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetZendeskJwtMockHandler504 = (overrideResponse)=>{
    return http.get('*/api/zendesk/jwt', (info)=>{
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetZendeskJwtResponseMock504()), {
            status: 504,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEntitySessionMockHandler = ()=>{
    return http.get('*/api/:entity/session', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEntitySessionMockHandler200 = ()=>{
    return http.get('*/api/:entity/session', ()=>{
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPortalMiddlewareHooksMock = ()=>[
        getGetAdvisorByIdMockHandler(),
        getGetAdvisorCommercialPlatformsMockHandler(),
        getGetAdvisorContactCardMockHandler(),
        getPutAdvisorContactCardMockHandler(),
        getGetPlansMockHandler(),
        getGetAdvisorAnnualTestingPlansPerYearMockHandler(),
        getGetPlansTrackerMockHandler(),
        getGetAdvisorPlanEmployeesMockHandler(),
        getGetPlanEmployeeMockHandler(),
        getGetAdvisorPlanStatisticsMockHandler(),
        getPostLinkSponsorMockHandler(),
        getGetAdvisorStatsMockHandler(),
        getGetCarouselMockHandler(),
        getGetConnectivityMockHandler(),
        getGetCsmMockHandler(),
        getGetLoginDisclosureMockHandler(),
        getPutLoginDisclosureMockHandler(),
        getGetLoginDisclosureAgreementMockHandler(),
        getGetDocumentByIdMockHandler(),
        getPatchDeleteDocumentByIdMockHandler(),
        getGetAllDocumentsMockHandler(),
        getGetDocumentAgreementMockHandler(),
        getPostDocumentAgreementMockHandler(),
        getGetDocumentDownloadByIdMockHandler(),
        getGetDocumentDownloadByKeyMockHandler(),
        getGetDocumentAsHtmlMockHandler(),
        getGetDocumentAsHtmlAndDownloadMockHandler(),
        getPostPdfMockHandler(),
        getPostProcessDocumentMockHandler(),
        getPostUploadDocumentMockHandler(),
        getPostEmailMockHandler(),
        getPostEmailPreviewRenderMockHandler(),
        getGetEmailPreviewByIdMockHandler(),
        getGetEmployeeHoldingsMockHandler(),
        getGetEmployeeLoansMockHandler(),
        getGetEmployeePerformanceMockHandler(),
        getGetEmployeeTransactionsMockHandler(),
        getGetEmployeePendingTransactionsMockHandler(),
        getGetEmployeeTransactionsYearsMockHandler(),
        getGetProgramModelSecuritiesMockHandler(),
        getGetEmployeesWithContributionsMockHandler(),
        getGetEmployeeLoanDetailsMockHandler(),
        getGetEmployeesTransactionsYearsMockHandler(),
        getPatchEsaParticipantGoalMockHandler(),
        getGetEsaParticipantGoalsMockHandler(),
        getGetEsaParticipantIncentivesMockHandler(),
        getGetEsaPlanCashInterestRateMockHandler(),
        getGetEsaPlanGroupBalanceOverTimeMockHandler(),
        getGetEsaPlanGroupStatsMockHandler(),
        getGetEsaPlanGroupsMockHandler(),
        getGetEsaPlanIncentivesMockHandler(),
        getPatchEsaWithdrawalMockHandler(),
        getGetFi360DownloadMockHandler(),
        getGetFeatureTogglesMockHandler(),
        getGetFeatureTogglesListMockHandler(),
        getGetFirmByIdMockHandler(),
        getGetGiftContributorRecurringMockHandler(),
        getDeleteGiftContributorRecurringMockHandler(),
        getGetGiftContributorBanksMockHandler(),
        getGetGiftContributorPaymentsMockHandler(),
        getGetGiftContributorRecipientsMockHandler(),
        getGetGiftingPageAndAccountByIdMockHandler(),
        getGetGiftingPageByIdMockHandler(),
        getPostCreateGiftorProfileMockHandler(),
        getPutValidateGiftorProfileMockHandler(),
        getPostGiftSubmissionMockHandler(),
        getPutValidateGiftSubmissionMockHandler(),
        getGetHealthMockHandler(),
        getGetLoanAmortizationPdfMockHandler(),
        getGetManagedAccountsPlaidTokenMockHandler(),
        getDeleteManagedAccountsPlaidLinksMockHandler(),
        getGetManagedAccountsPlaidLinksMockHandler(),
        getPostManagedAccountsPlaidLinksMockHandler(),
        getPostManagedAccountsPlaidBalancesMockHandler(),
        getGetMidYearTestingMockHandler(),
        getGetMidYearTestingCensusRecordMockHandler(),
        getPostMsManagedAccounts401kManagerQuestionnaireMockHandler(),
        getPostMsManagedAccountsActivateMockHandler(),
        getPostMsManagedAccountsDeactivateMockHandler(),
        getGetMsManagedAccountsPreviewAllocationMockHandler(),
        getPostMsManagedAccountsPreviewAllocationMockHandler(),
        getGetDigitalOnboardingStateMockHandler(),
        getPatchDigitalOnboardingStateMockHandler(),
        getPutDigitalOnboardingStateMockHandler(),
        getPatchStatefulSchemaTrackingStatusMockHandler(),
        getGetParticipantByIdMockHandler(),
        getGetParticipantAccountBalanceByIdMockHandler(),
        getPostParticipantLoanMockHandler(),
        getGetParticipantPlaidLinkTokenMockHandler(),
        getGetParticipantPlaidLinksMockHandler(),
        getPostParticipantPlaidLinksMockHandler(),
        getGetParticipantLoanCreateMockHandler(),
        getPatchParticipantLoanMockHandler(),
        getPostLoanManualRepaymentMockHandler(),
        getGetParticipantAccountsMockHandler(),
        getGetParticipantBalanceOverTimeMockHandler(),
        getPutArchiveBankAccountMockHandler(),
        getGetParticipantBankAccountsMockHandler(),
        getGetParticipantDepositsMockHandler(),
        getPostDepositDataMockHandler(),
        getGetParticipantRecurringSchedulesMockHandler(),
        getPutRecurringScheduleMockHandler(),
        getGetDepositMockHandler(),
        getGetRecentParticipantDocumentsMockHandler(),
        getPostParticipantEligibilityMockHandler(),
        getPostEsaGoalMockHandler(),
        getGetParticipantIdentityVerificationMockHandler(),
        getPatchParticipantInfoWithEmailsMockHandler(),
        getGetGoalFeedbackMockHandler(),
        getPostElectionAgeSuggestionMockHandler(),
        getPostElectionRetirementIncomeSuggestionMockHandler(),
        getGetElectionsSetupMockHandler(),
        getPostElectionsSetupMockHandler(),
        getGetInvestmentsModelDisplayMockHandler(),
        getGetPlanParticipantStatsMockHandler(),
        getPostRebalanceRequestMockHandler(),
        getGetRebalanceSettingsMockHandler(),
        getPutRebalanceSettingsMockHandler(),
        getGetStrategiesIndexMockHandler(),
        getGetAgeBasedMockHandler(),
        getPutAgeBasedMockHandler(),
        getPutCustomAllocationMockHandler(),
        getGetRiskBasedMockHandler(),
        getPutRiskBasedMockHandler(),
        getGetRiskModelQuestionnaireMockHandler(),
        getGetMailPreferencesMockHandler(),
        getPutMailPreferencesMockHandler(),
        getGetParticipantOnboardingMockHandler(),
        getGetParticipantOverviewMockHandler(),
        getPostParticipantPlaidLinksBalanceMockHandler(),
        getPostParticipantPlaidLinksBankAccountMockHandler(),
        getPostParticipantDiscardPendingPlaidLinksMockHandler(),
        getGetPositionsMockHandler(),
        getGetQboadWithdrawalsMockHandler(),
        getPatchParticipantRolloverMockHandler(),
        getGetRolloverInstructionsMockHandler(),
        getGetRolloverEligibilityMockHandler(),
        getPostParticipantRolloverMockHandler(),
        getGetParticipantRolloverMockHandler(),
        getGetGenerateRolloverLetterMockHandler(),
        getGetSavingsDisplayMockHandler(),
        getPutSavingsMockHandler(),
        getGetSurveyLinkMockHandler(),
        getGetParticipantAggregatedByCategoryTransactionsMockHandler(),
        getGetAllowedWithdrawalReasonsMockHandler(),
        getPostWithdrawalMockHandler(),
        getPatchOverrideParticipantEligibilityMockHandler(),
        getGetEligibleAutoEnrolledParticipantsMockHandler(),
        getGetParticipantOptOutEmailDownloadMockHandler(),
        getGetOptedOutAutoEnrolledParticipantsMockHandler(),
        getGetUnregisteredParticipantsMockHandler(),
        getGetUnregisteredParticipantsCountMockHandler(),
        getPostParticipantsWelcomeEmailsMockHandler(),
        getGetParticipantWelcomeEmailDownloadMockHandler(),
        getGetParticipantWelcomeEmailsHistoryMockHandler(),
        getGetCalculatedEsaEmployerContributionsMockHandler(),
        getGetCalculatedEmployerMatchContributionMockHandler(),
        getPostParticipantsAutoEnrollOptOutMockHandler(),
        getGetPlanDesignMockHandler(),
        getPatchUpdatePlanDesignMockHandler(),
        getGetPlanDesignTilesMockHandler(),
        getGetPlanParticipantsMockHandler(),
        getGetPlanModelMockHandler(),
        getPatchPlanMockHandler(),
        getGetEsaProgramMockHandler(),
        getGetPlanInvestmentsMockHandler(),
        getGetPlanModelSecuritiesMockHandler(),
        getGetProgramModelsMockHandler(),
        getGetProgramInvestmentOptionsExportMockHandler(),
        getGetProspectusUrlPartsMockHandler(),
        getGetAdvisorReportMockHandler(),
        getGetEmployeeReportMockHandler(),
        getGetUnregisteredParticipantsReportMockHandler(),
        getGetPlanReportMockHandler(),
        getGetSponsorReportMockHandler(),
        getGetSubaTransactionsReportMockHandler(),
        getGetAllSafeHarborContributionTypesMockHandler(),
        getGetSubaExternalMarketValueMockHandler(),
        getPostSubaInitiateExternalTransferMockHandler(),
        getGetSdbaSetupMockHandler(),
        getGetSdbaTransfersInfoMockHandler(),
        getGetCheckActiveSdbaTransfersMockHandler(),
        getGetSessionMockHandler(),
        getGetSponsorAbilitiesMockHandler(),
        getGetAutoEnrollSponsorPlanMockHandler(),
        getGetCensusParticipantsMockHandler(),
        getGetBankAccountMockHandler(),
        getPostBankAccountMockHandler(),
        getPutBankAccountMockHandler(),
        getPutSponsorArchiveBankAccountMockHandler(),
        getPutFeePaymentMethodMockHandler(),
        getPatchSponsorMockHandler(),
        getGetSponsorTeammatesMockHandler(),
        getPatchDeleteTeammateMockHandler(),
        getPostSendUserInviteMockHandler(),
        getGetPlanConfigurationV2MockHandler(),
        getPutPlanConfigurationV2MockHandler(),
        getGetPlanEmployeesV2MockHandler(),
        getGetPlanGrossCompensationV2MockHandler(),
        getPutPlanEmployeeGrossCompensationV2MockHandler(),
        getGetGrossCompensationTemplateV2MockHandler(),
        getPostPlanEmployeeGrossCompensationUploadV2MockHandler(),
        getPostPlanNonEmployeeOwnerV2MockHandler(),
        getGetPlanOfficersV2MockHandler(),
        getPutPlanOfficerStatusV2MockHandler(),
        getDeletePlanOwnerV2MockHandler(),
        getGetPlanOwnersV2MockHandler(),
        getPostPlanEmployeeOwnerV2MockHandler(),
        getPutPlanEmployeeOwnerV2MockHandler(),
        getDeletePlanOwnersFamilyV2MockHandler(),
        getGetPlanOwnersFamilyV2MockHandler(),
        getPutPlanOwnersFamilyV2MockHandler(),
        getPostFileHeadersUpdateMockHandler(),
        getGetContributionsLandingPageDisplayMockHandler(),
        getPostContributionMockHandler(),
        getPostCancelSubmissionMockHandler(),
        getPostCancellationSubmissionMockHandler(),
        getGetParticipantsLoansMockHandler(),
        getPostMatchRemediationContributionMockHandler(),
        getPostOffCycleContributionMockHandler(),
        getPostResumeSubmissionMockHandler(),
        getPostIngestionFlowValidationMockHandler(),
        getPostContributionValidationMockHandler(),
        getGetContributionSubmissionDisplayMockHandler(),
        getGetContributionAdjustmentsMockHandler(),
        getPostContributionConfirmationMockHandler(),
        getGetContributionConfirmationDisplayMockHandler(),
        getPostContributionCorrectionMockHandler(),
        getGetContributionCorrectionsMockHandler(),
        getGetContributionDetailsMockHandler(),
        getGetContributionDisplayMockHandler(),
        getPostContributionUploadMockHandler(),
        getGetDownloadContributionFileMockHandler(),
        getGetForfeitureMockHandler(),
        getPostForfeitureMockHandler(),
        getGetContributionHeaderValidationsMockHandler(),
        getGetNormalizedContributionDataMockHandler(),
        getPostIngestionFlowStartMockHandler(),
        getGetDownloadContributionTemplateMockHandler(),
        getGetContributionValidationPageDisplayMockHandler(),
        getGetContributionValidationMockHandler(),
        getGetDeferralChangesMockHandler(),
        getPatchDeferralChangesActivitiesMockHandler(),
        getPutParticipantMockHandler(),
        getGetEmployeeClassesMockHandler(),
        getGetEmployeesMockHandler(),
        getPutParticipantsMockHandler(),
        getPostUploadCensusOriginalMockHandler(),
        getPostValidateEmployeeMockHandler(),
        getGetEmployeeDetailsMockHandler(),
        getPostContactInfoMockHandler(),
        getPutParticipantContributionsMockHandler(),
        getGetSponsorEntityMockHandler(),
        getGetForfeiturePreferenceMockHandler(),
        getPutForfeiturePreferenceMockHandler(),
        getGetHeapDataMockHandler(),
        getGetOnboardingMockHandler(),
        getPostOnboardingMockHandler(),
        getPutOnboardingMockHandler(),
        getGetSponsorOnboardingInformationMockHandler(),
        getPutSponsorOnboardingInformationMockHandler(),
        getPostUploadCensusMockHandler(),
        getPostUploadOnboardingCensusOriginalMockHandler(),
        getGetInitialCensusMockHandler(),
        getDeleteCensusCacheMockHandler(),
        getGetCensusCacheMockHandler(),
        getPostCensusCacheMockHandler(),
        getGetSponsorEsaProgramMockHandler(),
        getPostFinishOnboardingMockHandler(),
        getGetSponsorOnboardingTeammatesMockHandler(),
        getPostSendOnboardingUserInviteMockHandler(),
        getGetNextPayrollDatesMockHandler(),
        getGetPayrollProvidersMockHandler(),
        getGetSponsorPlaidLinkTokenMockHandler(),
        getPostGetSponsorPlaidLinksMockHandler(),
        getGetPlanDesignConsultStateMockHandler(),
        getPatchPlanDesignConsultStateMockHandler(),
        getGetPlanLaunchCallUrlMockHandler(),
        getGetUserRolesMockHandler(),
        getGetPayrollConnectionStatusMockHandler(),
        getGetPayrollConnectionStatusV2MockHandler(),
        getGetPayrollDatesMockHandler(),
        getGetPayrollInfoMockHandler(),
        getGetPayrollSetupsMockHandler(),
        getPostPayrollSetupMockHandler(),
        getPostBulkPayrollSetupDisconnectionMockHandler(),
        getGetPayrollFundingSetupsMockHandler(),
        getPutPayrollProviderMockHandler(),
        getPutPayrollSkipStatusMockHandler(),
        getPutSkipSubmissionMockHandler(),
        getDeletePayrollSetupMockHandler(),
        getPutPayrollDatesMockHandler(),
        getPostPayrollSetupDisconnectionMockHandler(),
        getPutPayrollSetupInfoMockHandler(),
        getPostPayrollValidationsMockHandler(),
        getGetPlanFeaturesMockHandler(),
        getGetPlanOnboardingStatusMockHandler(),
        getPostSponsorPlanDisconnectionMockHandler(),
        getGetPlanStatisticsMockHandler(),
        getGetPlanConfigurationMockHandler(),
        getPutPlanConfigurationMockHandler(),
        getGetPlanEmployeesMockHandler(),
        getGetPlanGrossCompensationMockHandler(),
        getPutPlanEmployeeGrossCompensationMockHandler(),
        getGetGrossCompensationTemplateMockHandler(),
        getPostPlanEmployeeGrossCompensationUploadMockHandler(),
        getPostPlanNonEmployeeOwnerMockHandler(),
        getGetPlanOfficersMockHandler(),
        getPutPlanOfficerStatusMockHandler(),
        getDeletePlanOwnerMockHandler(),
        getGetPlanOwnersMockHandler(),
        getPostPlanEmployeeOwnerMockHandler(),
        getPutPlanEmployeeOwnerMockHandler(),
        getDeletePlanOwnersFamilyMockHandler(),
        getGetPlanOwnersFamilyMockHandler(),
        getPutPlanOwnersFamilyMockHandler(),
        getGetTrackerDetailsMockHandler(),
        getPostPriorProviderMockHandler(),
        getGetPriorProvidersMockHandler(),
        getGetSponsorQuestionnaireMockHandler(),
        getPatchSponsorQuestionnaireMockHandler(),
        getGetQuestionnaireInformationMockHandler(),
        getGetContributionsMockHandler(),
        getGetSubaPlanDetailsMockHandler(),
        getGetSubaTransactionsMockHandler(),
        getPostYetCensusAutosaveMockHandler(),
        getGetYetCensusDataDownloadMockHandler(),
        getGetYetCensusDataPagedMockHandler(),
        getPostRefreshCensusMockHandler(),
        getPostRestartCensusMockHandler(),
        getPostYetCensusStartMockHandler(),
        getGetCensusStatusMockHandler(),
        getPostYetCensusSubmitMockHandler(),
        getPostYetCensusUploadMockHandler(),
        getGetYetChecklistMockHandler(),
        getPatchYetChecklistMockHandler(),
        getGetYetConfigMockHandler(),
        getPostContributionsFundMockHandler(),
        getPostContributionsRefundMockHandler(),
        getGetYetDocumentsMockHandler(),
        getPostStartOfPackagingMockHandler(),
        getGetPlanTestResultsMockHandler(),
        getGetYetSponsorQuestionnaireMockHandler(),
        getPostYetSponsorQuestionnaireMockHandler(),
        getPostRestartTestingProcessMockHandler(),
        getGetYetStatusMockHandler(),
        getGetYtdContributionsMockHandler(),
        getGetTIAAIncomeProjectionMockHandler(),
        getPatchParticipantByIdMockHandler(),
        getGetParticipantBeneficiariesMockHandler(),
        getPutParticipantBeneficiariesV2MockHandler(),
        getGetPlanByIdV2MockHandler(),
        getGetVestingScheduleMockHandler(),
        getGetVssPlanByIdMockHandler(),
        getGetVssStatusMockHandler(),
        getPostLobLetterEventsWebhookMockHandler(),
        getGetWhiteLabelMockHandler(),
        getGetWhiteLabelUnauthorizedMockHandler(),
        getPostCreateWithdrawalMockHandler(),
        getPostWithdrawalIdentityVerificationMockHandler(),
        getGetRmdAmountMockHandler(),
        getGetRmdBalanceMockHandler(),
        getGetRolloverProvidersMockHandler(),
        getGetWithholdingMockHandler(),
        getGetWithholdingDetailMockHandler(),
        getGetYetNaicsMockHandler(),
        getGetZendeskJwtMockHandler(),
        getGetEntitySessionMockHandler()
    ];

//# sourceMappingURL=index.js.map